/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(681);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1307);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(67);
	var hide = __webpack_require__(47);
	var redefine = __webpack_require__(48);
	var ctx = __webpack_require__(68);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(106);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(321);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(143);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1276);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(529);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1272);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1288);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1273);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(528);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(322);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(530);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(1271);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(1274);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(1275);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(1287);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(221);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(1277);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(1285);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(535);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1279);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1280);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1284);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(531);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.routes = exports.PATH_FH = exports.PATH_FL = exports.PATH_AS = exports.PATH_DP = exports.PATH_ARTICLE = exports.PATH_INTERVIEW = exports.PATH_EDITORIAL = exports.PATH_ACCOUNT = exports.PATH_LEADERBOARD = exports.PATH_TIMELINE = exports.PATH_PAGE = exports.PATH_JURY = exports.PATH_JOBS = exports.PATH_PROFILES = exports.PATH_CASES = undefined;
	exports.genericRoute = genericRoute;
	exports.accountRoute = accountRoute;
	exports.awardsRoute = awardsRoute;
	exports.liveRoute = liveRoute;
	exports.jobsRoute = jobsRoute;
	exports.interviewRoute = interviewRoute;
	exports.casesRoute = casesRoute;
	exports.agencyRoute = agencyRoute;
	exports.profilesRoute = profilesRoute;
	exports.editorialRoute = editorialRoute;
	exports.pageRoute = pageRoute;
	exports.generateURL = generateURL;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Route = __webpack_require__(530);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Redirect = __webpack_require__(322);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _IndexRoute = __webpack_require__(528);
	
	var _IndexRoute2 = _interopRequireDefault(_IndexRoute);
	
	var _toSlug = __webpack_require__(1385);
	
	var _toSlug2 = _interopRequireDefault(_toSlug);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _containers = __webpack_require__(663);
	
	var _containers2 = _interopRequireDefault(_containers);
	
	var _types = __webpack_require__(88);
	
	var MenuType = _interopRequireWildcard(_types);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH_CASES = exports.PATH_CASES = 'cases';
	var PATH_PROFILES = exports.PATH_PROFILES = 'profiles';
	var PATH_JOBS = exports.PATH_JOBS = 'jobs';
	
	var PATH_JURY = exports.PATH_JURY = 'about/jury';
	var PATH_PAGE = exports.PATH_PAGE = 'page';
	var PATH_TIMELINE = exports.PATH_TIMELINE = 'awards';
	var PATH_LEADERBOARD = exports.PATH_LEADERBOARD = 'live-judging';
	var PATH_ACCOUNT = exports.PATH_ACCOUNT = 'account';
	
	//Editorial paths
	var PATH_EDITORIAL = exports.PATH_EDITORIAL = 'editorial';
	var PATH_INTERVIEW = exports.PATH_INTERVIEW = 'interviews'; //ID: 4
	var PATH_ARTICLE = exports.PATH_ARTICLE = 'article'; //ID: 1
	var PATH_DP = exports.PATH_DP = 'digital-pioneers'; //ID: 3
	var PATH_AS = exports.PATH_AS = 'agency-spotlight'; //ID: 5
	var PATH_FL = exports.PATH_FL = 'fwa-legends'; //ID: 2
	var PATH_FH = exports.PATH_FH = 'fwa-hero'; //ID:
	
	var routes = exports.routes = _react2.default.createElement(
		_Route2.default,
		{ path: _baseUrl2.default + '/', component: _containers2.default.App, showFilter: true },
		_react2.default.createElement(
			_Route2.default,
			{ path: PATH_TIMELINE, component: _containers2.default.Timeline, showFilter: true },
			_react2.default.createElement(_Route2.default, { path: 'page/:pageNum', component: _containers2.default.Timeline, showFilter: true })
		),
		_react2.default.createElement(_Route2.default, { path: PATH_LEADERBOARD, component: _containers2.default.LiveJudging }),
		'// Resource routes',
		_react2.default.createElement(_Route2.default, { path: PATH_JURY, component: _containers2.default.Jury }),
		_react2.default.createElement(_Route2.default, { path: PATH_CASES + '/:slug', component: _containers2.default.Case }),
		_react2.default.createElement(_Route2.default, { path: PATH_PROFILES, component: _containers2.default.Profiles }),
		_react2.default.createElement(_Route2.default, { path: PATH_PROFILES + '/:slug', component: _containers2.default.ProfilePage }),
		_react2.default.createElement(_Route2.default, { path: PATH_JOBS, component: _containers2.default.Jobs }),
		_react2.default.createElement(_Route2.default, { path: PATH_JOBS + '/:slug', component: _containers2.default.JobPage }),
		_react2.default.createElement(_Redirect2.default, { from: PATH_ACCOUNT, to: PATH_ACCOUNT + '/settings' }),
		_react2.default.createElement(_Route2.default, { path: 'submit/project', component: _containers2.default.SubmitCaseNotLoggedIn }),
		_react2.default.createElement(_Route2.default, { path: 'submit/job', component: _containers2.default.SubmitJobNotLoggedIn }),
		_react2.default.createElement(_Redirect2.default, { from: 'submit_site', to: 'submit/project' }),
		_react2.default.createElement(_Redirect2.default, { from: 'submit_job', to: 'submit/job' }),
		_react2.default.createElement(
			_Route2.default,
			{ path: PATH_ACCOUNT, component: _containers2.default.Account },
			_react2.default.createElement(_Route2.default, { path: 'settings', component: _containers.accountPages.AccountBasic }),
			_react2.default.createElement(
				_Route2.default,
				{ path: 'jury', component: _containers.accountPages.AccountJury },
				_react2.default.createElement(_Route2.default, { path: 'fotd', component: _containers.accountPages.AccountJuryFOTD }),
				_react2.default.createElement(_Route2.default, { path: 'fotm', component: _containers.accountPages.AccountJuryFOTM }),
				_react2.default.createElement(_Route2.default, { path: 'foty', component: _containers.accountPages.AccountJuryFOTY }),
				_react2.default.createElement(_Route2.default, { path: 'tcea', component: _containers.accountPages.AccountJuryTCEA })
			),
			_react2.default.createElement(_Redirect2.default, { from: 'profile', to: 'profile/settings' }),
			_react2.default.createElement(
				_Route2.default,
				{ path: 'profile' },
				_react2.default.createElement(_Route2.default, { path: 'settings', component: _containers.accountPages.ProfileEdit }),
				_react2.default.createElement(
					_Route2.default,
					{ path: 'projects' },
					_react2.default.createElement(_IndexRoute2.default, { component: _containers.accountPages.CaseList }),
					_react2.default.createElement(_Route2.default, { path: 'create', component: _containers.accountPages.CaseCreate }),
					_react2.default.createElement(_Route2.default, { path: ':id', component: _containers.accountPages.CaseEdit })
				),
				_react2.default.createElement(
					_Route2.default,
					{ path: 'jobs' },
					_react2.default.createElement(_IndexRoute2.default, { component: _containers.accountPages.JobList }),
					_react2.default.createElement(_Route2.default, { path: 'create', component: _containers.accountPages.JobCreate }),
					_react2.default.createElement(_Route2.default, { path: ':id', component: _containers.accountPages.JobEdit })
				)
			),
			_react2.default.createElement(
				_Route2.default,
				{ path: 'editorial', source: 'user' },
				_react2.default.createElement(_Route2.default, { path: ':type', component: _containers.accountPages.ProfileEditorial }),
				_react2.default.createElement(_Route2.default, { path: ':type/:id', component: _containers.accountPages.EditorialEdit })
			),
			_react2.default.createElement(
				_Route2.default,
				{ path: 'profile/editorial', source: 'profile' },
				_react2.default.createElement(_Route2.default, { path: ':type/create', component: _containers.accountPages.EditorialEdit }),
				_react2.default.createElement(_Route2.default, { path: ':type/:id', component: _containers.accountPages.EditorialEdit }),
				_react2.default.createElement(_Route2.default, { path: ':type', component: _containers.accountPages.ProfileEditorial })
			),
			_react2.default.createElement(
				_Route2.default,
				{ path: 'admin' },
				_react2.default.createElement(_Route2.default, { path: 'jury-overview', component: _containers.accountPages.AdminJuryOverview })
			)
		),
		'//All editorial routes delivered by CMS',
		konfig.editorialSlugs.map(function (item, i) {
			if (!item) {
				return false;
			}
	
			return _react2.default.createElement(_Route2.default, { key: i, path: item + '/:slug', component: _containers2.default.Editorial });
		}),
		_react2.default.createElement(_Route2.default, { path: '/tceay', component: _containers2.default.TCEAYVote }),
		_react2.default.createElement(_Route2.default, { path: '/pca', component: _containers2.default.PCAVote }),
		_react2.default.createElement(_Route2.default, { path: PATH_ACCOUNT + '/login', component: _containers2.default.AccountLogin }),
		_react2.default.createElement(_Route2.default, { path: PATH_ACCOUNT + '/logout', component: _containers2.default.AccountLogout }),
		_react2.default.createElement(_Route2.default, { path: PATH_ACCOUNT + '/register', component: _containers2.default.AccountRegister }),
		_react2.default.createElement(
			_Route2.default,
			{ path: PATH_ACCOUNT + '/verify', component: _containers2.default.AccountActivate },
			_react2.default.createElement(_Route2.default, { path: ':hash' })
		),
		_react2.default.createElement(
			_Route2.default,
			{ path: PATH_ACCOUNT + '/recover', component: _containers2.default.AccountRecover },
			_react2.default.createElement(_Route2.default, { path: ':hash' })
		),
		'// These paths are all editorial content',
		_react2.default.createElement(_Route2.default, { path: PATH_EDITORIAL + '/:slug', component: _containers2.default.Editorial }),
		'/*',
		_react2.default.createElement(_Route2.default, { path: PATH_PAGE + '/:slug', component: _containers2.default.Page }),
		'*/',
		_react2.default.createElement(_Route2.default, { path: 'error', component: _containers2.default.ErrorPage }),
		'/*',
		_react2.default.createElement(_Route2.default, { path: 'user/:menuactive', component: _containers2.default.Timeline }),
		'*/',
		_react2.default.createElement(_Route2.default, { path: '*', component: _containers2.default.Page })
	);
	
	function genericRoute(slug) {
		var path = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
		var shouldSlugify = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
		var returnPath = _baseUrl2.default + '/';
		if (path) {
			returnPath += path + '/';
		}
	
		if (shouldSlugify && typeof slug === 'string' && slug.length > 1) {
			returnPath += (0, _toSlug2.default)(slug);
		}
	
		return returnPath;
	}
	
	function accountRoute() {
		var path = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		return genericRoute(false, PATH_ACCOUNT + path);
	}
	
	function awardsRoute() {
		return genericRoute('', PATH_TIMELINE);
	};
	
	function liveRoute() {
		return genericRoute('', PATH_LEADERBOARD);
	};
	
	function jobsRoute() {
		var slug = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		return genericRoute(slug, PATH_JOBS);
	};
	
	function interviewRoute() {
		var slug = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		return genericRoute(slug, PATH_INTERVIEW);
	};
	
	function casesRoute(slug) {
		return genericRoute(slug, PATH_CASES);
	};
	
	function agencyRoute(slug) {
		return genericRoute(slug, PATH_AGENCIES);
	};
	
	function profilesRoute(slug) {
		return genericRoute(slug, PATH_PROFILES);
	};
	
	function editorialRoute(slug) {
		return genericRoute(slug, PATH_EDITORIAL);
	};
	
	function pageRoute(path) {
		return genericRoute(false, path, false);
	};
	
	function generateURL(type, slug) {
		switch (type) {
			case MenuType.TYPE_TIMELINE:
				return genericRoute(PATH_TIMELINE);
	
			case MenuType.TYPE_TIMELINE:
				return genericRoute(PATH_LEADERBOARD);
	
			case MenuType.TYPE_TEMPLATES:
				return pageRoute(slug);
	
			case MenuType.TYPE_EDITORIAL:
				return editorialRoute(slug);
	
			case MenuType.TYPE_INTERVIEW:
				return interviewRoute(slug);
	
			// Has List view...
			case MenuType.TYPE_PROFILES:
				return genericRoute(PATH_PROFILES);
	
			case MenuType.TYPE_JOBS:
				return genericRoute(PATH_JOBS);
	
			// the following get a default route
			case MenuType.TYPE_NONE:
			case MenuType.TYPE_CONTAINER:
			case MenuType.TYPE_EDITORIAL_LIST:
			default:
				return genericRoute(slug, type);
		}
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(574);

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var baseUrl = '';
	if (window.konfig && window.konfig.baseUrl) {
		baseUrl = window.konfig.baseUrl;
	}
	
	exports.default = baseUrl;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRedux = __webpack_require__(166);
	
	function mapStateToProps(state) {
		return state;
	} // Helper function to set redux store props on router components
	
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spinner = __webpack_require__(1029);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Spinner = function (_Component) {
		_inherits(Spinner, _Component);
	
		function Spinner(props) {
			_classCallCheck(this, Spinner);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Spinner).call(this, props));
		}
	
		_createClass(Spinner, [{
			key: 'render',
			value: function render() {
				var className = 'svg-spinner ' + this.props.className;
	
				if (!this.props.active) {
					className += ' svg-spinner--inactive';
				}
	
				return _react2.default.createElement(
					'svg',
					{ className: className, width: this.props.size, height: this.props.size, viewBox: '0 0 66 66', xml: 'http://www.w3.org/2000/svg', xmlXlink: 'http://www.w3.org/1999/xlink' },
					_react2.default.createElement('circle', { className: 'svg-spinner__path-bg', stroke: this.props.pathbgStroke, fill: 'none', strokeWidth: '6', strokeLinecap: 'round', cx: '33', cy: '33', r: '30' }),
					_react2.default.createElement('circle', { className: 'svg-spinner__path', stroke: this.props.pathStroke, fill: 'none', strokeWidth: '6', strokeLinecap: 'round', cx: '33', cy: '33', r: '30' })
				);
			}
		}]);
	
		return Spinner;
	}(_react.Component);
	
	Spinner.propTypes = {
		size: _react.PropTypes.string,
		className: _react.PropTypes.string,
		pathbgStroke: _react.PropTypes.string,
		pathStroke: _react.PropTypes.string,
		active: _react.PropTypes.bool
	};
	Spinner.defaultProps = {
		size: '20px',
		className: '',
		pathbgStroke: '#dbdbdb',
		pathStroke: '#666',
		active: true
	};
	exports.default = Spinner;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	__webpack_require__(1220);
	
	__webpack_require__(1221);
	
	__webpack_require__(1222);
	
	__webpack_require__(1223);
	
	__webpack_require__(1224);
	
	__webpack_require__(1225);
	
	__webpack_require__(1226);
	
	var _Helmet = __webpack_require__(1217);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	exports["default"] = _Helmet2["default"];
	module.exports = exports["default"];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _content = __webpack_require__(983);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import CornerLabel from '../../components/block/cornerLabel';
	
	var AccountBlockContent = function (_Component) {
		_inherits(AccountBlockContent, _Component);
	
		function AccountBlockContent(props) {
			_classCallCheck(this, AccountBlockContent);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountBlockContent).call(this));
	
			_this.headerHeight = 0;
			_this.offsetTop = 0;
	
			_this.getStickyStyle = _this.getStickyStyle.bind(_this);
	
			if (props.sticky && !props.browser) {
				console.warn('Sticky header needs browser props.');
			}
	
			_this.state = {
				stickyStyle: {}
			};
			return _this;
		}
	
		_createClass(AccountBlockContent, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.sticky && this.props.browser) {
					this.props.browser.scroll.register(this.getStickyStyle);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.sticky && this.props.browser) {
					this.props.browser.scroll.deregister(this.getStickyStyle);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var mainClass = 'account-block-content';
				var containerClass = mainClass;
				var stickyClass = this.props.sticky ? mainClass + '__sticky span14' : '';
				var asideClass = 'span5 span5-tablet span14-mobile account-block-content__aside';
				var contentClass = 'span9 span100p-tablet span100p-mobile account-block-content__content';
	
				if (this.props.sticky) {
					containerClass += ' account-block-content--fixed-height account-block-content--title-head';
					contentClass = 'span9 span9-tablet span100p-mobile account-block-content__content';
				}
	
				if (this.props.className) {
					containerClass += ' ' + this.props.className;
				}
	
				if (this.props.smallAside) {
					containerClass += ' account-block-content--small-aside';
					asideClass = 'span3 span12-tablet span10-mobile account-block-content__aside';
				}
	
				if (!this.props.title) {
					asideClass += ' account-block-content__aside--no-content';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: containerClass, ref: 'mainElement', style: this.props.style },
					_react2.default.createElement(
						'div',
						{ className: stickyClass, ref: 'stickyElement', style: this.state.stickyStyle },
						_react2.default.createElement(
							'aside',
							{ className: asideClass, ref: 'asideElement', style: this.state.asideStyle },
							this.props.title
						),
						_react2.default.createElement(
							'div',
							{ className: contentClass, ref: 'contentElement' },
							this.props.children
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'getStickyStyle',
			value: function getStickyStyle(e) {
				if (e.scrollY === this.prevSrollY) {
					return false; // noop
				} else {
					this.prevSrollY = e.scrollY;
				}
	
				var newState = _extends({}, this.state);
				var headerHeight = this.headerHeight = !this.headerHeight ? document.querySelector('.header-main').offsetHeight : this.headerHeight;
				var mainOffsetTop = this.offsetTop = !this.offsetTop && this.refs.mainElement ? this.refs.mainElement.offsetTop : this.offsetTop;
				var mainHeight = this.offsetHeight = !this.offsetHeight && this.refs.mainElement ? this.refs.mainElement.offsetHeight : this.offsetHeight;
	
				var distanceToMenu = mainOffsetTop - headerHeight;
				var isSticky = e.scrollY >= distanceToMenu;
	
				newState.stickyStyle = this.getStickyElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight);
				newState.asideStyle = this.getAsideElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight);
				this.setState(newState);
			}
		}, {
			key: 'getStickyElementStickyStyle',
			value: function getStickyElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight) {
				var minHeight = 77;
				var isMobile = this.props.browser.window.width <= 719;
				var scrollY = e.scrollY;
				var asideHeight = 0;
	
				if (isMobile) {
					var compStyle = window.getComputedStyle(this.refs.asideElement);
					asideHeight = this.refs.asideElement.offsetHeight + (parseInt(compStyle.marginTop, 10) || 0) + (parseInt(compStyle.marginBottom, 10) || 0);
	
					scrollY -= asideHeight;
				}
	
				var isSticky = scrollY >= distanceToMenu;
	
				if (isSticky) {
					var newHeight = mainHeight + distanceToMenu - scrollY;
	
					newHeight = newHeight > mainHeight ? mainHeight : newHeight < minHeight ? minHeight : newHeight;
	
					return {
						position: 'fixed',
						top: (isMobile ? headerHeight - asideHeight : headerHeight) + 'px',
						height: (isMobile ? mainHeight : newHeight) + 'px'
					};
				}
	
				return {};
			}
		}, {
			key: 'getAsideElementStickyStyle',
			value: function getAsideElementStickyStyle(e, distanceToMenu, mainHeight) {
				var scrollY = e.scrollY;
				var progress = scrollY - distanceToMenu;
	
				// limit to our heights
				progress = progress > mainHeight ? mainHeight : progress < 0 ? 0 : progress;
	
				// convert to percentage
				progress = 1 - 1 / mainHeight * progress;
	
				return {
					opacity: progress
				};
			}
		}]);
	
		return AccountBlockContent;
	}(_react.Component);
	
	AccountBlockContent.propTypes = {
		title: _react.PropTypes.oneOfType([_react.PropTypes.string, _react2.default.PropTypes.object]),
		sticky: _react.PropTypes.bool.isRequired,
		browser: _react.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.oneOf([false])]).isRequired,
		smallAside: _react.PropTypes.bool,
		style: _react.PropTypes.object
	};
	AccountBlockContent.defaultProps = {
		title: '',
		className: '',
		sticky: false,
		browser: false,
		smallAside: false,
		style: {}
	};
	exports.default = AccountBlockContent;

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//GENERIC ACTIONS
	var CHANGE_EVENT = exports.CHANGE_EVENT = 'CHANGE_EVENT';
	var REQ_DATA = exports.REQ_DATA = 'REQ_DATA';
	var RECV_DATA = exports.RECV_DATA = 'RECV_DATA';
	var RECV_ERROR = exports.RECV_ERROR = 'RECV_ERROR';
	var RECV_MSG = exports.RECV_MSG = 'RECV_MSG';
	var CLEAR_ERROR = exports.CLEAR_ERROR = 'CLEAR_ERROR';
	
	// BROWSER
	var BROWSER_RESIZE = exports.BROWSER_RESIZE = 'BROWSER_RESIZE';
	var UPDATE_SCROLLER = exports.UPDATE_SCROLLER = 'UPDATE_SCROLLER';
	
	//MENU ACTIONS
	var MENU_TOGGLE = exports.MENU_TOGGLE = 'MENU_TOGGLE';
	var MENU_CLOSE = exports.MENU_CLOSE = 'MENU_CLOSE';
	var MENU_TOGGLE_SEARCH = exports.MENU_TOGGLE_SEARCH = 'MENU_TOGGLE_SEARCH';
	var MENU_FETCH = exports.MENU_FETCH = 'MENU_FETCH';
	var MENU_UPDATE_SUB = exports.MENU_UPDATE_SUB = 'MENU_UPDATE_SUB';
	var MENU_REQ_DATA = exports.MENU_REQ_DATA = 'MENU_REQ_DATA';
	var MENU_RECV_DATA = exports.MENU_RECV_DATA = 'MENU_RECV_DATA';
	var MENU_RECV_ERROR = exports.MENU_RECV_ERROR = 'MENU_RECV_ERROR';
	
	//JOBS ACTIONS
	var JOBS_FETCH = exports.JOBS_FETCH = 'JOBS_FETCH';
	var JOBS_UPDATE_SUB = exports.JOBS_UPDATE_SUB = 'JOBS_UPDATE_SUB';
	var JOBS_REQ_DATA = exports.JOBS_REQ_DATA = 'JOBS_REQ_DATA';
	var JOBS_RECV_DATA = exports.JOBS_RECV_DATA = 'JOBS_RECV_DATA';
	var JOBS_RECV_ERROR = exports.JOBS_RECV_ERROR = 'JOBS_RECV_ERROR';
	var JOBS_REQ_DATA_SINGLE = exports.JOBS_REQ_DATA_SINGLE = 'JOBS_REQ_DATA_SINGLE';
	var JOBS_RECV_DATA_SINGLE = exports.JOBS_RECV_DATA_SINGLE = 'JOBS_RECV_DATA_SINGLE';
	var JOBS_RECV_ERROR_SINGLE = exports.JOBS_RECV_ERROR_SINGLE = 'JOBS_RECV_ERROR_SINGLE';
	
	//JOBS ACTIONS
	var NEWS_FETCH = exports.NEWS_FETCH = 'NEWS_FETCH';
	var NEWS_UPDATE_SUB = exports.NEWS_UPDATE_SUB = 'NEWS_UPDATE_SUB';
	var NEWS_REQ_DATA = exports.NEWS_REQ_DATA = 'NEWS_REQ_DATA';
	var NEWS_RECV_DATA = exports.NEWS_RECV_DATA = 'NEWS_RECV_DATA';
	var NEWS_RECV_ERROR = exports.NEWS_RECV_ERROR = 'NEWS_RECV_ERROR';
	var NEWS_REQ_DATA_SINGLE = exports.NEWS_REQ_DATA_SINGLE = 'NEWS_REQ_DATA_SINGLE';
	var NEWS_RECV_DATA_SINGLE = exports.NEWS_RECV_DATA_SINGLE = 'NEWS_RECV_DATA_SINGLE';
	var NEWS_RECV_ERROR_SINGLE = exports.NEWS_RECV_ERROR_SINGLE = 'NEWS_RECV_ERROR_SINGLE';
	
	//CASES ACTIONS
	var CASES_CLEAR_DATA = exports.CASES_CLEAR_DATA = 'CASES_CLEAR_DATA';
	var CASES_FETCH = exports.CASES_FETCH = 'CASES_FETCH';
	var CASES_FETCH_WINNERS = exports.CASES_FETCH_WINNERS = 'CASES_FETCH_WINNERS';
	var CASES_REQ_DATA = exports.CASES_REQ_DATA = 'CASES_REQ_DATA';
	var CASES_REQ_SINGLE_DATA = exports.CASES_REQ_SINGLE_DATA = 'CASES_REQ_SINGLE_DATA';
	var CASES_RECV_DATA = exports.CASES_RECV_DATA = 'CASES_RECV_DATA';
	var CASES_RECV_DATA_CONT = exports.CASES_RECV_DATA_CONT = 'CASES_RECV_DATA_CONT';
	var CASES_RECV_SINGLE_DATA = exports.CASES_RECV_SINGLE_DATA = 'CASES_RECV_SINGLE_DATA';
	var CASES_RECV_ERROR = exports.CASES_RECV_ERROR = 'CASES_RECV_ERROR';
	
	//EDITORIALS ACTIONS
	var EDITORIALS_FETCH = exports.EDITORIALS_FETCH = 'EDITORIALS_FETCH';
	var EDITORIALS_FETCH_SINGLE = exports.EDITORIALS_FETCH_SINGLE = 'EDITORIALS_FETCH_SINGLE';
	var EDITORIALS_CLEAR_SINGLE = exports.EDITORIALS_CLEAR_SINGLE = 'EDITORIALS_CLEAR_SINGLE';
	var EDITORIALS_REQ_DATA = exports.EDITORIALS_REQ_DATA = 'EDITORIALS_REQ_DATA';
	var EDITORIALS_REQ_SINGLE_DATA = exports.EDITORIALS_REQ_SINGLE_DATA = 'EDITORIALS_REQ_DATA';
	var EDITORIALS_RECV_DATA = exports.EDITORIALS_RECV_DATA = 'EDITORIALS_RECV_DATA';
	var EDITORIALS_RECV_TYPE_DATA = exports.EDITORIALS_RECV_TYPE_DATA = 'EDITORIALS_RECV_TYPE_DATA';
	var EDITORIALS_RECV_SINGLE_DATA = exports.EDITORIALS_RECV_SINGLE_DATA = 'EDITORIALS_RECV_SINGLE_DATA';
	var EDITORIALS_RECV_ERROR = exports.EDITORIALS_RECV_ERROR = 'EDITORIALS_RECV_ERROR';
	
	//PAGES ACTIONS
	var PAGES_REQ_SINGLE_DATA = exports.PAGES_REQ_SINGLE_DATA = 'PAGES_REQ_SINGLE_DATA';
	var PAGES_RECV_SINGLE_DATA = exports.PAGES_RECV_SINGLE_DATA = 'PAGES_RECV_SINGLE_DATA';
	var PAGES_RECV_ERROR = exports.PAGES_RECV_ERROR = 'PAGES_RECV_ERROR';
	
	//AGENCIES ACTIONS
	var PROFILES_FETCH = exports.PROFILES_FETCH = 'PROFILES_FETCH';
	var PROFILES_FETCH_SINGLE = exports.PROFILES_FETCH_SINGLE = 'PROFILES_FETCH_SINGLE';
	var PROFILES_CLEAR_DATA = exports.PROFILES_CLEAR_DATA = 'PROFILES_CLEAR_DATA';
	var PROFILES_REQ_DATA = exports.PROFILES_REQ_DATA = 'PROFILES_REQ_DATA';
	var PROFILES_REQ_SINGLE_DATA = exports.PROFILES_REQ_SINGLE_DATA = 'PROFILES_REQ_SINGLE_DATA';
	var PROFILES_RECV_DATA = exports.PROFILES_RECV_DATA = 'PROFILES_RECV_DATA';
	var PROFILES_RECV_SINGLE_DATA = exports.PROFILES_RECV_SINGLE_DATA = 'PROFILES_RECV_SINGLE_DATA';
	var PROFILES_RECV_CASE_DATA = exports.PROFILES_RECV_CASE_DATA = 'PROFILES_RECV_CASE_DATA';
	var PROFILES_RECV_ERROR = exports.PROFILES_RECV_ERROR = 'PROFILES_RECV_ERROR';
	
	//JURY ACTIONS
	var JURY_RECV_DATA = exports.JURY_RECV_DATA = 'JURY_RECV_DATA';
	var JURY_RECV_ERROR = exports.JURY_RECV_ERROR = 'JURY_RECV_ERROR';
	
	//TIMELINE ACTIONS
	var TIMELINE_CLEAR_DATA = exports.TIMELINE_CLEAR_DATA = 'TIMELINE_CLEAR_DATA';
	var TIMELINE_REQ_DATA = exports.TIMELINE_REQ_DATA = 'TIMELINE_REQ_DATA';
	var TIMELINE_RECV_ERROR = exports.TIMELINE_RECV_ERROR = 'TIMELINE_RECV_ERROR';
	var TIMELINE_FILTER = exports.TIMELINE_FILTER = 'TIMELINE_FILTER';
	
	var TIMELINE_RECV_INIT_DATA = exports.TIMELINE_RECV_INIT_DATA = 'TIMELINE_RECV_INIT_DATA';
	var TIMELINE_RECV_NEXT_DATA = exports.TIMELINE_RECV_NEXT_DATA = 'TIMELINE_RECV_NEXT_DATA';
	var TIMELINE_RECV_PREV_DATA = exports.TIMELINE_RECV_PREV_DATA = 'TIMELINE_RECV_PREV_DATA';
	var TIMELINE_FETCH_NEXT = exports.TIMELINE_FETCH_NEXT = 'TIMELINE_FETCH_NEXT';
	var TIMELINE_FETCH_PREV = exports.TIMELINE_FETCH_PREV = 'TIMELINE_FETCH_PREV';
	
	// FOOTER
	var FOOTER_STICKY_UPDATE = exports.FOOTER_STICKY_UPDATE = 'FOOTER_STICKY_UPDATE';
	
	//USERS ACTIONS
	var USERS_LOGIN_INIT = exports.USERS_LOGIN_INIT = 'USERS_LOGIN_INIT';
	var USERS_LOGIN = exports.USERS_LOGIN = 'USERS_LOGIN';
	var USERS_LOGIN_FB = exports.USERS_LOGIN_FB = 'USERS_LOGIN_FB';
	var USERS_LOGIN_TWITTER = exports.USERS_LOGIN_TWITTER = 'USERS_LOGIN_TWITTER';
	var USERS_LOGIN_GOOGLE = exports.USERS_LOGIN_GOOGLE = 'USERS_LOGIN_GOOGLE';
	var USERS_LOGOUT = exports.USERS_LOGOUT = 'USERS_LOGOUT';
	var USERS_ERROR = exports.USERS_ERROR = 'USERS_ERROR';
	
	//CATEGORIES
	var CATEGORIES_RECV_DATA = exports.CATEGORIES_RECV_DATA = 'CATEGORIES_RECV_DATA';
	var CATEGORIES_RECV_ERROR = exports.CATEGORIES_RECV_ERROR = 'CATEGORIES_RECV_ERROR';
	
	//ACCOUNT
	var ACCOUNT_RECV_SINGLE = exports.ACCOUNT_RECV_SINGLE = 'ACCOUNT_RECV_SINGLE';
	var ACCOUNT_RECV_COLLECTION = exports.ACCOUNT_RECV_COLLECTION = 'ACCOUNT_RECV_COLLECTION';
	var ACCOUNT_CLEAR_SINGLE = exports.ACCOUNT_CLEAR_SINGLE = 'ACCOUNT_CLEAR_SINGLE';
	var ACCOUNT_CLEAR_COLLECTION = exports.ACCOUNT_CLEAR_COLLECTION = 'ACCOUNT_CLEAR_COLLECTION';
	
	var ACCOUNT_EDITORIAL_RECV_DATA = exports.ACCOUNT_EDITORIAL_RECV_DATA = 'ACCOUNT_EDITORIAL_RECV_DATA';
	var ACCOUNT_EDITORIAL_RECV_ERROR = exports.ACCOUNT_EDITORIAL_RECV_ERROR = 'ACCOUNT_EDITORIAL_RECV_ERROR';
	var ACCOUNT_EDITORIAL_SAVE = exports.ACCOUNT_EDITORIAL_SAVE = 'ACCOUNT_EDITORIAL_SAVE';
	var ACCOUNT_EDITORIAL_SAVE_ERROR = exports.ACCOUNT_EDITORIAL_SAVE_ERROR = 'ACCOUNT_EDITORIAL_SAVE_ERROR';
	var ACCOUNT_EDITORIAL_PREVIEW = exports.ACCOUNT_EDITORIAL_PREVIEW = 'ACCOUNT_EDITORIAL_PREVIEW';
	var ACCOUNT_EDITORIAL_PUBLISH = exports.ACCOUNT_EDITORIAL_PUBLISH = 'ACCOUNT_EDITORIAL_PUBLISH';
	var ACCOUNT_EDITORIAL_PUBLISH_ERROR = exports.ACCOUNT_EDITORIAL_PUBLISH_ERROR = 'ACCOUNT_EDITORIAL_PUBLISH_ERROR';
	
	// COOKIE
	var COOKIES_ACCEPT = exports.COOKIES_ACCEPT = 'COOKIES_ACCEPT';

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.formatNumber = formatNumber;
	exports.millisToMinutesAndSeconds = millisToMinutesAndSeconds;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dateRegex = /^([0-9]{4}(\-[0-9]{2}){2})/;
	var dbDateRegex = /([0-9]{4})-([0-1]{1}[0-9]{1})-([0-3]{1}[0-9]{1}) ([0-2]{1}[0-9]{1}):([0-6]{1}[0-9]{1}):([0-6]{1}[0-9]{1})/;
	var locales = exports.locales = {
		en: {
			monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		}
	};
	
	function formatNumber(number) {
		if (parseInt(number, 10) < 10) {
			return '0' + number;
		}
	
		return number.toString();
	}
	
	function millisToMinutesAndSeconds(millis) {
		var minutes = Math.floor(millis / 60000);
		var seconds = (millis % 60000 / 1000).toFixed(0);
		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}
	
	var DateFormatter = exports.DateFormatter = function () {
		function DateFormatter() {
			var dateStr = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
			_classCallCheck(this, DateFormatter);
	
			if (typeof dateStr === 'string' && dateStr.length) {
				//YYYY-MM-DD HH:MM:SS
	
				if (dbDateRegex.test(dateStr)) {
					var match = dbDateRegex.exec(dateStr);
					this._internalDate = new Date(match[1], parseInt(match[2], 10) - 1, match[3], match[4], match[5], match[6]);
				} else if (dateRegex.test(dateStr)) {
					//Removing substr as we need the time in some locations.
					dateStr = dateStr.substr(0, 10);
					this._internalDate = new Date(dateStr);
				} else {
					console.warn('DateFormatter expect a string in the format "YYYY-MM-DD", was: ' + dateStr.toString());
					this._internalDate = new Date();
				}
			} else if (typeof dateStr === 'number' && dateStr) {
				this._internalDate = new Date(dateStr);
			} else {
				this._internalDate = new Date();
			}
		}
	
		_createClass(DateFormatter, [{
			key: 'addTime',
			value: function addTime(ms) {
				if (typeof ms === 'number') {
					this._internalDate = new Date(this._internalDate.getTime() + ms);
				}
			}
		}, {
			key: 'getTime',
			value: function getTime() {
				return this._internalDate.getTime();
			}
		}, {
			key: 'calculateDaysBetweenString',
			value: function calculateDaysBetweenString() {
				var endDate = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
				var eDate = (typeof endDate === 'undefined' ? 'undefined' : _typeof(endDate)) === 'object' ? endDate : new DateFormatter(endDate);
	
				if (typeof eDate.getTime !== 'function') {
					return '??';
				}
	
				var createStamp = this._internalDate.getTime();
				var winStamp = eDate.getTime();
	
				var days = Math.ceil((winStamp - createStamp) / 86400000); // 1000*60*60*24
	
				//if (!days) { //debug
				//	console.log(`Math.ceil((${winStamp} - ${createStamp}) / (86400000)) === ${days}`);
				//}
	
				return formatNumber(days);
			}
		}, {
			key: 'toString',
			value: function toString() {
				var d = this._internalDate;
				var month = formatNumber(d.getUTCMonth() + 1);
				var day = formatNumber(d.getUTCDay());
	
				return d.getUTCFullYear() + '-' + month + '-' + day;
			}
		}, {
			key: 'date',
			get: function get() {
				return formatNumber(this._internalDate.getUTCDate());
			}
		}, {
			key: 'month',
			get: function get() {
				return locales.en.monthNames[this._internalDate.getUTCMonth()];
			}
		}, {
			key: 'monthShort',
			get: function get() {
				return locales.en.monthNamesShort[this._internalDate.getUTCMonth()];
			}
		}, {
			key: 'year',
			get: function get() {
				return this._internalDate.getUTCFullYear();
			}
		}, {
			key: 'dayOfWeek',
			get: function get() {
				return this._internalDate.getUTCDay();
			}
		}, {
			key: 'week',
			get: function get() {
				// Copy date so don't modify original
				var d = new Date(this._internalDate);
				d.setHours(0, 0, 0);
	
				// Set to nearest Thursday: current date + 4 - current day number
				// Make Sunday's day number 7
				d.setDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
	
				// Get first day of year
				var yearStart = new Date(d.getUTCFullYear(), 0, 1);
	
				// Calculate full weeks to nearest Thursday
				var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
	
				return weekNo;
			}
		}, {
			key: 'monthAndYear',
			get: function get() {
				var month = locales.en.monthNames[this._internalDate.getUTCMonth()];
	
				return this.month + ', ' + this._internalDate.getUTCFullYear();
			}
		}, {
			key: 'monthDateAndYear',
			get: function get() {
				var month = locales.en.monthNames[this._internalDate.getUTCMonth()];
	
				return this.month + ' ' + this._internalDate.getUTCDate() + ', ' + this._internalDate.getUTCFullYear();
			}
		}, {
			key: 'dateMonthAndYear',
			get: function get() {
				var month = locales.en.monthNames[this._internalDate.getUTCMonth()];
	
				return this._internalDate.getUTCDate() + ' ' + this.month + ', ' + this._internalDate.getUTCFullYear();
			}
		}, {
			key: 'dateShortMonthAndYear',
			get: function get() {
				var month = locales.en.monthNames[this._internalDate.getUTCMonth()];
	
				return this._internalDate.getUTCDate() + ' ' + this.monthShort + ', ' + this._internalDate.getUTCFullYear();
			}
		}, {
			key: 'prettyTime',
			get: function get() {
				var hours = this._internalDate.getUTCHours();
				var minutes = '0' + this._internalDate.getUTCMinutes();
				var seconds = '0' + this._internalDate.getUTCSeconds();
	
				// Will display time in 10:30:23 format
				return hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
			}
		}]);

		return DateFormatter;
	}();

/***/ },
/* 15 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = translate;
	
	var _markdown = __webpack_require__(506);
	
	function translate() {
		var path = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
		var md = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
		var stripParagraphs = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
		var target = arguments.length <= 3 || arguments[3] === undefined ? '_blank' : arguments[3];
	
		if (window.konfig && window.konfig.translations) {
			var _ret = function () {
				var getTrans = function getTrans(path, translations) {
					var pathSlice = path.pop();
					if (translations[pathSlice]) {
						if (_typeof(translations[pathSlice]) === 'object') {
							return getTrans(path, translations[pathSlice]);
						} else if (typeof translations[pathSlice] === 'string') {
							return translations[pathSlice];
						}
					}
	
					console.warn('Localization not defined. ' + pathSlice);
					return '';
				};
	
				var translations = window.konfig.translations;
				var pathArr = [];
	
				pathArr = path.split('/');
				pathArr.reverse();
	
				var trans = getTrans(pathArr, translations);
	
				if (md) {
					var breakRegex = /<br\s*[\/]?>/gi;
					var anchorTargetRegex = /<a /gi;
					trans = trans.replace(breakRegex, '');
	
					trans = _markdown.markdown.toHTML(trans);
	
					trans = trans.replace(anchorTargetRegex, '<a target="' + target + '" ');
				}
	
				if (stripParagraphs) {
					trans = trans.replace(new RegExp('<p>', 'g'), '').replace(new RegExp('</p>', 'g'), '');
				}
	
				return {
					v: trans
				};
			}();
	
			if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		}
	
		return '';
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function warning(condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import defaultImg from './image-ph.png';
	
	var sizes = {
		720: 538,
		1200: 958,
		1441: 1364
	};
	
	var sizesExact = _extends({}, sizes, {
		568: 314,
		1000: 706,
		1440: 1126
	});
	
	var sizeNames = {
		314: 'mobile-small',
		538: 'mobile',
		706: 'tablet-small',
		958: 'tablet',
		1126: 'desktop-small',
		1364: 'desktop'
	};
	
	var ResponsiveImage = function (_Component) {
		_inherits(ResponsiveImage, _Component);
	
		function ResponsiveImage(props) {
			_classCallCheck(this, ResponsiveImage);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ResponsiveImage).call(this, props));
	
			_this.mounted = true;
	
			_this.state = {
				broken: false
			};
			return _this;
		}
	
		_createClass(ResponsiveImage, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this2 = this;
	
				if (!(0, _deepEqual2.default)(nextProps.img, this.props.img)) {
					this.setState({
						clear: true
					});
	
					setTimeout(function () {
						_this2.mounted && _this2.setState({
							clear: false
						});
					}, 20);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var path = this.getPath();
	
				if (this.state.clear) {
					return false;
				}
	
				if (path && !this.state.broken) {
					if (!this.props.renderToDiv) {
						return _react2.default.createElement('img', {
							src: path,
							alt: this.getAltText(),
							className: this.props.className,
							style: this.props.style,
							onError: function onError(e) {
								return _this3.brokenImage(true, e);
							},
							onLoad: function onLoad(e) {
								return _this3.brokenImage(false, e);
							}
						});
					} else {
						var style = _extends({}, this.props.style, {
							backgroundImage: 'url(' + path + ')'
						});
	
						return _react2.default.createElement(
							'div',
							{ className: this.props.className, style: style },
							this.props.children
						);
					}
				}
	
				return false;
			}
		}, {
			key: 'brokenImage',
			value: function brokenImage(val, e) {
				if (this.state.broken !== val) {
					this.setState(_extends({}, this.state, {
						broken: val
					}));
				}
	
				this.props.onLoad(val, e);
			}
		}, {
			key: 'getPath',
			value: function getPath() {
				if (typeof this.props.img === 'string') {
					return this.props.img;
				}
	
				var resolution = this.getResolution();
				var span = this.getSpan();
	
				if (this.props.img && this.props.img.hasOwnProperty(resolution) && this.props.img[resolution].hasOwnProperty(span) && this.props.img[resolution][span]) {
					return this.props.img[resolution][span];
				}
	
				return false;
			}
		}, {
			key: 'getSpan',
			value: function getSpan() {
				if (typeof this.props.span === 'string') {
					if (this.props.span) {
						return this.props.span;
					}
	
					var res = Object.keys(this.props.img);
					var span = Object.keys(this.props.img[res[0]]);
					return span[span.length - 1];
				} else if (_typeof(this.props.span) === 'object') {
					var breakpoint = sizeNames[this.getResolution()];
	
					// this.props.useExactBreakpoint && console.log(breakpoint);
					if (this.props.span.hasOwnProperty(breakpoint)) {
						return this.props.span[breakpoint];
					}
				}
	
				return 'span14';
			}
		}, {
			key: 'getAltText',
			value: function getAltText() {
				return this.props.alt || '';
			}
		}, {
			key: 'getResolution',
			value: function getResolution() {
				var browserWidth = this.props.browser && this.props.browser.window ? this.props.browser.window.width : 2000;
				var sizeArray = this.props.useExactBreakpoint ? sizesExact : sizes;
				var keys = Object.keys(sizeArray);
				for (var i = 0; i < keys.length; i++) {
					if (browserWidth < keys[i] || !keys.hasOwnProperty(i + 1)) {
						// this.props.useExactBreakpoint && console.log(`${browserWidth} < ${keys[i]}  >> ${sizeArray[keys[i]]}`);
						return sizeArray[keys[i]];
					}
				}
			}
		}]);
	
		return ResponsiveImage;
	}(_react.Component);
	
	ResponsiveImage.propTypes = {
		browser: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.oneOf([false])]).isRequired,
		img: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string, _react.PropTypes.oneOf([false])]),
		alt: _react.PropTypes.string,
		span: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]).isRequired,
		className: _react.PropTypes.string,
		useExactBreakpoint: _react.PropTypes.bool,
		style: _react.PropTypes.object,
		renderToDiv: _react.PropTypes.bool,
		onLoad: _react.PropTypes.func
	};
	ResponsiveImage.defaultProps = {
		browser: false,
		useExactBreakpoint: false,
		style: {},
		renderToDiv: false,
		className: '',
		onLoad: function onLoad() {}
	};
	exports.default = ResponsiveImage;

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var BlockTree = __webpack_require__(426);
	var ContentState = __webpack_require__(272);
	var EditorBidiService = __webpack_require__(933);
	var Immutable = __webpack_require__(24);
	var SelectionState = __webpack_require__(138);
	
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	var Stack = Immutable.Stack;
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = (function () {
	  _createClass(EditorState, [{
	    key: 'toJS',
	    value: function toJS() {
	      return this.getImmutable().toJS();
	    }
	  }, {
	    key: 'getAllowUndo',
	    value: function getAllowUndo() {
	      return this.getImmutable().get('allowUndo');
	    }
	  }, {
	    key: 'getCurrentContent',
	    value: function getCurrentContent() {
	      return this.getImmutable().get('currentContent');
	    }
	  }, {
	    key: 'getUndoStack',
	    value: function getUndoStack() {
	      return this.getImmutable().get('undoStack');
	    }
	  }, {
	    key: 'getRedoStack',
	    value: function getRedoStack() {
	      return this.getImmutable().get('redoStack');
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      return this.getImmutable().get('selection');
	    }
	  }, {
	    key: 'getDecorator',
	    value: function getDecorator() {
	      return this.getImmutable().get('decorator');
	    }
	  }, {
	    key: 'isInCompositionMode',
	    value: function isInCompositionMode() {
	      return this.getImmutable().get('inCompositionMode');
	    }
	  }, {
	    key: 'mustForceSelection',
	    value: function mustForceSelection() {
	      return this.getImmutable().get('forceSelection');
	    }
	  }, {
	    key: 'getNativelyRenderedContent',
	    value: function getNativelyRenderedContent() {
	      return this.getImmutable().get('nativelyRenderedContent');
	    }
	  }, {
	    key: 'getLastChangeType',
	    value: function getLastChangeType() {
	      return this.getImmutable().get('lastChangeType');
	    }
	
	    /**
	     * While editing, the user may apply inline style commands with a collapsed
	     * cursor, intending to type text that adopts the specified style. In this
	     * case, we track the specified style as an "override" that takes precedence
	     * over the inline style of the text adjacent to the cursor.
	     *
	     * If null, there is no override in place.
	     */
	  }, {
	    key: 'getInlineStyleOverride',
	    value: function getInlineStyleOverride() {
	      return this.getImmutable().get('inlineStyleOverride');
	    }
	  }, {
	    key: 'getCurrentInlineStyle',
	
	    /**
	     * Get the appropriate inline style for the editor state. If an
	     * override is in place, use it. Otherwise, the current style is
	     * based on the location of the selection state.
	     */
	    value: function getCurrentInlineStyle() {
	      var override = this.getInlineStyleOverride();
	      if (override != null) {
	        return override;
	      }
	
	      var content = this.getCurrentContent();
	      var selection = this.getSelection();
	
	      if (selection.isCollapsed()) {
	        return getInlineStyleForCollapsedSelection(content, selection);
	      }
	
	      return getInlineStyleForNonCollapsedSelection(content, selection);
	    }
	  }, {
	    key: 'getBlockTree',
	    value: function getBlockTree(blockKey) {
	      return this.getImmutable().getIn(['treeMap', blockKey]);
	    }
	  }, {
	    key: 'isSelectionAtStartOfContent',
	    value: function isSelectionAtStartOfContent() {
	      var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	      return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	    }
	  }, {
	    key: 'isSelectionAtEndOfContent',
	    value: function isSelectionAtEndOfContent() {
	      var content = this.getCurrentContent();
	      var blockMap = content.getBlockMap();
	      var last = blockMap.last();
	      var end = last.getLength();
	      return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	    }
	  }, {
	    key: 'getDirectionMap',
	    value: function getDirectionMap() {
	      return this.getImmutable().get('directionMap');
	    }
	
	    /**
	     * Incorporate native DOM selection changes into the EditorState. This
	     * method can be used when we simply want to accept whatever the DOM
	     * has given us to represent selection, and we do not need to re-render
	     * the editor.
	     *
	     * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	     */
	  }], [{
	    key: 'createEmpty',
	    value: function createEmpty(decorator) {
	      return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	    }
	  }, {
	    key: 'createWithContent',
	    value: function createWithContent(contentState, decorator) {
	      var firstKey = contentState.getBlockMap().first().getKey();
	      return EditorState.create({
	        currentContent: contentState,
	        undoStack: Stack(),
	        redoStack: Stack(),
	        decorator: decorator || null,
	        selection: SelectionState.createEmpty(firstKey)
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(config) {
	      var currentContent = config.currentContent;
	      var decorator = config.decorator;
	
	      var recordConfig = _extends({}, config, {
	        treeMap: generateNewTreeMap(currentContent, decorator),
	        directionMap: EditorBidiService.getDirectionMap(currentContent)
	      });
	      return new EditorState(new EditorStateRecord(recordConfig));
	    }
	  }, {
	    key: 'set',
	    value: function set(editorState, put) {
	      var map = editorState.getImmutable().withMutations(function (state) {
	        var existingDecorator = state.get('decorator');
	        var decorator = existingDecorator;
	        if (put.decorator === null) {
	          decorator = null;
	        } else if (put.decorator) {
	          decorator = put.decorator;
	        }
	
	        var newContent = put.currentContent || editorState.getCurrentContent();
	
	        if (decorator !== existingDecorator) {
	          var treeMap = state.get('treeMap');
	          var newTreeMap;
	          if (decorator && existingDecorator) {
	            newTreeMap = regenerateTreeForNewDecorator(newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	          } else {
	            newTreeMap = generateNewTreeMap(newContent, decorator);
	          }
	
	          state.merge({
	            decorator: decorator,
	            treeMap: newTreeMap,
	            nativelyRenderedContent: null
	          });
	          return;
	        }
	
	        var existingContent = editorState.getCurrentContent();
	        if (newContent !== existingContent) {
	          state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), decorator));
	        }
	
	        state.merge(put);
	      });
	
	      return new EditorState(map);
	    }
	  }, {
	    key: 'setInlineStyleOverride',
	    value: function setInlineStyleOverride(editorState, inlineStyleOverride) {
	      return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	    }
	  }, {
	    key: 'acceptSelection',
	    value: function acceptSelection(editorState, selection) {
	      return updateSelection(editorState, selection, false);
	    }
	
	    /**
	     * At times, we need to force the DOM selection to be where we
	     * need it to be. This can occur when the anchor or focus nodes
	     * are non-text nodes, for instance. In this case, we want to trigger
	     * a re-render of the editor, which in turn forces selection into
	     * the correct place in the DOM. The `forceSelection` method
	     * accomplishes this.
	     *
	     * This method should be used in cases where you need to explicitly
	     * move the DOM selection from one place to another without a change
	     * in ContentState.
	     */
	  }, {
	    key: 'forceSelection',
	    value: function forceSelection(editorState, selection) {
	      if (!selection.getHasFocus()) {
	        selection = selection.set('hasFocus', true);
	      }
	      return updateSelection(editorState, selection, true);
	    }
	
	    /**
	     * Move selection to the end of the editor without forcing focus.
	     */
	  }, {
	    key: 'moveSelectionToEnd',
	    value: function moveSelectionToEnd(editorState) {
	      var content = editorState.getCurrentContent();
	      var lastBlock = content.getLastBlock();
	      var lastKey = lastBlock.getKey();
	      var length = lastBlock.getLength();
	
	      return EditorState.acceptSelection(editorState, new SelectionState({
	        anchorKey: lastKey,
	        anchorOffset: length,
	        focusKey: lastKey,
	        focusOffset: length,
	        isBackward: false
	      }));
	    }
	
	    /**
	     * Force focus to the end of the editor. This is useful in scenarios
	     * where we want to programmatically focus the input and it makes sense
	     * to allow the user to continue working seamlessly.
	     */
	  }, {
	    key: 'moveFocusToEnd',
	    value: function moveFocusToEnd(editorState) {
	      var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	      return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	    }
	
	    /**
	     * Push the current ContentState onto the undo stack if it should be
	     * considered a boundary state, and set the provided ContentState as the
	     * new current content.
	     */
	  }, {
	    key: 'push',
	    value: function push(editorState, contentState, changeType) {
	      if (editorState.getCurrentContent() === contentState) {
	        return editorState;
	      }
	
	      var forceSelection = changeType !== 'insert-characters';
	      var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	      if (!editorState.getAllowUndo()) {
	        return EditorState.set(editorState, {
	          currentContent: contentState,
	          directionMap: directionMap,
	          lastChangeType: changeType,
	          selection: contentState.getSelectionAfter(),
	          forceSelection: forceSelection,
	          inlineStyleOverride: null
	        });
	      }
	
	      var selection = editorState.getSelection();
	      var currentContent = editorState.getCurrentContent();
	      var undoStack = editorState.getUndoStack();
	      var newContent = contentState;
	
	      if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	        undoStack = undoStack.push(currentContent);
	        newContent = newContent.set('selectionBefore', selection);
	      } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	        // Preserve the previous selection.
	        newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	      }
	
	      var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	      // Don't discard inline style overrides on block type or depth changes.
	      if (changeType !== 'adjust-depth' && changeType !== 'change-block-type') {
	        inlineStyleOverride = null;
	      }
	
	      var editorStateChanges = {
	        currentContent: newContent,
	        directionMap: directionMap,
	        undoStack: undoStack,
	        redoStack: Stack(),
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: inlineStyleOverride
	      };
	
	      return EditorState.set(editorState, editorStateChanges);
	    }
	
	    /**
	     * Make the top ContentState in the undo stack the new current content and
	     * push the current content onto the redo stack.
	     */
	  }, {
	    key: 'undo',
	    value: function undo(editorState) {
	      if (!editorState.getAllowUndo()) {
	        return editorState;
	      }
	
	      var undoStack = editorState.getUndoStack();
	      var newCurrentContent = undoStack.peek();
	      if (!newCurrentContent) {
	        return editorState;
	      }
	
	      var currentContent = editorState.getCurrentContent();
	      var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	      return EditorState.set(editorState, {
	        currentContent: newCurrentContent,
	        directionMap: directionMap,
	        undoStack: undoStack.shift(),
	        redoStack: editorState.getRedoStack().push(currentContent),
	        forceSelection: true,
	        inlineStyleOverride: null,
	        lastChangeType: 'undo',
	        nativelyRenderedContent: null,
	        selection: currentContent.getSelectionBefore()
	      });
	    }
	
	    /**
	     * Make the top ContentState in the redo stack the new current content and
	     * push the current content onto the undo stack.
	     */
	  }, {
	    key: 'redo',
	    value: function redo(editorState) {
	      if (!editorState.getAllowUndo()) {
	        return editorState;
	      }
	
	      var redoStack = editorState.getRedoStack();
	      var newCurrentContent = redoStack.peek();
	      if (!newCurrentContent) {
	        return editorState;
	      }
	
	      var currentContent = editorState.getCurrentContent();
	      var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	      return EditorState.set(editorState, {
	        currentContent: newCurrentContent,
	        directionMap: directionMap,
	        undoStack: editorState.getUndoStack().push(currentContent),
	        redoStack: redoStack.shift(),
	        forceSelection: true,
	        inlineStyleOverride: null,
	        lastChangeType: 'redo',
	        nativelyRenderedContent: null,
	        selection: newCurrentContent.getSelectionAfter()
	      });
	    }
	
	    /**
	     * Not for public consumption.
	     */
	  }]);
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Set the supplied SelectionState as the new current selection, and set
	   * the `force` flag to trigger manual selection placement by the view.
	   */
	
	  /**
	   * Not for public consumption.
	   */
	
	  _createClass(EditorState, [{
	    key: 'getImmutable',
	    value: function getImmutable() {
	      return this._immutable;
	    }
	  }]);
	
	  return EditorState;
	})();
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, decorator) {
	  var prevBlockMap = editorState.getCurrentContent().getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block) !== existingDecorator.getDecorations(block);
	  }).map(function (block) {
	    return BlockTree.generate(block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var previousBlock = content.getBlockBefore(fromKey);
	  var previousLength;
	
	  while (previousBlock) {
	    previousLength = previousBlock.getLength();
	    if (previousLength) {
	      return previousBlock.getInlineStyleAt(previousLength - 1);
	    }
	    previousBlock = content.getBlockBefore(previousBlock.getKey());
	  }
	
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1125),
	    baseEach = __webpack_require__(293),
	    baseIteratee = __webpack_require__(295),
	    isArray = __webpack_require__(72);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(154)('wks');
	var uid = __webpack_require__(118);
	var Symbol = __webpack_require__(15).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(566);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1374);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1373);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1372);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(565);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(567);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(70);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(19)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.dispatchError = dispatchError;
	exports.dispatchMsg = dispatchMsg;
	exports.clearErrors = clearErrors;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function dispatchError(data) {
		return function (dispatch) {
			dispatch({
				type: actionTypes.RECV_ERROR,
				payload: data
			});
	
			if (data.message && (data.message === 'Login is required' || data.message === 'Requires login')) {
				dispatch({
					type: actionTypes.USERS_LOGOUT
				});
			}
		};
	}
	
	function dispatchMsg(data) {
		return function (dispatch) {
			dispatch({
				type: actionTypes.RECV_MSG,
				payload: data
			});
		};
	}
	
	function clearErrors() {
		return function (dispatch) {
			dispatch({
				type: actionTypes.CLEAR_ERROR
			});
		};
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdown = __webpack_require__(506);
	
	var _confirm = __webpack_require__(448);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmDialog = function (_Component) {
		_inherits(ConfirmDialog, _Component);
	
		function ConfirmDialog(props) {
			_classCallCheck(this, ConfirmDialog);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConfirmDialog).call(this));
	
			_this.promiseResolve = function () {};
			_this.promiseReject = function () {};
	
			_this.newPromise();
			_this._handleEscKey = _this._handleEscKey.bind(_this);
	
			_this.state = {
				show: false,
				text: 'Are you sure?',
				confirmText: 'Confirm',
				cancelText: 'Cancel',
				openLinkOnConfirm: false
			};
			return _this;
		}
	
		_createClass(ConfirmDialog, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'confirm-dialog';
	
				if (this.state.show) {
					className += ' confirm-dialog--show';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className, onClick: function onClick(e) {
							return _this2.close(e);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'confirm-dialog__dialog', onClick: function onClick(e) {
								return e.stopPropagation();
							} },
						_react2.default.createElement('div', { className: 'confirm-dialog__dialog__content', dangerouslySetInnerHTML: { __html: _markdown.markdown.toHTML(this.state.text) } }),
						_react2.default.createElement(
							'div',
							{ className: 'confirm-dialog__dialog__actions' },
							!!this.state.confirmText && (this.state.openLinkOnConfirm && _react2.default.createElement(
								'a',
								{ href: this.state.openLinkOnConfirm, target: '_blank', className: 'button', onClick: function onClick() {
										return _this2.handleOK();
									} },
								this.state.confirmText
							) || _react2.default.createElement(
								'button',
								{ onClick: this.handleOK.bind(this), ref: 'confirm' },
								this.state.confirmText
							)),
							!!this.state.cancelText && _react2.default.createElement(
								'button',
								{ onClick: this.handleCancel.bind(this), className: 'button--dark' },
								this.state.cancelText
							)
						)
					)
				);
			}
		}, {
			key: 'handleOK',
			value: function handleOK(e) {
				e && e.preventDefault();
				this.promiseResolve();
				this.setState(_extends({}, this.state, { show: false }));
			}
		}, {
			key: 'handleCancel',
			value: function handleCancel(e) {
				e.preventDefault();
				this.promiseReject({ status: 'CANCELLED' });
				this.setState(_extends({}, this.state, { show: false }));
			}
		}, {
			key: 'close',
			value: function close(e) {
				e.preventDefault();
				e.stopPropagation();
				this.promiseReject({ status: 'CLOSED' });
				this.setState(_extends({}, this.state, { show: false }));
			}
		}, {
			key: 'newPromise',
			value: function newPromise() {
				var _this3 = this;
	
				this.promise = new Promise(function (resolve, reject) {
					_this3.promiseResolve = resolve;
					_this3.promiseReject = reject;
				});
			}
		}, {
			key: 'confirm',
			value: function confirm(text) {
				var confirmText = arguments.length <= 1 || arguments[1] === undefined ? 'Confirm' : arguments[1];
	
				var _this4 = this;
	
				var cancelText = arguments.length <= 2 || arguments[2] === undefined ? 'Cancel' : arguments[2];
				var openLinkOnConfirm = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
				this.newPromise();
				this.setState(_extends({}, this.state, {
					show: true,
					text: text,
					confirmText: confirmText,
					cancelText: cancelText,
					openLinkOnConfirm: openLinkOnConfirm
				}));
				this.refs.confirm && this.refs.confirm.focus();
	
				document.addEventListener('keydown', this._handleEscKey, false);
	
				this.promise.then(function () {
					document.removeEventListener('keydown', _this4._handleEscKey, false);
				}).catch(function () {
					document.removeEventListener('keydown', _this4._handleEscKey, false);
				});
	
				return this.promise;
			}
		}, {
			key: '_handleEscKey',
			value: function _handleEscKey(e) {
				if (e.keyCode === 27) {
					this.handleCancel(e);
				}
			}
		}]);
	
		return ConfirmDialog;
	}(_react.Component);
	
	ConfirmDialog.propTypes = {};
	ConfirmDialog.defaultProps = {};
	exports.default = ConfirmDialog;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _submit = __webpack_require__(1005);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSubmit = function (_Component) {
		_inherits(InputSubmit, _Component);
	
		function InputSubmit() {
			_classCallCheck(this, InputSubmit);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(InputSubmit).apply(this, arguments));
		}
	
		_createClass(InputSubmit, [{
			key: 'render',
			value: function render() {
				var defaultClass = 'form-submit';
				var spinnerClass = 'form-submit__spinner';
	
				if (this.props.className) {
					defaultClass += ' ' + this.props.className;
				}
	
				if (this.props.waiting) {
					defaultClass += ' form-submit--show-spinner';
				}
	
				return _react2.default.createElement(
					'button',
					_extends({ type: 'submit', value: this.props.name }, this.props, { className: defaultClass, onClick: this.props.onClick }),
					this.props.name,
					_react2.default.createElement(_spinner2.default, { size: '16px', className: spinnerClass, pathbgStroke: 'transparent', pathStroke: '#dbdbdb', active: this.props.waiting })
				);
			}
		}]);
	
		return InputSubmit;
	}(_react.Component);
	
	InputSubmit.propTypes = {
		name: _react2.default.PropTypes.string.isRequired,
		waiting: _react2.default.PropTypes.bool,
		onClick: _react2.default.PropTypes.func
	};
	InputSubmit.defaultProps = {
		waiting: false,
		onClick: function onClick() {}
	};
	exports.default = InputSubmit;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import CornerLabel from '../../components/block/cornerLabel';
	
	//import css from './account.scss';
	
	var AccountBlockSplitter = function (_Component) {
		_inherits(AccountBlockSplitter, _Component);
	
		function AccountBlockSplitter(props) {
			_classCallCheck(this, AccountBlockSplitter);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountBlockSplitter).call(this));
		}
	
		_createClass(AccountBlockSplitter, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-splitter ' + this.props.className },
					_react2.default.createElement('div', { className: 'pixel-pattern pixel-pattern--01 span5 span5-tablet span7-mobile' })
				);
			}
		}]);
	
		return AccountBlockSplitter;
	}(_react.Component);
	
	AccountBlockSplitter.propTypes = {
		className: _react.PropTypes.string
	};
	AccountBlockSplitter.defaultProps = {
		className: ''
	};
	exports.default = AccountBlockSplitter;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(298);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _validate = __webpack_require__(76);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _text = __webpack_require__(450);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputText = function (_Component) {
		_inherits(InputText, _Component);
	
		function InputText(props) {
			_classCallCheck(this, InputText);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputText).call(this));
	
			_this.valid = typeof props.error === 'undefined' ? true : !props.error;
	
			_this.state = {
				value: '' + props.value,
				valid: _this.valid
			};
			return _this;
		}
	
		_createClass(InputText, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.valid !== nextState.valid || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = _extends({}, this.state);
				if (nextProps.error && nextProps.error !== this.props.error) {
					this.valid = !nextProps.error;
					newState.valid = this.valid;
				}
	
				if (nextProps.value !== this.props.value) {
					newState.value = '' + nextProps.value;
				}
	
				this.setState(newState);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'custom-input__input';
				var hideLabel = this.props.hideLabel || this.props.type === 'hidden';
				var btw = this.props.btw;
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (!this.state.valid || this.props.error) {
					className += ' invalid';
				}
	
				if (this.props.disabled) {
					className += ' disabled';
				}
	
				if (this.props.maxChars) {
					btw += ' (' + this.charRemaining(this.state.value) + ' characters left)';
				}
	
				return _react2.default.createElement(
					_label2.default,
					{ name: this.props.name, label: this.props.label, btw: btw, hideLabel: hideLabel, className: 'relative' },
					_react2.default.createElement('input', _extends({ key: 'input', type: this.props.type, id: this.props.name }, this.props, { ref: 'input', disabled: false, value: this.state.value, onChange: function onChange(e) {
							return _this2.onChange(e);
						}, className: className })),
					this.renderError(this.props.error)
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(errors) {
				if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'custom-input__error' },
					errors.map(function (error, i) {
						return _react2.default.createElement(
							'span',
							{ key: i },
							error
						);
					})
				);
			}
		}, {
			key: 'charRemaining',
			value: function charRemaining(value) {
				if (!this.props.maxChars) {
					// when no max is set, always return 1
					return 1;
				}
	
				var remaining = this.props.maxChars - value.length;
				return remaining;
			}
		}, {
			key: 'value',
			value: function value(val) {
				if (!this) {
					return '';
				}
	
				if (val !== undefined) {
					return this.setState(_extends({}, this.state, {
						value: val
					}));
				}
	
				var newVal = this.state.value;
				if (this.refs.input && this.refs.input.value && this.refs.input.value !== this.state.value) {
					newVal.valid = this.refs.input.value;
				}
	
				this.state.value = newVal;
	
				return newVal;
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				if (this.props.disabled) {
					return false;
				}
				var newState = _extends({}, this.state);
	
				var newVal = this.state.value;
				if (e && e.target) {
					newState.value = e.target.value;
				}
	
				if (!this.props.manualValidate && this.props.validate) {
					this.valid = (0, _validate.isValid)(newState.value, this.props.validate, this.props.error);
					newState.valid = this.valid;
				}
	
				// console.log('setState: ', newState.value);
	
				this.setState(newState);
	
				this.props.onChange(newState.value);
			}
		}, {
			key: 'testValidity',
			value: function testValidity() {
				this.valid = (0, _validate.isValid)(this.value(), this.props.validate, this.props.error);
				this.setState(_extends({}, this.state, { valid: this.valid }));
	
				return this.valid;
			}
		}]);
	
		return InputText;
	}(_react.Component);
	
	InputText.propTypes = {
		name: _react.PropTypes.string.isRequired,
		type: _react.PropTypes.string,
		btw: _react.PropTypes.string.isRequired,
		// error: PropTypes.oneOf([
		// 	PropTypes.bool,
		// 	PropTypes.array,
		// 	PropTypes.null,
		// ]),
		value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
		error: _react.PropTypes.bool,
		disabled: _react.PropTypes.oneOf([1, 0, true, false]),
		validate: _react.PropTypes.array,
		manualValidate: _react.PropTypes.bool,
		hideLabel: _react.PropTypes.bool,
		onChange: _react.PropTypes.func,
		maxChars: _react.PropTypes.number.isRequired
	};
	InputText.defaultProps = {
		type: 'text',
		error: undefined,
		value: '',
		btw: '',
		manualValidate: false,
		hideLabel: false,
		maxChars: 0,
		onChange: function onChange() {}
	};
	exports.default = InputText;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(10);
	var IE8_DOM_DEFINE = __webpack_require__(392);
	var toPrimitive = __webpack_require__(82);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.13.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
	    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a cache value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to stub `Date#getTime` use in `_.now`.
	   * var stubbed = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': stubGetTime };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype,
	        stringProto = context.String.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice;
	
	    /** Built-in method references that are mockable. */
	    var setTimeout = function(func, wait) { return context.setTimeout.call(root, func, wait); };
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetPrototype = Object.getPrototypeOf,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReplace = stringProto.replace,
	        nativeReverse = arrayProto.reverse,
	        nativeSplit = stringProto.split;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	     * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	     * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	     * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      this.__data__ = new ListCache(entries);
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      return this.__data__['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var cache = this.__data__;
	      if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	        cache = this.__data__ = new MapCache(cache.__data__);
	      }
	      cache.set(key, value);
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      // Recursively populate clone (susceptible to call stack limits).
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined &&
	              !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return object != null &&
	        (hasOwnProperty.call(object, key) ||
	          (typeof object == 'object' && key in object && getPrototype(object) === null));
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = keysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce `n` to an integer.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var index = -1,
	          props = getAllKeysIn(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]);
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && baseHas(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        predicate = getIteratee(predicate, 3);
	        if (!isArrayLike(collection)) {
	          var props = keys(collection);
	        }
	        var index = findIndexFunc(props || collection, function(value, key) {
	          if (props) {
	            key = value;
	            value = iterable[key];
	          }
	          return predicate(value, key, iterable);
	        }, fromIndex);
	        return index > -1 ? collection[props ? props[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return 0;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!seen.has(othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.add(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and
	          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	          // not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	          stack.set(object, other);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a
	     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	     * Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the `[[Prototype]]` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {null|Object} Returns the `[[Prototype]]`.
	     */
	    function getPrototype(value) {
	      return nativeGetPrototype(Object(value));
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    function getSymbols(object) {
	      // Coerce `object` to an object to avoid non-object errors in V8.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	      return getOwnPropertySymbols(Object(object));
	    }
	
	    // Fallback for IE < 11.
	    if (!getOwnPropertySymbols) {
	      getSymbols = stubArray;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isString(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value);
	    }
	
	    /**
	     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	     * iteratee shorthand.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenableIteratee(value) {
	      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          args = Array(length ? length - 1 : 0),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return length
	        ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other given
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index - 1, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function, it's
	     * invoked for and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      if (isObjectLike(collection)) {
	        var tag = getTag(collection);
	        if (tag == mapTag || tag == setTag) {
	          return collection.size;
	        }
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	        ? iteratees[0]
	        : baseFlatten(iteratees, 1, isFlattenableIteratee);
	
	      return baseOrderBy(collection, iteratees, []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    function now() {
	      return Date.now();
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [transforms[_.identity]] The functions to transform.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? stubFalse : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element,
	     *  else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) || isFunction(value.splice) ||
	            isArguments(value) || isBuffer(value))) {
	        return !value.length;
	      }
	      if (isObjectLike(value)) {
	        var tag = getTag(value);
	        if (tag == mapTag || tag == setTag) {
	          return !value.size;
	        }
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return !(nonEnumShadows && keys(value).length);
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object,
	     *  else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number,
	     *  else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length,
	     *  else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the
	     * presence of the `core-js` package because `core-js` circumvents this kind
	     * of detection. Despite multiple requests, the `core-js` maintainer has made
	     * it clear: any attempt to fix the detection will be obstructed. As a result,
	     * we're left with little choice but to throw an error. Unfortunately, this
	     * also affects packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on `core-js`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error('This method is not supported with `core-js`. Try https://github.com/es-shims.');
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object,
	     *  else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer,
	     *  else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : nativeReplace.call(string, args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (separator == '' && reHasComplexSymbol.test(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return nativeSplit.call(string, separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(baseToString(target), position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['onClick']);
	     * jQuery(element).on('click', view.onClick);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': function(n) { return n > 38; } }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A method that returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return rest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [predicates=[_.identity]] The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * A method that returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * A method that returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * A method that returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * A method that returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * A method that returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    });
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    });
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    });
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    });
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose Lodash on the free variable `window` or `self` when available so it's
	  // globally accessible, even when bundled with Browserify, Webpack, etc. This
	  // also prevents errors in cases where Lodash is loaded by a script tag in the
	  // presence of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch
	  // for more details. Use `_.noConflict` to remove Lodash from the global object.
	  (freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(569)(module), (function() { return this; }())))

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FWA_ADMIN = exports.ROLE_JUDGE_TCEA = exports.ROLE_JUDGE_FOTY = exports.ROLE_JUDGE_FOTM = exports.ROLE_JUDGE_FOTD = exports.ROLE_JUDGE = exports.ROLE_ADMIN = exports.ROLE_MEMBER = exports.ROLE_ACCOUNT = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.redirectToPathIf = redirectToPathIf;
	exports.redirectToAccountIfNoProfile = redirectToAccountIfNoProfile;
	
	var _reduxRouter = __webpack_require__(74);
	
	var _routes = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ROLE_ACCOUNT = exports.ROLE_ACCOUNT = 'ACCOUNT'; //simple account role
	var ROLE_MEMBER = exports.ROLE_MEMBER = 'MEMBER';
	var ROLE_ADMIN = exports.ROLE_ADMIN = 'ADMIN';
	var ROLE_JUDGE = exports.ROLE_JUDGE = 'JUDGE';
	var ROLE_JUDGE_FOTD = exports.ROLE_JUDGE_FOTD = 'JUDGE_FOTD';
	var ROLE_JUDGE_FOTM = exports.ROLE_JUDGE_FOTM = 'JUDGE_FOTM';
	var ROLE_JUDGE_FOTY = exports.ROLE_JUDGE_FOTY = 'JUDGE_FOTY';
	var ROLE_JUDGE_TCEA = exports.ROLE_JUDGE_TCEA = 'JUDGE_TCEA';
	var FWA_ADMIN = exports.FWA_ADMIN = 'FWA_ADMIN';
	
	function getProperty(user, property) {
		var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
		if (user && user.hasOwnProperty(property)) {
			return user[property];
		} else {
			return defaultValue;
		}
	}
	
	var _user = {};
	
	var Auth = function () {
		function Auth(userObj) {
			_classCallCheck(this, Auth);
	
			this.setIdentity(userObj);
		}
	
		_createClass(Auth, [{
			key: 'canHas',
			value: function canHas() {
				var rolesToCheck = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
				if (typeof rolesToCheck === 'string') {
					rolesToCheck = [rolesToCheck];
				}
	
				for (var i = 0; i < rolesToCheck.length; i++) {
					for (var k = 0; k < this.roles.length; k++) {
						if (this.roles[k] === rolesToCheck[i]) {
							return true;
						}
					}
				}
	
				return false;
			}
		}, {
			key: 'setIdentity',
			value: function setIdentity(userObj) {
				_user = userObj;
	
				this._id = userObj.id;
				this._name = userObj.name;
				this._message = userObj.message || '';
	
				return this;
			}
		}, {
			key: 'isLoggedIn',
			value: function isLoggedIn() {
				return !!getProperty(_user, 'id', false);
			}
		}, {
			key: 'id',
			get: function get() {
				return getProperty(_user, 'id', false);
			}
		}, {
			key: 'name',
			get: function get() {
				return getProperty(_user, 'name');
			}
		}, {
			key: 'email',
			get: function get() {
				return getProperty(_user, 'email');
			}
		}, {
			key: 'msg',
			get: function get() {
				return getProperty(_user, 'message');
			}
		}, {
			key: 'roles',
			get: function get() {
				return getProperty(_user, 'roles', []);
			}
		}, {
			key: 'profile',
			get: function get() {
				return getProperty(_user, 'profiles');
			}
		}, {
			key: 'editorials',
			get: function get() {
				return getProperty(_user, 'editorials');
			}
		}, {
			key: 'hasPassword',
			get: function get() {
				return getProperty(_user, 'hasPassword');
			}
		}, {
			key: 'receiveNewsletter',
			get: function get() {
				return getProperty(_user, 'receiveNewsletter');
			}
		}]);
	
		return Auth;
	}();
	
	exports.default = Auth;
	function redirectToPathIf(dispatch, pathname, condition) {
		var returnTo = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		if (!condition) {
			return false;
		}
	
		var query = {};
		if (returnTo && (typeof returnTo === 'undefined' ? 'undefined' : _typeof(returnTo)) === 'object') {
			query = returnTo;
		} else if (returnTo && typeof returnTo === 'string') {
			query.returnTo = returnTo;
		} else if (returnTo && (typeof returnTo === 'undefined' ? 'undefined' : _typeof(returnTo)) !== 'object') {
			query = { returnTo: window.location.pathname };
		}
	
		// console.log('URL: ', pathname, 'RETURN:', query.returnTo);
	
		dispatch((0, _reduxRouter.push)({
			pathname: pathname,
			query: query
		}));
	}
	
	function redirectToAccountIfNoProfile(dispatch, user) {
		if (user && !user.profile) {
			dispatch((0, _reduxRouter.push)({
				pathname: (0, _routes.accountRoute)('/settings'),
				query: { returnTo: window.location.pathname }
			}));
		} else if (user && !user.isLoggedIn()) {
			dispatch((0, _reduxRouter.push)({
				pathname: (0, _routes.accountRoute)('/login'),
				query: { returnTo: window.location.pathname }
			}));
		}
	}

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(80);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stringify = __webpack_require__(703);
	var Parse = __webpack_require__(702);
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1310);


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(127);
	var ReactDOMComponentFlags = __webpack_require__(542);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a native or
	 * native text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedNativeOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_nativeNode` on the rendered native/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var nativeInst = getRenderedNativeOrTextFromComponent(inst);
	  nativeInst._nativeNode = node;
	  node[internalInstanceKey] = nativeInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._nativeNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._nativeNode = null;
	  }
	}
	
	/**
	 * Populate `_nativeNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedNativeOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : invariant(false) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._nativeNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._nativeNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  if (inst._nativeNode) {
	    return inst._nativeNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._nativeNode) {
	    parents.push(inst);
	    !inst._nativeParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : invariant(false) : void 0;
	    inst = inst._nativeParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._nativeNode);
	  }
	
	  return inst._nativeNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @typechecks
	 * 
	 */
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentStateInlineStyle = __webpack_require__(922);
	
	var _require = __webpack_require__(24);
	
	var OrderedSet = _require.OrderedSet;
	
	var applyEntityToContentState = __webpack_require__(938);
	var getCharacterRemovalRange = __webpack_require__(959);
	var getContentStateFragment = __webpack_require__(198);
	var insertFragmentIntoContentState = __webpack_require__(964);
	var insertTextIntoContentState = __webpack_require__(965);
	var invariant = __webpack_require__(7);
	var removeEntitiesAtEdges = __webpack_require__(444);
	var removeRangeFromContentState = __webpack_require__(976);
	var setBlockTypeForContentState = __webpack_require__(977);
	var splitBlockInContentState = __webpack_require__(979);
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : undefined;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (rangeToRemove.getAnchorKey() === rangeToRemove.getFocusKey()) {
	      var key = rangeToRemove.getAnchorKey();
	      var startOffset = rangeToRemove.getStartOffset();
	      var endOffset = rangeToRemove.getEndOffset();
	      var block = contentState.getBlockForKey(key);
	
	      var startEntity = block.getEntityAt(startOffset);
	      var endEntity = block.getEntityAt(endOffset - 1);
	      if (startEntity && startEntity === endEntity) {
	        var adjustedRemovalRange = getCharacterRemovalRange(block, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, adjustedRemovalRange);
	      }
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
	    return removeRangeFromContentState(withoutEntities, rangeToRemove);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return setBlockTypeForContentState(contentState, selectionState, blockType);
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	//import { accountRoute } from '../../routes';
	
	// import Splitter from '../account/block/splitter';
	// import ContentBlock from '../account/block/content';
	// import SubmitBlock from '../account/block/submit';
	
	// import connect from '../../utils/connect';
	
	
	exports.formatErrors = formatErrors;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(35);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _form = __webpack_require__(1004);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formatErrors(errors) {
		var fieldsWithErrors = [];
	
		if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) === 'object' && Object.keys(errors).length) {
			var keys = Object.keys(errors);
	
			for (var i = 0; i < keys.length; i++) {
				var errorArr = _typeof(errors[keys[i]]) !== 'object' ? [errors[keys[i]]] : errors[keys[i]];
				if (keys[i] && errorArr) {
					fieldsWithErrors.push({
						name: keys[i],
						errors: errorArr
					});
				}
			}
		}
	
		return fieldsWithErrors;
	}
	
	var Form = function (_Component) {
		_inherits(Form, _Component);
	
		function Form(props) {
			_classCallCheck(this, Form);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Form).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				id: (0, _lodash.uniqueId)('id'),
				waiting: false,
				fieldsWithErrors: []
			};
			return _this;
		}
	
		_createClass(Form, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				var spanClass = 'push5 span9';
	
				if (this.props.smallAside) {
					spanClass = 'push3-desktop span9-desktop push0 span100p';
				}
	
				if (this.props.commentForm) {
					spanClass = 'push0 span100p';
				}
	
				if (this.props.newsletterForm) {
					spanClass = 'push0 span100p';
				}
	
				return _react2.default.createElement(
					'form',
					_extends({}, this.props, { noValidate: true, ref: 'form', onSubmit: this.submit.bind(this), id: this.state.id }),
					this.props.head,
					!this.props.disableErrors && !!this.state.fieldsWithErrors.length && _react2.default.createElement(
						'div',
						{ className: 'form-errors', ref: 'errors' },
						_react2.default.createElement(
							'div',
							{ className: spanClass },
							_react2.default.createElement(
								'ol',
								null,
								this.state.fieldsWithErrors.map(this.renderError.bind(this))
							)
						)
					),
					this.props.children
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(errObj, i) {
				if (!errObj.errors || !errObj.errors.length || typeof errObj.errors.map !== 'function') {
					return false;
				}
	
				var refs = this.props.getRefs();
				var curRef = refs[errObj.name];
				var label = ''; // errObj.name
	
				if (curRef && curRef.props) {
					label = curRef.props.label;
				}
	
				return errObj.errors.map(function (err, k) {
					return _react2.default.createElement(
						'li',
						{ key: k },
						_react2.default.createElement(
							'strong',
							null,
							label
						),
						' ',
						err
					);
				});
			}
		}, {
			key: 'submit',
			value: function submit(e) {
				var _this2 = this;
	
				e && e.preventDefault && e.preventDefault();
				var allowedMethods = ['post', 'get', 'delete', 'put'];
				var method = 'post';
	
				if ((0, _lodash.includes)(allowedMethods, this.props.method)) {
					method = this.props.method;
				}
	
				this.props.onSubmit(new Promise(function (resolve, reject) {
					if (!_this2.props.disableAjaxSubmit) {
						_axios2.default[method](_baseUrl2.default + _this2.props.action, _qs2.default.stringify(_this2.serialize())).then(function (response) {
							_this2.clearErrorState();
	
							if (response.data && response.data.message) {
								_this2.props.dispatch((0, _errors.dispatchMsg)(response.data));
							}
	
							resolve(response);
						}).catch(function (response) {
							_this2.setErrorState(response.data, response.status);
	
							if (response.data && response.data.message) {
								_this2.props.dispatch((0, _errors.dispatchError)(response.data));
							}
	
							reject(response);
						});
					} else {
						resolve(_this2.serialize());
					}
				}));
			}
		}, {
			key: 'clearErrorState',
			value: function clearErrorState() {
				this.mounted && this.setState(_extends({}, this.state, {
					fieldsWithErrors: []
				}));
			}
		}, {
			key: 'setErrorState',
			value: function setErrorState(data, status) {
				var fieldsWithErrors = formatErrors(data.errors);
	
				if (status === 500) {
					var msgs = ['Please try again in a few minutes.'];
	
					var msg = this.props.noFun ? '' : msgs[Math.floor(msgs.length * Math.random())];
	
					fieldsWithErrors.push({
						name: 'Oops!',
						errors: ['A server error occurred. ' + msg]
					});
	
					if (data.message) {
						fieldsWithErrors.push({
							name: 'Error',
							errors: [data.message]
						});
					}
				}
	
				if (status === 401) {
					fieldsWithErrors.push({
						name: 'Error',
						errors: 'Please login to continue'
					});
	
					if (data.message) {
						fieldsWithErrors.push({
							name: 'Error',
							errors: [data.message]
						});
					}
				}
	
				if (data.message && status !== 500 && status !== 401) {
					fieldsWithErrors = [{
						name: 'Error',
						errors: [data.message]
					}].concat(_toConsumableArray(fieldsWithErrors));
				}
	
				this.mounted && this.setState(_extends({}, this.state, {
					fieldsWithErrors: fieldsWithErrors
				}));
	
				if (this.refs.errors) {
					var element = _reactDom2.default.findDOMNode(this.refs.form);
					if (element && typeof element.getAttribute === 'function') {
						var scroller = new _sweetScroll2.default({ easing: 'easeOutBounce', offset: -60, duration: 1000 });
						scroller.to('#' + element.getAttribute('id'));
					}
				}
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.mounted && this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'serialize',
			value: function serialize() {
				var result = {};
				var inputRefs = this.props.getRefs();
	
				if (inputRefs) {
					var keys = Object.keys(inputRefs);
					for (var i = 0; i < keys.length; i++) {
						var input = inputRefs[keys[i]];
						if (input && typeof input.value === 'function' && input.props.name) {
							result[input.props.name] = input.value();
						} else if (input && input.value !== undefined && input.props.name) {
							result[input.props.name] = input.value;
						}
					}
				}
	
				// console.log(decodeURIComponent(qs.stringify(result)));
				return result;
			}
		}]);
	
		return Form;
	}(_react.Component);
	
	Form.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		method: _react.PropTypes.string,
		action: _react.PropTypes.string.isRequired,
		getRefs: _react.PropTypes.func.isRequired,
		disableErrors: _react.PropTypes.bool,
		disableAjaxSubmit: _react.PropTypes.bool,
		onSubmit: _react.PropTypes.func,
		head: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]).isRequired
	};
	Form.defaultProps = {
		method: 'post',
		action: '',
		head: false,
		disableErrors: false,
		disableAjaxSubmit: false,
		dispatch: function dispatch() {},
		getRefs: function getRefs() {},
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = Form;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var createDesc = __webpack_require__(114);
	module.exports = __webpack_require__(27) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(47);
	var has = __webpack_require__(53);
	var SRC = __webpack_require__(118)('src');
	var $toString = __webpack_require__(710);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(67).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(19);
	var defined = __webpack_require__(80);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(35);
	
	var _validate = __webpack_require__(76);
	
	var _checkbox = __webpack_require__(449);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputCheckbox = function (_Component) {
		_inherits(InputCheckbox, _Component);
	
		function InputCheckbox(props) {
			_classCallCheck(this, InputCheckbox);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputCheckbox).call(this));
	
			_this.valid = typeof props.error === 'undefined' ? true : !props.error;
			_this.value = props.value ? 1 : 0;
			_this.unique = (0, _lodash.uniqueId)();
	
			_this.state = {
				value: _this.value,
				valid: _this.valid
			};
			return _this;
		}
	
		_createClass(InputCheckbox, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.valid !== nextState.valid || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.props.value) {
					this.value = nextProps.value ? 1 : 0;
					this.setState(_extends({}, this.state, {
						value: nextProps.value ? 1 : 0
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var labelClassName = 'custom-checkbox';
				var inputClassName = 'custom-checkbox__input';
	
				if (this.props.className) {
					labelClassName += ' ' + this.props.className;
				}
	
				if (!this.state.valid || this.props.error) {
					inputClassName += ' custom-checkbox__input--error';
				}
	
				return _react2.default.createElement(
					'label',
					{ htmlFor: this.props.name + this.unique, className: labelClassName, onClick: function onClick(e) {
							return e.stopPropagation();
						} },
					_react2.default.createElement('input', {
						ref: 'input',
						type: 'checkbox',
						id: this.props.name + this.unique,
						name: this.props.name,
						onChange: function onChange(e) {
							return _this2.onChange(e);
						},
						className: inputClassName,
						checked: this.state.value
					}),
					_react2.default.createElement('div', { className: 'custom-checkbox__pseudo' }),
					this.props.children
				);
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				if (e && e.target) {
					this.value = e.target.checked ? 1 : 0;
				}
	
				if (!this.props.manualValidate && this.props.validate) {
					this.valid = (0, _validate.isValid)(this.value, this.props.validate, this.props.error);
				}
	
				this.setState(_extends({}, this.state, { value: this.value, valid: this.valid }));
	
				this.props.onChange(this.value, e);
			}
		}, {
			key: 'testValidity',
			value: function testValidity() {
				this.valid = (0, _validate.isValid)(this.value, this.props.validate, this.props.error);
				this.setState(_extends({}, this.state, { valid: this.valid }));
	
				return this.valid;
			}
		}]);
	
		return InputCheckbox;
	}(_react.Component);
	
	InputCheckbox.propTypes = {
		name: _react.PropTypes.string.isRequired,
		error: _react.PropTypes.bool,
		validate: _react.PropTypes.array,
		manualValidate: _react.PropTypes.bool,
		onChange: _react.PropTypes.func,
		value: _react.PropTypes.oneOf([0, 1, true, false])
	};
	InputCheckbox.defaultProps = {
		error: undefined,
		value: 0,
		onChange: function onChange() {}
	};
	exports.default = InputCheckbox;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(35);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _select = __webpack_require__(1010);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_Component) {
		_inherits(Select, _Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Select).call(this, props));
	
			_this.value = _this.props.value || '';
			_this.mounted = true;
	
			_this.state = {
				isActive: false,
				selected: false,
				value: _this.value,
				options: props.options,
				ajaxOptions: []
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.ajaxOptionsUrl === 'string' && this.props.ajaxOptionsUrl.length > 5) {
					this.getAjaxOptions(this.props.ajaxOptionsUrl, this.props);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'getAjaxOptions',
			value: function getAjaxOptions(path, props) {
				var _this2 = this;
	
				var retry = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
				_axios2.default.get(_baseUrl2.default + path).then(function (res) {
					if (res.data) {
						var filteredOptions = (0, _lodash.filter)(res.data, function (o) {
							return !!(o.label && o.value);
						});
						_this2.mounted && _this2.setState(_extends({}, _this2.state, {
							ajaxOptions: filteredOptions,
							options: _this2.combineOptions(props.options, filteredOptions)
						}));
					}
				}).catch(function () {
					if (retry <= 3) {
						_this2.getAjaxOptions(path, props, retry + 1);
					}
				});
			}
		}, {
			key: 'combineOptions',
			value: function combineOptions(opt1, opt2) {
				return [].concat(opt1).concat(opt2);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.props.value || nextProps.options !== this.props.options) {
					var newState = _extends({}, this.state, {
						options: this.combineOptions(nextProps.options, this.state.ajaxOptions)
					});
	
					for (var i = 0; i < this.state.length; i++) {
						if (this.state[i].value === nextProps.value) {
							newState = this.setValue(this.state[i].value, this.state[i].label, newState);
						}
					}
	
					this.setState(newState);
				}
			}
		}, {
			key: 'getLabel',
			value: function getLabel(opts, val) {
				if (opts && opts.length) {
					for (var i = 0; i < opts.length; i++) {
						if (opts[i].value === val) {
							return opts[i].label;
						}
					}
				}
	
				return val;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.value !== this.state.value) {
					this.onChange();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var className = 'select';
				var dropdownClass = 'select__options';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (this.state.isActive) {
					className += ' select--active';
					dropdownClass += ' ' + 'select__options--active';
				}
	
				if (this.props.dropdownClass) {
					dropdownClass += ' ' + this.props.dropdownClass;
				}
	
				if (this.props.error) {
					className += ' error';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					this.renderSelected(),
					this.state.isActive && _react2.default.createElement('div', { className: 'select--closer', onClick: function onClick() {
							return _this3.closeMenu();
						} }),
					_react2.default.createElement(
						'div',
						{
							className: dropdownClass,
							scrollbarVertical: function scrollbarVertical(props) {
								return _react2.default.createElement('div', _extends({}, props, { className: 'scrollbar-vertical' }));
							}
						},
						_react2.default.createElement(
							'div',
							{ className: 'mask' },
							this.state.options.map(this.renderOption.bind(this))
						)
					)
				);
			}
		}, {
			key: 'renderSelected',
			value: function renderSelected() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{
						className: 'select__activator',
						onClick: function onClick() {
							_this4.toggleDropdown();
						},
						onKeyDown: function onKeyDown(e) {
							if (e.keyCode === 27) {
								_this4.closeMenu();
							}
	
							if (e.keyCode === 13 || e.keyCode === 32) {
								_this4.toggleDropdown();
							}
						},
						tabIndex: '0' },
					this.getLabel(this.state.options, this.state.value) || this.props.placeholder
				);
			}
		}, {
			key: 'renderOption',
			value: function renderOption(opt, i) {
				var _this5 = this;
	
				var className = 'select__option';
				var ref = undefined;
				if (opt.disabled) {
					className += ' select__option--disabled';
				}
	
				if (opt.value === this.state.value) {
					className += ' select__option--selected';
					ref = 'selected';
				}
	
				return _react2.default.createElement(
					'div',
					{ key: i, ref: ref, className: className, onClick: function onClick() {
							!opt.disabled && _this5.selectOption(opt);
						} },
					opt.label
				);
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				this.setState(_extends({}, this.state, {
					isActive: false
				}));
			}
		}, {
			key: 'toggleDropdown',
			value: function toggleDropdown() {
				var newState = _extends({}, this.state, {
					isActive: !this.state.isActive
				});
	
				if (this.refs.selected) {
					var scrollToElement = _reactDom2.default.findDOMNode(this.refs.selected);
					if (scrollToElement && typeof scrollToElement.getAttribute === 'function') {
						var parent = scrollToElement.parentElement;
						parent.scrollTop = scrollToElement.offsetTop;
					}
				}
	
				this.setState(newState);
			}
		}, {
			key: 'selectOption',
			value: function selectOption(opt) {
				this.setState(this.setValue(opt.value, opt.label, {
					isActive: false
				}));
			}
		}, {
			key: 'onChange',
			value: function onChange() {
				if (typeof this.props.onChange === 'function') {
					return this.props.onChange(this.state.value);
				}
	
				return false;
			}
		}, {
			key: 'setValue',
			value: function setValue() {
				var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
				var label = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
				var addedState = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
				// console.log(value, label);
				var newState = _extends({}, this.state, addedState);
	
				if (newState.value !== value) {
					// console.log(value, label);
					newState.value = value === null ? null : value;
					newState.label = label && value ? label : '';
	
					this.value = value;
				}
	
				return newState;
			}
		}]);
	
		return Select;
	}(_react.Component);
	
	Select.propTypes = {
		options: _react.PropTypes.array,
		ajaxOptionsUrl: _react.PropTypes.string,
		placeholder: _react.PropTypes.string,
		className: _react.PropTypes.string,
		onChange: _react.PropTypes.func,
		value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	};
	Select.defaultProps = {
		options: [],
		ajaxOptionsUrl: '',
		placeholder: 'Select...',
		className: '',
		value: '',
		error: false,
		onChange: function onChange() {}
	};
	exports.default = Select;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pixeltext = __webpack_require__(1028);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pixeltext = function (_Component) {
		_inherits(Pixeltext, _Component);
	
		function Pixeltext(props) {
			_classCallCheck(this, Pixeltext);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Pixeltext).call(this, props));
		}
	
		_createClass(Pixeltext, [{
			key: 'render',
			value: function render() {
				var textStyles = {
					fill: 'url(#darkpixel)',
					dominantBaseline: 'text-before-edge',
					WebkitFontSmoothing: 'antialiased' };
	
				return _react2.default.createElement(
					'div',
					{ className: 'pixel-text ' + this.props.className },
					_react2.default.createElement(
						'span',
						{ className: 'pixel-text__text' },
						this.props.text
					)
				);
			}
		}]);
	
		return Pixeltext;
	}(_react.Component);
	
	Pixeltext.propTypes = {
		text: _react.PropTypes.string.isRequired
	};
	Pixeltext.defaultProps = {
		className: ''
	};
	exports.default = Pixeltext;

/***/ },
/* 53 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(153);
	var createDesc = __webpack_require__(114);
	var toIObject = __webpack_require__(56);
	var toPrimitive = __webpack_require__(82);
	var has = __webpack_require__(53);
	var IE8_DOM_DEFINE = __webpack_require__(392);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(53);
	var toObject = __webpack_require__(37);
	var IE_PROTO = __webpack_require__(260)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(152);
	var defined = __webpack_require__(80);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ },
/* 59 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 60 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.0.3'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(518)('wks')
	  , uid        = __webpack_require__(219)
	  , Symbol     = __webpack_require__(105).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * sweet-scroll
	 * Modern and the sweet smooth scroll library.
	 * @author tsuyoshiwada
	 * @license MIT
	 * @version 1.0.1
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.SweetScroll = factory());
	}(this, function () { 'use strict';
	
	  var cos = Math.cos;
	  var sin = Math.sin;
	  var pow = Math.pow;
	  var abs = Math.abs;
	  var sqrt = Math.sqrt;
	  var asin = Math.asin;
	  var PI = Math.PI;
	  var max = Math.max;
	  var min = Math.min;
	  var round = Math.round;
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	  };
	
	  var classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	
	  var createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  var MAX_ARRAY_INDEX = pow(2, 53) - 1;
	  var classTypeList = ["Boolean", "Number", "String", "Function", "Array", "Object"];
	  var classTypes = {};
	
	  classTypeList.forEach(function (name) {
	    classTypes["[object " + name + "]"] = name.toLowerCase();
	  });
	
	  function getType(obj) {
	    if (obj == null) {
	      return "";
	    }
	
	    return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? classTypes[Object.prototype.toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	  }
	
	  function isNumber(obj) {
	    return getType(obj) === "number";
	  }
	
	  function isString(obj) {
	    return getType(obj) === "string";
	  }
	
	  function isFunction(obj) {
	    return getType(obj) === "function";
	  }
	
	  function isArray(obj) {
	    return Array.isArray(obj);
	  }
	
	  function isArrayLike(obj) {
	    var length = obj == null ? null : obj.length;
	
	    return isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
	  }
	
	  function isNumeric(obj) {
	    return !isArray(obj) && obj - parseFloat(obj) + 1 >= 0;
	  }
	
	  function isObject(obj) {
	    return !isArray(obj) && getType(obj) === "object";
	  }
	
	  function hasProp(obj, key) {
	    return obj && obj.hasOwnProperty(key);
	  }
	
	  function each(obj, iterate, context) {
	    if (obj == null) return obj;
	
	    var ctx = context || obj;
	
	    if (isObject(obj)) {
	      for (var key in obj) {
	        if (!hasProp(obj, key)) continue;
	        if (iterate.call(ctx, obj[key], key) === false) break;
	      }
	    } else if (isArrayLike(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	        if (iterate.call(ctx, obj[i], i) === false) break;
	      }
	    }
	
	    return obj;
	  }
	
	  function merge(obj) {
	    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      sources[_key - 1] = arguments[_key];
	    }
	
	    each(sources, function (source) {
	      each(source, function (value, key) {
	        obj[key] = value;
	      });
	    });
	
	    return obj;
	  }
	
	  function removeSpaces(str) {
	    return str.replace(/\s*/g, "") || "";
	  }
	
	  var win = window;
	  var doc = document;
	
	  function $(selector) {
	    var context = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (!selector) return;
	
	    return (context == null ? doc : context).querySelector(selector);
	  }
	
	  function $$(selector) {
	    var context = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (!selector) return;
	
	    return (context == null ? doc : context).querySelectorAll(selector);
	  }
	
	  function matches(el, selector) {
	    var results = (el.document || el.ownerDocument).querySelectorAll(selector);
	    var i = results.length;
	    while (--i >= 0 && results.item(i) !== el) {}
	
	    return i > -1;
	  }
	
	  var directionMethodMap = {
	    y: "scrollTop",
	    x: "scrollLeft"
	  };
	
	  var directionPropMap = {
	    y: "pageYOffset",
	    x: "pageXOffset"
	  };
	
	  function isRootContainer(el) {
	    return el === doc.documentElement || el === doc.body;
	  }
	
	  function getScrollable(selectors) {
	    var direction = arguments.length <= 1 || arguments[1] === undefined ? "y" : arguments[1];
	    var all = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	    var method = directionMethodMap[direction];
	    var elements = selectors instanceof Element ? [selectors] : $$(selectors);
	    var scrollables = [];
	    var $div = doc.createElement("div");
	
	    for (var i = 0; i < elements.length; i++) {
	      var el = elements[i];
	
	      if (el[method] > 0) {
	        scrollables.push(el);
	      } else {
	        $div.style.width = el.clientWidth + 1 + "px";
	        $div.style.height = el.clientHeight + 1 + "px";
	        el.appendChild($div);
	
	        el[method] = 1;
	        if (el[method] > 0) {
	          scrollables.push(el);
	        }
	        el[method] = 0;
	
	        el.removeChild($div);
	      }
	
	      if (!all && scrollables.length > 0) break;
	    }
	
	    return scrollables;
	  }
	
	  function scrollableFind(selectors, direction) {
	    var scrollables = getScrollable(selectors, direction, false);
	
	    return scrollables.length >= 1 ? scrollables[0] : null;
	  }
	
	  function getWindow(el) {
	    return el != null && el === el.window ? el : el.nodeType === 9 && el.defaultView;
	  }
	
	  function getHeight(el) {
	    return max(el.scrollHeight, el.clientHeight, el.offsetHeight);
	  }
	
	  function getWidth(el) {
	    return max(el.scrollWidth, el.clientWidth, el.offsetWidth);
	  }
	
	  function getSize(el) {
	    return {
	      width: getWidth(el),
	      height: getHeight(el)
	    };
	  }
	
	  function getDocumentSize() {
	    return {
	      width: max(getWidth(doc.body), getWidth(doc.documentElement)),
	      height: max(getHeight(doc.body), getHeight(doc.documentElement))
	    };
	  }
	
	  function getViewportAndElementSizes(el) {
	    if (isRootContainer(el)) {
	      return {
	        viewport: {
	          width: min(win.innerWidth, doc.documentElement.clientWidth),
	          height: win.innerHeight
	        },
	        size: getDocumentSize()
	      };
	    }
	
	    return {
	      viewport: {
	        width: el.clientWidth,
	        height: el.clientHeight
	      },
	      size: getSize(el)
	    };
	  }
	
	  function getScroll(el) {
	    var direction = arguments.length <= 1 || arguments[1] === undefined ? "y" : arguments[1];
	
	    var currentWindow = getWindow(el);
	
	    return currentWindow ? currentWindow[directionPropMap[direction]] : el[directionMethodMap[direction]];
	  }
	
	  function setScroll(el, offset) {
	    var direction = arguments.length <= 2 || arguments[2] === undefined ? "y" : arguments[2];
	
	    var currentWindow = getWindow(el);
	    var top = direction === "y";
	    if (currentWindow) {
	      currentWindow.scrollTo(!top ? offset : currentWindow[directionPropMap.x], top ? offset : currentWindow[directionPropMap.y]);
	    } else {
	      el[directionMethodMap[direction]] = offset;
	    }
	  }
	
	  function getOffset(el) {
	    var context = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    if (!el || el && !el.getClientRects().length) {
	      return { top: 0, left: 0 };
	    }
	
	    var rect = el.getBoundingClientRect();
	
	    if (rect.width || rect.height) {
	      var scroll = {};
	      var ctx = null;
	      if (context == null || isRootContainer(context)) {
	        ctx = el.ownerDocument.documentElement;
	        scroll.top = win.pageYOffset;
	        scroll.left = win.pageXOffset;
	      } else {
	        ctx = context;
	        var ctxRect = ctx.getBoundingClientRect();
	        scroll.top = ctxRect.top * -1 + ctx.scrollTop;
	        scroll.left = ctxRect.left * -1 + ctx.scrollLeft;
	      }
	
	      return {
	        top: rect.top + scroll.top - ctx.clientTop,
	        left: rect.left + scroll.left - ctx.clientLeft
	      };
	    }
	
	    return rect;
	  }
	
	  // @link https://github.com/Modernizr/Modernizr
	  var history = function () {
	    var ua = navigator.userAgent;
	    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) {
	      return false;
	    }
	
	    return window.history && "pushState" in window.history && window.location.protocol !== "file:";
	  }();
	
	  function addEvent(el, event, listener) {
	    var events = event.split(",");
	    events.forEach(function (eventName) {
	      el.addEventListener(eventName.trim(), listener, false);
	    });
	  }
	
	  function removeEvent(el, event, listener) {
	    var events = event.split(",");
	    events.forEach(function (eventName) {
	      el.removeEventListener(eventName.trim(), listener, false);
	    });
	  }
	
	  function linear(p) {
	    return p;
	  }
	
	  function InQuad(x, t, b, c, d) {
	    return c * (t /= d) * t + b;
	  }
	
	  function OutQuad(x, t, b, c, d) {
	    return -c * (t /= d) * (t - 2) + b;
	  }
	
	  function InOutQuad(x, t, b, c, d) {
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    }
	    return -c / 2 * (--t * (t - 2) - 1) + b;
	  }
	
	  function InCubic(x, t, b, c, d) {
	    return c * (t /= d) * t * t + b;
	  }
	
	  function OutCubic(x, t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  }
	
	  function InOutCubic(x, t, b, c, d) {
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t + 2) + b;
	  }
	
	  function InQuart(x, t, b, c, d) {
	    return c * (t /= d) * t * t * t + b;
	  }
	
	  function OutQuart(x, t, b, c, d) {
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  }
	
	  function InOutQuart(x, t, b, c, d) {
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    }
	    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	  }
	
	  function InQuint(x, t, b, c, d) {
	    return c * (t /= d) * t * t * t * t + b;
	  }
	
	  function OutQuint(x, t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  }
	
	  function InOutQuint(x, t, b, c, d) {
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	  }
	
	  function InSine(x, t, b, c, d) {
	    return -c * cos(t / d * (PI / 2)) + c + b;
	  }
	
	  function OutSine(x, t, b, c, d) {
	    return c * sin(t / d * (PI / 2)) + b;
	  }
	
	  function InOutSine(x, t, b, c, d) {
	    return -c / 2 * (cos(PI * t / d) - 1) + b;
	  }
	
	  function InExpo(x, t, b, c, d) {
	    return t === 0 ? b : c * pow(2, 10 * (t / d - 1)) + b;
	  }
	
	  function OutExpo(x, t, b, c, d) {
	    return t === d ? b + c : c * (-pow(2, -10 * t / d) + 1) + b;
	  }
	
	  function InOutExpo(x, t, b, c, d) {
	    if (t === 0) return b;
	    if (t === d) return b + c;
	    if ((t /= d / 2) < 1) return c / 2 * pow(2, 10 * (t - 1)) + b;
	    return c / 2 * (-pow(2, -10 * --t) + 2) + b;
	  }
	
	  function InCirc(x, t, b, c, d) {
	    return -c * (sqrt(1 - (t /= d) * t) - 1) + b;
	  }
	
	  function OutCirc(x, t, b, c, d) {
	    return c * sqrt(1 - (t = t / d - 1) * t) + b;
	  }
	
	  function InOutCirc(x, t, b, c, d) {
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (sqrt(1 - t * t) - 1) + b;
	    }
	    return c / 2 * (sqrt(1 - (t -= 2) * t) + 1) + b;
	  }
	
	  function InElastic(x, t, b, c, d) {
	    var s = 1.70158;
	    var p = 0;
	    var a = c;
	    if (t === 0) return b;
	    if ((t /= d) === 1) return b + c;
	    if (!p) p = d * .3;
	    if (a < abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * PI) * asin(c / a);
	    }
	    return -(a * pow(2, 10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p)) + b;
	  }
	
	  function OutElastic(x, t, b, c, d) {
	    var s = 1.70158;
	    var p = 0;
	    var a = c;
	    if (t === 0) return b;
	    if ((t /= d) === 1) return b + c;
	    if (!p) p = d * .3;
	    if (a < abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * PI) * asin(c / a);
	    }
	    return a * pow(2, -10 * t) * sin((t * d - s) * (2 * PI) / p) + c + b;
	  }
	
	  function InOutElastic(x, t, b, c, d) {
	    var s = 1.70158;
	    var p = 0;
	    var a = c;
	    if (t === 0) return b;
	    if ((t /= d / 2) === 2) return b + c;
	    if (!p) p = d * (.3 * 1.5);
	    if (a < abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * PI) * asin(c / a);
	    }
	    if (t < 1) {
	      return -.5 * (a * pow(2, 10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p)) + b;
	    }
	    return a * pow(2, -10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p) * .5 + c + b;
	  }
	
	  function InBack(x, t, b, c, d) {
	    var s = arguments.length <= 5 || arguments[5] === undefined ? 1.70158 : arguments[5];
	
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  }
	
	  function OutBack(x, t, b, c, d) {
	    var s = arguments.length <= 5 || arguments[5] === undefined ? 1.70158 : arguments[5];
	
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  }
	
	  function InOutBack(x, t, b, c, d) {
	    var s = arguments.length <= 5 || arguments[5] === undefined ? 1.70158 : arguments[5];
	
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    }
	    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	  }
	
	  function OutBounce(x, t, b, c, d) {
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
	    }
	  }
	
	  function InBounce(x, t, b, c, d) {
	    return c - OutBounce(x, d - t, 0, c, d) + b;
	  }
	
	  function InOutBounce(x, t, b, c, d) {
	    if (t < d / 2) {
	      return InBounce(x, t * 2, 0, c, d) * .5 + b;
	    }
	    return OutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
	  }
	
	var Easing = Object.freeze({
	    linear: linear,
	    InQuad: InQuad,
	    OutQuad: OutQuad,
	    InOutQuad: InOutQuad,
	    InCubic: InCubic,
	    OutCubic: OutCubic,
	    InOutCubic: InOutCubic,
	    InQuart: InQuart,
	    OutQuart: OutQuart,
	    InOutQuart: InOutQuart,
	    InQuint: InQuint,
	    OutQuint: OutQuint,
	    InOutQuint: InOutQuint,
	    InSine: InSine,
	    OutSine: OutSine,
	    InOutSine: InOutSine,
	    InExpo: InExpo,
	    OutExpo: OutExpo,
	    InOutExpo: InOutExpo,
	    InCirc: InCirc,
	    OutCirc: OutCirc,
	    InOutCirc: InOutCirc,
	    InElastic: InElastic,
	    OutElastic: OutElastic,
	    InOutElastic: InOutElastic,
	    InBack: InBack,
	    OutBack: OutBack,
	    InOutBack: InOutBack,
	    OutBounce: OutBounce,
	    InBounce: InBounce,
	    InOutBounce: InOutBounce
	  });
	
	  var vendors = ["ms", "moz", "webkit"];
	  var lastTime = 0;
	
	  var raf = win.requestAnimationFrame;
	  var caf = win.cancelAnimationFrame;
	
	  for (var x = 0; x < vendors.length && !raf; ++x) {
	    raf = win[vendors[x] + "RequestAnimationFrame"];
	    caf = win[vendors[x] + "CancelAnimationFrame"] || win[vendors[x] + "CancelRequestAnimationFrame"];
	  }
	
	  if (!raf) {
	    raf = function raf(callback) {
	      var currentTime = Date.now();
	      var timeToCall = max(0, 16 - (currentTime - lastTime));
	      var id = setTimeout(function () {
	        callback(currentTime + timeToCall);
	      }, timeToCall);
	
	      lastTime = currentTime + timeToCall;
	
	      return id;
	    };
	  }
	
	  if (!caf) {
	    caf = function caf(id) {
	      clearTimeout(id);
	    };
	  }
	
	  var ScrollTween = function () {
	    function ScrollTween(el) {
	      classCallCheck(this, ScrollTween);
	
	      this.el = el;
	      this.props = {};
	      this.options = {};
	      this.progress = false;
	      this.easing = null;
	      this.startTime = null;
	      this.rafId = null;
	    }
	
	    createClass(ScrollTween, [{
	      key: "run",
	      value: function run(x, y, options) {
	        var _this = this;
	
	        if (this.progress) return;
	        this.props = { x: x, y: y };
	        this.options = options;
	        this.easing = isFunction(options.easing) ? options.easing : Easing[options.easing.replace("ease", "")];
	        this.progress = true;
	
	        setTimeout(function () {
	          _this.startProps = {
	            x: getScroll(_this.el, "x"),
	            y: getScroll(_this.el, "y")
	          };
	          _this.rafId = raf(function (time) {
	            return _this._loop(time);
	          });
	        }, this.options.delay);
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        var gotoEnd = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	        var complete = this.options.complete;
	
	        this.startTime = null;
	        this.progress = false;
	        caf(this.rafId);
	
	        if (gotoEnd) {
	          setScroll(this.el, this.props.x, "x");
	          setScroll(this.el, this.props.y, "y");
	        }
	
	        if (isFunction(complete)) {
	          complete.call(this);
	          this.options.complete = null;
	        }
	      }
	    }, {
	      key: "_loop",
	      value: function _loop(time) {
	        var _this2 = this;
	
	        if (!this.startTime) {
	          this.startTime = time;
	        }
	
	        if (!this.progress) {
	          this.stop(false);
	
	          return;
	        }
	
	        var el = this.el;
	        var props = this.props;
	        var options = this.options;
	        var startTime = this.startTime;
	        var startProps = this.startProps;
	        var easing = this.easing;
	        var duration = options.duration;
	        var step = options.step;
	
	        var toProps = {};
	        var timeElapsed = time - startTime;
	        var t = min(1, max(timeElapsed / duration, 0));
	
	        each(props, function (value, key) {
	          var initialValue = startProps[key];
	          var delta = value - initialValue;
	          if (delta === 0) return true;
	
	          var val = easing(t, duration * t, 0, 1, duration);
	          toProps[key] = round(initialValue + delta * val);
	        });
	
	        each(toProps, function (value, key) {
	          setScroll(el, value, key);
	        });
	
	        if (timeElapsed <= duration) {
	          step.call(this, t, toProps);
	          this.rafId = raf(function (currentTime) {
	            return _this2._loop(currentTime);
	          });
	        } else {
	          this.stop(true);
	        }
	      }
	    }]);
	    return ScrollTween;
	  }();
	
	  var WHEEL_EVENT = function () {
	    if ("onwheel" in doc) {
	      return "wheel";
	    } else if ("onmousewheel" in doc) {
	      return "mousewheel";
	    } else {
	      return "DOMMouseScroll";
	    }
	  }();
	
	  var CONTAINER_STOP_EVENTS = WHEEL_EVENT + ", touchstart, touchmove";
	  var DOM_CONTENT_LOADED = "DOMContentLoaded";
	  var isDomContentLoaded = false;
	
	  addEvent(doc, DOM_CONTENT_LOADED, function () {
	    isDomContentLoaded = true;
	  });
	
	  var SweetScroll = function () {
	
	    /* eslint-enable max-len */
	
	    /**
	     * SweetScroll constructor
	     * @constructor
	     * @param {Object} options
	     * @param {String | Element} container
	     */
	
	    function SweetScroll() {
	      var _this = this;
	
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var container = arguments.length <= 1 || arguments[1] === undefined ? "body, html" : arguments[1];
	      classCallCheck(this, SweetScroll);
	
	      var params = merge({}, SweetScroll.defaults, options);
	
	      this.options = params;
	      this.getContainer(container, function (target) {
	        _this.container = target;
	        _this.header = $(params.header);
	        _this.tween = new ScrollTween(target);
	        _this._trigger = null;
	        _this._shouldCallCancelScroll = false;
	        _this.bindContainerClick();
	        _this.hook(params, "initialized");
	      });
	    }
	
	    /**
	     * Scroll animation to the specified position
	     * @param {*} distance
	     * @param {Object} options
	     * @return {void}
	     */
	
	
	    // Default options
	    /* eslint-disable max-len */
	
	
	    createClass(SweetScroll, [{
	      key: "to",
	      value: function to(distance) {
	        var _this2 = this;
	
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	        var container = this.container;
	        var header = this.header;
	
	        var params = merge({}, this.options, options);
	
	        // Temporary options
	        this._options = params;
	
	        var offset = this.parseCoodinate(params.offset);
	        var trigger = this._trigger;
	        var scroll = this.parseCoodinate(distance);
	        var hash = null;
	
	        // Remove the triggering elements which has been temporarily retained
	        this._trigger = null;
	
	        // Disable the call flag of `cancelScroll`
	        this._shouldCallCancelScroll = false;
	
	        // Stop current animation
	        this.stop();
	
	        // Does not move if the container is not found
	        if (!container) return;
	
	        // Using the coordinates in the case of CSS Selector
	        if (!scroll && isString(distance)) {
	          hash = /^#/.test(distance) ? distance : null;
	
	          if (distance === "#") {
	            scroll = {
	              top: 0,
	              left: 0
	            };
	          } else {
	            var target = $(distance);
	            var targetOffset = getOffset(target, container);
	            if (!targetOffset) return;
	            scroll = targetOffset;
	          }
	        }
	
	        if (!scroll) return;
	
	        // Apply `offset` value
	        if (offset) {
	          scroll.top += offset.top;
	          scroll.left += offset.left;
	        }
	
	        // If the header is present apply the height
	        if (header) {
	          scroll.top = max(0, scroll.top - getSize(header).height);
	        }
	
	        // Determine the final scroll coordinates
	
	        var _Dom$getViewportAndEl = getViewportAndElementSizes(container);
	
	        var viewport = _Dom$getViewportAndEl.viewport;
	        var size = _Dom$getViewportAndEl.size;
	
	        // Call `beforeScroll`
	        // Stop scrolling when it returns false
	
	        if (this.hook(params, "beforeScroll", scroll, trigger) === false) {
	          return;
	        }
	
	        // Adjustment of the maximum value
	        scroll.top = params.verticalScroll ? max(0, min(size.height - viewport.height, scroll.top)) : getScroll(container, "y");
	        scroll.left = params.horizontalScroll ? max(0, min(size.width - viewport.width, scroll.left)) : getScroll(container, "x");
	
	        // Run the animation!!
	        this.tween.run(scroll.left, scroll.top, {
	          duration: params.duration,
	          delay: params.delay,
	          easing: params.easing,
	          complete: function complete() {
	            // Update URL
	            if (hash != null && hash !== window.location.hash) {
	              _this2.updateURLHash(hash, params.updateURL);
	            }
	
	            // Unbind the scroll stop events, And call `afterScroll` or `cancelScroll`
	            _this2.unbindContainerStop();
	
	            // Remove the temporary options
	            _this2._options = null;
	
	            // Call `cancelScroll` or `afterScroll`
	            if (_this2._shouldCallCancelScroll) {
	              _this2.hook(params, "cancelScroll");
	            } else {
	              _this2.hook(params, "afterScroll", scroll, trigger);
	            }
	
	            // Call `completeScroll`
	            _this2.hook(params, "completeScroll", _this2._shouldCallCancelScroll);
	          },
	          step: function step(currentTime, props) {
	            _this2.hook(params, "stepScroll", currentTime, props);
	          }
	        });
	
	        // Bind the scroll stop events
	        this.bindContainerStop();
	      }
	
	      /**
	       * Scroll animation to the specified top position
	       * @param {*} distance
	       * @param {Object} options
	       * @return {void}
	       */
	
	    }, {
	      key: "toTop",
	      value: function toTop(distance) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        this.to(distance, merge({}, options, {
	          verticalScroll: true,
	          horizontalScroll: false
	        }));
	      }
	
	      /**
	       * Scroll animation to the specified left position
	       * @param {*} distance
	       * @param {Object} options
	       * @return {void}
	       */
	
	    }, {
	      key: "toLeft",
	      value: function toLeft(distance) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        this.to(distance, merge({}, options, {
	          verticalScroll: false,
	          horizontalScroll: true
	        }));
	      }
	
	      /**
	       * Scroll animation to the specified element
	       * @param {Element} el
	       * @param {Object} options
	       * @return {void}
	       */
	
	    }, {
	      key: "toElement",
	      value: function toElement(el) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        if (el instanceof Element) {
	          var offset = getOffset(el, this.container);
	          this.to(offset, merge({}, options));
	        }
	      }
	
	      /**
	       * Stop the current animation
	       * @param {Boolean} gotoEnd
	       * @return {void}
	       */
	
	    }, {
	      key: "stop",
	      value: function stop() {
	        var gotoEnd = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	        if (this._stopScrollListener) {
	          this._shouldCallCancelScroll = true;
	        }
	        this.tween.stop(gotoEnd);
	      }
	
	      /**
	       * Update the instance
	       * @param {Object} options
	       * @return {void}
	       */
	
	    }, {
	      key: "update",
	      value: function update() {
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        this.stop();
	        this.unbindContainerClick();
	        this.unbindContainerStop();
	        this.options = merge({}, this.options, options);
	        this.header = $(this.options.header);
	        this.bindContainerClick();
	      }
	
	      /**
	       * Destroy SweetScroll instance
	       * @return {void}
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        this.stop();
	        this.unbindContainerClick();
	        this.unbindContainerStop();
	        this.container = null;
	        this.header = null;
	        this.tween = null;
	      }
	
	      /**
	       * Called at after of the initialize.
	       * @return {void}
	       */
	
	    }, {
	      key: "initialized",
	      value: function initialized() {}
	
	      /**
	       * Called at before of the scroll.
	       * @param {Object} toScroll
	       * @param {Element} trigger
	       * @return {Boolean}
	       */
	      /* eslint-disable no-unused-vars */
	
	    }, {
	      key: "beforeScroll",
	      value: function beforeScroll(toScroll, trigger) {
	        return true;
	      }
	
	      /* eslint-enable no-unused-vars */
	
	      /**
	       * Called at cancel of the scroll.
	       * @return {void}
	       */
	
	    }, {
	      key: "cancelScroll",
	      value: function cancelScroll() {}
	
	      /**
	       * Called at after of the scroll.
	       * @param {Object} toScroll
	       * @param {Element} trigger
	       * @return {void}
	       */
	      /* eslint-disable no-unused-vars */
	
	    }, {
	      key: "afterScroll",
	      value: function afterScroll(toScroll, trigger) {}
	
	      /* eslint-enable no-unused-vars */
	
	      /**
	       * Called at complete of the scroll.
	       * @param {Boolean} isCancel
	       * @return {void}
	       */
	      /* eslint-disable no-unused-vars */
	
	    }, {
	      key: "completeScroll",
	      value: function completeScroll(isCancel) {}
	
	      /* eslint-enable no-unused-vars */
	
	      /**
	       * Called at each animation frame of the scroll.
	       * @param {Float} currentTime
	       * @param {Object} props
	       * @return {void}
	       */
	      /* eslint-disable no-unused-vars */
	
	    }, {
	      key: "stepScroll",
	      value: function stepScroll(currentTime, props) {}
	
	      /* eslint-enable no-unused-vars */
	
	      /**
	       * Parse the value of coordinate
	       * @param {*} coodinate
	       * @return {Object}
	       */
	
	    }, {
	      key: "parseCoodinate",
	      value: function parseCoodinate(coodinate) {
	        var enableTop = this._options ? this._options.verticalScroll : this.options.verticalScroll;
	        var scroll = { top: 0, left: 0 };
	
	        // Object
	        if (hasProp(coodinate, "top") || hasProp(coodinate, "left")) {
	          scroll = merge(scroll, coodinate);
	
	          // Array
	        } else if (isArray(coodinate)) {
	            if (coodinate.length === 2) {
	              scroll.top = coodinate[0];
	              scroll.left = coodinate[1];
	            } else {
	              scroll.top = enableTop ? coodinate[0] : 0;
	              scroll.left = !enableTop ? coodinate[0] : 0;
	            }
	
	            // Number
	          } else if (isNumeric(coodinate)) {
	              scroll.top = enableTop ? coodinate : 0;
	              scroll.left = !enableTop ? coodinate : 0;
	
	              // String
	            } else if (isString(coodinate)) {
	                var trimedCoodinate = removeSpaces(coodinate);
	
	                // "{n},{n}" (Array like syntax)
	                if (/^\d+,\d+$/.test(trimedCoodinate)) {
	                  trimedCoodinate = trimedCoodinate.split(",");
	                  scroll.top = trimedCoodinate[0];
	                  scroll.left = trimedCoodinate[1];
	
	                  // "top:{n}, left:{n}" (Object like syntax)
	                } else if (/^(top|left):\d+,?(?:(top|left):\d+)?$/.test(trimedCoodinate)) {
	                    var top = trimedCoodinate.match(/top:(\d+)/);
	                    var left = trimedCoodinate.match(/left:(\d+)/);
	                    scroll.top = top ? top[1] : 0;
	                    scroll.left = left ? left[1] : 0;
	
	                    // "+={n}", "-={n}" (Relative position)
	                  } else if (this.container && /^(\+|-)=(\d+)$/.test(trimedCoodinate)) {
	                      var current = getScroll(this.container, enableTop ? "y" : "x");
	                      var results = trimedCoodinate.match(/^(\+|-)=(\d+)$/);
	                      var op = results[1];
	                      var value = parseInt(results[2], 10);
	                      if (op === "+") {
	                        scroll.top = enableTop ? current + value : 0;
	                        scroll.left = !enableTop ? current + value : 0;
	                      } else {
	                        scroll.top = enableTop ? current - value : 0;
	                        scroll.left = !enableTop ? current - value : 0;
	                      }
	                    } else {
	                      return null;
	                    }
	              } else {
	                return null;
	              }
	
	        scroll.top = parseInt(scroll.top, 10);
	        scroll.left = parseInt(scroll.left, 10);
	
	        return scroll;
	      }
	
	      /**
	       * Update the Hash of the URL.
	       * @param {String} hash
	       * @param {Boolean | String} historyType
	       * @return {void}
	       */
	
	    }, {
	      key: "updateURLHash",
	      value: function updateURLHash(hash, historyType) {
	        if (!history || !historyType) return;
	        window.history[historyType === "replace" ? "replaceState" : "pushState"](null, null, hash);
	      }
	
	      /**
	       * Get the container for the scroll, depending on the options.
	       * @param {String | Element} selector
	       * @param {Function} callback
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "getContainer",
	      value: function getContainer(selector, callback) {
	        var _this3 = this;
	
	        var _options = this.options;
	        var verticalScroll = _options.verticalScroll;
	        var horizontalScroll = _options.horizontalScroll;
	
	        var container = null;
	
	        if (verticalScroll) {
	          container = scrollableFind(selector, "y");
	        }
	
	        if (!container && horizontalScroll) {
	          container = scrollableFind(selector, "x");
	        }
	
	        if (!container && !isDomContentLoaded) {
	          (function () {
	            var isCompleted = false;
	
	            addEvent(doc, DOM_CONTENT_LOADED, function () {
	              isCompleted = true;
	              _this3.getContainer(selector, callback);
	            });
	
	            // Fallback for DOMContentLoaded
	            addEvent(win, "load", function () {
	              if (!isCompleted) {
	                _this3.getContainer(selector, callback);
	              }
	            });
	          })();
	        } else {
	          callback.call(this, container);
	        }
	      }
	
	      /**
	       * Bind a click event to the container
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "bindContainerClick",
	      value: function bindContainerClick() {
	        var container = this.container;
	
	        if (!container) return;
	        this._containerClickListener = this.handleContainerClick.bind(this);
	        addEvent(container, "click", this._containerClickListener);
	      }
	
	      /**
	       * Unbind a click event to the container
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "unbindContainerClick",
	      value: function unbindContainerClick() {
	        var container = this.container;
	
	        if (!container || !this._containerClickListener) return;
	        removeEvent(container, "click", this._containerClickListener);
	        this._containerClickListener = null;
	      }
	
	      /**
	       * Bind the scroll stop of events
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "bindContainerStop",
	      value: function bindContainerStop() {
	        var container = this.container;
	
	        if (!container) return;
	        this._stopScrollListener = this.handleStopScroll.bind(this);
	        addEvent(container, CONTAINER_STOP_EVENTS, this._stopScrollListener);
	      }
	
	      /**
	       * Unbind the scroll stop of events
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "unbindContainerStop",
	      value: function unbindContainerStop() {
	        var container = this.container;
	
	        if (!container || !this._stopScrollListener) return;
	        removeEvent(container, CONTAINER_STOP_EVENTS, this._stopScrollListener);
	        this._stopScrollListener = null;
	      }
	
	      /**
	       * Call the specified callback
	       * @param {Object} options
	       * @param {String} type
	       * @param {...*} args
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "hook",
	      value: function hook(options, type) {
	        var callback = options[type];
	
	        // callback
	
	        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          args[_key - 2] = arguments[_key];
	        }
	
	        if (isFunction(callback)) {
	          var result = callback.apply(this, args);
	          if (typeof result === "undefined") return result;
	        }
	
	        // method
	        return this[type].apply(this, args);
	      }
	
	      /**
	       * Handling of scroll stop event
	       * @param {Event} e
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "handleStopScroll",
	      value: function handleStopScroll(e) {
	        var stopScroll = this._options ? this._options.stopScroll : this.options.stopScroll;
	        if (stopScroll) {
	          this.stop();
	        } else {
	          e.preventDefault();
	        }
	      }
	
	      /**
	       * Handling of container click event
	       * @param {Event} e
	       * @return {void}
	       * @private
	       */
	
	    }, {
	      key: "handleContainerClick",
	      value: function handleContainerClick(e) {
	        var options = this.options;
	
	        var el = e.target;
	
	        // Explore parent element until the trigger selector matches
	        for (; el && el !== doc; el = el.parentNode) {
	          if (!matches(el, options.trigger)) continue;
	          var data = el.getAttribute("data-scroll");
	          var dataOptions = this.parseDataOptions(el);
	          var href = data || el.getAttribute("href");
	
	          options = merge({}, options, dataOptions);
	
	          if (options.preventDefault) e.preventDefault();
	          if (options.stopPropagation) e.stopPropagation();
	
	          // Passes the trigger elements to callback
	          this._trigger = el;
	
	          if (options.horizontalScroll && options.verticalScroll) {
	            this.to(href, options);
	          } else if (options.verticalScroll) {
	            this.toTop(href, options);
	          } else if (options.horizontalScroll) {
	            this.toLeft(href, options);
	          }
	        }
	      }
	
	      /**
	       * Parse the data-scroll-options attribute
	       * @param {Element} el
	       * @return {Object}
	       * @private
	       */
	
	    }, {
	      key: "parseDataOptions",
	      value: function parseDataOptions(el) {
	        var options = el.getAttribute("data-scroll-options");
	
	        return options ? JSON.parse(options) : {};
	      }
	    }]);
	    return SweetScroll;
	  }();
	
	  // Export SweetScroll class
	
	
	  SweetScroll.defaults = {
	    trigger: "[data-scroll]", // Selector for trigger (must be a valid css selector)
	    header: "[data-scroll-header]", // Selector for fixed header (must be a valid css selector)
	    duration: 1000, // Specifies animation duration in integer
	    delay: 0, // Specifies timer for delaying the execution of the scroll in milliseconds
	    easing: "easeOutQuint", // Specifies the pattern of easing
	    offset: 0, // Specifies the value to offset the scroll position in pixels
	    verticalScroll: true, // Enable the vertical scroll
	    horizontalScroll: false, // Enable the horizontal scroll
	    stopScroll: true, // When fired wheel or touchstart events to stop scrolling
	    updateURL: false, // Update the URL hash on after scroll (true | false | "push" | "replace")
	    preventDefault: true, // Cancels the container element click event
	    stopPropagation: true, // Prevents further propagation of the container element click event in the bubbling phase
	
	    // Callbacks
	    initialized: null,
	    beforeScroll: null,
	    afterScroll: null,
	    cancelScroll: null,
	    completeScroll: null,
	    stepScroll: null
	  };
	
	  return SweetScroll;
	
	}));

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.login = login;
	exports.logout = logout;
	exports.requestRecovery = requestRecovery;
	exports.resetPassword = resetPassword;
	exports.getLogin = getLogin;
	exports.getLoginWithErrors = getLoginWithErrors;
	exports.updateLogin = updateLogin;
	exports.deleteLogin = deleteLogin;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _routes = __webpack_require__(4);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestData() {
		return { type: actionTypes.USERS_LOGIN_REQ };
	};
	
	function receiveData(type, json) {
		return {
			type: type,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.RECV_ERROR,
			payload: json
		};
	};
	
	function login(email, password) {
		var remember = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
		var success = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
		var fail = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
	
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.post(_baseUrl2.default + '/api/account/login', _qs2.default.stringify({
				email: email,
				password: password,
				remember: remember
			})).then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGIN, response.data));
				typeof success === 'function' && success();
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				typeof fail === 'function' && fail();
			});
		};
	};
	
	function logout() {
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.post(_baseUrl2.default + '/api/account/logout').then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGOUT, response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};
	
	function requestRecovery(email) {
		var done = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
		var fail = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.get(_baseUrl2.default + '/api/account/recover', {
				params: {
					email: email
				}
			}).then(function (response) {
				typeof done === 'function' && done();
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				typeof fail === 'function' && fail();
			});
		};
	};
	
	function resetPassword(token, password) {
		var done = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
		var fail = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.get(_baseUrl2.default + '/api/account/reset', {
				params: {
					hash: token,
					password: password
				}
			}).then(function (response) {
				typeof done === 'function' && done();
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				typeof fail === 'function' && fail();
			});
		};
	};
	
	function getLogin() {
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.get(_baseUrl2.default + '/api/account/current').then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
			}).catch(function (response) {});
		};
	};
	
	function getLoginWithErrors() {
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.get(_baseUrl2.default + '/api/account/current').then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};
	
	function updateLogin(params) {
		var success = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
		var fail = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.put(_baseUrl2.default + '/api/account/current', _qs2.default.stringify(params)).then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGIN_INIT, response.data));
				dispatch(receiveData(actionTypes.RECV_MSG, response.data));
				typeof success === 'function' && success();
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				typeof fail === 'function' && fail();
			});
		};
	};
	
	function deleteLogin() {
		var success = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
		var fail = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		return function (dispatch) {
			//dispatch(requestData());
			return _axios2.default.delete(_baseUrl2.default + '/api/account/current').then(function (response) {
				dispatch(receiveData(actionTypes.USERS_LOGOUT, response.data));
				typeof success === 'function' && success();
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				typeof fail === 'function' && fail();
			});
		};
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _label = __webpack_require__(1007);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../utils/translate';
	
	
	var Label = function (_Component) {
		_inherits(Label, _Component);
	
		function Label(props) {
			_classCallCheck(this, Label);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Label).call(this));
		}
	
		_createClass(Label, [{
			key: 'render',
			value: function render() {
				var className = 'custom-label';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (this.props.hideLabel) {
					className += ' custom-label--hide';
				}
	
				return _react2.default.createElement(
					'label',
					{ className: className },
					!this.props.hideLabel && (this.props.label || this.props.btw) ? _react2.default.createElement(
						'span',
						{ className: 'custom-label__label' },
						this.props.label,
						this.props.btw ? _react2.default.createElement(
							'span',
							{ className: 'custom-label__label__btw' },
							this.props.btw
						) : false
					) : false,
					this.props.children,
					this.props.helpText && _react2.default.createElement('span', { className: 'custom-label__helptext', dangerouslySetInnerHTML: { __html: this.props.helpText } })
				);
			}
		}]);
	
		return Label;
	}(_react.Component);
	
	Label.propTypes = {
		label: _react2.default.PropTypes.string.isRequired,
		hideLabel: _react2.default.PropTypes.bool,
		btw: _react2.default.PropTypes.any,
		name: _react2.default.PropTypes.string
	};
	Label.defaultProps = {
		hideLabel: false,
		label: '',
		btw: '',
		name: ''
	};
	exports.default = Label;

/***/ },
/* 66 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 67 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(42);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(19);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 70 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(24);
	
	var Map = _require.Map;
	var OrderedSet = _require.OrderedSet;
	var Record = _require.Record;
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = (function (_CharacterMetadataRecord) {
	  _inherits(CharacterMetadata, _CharacterMetadataRecord);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    _get(Object.getPrototypeOf(CharacterMetadata.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CharacterMetadata, [{
	    key: 'getStyle',
	    value: function getStyle() {
	      return this.get('style');
	    }
	  }, {
	    key: 'getEntity',
	    value: function getEntity() {
	      return this.get('entity');
	    }
	  }, {
	    key: 'hasStyle',
	    value: function hasStyle(style) {
	      return this.getStyle().has(style);
	    }
	  }], [{
	    key: 'applyStyle',
	    value: function applyStyle(record, style) {
	      var withStyle = record.set('style', record.getStyle().add(style));
	      return CharacterMetadata.create(withStyle);
	    }
	  }, {
	    key: 'removeStyle',
	    value: function removeStyle(record, style) {
	      var withoutStyle = record.set('style', record.getStyle().remove(style));
	      return CharacterMetadata.create(withoutStyle);
	    }
	  }, {
	    key: 'applyEntity',
	    value: function applyEntity(record, entityKey) {
	      var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	      return CharacterMetadata.create(withEntity);
	    }
	
	    /**
	     * Use this function instead of the `CharacterMetadata` constructor.
	     * Since most content generally uses only a very small number of
	     * style/entity permutations, we can reuse these objects as often as
	     * possible.
	     */
	  }, {
	    key: 'create',
	    value: function create(config) {
	      if (!config) {
	        return EMPTY;
	      }
	
	      // Fill in unspecified properties, if necessary.
	      var configMap = Map({ style: EMPTY_SET, entity: null }).merge(config);
	
	      var existing = pool.get(configMap);
	      if (existing) {
	        return existing;
	      }
	
	      var newCharacter = new CharacterMetadata(configMap);
	      pool = pool.set(configMap, newCharacter);
	      return newCharacter;
	    }
	  }]);
	
	  return CharacterMetadata;
	})(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(107);
	
	var warning = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(333);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      ref = !config.hasOwnProperty('ref') || Object.getOwnPropertyDescriptor(config, 'ref').get ? null : config.ref;
	      key = !config.hasOwnProperty('key') || Object.getOwnPropertyDescriptor(config, 'key').get ? null : '' + config.key;
	    } else {
	      ref = config.ref === undefined ? null : config.ref;
	      key = config.key === undefined ? null : '' + config.key;
	    }
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    // Create dummy `key` and `ref` property to `props` to warn users
	    // against its use
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: function () {
	            if (!specialPropKeyWarningShown) {
	              specialPropKeyWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: function () {
	            if (!specialPropRefWarningShown) {
	              specialPropRefWarningShown = true;
	              process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', typeof type === 'function' && 'displayName' in type ? type.displayName : 'Element') : void 0;
	            }
	            return undefined;
	          },
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerStateReducer2 = __webpack_require__(1369);
	
	var _routerStateReducer3 = _interopRequireDefault(_routerStateReducer2);
	
	exports.routerStateReducer = _routerStateReducer3['default'];
	
	var _ReduxRouter2 = __webpack_require__(1362);
	
	var _ReduxRouter3 = _interopRequireDefault(_ReduxRouter2);
	
	exports.ReduxRouter = _ReduxRouter3['default'];
	
	var _client = __webpack_require__(1363);
	
	var _client2 = _interopRequireDefault(_client);
	
	exports.reduxReactRouter = _client2['default'];
	
	var _isActive2 = __webpack_require__(1365);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	exports.isActive = _isActive3['default'];
	
	var _actionCreators = __webpack_require__(344);
	
	exports.historyAPI = _actionCreators.historyAPI;
	exports.push = _actionCreators.push;
	exports.replace = _actionCreators.replace;
	exports.setState = _actionCreators.setState;
	exports.go = _actionCreators.go;
	exports.goBack = _actionCreators.goBack;
	exports.goForward = _actionCreators.goForward;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.formIsValid = formIsValid;
	exports.isValid = isValid;
	var VALIDATE_NOT_EMPTY = exports.VALIDATE_NOT_EMPTY = 'VALIDATE_NOT_EMPTY';
	var VALIDATE_MAX_LENGTH = exports.VALIDATE_MAX_LENGTH = 'VALIDATE_MAX_LENGTH';
	var VALIDATE_MIN_LENGTH = exports.VALIDATE_MIN_LENGTH = 'VALIDATE_MIN_LENGTH';
	var VALIDATE_EQUALS_FIELD = exports.VALIDATE_EQUALS_FIELD = 'VALIDATE_EQUALS_FIELD';
	var VALIDATE_EMAIL = exports.VALIDATE_EMAIL = 'VALIDATE_EMAIL';
	var VALIDATE_REGEX = exports.VALIDATE_REGEX = 'VALIDATE_REGEX';
	var VALIDATE_CHECKED = exports.VALIDATE_CHECKED = 'VALIDATE_CHECKED';
	var VALIDATE_UNCHECKED = exports.VALIDATE_UNCHECKED = 'VALIDATE_UNCHECKED';
	var VALIDATE_URL = exports.VALIDATE_URL = 'VALIDATE_URL';
	var VALIDATE_CUSTOM = exports.VALIDATE_CUSTOM = 'VALIDATE_CUSTOM';
	
	var validators = exports.validators = {
		VALIDATE_NOT_EMPTY: function VALIDATE_NOT_EMPTY(val) {
			return !!val.length;
		},
		VALIDATE_MAX_LENGTH: function VALIDATE_MAX_LENGTH(val, max) {
			return val.length <= max;
		},
		VALIDATE_MIN_LENGTH: function VALIDATE_MIN_LENGTH(val, min) {
			return val.length >= min;
		},
		VALIDATE_EQUALS_FIELD: function VALIDATE_EQUALS_FIELD(val, fieldFn) {
			if (typeof fieldFn === 'function' && fieldFn()) {
				var fldVal = fieldFn().value;
	
				if (typeof fldVal === 'function') {
					fldVal = fieldFn().value();
				}
	
				return val === fldVal;
			}
	
			return true;
		},
		VALIDATE_EQUALS: function VALIDATE_EQUALS(val, val2) {
			return val === val2;
		},
		VALIDATE_EMAIL: function VALIDATE_EMAIL(val) {
			return (/\S+@\S+/.test(val)
			);
		},
		VALIDATE_CHECKED: function VALIDATE_CHECKED(val) {
			return !!val;
		},
		VALIDATE_UNCHECKED: function VALIDATE_UNCHECKED(val) {
			return !val;
		},
		VALIDATE_CUSTOM: function VALIDATE_CUSTOM(val, func) {
			return func(val);
		},
		VALIDATE_REGEX: function VALIDATE_REGEX(val, regex) {
			if (regex.hasOwnProperty('test')) {
				return regex.test(val);
			}
	
			return true;
		},
	
		VALIDATE_URL: function VALIDATE_URL(val) {
			return !val.length || /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:ww‌​w.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?‌​(?:[\w]*))?)/.test(val);
		}
	
	};
	
	function formIsValid(fields) {
		var valid = true;
		for (var i = 0; i < fields.length; i++) {
			if (typeof fields[i].testValidity !== 'function') {
				console.log(fields[i]);
			}
			if (typeof fields[i].testValidity === 'function' && !fields[i].testValidity()) {
				valid = false;
			}
		}
	
		return valid;
	};
	
	function isValid(value, validatorsToRun) {
		var errorOverride = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
		var valid = true;
	
		if (!errorOverride && validatorsToRun && validatorsToRun.length) {
			valid = function (val) {
				// run though enabled validators from props
				for (var i = 0; i < validatorsToRun.length; i++) {
					// if the validator exists
					if (validators.hasOwnProperty(validatorsToRun[i].rule)) {
						// run the validator with its options -- if any validator fails return invalid/false
						var validate = validators[validatorsToRun[i].rule];
						if (typeof validate === 'function' && !validate(val, validatorsToRun[i].params)) {
							return false;
						}
					}
				}
	
				return true;
			}(value);
	
			return valid;
		} else {
			return !errorOverride;
		}
	}

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _share = __webpack_require__(1027);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Share = function (_Component) {
		_inherits(Share, _Component);
	
		function Share(props) {
			_classCallCheck(this, Share);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Share).call(this, props));
	
			_this.fb = new _fb2.default();
			return _this;
		}
	
		_createClass(Share, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fb.load();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'social-share' },
					_react2.default.createElement(
						'button',
						{ ref: 'share', className: 'social-share__button' },
						'Share +'
					),
					_react2.default.createElement(
						_dropdown2.default,
						{ key: 'dropdown', attachTo: function attachTo() {
								return _this2.refs.share;
							}, pointTo: 'BOTTOM_RIGHT', browser: this.props.browser },
						_react2.default.createElement(
							'ol',
							{ key: 'dropdown-ol' },
							_react2.default.createElement(
								'li',
								{ key: 'facebook' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick(event) {
											return _this2.faceShare(event);
										}, href: '#' },
									(0, _translate2.default)('socialshare/facebook')
								)
							),
							_react2.default.createElement(
								'li',
								{ key: 'twitter' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick(event) {
											return _this2.twitterClick(event);
										}, href: '#' },
									(0, _translate2.default)('socialshare/twitter')
								)
							),
							_react2.default.createElement(
								'li',
								{ key: 'google' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick(event) {
											return _this2.googleClick(event);
										}, href: '#' },
									(0, _translate2.default)('socialshare/gplus')
								)
							),
							_react2.default.createElement(
								'li',
								{ key: 'linkedin' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick(event) {
											return _this2.linkedinClick(event);
										}, href: '#' },
									(0, _translate2.default)('socialshare/linkedin')
								)
							),
							_react2.default.createElement(
								'li',
								{ key: 'email' },
								_react2.default.createElement(
									'a',
									{ href: 'mailto:?subject=The FWA - ' + this.props.title + '&body=' + this.props.url },
									(0, _translate2.default)('socialshare/email')
								)
							)
						)
					)
				);
			}
		}, {
			key: 'twitterShare',
			value: function twitterShare(url) {
				var winWidth = arguments.length <= 1 || arguments[1] === undefined ? 520 : arguments[1];
				var winHeight = arguments.length <= 2 || arguments[2] === undefined ? 350 : arguments[2];
	
				var winTop = screen.height / 2 - winHeight / 2;
				var winLeft = screen.width / 2 - winWidth / 2;
				window.open('https://twitter.com/intent/tweet?text=' + this.props.title + '&url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
			}
		}, {
			key: 'googleShare',
			value: function googleShare(url) {
				var winWidth = arguments.length <= 1 || arguments[1] === undefined ? 520 : arguments[1];
				var winHeight = arguments.length <= 2 || arguments[2] === undefined ? 350 : arguments[2];
	
				var winTop = screen.height / 2 - winHeight / 2;
				var winLeft = screen.width / 2 - winWidth / 2;
				window.open('https://plus.google.com/share?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
			}
		}, {
			key: 'linkedinShare',
			value: function linkedinShare(url) {
				var winWidth = arguments.length <= 1 || arguments[1] === undefined ? 520 : arguments[1];
				var winHeight = arguments.length <= 2 || arguments[2] === undefined ? 350 : arguments[2];
	
				var winTop = screen.height / 2 - winHeight / 2;
				var winLeft = screen.width / 2 - winWidth / 2;
				window.open('https://www.linkedin.com/cws/share?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
			}
		}, {
			key: 'faceShare',
			value: function faceShare(e) {
				e.preventDefault();
				this.fb.share(this.props.url);
			}
		}, {
			key: 'twitterClick',
			value: function twitterClick(e) {
				e.preventDefault();
				var url = this.props.url;
				var hashtag = (0, _translate2.default)('socialshare/hashtag');
				url += '&hashtags=' + hashtag;
				this.twitterShare(url);
			}
		}, {
			key: 'googleClick',
			value: function googleClick(e) {
				e.preventDefault();
				var url = this.props.url;
				this.googleShare(url);
			}
		}, {
			key: 'linkedinClick',
			value: function linkedinClick(e) {
				e.preventDefault();
				var url = this.props.url;
				this.linkedinShare(url);
			}
		}]);
	
		return Share;
	}(_react.Component);
	
	Share.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		title: _react.PropTypes.string.isRequired,
		url: _react.PropTypes.string.isRequired
	};
	Share.defaultProps = {
		url: window.location.toString()
	};
	exports.default = Share;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = formatCredits;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _index = __webpack_require__(4);
	
	var _pluralize = __webpack_require__(160);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatCredits() {
		var profiles = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
		var showPoint = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
		var linkProfiles = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
		var credits = [];
		var className = 'case-credit__name';
		var split = ' and ';
	
		if (!showPoint) {
			className += ' case-credit__name--faded';
		}
	
		if (profiles.length > 2) {
			split = ', ';
		}
	
		for (var i = 0; i < profiles.length; i++) {
			if (credits.length) {
				credits.push(_react2.default.createElement(
					'span',
					{ key: i + 's' },
					split
				));
			}
	
			if (profiles[i].name) {
				var LinkComp = _reactRouter.Link;
				var newProps = {
					key: i,
					className: className
				};
	
				if (linkProfiles && !profiles[i].isPoor && (profiles[i].total || !profiles[i].total && profiles[i].website)) {
					if (profiles[i].total) {
						newProps.to = (0, _index.profilesRoute)(profiles[i].slug);
					} else {
						LinkComp = 'a';
						newProps.href = profiles[i].website;
						newProps.target = '_blank';
					}
				} else {
					LinkComp = 'span';
					newProps.className += ' case-credit__name--nolink';
				}
	
				credits.push(_react2.default.createElement(LinkComp, newProps, [profiles[i].name, showPoint && _react2.default.createElement(
					'span',
					{ className: 'case-credit__count', key: 'count' },
					' ',
					profiles[i].total ? '(' + profiles[i].total + ' ' + (0, _pluralize2.default)('FWAs', profiles[i].total) + ')' : ''
				)]));
			}
		}
	
		return _react2.default.createElement(
			'span',
			{ className: 'case-credit' },
			credits
		);
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(68);
	var IObject = __webpack_require__(152);
	var toObject = __webpack_require__(37);
	var toLength = __webpack_require__(26);
	var asc = __webpack_require__(244);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 80 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(67);
	var fails = __webpack_require__(19);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(20);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = undefined;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(1057);
	var VersionRange = __webpack_require__(1058);
	
	var mapObject = __webpack_require__(463);
	var memoizeStringOnly = __webpack_require__(464);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var CallbackQueue = __webpack_require__(537);
	var PooledClass = __webpack_require__(128);
	var ReactFeatureFlags = __webpack_require__(546);
	var ReactPerf = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(146);
	var Transaction = __webpack_require__(332);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    return ArrayBuffer.isView(val);
	  } else {
	    return (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if a value is an Arguments object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Arguments object, otherwise false
	 */
	function isArguments(val) {
	  return toString.call(val) === '[object Arguments]';
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createelement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array or arguments callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Check if obj is array-like
	  var isArrayLike = isArray(obj) || isArguments(obj);
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArrayLike) {
	    obj = [obj];
	  }
	
	  // Iterate over array values
	  if (isArrayLike) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  }
	  // Iterate over object keys
	  else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/*obj1, obj2, obj3, ...*/) {
	  var result = {};
	  forEach(arguments, function (obj) {
	    forEach(obj, function (val, key) {
	      result[key] = val;
	    });
	  });
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// --------------------------------------------------------------------------------------------------------------------
	// Simple Carousel-component - inspired by Nuka-carousel
	// --------------------------------------------------------------------------------------------------------------------
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIRECTION_VERTICAL = exports.DIRECTION_HORIZONTAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultDecorator = __webpack_require__(363);
	
	var _defaultDecorator2 = _interopRequireDefault(_defaultDecorator);
	
	var _carousel = __webpack_require__(993);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIRECTION_HORIZONTAL = exports.DIRECTION_HORIZONTAL = 'DIRECTION_HORIZONTAL';
	var DIRECTION_VERTICAL = exports.DIRECTION_VERTICAL = 'DIRECTION_VERTICAL';
	
	var Carousel = function (_Component) {
		_inherits(Carousel, _Component);
	
		function Carousel(props) {
			_classCallCheck(this, Carousel);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(Carousel).call(this, props));
	
			_this2.mounted = true;
	
			var skipSlides = [];
			_react2.default.Children.map(props.children, function (child, index) {
				if (child.props.skipSlide) {
					skipSlides.push(index);
				}
			});
	
			_this2.state = {
				prevSlide: props.startingSlide,
				currentSlide: props.startingSlide,
				slideCount: 0,
				direction: _this2.props.direction,
				autoplay: _this2.props.autoplay,
				playVideo: false,
				skipSlides: skipSlides
			};
			return _this2;
		}
	
		_createClass(Carousel, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.setState(_extends({}, this.state, {
					slideCount: _react2.default.Children.count(this.props.children),
					slideClasses: _react2.default.Children.map(this.props.children, function (child) {
						var classes = '';
						if (child.props && typeof child.props.codaClass === 'string') {
							classes += ' ' + child.props.codaClass;
						}
	
						return classes;
					})
				}));
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return !!(nextProps.children !== this.props.children || nextProps.autoPlayVid !== this.props.autoPlayVid || nextState.playVideo !== this.state.playVideo || nextState.currentSlide !== this.state.currentSlide || this.props.autoplay);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var skipSlides = [];
				_react2.default.Children.map(nextProps.children, function (child, index) {
					if (child.props.skipSlide) {
						skipSlides.push(index);
					}
				});
	
				this.setState(_extends({}, this.state, {
					slideCount: _react2.default.Children.count(nextProps.children),
					currentSlide: this.state.currentSlide % (_react2.default.Children.count(nextProps.children) || 1),
					autoplay: nextProps.autoplay,
					skipSlides: skipSlides
				}));
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.playVideo && this.props.autoPlayVid) {
					this.props.autoPlayVid.playVideo();
					this.state.playVideo = false;
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				clearTimeout(this.timer);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _this = this;
				var children = this.formatChildren(this.props.children);
				var sliderClass = 'slider';
				var sliderListClass = 'slider-list';
				var decoClass = '';
	
				if (this.props.sliderClass) {
					sliderClass += ' ' + this.props.sliderClass;
				}
	
				if (this.props.sliderListClass) {
					sliderListClass += ' ' + this.props.sliderListClass;
				}
	
				if (this.props.decoClass) {
					decoClass += ' ' + this.props.decoClass;
				}
	
				if (this.props.autoplay && this.state.autoplay) {
					this.timer && clearTimeout(this.timer);
					this.timer = setTimeout(function () {
						_this3.nextSlide();
					}, this.props.timer);
				}
	
				if (!this.state.autoplay) {
					this.timer && clearTimeout(this.timer);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: sliderClass, 'data-slide': this.state.currentSlide },
					_react2.default.createElement(
						'ul',
						{ className: sliderListClass, onTouchStart: function onTouchStart(e) {
								return _this3.onTouchStart(e);
							}, onTouchMove: function onTouchMove(e) {
								return _this3.onTouchMove(e);
							}, onTouchEnd: function onTouchEnd(e) {
								return _this3.onTouchEnd(e);
							} },
						children
					),
					this.state.slideCount > 1 && this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
						var DecoComponent = Decorator.component;
						if (!DecoComponent) {
							return false;
						}
	
						return _react2.default.createElement(
							'div',
							{
								style: Decorator.style || {},
								className: 'slider-decorator-' + index + decoClass,
								key: index },
							_react2.default.createElement(DecoComponent, _extends({}, _this3.state, {
								decoratorData: _this3.props.decoratorData,
								nextSlide: function nextSlide() {
									_this3.nextSlide();
								},
								onVideoPlay: function onVideoPlay() {
									_this.setState(_extends({}, _this.state, { playVideo: true }));
								},
								hasVideo: _this.props.hasVideo,
								previousSlide: function previousSlide() {
									_this3.previousSlide();
								},
								goToSlide: function goToSlide(slideNumber) {
									var disableAutoplay = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
									_this3.goToSlide(slideNumber, disableAutoplay);
								} }))
						);
					}) : null
				);
			}
		}, {
			key: 'formatChildren',
			value: function formatChildren(children) {
				var _this = this;
				return _react2.default.Children.map(children, function (child, index) {
					var className = 'slider-slide';
					if (_this.state.currentSlide === index) {
						className += ' slider-slide--active';
					}
	
					if (_this.state.prevSlide === index) {
						className += ' slider-slide--prev';
					}
	
					return _react2.default.createElement(
						'li',
						{ className: className, style: {}, key: index },
						child
					);
				});
			}
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				var disableAutoplay = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
				var skip = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
				var nextSlide = (this.state.currentSlide + 1 + skip) % this.state.slideCount;
				// if (this.state.skipSlides.indexOf(nextSlide) !== -1) {
				// 	return this.nextSlide(disableAutoplay, skip + 1);
				// }
	
				return this.goToSlide(nextSlide, disableAutoplay);
			}
		}, {
			key: 'previousSlide',
			value: function previousSlide() {
				var disableAutoplay = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				this.goToSlide(this.state.currentSlide - 1, disableAutoplay);
			}
		}, {
			key: 'goToSlide',
			value: function goToSlide() {
				var _this4 = this;
	
				var slideNumber = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
				var disableAutoplay = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
				if (typeof slideNumber !== 'number') {
					return;
				}
	
				// Make sure currentSlide is within bounds
				slideNumber = Math.max(Math.min(slideNumber, this.state.slideCount - 1), 0);
	
				setTimeout(function () {
					_this4.mounted && _this4.setState(_extends({}, _this4.state, {
						autoplay: _this4.props.autoplay
					}));
				}, 10000);
	
				this.setState(_extends({}, this.state, {
					swiping: false,
					prevSlide: this.state.currentSlide,
					currentSlide: slideNumber,
					autoplay: !disableAutoplay
				}));
			}
		}, {
			key: 'calculatePos',
			value: function calculatePos(e) {
				var x = e.changedTouches[0].clientX;
				var y = e.changedTouches[0].clientY;
	
				var xd = this.state.x - x;
				var yd = this.state.y - y;
	
				var axd = Math.abs(xd);
				var ayd = Math.abs(yd);
	
				return {
					deltaX: xd,
					deltaY: yd,
					absX: axd,
					absY: ayd
				};
			}
		}, {
			key: 'onTouchStart',
			value: function onTouchStart(ev) {
				// console.log('onTouchStart: ', ev);
				if (ev.touches.length > 1) {
					return;
				}
	
				this.setState(_extends({}, this.state, {
					swipeStart: Date.now(),
					x: ev.touches[0].clientX,
					y: ev.touches[0].clientY,
					swiping: true
				}));
			}
		}, {
			key: 'onTouchMove',
			value: function onTouchMove(ev) {
				// console.log('onTouchMove: ', e);
			}
		}, {
			key: 'onTouchEnd',
			value: function onTouchEnd(ev) {
				// console.log('onTouchEnd: ');
				if (this.state.swiping) {
					var pos = this.calculatePos(ev);
	
					// var time = Date.now() - this.state.swipeStart;
					// var velocity = Math.sqrt(pos.absX * pos.absX + pos.absY * pos.absY) / time;
					// var isFlick = velocity > this.props.flickThreshold;
	
					// this.props.onSwiped && this.props.onSwiped(
					// 	ev,
					// 	pos.deltaX,
					// 	pos.deltaY,
					// 	isFlick,
					// );
	
					if (pos.absX > pos.absY) {
						if (this.state.direction === DIRECTION_HORIZONTAL) {
							if (pos.deltaX > 0) {
								// LEFT
								//console.log('swipe-NEXT');
								return this.nextSlide();
							} else {
								// RIGHT
								//console.log('swipe-PREV');
								return this.previousSlide();
							}
						}
					} else {
						if (this.state.direction === DIRECTION_VERTICAL) {
							if (pos.deltaY > 0) {
								// UP
								//console.log('swipe-NEXT');
								return this.nextSlide();
							} else {
								// DOWN
								//console.log('swipe-PREV');
								return this.previousSlide();
							}
						}
					}
				}
	
				this.setState(_extends({}, this.state, {
					swiping: false
				}));
			}
		}]);
	
		return Carousel;
	}(_react.Component);
	
	Carousel.propTypes = {};
	Carousel.defaultProps = {
		decorators: [_defaultDecorator2.default],
		decoratorData: {},
		timer: 4000,
		startingSlide: 0,
		direction: DIRECTION_HORIZONTAL,
		autoPlayVid: false
	};
	exports.default = Carousel;

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPE_NONE = exports.TYPE_NONE = false;
	var TYPE_CONTAINER = exports.TYPE_CONTAINER = 'container-list';
	var TYPE_EDITORIAL = exports.TYPE_EDITORIAL = 'editorials';
	var TYPE_EDITORIAL_LIST = exports.TYPE_EDITORIAL_LIST = 'editorials-list';
	var TYPE_INTERVIEW = exports.TYPE_INTERVIEW = 'interview';
	var TYPE_TIMELINE = exports.TYPE_TIMELINE = 'timeline';
	var TYPE_TEMPLATE = exports.TYPE_TEMPLATE = 'template';
	var TYPE_PROFILES = exports.TYPE_PROFILES = 'profiles';
	var TYPE_JOBS = exports.TYPE_JOBS = 'jobs';
	var TYPE_TEMPLATES = exports.TYPE_TEMPLATES = 'templates';
	//export const TYPE_CASES           = 'cases';
	
	var EDITORIAL_TYPE_QA = exports.EDITORIAL_TYPE_QA = 'QA';
	var EDITORIAL_TYPE_ARTICLE = exports.EDITORIAL_TYPE_ARTICLE = 'ARTICLE';
	
	var EDITORIAL_SIDEBAR_TYPE_IMAGE = exports.EDITORIAL_SIDEBAR_TYPE_IMAGE = 'IMAGE';
	var EDITORIAL_SIDEBAR_TYPE_YOUTUBE = exports.EDITORIAL_SIDEBAR_TYPE_YOUTUBE = 'YOUTUBE';
	var EDITORIAL_SIDEBAR_TYPE_VIMEO = exports.EDITORIAL_SIDEBAR_TYPE_VIMEO = 'VIMEO';
	var EDITORIAL_SIDEBAR_TYPE_LINK = exports.EDITORIAL_SIDEBAR_TYPE_LINK = 'LINK';
	
	var DEVICE_DESKTOP = exports.DEVICE_DESKTOP = 'DEVICE_DESKTOP';
	var DEVICE_TABLET_PORTRAIT = exports.DEVICE_TABLET_PORTRAIT = 'DEVICE_TABLET_PORTRAIT';
	var DEVICE_TABLET_LANDSCAPE = exports.DEVICE_TABLET_LANDSCAPE = 'DEVICE_TABLET_LANDSCAPE';
	var DEVICE_MOBILE_PORTRAIT = exports.DEVICE_MOBILE_PORTRAIT = 'DEVICE_MOBILE_PORTRAIT';
	var DEVICE_MOBILE_LANDSCAPE = exports.DEVICE_MOBILE_LANDSCAPE = 'DEVICE_MOBILE_LANDSCAPE';

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(414);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(154)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(418))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(27)) {
	  var LIBRARY = __webpack_require__(100);
	  var global = __webpack_require__(15);
	  var fails = __webpack_require__(19);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(193);
	  var $buffer = __webpack_require__(265);
	  var ctx = __webpack_require__(68);
	  var anInstance = __webpack_require__(109);
	  var propertyDesc = __webpack_require__(114);
	  var hide = __webpack_require__(47);
	  var redefineAll = __webpack_require__(115);
	  var toInteger = __webpack_require__(70);
	  var toLength = __webpack_require__(26);
	  var toIndex = __webpack_require__(412);
	  var toAbsoluteIndex = __webpack_require__(117);
	  var toPrimitive = __webpack_require__(82);
	  var has = __webpack_require__(53);
	  var classof = __webpack_require__(134);
	  var isObject = __webpack_require__(20);
	  var toObject = __webpack_require__(37);
	  var isArrayIter = __webpack_require__(251);
	  var create = __webpack_require__(111);
	  var getPrototypeOf = __webpack_require__(55);
	  var gOPN = __webpack_require__(112).f;
	  var getIterFn = __webpack_require__(267);
	  var uid = __webpack_require__(118);
	  var wks = __webpack_require__(23);
	  var createArrayMethod = __webpack_require__(79);
	  var createArrayIncludes = __webpack_require__(181);
	  var speciesConstructor = __webpack_require__(155);
	  var ArrayIterators = __webpack_require__(268);
	  var Iterators = __webpack_require__(135);
	  var $iterDetect = __webpack_require__(186);
	  var setSpecies = __webpack_require__(116);
	  var arrayFill = __webpack_require__(243);
	  var arrayCopyWithin = __webpack_require__(384);
	  var $DP = __webpack_require__(34);
	  var $GOPD = __webpack_require__(54);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var DraftEntityInstance = __webpack_require__(429);
	var Immutable = __webpack_require__(24);
	
	var invariant = __webpack_require__(7);
	
	var Map = Immutable.Map;
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    return DraftEntity.add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key.') : invariant(false) : undefined;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    var instance = DraftEntity.get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    var instance = DraftEntity.get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(105)
	  , core      = __webpack_require__(60)
	  , hide      = __webpack_require__(124)
	  , redefine  = __webpack_require__(125)
	  , ctx       = __webpack_require__(214)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(201);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(128);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(17);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      var noop = require('fbjs/lib/emptyFunction');
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', noop));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', noop));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AUTO = exports.BOTTOM_LEFT = exports.BOTTOM_RIGHT = exports.TOP_LEFT = exports.TOP_RIGHT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _dropdown = __webpack_require__(997);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOP_RIGHT = exports.TOP_RIGHT = 'TOP_RIGHT';
	var TOP_LEFT = exports.TOP_LEFT = 'TOP_LEFT';
	var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'BOTTOM_RIGHT';
	var BOTTOM_LEFT = exports.BOTTOM_LEFT = 'BOTTOM_LEFT';
	var AUTO = exports.AUTO = 'AUTO';
	
	var Dropdown = function (_Component) {
		_inherits(Dropdown, _Component);
	
		function Dropdown(props) {
			_classCallCheck(this, Dropdown);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropdown).call(this));
	
			_this.mounted = true;
	
			_this.setActive = _this.setActive.bind(_this);
			_this.setInactive = _this.setInactive.bind(_this);
			_this.toggleActive = _this.toggleActive.bind(_this);
	
			_this.state = _extends({
				active: false,
				fading: false
			}, _this.getClientRect(props), {
				maxWidth: _this.getMaxWidth()
			});
			return _this;
		}
	
		_createClass(Dropdown, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var attachElement = this.props.attachTo();
				this.addListener(attachElement);
				//this.addListener(this.refs.dropdown);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				var attachElement = this.props.attachTo();
				this.removeListener(attachElement);
				//this.removeListener(this.refs.dropdown);
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps) {
				if (this.mounted && this.props.browser.window.width !== nProps.browser.window.width || this.props.browser.window.height !== nProps.browser.window.height) {
					this.mounted && this.setState(_extends({}, this.state, this.getClientRect(this.props), {
						maxWidth: this.getMaxWidth()
					}));
				}
			}
		}, {
			key: 'getClientRect',
			value: function getClientRect(props) {
				return {
					clientRect: props.attachTo() ? props.attachTo().getClientRects()[0] : false
				};
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var styles = {};
				var attachElement = this.props.attachTo();
				var className = 'dropdown';
				var arrowClassName = 'dropdown__arrow';
				var arrowOffset = 30;
				var arrowUp = true;
				var arrowLeft = true;
				var wCenterX = window.innerWidth / 2;
				var wCenterY = window.innerHeight / 2;
				var width = parseInt(this.props.width, 10);
				var maxWidth = this.state.maxWidth;
				var correctionStyle = {
					marginLeft: 0
				};
				var clientRect = this.state.clientRect;
	
				// if (attachElement) {
				// 	clientRect = attachElement.getClientRects()[0];
				// }
	
				if (clientRect && clientRect.width) {
					var eHalfWidth = clientRect.width / 2;
					var eHalfHeight = clientRect.height / 2;
					var eCenterX = clientRect.left + eHalfWidth;
					var eCenterY = clientRect.top + eHalfHeight;
	
					arrowLeft = eCenterX < wCenterX;
					arrowUp = eCenterY < wCenterY;
	
					if (arrowLeft) {
						styles.left = attachElement.offsetLeft - arrowOffset + eHalfWidth + 'px';
						arrowClassName += ' dropdown__arrow--left';
					} else {
						styles.left = attachElement.offsetLeft - (this.props.width - arrowOffset - eHalfWidth) + 'px';
						arrowClassName += ' dropdown__arrow--right';
					}
	
					if (arrowUp) {
						styles.top = attachElement.offsetTop + clientRect.height + 'px';
						arrowClassName += ' dropdown__arrow--top';
					} else {
						styles.bottom = attachElement.offsetParent.offsetHeight - attachElement.offsetTop + 'px';
						correctionStyle.bottom = '0px';
						//styles.bottom = '100%';//getTopOffset(attachElement);
						//styles.marginBottom = (clientRect.height - attachElement.offsetTop) + 'px';
						arrowClassName += ' dropdown__arrow--bottom';
					}
	
					if (this.props.height) {
						styles.height = parseInt(this.props.height, 10) + 'px';
					}
	
					if (this.props.width) {
						styles.width = (width > maxWidth ? maxWidth : width) + 'px';
					}
	
					// console.log(`(${wCenterX} < ${(width > maxWidth ? maxWidth : width)})`);
					if (wCenterX < (width > maxWidth ? maxWidth : width)) {
						var dropWidth = width > maxWidth ? maxWidth : width;
						//let outWidth = (dropWidth - wCenterX);
						var realOutWidth = 0;
	
						if (arrowLeft) {
							//realOutWidth = dropWidth - (clientRect.left + arrowOffset);
							//correctionStyle.left = realOutWidth + 'px';
							//correctionStyle.right = outWidth + 'px';
							//styles.left = -outWidth + 'px';
						} else {
							realOutWidth = clientRect.left + -arrowOffset - dropWidth;
							correctionStyle.left = -realOutWidth + 'px';
	
							//styles.left = (dropWidth - (dropWidth - outWidth)) + 'px';
						}
	
						//console.log('out: ' + realOutWidth);
					}
				} else {
					setTimeout(function () {
						_this2.mounted && _this2.setState(_extends({}, _this2.state, _this2.getClientRect(_this2.props)));
					}, 100);
				}
	
				correctionStyle.width = styles.width;
	
				if (this.state.active) {
					className += ' dropdown--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: 'dropdown' },
					this.state.active && _react2.default.createElement('div', { className: 'dropdown__dimmer', onClick: this.setInactive.bind(this) }),
					_react2.default.createElement(
						'div',
						{ className: className, style: styles, ref: 'dropdown' },
						arrowUp && _react2.default.createElement('div', { className: arrowClassName }),
						_react2.default.createElement(
							'div',
							{ className: 'dropdown__repositioner', style: correctionStyle },
							arrowUp && !this.props.disablePattern && _react2.default.createElement('div', { className: 'dropdown__grid pixel-pattern pixel-pattern--darker pixel-pattern--01' }),
							_react2.default.createElement(
								'div',
								{ className: 'dropdown__content', onClick: this.setInactive.bind(this) },
								this.props.children
							),
							!arrowUp && !this.props.disablePattern && _react2.default.createElement('div', { className: 'dropdown__grid dropdown__grid--bottom pixel-pattern pixel-pattern--darker pixel-pattern--01' })
						),
						!arrowUp && _react2.default.createElement('div', { className: arrowClassName })
					)
				);
			}
		}, {
			key: 'addListener',
			value: function addListener(element) {
				if (element && typeof element.addEventListener === 'function') {
					//element.addEventListener('mouseenter', this.setActive);
					//element.addEventListener('mouseleave', this.setInactive);
					element.addEventListener('click', this.toggleActive);
				}
			}
		}, {
			key: 'removeListener',
			value: function removeListener(element) {
				if (element && typeof element.removeEventListener === 'function') {
					//element.removeEventListener('mouseenter', this.setActive);
					//element.removeEventListener('mouseleave', this.setInactive);
					element.removeEventListener('click', this.toggleActive);
				}
			}
		}, {
			key: 'setActive',
			value: function setActive() {
				//clearTimeout(this.graceTimer);
				//this.state.active = true;
				this.setAttachElementActiveClass(true);
				this.setState(_extends({}, this.state, {
					active: true
				}));
			}
		}, {
			key: 'setInactive',
			value: function setInactive() {
				this.setAttachElementActiveClass(false);
				this.setState(_extends({}, this.state, {
					active: false
				}));
			}
		}, {
			key: 'toggleActive',
			value: function toggleActive() {
				this.setAttachElementActiveClass(!this.state.active);
	
				this.setState(_extends({}, this.state, {
					active: !this.state.active
				}));
			}
		}, {
			key: 'setAttachElementActiveClass',
			value: function setAttachElementActiveClass(active) {
				var attachElement = this.props.attachTo();
				attachElement.classList[active ? 'add' : 'remove']('dropdown-activator--active');
			}
		}, {
			key: 'getMaxWidth',
			value: function getMaxWidth() {
				if (document.documentElement && document.documentElement.clientWidth) {
					return document.documentElement.clientWidth - 40;
				}
	
				if (document.body) {
					return document.body.clientWidth - 40;
				}
	
				return 0;
			}
		}]);
	
		return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
		attachTo: _react.PropTypes.func.isRequired,
		height: _react.PropTypes.number,
		width: _react.PropTypes.number,
		pointTo: _react.PropTypes.string
	};
	Dropdown.defaultProps = {
		height: 0,
		width: 260,
		pointTo: TOP_RIGHT
	};
	exports.default = Dropdown;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(298);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _validate = __webpack_require__(76);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _text = __webpack_require__(450);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputTextarea = function (_Component) {
		_inherits(InputTextarea, _Component);
	
		function InputTextarea(props) {
			_classCallCheck(this, InputTextarea);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputTextarea).call(this));
	
			_this.valid = typeof props.error === 'undefined' ? true : !props.error;
	
			_this.state = {
				value: '' + props.value,
				valid: _this.valid
			};
			return _this;
		}
	
		_createClass(InputTextarea, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.props.value) {
					this.setState(_extends({}, this.state, {
						value: '' + nextProps.value
					}));
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.valid !== nextState.valid || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateHeight();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				this.updateHeight();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'custom-input__textarea';
				var btw = this.props.btw || '';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (!this.props.span) {
					className += ' span8-tablet span100p-mobile';
				} else {
					className += ' ' + this.props.span;
				}
	
				if (!this.state.valid || this.props.error) {
					className += ' invalid';
				}
	
				if (this.props.maxChars) {
					btw += ' (' + this.charRemaining(this.state.value) + ' characters left)';
				}
	
				return _react2.default.createElement(
					_label2.default,
					{ name: this.props.name, label: this.props.label, btw: btw, className: 'relative' },
					_react2.default.createElement('textarea', _extends({ key: 'input', ref: 'input', id: this.props.name }, this.props, { style: {}, value: this.state.value, onChange: function onChange(e) {
							return _this2.onChange(e);
						}, className: className })),
					this.renderError(this.props.error)
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(errors) {
				if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'custom-input__textarea__error' },
					errors.map(function (error, i) {
						return _react2.default.createElement(
							'span',
							{ key: i },
							error
						);
					})
				);
			}
		}, {
			key: 'updateHeight',
			value: function updateHeight() {
				if (this.props.autosize && this.refs.input) {
					this.refs.input.style.minHeight = '0';
					var scrollHeight = this.refs.input.scrollHeight;
					this.refs.input.style.minHeight = scrollHeight + 2 + 'px';
				}
			}
		}, {
			key: 'charRemaining',
			value: function charRemaining(value) {
				if (!this.props.maxChars) {
					// when no max is set, always return 1
					return 1;
				}
	
				var remaining = this.props.maxChars - value.length;
				return remaining;
			}
		}, {
			key: 'value',
			value: function value(val) {
				if (!this) {
					return '';
				}
	
				if (val !== undefined) {
					return this.setState(_extends({}, this.state, {
						value: val
					}));
				}
	
				var newVal = this.state.value;
				if (this.refs.input && this.refs.input.value && this.refs.input.value !== this.state.value) {
					newVal = this.refs.input.value;
				}
	
				this.state.value = newVal;
	
				return newVal;
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				var newVal = this.state.value;
	
				if (e && e.target) {
					var remaining = this.charRemaining(e.target.value);
					if (remaining >= 0) {
						newVal = e.target.value;
					}
				}
	
				if (!this.props.manualValidate && this.props.validate) {
					this.valid = (0, _validate.isValid)(newVal, this.props.validate, this.props.error);
					this.setState(_extends({}, this.state, { value: newVal, valid: this.valid }));
				}
	
				this.setState(_extends({}, this.state, { value: newVal, valid: this.valid }));
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.setState(_extends({}, this.state, { value: '' }));
			}
		}, {
			key: 'testValidity',
			value: function testValidity() {
				this.valid = (0, _validate.isValid)(this.value(), this.props.validate, this.props.error);
				this.setState(_extends({}, this.state, { valid: this.valid }));
	
				return this.valid;
			}
		}]);
	
		return InputTextarea;
	}(_react.Component);
	
	InputTextarea.propTypes = {
		name: _react.PropTypes.string.isRequired,
		btw: _react.PropTypes.string,
		span: _react.PropTypes.string,
		// error: PropTypes.oneOf([
		// 	PropTypes.bool,
		// 	PropTypes.array,
		// 	PropTypes.null,
		// ]),
		validate: _react.PropTypes.array,
		manualValidate: _react.PropTypes.bool,
		autosize: _react.PropTypes.bool,
		maxChars: _react.PropTypes.number.isRequired
	};
	InputTextarea.defaultProps = {
		btw: '',
		error: undefined,
		value: '',
		manualValidate: false,
		maxChars: 0,
		autosize: false
	};
	exports.default = InputTextarea;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlayerButtonTrigger = exports.PlayerWithTrigger = exports.PlayerTrigger = exports.Player = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _trim = __webpack_require__(1207);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _player = __webpack_require__(1037);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _reactPlayer = __webpack_require__(1258);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	var _vimeoLogo = __webpack_require__(1103);
	
	var _vimeoLogo2 = _interopRequireDefault(_vimeoLogo);
	
	var _youtubeLogo = __webpack_require__(1104);
	
	var _youtubeLogo2 = _interopRequireDefault(_youtubeLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './content.scss';
	
	var REGEX_EXTRACT_YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	var REGEX_EXTRACT_YT_ID2 = /([a-zA-Z0-9_-]{11})/i;
	var REGEX_EXTRACT_VIMEO_ID = /vimeo.*?([0-9]+$)/i;
	var REGEX_EXTRACT_VIMEO_ID2 = /(^[0-9]+$)/i;
	
	var Player = exports.Player = function (_Component) {
		_inherits(Player, _Component);
	
		function Player(props) {
			_classCallCheck(this, Player);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Player).call(this));
	
			_this.mounted = true;
			_this.played = 0;
			_this.loaded = 0;
			_this.duration = 0;
			_this.wasActivated = false;
	
			_this.state = {
				playbackState: false,
				width: 640,
				height: 360,
				volume: 0.4,
				duration: '00;00',
				played: '00:00',
				url: props.url,
				visible: props.showVideo,
				thumb: ''
			};
			return _this;
		}
	
		_createClass(Player, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.url !== this.props.url || this.state.thumb !== nextState.thumb || this.state.playbackState !== nextState.playbackState || this.state.duration !== nextState.duration || this.state.played !== nextState.played || this.state.visible !== nextState.visible;
	
				// update on init
				if (!this.props.url.length && nextProps.url.length) {
					return true;
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				document.addEventListener('webkitfullscreenchange', this.onFullScreenExit, false);
				document.addEventListener('mozfullscreenchange', this.onFullScreenExit, false);
				document.addEventListener('fullscreenchange', this.onFullScreenExit, false);
				document.addEventListener('MSFullscreenChange', this.onFullScreenExit, false);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.visible && !this.wasActivated && this.props.browser.window.width > 719) {
					//document.body.scrollTop = getOffsetTop(this.refs.youtubePlayer) - 50;
					this.wasActivated = true;
	
					this.setState({
						playbackState: true
					});
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.vimeo && this.state.thumb == '') {
					getVideoThumb(this.props.url);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = _extends({}, this.state);
	
				if (nextProps.showVideo !== this.state.visible) {
					newState.visible = nextProps.showVideo;
				}
	
				if (nextProps.vimeo && this.props.url !== nextProps.url) {
					getVideoThumb(this.props.url);
				} else {
					this.setState(newState);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.removeEventListener('webkitfullscreenchange', this.onFullScreenExit, false);
				document.removeEventListener('mozfullscreenchange', this.onFullScreenExit, false);
				document.removeEventListener('fullscreenchange', this.onFullScreenExit, false);
				document.removeEventListener('MSFullscreenChange', this.onFullScreenExit, false);
	
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var youtubeConfig = {
					playerVars: {
						showinfo: 0, // deprecated
						controls: 1,
						fs: 1
					}
				};
	
				var vimeoConfig = {
					badge: 0,
					title: 0,
					frameborder: 0
				};
	
				if (this.props.youtube) {
					getVideoThumb(this.props.url);
				}
	
				var overlayClass = 'youtube-overlay';
				var playerClass = 'youtube-player span12 span14-tablet span14-mobile';
	
				if (this.state.visible) {
					overlayClass = 'youtube-overlay youtube-overlay--active';
					playerClass = 'youtube-player span12 span14-tablet span14-mobile youtube-player--active';
				}
	
				var playerUrl = this.getVideoUrl(this.props.url);
	
				return _react2.default.createElement(
					'div',
					{ className: '', onKeyPress: function onKeyPress(event) {
							return _this2.handleKeyDown(event);
						} },
					_react2.default.createElement('div', { ref: 'youtubeOverlay', onClick: function onClick() {
							return _this2.handleHideVideo();
						}, className: overlayClass }),
					this.state.visible && _react2.default.createElement(
						'div',
						{ ref: 'youtubePlayer', className: playerClass },
						this.getYoutubeID(playerUrl) && _react2.default.createElement(
							'a',
							{ className: 'youtube-player__original', href: playerUrl },
							_react2.default.createElement('img', { src: _youtubeLogo2.default.src })
						) || _react2.default.createElement(
							'a',
							{ className: 'youtube-player__original', href: playerUrl },
							_react2.default.createElement('img', { src: _vimeoLogo2.default.src })
						),
						_react2.default.createElement(_reactPlayer2.default, {
							className: 'player-iframe',
							ref: 'player',
							height: '100%',
							width: '100%',
							url: playerUrl,
							playing: this.state.playbackState,
							volume: this.state.volume,
							onProgress: function onProgress(e) {
								return _this2.mounted && _this2.handleProgess(e);
							},
							onPlay: function onPlay() {
								return _this2.mounted && _this2.setState({ playbackState: true });
							},
							onPause: function onPause() {
								return _this2.mounted && _this2.setState({ playbackState: false });
							},
							youtubeConfig: youtubeConfig,
							vimeoConfig: vimeoConfig
						})
					)
				);
			}
		}, {
			key: 'getVideoUrl',
			value: function getVideoUrl(url) {
				var youtubeID = this.getYoutubeID((0, _trim2.default)(url));
				if (youtubeID) {
					return 'https://youtube.com/watch?v=' + youtubeID;
				}
	
				var vimeoID = this.getVimeoID((0, _trim2.default)(url));
				if (vimeoID) {
					return 'https://vimeo.com/' + vimeoID;
				}
	
				return false;
			}
		}, {
			key: 'getVideoThumb',
			value: function getVideoThumb(url) {
				var youtubeID = this.getYoutubeID((0, _trim2.default)(url));
				if (youtubeID) {
					return this.getYoutubePreview(youtubeID);
				}
	
				var vimeoID = this.getVimeoID((0, _trim2.default)(url));
				if (vimeoID) {
					return this.getVimeoPreview(vimeoID);
				}
	
				return false;
			}
		}, {
			key: 'getYoutubeID',
			value: function getYoutubeID(url) {
				var extracted = REGEX_EXTRACT_YT_ID.exec(url);
	
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				extracted = REGEX_EXTRACT_YT_ID2.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				return false;
			}
		}, {
			key: 'getYoutubePreview',
			value: function getYoutubePreview(videoID) {
				if (!videoID) {
					return '';
				}
	
				var previewUrl = 'https://img.youtube.com/vi/' + videoID + '/hqdefault.jpg';
	
				return previewUrl;
			}
		}, {
			key: 'getVimeoID',
			value: function getVimeoID(url) {
				var extracted = REGEX_EXTRACT_VIMEO_ID.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				extracted = REGEX_EXTRACT_VIMEO_ID2.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				return false;
			}
		}, {
			key: 'getVimeoPreview',
			value: function getVimeoPreview(videoID) {
				var _this3 = this;
	
				_axios2.default.get('https://vimeo.com/api/v2/video/' + videoID + '.json').then(function (response) {
					if (response.data[0].thumbnail_large) {
						if (_this3.state.thumb !== response.data[0].thumbnail_large) {
							_this3.mounted && _this3.setState(_extends({}, _this3.state, {
								thumb: response.data[0].thumbnail_large
							}));
						}
					}
				}).catch(function (response) {
					console.log('error fetching vimeo data');
					console.log(response);
				});
			}
		}, {
			key: 'handlePlayPause',
			value: function handlePlayPause() {
				this.setState({
					playbackState: !this.state.playbackState
				});
			}
		}, {
			key: 'handleFullscreen',
			value: function handleFullscreen() {
				var target = this.refs.youtubePlayer;
	
				if (target.getAttribute('fullscreen') == 'yes') {
					var exitFullscreen = function exitFullscreen() {
						if (document.exitFullscreen) {
							document.exitFullscreen();
						} else if (document.mozCancelFullScreen) {
							document.mozCancelFullScreen();
						} else if (document.webkitExitFullscreen) {
							document.webkitExitFullscreen();
						}
					};
	
					// Cancel fullscreen for browsers that support it!
	
	
					target.classList.remove('youtube-player--fullScreen');
					target.setAttribute('fullscreen', 'no');
	
					exitFullscreen();
				} else {
					target.classList.add('youtube-player--fullScreen');
					target.setAttribute('fullscreen', 'yes');
	
					var requestFullScreen = target.requestFullScreen || target.mozRequestFullScreen || target.webkitRequestFullScreen;
					if (requestFullScreen) {
						requestFullScreen.bind(target)();
					}
				}
			}
		}, {
			key: 'keyPress',
			value: function keyPress(e) {
				if (e.which == 27) {
					document.querySelector('.youtube-player').classList.remove('youtube-player--fullScreen');
				}
			}
		}, {
			key: 'onFullScreenExit',
			value: function onFullScreenExit() {
				if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
					document.querySelector('.youtube-player').classList.remove('youtube-player--fullScreen');
					document.querySelector('.youtube-player').setAttribute('fullscreen', 'no');
				}
			}
		}, {
			key: 'handleVideoToggle',
			value: function handleVideoToggle() {
				this.setState({
					visible: true
				});
			}
		}, {
			key: 'handleProgess',
			value: function handleProgess(e) {
				if (e.played) {
					this.played = e.played;
				}
	
				if (e.loaded) {
					this.loaded = e.loaded;
				}
			}
		}, {
			key: 'handleHideVideo',
			value: function handleHideVideo() {
				this.wasActivated = false;
	
				this.props.onClose();
				this.setState({
					visible: false,
					playbackState: false
				});
			}
		}]);
	
		return Player;
	}(_react.Component);
	
	Player.PropTypes = {
		url: _react.PropTypes.string.isRequired,
		showVideo: _react.PropTypes.bool.isRequired,
		onClose: _react.PropTypes.func.isRequired,
		browser: _react.PropTypes.object.isRequired
	};
	Player.defaultProps = {
		url: '',
		showVideo: false,
		onClose: function onClose() {}
	};
	
	var PlayerTrigger = exports.PlayerTrigger = function (_Component2) {
		_inherits(PlayerTrigger, _Component2);
	
		function PlayerTrigger(props) {
			_classCallCheck(this, PlayerTrigger);
	
			var _this4 = _possibleConstructorReturn(this, Object.getPrototypeOf(PlayerTrigger).call(this, props));
	
			_this4.mounted = true;
	
			_this4.state = {
				thumb: _this4.getVideoThumb(props.url)
			};
			return _this4;
		}
	
		_createClass(PlayerTrigger, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.url !== this.props.url) {
					this.setState(_extends({}, this.state, {
						thumb: this.getVideoThumb(nextProps.url)
					}));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.props.onUpdate) {
					this.props.onUpdate();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.onUpdate) {
					this.props.onUpdate();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var className = 'player-toggle';
				var style = {
					backgroundImage: 'url(\'' + this.state.thumb + '\')'
				};
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className, style: style, onClick: this.props.onClick },
					_react2.default.createElement('img', { src: this.state.thumb, alt: '' })
				);
			}
		}, {
			key: 'playVideo',
			value: function playVideo() {
				this.props.onClick();
			}
		}, {
			key: 'getVideoThumb',
			value: function getVideoThumb(url) {
				var youtubeID = this.getYoutubeID((0, _trim2.default)(url));
				if (youtubeID) {
					return this.getYoutubePreview(youtubeID);
				}
	
				var vimeoID = this.getVimeoID((0, _trim2.default)(url));
				if (vimeoID) {
					return this.getVimeoPreview(vimeoID);
				}
	
				return false;
			}
		}, {
			key: 'getYoutubeID',
			value: function getYoutubeID(url) {
				var extracted = REGEX_EXTRACT_YT_ID.exec(url);
	
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				extracted = REGEX_EXTRACT_YT_ID2.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				return false;
			}
		}, {
			key: 'getYoutubePreview',
			value: function getYoutubePreview(videoID) {
				if (!videoID) {
					return '';
				}
	
				return 'https://img.youtube.com/vi/' + videoID + '/hqdefault.jpg';
			}
		}, {
			key: 'getVimeoID',
			value: function getVimeoID(url) {
				var extracted = REGEX_EXTRACT_VIMEO_ID.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				extracted = REGEX_EXTRACT_VIMEO_ID2.exec(url);
				if (extracted && extracted.length > 1) {
					return extracted[1];
				}
	
				return false;
			}
		}, {
			key: 'getVimeoPreview',
			value: function getVimeoPreview(videoID) {
				var _this5 = this;
	
				_axios2.default.get('https://vimeo.com/api/v2/video/' + videoID + '.json').then(function (response) {
					if (response.data[0].thumbnail_large) {
						if (_this5.state.thumb !== response.data[0].thumbnail_large) {
							_this5.mounted && _this5.setState(_extends({}, _this5.state, {
								thumb: response.data[0].thumbnail_large
							}));
						}
					}
				}).catch(function (response) {
					console.log('error fetching vimeo data');
					console.log(response);
				});
			}
		}]);
	
		return PlayerTrigger;
	}(_react.Component);
	
	PlayerTrigger.propTypes = {
		url: _react.PropTypes.string.isRequired,
		thumb: _react.PropTypes.string,
		onUpdate: _react.PropTypes.func,
		className: _react.PropTypes.string
	};
	PlayerTrigger.defaultProps = {
		url: '',
		thumb: '',
		className: '',
		onUpdate: function onUpdate() {}
	};
	
	var PlayerWithTrigger = exports.PlayerWithTrigger = function (_Component3) {
		_inherits(PlayerWithTrigger, _Component3);
	
		function PlayerWithTrigger(props) {
			_classCallCheck(this, PlayerWithTrigger);
	
			var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(PlayerWithTrigger).call(this, props));
	
			_this6.state = {
				showVideo: false
			};
			return _this6;
		}
	
		_createClass(PlayerWithTrigger, [{
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var className = 'player-toggle';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(PlayerTrigger, {
						url: this.props.url,
						onClick: function onClick(e) {
							_this7.setState(_extends({}, _this7.state, {
								showVideo: !_this7.state.showVideo
							}));
						}
					}),
					_react2.default.createElement(Player, { url: this.props.url, showVideo: this.state.showVideo, browser: this.props.browser, onClose: function onClose() {
							_this7.setState(_extends({}, _this7.state, { showVideo: false }));
						} })
				);
			}
		}]);
	
		return PlayerWithTrigger;
	}(_react.Component);
	
	PlayerWithTrigger.propTypes = {
		url: _react.PropTypes.string.isRequired,
		browser: _react.PropTypes.object.isRequired,
		className: _react.PropTypes.string
	};
	PlayerWithTrigger.defaultProps = {
		url: '',
		className: ''
	};
	
	var PlayerButtonTrigger = exports.PlayerButtonTrigger = function (_Component4) {
		_inherits(PlayerButtonTrigger, _Component4);
	
		function PlayerButtonTrigger(props) {
			_classCallCheck(this, PlayerButtonTrigger);
	
			var _this8 = _possibleConstructorReturn(this, Object.getPrototypeOf(PlayerButtonTrigger).call(this, props));
	
			_this8.state = {
				showVideo: false
			};
			return _this8;
		}
	
		_createClass(PlayerButtonTrigger, [{
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var className = 'player-toggle-btn';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'button',
						{
							className: 'player-toggle-btn__btn',
							onClick: function onClick() {
								return _this9.setState(_extends({}, _this9.state, { showVideo: !_this9.state.showVideo }));
							}
						},
						this.props.text
					),
					_react2.default.createElement(Player, { url: this.props.url, browser: this.props.browser, showVideo: this.state.showVideo, onClose: function onClose() {
							_this9.setState(_extends({}, _this9.state, { showVideo: false }));
						} })
				);
			}
		}]);
	
		return PlayerButtonTrigger;
	}(_react.Component);
	
	PlayerButtonTrigger.propTypes = {
		url: _react.PropTypes.string.isRequired,
		text: _react.PropTypes.string,
		className: _react.PropTypes.string,
		browser: _react.PropTypes.object.isRequired
	};
	PlayerButtonTrigger.defaultProps = {
		url: '',
		text: '',
		className: ''
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = metaDesc;
	function metaDesc() {
		var description = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		if (document.querySelector('meta[name="description"]')) {
			document.querySelector('meta[name="description"]').remove();
		}
	
		if (description !== '') {
			var meta = '<meta name="description" class="inserted" content="' + description + '">';
			document.querySelector('head').insertAdjacentHTML('beforeend', meta);
		}
	
		return false;
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(23)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(47)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(118)('meta');
	var isObject = __webpack_require__(20);
	var has = __webpack_require__(53);
	var setDesc = __webpack_require__(34).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(19)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(1151);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 105 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (Object.prototype.hasOwnProperty.call(propTypes, propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      /* istanbul ignore if: error logging */
	      if (error instanceof Error)  false ? (0, _routerWarning2.default)(false, error.message) : void 0;
	    }
	  }
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName || type.name, type.propTypes, route);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *   
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 108 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = getTopOffset;
	exports.getLeftOffset = getLeftOffset;
	function getTopOffset(element) {
		var stopElement = arguments.length <= 1 || arguments[1] === undefined ? document.body : arguments[1];
	
		if (!element) {
			return 0;
		}
	
		var recursiveOffset = 0;
		if (element.offsetParent && element.offsetParent !== stopElement) {
			recursiveOffset = getTopOffset(element.offsetParent, stopElement);
		}
	
		return recursiveOffset + element.offsetTop;
	}
	
	function getLeftOffset(element) {
		var stopElement = arguments.length <= 1 || arguments[1] === undefined ? document.body : arguments[1];
	
		if (!element) {
			return 0;
		}
	
		var recursiveOffset = 0;
		if (element.offsetParent && element.offsetParent !== stopElement) {
			recursiveOffset = getLeftOffset(element.offsetParent, stopElement);
		}
	
		return recursiveOffset + element.offsetLeft;
	}

/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(68);
	var call = __webpack_require__(395);
	var isArrayIter = __webpack_require__(251);
	var anObject = __webpack_require__(10);
	var toLength = __webpack_require__(26);
	var getIterFn = __webpack_require__(267);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(10);
	var dPs = __webpack_require__(401);
	var enumBugKeys = __webpack_require__(247);
	var IE_PROTO = __webpack_require__(260)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(246)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(249).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(403);
	var hiddenKeys = __webpack_require__(247).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(403);
	var enumBugKeys = __webpack_require__(247);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(48);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var dP = __webpack_require__(34);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(23)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 118 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(907);
	var isArguments = __webpack_require__(906);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(24);
	
	var findRangesImmutable = __webpack_require__(197);
	
	var List = Immutable.List;
	var OrderedSet = Immutable.OrderedSet;
	var Record = Immutable.Record;
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var ContentBlock = (function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock() {
	    _classCallCheck(this, ContentBlock);
	
	    _get(Object.getPrototypeOf(ContentBlock.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ContentBlock, [{
	    key: 'getKey',
	    value: function getKey() {
	      return this.get('key');
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      return this.get('text');
	    }
	  }, {
	    key: 'getCharacterList',
	    value: function getCharacterList() {
	      return this.get('characterList');
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.getText().length;
	    }
	  }, {
	    key: 'getDepth',
	    value: function getDepth() {
	      return this.get('depth');
	    }
	  }, {
	    key: 'getInlineStyleAt',
	    value: function getInlineStyleAt(offset) {
	      var character = this.getCharacterList().get(offset);
	      return character ? character.getStyle() : EMPTY_SET;
	    }
	  }, {
	    key: 'getEntityAt',
	    value: function getEntityAt(offset) {
	      var character = this.getCharacterList().get(offset);
	      return character ? character.getEntity() : null;
	    }
	
	    /**
	     * Execute a callback for every contiguous range of styles within the block.
	     */
	  }, {
	    key: 'findStyleRanges',
	    value: function findStyleRanges(filterFn, callback) {
	      findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	    }
	
	    /**
	     * Execute a callback for every contiguous range of entities within the block.
	     */
	  }, {
	    key: 'findEntityRanges',
	    value: function findEntityRanges(filterFn, callback) {
	      findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	    }
	  }]);
	
	  return ContentBlock;
	})(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(59)
	  , createDesc = __webpack_require__(312);
	module.exports = __webpack_require__(216) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(105)
	  , hide      = __webpack_require__(124)
	  , SRC       = __webpack_require__(219)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(60).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_SIDE_EFFECTS: 0x2,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : void 0;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\uB7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 129 */
/***/ function(module, exports) {

	// Signals that the router's state has changed. It should
	// never be called by the application, only as an implementation detail of
	// redux-react-router.
	'use strict';
	
	exports.__esModule = true;
	var ROUTER_DID_CHANGE = '@@reduxReactRouter/routerDidChange';
	
	exports.ROUTER_DID_CHANGE = ROUTER_DID_CHANGE;
	var HISTORY_API = '@@reduxReactRouter/historyAPI';
	exports.HISTORY_API = HISTORY_API;
	var MATCH = '@@reduxReactRouter/match';
	exports.MATCH = MATCH;
	var INIT_ROUTES = '@@reduxReactRouter/initRoutes';
	exports.INIT_ROUTES = INIT_ROUTES;
	var REPLACE_ROUTES = '@@reduxReactRouter/replaceRoutes';
	
	exports.REPLACE_ROUTES = REPLACE_ROUTES;
	var ROUTER_STATE_SELECTOR = '@@reduxReactRouter/routerStateSelector';
	
	exports.ROUTER_STATE_SELECTOR = ROUTER_STATE_SELECTOR;
	var DOES_NEED_REFRESH = '@@reduxReactRouter/doesNeedRefresh';
	exports.DOES_NEED_REFRESH = DOES_NEED_REFRESH;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.clearSingleEditorial = clearSingleEditorial;
	exports.fetchEditorials = fetchEditorials;
	exports.fetchEditorialsFromType = fetchEditorialsFromType;
	exports.fetchSingleEditorial = fetchSingleEditorial;
	exports.editEditorial = editEditorial;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/editorials/';
	
	function action(type) {
		return { type: type };
	};
	
	function respond(json, type) {
		//console.log(type);
		return {
			type: type,
			payload: json
		};
	};
	
	function clearSingleEditorial() {
		return function (dispatch) {
			dispatch(action(actionTypes.EDITORIALS_CLEAR_SINGLE));
		};
	}
	
	function fetchEditorials() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 20 : arguments[1];
		var slug = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
		var queryParams = {
			offset: offset,
			limit: limit
		};
	
		return function (dispatch) {
			dispatch(action(actionTypes.EDITORIALS_REQ_DATA));
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_DATA));
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_ERROR));
	
				console.log('editorials - fetch error');
				console.log(response.data);
	
				//dispatch(pushState(null, '/error'));
			});
		};
	};
	
	function fetchEditorialsFromType() {
		var type = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
		var offset = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
		var limit = arguments.length <= 2 || arguments[2] === undefined ? 36 : arguments[2];
		var month = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
		var year = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];
		var q = arguments.length <= 5 || arguments[5] === undefined ? '' : arguments[5];
	
		var queryParams = {
			type: type,
			offset: offset,
			limit: limit,
			month: month,
			year: year,
			q: q
		};
	
		return function (dispatch) {
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_TYPE_DATA));
			}).catch(function (response) {
	
				console.log('editorials TYPE - fetch error');
				console.log(response);
	
				//dispatch(pushState(null, '/error'));
			});
		};
	};
	
	function fetchSingleEditorial(slug) {
		var success = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
		var fail = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];
		var preview = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		if (!(typeof slug === 'number' || typeof slug === 'string' && slug.length)) {
			console.log('editorial - invalid slug');
			return function (dispatch) {
				//dispatch(pushState(null, '/error'));
			};
		}
	
		//console.log('fetch single editorial - ' + url + slug);
	
		return function (dispatch) {
			dispatch(action(actionTypes.EDITORIALS_REQ_SINGLE_DATA));
	
			var data = {};
	
			if (preview) {
				data.preview = preview;
			}
	
			return (0, _axios2.default)({
				url: url + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: data
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_SINGLE_DATA));
				success();
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_ERROR));
				fail();
	
				console.log('editorial - fetch error');
				console.log(response);
	
				fail();
			});
		};
	}
	
	function editEditorial() {
		var type = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
		var id = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		if (!type && !type.length) {
			return function (dispatch) {
				//dispatch(pushState(null, '/error'));
			};
		}
	
		var editUrl = _baseUrl2.default + ('/api/account/editorials/' + type + '/form');
	
		return function (dispatch) {
			//dispatch(action(actionTypes.EDITORIALS_REQ_SINGLE_DATA));
			return (0, _axios2.default)({
				url: editUrl,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: {
					editorialId: id
				}
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.ACCOUNT_EDITORIAL_RECV_DATA));
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.RECV_ERROR));
	
				console.log('editorials - create error');
				console.log(response.data);
	
				//dispatch(pushState(null, '/error'));
			});
		};
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormFitterDecorator = function (_Component) {
		_inherits(FormFitterDecorator, _Component);
	
		function FormFitterDecorator() {
			_classCallCheck(this, FormFitterDecorator);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(FormFitterDecorator).apply(this, arguments));
		}
	
		_createClass(FormFitterDecorator, [{
			key: 'render',
			value: function render() {
				var className = 'account-block-content__default__section';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				} else {
					className += ' span3 span5-tablet span11-mobile';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-block-content__default' },
					_react2.default.createElement(
						'div',
						{ className: className },
						this.props.children
					)
				);
			}
		}]);
	
		return FormFitterDecorator;
	}(_react.Component);
	
	FormFitterDecorator.propTypes = {
		className: _react.PropTypes.string
	};
	FormFitterDecorator.defaultProps = {
		className: ''
	};
	exports.default = FormFitterDecorator;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (elementToActivate, browser) {
		//event.scrollY
		var _offsetTop = 0;
		var _wWidth = 0;
		var _wHeight = 0;
		var elem = elementToActivate();
		// let _DEBUG_ID = DEBUG_ID++;
	
		var tryActivateElem = function tryActivateElem(event) {
			// console.log(`[ID:${_DEBUG_ID}] tryActivateElem`);
			if (event && event.deltaY === 0) {
				return false;
			}
	
			// console.log(`[ID:${_DEBUG_ID}] tryActivateElem - running`);
			// let perf = performance.now() / 1000;
			// console.log(`[ID:${_DEBUG_ID}] START: ${perf}`);
	
			event = event || { scrollY: window.scrollY };
	
			// offsetTop is expensive, so we use a cached value if available
			// + invalidate if browser window is resized
			var offsetTop = _offsetTop;
			if (!offsetTop || document.documentElement.clientHeight !== _wHeight || document.documentElement.clientWidth !== _wWidth) {
				_wHeight = document.documentElement.clientHeight;
				_wWidth = document.documentElement.clientWidth;
				_offsetTop = offsetTop = (0, _getOffsetTop2.default)(elem);
			}
	
			var elementTrigger = offsetTop + 150;
			var shouldActivate = event.scrollY + browser.window.height >= elementTrigger;
	
			if (shouldActivate) {
				//console.log(elem);
				//console.log(`(${event.scrollY + browser.window.height} >= ${elementTrigger})`);
				if (!hasClass(elem, 'active')) {
					elem.className += ' active';
				}
	
				browser.scroll.deregister(tryActivateElem);
			}
	
			// let newPerf = (performance.now() / 1000);
			// console.log(`[ID:${_DEBUG_ID}] END: ${newPerf} - DIFF: ${newPerf - perf}`);
	
			return shouldActivate;
		};
	
		return tryActivateElem;
	};
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasClass = function hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	};
	
	// let DEBUG_ID = 0;
	
	;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _routes = __webpack_require__(4);
	
	var _actions = __webpack_require__(13);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.fbAsyncInit = function () {
		//console.log('fb init');
		window.FB.init({
			appId: window.konfig.social.fbAppId,
			cookie: true,
			xfbml: true,
			version: 'v2.5'
		});
	};
	
	var FBAuth = function () {
		function FBAuth() {
			//this.load();
	
			_classCallCheck(this, FBAuth);
		}
	
		_createClass(FBAuth, [{
			key: 'load',
			value: function load() {
				if (!this.isLoaded()) {
					// Inject facebook api
					(function (d, s, id) {
						var js,
						    fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s);js.id = id;
						js.src = 'https://connect.facebook.net/en_GB/sdk.js';
						fjs.parentNode.insertBefore(js, fjs);
					})(document, 'script', 'facebook-jssdk');
				}
			}
		}, {
			key: 'isLoaded',
			value: function isLoaded() {
				return _typeof(this.API) === 'object';
			}
		}, {
			key: 'share',
			value: function share(url) {
				if (this.isLoaded()) {
					this.API.ui({
						method: 'share',
						href: url
					}, function (response) {
						//console.log(response);
					});
				} else {
					this.load();
				}
			}
		}, {
			key: 'login',
			value: function login(dispatch) {
				return this._FBLogin((0, _routes.genericRoute)(false, 'api/account/facebooksignin'), dispatch);
			}
		}, {
			key: 'register',
			value: function register(dispatch) {
				return this._FBLogin((0, _routes.genericRoute)(false, 'api/account/facebooksignup'), dispatch);
			}
		}, {
			key: '_FBLogin',
			value: function _FBLogin(path, dispatch) {
				if (this.isLoaded()) {
					this.API.login(function (fbRes) {
						if (fbRes.authResponse) {
							// var date = new Date();
							// date.setTime(date.getTime() + (31 * 24 * 60 * 60 * 1000));
							// let cookie = 'fb_access_token=' + fbRes.authResponse.accessToken + '; expires=' + date.toGMTString();
							// document.cookie = cookie;
							_axios2.default.post(path).then(function (res) {
								//console.log('Signed in as: ' + res.data.user.name);
								if (res.data.user) {
									dispatch({
										type: _actions.USERS_LOGIN_FB,
										payload: res.data
									});
								}
							}).catch(function (res) {
								dispatch((0, _errors.dispatchError)(res.data));
							});
						} else {
							dispatch((0, _errors.dispatchError)({
								message: 'Facebook Auth not completed.'
							}));
						}
					}, { scope: 'email' });
				} else {
					this.load();
				}
			}
		}, {
			key: 'API',
			get: function get() {
				return window.FB;
			}
		}]);
	
		return FBAuth;
	}();
	
	exports.default = FBAuth;
	;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(66);
	var TAG = __webpack_require__(23)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(34).f;
	var has = __webpack_require__(53);
	var TAG = __webpack_require__(23)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(80);
	var fails = __webpack_require__(19);
	var spaces = __webpack_require__(263);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(24);
	
	var Record = Immutable.Record;
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = (function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    _get(Object.getPrototypeOf(SelectionState.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SelectionState, [{
	    key: 'serialize',
	    value: function serialize() {
	      return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	    }
	  }, {
	    key: 'getAnchorKey',
	    value: function getAnchorKey() {
	      return this.get('anchorKey');
	    }
	  }, {
	    key: 'getAnchorOffset',
	    value: function getAnchorOffset() {
	      return this.get('anchorOffset');
	    }
	  }, {
	    key: 'getFocusKey',
	    value: function getFocusKey() {
	      return this.get('focusKey');
	    }
	  }, {
	    key: 'getFocusOffset',
	    value: function getFocusOffset() {
	      return this.get('focusOffset');
	    }
	  }, {
	    key: 'getIsBackward',
	    value: function getIsBackward() {
	      return this.get('isBackward');
	    }
	  }, {
	    key: 'getHasFocus',
	    value: function getHasFocus() {
	      return this.get('hasFocus');
	    }
	
	    /**
	     * Return whether the specified range overlaps with an edge of the
	     * SelectionState.
	     */
	  }, {
	    key: 'hasEdgeWithin',
	    value: function hasEdgeWithin(blockKey, start, end) {
	      var anchorKey = this.getAnchorKey();
	      var focusKey = this.getFocusKey();
	
	      if (anchorKey === focusKey && anchorKey === blockKey) {
	        var selectionStart = this.getStartOffset();
	        var selectionEnd = this.getEndOffset();
	        return start <= selectionEnd && selectionStart <= end;
	      }
	
	      if (blockKey !== anchorKey && blockKey !== focusKey) {
	        return false;
	      }
	
	      var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	      return start <= offsetToCheck && end >= offsetToCheck;
	    }
	  }, {
	    key: 'isCollapsed',
	    value: function isCollapsed() {
	      return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	    }
	  }, {
	    key: 'getStartKey',
	    value: function getStartKey() {
	      return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	    }
	  }, {
	    key: 'getStartOffset',
	    value: function getStartOffset() {
	      return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	    }
	  }, {
	    key: 'getEndKey',
	    value: function getEndKey() {
	      return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	    }
	  }, {
	    key: 'getEndOffset',
	    value: function getEndOffset() {
	      return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	    }
	  }], [{
	    key: 'createEmpty',
	    value: function createEmpty(key) {
	      return new SelectionState({
	        anchorKey: key,
	        anchorOffset: 0,
	        focusKey: key,
	        focusOffset: 0,
	        isBackward: false,
	        hasFocus: false
	      });
	    }
	  }]);
	
	  return SelectionState;
	})(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1137),
	    getValue = __webpack_require__(1160);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1211)();
	}


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(324);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(1294);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(224);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(1292);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(1293);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Define Elements, and register their implied token / source types for
	// automatic token / source creation.
	
	// Card
	var CardElement = (0, _Element2.default)('card', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	
	// Split Fields
	// Note: we only register the CardNumberElement for split fields so that we have
	// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	
	// IBAN
	var IbanElement = (0, _Element2.default)('iban', {
	  impliedTokenType: 'bank_account',
	  impliedSourceType: 'sepa_debit'
	});
	
	// iDEAL Bank
	var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
	exports.IbanElement = IbanElement;
	exports.IdealBankElement = IdealBankElement;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(334);
	var setTextContent = __webpack_require__(563);
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    node.innerHTML = tree.html;
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level.
	  if (tree.node.nodeType === 11) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    tree.node.innerHTML = html;
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1338);
	var ReactInstrumentation = __webpack_require__(227);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing native component instance
	   * @param {?object} info about the native container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, nativeParent, nativeContainerInfo, context) {
	    var markup = internalInstance.mountComponent(transaction, nativeParent, nativeContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      ReactInstrumentation.debugTool.onMountComponent(internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getNativeNode: function (internalInstance) {
	    return internalInstance.getNativeNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      ReactInstrumentation.debugTool.onUnmountComponent(internalInstance);
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onUpdateComponent(internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      ReactInstrumentation.debugTool.onUpdateComponent(internalInstance);
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _contextualJobs = __webpack_require__(616);
	
	var _contextualJobs2 = _interopRequireDefault(_contextualJobs);
	
	var _contextualProfiles = __webpack_require__(617);
	
	var _contextualProfiles2 = _interopRequireDefault(_contextualProfiles);
	
	var _contextualCases = __webpack_require__(613);
	
	var _contextualCases2 = _interopRequireDefault(_contextualCases);
	
	var _contextualDefault = __webpack_require__(614);
	
	var _contextualDefault2 = _interopRequireDefault(_contextualDefault);
	
	var _contextualImage = __webpack_require__(615);
	
	var _contextualImage2 = _interopRequireDefault(_contextualImage);
	
	var _contextual = __webpack_require__(995);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _relLinks = __webpack_require__(380);
	
	var _relLinks2 = _interopRequireDefault(_relLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualMenu = function (_Component) {
		_inherits(ContextualMenu, _Component);
	
		function ContextualMenu(props) {
			_classCallCheck(this, ContextualMenu);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualMenu).call(this, props));
	
			_this.prev = '';
			_this.next = '';
			return _this;
		}
	
		_createClass(ContextualMenu, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state !== nextState;
			}
		}, {
			key: 'render',
			value: function render() {
				var seen = false;
				if (localStorage.getItem('context') == 'seen') {
					seen = true;
				}
	
				var url = window.location.href;
				var remove = window.location.href.split('/')[window.location.href.split('/').length - 1];
	
				var prev = '';
				var next = '';
	
				if (this.props.next) {
					next = url.replace(remove, this.props.next);
				}
	
				if (this.props.prev) {
					prev = url.replace(remove, this.props.prev);
				}
	
				if (this.props.nextProfile) {
					next = url.replace(remove, this.props.nextProfile);
				}
	
				if (this.props.prevProfile) {
					prev = url.replace(remove, this.props.prevProfile);
				}
	
				if (!this.props.enableJobs && (this.prev !== prev || this.next !== next)) {
					(0, _relLinks2.default)(prev, next);
					this.prev = prev;
					this.next = next;
				}
	
				return this.props.enableJobs && _react2.default.createElement(_contextualJobs2.default, { seen: seen, jobId: this.props.jobId, enableJobs: true }) || this.props.enableProfiles && _react2.default.createElement(_contextualProfiles2.default, { seen: seen, enableProfiles: true, nextProfile: this.props.nextProfile, prevProfile: this.props.prevProfile }) || this.props.enableCases && _react2.default.createElement(_contextualCases2.default, { seen: seen, enableCases: true, next: this.props.next, prev: this.props.prev }) || this.props.editorial && this.props.type == 'CONTEXT_DEFAULT' && _react2.default.createElement(_contextualDefault2.default, { seen: seen, dateFilter: this.props.dateFilter, typeSlug: this.props.typeSlug, next: this.props.next, prev: this.props.prev, typeId: this.props.typeId, intro: this.props.intro, interviewId: this.props.thisId, enableNews: true, name: this.props.name }) || this.props.editorial && this.props.type == 'CONTEXT_IMAGE' && _react2.default.createElement(_contextualImage2.default, { seen: seen, dateFilter: this.props.dateFilter, typeSlug: this.props.typeSlug, next: this.props.next, prev: this.props.prev, typeId: this.props.typeId, intro: this.props.intro, interviewId: this.props.thisId, enableNews: true, name: this.props.name }) || null;
			}
		}]);
	
		return ContextualMenu;
	}(_react.Component);
	
	ContextualMenu.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualMenu);

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = getCategoryName;
	
	var _types = __webpack_require__(88);
	
	var _lodash = __webpack_require__(35);
	
	function getCategoryName(categories, bestViewedOn) {
		var cat = '';
		var suffix = '';
	
		//console.log(bestViewedOn);
		switch (bestViewedOn) {
			case _types.DEVICE_TABLET_PORTRAIT:
			case _types.DEVICE_TABLET_LANDSCAPE:
				suffix += ' - tablet';
				break;
			case _types.DEVICE_MOBILE_PORTRAIT:
			case _types.DEVICE_MOBILE_LANDSCAPE:
				suffix += ' - mobile';
				break;
		}
	
		if (categories && (0, _lodash.isArray)(categories) && categories.length) {
			cat = categories.slice(0, 1).map(function (item) {
				return item.name + suffix;
			});
		} else if (categories && (typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object') {
			if (categories.name) {
				cat = categories.name + suffix;
			}
		} else if (categories && typeof categories === 'string') {
			cat = categories + suffix;
		}
	
		return cat;
	}

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _routes = __webpack_require__(4);
	
	var _actions = __webpack_require__(13);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.gglAsyncInit = function () {
		window.gapi.load('auth2', function () {
			window.gauth = window.gapi.auth2.init({
				client_id: window.konfig && window.konfig.social && window.konfig.social.gglAppId ? window.konfig.social.gglAppId : '921710696389-ip19ev7u4vuu774cfrtnerh4borj8rou.apps.googleusercontent.com',
				cookiepolicy: 'single_host_origin'
			});
		});
	};
	
	var FBLoader = function () {
		function FBLoader() {
			//this.load();
	
			_classCallCheck(this, FBLoader);
		}
	
		_createClass(FBLoader, [{
			key: 'load',
			value: function load() {
				if (!this.isLoaded()) {
					// Inject google api
					(function (d, s, id) {
						var js,
						    fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s);js.id = id;
						js.src = '//apis.google.com/js/api:client.js?onload=gglAsyncInit';
						fjs.parentNode.insertBefore(js, fjs);
					})(document, 'script', 'google-jssdk');
				}
			}
		}, {
			key: 'isLoaded',
			value: function isLoaded() {
				return _typeof(this.API) === 'object';
			}
		}, {
			key: 'login',
			value: function login(dispatch) {
				return this._GoogleLogin((0, _routes.genericRoute)(false, 'api/account/googlesignin'), dispatch);
			}
		}, {
			key: 'register',
			value: function register(dispatch) {
				return this._GoogleLogin((0, _routes.genericRoute)(false, 'api/account/googlesignup'), dispatch);
			}
		}, {
			key: '_GoogleLogin',
			value: function _GoogleLogin(path, dispatch) {
				if (this.isLoaded()) {
					this.API.signIn({
						scope: 'email'
					}).then(function (googleUser) {
						//console.log(googleUser);
	
						var idToken = googleUser.getAuthResponse().id_token;
	
						_axios2.default.post(path, _qs2.default.stringify({
							idtoken: idToken
						})).then(function (response) {
							//console.log('Signed in as: ' + response.data.user.name);
	
							if (response.data.user) {
								dispatch({
									type: _actions.USERS_LOGIN_GOOGLE,
									payload: response.data
								});
							}
						}).catch(function (response) {
							dispatch((0, _errors.dispatchError)(response.data));
							//console.warn(response);
						});
					}, function (error) {
						dispatch((0, _errors.dispatchError)({
							message: 'Google Auth not completed.'
						}));
						console.warn(error);
					});
				} else {
					this.load();
				}
			}
		}, {
			key: 'API',
			get: function get() {
				return window.gauth;
			}
		}]);
	
		return FBLoader;
	}();
	
	exports.default = FBLoader;
	;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _routes = __webpack_require__(4);
	
	var _redux = __webpack_require__(25);
	
	var _actions = __webpack_require__(13);
	
	var _users = __webpack_require__(64);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TWITTER_AUTH_COMPLETE = 'TWITTER_AUTH_COMPLETE';
	var TWITTER_AUTH_FAILED = 'TWITTER_AUTH_FAILED';
	
	var TwitterAuth = function () {
		function TwitterAuth() {
			_classCallCheck(this, TwitterAuth);
	
			this._receiveMessage = this._receiveMessage.bind(this);
		}
	
		_createClass(TwitterAuth, [{
			key: 'login',
			value: function login(dispatch) {
				return this._TWTLogin((0, _routes.genericRoute)(false, 'api/account/twittersigninurl'), dispatch);
			}
		}, {
			key: 'register',
			value: function register(dispatch) {
				return this._TWTLogin((0, _routes.genericRoute)(false, 'api/account/twittersignupurl'), dispatch);
			}
		}, {
			key: '_TWTLogin',
			value: function _TWTLogin(path, dispatch) {
				var width = 550;var height = 300;
				var top = (window.screen.height - height) / 4;
				var left = (window.screen.width - width) / 2;
				var win = window.open(path, 'twitter-auth', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
				this.dispatch = dispatch;
	
				window.addEventListener('message', this._receiveMessage, false);
			}
		}, {
			key: '_receiveMessage',
			value: function _receiveMessage(event) {
				if (event.data) {
					switch (event.data.result) {
						case TWITTER_AUTH_COMPLETE:
							{
								(0, _redux.bindActionCreators)(_users.getLoginWithErrors, this.dispatch)();
								break;
							}
						case TWITTER_AUTH_FAILED:
						default:
							{
								var msg = event.data.message || 'Twitter Authentication failed.';
								this.dispatch((0, _errors.dispatchError)({ message: msg }));
							}
					}
				}
	
				window.removeEventListener('message', this._receiveMessage);
			}
		}]);
	
		return TwitterAuth;
	}();
	
	exports.default = TwitterAuth;
	;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(10);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(66);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 153 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(67);
	var global = __webpack_require__(15);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(100) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(10);
	var aFunction = __webpack_require__(42);
	var SPECIES = __webpack_require__(23)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	var OrderedMap = Immutable.OrderedMap;
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * 
	 */
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(211);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Title case a string.
	   *
	   * @param  {string} str
	   * @return {string}
	   */
	  function toTitleCase (str) {
	    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
	  }
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Upper cased words. E.g. "HELLO".
	    if (word === word.toUpperCase()) {
	      return token.toUpperCase();
	    }
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return toTitleCase(token);
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {String}   token
	   * @param  {String}   word
	   * @param  {Array}    collection
	   * @return {String}
	   */
	  function sanitizeWord (token, word, collection) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = collection.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = collection[len];
	
	      // If the rule passes, return the replacement.
	      if (rule[0].test(word)) {
	        return word.replace(rule[0], function (match, index, word) {
	          var result = interpolate(rule[1], arguments);
	
	          if (match === '') {
	            return restoreCase(word[index - 1], result);
	          }
	
	          return restoreCase(match, result);
	        });
	      }
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {String}  word
	   * @param  {Number}  count
	   * @param  {Boolean} inclusive
	   * @return {String}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {String} single
	   * @param {String} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['thief', 'thieves'],
	    ['genie', 'genies'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['whiskey', 'whiskies']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
	    [/(^analy)(?:sis|ses)$/i, '$1sis'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/([^aeiouy]|qu)ies$/i, '$1y'],
	    [/(^[pl]|zomb|^(?:neck)?t|[aeo][lt]|cut)ies$/i, '$1ie'],
	    [/(\b(?:mon|smil))ies$/i, '$1ey'],
	    [/(m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
	    [/(e[mn]u)s?$/i, '$1'],
	    [/(movie|twelve)s$/i, '$1'],
	    [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'advice',
	    'agenda',
	    'bison',
	    'bream',
	    'buffalo',
	    'carp',
	    'chassis',
	    'cod',
	    'cooperation',
	    'corps',
	    'digestion',
	    'debris',
	    'diabetes',
	    'energy',
	    'equipment',
	    'elk',
	    'excretion',
	    'expertise',
	    'flounder',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'machinery',
	    'mackerel',
	    'media',
	    'mews',
	    'moose',
	    'news',
	    'pike',
	    'plankton',
	    'pliers',
	    'pollution',
	    'premises',
	    'rain',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'species',
	    'staff',
	    'swine',
	    'trout',
	    'tuna',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    // Regexes.
	    /pox$/i, // "chickpox", "smallpox"
	    /ois$/i,
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /sheep$/i,
	    /measles$/i,
	    /[^aeiou]ese$/i // "chinese", "japanese"
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ },
/* 161 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var clamp = __webpack_require__(905);
	var PropTypes = __webpack_require__(142);
	/**
	 * multuline text-overflow: ellipsis
	 */
	function Dotdotdot() {
	  if(!(this instanceof Dotdotdot)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	Dotdotdot.prototype = Object.create(React.Component.prototype);
	Dotdotdot.prototype.componentDidUpdate = function() {
	  if (this.props.clamp) {
	    this.dotdotdot(ReactDOM.findDOMNode(this.refs.container));
	  }
	};
	
	Dotdotdot.prototype.dotdotdot = function(container) {
	  if (container.length) {
	    throw new Error('Please provide exacly one child to dotdotdot');
	  }
	
	  clamp(container, {
	    clamp: this.props.clamp,
	    truncationChar: this.props.truncationChar,
	    useNativeClamp: this.props.useNativeClamp
	  });
	};
	
	Dotdotdot.prototype.render = function() {
	  return React.createElement(
	    this.props.tagName || "div",
	    { ref: "container", className: this.props.className },
	    this.props.children
	  );
	};
	
	// Statics:
	Dotdotdot.propTypes = {
	  children: PropTypes.node,
	  clamp: PropTypes.oneOfType([
	    PropTypes.string,
	    PropTypes.number,
	    PropTypes.bool
	  ]).isRequired,
	  truncationChar: PropTypes.string,
	  className: PropTypes.string,
	  tagName: PropTypes.string,
	  useNativeClamp: PropTypes.bool
	};
	
	Dotdotdot.defaultProps = {
	  truncationChar: '\u2026',
	  useNativeClamp: true
	};
	
	module.exports = Dotdotdot;


/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(1232)
	  , defined = __webpack_require__(215);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1267);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1268);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(225);
	var EventPluginUtils = __webpack_require__(327);
	var ReactErrorUtils = __webpack_require__(330);
	
	var accumulateInto = __webpack_require__(557);
	var forEachAccumulated = __webpack_require__(558);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : void 0;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[inst._rootNodeID] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[inst._rootNodeID];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][inst._rootNodeID]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventPluginHub = __webpack_require__(167);
	var EventPluginUtils = __webpack_require__(327);
	
	var accumulateInto = __webpack_require__(557);
	var forEachAccumulated = __webpack_require__(558);
	var warning = __webpack_require__(17);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	var getEventTarget = __webpack_require__(337);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchJobs = fetchJobs;
	exports.fetchJob = fetchJob;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/jobs/';
	
	function requestSingleData() {
		return { type: actionTypes.JOBS_REQ_DATA };
	};
	
	function requestSingleData() {
		return { type: actionTypes.JOBS_REQ_DATA_SINGLE };
	};
	
	function receiveData(json) {
		return {
			type: actionTypes.JOBS_RECV_DATA,
			payload: json
		};
	};
	
	function receiveDataSingle(json) {
		return {
			type: actionTypes.JOBS_RECV_DATA_SINGLE,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.JOBS_RECV_ERROR,
			payload: json
		};
	};
	
	function fetchJobs() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];
	
		return function (dispatch) {
			//dispatch(requestData());
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(receiveData(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};
	
	function fetchJob(slug) {
		var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		return function (dispatch) {
			//dispatch(requestSingleData());
			var data = {};
	
			if (preview) {
				data.preview = preview;
			}
	
			return (0, _axios2.default)({
				url: _baseUrl2.default + url + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: data
			}).then(function (response) {
				dispatch(receiveDataSingle(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountCaseCreateStepGeneric = function (_Component) {
		_inherits(AccountCaseCreateStepGeneric, _Component);
	
		function AccountCaseCreateStepGeneric(props) {
			_classCallCheck(this, AccountCaseCreateStepGeneric);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStepGeneric).call(this));
	
			_this.state = {
				hasBeenActive: false
			};
			return _this;
		}
	
		_createClass(AccountCaseCreateStepGeneric, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.active) {
					this.setState(_extends({}, this.state, {
						hasBeenActive: true
					}));
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var _this2 = this;
	
				if (!prevProps.active && this.props.active) {
					(function () {
						var element = _reactDom2.default.findDOMNode(_this2.refs.step);
						if (element && typeof element.getAttribute === 'function') {
							setTimeout(function () {
								var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
								scroller.toElement(element);
							}, 500);
						}
					})();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var stepHeadClass = 'account-process__step-head';
				var stepClass = 'account-process__step';
	
				if (this.props.active) {
					stepClass += ' account-process__step--active';
				}
	
				if (this.props.active || this.state.hasBeenActive) {
					stepHeadClass += ' account-process__step-head--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: 'step' },
					_react2.default.createElement(
						'div',
						{ className: stepHeadClass },
						_react2.default.createElement(
							'div',
							{ className: 'span2 span4-mobile pixel-pattern-overlay pixel-pattern-overlay--01 account-process__step-head__counter' },
							this.props.stepNumber
						),
						_react2.default.createElement(
							'div',
							{ className: 'span12 span10-mobile account-process__step-head__content' },
							_react2.default.createElement(
								_content2.default,
								{ title: this.props.stepTitle, smallAside: true },
								this.props.summary
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: stepClass },
						_react2.default.createElement(
							'div',
							{ className: 'span2 hide-mobile' },
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span12 span14-mobile account-process__step__content' },
							this.props.children
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}]);
	
		return AccountCaseCreateStepGeneric;
	}(_react.Component);
	
	AccountCaseCreateStepGeneric.propTypes = {
		active: _react.PropTypes.bool.isRequired,
		stepTitle: _react.PropTypes.string,
		stepNumber: _react.PropTypes.string,
		summary: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]),
		editLink: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object])
	};
	AccountCaseCreateStepGeneric.defaultProps = {
		active: false,
		stepTitle: '',
		stepNumber: '00',
		summary: false,
		editLink: false
	};
	exports.default = AccountCaseCreateStepGeneric;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountCaseCreateStepGeneric = function (_Component) {
		_inherits(AccountCaseCreateStepGeneric, _Component);
	
		function AccountCaseCreateStepGeneric(props) {
			_classCallCheck(this, AccountCaseCreateStepGeneric);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStepGeneric).call(this));
	
			_this.state = {
				hasBeenActive: false
			};
			return _this;
		}
	
		_createClass(AccountCaseCreateStepGeneric, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.active) {
					this.setState(_extends({}, this.state, {
						hasBeenActive: true
					}));
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var _this2 = this;
	
				if (!prevProps.active && this.props.active) {
					(function () {
						var element = _reactDom2.default.findDOMNode(_this2.refs.step);
						if (element && typeof element.getAttribute === 'function') {
							setTimeout(function () {
								var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
								scroller.toElement(element);
							}, 500);
						}
					})();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var stepHeadClass = 'account-process__step-head';
				var stepClass = 'account-process__step';
	
				if (this.props.active) {
					stepClass += ' account-process__step--active';
				}
	
				if (this.props.active || this.state.hasBeenActive) {
					stepHeadClass += ' account-process__step-head--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: 'step' },
					_react2.default.createElement(
						'div',
						{ className: stepHeadClass },
						_react2.default.createElement(
							'div',
							{ className: 'span2 span4-mobile pixel-pattern-overlay pixel-pattern-overlay--01 account-process__step-head__counter' },
							this.props.stepNumber
						),
						_react2.default.createElement(
							'div',
							{ className: 'span12 span10-mobile account-process__step-head__content' },
							_react2.default.createElement(
								_content2.default,
								{ title: this.props.stepTitle, smallAside: true },
								this.props.summary
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: stepClass },
						_react2.default.createElement(
							'div',
							{ className: 'span2 hide-mobile' },
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span12 span14-mobile account-process__step__content' },
							this.props.children
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}]);
	
		return AccountCaseCreateStepGeneric;
	}(_react.Component);
	
	AccountCaseCreateStepGeneric.propTypes = {
		active: _react.PropTypes.bool.isRequired,
		stepTitle: _react.PropTypes.string,
		stepNumber: _react.PropTypes.string,
		summary: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]),
		editLink: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object])
	};
	AccountCaseCreateStepGeneric.defaultProps = {
		active: false,
		stepTitle: '',
		stepNumber: '00',
		summary: false,
		editLink: false
	};
	exports.default = AccountCaseCreateStepGeneric;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _player = __webpack_require__(97);
	
	var _types = __webpack_require__(88);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JuryEntry = function (_Component) {
		_inherits(JuryEntry, _Component);
	
		function JuryEntry(props) {
			_classCallCheck(this, JuryEntry);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JuryEntry).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				voteSubmitted: false,
				showWarning: false,
				notBroken: false,
				showVideo: false
			};
			return _this;
		}
	
		_createClass(JuryEntry, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var VotingComponent = this.props.component;
				var className = 'account-jury__entry';
				var item = this.props.item;
				var imgSpan = { desktop: 'span4', tablet: 'span5', mobile: 'span12' };
				var caseTypes = item.caseTypes ? item.caseTypes : 'Uncategorized';
	
				var entryHolderClass = 'account-jury__entry-holder';
				if (this.props.hideAfterSubmit && this.state.voteSubmitted) {
					entryHolderClass += ' account-jury__entry-holder--hide';
				}
	
				var bestViewedWarning = '';
				switch (this.props.item.bestViewedOn) {
					case _types.DEVICE_TABLET_PORTRAIT:
					case _types.DEVICE_TABLET_LANDSCAPE:
						bestViewedWarning = _react2.default.createElement(
							'span',
							null,
							'Should be viewed on ',
							_react2.default.createElement(
								'strong',
								null,
								'tablet'
							),
							' before voting'
						);
						break;
					case _types.DEVICE_MOBILE_PORTRAIT:
					case _types.DEVICE_MOBILE_LANDSCAPE:
						bestViewedWarning = _react2.default.createElement(
							'span',
							null,
							'Should be viewed on ',
							_react2.default.createElement(
								'strong',
								null,
								'mobile'
							),
							' before voting'
						);
						break;
				}
	
				var slides = [];
				!!item.slide1 && slides.push(_react2.default.createElement(_image2.default, { key: 'slide1', img: item.slide1, span: imgSpan, alt: '', browser: this.props.browser }));
				!!item.slide2 && slides.push(_react2.default.createElement(_image2.default, { key: 'slide2', img: item.slide2, span: imgSpan, alt: '', browser: this.props.browser }));
				!!item.slide3 && slides.push(_react2.default.createElement(_image2.default, { key: 'slide3', img: item.slide3, span: imgSpan, alt: '', browser: this.props.browser }));
	
				!!item.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { key: 'slide4', url: item.showreelUrl, codaClass: 'slide-coda__item--is-video', skipSlide: true, onClick: function onClick(e) {
						_this2.setState(_extends({}, _this2.state, {
							showVideo: !_this2.state.showVideo
						}));
					} }));
	
				return _react2.default.createElement(
					'div',
					{ className: entryHolderClass },
					_react2.default.createElement(
						'div',
						{ className: className },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span6-tablet span14-mobile account-jury__entry__col1 account-jury__entry__carousel' },
							_react2.default.createElement(
								_carousel2.default,
								{ autoplay: false, sliderClass: 'span4 span5-tablet span12-mobile pixel-pattern pixel-pattern--dark', sliderListClass: 'span4 span5-tablet span12-mobile' },
								slides
							),
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__carousel__overlay span4 span5-tablet span12-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__carousel__overlay__aligner' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.casesRoute)(item.slug), className: 'button button--dark-to-light-anim' },
										'See Case'
									),
									_react2.default.createElement(
										'a',
										{ href: item.url, target: '_blank', className: 'button button--light-to-dark-anim' },
										'Launch Project'
									)
								)
							),
							!!item.showreelUrl && _react2.default.createElement(_player.Player, { browser: this.props.browser, url: item.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
									_this2.setState(_extends({}, _this2.state, { showVideo: false }));
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'span8-tablet span14-mobile account-jury__entry__col2' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__description' },
								_react2.default.createElement(
									'span',
									{ className: 'account-jury__entry__description__cat' },
									caseTypes.name,
									_react2.default.createElement(
										'span',
										{ className: 'account-jury__entry__description__cat__devicewarn' },
										bestViewedWarning
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__description__content' },
									_react2.default.createElement(
										'h2',
										{ className: 'account-jury__entry__description__content__title' },
										item.title
									),
									_react2.default.createElement(
										'p',
										{ className: 'account-jury__entry__description__content__excerpt' },
										item.description
									)
								)
							)
						),
						VotingComponent && _react2.default.createElement(VotingComponent, {
							item: item,
							path: this.props.path,
							selected: this.props.selected,
							browser: this.props.browser,
							onSubmit: this.onSubmit.bind(this),
							onChangeVote: this.onChangeVote.bind(this),
							data: this.props.data,
							waiting: this.props.waiting
						})
					),
					_react2.default.createElement(_splitter2.default, null)
				);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this3 = this;
	
				promise.then(function (res) {
					res.data && res.data.message && _this3.props.dispatch((0, _errors.dispatchMsg)(res.data));
	
					_this3.mounted && _this3.setState(_extends({}, _this3.state, {
						voteSubmitted: true
					}));
	
					_this3.props.onSubmit && _this3.props.onSubmit(res);
	
					if (_this3.props.hideAfterSubmit && _this3.props.removeItemCB) {
						setTimeout(function () {
							_this3.props.removeItemCB(_this3.props.item);
						}, 500);
					}
				}).catch(function (res) {
					res.data && res.data.message && _this3.props.dispatch((0, _errors.dispatchError)(res.data));
				});
			}
		}, {
			key: 'onChangeVote',
			value: function onChangeVote(val) {
				return this.props.onChangeVote(val);
			}
		}]);
	
		return JuryEntry;
	}(_react.Component);
	
	JuryEntry.propTypes = {
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired,
		component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.oneOf([false])]).isRequired,
		onChangeVote: _react.PropTypes.func.isRequired,
		path: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.oneOf([false])]).isRequired,
		onSubmit: _react.PropTypes.oneOfType([_react.PropTypes.func.isRequired, _react.PropTypes.oneOf([false])]).isRequired,
		hideAfterSubmit: _react.PropTypes.bool.isRequired,
		data: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.oneOf([false])])
	};
	JuryEntry.defaultProps = {
		hideAfterSubmit: false,
		selected: false,
		path: false,
		onSubmit: false,
		onChangeVote: function onChangeVote() {}
	};
	exports.default = JuryEntry;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _authorization = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JuryNav = function (_Component) {
		_inherits(JuryNav, _Component);
	
		function JuryNav() {
			_classCallCheck(this, JuryNav);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(JuryNav).apply(this, arguments));
		}
	
		_createClass(JuryNav, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'ol',
					{ className: 'account-jury__subhead__navigation' },
					this.props.users.canHas([_authorization.ROLE_JUDGE_FOTD]) && _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/jury/fotd'), activeClassName: 'active' },
							'FOTD'
						)
					),
					this.props.users.canHas([_authorization.ROLE_JUDGE_FOTM]) && _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/jury/fotm'), activeClassName: 'active' },
							'FOTM'
						)
					),
					this.props.users.canHas([_authorization.ROLE_JUDGE_FOTY]) && _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/jury/foty'), activeClassName: 'active' },
							'FOTY'
						)
					),
					this.props.users.canHas([_authorization.ROLE_JUDGE_TCEA]) && _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/jury/tcea'), activeClassName: 'active' },
							'TCEA'
						)
					)
				);
			}
		}]);
	
		return JuryNav;
	}(_react.Component);
	
	exports.default = JuryNav;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JurySticky = function (_Component) {
		_inherits(JurySticky, _Component);
	
		function JurySticky(props) {
			_classCallCheck(this, JurySticky);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JurySticky).call(this, props));
	
			_this.mounted = true;
			_this.scrollHandler = _this.scrollHandler.bind(_this);
	
			_this.state = {
				isSticky: false,
				stickAtPos: 0,
				stickyHeight: 0,
				headerHeight: 0
			};
			return _this;
		}
	
		_createClass(JurySticky, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.browser) {
					this.props.browser.scroll.register(this.scrollHandler);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateDimensions();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
	
				if (this.props.browser) {
					this.props.browser.scroll.deregister(this.scrollHandler);
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.update !== this.props.update || nextState !== this.state;
			}
		}, {
			key: 'render',
			value: function render() {
				var stickyClass = this.props.className;
				var className = ' stickifier span14';
	
				var stickyStyle = {};
				var placeholderStyle = {};
	
				if (this.state.isSticky) {
					placeholderStyle.height = this.state.stickyHeight;
	
					stickyStyle.position = 'fixed';
					stickyStyle.top = this.state.headerHeight;
					stickyStyle.height = this.state.stickyHeight;
					stickyStyle.zIndex = 100;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement('div', { style: placeholderStyle }),
					_react2.default.createElement(
						'div',
						{ style: stickyStyle, className: stickyClass, ref: 'stickyElement' },
						this.props.children
					)
				);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var _this2 = this;
	
				var headerHeight = document.querySelector('.header-main').offsetHeight;
				var mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
				var distanceToMenu = mainOffsetTop - headerHeight ? mainOffsetTop - headerHeight : 9999;
	
				var stickyHeight = this.refs.stickyElement ? this.refs.stickyElement.offsetHeight : 0;
	
				if (distanceToMenu === 9999) {
					setTimeout(function () {
						_this2.updateDimensions();
					}, 200);
				}
	
				this.mounted && this.setState(_extends({}, this.state, {
					stickAtPos: distanceToMenu,
					stickyHeight: stickyHeight,
					headerHeight: headerHeight
				}));
			}
		}, {
			key: 'scrollHandler',
			value: function scrollHandler(e) {
				if (e.scrollY === this.prevSrollY) {
					return false; // noop
				} else {
					this.prevSrollY = e.scrollY;
				}
	
				var isMobile = this.props.browser.window.width <= 719;
				var isSticky = e.scrollY >= this.state.stickAtPos && !isMobile;
	
				if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
					return this.updateDimensions();
				}
	
				// stop setting state if not necessary
				if (this.state.isSticky === isSticky) {
					return false; // noop
				}
	
				this.setState(_extends({}, this.state, {
					isSticky: isSticky
				}));
			}
		}]);
	
		return JurySticky;
	}(_react.Component);
	
	JurySticky.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		children: _react.PropTypes.any,
		className: _react.PropTypes.string
	};
	JurySticky.defaultProps = {
		className: ''
	};
	exports.default = JurySticky;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AccountJuryMediaTitle = exports.AccountJuryOther = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _juryEntry = __webpack_require__(173);
	
	var _juryEntry2 = _interopRequireDefault(_juryEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountJuryOther = exports.AccountJuryOther = function (_Component) {
		_inherits(AccountJuryOther, _Component);
	
		function AccountJuryOther() {
			_classCallCheck(this, AccountJuryOther);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryOther).apply(this, arguments));
		}
	
		_createClass(AccountJuryOther, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var cases = [];
	
				for (var i = 0; i < this.props.allCases.length; i++) {
					if (this.props.cases.indexOf(this.props.allCases[i]) === -1) {
						cases.push(this.props.allCases[i]);
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						_content2.default,
						{ style: { marginTop: '1px' } },
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__juryhead' },
							'Other projects',
							_react2.default.createElement(
								'div',
								{ className: 'account-block-content__juryhead__sub' },
								'–view on desktop to vote'
							)
						)
					),
					cases.map(function (item, i) {
						return _react2.default.createElement(_juryEntry2.default, {
							key: item.id,
							item: item,
							browser: _this2.props.browser,
							dispatch: _this2.props.dispatch,
							component: false });
					})
				);
			}
		}]);
	
		return AccountJuryOther;
	}(_react.Component);
	
	var AccountJuryMediaTitle = exports.AccountJuryMediaTitle = function (_Component2) {
		_inherits(AccountJuryMediaTitle, _Component2);
	
		function AccountJuryMediaTitle() {
			_classCallCheck(this, AccountJuryMediaTitle);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryMediaTitle).apply(this, arguments));
		}
	
		_createClass(AccountJuryMediaTitle, [{
			key: 'render',
			value: function render() {
				var media = this.props.browser.window.width < 720 ? 'Mobile' : 'Tablet';
				var title = media + ' projects (' + this.props.caseCount + ')';
	
				return _react2.default.createElement(
					_content2.default,
					null,
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content__juryhead' },
						title,
						_react2.default.createElement('div', { className: 'account-block-content__juryhead__sub' })
					)
				);
			}
		}]);
	
		return AccountJuryMediaTitle;
	}(_react.Component);
	
	AccountJuryMediaTitle.defaultProps = {
		caseCount: 0
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cornerLabel = __webpack_require__(992);
	
	var _cornerLabel2 = _interopRequireDefault(_cornerLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CornerLabel = function (_Component) {
		_inherits(CornerLabel, _Component);
	
		function CornerLabel() {
			_classCallCheck(this, CornerLabel);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(CornerLabel).apply(this, arguments));
		}
	
		_createClass(CornerLabel, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'header',
					{ className: 'block-label--absolute' },
					this.props.name
				);
			}
		}]);
	
		return CornerLabel;
	}(_react.Component);
	
	CornerLabel.propTypes = {
		name: _react.PropTypes.string.isRequired
	};
	exports.default = CornerLabel;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countdown = __webpack_require__(996);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Countdown = function (_Component) {
		_inherits(Countdown, _Component);
	
		function Countdown(props) {
			_classCallCheck(this, Countdown);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Countdown).call(this, props));
	
			_this.timeInterval = false;
	
			_this.state = {
				timeLeft: 0
			};
			return _this;
		}
	
		_createClass(Countdown, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				this.state.timeLeft = this.props.timeLeft || new Date().getTime();
	
				this.timeInterval = setInterval(function () {
					if (_this2.state.timeLeft == 0) {
						_this2.setState(_extends({}, _this2.state, {
							timeLeft: _this2.state.timeLeft
						}));
					} else {
						_this2.setState(_extends({}, _this2.state, {
							timeLeft: _this2.state.timeLeft - 1
						}));
					}
				}, 1000);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.timeLeft !== this.props.timeLeft) {
					this.setState(_extends({}, this.state, {
						timeLeft: nextProps.timeLeft || new Date().getTime()
					}));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.timeInterval);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState.timeLeft !== this.state.timeLeft;
			}
		}, {
			key: 'render',
			value: function render() {
				var day = this.getDaysLeft(this.state.timeLeft);
				var hrs = this.getHoursLeft(this.state.timeLeft);
				var min = this.getMinutesLeft(this.state.timeLeft);
				var sec = this.getSecondsLeft(this.state.timeLeft);
	
				return _react2.default.createElement(
					'div',
					{ className: 'countdown ' + this.props.spans },
					_react2.default.createElement(
						'span',
						{ className: 'countdown__name' },
						_react2.default.createElement(
							'span',
							{ className: 'countdown__name__day' + (day === 0 ? ' countdown__name__day--expendable' : '') },
							this.formatNumber(day, 'D')
						),
						_react2.default.createElement(
							'span',
							{ className: 'countdown__name__hrs' },
							this.formatNumber(hrs, 'H')
						),
						_react2.default.createElement(
							'span',
							{ className: 'countdown__name__min' },
							this.formatNumber(min, 'M')
						),
						_react2.default.createElement(
							'span',
							{ className: 'countdown__name__sec' },
							this.formatNumber(sec, 'S')
						)
					)
				);
			}
		}, {
			key: 'getDaysLeft',
			value: function getDaysLeft(timeLeft) {
				var days = Math.floor(timeLeft / 86400);
				return days;
			}
		}, {
			key: 'getHoursLeft',
			value: function getHoursLeft(timeLeft) {
				var hoursLeft = timeLeft % 86400; // (60*60*24)
				var hours = Math.floor(hoursLeft / 3600) % 24;
				return hours;
			}
		}, {
			key: 'getMinutesLeft',
			value: function getMinutesLeft(timeLeft) {
				var minutesLeft = timeLeft % 86400 % 3600; // (60*60)
				var minutes = Math.floor(minutesLeft / 60) % 60;
				return minutes;
			}
		}, {
			key: 'getSecondsLeft',
			value: function getSecondsLeft(timeLeft) {
				var secondsLeft = timeLeft % 86400 % 3600 % 60;
				var seconds = Math.floor(secondsLeft);
				return seconds;
			}
		}, {
			key: 'formatNumber',
			value: function formatNumber(number, letter) {
				var numberString = Math.max(number, 0).toString();
				if (numberString.length < 2) {
					numberString = '0' + numberString;
				}
	
				return numberString + letter + ' ';
			}
		}]);
	
		return Countdown;
	}(_react.Component);
	
	Countdown.propTypes = {
		timeLeft: _react.PropTypes.number.isRequired,
		spans: _react.PropTypes.string
	};
	Countdown.defaultProps = {
		spans: ''
	};
	exports.default = Countdown;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(35);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _reactRouter = __webpack_require__(3);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _tagselect = __webpack_require__(1011);
	
	var _tagselect2 = _interopRequireDefault(_tagselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { VALIDATE_URL } from '../validate';
	// import searchIcon from './icon-search.png';
	
	var InputTagSelect = function (_Component) {
		_inherits(InputTagSelect, _Component);
	
		function InputTagSelect(props) {
			_classCallCheck(this, InputTagSelect);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputTagSelect).call(this, props));
	
			_this.DEBUG = true;
	
			_this.value = JSON.parse(props.value);
	
			_this.search = (0, _lodash.debounce)(_this.search.bind(_this), 500);
	
			_this.state = {
				waiting: false,
				value: _this.value,
				results: [],
				showResults: false,
				inputValue: ''
			};
			return _this;
		}
	
		_createClass(InputTagSelect, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate() {
				return true;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var regex = new RegExp('^(.*?)(' + this.state.inputValue.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') + ')(.*?)$', 'i');
				var results = [];
	
				var mainClass = 'span3 span5-tablet span11-mobile form-tagselect';
				var taglistClass = 'form-tagselect__taglist';
				var tagsearchClass = 'form-tagselect__tagsearch';
				var tagresultClass = 'form-tagselect__tagresult';
				var tagresultItemClass = 'form-tagselect__tagresult__item';
				var resultLength = this.state.results.length;
	
				if (this.state.showResults && this.props.link && this.props.showLink) {
					resultLength++;
				}
	
				if (this.props.createEnabled) {
					resultLength++;
				}
	
				var tagResultStyles = {
					height: (this.state.showResults ? resultLength * 41 + 1 : 0) + 'px'
				};
	
				if (this.props.mainClass) {
					mainClass += ' ' + this.props.mainClass;
				}
	
				(0, _lodash.each)(this.state.results, function (obj) {
					if (regex.test(obj.name)) {
						var newObj = _extends({}, obj);
						newObj.parts = regex.exec(obj.name);
						results.push(newObj);
					}
				});
	
				return _react2.default.createElement(
					'div',
					{ className: mainClass },
					_react2.default.createElement(
						'ol',
						{ className: taglistClass + ' ' + (this.state.value.length ? taglistClass + '--active ' : '') },
						this.state.value.map(function (item) {
							return _react2.default.createElement(InputTagSelectItem, {
								key: item.id || item.fid,
								'delete': function _delete(obj) {
									return _this2.delete(obj);
								},
								item: item,
								canDelete: _this2.props.canDelete
							});
						})
					),
					_react2.default.createElement(
						'div',
						{ className: tagsearchClass },
						this.state.waiting && _react2.default.createElement(_spinner2.default, { className: tagsearchClass + '__waiting', size: '18px' }),
						_react2.default.createElement('input', {
							type: 'text',
							ref: 'input',
							value: this.state.inputValue,
							placeholder: this.props.placeholder,
							className: tagsearchClass + '__input ' + (this.state.showResults ? tagsearchClass + '__input--search-active' : ''),
							disabled: !(!this.props.maxSelected || this.state.value.length < this.props.maxSelected),
							onInput: function onInput(e) {
								return _this2.inputChange(e);
							},
							onFocus: function onFocus() {
								return _this2.showResult();
							}
						}),
						this.state.showResults && _react2.default.createElement('div', { className: tagresultClass + '__dimmer', onClick: function onClick() {
								return _this2.hideResults();
							} }),
						_react2.default.createElement(
							'div',
							{ className: tagresultClass + ' ' + (this.state.showResults ? tagresultClass + '--active' : ''), style: tagResultStyles },
							_react2.default.createElement(
								'ol',
								{ className: tagresultClass + '__list' },
								results.map(function (item, i) {
									return _react2.default.createElement(
										'li',
										{ key: i, className: tagresultItemClass, onClick: function onClick() {
												return _this2.add(item);
											} },
										_react2.default.createElement(
											'span',
											null,
											item.parts[1]
										),
										_react2.default.createElement(
											'span',
											{ className: 'highlight' },
											item.parts[2]
										),
										_react2.default.createElement(
											'span',
											null,
											item.parts[3]
										)
									);
								}),
								!!this.props.createEnabled && _react2.default.createElement(
									'li',
									{ className: tagresultItemClass + ' pixel-pattern' },
									_react2.default.createElement(
										'a',
										{ href: '#', onClick: function onClick() {
												return _this2.createEntry();
											} },
										this.props.createEnabled,
										_react2.default.createElement('div', { className: 'icon-plus' })
									)
								),
								!!this.props.link && this.props.showLink && _react2.default.createElement(
									'li',
									{ className: tagresultItemClass + ' pixel-pattern' },
									_react2.default.createElement(
										_reactRouter.Link,
										{
											to: this.props.link.url,
											target: '_blank', onClick: function onClick(e) {
												_this2.props.link.onClick && _this2.props.link.onClick(e, _this2.state.inputValue, function () {
													for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
														args[_key] = arguments[_key];
													}
	
													return _this2.createEntry.apply(_this2, args);
												});
												_this2.hideResults();
											}
										},
										this.props.link.text,
										_react2.default.createElement('div', { className: 'icon-plus' })
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'createEntry',
			value: function createEntry() {
				var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
				var item = _extends({
					id: false,
					fid: (0, _lodash.uniqueId)('t')
				}, data, {
					name: this.state.inputValue
				});
	
				this.add(item);
			}
		}, {
			key: 'inputChange',
			value: function inputChange(e) {
				this.setState(_extends({}, this.state, {
					waiting: true,
					inputValue: e.target.value
				}));
	
				this.search();
			}
		}, {
			key: 'showResult',
			value: function showResult() {
				if (this.state.inputValue) {
					this.setState(_extends({}, this.state, {
						showResults: true
					}));
				}
			}
		}, {
			key: 'hideResults',
			value: function hideResults() {
				this.setState(_extends({}, this.state, {
					showResults: false
				}));
			}
		}, {
			key: 'search',
			value: function search() {
				var _this3 = this;
	
				var handleResult = function handleResult(result) {
					var newResult = (0, _lodash.remove)(result, function (item) {
						for (var i = 0; i < _this3.state.value.length; i++) {
							if (_this3.state.value[i].id === item.id) {
								return false;
							}
						}
						return true;
					});
					_this3.setState(_extends({}, _this3.state, {
						waiting: false,
						showResults: !!newResult.length || !!_this3.props.link,
						results: !!newResult.length ? newResult : _this3.state.results
					}));
				};
	
				this.searchApi(this.state.inputValue).then(function (result) {
					return handleResult(result);
				}).catch(function (result) {
					return handleResult(result);
				});
			}
		}, {
			key: 'delete',
			value: function _delete(item) {
				var newValue = [].concat(_toConsumableArray(this.state.value));
				(0, _lodash.remove)(newValue, function (o) {
					return item.id && item.id === o.id || item.fid && item.fid === o.fid;
				});
	
				this.setState(_extends({}, this.state, {
					value: newValue
				}));
	
				this.onChange(newValue);
			}
		}, {
			key: 'add',
			value: function add(item) {
				var newValue = (0, _lodash.unionWith)(this.state.value, [item], _lodash.isEqual);
	
				this.setState(_extends({}, this.state, {
					value: newValue,
					showResults: false,
					inputValue: ''
				}));
	
				this.onChange(newValue);
			}
		}, {
			key: 'onChange',
			value: function onChange(value) {
				var cleanValue = [];
	
				// make a new array with only the needed values
				// used for serializing the form later, so we want it clean
				for (var i = 0; i < value.length; i++) {
					cleanValue[i] = {};
					var keys = Object.keys(value[i]);
					for (var k = 0; k < keys.length; k++) {
						var key = keys[k];
						if (key === 'id' || key === 'name' || key === 'myProfile') {
							cleanValue[i][key] = value[i][key];
						}
					}
				}
	
				this.value = cleanValue;
				this.props.onChange({ value: cleanValue });
			}
		}, {
			key: 'searchApi',
			value: function searchApi(query) {
				var _this4 = this;
	
				var results = [];
	
				return new Promise(function (resolve, reject) {
					if (!query.length) {
						reject(results);
					}
	
					_axios2.default.get(_baseUrl2.default + _this4.props.path, {
						params: {
							q: query,
							limit: 8
						}
					}).then(function (response) {
						if (response.data && response.data.result && response.data.result.length) {
							results = response.data.result;
						}
	
						resolve(results);
					}).catch(function () {
						reject(results);
					});
				});
			}
		}]);
	
		return InputTagSelect;
	}(_react.Component);
	
	InputTagSelect.propTypes = {
		value: _react.PropTypes.string.isRequired,
		placeholder: _react.PropTypes.string,
		path: _react.PropTypes.string,
		maxSelected: _react.PropTypes.number.isRequired,
		canDelete: _react.PropTypes.bool.isRequired,
		onChange: _react.PropTypes.func.isRequired,
		link: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.shape({
			url: _react.PropTypes.string.isRequired,
			text: _react.PropTypes.string.isRequired
		})]),
		mainClass: _react.PropTypes.string,
		showLink: _react.PropTypes.bool,
		createEnabled: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.string]).isRequired
	};
	InputTagSelect.defaultProps = {
		value: '[]',
		placeholder: '',
		maxSelected: 0,
		canDelete: true,
		link: false,
		showLink: false,
		onChange: function onChange() {},
		createEnabled: false
	};
	exports.default = InputTagSelect;
	
	var InputTagSelectItem = function (_Component2) {
		_inherits(InputTagSelectItem, _Component2);
	
		function InputTagSelectItem() {
			_classCallCheck(this, InputTagSelectItem);
	
			var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(InputTagSelectItem).call(this));
	
			_this5.timer = 0;
	
			_this5.state = {
				animateIn: true,
				animateOut: false
			};
			return _this5;
		}
	
		_createClass(InputTagSelectItem, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate() {
				return true;
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearTimeout(this.timer);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				var mainClass = 'form-tagselect__taglist__item';
				var innerClass = 'form-tagselect__taglist__item-inner';
	
				if (this.props.mainClass) {
					mainClass += ' ' + this.props.mainClass;
				}
	
				if (this.state.animateIn) {
					this.timer = setTimeout(function () {
						_this6.setState(_extends({}, _this6.state, {
							animateIn: false
						}));
					}, 10);
				}
	
				if (!this.props.canDelete) {
					innerClass += ' form-tagselect__taglist__item-inner--no-delete';
				}
	
				return _react2.default.createElement(
					'li',
					{ className: mainClass + (!this.state.animateIn && !this.state.animateOut ? ' form-tagselect__taglist__item--show' : ''), onClick: function onClick() {
							return _this6.delete();
						} },
					_react2.default.createElement(
						'div',
						{ className: innerClass },
						this.props.item.name,
						this.props.item.fid && _react2.default.createElement(
							'span',
							{ className: 'form-tagselect__taglist__capsule' },
							this.props.item.myProfile ? 'New Profile' : 'New Credit'
						)
					)
				);
			}
		}, {
			key: 'delete',
			value: function _delete() {
				var _this7 = this;
	
				if (!this.props.canDelete) {
					return false;
				}
	
				if (typeof this.props.item.onDelete === 'function') {
					this.props.item.onDelete();
				}
	
				this.setState(_extends({}, this.state, {
					animateOut: true
				}));
	
				setTimeout(function () {
					_this7.props.delete(_this7.props.item);
				}, 300);
	
				return true;
			}
		}]);
	
		return InputTagSelectItem;
	}(_react.Component);
	
	InputTagSelectItem.propTypes = {
		item: _react.PropTypes.object.isRequired,
		delete: _react.PropTypes.func.isRequired,
		canDelete: _react.PropTypes.bool.isRequired,
		mainClass: _react.PropTypes.string
	};
	InputTagSelectItem.defaultProps = {
		canDelete: true,
		mainClass: '',
		delete: function _delete() {}
	
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tooltip = __webpack_require__(1036);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltip = function (_Component) {
		_inherits(Tooltip, _Component);
	
		function Tooltip(props) {
			_classCallCheck(this, Tooltip);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tooltip).call(this));
	
			_this.setActive = _this.setActive.bind(_this);
			_this.setInactive = _this.setInactive.bind(_this);
			_this.toggleActive = _this.toggleActive.bind(_this);
	
			_this.state = {
				active: false,
				fading: false
			};
			return _this;
		}
	
		_createClass(Tooltip, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var attachElement = this.props.attachTo();
				this.addListener(attachElement);
				this.addListener(this.refs.tooltip);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var attachElement = this.props.attachTo();
				this.removeListener(attachElement);
				this.removeListener(this.refs.tooltip);
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps) {}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {}
		}, {
			key: 'render',
			value: function render() {
				var styles = {};
				var attachElement = this.props.attachTo();
				var tooltipOffsetTop = 0;
				var className = 'tooltip';
	
				if (attachElement) {
					tooltipOffsetTop = attachElement.offsetTop + attachElement.offsetHeight;
	
					if (this.props.closer) {
						tooltipOffsetTop -= 10;
					}
	
					styles.top = tooltipOffsetTop + 'px';
					styles.left = attachElement.offsetLeft + 'px';
				}
	
				if (this.props.height) {
					styles.height = parseInt(this.props.height, 10) + 'px';
				}
	
				if (this.props.width) {
					var width = parseInt(this.props.width, 10);
					var maxWidth = this.getMaxWidth();
					styles.width = (width > maxWidth ? maxWidth : width) + 'px';
				}
	
				if (this.state.active) {
					className += ' tooltip--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className, style: styles, ref: 'tooltip' },
					this.props.children
				);
			}
		}, {
			key: 'addListener',
			value: function addListener(element) {
				if (element && typeof element.addEventListener === 'function') {
					element.addEventListener('mouseenter', this.setActive);
					element.addEventListener('mouseleave', this.setInactive);
					element.addEventListener('click', this.toggleActive);
				}
			}
		}, {
			key: 'removeListener',
			value: function removeListener(element) {
				if (element && typeof element.removeEventListener === 'function') {
					element.removeEventListener('mouseenter', this.setActive);
					element.removeEventListener('mouseleave', this.setInactive);
					element.removeEventListener('click', this.toggleActive);
				}
			}
		}, {
			key: 'setActive',
			value: function setActive() {
				this.state.active = true;
				this.setState(this.state);
			}
		}, {
			key: 'setInactive',
			value: function setInactive() {
				this.state.active = false;
				this.setState(this.state);
			}
		}, {
			key: 'toggleActive',
			value: function toggleActive() {
				this.state.active = !this.state.active;
				this.setState(this.state);
			}
		}, {
			key: 'getMaxWidth',
			value: function getMaxWidth() {
				if (document.documentElement && document.documentElement.clientHeight) {
					return document.documentElement.clientWidth - 40;
				}
	
				if (document.body) {
					return document.body.clientWidth - 40;
				}
	
				return 0;
			}
		}]);
	
		return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
		attachTo: _react.PropTypes.func.isRequired,
		height: _react.PropTypes.number,
		width: _react.PropTypes.number
	};
	Tooltip.defaultProps = {
		height: 0,
		width: 260
	};
	exports.default = Tooltip;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(56);
	var toLength = __webpack_require__(26);
	var toAbsoluteIndex = __webpack_require__(117);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(48);
	var redefineAll = __webpack_require__(115);
	var meta = __webpack_require__(101);
	var forOf = __webpack_require__(110);
	var anInstance = __webpack_require__(109);
	var isObject = __webpack_require__(20);
	var fails = __webpack_require__(19);
	var $iterDetect = __webpack_require__(186);
	var setToStringTag = __webpack_require__(136);
	var inheritIfRequired = __webpack_require__(250);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(415);
	var redefine = __webpack_require__(48);
	var hide = __webpack_require__(47);
	var fails = __webpack_require__(19);
	var defined = __webpack_require__(80);
	var wks = __webpack_require__(23);
	var regexpExec = __webpack_require__(258);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(66);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(20);
	var cof = __webpack_require__(66);
	var MATCH = __webpack_require__(23)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(23)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(100) || !__webpack_require__(19)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(15)[K];
	});


/***/ },
/* 188 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(134);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(42);
	var ctx = __webpack_require__(68);
	var forOf = __webpack_require__(110);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(70);
	var defined = __webpack_require__(80);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(47);
	var uid = __webpack_require__(118);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(920);
	var BlockMapBuilder = __webpack_require__(156);
	var CharacterMetadata = __webpack_require__(71);
	var CompositeDraftDecorator = __webpack_require__(921);
	var ContentBlock = __webpack_require__(121);
	var ContentState = __webpack_require__(272);
	var DefaultDraftBlockRenderMap = __webpack_require__(273);
	var DefaultDraftInlineStyle = __webpack_require__(427);
	var DraftEditor = __webpack_require__(923);
	var DraftEditorBlock = __webpack_require__(428);
	var DraftModifier = __webpack_require__(45);
	var DraftEntity = __webpack_require__(91);
	var DraftEntityInstance = __webpack_require__(429);
	var EditorState = __webpack_require__(21);
	var KeyBindingUtil = __webpack_require__(274);
	var RichTextEditorUtil = __webpack_require__(934);
	var SelectionState = __webpack_require__(138);
	
	var convertFromDraftStateToRaw = __webpack_require__(939);
	var convertFromHTMLToContentBlocks = __webpack_require__(432);
	var convertFromRawToDraftState = __webpack_require__(940);
	var generateRandomKey = __webpack_require__(83);
	var getDefaultKeyBinding = __webpack_require__(433);
	var getVisibleSelectionRect = __webpack_require__(963);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * 
	 */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER);
	
	    var _offsetKey$split2 = _slicedToArray(_offsetKey$split, 3);
	
	    var blockKey = _offsetKey$split2[0];
	    var decoratorKey = _offsetKey$split2[1];
	    var leafKey = _offsetKey$split2[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * 
	 */
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	'use strict';
	
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var generateRandomKey = __webpack_require__(83);
	var removeEntitiesAtEdges = __webpack_require__(444);
	
	function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  var slice = blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var newKey = generateRandomKey();
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        key: newKey,
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block.set('key', newKey);
	  });
	
	  return slice.toOrderedMap();
	}
	
	module.exports = getContentStateFragment;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1215);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(123);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1173),
	    listCacheDelete = __webpack_require__(1174),
	    listCacheGet = __webpack_require__(1175),
	    listCacheHas = __webpack_require__(1176),
	    listCacheSet = __webpack_require__(1177);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(1194);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1170);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(72),
	    isSymbol = __webpack_require__(211);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(1157),
	    isFunction = __webpack_require__(300),
	    isLength = __webpack_require__(210);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 210 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)))

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"));
		else
			root["Dropzone"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _attrAccept = __webpack_require__(1);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropzone).call(this, props, context));
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		
		    _this.state = {
		      isDragActive: false
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.enterCounter = 0;
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(e) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(e) {
		      e.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      ++this.enterCounter;
		
		      // This is tricky. During the drag even the dataTransfer.files is null
		      // But Chrome implements some drag store, which is accesible via dataTransfer.items
		      var dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];
		
		      // Now we need to convert the DataTransferList to Array
		      var allFilesAccepted = this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));
		
		      this.setState({
		        isDragActive: allFilesAccepted,
		        isDragReject: !allFilesAccepted
		      });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(e) {
		      e.preventDefault();
		      e.stopPropagation();
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(e) {
		      e.preventDefault();
		
		      // Only deactivate once the dropzone and all children was left.
		      if (--this.enterCounter > 0) {
		        return;
		      }
		
		      this.setState({
		        isDragActive: false,
		        isDragReject: false
		      });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, e);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(e) {
		      e.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.enterCounter = 0;
		
		      this.setState({
		        isDragActive: false,
		        isDragReject: false
		      });
		
		      var droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
		      var max = this.props.multiple ? droppedFiles.length : Math.min(droppedFiles.length, 1);
		      var files = [];
		
		      for (var i = 0; i < max; i++) {
		        var file = droppedFiles[i];
		        // We might want to disable the preview creation to support big files
		        if (!this.props.disablePreview) {
		          file.preview = window.URL.createObjectURL(file);
		        }
		        files.push(file);
		      }
		
		      if (this.allFilesAccepted(files)) {
		        if (this.props.onDrop) {
		          this.props.onDrop.call(this, files, e);
		        }
		
		        if (this.props.onDropAccepted) {
		          this.props.onDropAccepted.call(this, files, e);
		        }
		      } else {
		        if (this.props.onDropRejected) {
		          this.props.onDropRejected.call(this, files, e);
		        }
		      }
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick() {
		      if (!this.props.disableClick) {
		        this.open();
		      }
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this2 = this;
		
		      return files.every(function (file) {
		        return (0, _attrAccept2.default)(file, _this2.props.accept);
		      });
		    }
		  }, {
		    key: 'open',
		    value: function open() {
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this3 = this;
		
		      var _props = this.props;
		      var accept = _props.accept;
		      var activeClassName = _props.activeClassName;
		      var inputProps = _props.inputProps;
		      var multiple = _props.multiple;
		      var name = _props.name;
		      var rejectClassName = _props.rejectClassName;
		
		      var rest = _objectWithoutProperties(_props, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);
		
		      var activeStyle = // eslint-disable-line prefer-const
		      rest.activeStyle;
		      var className = rest.className;
		      var rejectStyle = rest.rejectStyle;
		      var style = rest.style;
		
		      var props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var _state = this.state;
		      var isDragActive = _state.isDragActive;
		      var isDragReject = _state.isDragReject;
		
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          backgroundColor: '#ffdddd'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: function ref(el) {
		          return _this3.fileInputEl = el;
		        }, // eslint-disable-line
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, props /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop
		        }),
		        this.props.children,
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.defaultProps = {
		  disablePreview: false,
		  disableClick: false,
		  multiple: true
		};
		
		Dropzone.propTypes = {
		  // Overriding drop behavior
		  onDrop: _react2.default.PropTypes.func,
		  onDropAccepted: _react2.default.PropTypes.func,
		  onDropRejected: _react2.default.PropTypes.func,
		
		  // Overriding drag behavior
		  onDragStart: _react2.default.PropTypes.func,
		  onDragEnter: _react2.default.PropTypes.func,
		  onDragLeave: _react2.default.PropTypes.func,
		
		  children: _react2.default.PropTypes.node, // Contents of the dropzone
		  style: _react2.default.PropTypes.object, // CSS styles to apply
		  activeStyle: _react2.default.PropTypes.object, // CSS styles to apply when drop will be accepted
		  rejectStyle: _react2.default.PropTypes.object, // CSS styles to apply when drop will be rejected
		  className: _react2.default.PropTypes.string, // Optional className
		  activeClassName: _react2.default.PropTypes.string, // className for accepted state
		  rejectClassName: _react2.default.PropTypes.string, // className for rejected state
		
		  disablePreview: _react2.default.PropTypes.bool, // Enable/disable preview generation
		  disableClick: _react2.default.PropTypes.bool, // Disallow clicking on the dropzone container to open file dialog
		
		  inputProps: _react2.default.PropTypes.object, // Pass additional attributes to the <input type="file"/> tag
		  multiple: _react2.default.PropTypes.bool, // Allow dropping multiple files
		  accept: _react2.default.PropTypes.string, // Allow specific types of files. See https://github.com/okonet/attr-accept for more information
		  name: _react2.default.PropTypes.string // name attribute for the input tag
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,d,y=t&s.G,h=t&s.P,v=y?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=y?o:o[n]||(o[n]={});y&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],d=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,d),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1227);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 215 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(163)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 217 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(59).setDesc
	  , has = __webpack_require__(217)
	  , TAG = __webpack_require__(61)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 219 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _props = __webpack_require__(525);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_READY_EXPIRY = 5000;
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Base);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Base)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.isReady = false, _this.onPlay = function () {
	      _this.props.onPlay();
	      _this.setVolume(_this.props.volume);
	      if (_this.seekOnReady) {
	        _this.seekTo(_this.seekOnReady);
	        _this.seekOnReady = null;
	      }
	      _this.props.onDuration(_this.getDuration());
	    }, _this.onReady = function () {
	      _this.isReady = true;
	      if (_this.props.playing || _this.preloading) {
	        _this.preloading = false;
	        if (_this.loadOnReady) {
	          _this.load(_this.loadOnReady);
	          _this.loadOnReady = null;
	        } else {
	          _this.play();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Base, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.url) {
	        this.load(this.props.url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Invoke player methods based on incoming props
	      if (this.props.url !== nextProps.url && nextProps.url) {
	        this.load(nextProps.url);
	        this.seekOnReady = null;
	      } else if (this.props.url && !nextProps.url) {
	        this.stop();
	        clearTimeout(this.updateTimeout);
	      } else if (!this.props.playing && nextProps.playing) {
	        this.play();
	      } else if (this.props.playing && !nextProps.playing) {
	        this.pause();
	      } else if (this.props.volume !== nextProps.volume) {
	        this.setVolume(nextProps.volume);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url;
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      var _this2 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && fraction !== 0) {
	        this.seekOnReady = fraction;
	        setTimeout(function () {
	          _this2.seekOnReady = null;
	        }, SEEK_ON_READY_EXPIRY);
	      }
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	Base.propTypes = _props.propTypes;
	Base.defaultProps = _props.defaultProps;
	exports.default = Base;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(223);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1283);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(139);
	
	var _computeChangedRoutes2 = __webpack_require__(1281);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1278);
	
	var _isActive2 = __webpack_require__(533);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1282);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1286);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(142);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(324);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType, impliedPaymentMethodType) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
	            element: element
	          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {}, impliedPaymentMethodType ? { impliedPaymentMethodType: impliedPaymentMethodType } : {})])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2._elements) {
	          fn(_this2._elements);
	          return;
	        }
	
	        var _props = _this2.props,
	            children = _props.children,
	            options = _objectWithoutProperties(_props, ['children']);
	
	        if (_this2.context.tag === 'sync') {
	          _this2._elements = _this2.context.stripe.elements(options);
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      }
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var EventConstants = __webpack_require__(93);
	var EventPluginRegistry = __webpack_require__(225);
	var ReactEventEmitterMixin = __webpack_require__(1330);
	var ViewportMetrics = __webpack_require__(556);
	
	var getVendorPrefixedEventName = __webpack_require__(1358);
	var isEventSupported = __webpack_require__(339);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var ReactDebugTool = __webpack_require__(1327);
	
	module.exports = { debugTool: ReactDebugTool };

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(201);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(169);
	var ViewportMetrics = __webpack_require__(556);
	
	var getEventModifierState = __webpack_require__(336);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.clearAction = clearAction;
	exports.fetchContCases = fetchContCases;
	exports.fetchCases = fetchCases;
	exports.fetchSingleCase = fetchSingleCase;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var busy = false;
	
	function requestData() {
		return { type: actionTypes.CASES_REQ_DATA };
	};
	
	function clearAction() {
		return { type: actionTypes.CASES_CLEAR_DATA };
	};
	
	function receiveData(type, json) {
		return {
			type: type,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.CASES_RECV_ERROR,
			payload: json
		};
	};
	
	// export function fetchWinners(offset = 0, limit = 36)
	// {
	// 	//@TODO Implement for real when API is ready
	// 	return function(dispatch) {
	// 		receiveData(actionTypes.CASES_RECV_DATA_CONT, response.data)
	// 	}
	// }
	
	function fetchContCases() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 36 : arguments[1];
		var month = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
		var year = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
		var q = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];
	
		var queryParams = {
			offset: offset,
			limit: limit,
			month: month,
			year: year,
			q: q
		};
	
		if (busy) {
			return function (dispatch) {
				false;
			};
		}
	
		return function (dispatch) {
			busy = true;
			return (0, _axios2.default)({
				url: _baseUrl2.default + '/api/cases/',
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(receiveData(actionTypes.CASES_RECV_DATA_CONT, response.data));
				busy = false;
			}).catch(function (response) {
				dispatch(receiveError(response.data));
	
				console.log('fetchContCases fetch error');
				console.log(response);
				busy = false;
	
				//dispatch(pushState(null, '/error'));
			});
		};
	};
	
	function fetchCases() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 20 : arguments[1];
	
		var queryParams = {
			offset: offset,
			limit: limit
		};
	
		return function (dispatch) {
			dispatch(requestData());
			return (0, _axios2.default)({
				url: _baseUrl2.default + '/api/cases/',
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(receiveData(actionTypes.CASES_RECV_DATA, response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
	
				console.log('caseS fetch error');
				console.log(response.data);
	
				//dispatch(push('/error'));
			});
		};
	};
	
	function fetchSingleCase(slug) {
		var preview = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		if (!(typeof slug === 'number' || typeof slug === 'string' && slug.length)) {
			console.log('cases - invalid slug');
			return function (dispatch) {
				//dispatch(pushState(null, '/error'));
			};
		}
	
		//console.log('fetch single case - ' + slug);
	
		return function (dispatch) {
			dispatch(requestData());
			var data = {};
	
			if (preview) {
				data.preview = preview;
			}
	
			return (0, _axios2.default)({
				url: _baseUrl2.default + '/api/cases/' + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: data
			}).then(function (response) {
				dispatch(receiveData(actionTypes.CASES_RECV_SINGLE_DATA, response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
	
				console.log('case fetch error');
				console.log(response);
	
				dispatch((0, _reduxRouter.push)('/error'));
			});
		};
	}

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.flushProfile = flushProfile;
	exports.fetchProfiles = fetchProfiles;
	exports.fetchSingleProfile = fetchSingleProfile;
	exports.fetchProfileCases = fetchProfileCases;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/profiles/';
	
	var busy = false;
	
	function action(type) {
		return { type: type };
	};
	
	function respond(json, type) {
		//console.log(type);
		return {
			type: type,
			payload: json
		};
	};
	
	function flushProfile() {
		return function (dispatch) {
			// IF we want to remove the old one when leaving the component and returning?
			dispatch(action(actionTypes.PROFILES_CLEAR_DATA));
		};
	}
	
	function fetchProfiles() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 36 : arguments[1];
		var q = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
		var order = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
		var orderBy = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];
	
		var queryParams = {
			offset: offset,
			limit: limit,
			q: q,
			order: order,
			orderBy: orderBy
		};
	
		if (busy) {
			return function (dispatch) {
				false;
			};
		}
	
		return function (dispatch) {
			busy = true;
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_DATA));
				busy = false;
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));
				console.log('profiles - fetch error');
				console.log(response);
				busy = false;
	
				//dispatch(pushState(null, '/error'));
			});
		};
	};
	
	function fetchSingleProfile(slug) {
		if (!(typeof slug === 'number' || typeof slug === 'string' && slug.length)) {
			console.log('profiles - invalid slug');
			return function (dispatch) {
				//dispatch(pushState(null, '/error'));
			};
		}
	
		return function (dispatch) {
			dispatch(action(actionTypes.PROFILES_REQ_SINGLE_DATA));
			return (0, _axios2.default)({
				url: url + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_SINGLE_DATA));
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));
	
				console.log('profile - fetch error');
				console.log(response);
	
				//dispatch(pushState(null, '/error'));
			});
		};
	}
	
	function fetchProfileCases(slug) {
		if (!(typeof slug === 'number' || typeof slug === 'string' && slug.length)) {
			console.log('profiles - invalid slug');
			return function (dispatch) {
				//dispatch(pushState(null, '/error'));
			};
		}
	
		return function (dispatch) {
			return (0, _axios2.default)({
				url: url + slug + '/related',
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_CASE_DATA));
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));
	
				console.log('profile - fetch error');
				console.log(response);
	
				//dispatch(pushState(null, '/error'));
			});
		};
	}

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _tagselect = __webpack_require__(179);
	
	var _tagselect2 = _interopRequireDefault(_tagselect);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _multicheckbox = __webpack_require__(367);
	
	var _multicheckbox2 = _interopRequireDefault(_multicheckbox);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _stepGeneric = __webpack_require__(171);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	var _cc = __webpack_require__(471);
	
	var _cc2 = _interopRequireDefault(_cc);
	
	var _cc3 = __webpack_require__(472);
	
	var _cc4 = _interopRequireDefault(_cc3);
	
	var _cc5 = __webpack_require__(473);
	
	var _cc6 = _interopRequireDefault(_cc5);
	
	var _cc7 = __webpack_require__(474);
	
	var _cc8 = _interopRequireDefault(_cc7);
	
	var _paypal = __webpack_require__(1079);
	
	var _paypal2 = _interopRequireDefault(_paypal);
	
	var _stripe = __webpack_require__(381);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CC_VISA = 'CC_VISA';
	var CC_ELECTRON = 'CC_ELECTRON';
	var CC_MASTERCARD = 'CC_MASTERCARD';
	var CC_DISCOVER = 'CC_DISCOVER';
	var CC_AMEX = 'CC_AMEX';
	
	var MODE_NEUTRAL = 'MODE_NEUTRAL';
	var MODE_CREDITCARD = 'MODE_CREDITCARD';
	var MODE_PAYPAL = 'MODE_PAYPAL';
	
	var PAYPAL_AUTH_COMPLETE = 'PAYPAL_AUTH_COMPLETE';
	var PAYPAL_AUTH_FAILED = 'PAYPAL_AUTH_FAILED';
	var CASE_SAVE_FAILED = 'CASE_SAVE_FAILED';
	
	var createOptions = function createOptions() {
		return {
			style: {
				base: {
					fontSize: '14px',
					color: '#8e8e8e',
					letterSpacing: '0.025em',
					fontFamily: 'Good Pro, sans-serif',
					fontWeight: 300
				},
				invalid: {
					color: '#9e2146'
				}
			}
		};
	};
	
	var AccountCaseCreateStep3 = function (_Component) {
		_inherits(AccountCaseCreateStep3, _Component);
	
		function AccountCaseCreateStep3(props) {
			_classCallCheck(this, AccountCaseCreateStep3);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStep3).call(this));
	
			_this._receiveMessage = _this._receiveMessage.bind(_this);
			_this.stripe = new _stripe2.default();
	
			_this.state = {
				submitting: false,
				mode: MODE_CREDITCARD,
				ccno: '',
				errors: {
					validExpiry: true,
					validCVC: true,
					validCC: true
				}
			};
			return _this;
		}
	
		_createClass(AccountCaseCreateStep3, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 3,
						stepNumber: '03',
						stepTitle: 'Payment'
					},
					this.state.mode === MODE_NEUTRAL && this.renderChoosePayment(),
					this.state.mode === MODE_CREDITCARD && this.renderCCForm()
				);
			}
		}, {
			key: 'renderChoosePayment',
			value: function renderChoosePayment() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Pay with credit/debit card', smallAside: true },
					_react2.default.createElement(_label2.default, { label: 'Select payment method' }),
					_react2.default.createElement(
						'div',
						{ className: 'payment-selection' },
						_react2.default.createElement(
							'button',
							{ className: 'button button--dark', onClick: function onClick() {
									_this2.setState(_extends({}, _this2.state, { mode: MODE_CREDITCARD }));
								} },
							'Pay with credit/debit card'
						)
					)
				);
			}
		}, {
			key: 'checkoutWithPaypal',
			value: function checkoutWithPaypal() {
				window.open('/api/paypal/case', '_blank');
				window.addEventListener('message', this._receiveMessage, false);
			}
		}, {
			key: '_receiveMessage',
			value: function _receiveMessage(event) {
				if (typeof event.data !== 'string') {
					return false;
				}
	
				switch (event.data) {
					case PAYPAL_AUTH_COMPLETE:
						this.props.goForward();
						break;
					case CASE_SAVE_FAILED:
						this.props.dispatch((0, _errors.dispatchError)({ message: 'Could not save your project - data is corrupt' }));
						break;
					case PAYPAL_AUTH_FAILED:
					default:
						this.props.dispatch((0, _errors.dispatchError)({ message: 'Paypal payment failed.' }));
				}
	
				window.removeEventListener('message', this._receiveMessage);
			}
		}, {
			key: 'renderCCForm',
			value: function renderCCForm() {
				var _this3 = this;
	
				var path = '/api/account/projects/create/payment';
				var smallAside = true;
	
				var expireMonths = [{ label: '01', value: '01' }, { label: '02', value: '02' }, { label: '03', value: '03' }, { label: '04', value: '04' }, { label: '05', value: '05' }, { label: '06', value: '06' }, { label: '07', value: '07' }, { label: '08', value: '08' }, { label: '09', value: '09' }, { label: '10', value: '10' }, { label: '11', value: '11' }, { label: '12', value: '12' }];
	
				var expireYears = function () {
					var years = [];
					var currentYear = new Date().getFullYear();
	
					for (var yearCount = currentYear; yearCount <= currentYear + 20; yearCount++) {
						years.push({ label: yearCount.toString(), value: yearCount.toString() });
					}
	
					return years;
				}();
	
				var cardType = this.detectCardType(this.state.ccno);
	
				return _react2.default.createElement(
					_form2.default,
					{
						getRefs: function getRefs() {
							return _this3.getRefs();
						},
						action: path,
						smallAside: smallAside,
						noFun: true,
						disableAjaxSubmit: true,
						onSubmit: function onSubmit(e) {
							return _this3.stripeSubmit(e);
						}
					},
					_react2.default.createElement(
						_content2.default,
						{ title: 'Information', smallAside: smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'name', name: 'name', label: 'Card holder', placeholder: 'Name of card holder' }),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardNumberElement, createOptions())
							),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardExpiryElement, createOptions())
							),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardCVCElement, createOptions())
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01', smallAside: smallAside },
						_react2.default.createElement(
							'div',
							{ className: 'span100p' },
							_react2.default.createElement(
								'div',
								{ className: 'account-process__button-area' },
								_react2.default.createElement(_submit2.default, { name: 'Complete payment', className: 'button--dark', disabled: this.state.submitting, waiting: this.state.submitting }),
								_react2.default.createElement(
									'span',
									{ className: 'account-process__button-area__button-desc' },
									'Complete payment using your credit/debit card.'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'stripeSubmit',
			value: function stripeSubmit(promise) {
				var _this4 = this;
	
				var token = void 0;
				_axios2.default.get(_baseUrl2.default + '/api/stripe/paymentintent?type=case').then(function (res) {
					var chargePromise = new Promise(function (resolve, reject) {
						promise.then(function () {
							_this4.props.stripe.createPaymentMethod('card').then(function (_ref) {
								var paymentMethod = _ref.paymentMethod;
							});
							_this4.props.stripe.createToken().then(function (response) {
								token = response.token;
							});
							_this4.props.stripe.handleCardPayment(res.data.intent_secret).then(function (result) {
								if (result.error) {
									_this4.setState(_extends({}, _this4.state, {
										submitting: false
									}));
									return;
								}
	
								var API_STRIPE_COMPLETE = '/api/stripe/complete';
								_axios2.default.post(_baseUrl2.default + API_STRIPE_COMPLETE, _qs2.default.stringify({
									type: 'case',
									stripeToken: token.id,
									id: result.paymentIntent.id
								}));
	
								// Make API call to populate order to add email
								_this4.setState(_extends({}, _this4.state, {
									submitting: false
								}));
								resolve();
							}).catch(function () {
								_this4.setState(_extends({}, _this4.state, {
									submitting: false
								}));
							});
						}).catch(function (res) {
							_this4.setState(_extends({}, _this4.state, {
								submitting: false
							}));
						});
					});
	
					_this4.setState(_extends({}, _this4.state, {
						submitting: true
					}));
	
					chargePromise.then(function () {}).catch(function () {
						_this4.setState(_extends({}, _this4.state, {
							submitting: false
						}));
					});
	
					return _this4.props.onSubmit(chargePromise);
				});
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'detectCardType',
			value: function detectCardType(number) {
				number = number + '';
				number = number.replace(/[^0-9.]/g, '');
	
				var re = {
					electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
					maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
					dankort: /^(5019)\d+$/,
					interpayment: /^(636)\d+$/,
					unionpay: /^(62|88)\d+$/,
					visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
					mastercard: /^5[1-5][0-9]{14}$/,
					amex: /^3[47][0-9]{13}$/,
					diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
					discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
					jcb: /^(?:2131|1800|35\d{3})\d{11}$/
				};
	
				if (re.electron.test(number)) {
					return CC_ELECTRON;
				} else if (re.visa.test(number)) {
					return CC_VISA;
				} else if (re.mastercard.test(number)) {
					return CC_MASTERCARD;
				} else if (re.amex.test(number)) {
					return CC_AMEX;
				} else {
					return undefined;
				}
			}
		}]);
	
		return AccountCaseCreateStep3;
	}(_react.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(AccountCaseCreateStep3);

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.caseFilterResponsive = caseFilterResponsive;
	
	var _types = __webpack_require__(88);
	
	function caseFilterResponsive(cases, browser) {
		var filteredCases = [];
		var matchViews = [];
	
		// Desktop return all
		if (browser.window.width >= 1200) {
			return cases;
		} else if (browser.window.width >= 720 && browser.window.width < 1200) {
			matchViews.push(_types.DEVICE_TABLET_PORTRAIT, _types.DEVICE_TABLET_LANDSCAPE);
		} else if (browser.window.width < 720) {
			matchViews.push(_types.DEVICE_MOBILE_PORTRAIT, _types.DEVICE_MOBILE_LANDSCAPE);
		}
	
		for (var i = 0; i < cases.length; i++) {
			if (matchViews.indexOf(cases[i].bestViewedOn) !== -1) {
				filteredCases.push(cases[i]);
			}
		}
	
		return filteredCases;
	}

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(213);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dropzoneDisplay = __webpack_require__(237);
	
	var _dropzoneDisplay2 = _interopRequireDefault(_dropzoneDisplay);
	
	var _dropzone = __webpack_require__(1003);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputDropzone = function (_Component) {
		_inherits(InputDropzone, _Component);
	
		function InputDropzone(props) {
			_classCallCheck(this, InputDropzone);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputDropzone).call(this));
	
			_this.state = {
				openFileUpload: function openFileUpload() {}
			};
			return _this;
		}
	
		_createClass(InputDropzone, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'form-dropzone pixel-pattern pixel-pattern--10';
	
				if (this.props.inputs.length > 3) {
					className += ' form-dropzone--all-clear';
				}
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (!this.props.inputs.length) {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'div',
						{ className: 'form-dropzone__container' },
						this.props.inputs.map(function (input, i) {
							return _react2.default.createElement(_dropzoneDisplay2.default, _extends({}, _this2.props, { ref: 'dropzone', key: input.name, name: input.name, preview: input.preview, disableDelete: _this2.props.disableDelete, bindOpen: _this2._bindOpen.bind(_this2), recommended: _this2.props.recommended }));
						}),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: '_bindOpen',
			value: function _bindOpen(cb) {
				this.state.openFileUpload = cb;
			}
		}, {
			key: 'open',
			value: function open() {
				if (this.state.openFileUpload) {
					this.state.openFileUpload();
				}
			}
		}]);
	
		return InputDropzone;
	}(_react.Component);
	
	InputDropzone.propTypes = {
		path: _react.PropTypes.string.isRequired,
		inputs: _react.PropTypes.array.isRequired,
		disableClick: _react.PropTypes.bool,
		multiple: _react.PropTypes.bool,
		accept: _react.PropTypes.string,
		recommended: _react.PropTypes.shape({
			width: _react.PropTypes.number.isRequired,
			height: _react.PropTypes.number.isRequired
		}),
		disableDelete: _react.PropTypes.bool.isRequired
	};
	InputDropzone.defaultProps = {
		inputs: [],
		disableClick: false,
		multiple: false,
		accept: '',
		recommended: {
			width: 0,
			height: 0
		},
		disableDelete: false
	};
	exports.default = InputDropzone;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(213);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _errors = __webpack_require__(29);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _dropUpload = __webpack_require__(1085);
	
	var _dropUpload2 = _interopRequireDefault(_dropUpload);
	
	var _dropRemove = __webpack_require__(1084);
	
	var _dropRemove2 = _interopRequireDefault(_dropRemove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_INITIAL = 0;
	var STATUS_UPLOADING = 1;
	var STATUS_PREVIEWING = 2;
	
	var InputDropzoneDisplay = function (_Component) {
		_inherits(InputDropzoneDisplay, _Component);
	
		function InputDropzoneDisplay(props) {
			_classCallCheck(this, InputDropzoneDisplay);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputDropzoneDisplay).call(this));
	
			var width = _this.getWidth(props);
	
			_this.state = {
				preview: props.preview,
				status: props.preview ? STATUS_PREVIEWING : STATUS_INITIAL,
				width: width,
				height: props.height ? props.height : props.aspect ? Math.floor(width * props.aspect) : 'auto'
			};
			return _this;
		}
	
		_createClass(InputDropzoneDisplay, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.preview && nextProps.preview !== this.props.preview || nextProps.browser.window.width !== this.props.browser.window.width) {
					this.setWidthState(nextProps);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				// this.refs not avail until after mount, so we call it again here
				this.setWidthState(this.props);
	
				// let parent have access to programatically opening dropzone upload dialog
				this.props.bindOpen(function () {
					_this2.refs.dropzone.open();
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactDropzone2.default,
					{
						ref: 'dropzone',
						disableClick: this.props.disableClick,
						multiple: this.props.multiple,
						accept: this.props.accept,
						onDropAccepted: this.onDrop.bind(this),
						style: {
							width: this.state.width,
							height: this.state.height
						},
						className: 'input-dropzone',
						activeClassName: 'input-dropzone--active',
						rejectClassName: 'input-dropzone--reject'
					},
					_react2.default.createElement(
						'div',
						{ className: 'input-dropzone__item' },
						this.renderContent(),
						_react2.default.createElement(_confirm2.default, { ref: 'confirm' })
					)
				);
			}
		}, {
			key: 'renderContent',
			value: function renderContent() {
				switch (this.state.status) {
					case STATUS_INITIAL:
					case STATUS_PREVIEWING:
				}
	
				var helpFormat = 'input-dropzone__help__centerer';
				if (this.state.height < 300 && this.state.width > 155 && this.props.aspect && this.props.aspect < 0.4) {
					helpFormat += ' input-dropzone__help__centerer--wide';
				} else if (this.state.height < 100 || this.state.width < 155) {
					helpFormat += ' input-dropzone__help__centerer--hidetext';
				}
				//if (this.state.status === STATUS_INITIAL || this.state.status === STATUS_PREVIEWING) {}
	
				return _react2.default.createElement(
					'div',
					{ className: 'input-dropzone__container', ref: 'container' },
					_react2.default.createElement(
						'div',
						{ className: 'input-dropzone__uploading' + (this.state.status === STATUS_UPLOADING ? ' input-dropzone__uploading--show' : '') },
						_react2.default.createElement(_spinner2.default, { size: '32px', className: 'input-dropzone__uploading__centerer' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'input-dropzone__preview pixel-pattern pixel-pattern--darker' + (this.state.status === STATUS_PREVIEWING ? ' input-dropzone__preview--show' : '') },
						this.state.status === STATUS_PREVIEWING && (typeof this.state.preview === 'string' ? _react2.default.createElement('img', { src: this.state.preview, alt: '' }) : _react2.default.createElement(_image2.default, { img: this.state.preview, span: '', alt: '' }))
					),
					_react2.default.createElement(
						'div',
						{ className: 'input-dropzone__help' + (this.state.status === STATUS_PREVIEWING || this.state.status === STATUS_UPLOADING ? ' input-dropzone__help--previewing' : '') },
						!this.props.disableDelete && _react2.default.createElement(
							'div',
							{ className: 'input-dropzone__help__delete', onClick: this.clearUpload.bind(this) },
							_react2.default.createElement('img', _extends({}, _dropRemove2.default, { className: '' }))
						),
						_react2.default.createElement(
							'div',
							{ className: helpFormat },
							_react2.default.createElement(
								'div',
								{ className: 'input-dropzone__help__image' },
								_react2.default.createElement('img', _extends({}, _dropUpload2.default, { className: '' }))
							),
							_react2.default.createElement(
								'div',
								{ className: 'input-dropzone__help__text' },
								this.props.browser.window.width <= 719 && _react2.default.createElement(
									'span',
									null,
									'Tap to upload a new image'
								) || _react2.default.createElement(
									'span',
									null,
									'Drag an image here or ',
									_react2.default.createElement(
										'a',
										null,
										'browse'
									),
									' to upload.'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'setWidthState',
			value: function setWidthState(props) {
				var width = this.getWidth(props);
	
				var preview = this.state.preview || props.preview;
	
				this.setState(_extends({}, this.state, {
					preview: preview,
					status: this.state.preview || props.preview ? STATUS_PREVIEWING : STATUS_INITIAL,
					width: width,
					height: props.height ? props.height : props.aspect ? Math.floor(width * props.aspect) : 'auto'
				}));
			}
		}, {
			key: 'getWidth',
			value: function getWidth(props) {
				var maxWidth = props.width || 1400;
	
				var calculatedMaxWidth = function (container) {
					if (container) {
						var mainParentContainer = container;
	
						while (mainParentContainer && mainParentContainer.classList && !mainParentContainer.classList.contains('form-dropzone')) {
							mainParentContainer = mainParentContainer.parentElement;
						}
	
						if (!mainParentContainer) {
							return maxWidth;
						}
	
						var containerComputedStyle = window.getComputedStyle(mainParentContainer);
						var parentComputedStyle = window.getComputedStyle(mainParentContainer.parentElement);
	
						maxWidth = mainParentContainer.parentElement.offsetWidth - (parseInt(containerComputedStyle.paddingLeft, 10) || 0) - (parseInt(containerComputedStyle.paddingRight, 10) || 0) - (parseInt(parentComputedStyle.paddingLeft, 10) || 0) - (parseInt(parentComputedStyle.paddingRight, 10) || 0);
	
						return props.width > maxWidth ? maxWidth : props.width;
					} else {
						return maxWidth;
					}
				}(this.refs.container);
	
				if (calculatedMaxWidth <= maxWidth) {
					return calculatedMaxWidth;
				}
	
				if (props.browser.window.width <= 567) {
					return props.width < 262 ? props.width : 262;
				} else if (props.browser.window.width <= 719) {
					return props.width < 354 ? props.width : 354;
				}
	
				return props.width;
			}
		}, {
			key: 'onDrop',
			value: function onDrop(files) {
				var _this3 = this;
	
				var data = new FormData();
				data.append('file', files[0]);
	
				if (files[0] && files[0].size && files[0].size >= 20000000) {
					return this.props.dispatch((0, _errors.dispatchError)({ message: 'Woah there!, that file is not small enough. (max. 20mb)' }));
				}
	
				if (/image/.test(files[0].type) && this.props.recommended.width && this.props.recommended.height && window.FileReader) {
					(function () {
						var reader = new FileReader();
						reader.addEventListener('load', function () {
							var img = new window.Image();
							img.src = reader.result;
	
							img.onload = function () {
								if (img.width !== _this3.props.recommended.width || img.height !== _this3.props.recommended.height) {
									_this3.refs.confirm.confirm('The image you uploaded does not match the recommend size (' + _this3.props.recommended.width + 'x' + _this3.props.recommended.height + '), please check that it looks the way you want it to.', 'Ok', false).then(function () {}).catch(function () {});
								}
							};
						}, false);
	
						reader.readAsDataURL(files[0]);
					})();
				}
	
				var params = _extends({}, this.props.params, {
					name: this.props.name
				});
	
				// fake a post
				this.setState(_extends({}, this.state, { status: STATUS_UPLOADING }));
				_axios2.default.post(_baseUrl2.default + this.props.path, data, {
					params: params,
					paramsSerializer: function paramsSerializer(params) {
						return _qs2.default.stringify(params);
					}
				}).then(function (response) {
					if (response.data.path) {
						_this3.setState(_extends({}, _this3.state, { preview: response.data.path, status: STATUS_PREVIEWING }));
					}
					_this3.props.onUpload(response);
				}).catch(function (response) {
					_this3.setState(_extends({}, _this3.state, { status: STATUS_INITIAL }));
					_this3.props.dispatch((0, _errors.dispatchError)(response.data));
					_this3.props.onFail(response);
				});
			}
		}, {
			key: 'clearUpload',
			value: function clearUpload(e) {
				var _this4 = this;
	
				e.preventDefault();
				e.stopPropagation();
	
				this.refs.confirm.confirm('Are you sure you want to remove this file?').then(function () {
					var data = new FormData();
					data.append('name', _this4.props.name);
	
					// optimistic update
					_this4.setState(_extends({}, _this4.state, { preview: false, status: STATUS_INITIAL }));
	
					var params = _extends({}, _this4.props.params, {
						name: _this4.props.name
					});
	
					_axios2.default.delete(_baseUrl2.default + _this4.props.path, {
						params: params,
						paramsSerializer: function paramsSerializer(params) {
							return _qs2.default.stringify(params);
						}
					}).then(function (response) {
						_this4.props.onClear();
					}).catch(function (response) {
						//this.setState({ ...this.state, status: STATUS_PREVIEWING });
						_this4.props.dispatch((0, _errors.dispatchError)(response.data));
	
						_this4.props.onClear(); // @TODO REMOVE WHEN DELETE CALL WORKS
	
						_this4.props.onFail();
					});
				}).catch(function () {});
			}
		}]);
	
		return InputDropzoneDisplay;
	}(_react.Component);
	
	InputDropzoneDisplay.propTypes = {
		name: _react.PropTypes.string.isRequired,
		preview: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.string, _react.PropTypes.object]).isRequired,
		params: _react.PropTypes.object.isRequired,
		onChange: _react.PropTypes.func.isRequired,
		onClear: _react.PropTypes.func.isRequired,
		onUpload: _react.PropTypes.func.isRequired,
		onFail: _react.PropTypes.func.isRequired,
		bindOpen: _react.PropTypes.func.isRequired,
		recommended: _react.PropTypes.shape({
			width: _react.PropTypes.number.isRequired,
			height: _react.PropTypes.number.isRequired
		}),
		disableDelete: _react.PropTypes.bool.isRequired
	};
	InputDropzoneDisplay.defaultProps = {
		preview: false,
		width: 270,
		height: false,
		aspect: false,
		params: {},
		recommended: {
			width: 0,
			height: 0
		},
		disableDelete: false,
		/*jscs:disable requirePaddingNewLinesAfterBlocks*/
		onChange: function onChange() {},
		onClear: function onClear() {},
		onUpload: function onUpload() {},
		onFail: function onFail() {},
		bindOpen: function bindOpen() {}
	};
	exports.default = (0, _connect2.default)(InputDropzoneDisplay);

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CaseList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _relatedcases = __webpack_require__(1024);
	
	var _relatedcases2 = _interopRequireDefault(_relatedcases);
	
	var _caseElementGeneric = __webpack_require__(364);
	
	var _caseElementGeneric2 = _interopRequireDefault(_caseElementGeneric);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedCases = function (_Component) {
		_inherits(RelatedCases, _Component);
	
		function RelatedCases(props) {
			_classCallCheck(this, RelatedCases);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RelatedCases).call(this, props));
	
			_this.state = {
				active: false,
				cases: [],
				done: false,
				offset: 5,
				next: false,
				waiting: false
			};
	
			_this.didScroll = false;
			return _this;
		}
	
		_createClass(RelatedCases, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state.cases = this.props.cases;
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				if (this.props.parentSlug !== nextProps.parentSlug || this.props.cases !== nextProps.cases) {
					this.state.cases = nextProps.cases;
					this.state.done = false;
					this.state.active = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.state !== nextState || this.props.id !== nextProps.id || this.props.names !== nextProps.names || this.props.cases !== nextProps.cases;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (window.location.hash && window.location.hash == '#related-cases' && !this.didScroll) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
					scroller.to('#related-cases');
					this.didScroll = true;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var uid = 'related-cases-' + this.props.id;
				var moreText = 'Load more (' + (this.props.total - this.state.cases.length) + ')';
				var arrowClass = 'related-cases__load-more__arrow';
	
				var relatedClass = 'related-cases span14';
	
				if (this.props.profile) {
					relatedClass = 'related-cases related-cases--profile span14';
					moreText = 'Load more (' + (this.props.cases.length - 6) + ')';
				}
	
				if (this.state.active) {
					relatedClass += ' active';
					moreText = 'Show less';
					arrowClass = 'related-cases__load-more__arrow related-cases__load-more__arrow--active';
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: relatedClass, key: uid, ref: 'relatedCases', id: 'related-cases' },
						_react2.default.createElement('div', { className: 'related-cases__fill span2 hide-mobile' }),
						_react2.default.createElement(
							'div',
							{ className: 'related-cases__top span12 span14-mobile' },
							_react2.default.createElement(
								'h2',
								{ className: 'related-cases__title' },
								'More FWAs from ',
								this.props.names
							)
						),
						_react2.default.createElement(CaseList, { cases: this.state.cases, browser: this.props.browser })
					),
					!this.state.done && this.props.cases.length > 5 && !this.props.profile && this.props.total - this.state.cases.length > 0 && _react2.default.createElement(
						'a',
						{ href: '#', ref: 'moreButton', className: 'related-cases__load-more span8 span100p-mobile pixel-pattern', onClick: function onClick(event) {
								return _this2.fetchMore(event);
							} },
						_react2.default.createElement(
							'span',
							{ className: 'span2 span4-mobile related-cases__load-more__arrow-holder' },
							this.state.waiting && _react2.default.createElement(_spinner2.default, { className: 'related-cases__load-more__spinner' }) || _react2.default.createElement('span', { className: arrowClass })
						),
						moreText
					) || this.props.cases.length > 5 && this.props.profile && !this.state.done && _react2.default.createElement(
						'a',
						{ href: '#', ref: 'moreButton', className: 'related-cases__load-more span8 span100p-mobile pixel-pattern', onClick: function onClick(event) {
								return _this2.onClick(event);
							} },
						_react2.default.createElement(
							'span',
							{ className: 'span2 span4-mobile related-cases__load-more__arrow-holder' },
							_react2.default.createElement('span', { className: arrowClass })
						),
						moreText
					)
				);
			}
		}, {
			key: 'fetchMore',
			value: function fetchMore(e) {
				var _this3 = this;
	
				e.preventDefault();
	
				if (!this.state.done) {
	
					this.setState({
						waiting: true
					});
	
					var offset = 6;
					var url = '';
	
					if (this.state.next) {
						url = this.state.next;
					} else {
						url = _baseUrl2.default + '/api/' + this.props.typeSlug + '/' + this.props.parentSlug + '/related?limit=6' + '&offset=' + offset;
					}
	
					var a = document.createElement('a');
					a.href = url;
					url = a.pathname + a.search;
	
					_axios2.default.get(url).then(function (response) {
						(0, _forEach2.default)(response.data.cases, function (single) {
							_this3.state.cases.push(single);
						});
	
						if (!response.data.next) {
							_this3.state.done = true;
						}
	
						_this3.setState({
							cases: _this3.state.cases,
							next: response.data.next,
							waiting: false,
							done: _this3.state.done
						});
					}).catch(function (response) {
						console.log('fetching related cases error');
						console.log(response);
					});
				}
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
	
				this.setState(_extends({}, this.state, {
					active: !this.state.active
				}));
			}
		}]);
	
		return RelatedCases;
	}(_react.Component);
	
	RelatedCases.propTypes = {};
	exports.default = RelatedCases;
	
	var CaseList = exports.CaseList = function (_Component2) {
		_inherits(CaseList, _Component2);
	
		function CaseList(props) {
			_classCallCheck(this, CaseList);
	
			var _this4 = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseList).call(this, props));
	
			_this4.state = {
				active: false
			};
			return _this4;
		}
	
		_createClass(CaseList, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'ul',
					{ className: 'related-cases__case-holder span12 span14-mobile' },
					this.props.cases.map(this.renderCase.bind(this)),
					_react2.default.createElement('li', { className: 'related-cases__case-fill span4 span6-tablet span14-mobile' }),
					_react2.default.createElement('li', { className: 'related-cases__case-fill span4 span6-tablet span14-mobile' })
				);
			}
		}, {
			key: 'renderCase',
			value: function renderCase(caseItem, i) {
				var uid = 'case' + i;
				var classes = 'related-cases__case span4 span6-tablet span14-mobile';
	
				if (this.props.browser.window.width < 1200) {
					if (i % 2 === 0) {
						classes += ' no-margin';
					}
				} else {
					if (i % 3 === 0) {
						classes += ' no-margin';
					}
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: classes },
					_react2.default.createElement(_caseElementGeneric2.default, { caseItem: caseItem, browser: this.props.browser, showPoints: true, contentComp: this.props.contentComp })
				);
			}
		}]);
	
		return CaseList;
	}(_react.Component);
	
	CaseList.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		cases: _react.PropTypes.array.isRequired,
		contentComp: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.func]).isRequired
	};
	CaseList.defaultProps = {
		contentComp: false
	};

/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATE_ALL_ON = exports.STATE_ALL_ON = 'STATE_ON';
	var STATE_ALL_OFF = exports.STATE_ALL_OFF = 'STATE_OFF';
	var STATE_UNDETERMINED = exports.STATE_UNDETERMINED = 'STATE_UNDETERMINED';

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AccountLoginForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _validate = __webpack_require__(76);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _users = __webpack_require__(64);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _google = __webpack_require__(149);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _login = __webpack_require__(1039);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Spinner from '../../components/svg/spinner';
	
	var AccountLogin = function (_Component) {
		_inherits(AccountLogin, _Component);
	
		function AccountLogin(props) {
			_classCallCheck(this, AccountLogin);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountLogin).call(this));
	
			_this.state = {
				waiting: false
			};
			return _this;
		}
	
		_createClass(AccountLogin, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(''), this.props.users.isLoggedIn());
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps, nState) {
				(0, _authorization.redirectToPathIf)(nProps.dispatch, this.props.router.location.query.returnTo || (0, _routes.accountRoute)(''), nProps.users.isLoggedIn());
	
				if (nProps.errors.error) {
					this.setState(_extends({}, nState, { waiting: false }));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'section',
					{ className: 'account-flow' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Login' }),
					_react2.default.createElement(
						'header',
						{ className: 'span14 account-flow__head' },
						_react2.default.createElement(
							'div',
							{ className: 'span7 span13-mobile push5-desktop' },
							_react2.default.createElement(
								'h1',
								{ className: 'account-flow__head__title' },
								(0, _translate2.default)('account/login/header')
							),
							_react2.default.createElement(
								'h2',
								{ className: 'account-flow__head__title account-flow__head__title--faded' },
								(0, _translate2.default)('account/login/subheader')
							)
						)
					),
					_react2.default.createElement(AccountLoginForm, this.props)
				);
			}
		}]);
	
		return AccountLogin;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountLogin);
	
	var AccountLoginForm = exports.AccountLoginForm = function (_Component2) {
		_inherits(AccountLoginForm, _Component2);
	
		function AccountLoginForm(props) {
			_classCallCheck(this, AccountLoginForm);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountLoginForm).call(this));
	
			_this2.FB = new _fb2.default();
			_this2.GGL = new _google2.default();
			_this2.TWT = new _twitter2.default();
	
			_this2.mounted = true;
	
			_this2.state = {
				waiting: false
			};
			return _this2;
		}
	
		_createClass(AccountLoginForm, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				this.FB.load();
				this.GGL.load();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					_content2.default,
					{ title: (0, _translate2.default)('account/login/aside') },
					_react2.default.createElement(
						'div',
						{ className: 'span4 span6-tablet span100p-mobile account-flow__form' },
						_react2.default.createElement(
							'header',
							{ className: 'block-label--relative' },
							(0, _translate2.default)('account/login/formtitle')
						),
						_react2.default.createElement(
							'form',
							{ action: '', onSubmit: function onSubmit(e) {
									return _this3.handleSubmit(e);
								}, noValidate: true },
							_react2.default.createElement(_text2.default, {
								className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
								name: 'email',
								ref: 'email',
								type: 'email',
								required: 'required',
								placeholder: 'Email',
								manualValidate: true,
								validate: [{ rule: _validate.VALIDATE_EMAIL }]
							}),
							_react2.default.createElement('span', null),
							_react2.default.createElement(_text2.default, {
								className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
								name: 'password',
								ref: 'password',
								type: 'password',
								required: 'required',
								placeholder: 'Password',
								pattern: '^.{6,}$',
								manualValidate: true,
								validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }]
							}),
							_react2.default.createElement(
								_checkbox2.default,
								{ name: 'remember', ref: 'remember' },
								'Remember me next time'
							),
							_react2.default.createElement(_submit2.default, { name: 'Sign in', waiting: this.state.waiting, className: 'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go') })
						),
						_react2.default.createElement(
							'div',
							{ className: 'account-flow__form__btw' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/recover'), className: 'account-flow__form__btw__link' },
								'Forgot password'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/register'), className: 'account-flow__form__btw__link' },
								'Sign up'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'span3 span4-tablet span100p-mobile span account-flow__social' },
						_react2.default.createElement(
							'header',
							{ className: 'block-label--relative' },
							(0, _translate2.default)('account/login/social')
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'button',
								{ className: 'button--fb account-flow__social__button', onClick: this.loginFB.bind(this) },
								'Facebook'
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'button',
								{ className: 'button--twt account-flow__social__button', onClick: this.loginTWT.bind(this) },
								'Twitter'
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'button',
								{ className: 'button--ggl account-flow__social__button', onClick: this.loginGGL.bind(this) },
								'Google'
							)
						)
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
				var fieldsToCheck = [this.refs.email, this.refs.password];
	
				if ((0, _validate.formIsValid)(fieldsToCheck)) {
					this.props.dispatch((0, _users.login)(this.refs.email.value(), this.refs.password.value(), this.refs.remember.value, this.stopWaiting.bind(this), this.stopWaiting.bind(this)));
					this.setState(_extends({}, this.state, { waiting: true }));
				} else {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'stopWaiting',
			value: function stopWaiting() {
				if (this.mounted) {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'loginFB',
			value: function loginFB() {
				this.FB.login(this.props.dispatch);
			}
		}, {
			key: 'loginGGL',
			value: function loginGGL() {
				this.GGL.login(this.props.dispatch);
			}
		}, {
			key: 'loginTWT',
			value: function loginTWT() {
				this.TWT.login(this.props.dispatch);
			}
		}]);

		return AccountLoginForm;
	}(_react.Component);

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = gaPush;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GaLoader = function () {
		function GaLoader() {
			_classCallCheck(this, GaLoader);
	
			this.load();
		}
	
		_createClass(GaLoader, [{
			key: 'load',
			value: function load() {
				if (window.konfig.gaKey && !this.isLoaded()) {
					(function (i, s, o, g, r, a, m) {
						i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
							(i[r].q = i[r].q || []).push(arguments);
						}, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
					})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	
					ga('create', window.konfig.gaKey, 'auto');
				}
			}
		}, {
			key: 'isLoaded',
			value: function isLoaded() {
				return typeof window.ga === 'function';
			}
		}]);
	
		return GaLoader;
	}();
	
	var GALoader = new GaLoader();
	function gaPush() {
		var type = arguments.length <= 0 || arguments[0] === undefined ? 'view' : arguments[0];
		var category = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
		var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
		GALoader.load();
	
		if (GALoader.isLoaded()) {
			if (type === 'event') {
				return window.ga('send', {
					hitType: 'event',
					eventCategory: category,
					eventAction: 'click',
					eventLabel: name
				});
			} else if (type === 'view') {
				// console.log('pageView');
				// console.log(window.location.pathname);
	
				return window.ga('send', {
					hitType: 'pageview',
					page: window.location.pathname
				});
			}
		} else {
			console.log('it ain\'t loaded BRO');
		}
	
		return false;
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(192)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(117);
	var toLength = __webpack_require__(26);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(706);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(34);
	var createDesc = __webpack_require__(114);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	var document = __webpack_require__(15).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 247 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(23)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(15).document;
	module.exports = document && document.documentElement;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	var setPrototypeOf = __webpack_require__(259).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(135);
	var ITERATOR = __webpack_require__(23)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(111);
	var descriptor = __webpack_require__(114);
	var setToStringTag = __webpack_require__(136);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(47)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(100);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(48);
	var hide = __webpack_require__(47);
	var Iterators = __webpack_require__(135);
	var $iterCreate = __webpack_require__(252);
	var setToStringTag = __webpack_require__(136);
	var getPrototypeOf = __webpack_require__(55);
	var ITERATOR = __webpack_require__(23)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 254 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 255 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var macrotask = __webpack_require__(264).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(66)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(42);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(151);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(20);
	var anObject = __webpack_require__(10);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(68)(Function.call, __webpack_require__(54).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(154)('keys');
	var uid = __webpack_require__(118);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(185);
	var defined = __webpack_require__(80);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(70);
	var defined = __webpack_require__(80);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(68);
	var invoke = __webpack_require__(393);
	var html = __webpack_require__(249);
	var cel = __webpack_require__(246);
	var global = __webpack_require__(15);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(66)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var DESCRIPTORS = __webpack_require__(27);
	var LIBRARY = __webpack_require__(100);
	var $typed = __webpack_require__(193);
	var hide = __webpack_require__(47);
	var redefineAll = __webpack_require__(115);
	var fails = __webpack_require__(19);
	var anInstance = __webpack_require__(109);
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(26);
	var toIndex = __webpack_require__(412);
	var gOPN = __webpack_require__(112).f;
	var dP = __webpack_require__(34).f;
	var arrayFill = __webpack_require__(243);
	var setToStringTag = __webpack_require__(136);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(67);
	var LIBRARY = __webpack_require__(100);
	var wksExt = __webpack_require__(413);
	var defineProperty = __webpack_require__(34).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(134);
	var ITERATOR = __webpack_require__(23)('iterator');
	var Iterators = __webpack_require__(135);
	module.exports = __webpack_require__(67).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(99);
	var step = __webpack_require__(396);
	var Iterators = __webpack_require__(135);
	var toIObject = __webpack_require__(56);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(253)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns an array of all `ContentBlock` instances within two block keys
	 *
	 * @param  {object} contentState A draft.js `ContentState` instance
	 * @param  {string} anchorKey    The block key to start searching from
	 * @param  {string} focusKey     The block key until which to search
	 *
	 * @return {array} An array containing the found content blocks
	 */
	
	exports.default = function (contentState, anchorKey, focusKey) {
	  var isSameBlock = anchorKey === focusKey;
	  var startingBlock = contentState.getBlockForKey(anchorKey);
	
	  if (!startingBlock) {
	    return [];
	  }
	
	  var selectedBlocks = [startingBlock];
	
	  if (!isSameBlock) {
	    var blockKey = anchorKey;
	
	    while (blockKey !== focusKey) {
	      var nextBlock = contentState.getBlockAfter(blockKey);
	
	      if (!nextBlock) {
	        selectedBlocks = [];
	        break;
	      }
	
	      selectedBlocks.push(nextBlock);
	      blockKey = nextBlock.getKey();
	    }
	  }
	
	  return selectedBlocks;
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(156);
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(121);
	var Immutable = __webpack_require__(24);
	var SelectionState = __webpack_require__(138);
	
	var generateRandomKey = __webpack_require__(83);
	var sanitizeDraftText = __webpack_require__(278);
	
	var List = Immutable.List;
	var Record = Immutable.Record;
	var Repeat = Immutable.Repeat;
	
	var defaultRecord = {
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = (function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    _get(Object.getPrototypeOf(ContentState.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ContentState, [{
	    key: 'getBlockMap',
	    value: function getBlockMap() {
	      return this.get('blockMap');
	    }
	  }, {
	    key: 'getSelectionBefore',
	    value: function getSelectionBefore() {
	      return this.get('selectionBefore');
	    }
	  }, {
	    key: 'getSelectionAfter',
	    value: function getSelectionAfter() {
	      return this.get('selectionAfter');
	    }
	  }, {
	    key: 'getBlockForKey',
	    value: function getBlockForKey(key) {
	      var block = this.getBlockMap().get(key);
	      return block;
	    }
	  }, {
	    key: 'getKeyBefore',
	    value: function getKeyBefore(key) {
	      return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	        return v === key;
	      }).skip(1).first();
	    }
	  }, {
	    key: 'getKeyAfter',
	    value: function getKeyAfter(key) {
	      return this.getBlockMap().keySeq().skipUntil(function (v) {
	        return v === key;
	      }).skip(1).first();
	    }
	  }, {
	    key: 'getBlockAfter',
	    value: function getBlockAfter(key) {
	      return this.getBlockMap().skipUntil(function (_, k) {
	        return k === key;
	      }).skip(1).first();
	    }
	  }, {
	    key: 'getBlockBefore',
	    value: function getBlockBefore(key) {
	      return this.getBlockMap().reverse().skipUntil(function (_, k) {
	        return k === key;
	      }).skip(1).first();
	    }
	  }, {
	    key: 'getBlocksAsArray',
	    value: function getBlocksAsArray() {
	      return this.getBlockMap().toArray();
	    }
	  }, {
	    key: 'getFirstBlock',
	    value: function getFirstBlock() {
	      return this.getBlockMap().first();
	    }
	  }, {
	    key: 'getLastBlock',
	    value: function getLastBlock() {
	      return this.getBlockMap().last();
	    }
	  }, {
	    key: 'getPlainText',
	    value: function getPlainText(delimiter) {
	      return this.getBlockMap().map(function (block) {
	        return block ? block.getText() : '';
	      }).join(delimiter || '\n');
	    }
	  }, {
	    key: 'hasText',
	    value: function hasText() {
	      var blockMap = this.getBlockMap();
	      return blockMap.size > 1 || blockMap.first().getLength() > 0;
	    }
	  }], [{
	    key: 'createFromBlockArray',
	    value: function createFromBlockArray(blocks) {
	      var blockMap = BlockMapBuilder.createFromArray(blocks);
	      var selectionState = SelectionState.createEmpty(blockMap.first().getKey());
	      return new ContentState({
	        blockMap: blockMap,
	        selectionBefore: selectionState,
	        selectionAfter: selectionState
	      });
	    }
	  }, {
	    key: 'createFromText',
	    value: function createFromText(text) {
	      var delimiter = arguments.length <= 1 || arguments[1] === undefined ? /\r\n?|\n/g : arguments[1];
	
	      var strings = text.split(delimiter);
	      var blocks = strings.map(function (block) {
	        block = sanitizeDraftText(block);
	        return new ContentBlock({
	          key: generateRandomKey(),
	          text: block,
	          type: 'unstyled',
	          characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	        });
	      });
	      return ContentState.createFromBlockArray(blocks);
	    }
	  }]);
	
	  return ContentState;
	})(ContentStateRecord);
	
	module.exports = ContentState;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(24);
	
	var Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(158);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	module.exports = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  'blockquote': {
	    element: 'blockquote'
	  },
	  'atomic': {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  'unstyled': {
	    element: 'div'
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(84);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(438);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  while (node && node !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(node);
	    if (key != null) {
	      return key;
	    }
	    node = node.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @typechecks
	 * 
	 */
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	'use strict';
	
	var DraftEntity = __webpack_require__(91);
	
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      return filterKey(entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityKey) {
	  if (entityKey) {
	    var entity = DraftEntity.get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * 
	 */
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	'use strict';
	
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ },
/* 278 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ },
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(1064);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    while (node && node !== document.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return window;
	  }
	
	};
	
	module.exports = Style;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1068);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(1061);
	var getUnboundedScrollPosition = __webpack_require__(461);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement();
	  if (scrollable === window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? document.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "countries-6213c40e8f13003dd4e7520187c81b2b.json";

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(139);
	
	var _PathUtils = __webpack_require__(123);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _DOMUtils = __webpack_require__(287);
	
	var _DOMStateStorage = __webpack_require__(286);
	
	var _createDOMHistory = __webpack_require__(466);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1178),
	    mapCacheDelete = __webpack_require__(1179),
	    mapCacheGet = __webpack_require__(1180),
	    mapCacheHas = __webpack_require__(1181),
	    mapCacheSet = __webpack_require__(1182);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 292 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1133),
	    createBaseEach = __webpack_require__(1153);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(1168);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1140),
	    baseMatchesProperty = __webpack_require__(1141),
	    identity = __webpack_require__(1197),
	    isArray = __webpack_require__(72),
	    property = __webpack_require__(1204);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(485),
	    isSymbol = __webpack_require__(211);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 297 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104),
	    now = __webpack_require__(1202),
	    toNumber = __webpack_require__(505);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide an options object to indicate whether `func` should be invoked on
	 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent calls
	 * to the debounced function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(501);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(494),
	    isHostObject = __webpack_require__(297),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(488),
	    baseKeys = __webpack_require__(1138),
	    indexKeys = __webpack_require__(1167),
	    isArrayLike = __webpack_require__(209),
	    isIndex = __webpack_require__(495),
	    isPrototype = __webpack_require__(1172);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(296);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(212)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(309);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(307)
	  , TAG = __webpack_require__(61)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 307 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(214)
	  , call        = __webpack_require__(513)
	  , isArrayIter = __webpack_require__(512)
	  , anObject    = __webpack_require__(305)
	  , toLength    = __webpack_require__(314)
	  , getIterFn   = __webpack_require__(520);
	module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(516)
	  , $export        = __webpack_require__(92)
	  , redefine       = __webpack_require__(125)
	  , hide           = __webpack_require__(124)
	  , has            = __webpack_require__(217)
	  , Iterators      = __webpack_require__(164)
	  , $iterCreate    = __webpack_require__(1234)
	  , setToStringTag = __webpack_require__(218)
	  , getProto       = __webpack_require__(59).getProto
	  , ITERATOR       = __webpack_require__(61)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getProto($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(219)('meta')
	  , isObject = __webpack_require__(309)
	  , has      = __webpack_require__(217)
	  , setDesc  = __webpack_require__(59).setDesc
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(163)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 312 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 313 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(313)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(1239)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(310)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 316 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!style.hasOwnProperty(key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 319 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!style.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(223);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _PatternUtils = __webpack_require__(143);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(223);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(142);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken && stripe.createPaymentMethod && stripe.handleCardPayment) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && nextProps.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(nextProps.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(145);
	var Danger = __webpack_require__(1302);
	var ReactMultiChildUpdateTypes = __webpack_require__(549);
	var ReactPerf = __webpack_require__(62);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(334);
	var setInnerHTML = __webpack_require__(340);
	var setTextContent = __webpack_require__(563);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getNativeNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  replaceDelimitedText: 'replaceDelimitedText'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(127);
	var ReactDOMInstrumentation = __webpack_require__(1320);
	var ReactPerf = __webpack_require__(62);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1360);
	var warning = __webpack_require__(17);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          // No HAS_SIDE_EFFECTS logic here, only `value` has it and is string.
	          node[propName] = false;
	        } else {
	          if (!propertyInfo.hasSideEffects || '' + node[propName] !== '') {
	            node[propName] = '';
	          }
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var ReactErrorUtils = __webpack_require__(330);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : void 0;
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(dispatchInstance);
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(553);
	var ReactPropTypeLocations = __webpack_require__(229);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 331 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 336 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 337 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 338 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(334);
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  node.innerHTML = html;
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactElement = __webpack_require__(73);
	
	var getIteratorFn = __webpack_require__(338);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var emptyFunction = __webpack_require__(57);
	var warning = __webpack_require__(17);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerDidChange = routerDidChange;
	exports.initRoutes = initRoutes;
	exports.replaceRoutes = replaceRoutes;
	exports.historyAPI = historyAPI;
	
	var _constants = __webpack_require__(129);
	
	/**
	 * Action creator for signaling that the router has changed.
	 * @private
	 * @param  {RouterState} state - New router state
	 * @return {Action} Action object
	 */
	
	function routerDidChange(state) {
	  return {
	    type: _constants.ROUTER_DID_CHANGE,
	    payload: state
	  };
	}
	
	/**
	 * Action creator that initiates route config
	 * @private
	 * @param {Array<Route>|ReactElement} routes - New routes
	 */
	
	function initRoutes(routes) {
	  return {
	    type: _constants.INIT_ROUTES,
	    payload: routes
	  };
	}
	
	/**
	 * Action creator that replaces the current route config
	 * @private
	 * @param {Array<Route>|ReactElement} routes - New routes
	 */
	
	function replaceRoutes(routes) {
	  return {
	    type: _constants.REPLACE_ROUTES,
	    payload: routes
	  };
	}
	
	/**
	 * Creates an action creator for calling a history API method.
	 * @param {string} method - Name of method
	 * @returns {ActionCreator} Action creator with same parameters as corresponding
	 * history method
	 */
	
	function historyAPI(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: _constants.HISTORY_API,
	      payload: {
	        method: method,
	        args: args
	      }
	    };
	  };
	}
	
	var push = historyAPI('push');
	exports.push = push;
	var replace = historyAPI('replace');
	exports.replace = replace;
	var setState = historyAPI('setState');
	exports.setState = setState;
	var go = historyAPI('go');
	exports.go = go;
	var goBack = historyAPI('goBack');
	exports.goBack = goBack;
	var goForward = historyAPI('goForward');
	exports.goForward = goForward;

/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = {
	  // latin
	  'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
	  'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
	  'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
	  'Õ': 'O', 'Ö': 'O', 'Ő': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U',
	  'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH', 'ß': 'ss', 'à':'a', 'á':'a',
	  'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
	  'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
	  'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
	  'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
	  'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ẞ': 'SS',
	
	  // greek
	  'α':'a', 'β':'b', 'γ':'g', 'δ':'d', 'ε':'e', 'ζ':'z', 'η':'h', 'θ':'8',
	  'ι':'i', 'κ':'k', 'λ':'l', 'μ':'m', 'ν':'n', 'ξ':'3', 'ο':'o', 'π':'p',
	  'ρ':'r', 'σ':'s', 'τ':'t', 'υ':'y', 'φ':'f', 'χ':'x', 'ψ':'ps', 'ω':'w',
	  'ά':'a', 'έ':'e', 'ί':'i', 'ό':'o', 'ύ':'y', 'ή':'h', 'ώ':'w', 'ς':'s',
	  'ϊ':'i', 'ΰ':'y', 'ϋ':'y', 'ΐ':'i',
	  'Α':'A', 'Β':'B', 'Γ':'G', 'Δ':'D', 'Ε':'E', 'Ζ':'Z', 'Η':'H', 'Θ':'8',
	  'Ι':'I', 'Κ':'K', 'Λ':'L', 'Μ':'M', 'Ν':'N', 'Ξ':'3', 'Ο':'O', 'Π':'P',
	  'Ρ':'R', 'Σ':'S', 'Τ':'T', 'Υ':'Y', 'Φ':'F', 'Χ':'X', 'Ψ':'PS', 'Ω':'W',
	  'Ά':'A', 'Έ':'E', 'Ί':'I', 'Ό':'O', 'Ύ':'Y', 'Ή':'H', 'Ώ':'W', 'Ϊ':'I',
	  'Ϋ':'Y',
	
	  // turkish
	  'ş':'s', 'Ş':'S', 'ı':'i', 'İ':'I', 'ç':'c', 'Ç':'C', 'ü':'u', 'Ü':'U',
	  'ö':'o', 'Ö':'O', 'ğ':'g', 'Ğ':'G',
	
	  // russian
	  'а':'a', 'б':'b', 'в':'v', 'г':'g', 'д':'d', 'е':'e', 'ё':'yo', 'ж':'zh',
	  'з':'z', 'и':'i', 'й':'j', 'к':'k', 'л':'l', 'м':'m', 'н':'n', 'о':'o',
	  'п':'p', 'р':'r', 'с':'s', 'т':'t', 'у':'u', 'ф':'f', 'х':'h', 'ц':'c',
	  'ч':'ch', 'ш':'sh', 'щ':'sh', 'ъ':'u', 'ы':'y', 'ь':'', 'э':'e', 'ю':'yu',
	  'я':'ya',
	  'А':'A', 'Б':'B', 'В':'V', 'Г':'G', 'Д':'D', 'Е':'E', 'Ё':'Yo', 'Ж':'Zh',
	  'З':'Z', 'И':'I', 'Й':'J', 'К':'K', 'Л':'L', 'М':'M', 'Н':'N', 'О':'O',
	  'П':'P', 'Р':'R', 'С':'S', 'Т':'T', 'У':'U', 'Ф':'F', 'Х':'H', 'Ц':'C',
	  'Ч':'Ch', 'Ш':'Sh', 'Щ':'Sh', 'Ъ':'U', 'Ы':'Y', 'Ь':'', 'Э':'E', 'Ю':'Yu',
	  'Я':'Ya',
	
	  // ukranian
	  'Є':'Ye', 'І':'I', 'Ї':'Yi', 'Ґ':'G', 'є':'ye', 'і':'i', 'ї':'yi', 'ґ':'g',
	
	  // czech
	  'č':'c', 'ď':'d', 'ě':'e', 'ň': 'n', 'ř':'r', 'š':'s', 'ť':'t', 'ů':'u',
	  'ž':'z', 'Č':'C', 'Ď':'D', 'Ě':'E', 'Ň': 'N', 'Ř':'R', 'Š':'S', 'Ť':'T',
	  'Ů':'U', 'Ž':'Z',
	
	  // polish
	  'ą':'a', 'ć':'c', 'ę':'e', 'ł':'l', 'ń':'n', 'ó':'o', 'ś':'s', 'ź':'z',
	  'ż':'z', 'Ą':'A', 'Ć':'C', 'Ę':'e', 'Ł':'L', 'Ń':'N', 'Ś':'S',
	  'Ź':'Z', 'Ż':'Z',
	
	  // latvian
	  'ā':'a', 'č':'c', 'ē':'e', 'ģ':'g', 'ī':'i', 'ķ':'k', 'ļ':'l', 'ņ':'n',
	  'š':'s', 'ū':'u', 'ž':'z', 'Ā':'A', 'Č':'C', 'Ē':'E', 'Ģ':'G', 'Ī':'i',
	  'Ķ':'k', 'Ļ':'L', 'Ņ':'N', 'Š':'S', 'Ū':'u', 'Ž':'Z'
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*global ActiveXObject:true*/
	
	var defaults = __webpack_require__(347);
	var utils = __webpack_require__(86);
	var buildUrl = __webpack_require__(577);
	var parseHeaders = __webpack_require__(579);
	var transformData = __webpack_require__(581);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  // Transform request data
	  var data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Merge headers
	  var requestHeaders = utils.merge(
	    defaults.headers.common,
	    defaults.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  if (utils.isFormData(data)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  // Create the request
	  var request = new (XMLHttpRequest || ActiveXObject)('Microsoft.XMLHTTP');
	  request.open(config.method.toUpperCase(), buildUrl(config.url, config.params), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request.onreadystatechange = function () {
	    if (request && request.readyState === 4) {
	      // Prepare the response
	      var responseHeaders = parseHeaders(request.getAllResponseHeaders());
	      var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
	      var response = {
	        data: transformData(
	          responseData,
	          responseHeaders,
	          config.transformResponse
	        ),
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config
	      };
	
	      // Resolve or reject the Promise based on the status
	      (request.status >= 200 && request.status < 300 ?
	        resolve :
	        reject)(response);
	
	      // Clean up request
	      request = null;
	    }
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(578);
	    var urlIsSameOrigin = __webpack_require__(582);
	
	    // Add xsrf header
	    var xsrfValue = urlIsSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName || defaults.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  utils.forEach(requestHeaders, function (val, key) {
	    // Remove Content-Type if data is undefined
	    if (!data && key.toLowerCase() === 'content-type') {
	      delete requestHeaders[key];
	    }
	    // Otherwise add header to the request
	    else {
	      request.setRequestHeader(key, val);
	    }
	  });
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  if (utils.isArrayBuffer(data)) {
	    data = new DataView(data);
	  }
	
	  // Send the request
	  request.send(data);
	};


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function (data, headers) {
	    if(utils.isFormData(data)) {
	      return data;
	    }
	    if (utils.isArrayBuffer(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function (val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function (data) {
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN'
	};


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchUserEditorials = fetchUserEditorials;
	exports.fetchProfileEditorials = fetchProfileEditorials;
	exports.fetchCases = fetchCases;
	exports.clearCollection = clearCollection;
	exports.clearSingle = clearSingle;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function receiveData(type, key, json) {
		return {
			type: type,
			key: key,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.RECV_ERROR,
			payload: json
		};
	};
	
	function fetchGeneric(url, type) {
		var key = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
		var cb = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];
	
		return function (dispatch) {
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				if (key && response.data[key]) {
					dispatch(receiveData(type, key, response.data[key]));
				} else {
					dispatch(receiveData(type, key, response.data));
				}
	
				cb(true);
			}).catch(function (response) {
				dispatch(receiveError(response.data));
	
				//dispatch(pushState(null, '/error'));
				cb(false);
			});
		};
	}
	
	function fetchSingle(url) {
		return fetchGeneric(url, actionTypes.ACCOUNT_RECV_SINGLE);
	};
	
	function fetchCollection(url, key, cb) {
		return fetchGeneric(url, actionTypes.ACCOUNT_RECV_COLLECTION, key, cb);
	};
	
	function fetchUserEditorials(type, cb) {
		return fetchCollection(_baseUrl2.default + '/api/account/editorials/' + type, 'editorials', cb);
	}
	
	function fetchProfileEditorials(type, cb) {
		return fetchCollection(_baseUrl2.default + '/api/account/profiles/editorials/' + type, 'editorials', cb);
	}
	
	function fetchCases() {
		var cb = arguments.length <= 0 || arguments[0] === undefined ? function () {} : arguments[0];
	
		return fetchCollection(_baseUrl2.default + '/api/account/profiles/cases', 'cases', cb);
	}
	
	function clearCollection() {
		return { type: actionTypes.ACCOUNT_CLEAR_COLLECTION };
	}
	
	function clearSingle() {
		return { type: actionTypes.ACCOUNT_CLEAR_SINGLE };
	}

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toggleMenu = toggleMenu;
	exports.closeMenu = closeMenu;
	exports.toggleSearchMenu = toggleSearchMenu;
	exports.fetchMenu = fetchMenu;
	exports.setActiveMenu = setActiveMenu;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toggleMenu() {
		return {
			type: actionTypes.MENU_TOGGLE
		};
	};
	
	function closeMenu() {
		return {
			type: actionTypes.MENU_CLOSE
		};
	};
	
	function toggleSearchMenu(menu) {
		return {
			type: actionTypes.MENU_TOGGLE_SEARCH,
			payload: menu
		};
	};
	
	function requestData() {
		return { type: actionTypes.MENU_REQ_DATA };
	};
	
	function receiveData(json) {
		return {
			type: actionTypes.MENU_RECV_DATA,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.MENU_RECV_ERROR,
			payload: json
		};
	};
	
	function fetchMenu(menu) {
		if (menu !== 'footer' && menu !== 'social') {
			menu = 'header';
		}
	
		//console.log(`Fetching menu: ${menu}`);
	
		return function (dispatch) {
			dispatch(requestData());
			return (0, _axios2.default)({
				url: _baseUrl2.default + '/api/navigation/' + menu,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(receiveData(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
	
				//dispatch(pushState(null, '/error'));
				console.log('menu fetch error');
				console.log(response.data);
			});
		};
	};
	
	function setActiveMenu(menu) {
		return {
			type: actionTypes.MENU_UPDATE_SUB,
			payload: menu
		};
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchTimeline = fetchTimeline;
	exports.setFilter = setFilter;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFetching = 0;
	
	function createAction(type) {
		return { type: type };
	}
	
	function createResponse(json, type) {
		// console.log(type);
		return {
			type: type,
			payload: json
		};
	}
	
	function createDispatch(dispatch, action, data, params) {
		if (action === _actions.TIMELINE_RECV_INIT_DATA) {
			dispatch(createResponse({
				params: params,
				data: data
			}, action));
		} else {
			dispatch(createResponse(data, action));
		}
	}
	
	function processData(dispatch, action, url, params, data) {
		// console.log('~~ PROCESSING DATA ~~');
		if (action === _actions.TIMELINE_RECV_INIT_DATA || action === _actions.TIMELINE_RECV_PREV_DATA) {
			var skipCount = 0;
			for (var i = 0; i < data.items.length; i++) {
				if (data.items[i].hero) {
					skipCount = 0;
					break;
				}
	
				skipCount++;
			}
	
			if (skipCount >= 20 && data.prev) {
				(function () {
					// console.log('SKIPCOUNT IS TOO DAMN HIGH -- ' + skipCount);
					var url = data.prev;
					url = url.replace(/^.*\/\/[^\/]+/, '');
					_axios2.default.get(url).then(function (res) {
						var newData = _extends({}, data);
						if (res.data && res.data.items) {
							var pageSplitter = [{
								type: 'page-indicator',
								uid: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
							}];
	
							newData.items = res.data.items.concat(pageSplitter).concat(data.items);
							newData.prev = res.data.prev;
						}
						processData(dispatch, action, url, params, newData);
					}).catch(function (res) {
						console.log('TIMELINE -- FAILED PULLING EXTRA DATA');
					});
				})();
			} else {
				createDispatch(dispatch, action, data, params);
			}
		} else {
			createDispatch(dispatch, action, data, params);
		}
	}
	
	function fetchTimeline() {
		var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		var url = arguments.length <= 1 || arguments[1] === undefined ? '/api/timeline/' : arguments[1];
		var direction = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
		// console.log('called fetchTimeline');
		if (isFetching) {
			// console.log('is already fetching');
			// return { type: 'NOOP' };
		}
	
		url = _baseUrl2.default + url;
	
		// strip domain from url
		url = url.replace(/^.*\/\/[^\/]+/, '');
	
		var action = direction ? direction === _actions.TIMELINE_FETCH_NEXT ? _actions.TIMELINE_RECV_NEXT_DATA : _actions.TIMELINE_RECV_PREV_DATA : _actions.TIMELINE_RECV_INIT_DATA;
		// console.log(`Fetching timeline - ACTION: ${action} - DIRECTION: ${direction}`);
	
		return function (dispatch) {
			var buildParams = { filter: {} };
			if (action === _actions.TIMELINE_RECV_INIT_DATA) {
				dispatch(createAction(_actions.TIMELINE_CLEAR_DATA));
	
				if (params && Object.keys(params).length) {
					//console.log(params);
					buildParams = {
						params: params
					};
				}
			}
	
			var filtered = !!(buildParams.params && buildParams.params.filter);
	
			dispatch(createAction(_actions.TIMELINE_REQ_DATA));
			isFetching = true;
			return _axios2.default.get(url, buildParams).then(function (response) {
				processData(dispatch, action, url, buildParams, response.data);
	
				if (filtered) {
					window.scrollTo(0, 20);
				}
	
				isFetching = false;
			}).catch(function (response) {
				dispatch(createResponse(response.data, _actions.TIMELINE_RECV_ERROR));
				isFetching = false;
	
				if (filtered) {
					window.scrollTo(0, 20);
				}
	
				console.log('timeline - fetch error');
				console.log(response);
	
				// dispatch(pushState(null, '/error'));
			});
		};
	}
	
	function setFilter() {
		var filter = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		return createResponse(filter, _actions.TIMELINE_FILTER);
	}

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _routes = __webpack_require__(4);
	
	var _editorialListItem = __webpack_require__(984);
	
	var _editorialListItem2 = _interopRequireDefault(_editorialListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountBlockCategoryList = function (_Component) {
		_inherits(AccountBlockCategoryList, _Component);
	
		function AccountBlockCategoryList(props) {
			_classCallCheck(this, AccountBlockCategoryList);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountBlockCategoryList).call(this));
		}
	
		_createClass(AccountBlockCategoryList, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var Component = this.props.compComponent;
	
				return _react2.default.createElement(
					'div',
					{ className: 'editoriallist' },
					_react2.default.createElement(
						'aside',
						{ className: 'span5 span5-tablet span14-mobile editoriallist__aside' },
						this.props.title
					),
					_react2.default.createElement(
						'div',
						{ className: 'push5 push5-tablet push0-mobile span9 span9-tablet span14-mobile editoriallist__content' },
						Component && this.props.content.length && this.props.content.map(function (item, k) {
							return _react2.default.createElement(Component, { key: 'eitem' + k, item: item, type: _this2.props.type, browser: _this2.props.browser, data: _this2.props.data });
						}) || null
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}]);
	
		return AccountBlockCategoryList;
	}(_react.Component);
	
	AccountBlockCategoryList.propTypes = {
		title: _react.PropTypes.string,
		content: _react.PropTypes.array.isRequired,
		type: _react.PropTypes.string.isRequired,
		browser: _react.PropTypes.object.isRequired,
		compComponent: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.func]).isRequired,
		data: _react.PropTypes.object
	};
	AccountBlockCategoryList.defaultProps = {
		title: '',
		content: [],
		type: '',
		compComponent: false
	};
	exports.default = AccountBlockCategoryList;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _submit = __webpack_require__(985);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import CornerLabel from '../../components/block/cornerLabel';
	
	var AccountBlockSubmit = function (_Component) {
		_inherits(AccountBlockSubmit, _Component);
	
		function AccountBlockSubmit(props) {
			_classCallCheck(this, AccountBlockSubmit);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountBlockSubmit).call(this));
		}
	
		_createClass(AccountBlockSubmit, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-block-submit pixel-pattern pixel-pattern--01' },
					_react2.default.createElement(
						'div',
						{ className: 'push5 push0-mobile account-block-submit__content' },
						this.props.children
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}]);
	
		return AccountBlockSubmit;
	}(_react.Component);
	
	exports.default = AccountBlockSubmit;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropzone = __webpack_require__(236);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	var _dropzoneGrid = __webpack_require__(622);
	
	var _dropzoneGrid2 = _interopRequireDefault(_dropzoneGrid);
	
	var _tagselect = __webpack_require__(179);
	
	var _tagselect2 = _interopRequireDefault(_tagselect);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _multicheckbox = __webpack_require__(367);
	
	var _multicheckbox2 = _interopRequireDefault(_multicheckbox);
	
	var _caseExtra = __webpack_require__(1073);
	
	var _caseExtra2 = _interopRequireDefault(_caseExtra);
	
	var _devicepicker = __webpack_require__(986);
	
	var _devicepicker2 = _interopRequireDefault(_devicepicker);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _device_d = __webpack_require__(1074);
	
	var _device_d2 = _interopRequireDefault(_device_d);
	
	var _device_tp = __webpack_require__(1078);
	
	var _device_tp2 = _interopRequireDefault(_device_tp);
	
	var _device_tl = __webpack_require__(1077);
	
	var _device_tl2 = _interopRequireDefault(_device_tl);
	
	var _device_mp = __webpack_require__(1076);
	
	var _device_mp2 = _interopRequireDefault(_device_mp);
	
	var _device_ml = __webpack_require__(1075);
	
	var _device_ml2 = _interopRequireDefault(_device_ml);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _types = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	
	// import Splitter from '../block/splitter';
	
	// import InputDropzoneVideo from '../../form/dropzone/dropzoneVideo';
	
	// import * as actions from '../../actions/account';
	// const MOBILE = 'Mobile';
	// const TABLET = 'Tablet';
	// const DESKTOP = 'Desktop';
	
	var CaseEditForm = function (_Component) {
		_inherits(CaseEditForm, _Component);
	
		function CaseEditForm(props) {
			_classCallCheck(this, CaseEditForm);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseEditForm).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				profileCreated: false,
				types: [],
				categories: [],
				selectedType: props.case.typeId || false,
				selectedDevice: props.case.bestViewedOn || _types.DEVICE_DESKTOP
			};
			return _this;
		}
	
		_createClass(CaseEditForm, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.all([_axios2.default.get(_baseUrl2.default + '/api/account/projects/types'), _axios2.default.get(_baseUrl2.default + '/api/account/projects/categories')]).then(_axios2.default.spread(function (typesResponse, categoriesResponse) {
					var newState = _extends({}, _this2.state);
					if (typesResponse.data && typesResponse.data.types) {
						newState.types = function (types) {
							var formattedTypes = [];
	
							for (var i = 0; i < types.length; i++) {
								// let optimizedFor = [];
								//
								// types[i].desktop && optimizedFor.push(DESKTOP);
								// types[i].tablet && optimizedFor.push(TABLET);
								// types[i].mobile && optimizedFor.push(MOBILE);
								//
								// if (!types[i].desktop && !types[i].tablet && !types[i].mobile) {
								// 	// if none are selected in CMS.. add desktop anyway -- REBEL!
								// 	optimizedFor.push(DESKTOP);
								// }
	
								formattedTypes.push({
									id: types[i].id,
									value: types[i].id,
									label: types[i].name,
									// optimizedFor: optimizedFor,
									desktop: !!types[i].desktop,
									tablet: !!types[i].tablet,
									mobile: !!types[i].mobile
								});
							}
							return formattedTypes;
						}(typesResponse.data.types);
					}
	
					if (categoriesResponse.data && categoriesResponse.data.categories) {
						newState.categories = function (categories) {
							var formattedCategories = [];
							for (var i = 0; i < categories.length; i++) {
								formattedCategories.push({
									id: categories[i].id,
									label: categories[i].name
								});
							}
							return formattedCategories;
						}(categoriesResponse.data.categories);
					}
	
					_this2.mounted && _this2.setState(newState);
				})).catch(function () {
					// console.log(res);
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var uploadSize = this.getUploadSize();
				var type = this.findType(this.state.selectedType);
				return _react2.default.createElement(
					_form2.default,
					{
						dispatch: this.props.dispatch,
						getRefs: function getRefs() {
							return _this3.getRefs();
						},
						method: this.props.method,
						action: this.props.path,
						smallAside: this.props.smallAside,
						onSubmit: this.props.onSubmit,
						head: this.props.head,
						ref: 'form'
					},
					_react2.default.createElement(
						_content2.default,
						{ title: 'Basic description', smallAside: this.props.smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'title', name: 'title', value: this.props.case.title, label: 'Project name' }),
							_react2.default.createElement(_label2.default, { label: 'Project Type' }),
							_react2.default.createElement(_select2.default, {
								ref: 'typeId',
								name: 'typeId',
								value: this.props.case.typeId,
								options: this.state.types,
								placeholder: 'Select project type',
								onChange: function onChange(val) {
									return _this3.setState(_extends({}, _this3.state, { selectedType: val }));
								}
							})
						),
						!!type && _react2.default.createElement(
							_formfitter2.default,
							{ className: 'span100p' },
							_react2.default.createElement(_label2.default, { label: 'Device to be judged on' }),
							_react2.default.createElement(DevicePicker, _extends({
								ref: 'bestViewedOn',
								name: 'bestViewedOn'
							}, type, {
								value: this.props.case.bestViewedOn,
								onChange: function onChange(val) {
									return _this3.setState(_extends({}, _this3.state, { selectedDevice: val }));
								}
							}))
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span5 span5-tablet span11-mobile' },
							_react2.default.createElement(_textarea2.default, { ref: 'description', name: 'description', value: this.props.case.description, label: 'Short description', maxChars: 300, rows: 6 })
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'url', name: 'url', value: this.props.case.url, label: 'Project URL', btw: ' or case study URL for installations etc.' })
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Credits', smallAside: this.props.smallAside },
						_react2.default.createElement(_label2.default, { label: 'FWA Profile min. 1 required', btw: ' - all credited profiles will be able to edit the project after submission' }),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
							_react2.default.createElement(_tagselect2.default, {
								ref: 'credits',
								name: 'credits',
								value: this.props.case.credits,
								placeholder: 'Type to search for FWA Profiles',
								path: '/api/profiles/search',
								showLink: true,
								link: {
									url: _baseUrl2.default + '/account/profile/settings/',
									text: 'Create new',
									onClick: function onClick(e, val, createEntry) {
										e.preventDefault();
										var breakRegex = /<br\s*[\/]?>/gi;
	
										if (_this3.props.user && !_this3.props.user.profile && !_this3.state.profileCreated) {
											var confirmText = (0, _translate2.default)('account/casecreate/addProfilePopup', false).replace('%name%', val).replace(breakRegex, '\n');
											var buttonOk = 'Yes, create profile';
											var buttonCancel = 'No, just add a credit';
	
											_this3.refs.confirm.confirm(confirmText, buttonOk, buttonCancel).then(function () {
												_this3.setState(_extends({}, _this3.state, {
													profileCreated: true
												}));
												createEntry({
													myProfile: 1,
													onDelete: function onDelete() {
														_this3.setState(_extends({}, _this3.state, {
															profileCreated: false
														}));
													}
												});
											}).catch(function (res) {
												if (res.status !== 'CLOSED') {
													createEntry();
												}
											});
										} else {
											var _confirmText = (0, _translate2.default)('account/casecreate/addCreditPopup', false).replace('%name%', val).replace(breakRegex, '\n');
											var _buttonOk = 'Yes, add a credit';
											var _buttonCancel = 'Cancel';
	
											_this3.refs.confirm.confirm(_confirmText, _buttonOk, _buttonCancel).then(function () {
												createEntry();
											}).catch(function () {});
										}
									}
								},
								onChange: function onChange() {}
							})
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(_text2.default, { ref: 'createUserProfile', name: 'createUserProfile', type: 'hidden', value: this.state.profileCreated ? 1 : 0 })
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Categories', smallAside: this.props.smallAside },
						_react2.default.createElement(_label2.default, { label: 'Project categories', btw: ' - Min. 1 - max. 3' }),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span6 span8-tablet span100p-mobile' },
							_react2.default.createElement('div', { className: 'cf' }),
							_react2.default.createElement(_multicheckbox2.default, {
								name: 'categories',
								ref: 'categories',
								value: this.props.case.categories,
								maxChecked: 3,
								options: this.state.categories
							})
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Basic visuals', smallAside: this.props.smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span6 span100p-tablet span100p-mobile' },
							_react2.default.createElement(_label2.default, {
								label: 'Project Thumbnail',
								btw: ' 1076 · 672 jpg / png',
								helpText: (0, _translate2.default)('account/casecreate/thumbnailHelpText', true, false)
							}),
							_react2.default.createElement(_dropzone2.default, {
								ref: 'thumbnail',
								aspect: 672 / 1076,
								width: 270,
								path: this.props.path + '/image',
								inputs: [{ name: 'thumbnail', preview: this.getFirstImage(this.props.case.thumbnail) }],
								params: {
									device: this.state.selectedDevice || _types.DEVICE_DESKTOP
								},
								accept: 'image/*',
								recommended: {
									width: 1076,
									height: 672
								},
								disableDelete: true
							})
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span100p' },
							_react2.default.createElement(_label2.default, { label: '3 Project slide', btw: ' ' + uploadSize.width + ' · ' + uploadSize.height + ' jpg / png', helpText: (0, _translate2.default)('account/casecreate/slidesHelpText', true, false) }),
							_react2.default.createElement(_dropzone2.default, {
								ref: 'slides',
								aspect: 747 / 1169,
								width: 270,
								path: this.props.path + '/image',
								inputs: [{ name: 'slide1', preview: this.getFirstImage(this.props.case.slide1) }, { name: 'slide2', preview: this.getFirstImage(this.props.case.slide2) }, { name: 'slide3', preview: this.getFirstImage(this.props.case.slide3) }],
								params: {
									device: this.state.selectedDevice || _types.DEVICE_DESKTOP
								},
								accept: 'image/*',
								recommended: {
									width: uploadSize.width,
									height: uploadSize.height
								},
								disableDelete: true
							})
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'showreelUrl', name: 'showreelUrl', value: this.props.case.showreelUrl, label: 'PROJECT DEMO REEL/VIDEO', btw: ' Optional', placeholder: 'Youtube or Vimeo URL/ID' })
						)
					),
					_react2.default.createElement(
						_content2.default,
						{
							title: _react2.default.createElement(
								'span',
								null,
								'Case extras (optional)',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'span',
									{ style: { fontSize: '0.8em' } },
									'Add extras now, later, or not at all'
								)
							),
							smallAside: this.props.smallAside
						},
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span100p account-process__info-section' },
							_react2.default.createElement(
								'div',
								{ className: 'span4-desktop span8-tablet span100p-mobile account-process__info-section__text' },
								_react2.default.createElement(
									'h3',
									{ className: 'account-process__info-section__text__head' },
									(0, _translate2.default)('account/casecreate/extraVisualTitle', true, true)
								),
								_react2.default.createElement('div', { className: 'account-process__info-section__text__content', dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/casecreate/extraVisual', true, false) } })
							),
							_react2.default.createElement(
								'div',
								{ className: 'span4-desktop span8-tablet span100p-mobile account-process__info-section__visual' },
								_react2.default.createElement('img', _extends({}, _caseExtra2.default, { alt: '' }))
							),
							_react2.default.createElement('div', { className: 'cf' })
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span7 span100p-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'extraTitle', name: 'extraTitle', value: this.props.case.extraTitle, maxChars: 300, label: 'Extra title ', btw: ' optional', placeholder: 'Extra title' }),
							_react2.default.createElement(_textarea2.default, {
								ref: 'extraText',
								name: 'extraText',
								value: this.props.case.extraText,
								maxChars: 1000,
								label: 'Extra text ',
								btw: ' optional',
								rows: 6,
								placeholder: 'Add a more elaborate description of your project that reveals, for example, nice details, things to notice or keep in mind. You could also mention the project\'s goals etc.'
							})
						),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span100p' },
							_react2.default.createElement(_label2.default, { label: 'Extra visuals optional', btw: ' 628 · 353 | 877 · 548 jpg / png / mp4' }),
							_react2.default.createElement(_dropzoneGrid2.default, {
								ref: 'extras',
								path: this.props.path + '/image',
								inputs: [{ name: 'extra1',
									aspect: 353 / 628,
									preview: this.getFirstImage(this.props.case.extra1),
									recommended: {
										width: 628,
										height: 353
									}
								}, { name: 'extra2',
									aspect: 353 / 628,
									preview: this.getFirstImage(this.props.case.extra2),
									recommended: {
										width: 628,
										height: 353
									}
								}, { name: 'extra3',
									aspect: 548 / 877,
									preview: this.getFirstImage(this.props.case.extra3),
									recommended: {
										width: 877,
										height: 548
									}
								}],
								accept: 'image/*, video/*'
							})
						)
					),
					this.props.foot
				);
			}
		}, {
			key: 'getFirstImage',
			value: function getFirstImage(img) {
				if ((typeof img === 'undefined' ? 'undefined' : _typeof(img)) !== 'object') {
					return '';
				}
	
				var bps = Object.keys(img);
				var span = Object.keys(img[bps[0]]);
				return img[bps[0]][span[0]];
			}
		}, {
			key: 'getUploadSize',
			value: function getUploadSize() {
				switch (this.state.selectedDevice) {
					case _types.DEVICE_TABLET_PORTRAIT:
						return {
							width: 1536,
							height: 2048
						};
					case _types.DEVICE_TABLET_LANDSCAPE:
						return {
							width: 2048,
							height: 1536
						};
					case _types.DEVICE_MOBILE_PORTRAIT:
						return {
							width: 750,
							height: 1334
						};
					case _types.DEVICE_MOBILE_LANDSCAPE:
						return {
							width: 1334,
							height: 750
						};
					case _types.DEVICE_DESKTOP:
					default:
						return {
							width: 1169,
							height: 747
						};
				}
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'findType',
			value: function findType(val) {
				for (var i = 0; i < this.state.types.length; i++) {
					if (this.state.types[i].id === val) {
						return this.state.types[i];
					}
				}
	
				return false;
			}
		}, {
			key: 'formatFocusOptions',
			value: function formatFocusOptions(type) {
				var options = [];
	
				if (type && type.optimizedFor) {
					for (var i = 0; i < type.optimizedFor.length; i++) {
						options.push({
							id: type.optimizedFor[i],
							value: type.optimizedFor[i],
							label: type.optimizedFor[i]
						});
					}
				}
	
				return options;
			}
		}]);
	
		return CaseEditForm;
	}(_react.Component);
	
	CaseEditForm.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		smallAside: _react.PropTypes.bool.isRequired,
		path: _react.PropTypes.string.isRequired,
		method: _react.PropTypes.string.isRequired,
	
		head: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]).isRequired,
		foot: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]).isRequired,
	
		case: _react.PropTypes.object,
	
		onSubmit: _react.PropTypes.func.isRequired
	};
	CaseEditForm.defaultProps = {
		smallAside: false,
		path: '',
		method: 'put',
	
		head: false,
		foot: false,
		case: {},
	
		onSubmit: function onSubmit() {}
	};
	exports.default = CaseEditForm;
	
	var DevicePicker = function (_Component2) {
		_inherits(DevicePicker, _Component2);
	
		function DevicePicker(props) {
			_classCallCheck(this, DevicePicker);
	
			var _this4 = _possibleConstructorReturn(this, Object.getPrototypeOf(DevicePicker).call(this));
	
			var firstChoice = _this4.firstChoice(props);
			_this4.value = firstChoice;
	
			_this4.devices = {
				DEVICE_DESKTOP: {
					img: _device_d2.default,
					name: false,
					orientation: 'Desktop',
					title: 'Desktop'
				},
				DEVICE_TABLET_PORTRAIT: {
					img: _device_tp2.default,
					name: 'Tablet',
					orientation: 'Portrait',
					title: 'Tablet - Portrait'
				},
				DEVICE_TABLET_LANDSCAPE: {
					img: _device_tl2.default,
					name: 'Tablet',
					orientation: 'Landscape',
					title: 'Tablet - Landscape'
				},
				DEVICE_MOBILE_PORTRAIT: {
					img: _device_mp2.default,
					name: 'Mobile',
					orientation: 'Portrait',
					title: 'Mobile - Portrait'
				},
				DEVICE_MOBILE_LANDSCAPE: {
					img: _device_ml2.default,
					name: 'Mobile',
					orientation: 'Landscape',
					title: 'Mobile - Landscape'
				}
			};
	
			_this4.state = {
				selected: firstChoice
			};
			return _this4;
		}
	
		_createClass(DevicePicker, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var firstChoice = this.firstChoice(this.props);
				this.value = firstChoice;
	
				this.props.onChange(firstChoice);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.desktop !== this.props.desktop || nextProps.tablet !== this.props.tablet || nextProps.mobile !== this.props.mobile) {
					var firstChoice = this.firstChoice(nextProps);
					this.value = firstChoice;
	
					this.props.onChange(firstChoice);
	
					this.setState(_extends({}, this.state, {
						selected: firstChoice
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'devicepicker pixel-pattern pixel-pattern--01' },
					_react2.default.createElement(
						'div',
						{ className: 'devicepicker__inner' },
						this.renderChoice(_types.DEVICE_DESKTOP, this.props.desktop),
						this.renderChoice(_types.DEVICE_TABLET_PORTRAIT, this.props.tablet),
						this.renderChoice(_types.DEVICE_TABLET_LANDSCAPE, this.props.tablet),
						this.renderChoice(_types.DEVICE_MOBILE_PORTRAIT, this.props.mobile),
						this.renderChoice(_types.DEVICE_MOBILE_LANDSCAPE, this.props.mobile),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'renderChoice',
			value: function renderChoice(opt, show) {
				var _this5 = this;
	
				var className = 'devicepicker__inner__item';
				if (show) {
					className += ' devicepicker__inner__item--show';
				}
	
				var img = this.devices[opt].img;
				var imgTitle = this.devices[opt].title;
	
				return _react2.default.createElement(
					'div',
					{ className: className, onClick: function onClick() {
							return _this5.select(opt);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'devicepicker__inner__item__icon' },
						_react2.default.createElement('img', _extends({}, img, { width: img.width / 2, height: img.height / 2, alt: imgTitle }))
					),
					_react2.default.createElement(
						'div',
						{ className: 'devicepicker__inner__item__name' },
						this.devices[opt].name || ' '
					),
					_react2.default.createElement(
						'div',
						{ className: 'devicepicker__inner__item__orientation' },
						this.devices[opt].orientation
					),
					_react2.default.createElement(
						'div',
						{ className: 'devicepicker__inner__item__checkbox' },
						_react2.default.createElement(_checkbox2.default, { name: opt, onChange: function onChange() {
								return _this5.select(opt);
							}, value: this.state.selected === opt })
					)
				);
			}
		}, {
			key: 'select',
			value: function select(val) {
				this.value = val;
				this.setState(_extends({}, this.state, {
					selected: val
				}));
				this.props.onChange(val);
			}
		}, {
			key: 'firstChoice',
			value: function firstChoice(props) {
				if (props.value) {
					if (props.desktop && props.value === _types.DEVICE_DESKTOP) {
						return props.value;
					} else if (props.tablet && (props.value === _types.DEVICE_TABLET_PORTRAIT || props.value === _types.DEVICE_TABLET_LANDSCAPE)) {
						return props.value;
					} else if (props.mobile && (props.value === _types.DEVICE_MOBILE_PORTRAIT || props.value === _types.DEVICE_MOBILE_LANDSCAPE)) {
						return props.value;
					}
				}
	
				if (props.desktop) {
					return _types.DEVICE_DESKTOP;
				} else if (props.tablet) {
					return _types.DEVICE_TABLET_PORTRAIT;
				} else if (props.mobile) {
					return _types.DEVICE_MOBILE_PORTRAIT;
				}
	
				return _types.DEVICE_DESKTOP;
			}
		}]);
	
		return DevicePicker;
	}(_react.Component);
	
	DevicePicker.propTypes = {
		desktop: _react.PropTypes.bool.isRequired,
		tablet: _react.PropTypes.bool.isRequired,
		mobile: _react.PropTypes.bool.isRequired,
		onChange: _react.PropTypes.func,
		value: _react.PropTypes.string
	};
	DevicePicker.defaultProps = {
		desktop: true,
		tablet: false,
		mobile: false,
		onChange: function onChange() {}
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _caseEditForm = __webpack_require__(353);
	
	var _caseEditForm2 = _interopRequireDefault(_caseEditForm);
	
	var _stepGeneric = __webpack_require__(171);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountCaseCreateStep1 = function (_Component) {
		_inherits(AccountCaseCreateStep1, _Component);
	
		function AccountCaseCreateStep1(props) {
			_classCallCheck(this, AccountCaseCreateStep1);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStep1).call(this));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(AccountCaseCreateStep1, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				var path = '/api/account/projects/create';
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 1,
						stepNumber: '01',
						stepTitle: 'Project',
						summary: this.renderSummary()
					},
					_react2.default.createElement(_caseEditForm2.default, {
						ref: 'form',
						path: path,
						method: 'post',
						smallAside: true,
						onSubmit: this.props.onSubmit,
						foot: this.renderFooter(),
						dispatch: this.props.dispatch,
						user: this.props.user
					})
				);
			}
		}, {
			key: 'renderSummary',
			value: function renderSummary() {
				var _this2 = this;
	
				var active = this.props.activeStep > 1;
				var className = 'account-block-content__content__summary';
				if (active) {
					className += ' account-block-content__content__summary--active';
				}
	
				var form = this.refs.form;
				var formRefs = form && form.refs ? form.refs : false;
	
				var type = formRefs && formRefs.type && formRefs.type.value ? formRefs.type.value : '';
				var name = formRefs && formRefs.title && typeof formRefs.title.value === 'function' ? formRefs.title.value() : '';
	
				var credits = [];
				if (formRefs && formRefs.credits && formRefs.credits.value) {
					for (var i = 0; i < formRefs.credits.value.length; i++) {
						credits.push(formRefs.credits.value[i].name);
					}
				}
				credits = credits.join(', ');
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					active && this.props.activeStep !== 4 && _react2.default.createElement(
						'button',
						{ className: 'button account-block-content__content__summary__button', onClick: function onClick() {
								_this2.props.goToStep();
							} },
						'Edit'
					),
					_react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'strong',
							null,
							type + (type && name ? ', ' : '') + name
						),
						_react2.default.createElement('br', null),
						credits
					)
				);
			}
		}, {
			key: 'renderFooter',
			value: function renderFooter() {
				return _react2.default.createElement(
					_content2.default,
					{ className: 'pixel-pattern pixel-pattern--01', smallAside: true },
					_react2.default.createElement(
						'div',
						{ className: 'span9 span100p-tablet span100p-mobile' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							_react2.default.createElement(
								'button',
								{ type: 'submit', className: 'button--dark' },
								'Continue'
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								'Next, you’ll complete the information that goes on the invoice and other formal details.'
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}]);
	
		return AccountCaseCreateStep1;
	}(_react.Component);
	
	AccountCaseCreateStep1.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		activeStep: _react.PropTypes.number.isRequired,
		goToStep: _react.PropTypes.func.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	AccountCaseCreateStep1.defaultProps = {
		active: false,
		goToStep: function goToStep() {},
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = AccountCaseCreateStep1;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _stepGeneric = __webpack_require__(171);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _cc = __webpack_require__(471);
	
	var _cc2 = _interopRequireDefault(_cc);
	
	var _cc3 = __webpack_require__(472);
	
	var _cc4 = _interopRequireDefault(_cc3);
	
	var _cc5 = __webpack_require__(473);
	
	var _cc6 = _interopRequireDefault(_cc5);
	
	var _cc7 = __webpack_require__(474);
	
	var _cc8 = _interopRequireDefault(_cc7);
	
	var _countries = __webpack_require__(285);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	// import { accountRoute } from '../../../routes';
	
	
	var AccountCaseCreateStep2 = function (_Component) {
		_inherits(AccountCaseCreateStep2, _Component);
	
		function AccountCaseCreateStep2() {
			_classCallCheck(this, AccountCaseCreateStep2);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStep2).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				submitting: false,
				showVAT: false,
				showVoucher: false
			};
			return _this;
		}
	
		_createClass(AccountCaseCreateStep2, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var path = '/api/account/projects/create/info';
				var smallAside = true;
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 2,
						stepNumber: '02',
						stepTitle: 'Information',
						summary: this.renderSummary()
					},
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this2.getRefs();
							}, ref: 'form', action: path, smallAside: smallAside, onSubmit: function onSubmit(pr) {
								return _this2.onSubmit(pr);
							}, dispatch: this.props.dispatch },
						_react2.default.createElement(
							_content2.default,
							{ title: 'Information', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span3 span5-tablet span11-mobile' },
								_react2.default.createElement(_text2.default, { ref: 'contact', name: 'contact', label: 'Contact', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'email', name: 'email', label: 'Email', btw: ' (For this submission\'s correspondence)' }),
								_react2.default.createElement(_text2.default, { ref: 'company', name: 'company', label: 'Company name', btw: ' (optional)' }),
								_react2.default.createElement(_label2.default, { label: 'Country' }),
								_react2.default.createElement(_select2.default, {
									name: 'country',
									ref: 'country',
									placeholder: 'Country',
									label: 'Country',
									ajaxOptionsUrl: _countries2.default
								}),
								_react2.default.createElement(_text2.default, { ref: 'address', name: 'address', label: 'Street and number', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'city', name: 'city', label: 'City and/or state', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'zip', name: 'zip', label: 'Postal or zip code', btw: '' })
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'V.A.T.', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span100p' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'vatEnabled', name: 'vatEnabled', label: '', onChange: function onChange(checked) {
											_this2.setState(_extends({}, _this2.state, { showVAT: checked }));
										}, className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'I have a V.A.T number'
									),
									' (Required for companies in the EU who are V.A.T. registered)'
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.showVAT ? '' : 'hide', style: { width: '144px' } },
									_react2.default.createElement(_text2.default, { ref: 'vat', name: 'vat', label: '', btw: '', placeholder: 'GB9999999' })
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'Voucher', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span3 span5-tablet span11-mobile' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'voucher', name: 'voucher', label: '', onChange: function onChange(checked) {
											_this2.setState(_extends({}, _this2.state, { showVoucher: checked }));
										}, className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'I have a voucher'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.showVoucher ? '' : 'hide' },
									_react2.default.createElement(_text2.default, { ref: 'voucherCode', name: 'voucherCode', label: '', btw: '', placeholder: 'Voucher code' })
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: '', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span100p' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'confirmOwnership', name: 'confirmOwnership', label: 'Confirm ownership', className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'Please confirm that you are either the creator or representative of the submitted project.'
									)
								),
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'confirmTerms', name: 'confirmTerms', label: 'Confirm terms', className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'Please confirm that FWA can publish images (and video if applicable) of the submitted project on thefwa.com'
									)
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ className: 'pixel-pattern pixel-pattern--01', smallAside: smallAside },
							_react2.default.createElement(
								'div',
								{ className: 'span100p' },
								_react2.default.createElement(
									'div',
									{ className: 'account-process__button-area' },
									_react2.default.createElement(_submit2.default, { name: 'Continue', className: 'button--dark', disabled: this.state.submitting, waiting: this.state.submitting }),
									!(this.state.showVoucher || this.props.skipPayment) && _react2.default.createElement(
										'span',
										{ className: 'account-process__button-area__button-desc' },
										(0, _translate2.default)('account/casecreate/continueUsingCC')
									),
									!(this.state.showVoucher || this.props.skipPayment) && _react2.default.createElement(
										'span',
										{ className: 'account-process__button-area__cc-line' },
										'Accepted credit/debit cards:',
										_react2.default.createElement(
											'div',
											{ className: 'account-process__button-area__cc-line__cc-container' },
											_react2.default.createElement('img', _extends({}, _cc2.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc4.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc6.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc8.default, { height: '22', width: '35', alt: '' }))
										)
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'renderSummary',
			value: function renderSummary() {
				var _this3 = this;
	
				var active = this.props.activeStep > 2;
				var className = 'account-block-content__content__summary';
				if (active) {
					className += ' account-block-content__content__summary--active';
				}
	
				var contact = this.refs.contact && typeof this.refs.contact.value === 'function' ? this.refs.contact.value() : '';
				var company = this.refs.company && typeof this.refs.company.value === 'function' ? this.refs.company.value() : '';
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					active && this.props.activeStep !== 4 && _react2.default.createElement(
						'button',
						{ className: 'button account-block-content__content__summary__button', onClick: function onClick() {
								_this3.props.goToStep();
							} },
						'Edit'
					),
					_react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'strong',
							null,
							contact
						),
						_react2.default.createElement('br', null),
						company
					)
				);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this4 = this;
	
				this.setState(_extends({}, this.state, {
					submitting: true
				}));
	
				promise.then(function (res) {
					var addedState = { customerInfo: _this4.refs.form.serialize() };
					if (res.data && res.data.case && res.data.case.slug) {
						addedState.slug = res.data.case.slug;
					}
	
					_this4.mounted && _this4.setState(_extends({}, _this4.state, {
						submitting: false
					}));
	
					if (_this4.state.showVoucher) {
						_this4.props.skipToEnd(addedState);
					} else {
						_this4.props.onSubmit(promise, addedState);
					}
				}).catch(function (res) {
					_this4.mounted && _this4.setState(_extends({}, _this4.state, {
						submitting: false
					}));
				});
			}
		}, {
			key: 'getForm',
			value: function getForm() {
				return this.refs.form;
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}]);
	
		return AccountCaseCreateStep2;
	}(_react.Component);
	
	AccountCaseCreateStep2.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		skipPayment: _react.PropTypes.bool,
		activeStep: _react.PropTypes.number.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	AccountCaseCreateStep2.defaultProps = {
		active: false,
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		},
		serialize: function serialize() {}
	};
	exports.default = AccountCaseCreateStep2;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _stepGeneric = __webpack_require__(171);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _users = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountCaseCreateStep4 = function (_Component) {
		_inherits(AccountCaseCreateStep4, _Component);
	
		function AccountCaseCreateStep4(props) {
			_classCallCheck(this, AccountCaseCreateStep4);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreateStep4).call(this));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(AccountCaseCreateStep4, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.activeStep !== 4 && nextProps.activeStep === 4) {
					this.props.dispatch((0, _users.getLogin)());
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var text = (0, _translate2.default)('account/casecreate/outro', true, false, '_self');
				text = text.replace('%case-link%', (0, _routes.casesRoute)(this.props.slug));
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 4,
						stepNumber: '04',
						stepTitle: 'Confirmation'
					},
					_react2.default.createElement(
						_content2.default,
						{ title: 'Submission successful', smallAside: true },
						_react2.default.createElement('div', { className: 'span5 span100p-mobile', dangerouslySetInnerHTML: { __html: text } })
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01', smallAside: true },
						_react2.default.createElement(
							'div',
							{ className: 'span100p' },
							_react2.default.createElement(
								'div',
								{ className: 'account-process__button-area' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.liveRoute)(), type: 'submit', className: 'button button--dark' },
									'Live Judging'
								),
								_react2.default.createElement(
									'span',
									{ className: 'account-process__button-area__button-desc' },
									'Go to the live judging page'
								)
							)
						)
					)
				);
			}
		}]);
	
		return AccountCaseCreateStep4;
	}(_react.Component);
	
	AccountCaseCreateStep4.propTypes = {
		activeStep: _react.PropTypes.number.isRequired,
		onSubmit: _react.PropTypes.func.isRequired,
		slug: _react.PropTypes.string.isRequired,
		dispatch: _react.PropTypes.func.isRequired
	};
	AccountCaseCreateStep4.defaultProps = {
		active: false,
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = AccountCaseCreateStep4;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _wysiwyg = __webpack_require__(370);
	
	var _wysiwyg2 = _interopRequireDefault(_wysiwyg);
	
	var _tagselect = __webpack_require__(179);
	
	var _tagselect2 = _interopRequireDefault(_tagselect);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as actions from '../../actions/account';
	
	var JobEditForm = function (_Component) {
		_inherits(JobEditForm, _Component);
	
		function JobEditForm() {
			_classCallCheck(this, JobEditForm);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JobEditForm).call(this));
	
			_this.state = {
				profileCreated: false
			};
			return _this;
		}
	
		_createClass(JobEditForm, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var job = this.props.job;
	
	
				return _react2.default.createElement(
					_form2.default,
					{ getRefs: function getRefs() {
							return _this2.getRefs();
						}, ref: 'form', method: 'put', action: this.props.path, smallAside: this.props.smallAside, onSubmit: this.props.onSubmit, head: this.props.head, dispatch: this.props.dispatch },
					_react2.default.createElement(
						_content2.default,
						{ title: 'Job vacancy at', smallAside: this.props.smallAside },
						_react2.default.createElement(_label2.default, { label: 'Company name', btw: ' (vacancies are posted to the FWA "JOBS" section and also to the FWA Profile page of FWA winners)' }),
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
							_react2.default.createElement(_tagselect2.default, {
								ref: 'company',
								name: 'company',
								value: job.profiles,
								placeholder: 'Type to search for FWA Profiles',
								maxSelected: 1,
								path: _baseUrl2.default + '/api/profiles/search',
								showLink: this.props.user && !this.props.user.profile && !this.state.profileCreated,
								link: {
									url: _baseUrl2.default + '/account/profile/settings/',
									text: 'Create profile',
									onClick: function onClick(e, val, createEntry) {
										e.preventDefault();
										var breakRegex = /<br\s*[\/]?>/gi;
										var confirmText = (0, _translate2.default)('account/jobcreate/addProfilePopup', false).replace('%name%', val).replace(breakRegex, '\n');
										var buttonOk = 'Yes, create profile';
										var buttonCancel = 'Cancel';
	
										_this2.refs.confirm.confirm(confirmText, buttonOk, buttonCancel).then(function () {
											_this2.setState(_extends({}, _this2.state, {
												profileCreated: true
											}));
											createEntry({
												myProfile: 1,
												onDelete: function onDelete() {
													_this2.setState(_extends({}, _this2.state, {
														profileCreated: false
													}));
												}
											});
										}).catch(function () {});
									}
								},
								onChange: function onChange() {}
							})
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Job basics', smallAside: this.props.smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'title', name: 'title', label: 'Job Title', btw: '', value: job.title, placeholder: 'Descriptive job title' }),
							_react2.default.createElement(_text2.default, { ref: 'address', name: 'address', label: 'Address (Optional)', btw: '', value: job.address, placeholder: 'Address' }),
							_react2.default.createElement(_text2.default, { ref: 'city', name: 'city', label: 'Location City', btw: '', value: job.city, placeholder: 'City' }),
							_react2.default.createElement(_text2.default, { ref: 'zip', name: 'zip', label: 'Postal or zipcode (Optional)', btw: '', value: job.zip, placeholder: 'Zipcode' }),
							_react2.default.createElement(_text2.default, { ref: 'country', name: 'country', label: 'Location Country', btw: '', value: job.country, placeholder: 'Country' })
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Job details', smallAside: this.props.smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span5 span8-tablet span11-mobile' },
							_react2.default.createElement(_label2.default, { label: 'Job description', btw: '' }),
							_react2.default.createElement(_wysiwyg2.default, { ref: 'description', label: 'Job description', name: 'description', value: job.description, placeholder: 'Describe the position' }),
							_react2.default.createElement(_label2.default, { label: 'How to apply', btw: '' }),
							_react2.default.createElement(_wysiwyg2.default, { ref: 'howTo', name: 'howTo', label: 'How to apply', value: job.howTo, placeholder: 'Describe how to apply' }),
							_react2.default.createElement(
								'span',
								{ className: 'custom-label__helptext' },
								'Make sure you don’t forget to add an email address to be published on the site or a URL for applicants to click on.'
							)
						)
					),
					this.props.foot
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}]);
	
		return JobEditForm;
	}(_react.Component);
	
	JobEditForm.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		smallAside: _react.PropTypes.bool.isRequired,
		path: _react.PropTypes.string.isRequired,
	
		head: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]).isRequired,
		foot: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]).isRequired,
		job: _react.PropTypes.object,
		user: _react.PropTypes.object.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	JobEditForm.defaultProps = {
		smallAside: false,
		path: '',
	
		head: false,
		foot: false,
		job: {},
	
		onSubmit: function onSubmit() {}
	};
	exports.default = JobEditForm;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _jobEditForm = __webpack_require__(357);
	
	var _jobEditForm2 = _interopRequireDefault(_jobEditForm);
	
	var _stepGeneric = __webpack_require__(172);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountJobCreateStep1 = function (_Component) {
		_inherits(AccountJobCreateStep1, _Component);
	
		function AccountJobCreateStep1(props) {
			_classCallCheck(this, AccountJobCreateStep1);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobCreateStep1).call(this));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(AccountJobCreateStep1, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				var path = '/api/account/jobs/create';
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 1,
						stepNumber: '01',
						stepTitle: 'Job vacancy',
						summary: this.renderSummary()
					},
					_react2.default.createElement(_jobEditForm2.default, { ref: 'form', path: path, method: 'post', smallAside: true, onSubmit: this.props.onSubmit, foot: this.renderFooter(), dispatch: this.props.dispatch, user: this.props.user })
				);
			}
		}, {
			key: 'renderSummary',
			value: function renderSummary() {
				var _this2 = this;
	
				var active = this.props.activeStep > 1;
				var className = 'account-block-content__content__summary';
				if (active) {
					className += ' account-block-content__content__summary--active';
				}
	
				var form = this.refs.form;
				var formRefs = form && form.refs ? form.refs : false;
	
				var title = formRefs && formRefs.title && typeof formRefs.title.value === 'function' ? formRefs.title.value() : '';
				var employer = formRefs && formRefs.company && formRefs.company.value && formRefs.company.value.length ? formRefs.company.value[0].name : '-';
				var city = formRefs && formRefs.city && typeof formRefs.city.value === 'function' ? formRefs.city.value() : '';
				var country = formRefs && formRefs.country && typeof formRefs.country.value === 'function' ? formRefs.country.value() : '';
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					active && this.props.activeStep !== 4 && _react2.default.createElement(
						'button',
						{ className: 'button account-block-content__content__summary__button', onClick: function onClick() {
								_this2.props.goToStep();
							} },
						'Edit'
					),
					_react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'strong',
							null,
							title
						),
						_react2.default.createElement('br', null),
						employer,
						city && country ? ', ' + city + ', ' + country : ''
					)
				);
			}
		}, {
			key: 'renderFooter',
			value: function renderFooter() {
				return _react2.default.createElement(
					_content2.default,
					{ className: 'pixel-pattern pixel-pattern--01', smallAside: true },
					_react2.default.createElement(
						'div',
						{ className: 'span9 span100p-tablet span100p-mobile' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							_react2.default.createElement(
								'button',
								{ type: 'submit', className: 'button--dark' },
								'Continue'
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								'Next, you’ll complete the information that goes on the invoice and other formal details.'
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}]);
	
		return AccountJobCreateStep1;
	}(_react.Component);
	
	AccountJobCreateStep1.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		activeStep: _react.PropTypes.number.isRequired,
		goToStep: _react.PropTypes.func.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	AccountJobCreateStep1.defaultProps = {
		active: false,
		goToStep: function goToStep() {},
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = AccountJobCreateStep1;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _stepGeneric = __webpack_require__(172);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _cc = __webpack_require__(475);
	
	var _cc2 = _interopRequireDefault(_cc);
	
	var _cc3 = __webpack_require__(476);
	
	var _cc4 = _interopRequireDefault(_cc3);
	
	var _cc5 = __webpack_require__(477);
	
	var _cc6 = _interopRequireDefault(_cc5);
	
	var _cc7 = __webpack_require__(478);
	
	var _cc8 = _interopRequireDefault(_cc7);
	
	var _countries = __webpack_require__(285);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	// import { accountRoute } from '../../../routes';
	
	
	var AccountJobCreateStep2 = function (_Component) {
		_inherits(AccountJobCreateStep2, _Component);
	
		function AccountJobCreateStep2(props) {
			_classCallCheck(this, AccountJobCreateStep2);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobCreateStep2).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				submitting: false,
				showVAT: false,
				showVoucher: false
			};
			return _this;
		}
	
		_createClass(AccountJobCreateStep2, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var path = '/api/account/jobs/create/info';
				var smallAside = true;
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 2,
						stepNumber: '02',
						stepTitle: 'Submitter’s info',
						summary: this.renderSummary()
					},
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this2.getRefs();
							}, ref: 'form', action: path, smallAside: smallAside, onSubmit: this.onSubmit.bind(this), dispatch: this.props.dispatch },
						_react2.default.createElement(
							_content2.default,
							{ title: 'Information', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span3 span5-tablet span11-mobile' },
								_react2.default.createElement(_text2.default, { ref: 'contact', name: 'contact', label: 'Contact', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'email', name: 'email', label: 'Email', btw: ' (for this submission\'s correspondence)' }),
								_react2.default.createElement(_text2.default, { ref: 'company', name: 'company', label: 'Company name', btw: ' (optional)' }),
								_react2.default.createElement(_label2.default, { label: 'Country' }),
								_react2.default.createElement(_select2.default, {
									name: 'country',
									ref: 'country',
									placeholder: 'Country',
									label: 'Country',
									ajaxOptionsUrl: _countries2.default
								}),
								_react2.default.createElement(_text2.default, { ref: 'address', name: 'address', label: 'Street and number', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'city', name: 'city', label: 'City and/or state', btw: '' }),
								_react2.default.createElement(_text2.default, { ref: 'zip', name: 'zip', label: 'Postal or zip code', btw: '' })
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'V.A.T.', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span100p' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'vatEnabled', name: 'vatEnabled', label: '', onChange: function onChange(checked) {
											_this2.setState(_extends({}, _this2.state, { showVAT: checked }));
										}, className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'I have a V.A.T number'
									),
									' (Required for companies in the EU who are V.A.T. registered)'
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.showVAT ? '' : 'hide', style: { width: '144px' } },
									_react2.default.createElement(_text2.default, { ref: 'vat', name: 'vat', label: '', btw: '', placeholder: 'GB9999999' })
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'Voucher', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span3 span5-tablet span11-mobile' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'voucher', name: 'voucher', label: '', onChange: function onChange(checked) {
											_this2.setState(_extends({}, _this2.state, { showVoucher: checked }));
										}, className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'I have a voucher'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: this.state.showVoucher ? '' : 'hide' },
									_react2.default.createElement(_text2.default, { ref: 'voucherCode', name: 'voucherCode', label: '', btw: '', placeholder: 'Voucher code' })
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: '', smallAside: smallAside },
							_react2.default.createElement(
								_formfitter2.default,
								{ className: 'span100p' },
								_react2.default.createElement(
									_checkbox2.default,
									{ ref: 'confirmTerms', name: 'confirmTerms', label: '', className: 'custom-checkbox--tight' },
									_react2.default.createElement(
										'strong',
										{ className: 'custom-checkbox__highlight' },
										'Please confirm that you are the representative of the company'
									)
								)
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ className: 'pixel-pattern pixel-pattern--01', smallAside: smallAside },
							_react2.default.createElement(
								'div',
								{ className: 'span100p' },
								_react2.default.createElement(
									'div',
									{ className: 'account-process__button-area' },
									_react2.default.createElement(_submit2.default, { name: 'Continue', className: 'button--dark', disabled: this.state.submitting, waiting: this.state.submitting }),
									!(this.state.showVoucher || this.props.skipPayment) && _react2.default.createElement(
										'span',
										{ className: 'account-process__button-area__button-desc' },
										(0, _translate2.default)('account/jobcreate/continueUsingCC')
									),
									!(this.state.showVoucher || this.props.skipPayment) && _react2.default.createElement(
										'span',
										{ className: 'account-process__button-area__cc-line' },
										'Accepted credit/debit cards:',
										_react2.default.createElement(
											'div',
											{ className: 'account-process__button-area__cc-line__cc-container' },
											_react2.default.createElement('img', _extends({}, _cc2.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc4.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc6.default, { height: '22', width: '35', alt: '' })),
											_react2.default.createElement('img', _extends({}, _cc8.default, { height: '22', width: '35', alt: '' }))
										)
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'renderSummary',
			value: function renderSummary() {
				var _this3 = this;
	
				var active = this.props.activeStep > 2;
				var className = 'account-block-content__content__summary';
				if (active) {
					className += ' account-block-content__content__summary--active';
				}
	
				var contact = this.refs.contact && typeof this.refs.contact.value === 'function' ? this.refs.contact.value() : '';
				var company = this.refs.company && typeof this.refs.company.value === 'function' ? this.refs.company.value() : '';
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					active && this.props.activeStep !== 4 && _react2.default.createElement(
						'button',
						{ className: 'button account-block-content__content__summary__button', onClick: function onClick() {
								_this3.props.goToStep();
							} },
						'Edit'
					),
					_react2.default.createElement(
						'p',
						null,
						_react2.default.createElement(
							'strong',
							null,
							contact
						),
						_react2.default.createElement('br', null),
						company
					)
				);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this4 = this;
	
				this.mounted && this.setState(_extends({}, this.state, {
					submitting: true
				}));
	
				promise.then(function (res) {
					var addedState = { customerInfo: _this4.refs.form.serialize() };
					if (res.data && res.data.job && res.data.job.slug) {
						addedState.slug = res.data.job.slug;
					}
	
					_this4.mounted && _this4.setState(_extends({}, _this4.state, {
						submitting: false
					}));
	
					if (_this4.state.showVoucher) {
						_this4.props.skipToEnd(addedState);
					} else {
						_this4.props.onSubmit(promise, addedState);
					}
				}).catch(function (res) {
					_this4.mounted && _this4.setState(_extends({}, _this4.state, {
						submitting: false
					}));
				});
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}]);
	
		return AccountJobCreateStep2;
	}(_react.Component);
	
	AccountJobCreateStep2.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		skipPayment: _react.PropTypes.bool,
		activeStep: _react.PropTypes.number.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	AccountJobCreateStep2.defaultProps = {
		active: false,
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = AccountJobCreateStep2;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _formfitter = __webpack_require__(131);
	
	var _formfitter2 = _interopRequireDefault(_formfitter);
	
	var _stepGeneric = __webpack_require__(172);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	var _cc = __webpack_require__(475);
	
	var _cc2 = _interopRequireDefault(_cc);
	
	var _cc3 = __webpack_require__(476);
	
	var _cc4 = _interopRequireDefault(_cc3);
	
	var _cc5 = __webpack_require__(477);
	
	var _cc6 = _interopRequireDefault(_cc5);
	
	var _cc7 = __webpack_require__(478);
	
	var _cc8 = _interopRequireDefault(_cc7);
	
	var _stripe = __webpack_require__(381);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	// import { accountRoute } from '../../../routes';
	
	
	var CC_VISA = 'CC_VISA';
	var CC_ELECTRON = 'CC_ELECTRON';
	var CC_MASTERCARD = 'CC_MASTERCARD';
	var CC_DISCOVER = 'CC_DISCOVER';
	var CC_AMEX = 'CC_AMEX';
	
	var MODE_NEUTRAL = 'MODE_NEUTRAL';
	var MODE_CREDITCARD = 'MODE_CREDITCARD';
	var MODE_PAYPAL = 'MODE_PAYPAL';
	
	var PAYPAL_AUTH_COMPLETE = 'PAYPAL_AUTH_COMPLETE';
	var PAYPAL_AUTH_FAILED = 'PAYPAL_AUTH_FAILED';
	var JOB_SAVE_FAILED = 'JOB_SAVE_FAILED';
	
	var createOptions = function createOptions() {
		return {
			style: {
				base: {
					fontSize: '14px',
					color: '#8e8e8e',
					letterSpacing: '0.025em',
					fontFamily: 'Good Pro, sans-serif',
					fontWeight: 300
				},
				invalid: {
					color: '#9e2146'
				}
			}
		};
	};
	
	var AccountJobCreateStep3 = function (_Component) {
		_inherits(AccountJobCreateStep3, _Component);
	
		function AccountJobCreateStep3(props) {
			_classCallCheck(this, AccountJobCreateStep3);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobCreateStep3).call(this));
	
			_this._receiveMessage = _this._receiveMessage.bind(_this);
			_this.stripe = new _stripe2.default();
	
			_this.state = {
				submitting: false,
				mode: MODE_CREDITCARD,
				ccno: '',
				errors: {
					validExpiry: true,
					validCVC: true,
					validCC: true
				}
			};
			return _this;
		}
	
		_createClass(AccountJobCreateStep3, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 3,
						stepNumber: '03',
						stepTitle: 'Payment'
					},
					this.state.mode === MODE_NEUTRAL && this.renderChoosePayment(),
					this.state.mode === MODE_CREDITCARD && this.renderCCForm()
				);
			}
		}, {
			key: 'renderChoosePayment',
			value: function renderChoosePayment() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Pay with credit/debit card', smallAside: true },
					_react2.default.createElement(_label2.default, { label: 'Select payment method' }),
					_react2.default.createElement(
						'div',
						{ className: 'payment-selection' },
						_react2.default.createElement(
							'button',
							{ className: 'button button--dark', onClick: function onClick() {
									_this2.setState(_extends({}, _this2.state, { mode: MODE_CREDITCARD }));
								} },
							'Pay with credit/debit card'
						)
					)
				);
			}
		}, {
			key: 'checkoutWithPaypal',
			value: function checkoutWithPaypal() {
				window.open('/api/paypal/job', '_blank');
				window.addEventListener('message', this._receiveMessage, false);
			}
		}, {
			key: '_receiveMessage',
			value: function _receiveMessage(event) {
				if (typeof event.data !== 'string') {
					return false;
				}
	
				switch (event.data) {
					case PAYPAL_AUTH_COMPLETE:
						this.props.goForward();
						break;
					case JOB_SAVE_FAILED:
						this.props.dispatch((0, _errors.dispatchError)({ message: 'Could not save your project - data is corrupt' }));
						break;
					case PAYPAL_AUTH_FAILED:
					default:
						this.props.dispatch((0, _errors.dispatchError)({ message: 'Paypal payment failed.' }));
				}
	
				window.removeEventListener('message', this._receiveMessage);
			}
		}, {
			key: 'renderCCForm',
			value: function renderCCForm() {
				var _this3 = this;
	
				var path = '/api/account/jobs/create/payment';
				var smallAside = true;
	
				var expireMonths = [{ label: '01', value: '01' }, { label: '02', value: '02' }, { label: '03', value: '03' }, { label: '04', value: '04' }, { label: '05', value: '05' }, { label: '06', value: '06' }, { label: '07', value: '07' }, { label: '08', value: '08' }, { label: '09', value: '09' }, { label: '10', value: '10' }, { label: '11', value: '11' }, { label: '12', value: '12' }];
	
				var expireYears = function () {
					var years = [];
					var currentYear = new Date().getFullYear();
	
					for (var yearCount = currentYear; yearCount <= currentYear + 20; yearCount++) {
						years.push({ label: yearCount.toString(), value: yearCount.toString() });
					}
	
					return years;
				}();
	
				var cardType = this.detectCardType(this.state.ccno);
	
				return _react2.default.createElement(
					_form2.default,
					{ getRefs: function getRefs() {
							return _this3.getRefs();
						}, action: path, smallAside: smallAside, noFun: true, disableAjaxSubmit: true, onSubmit: this.stripeSubmit.bind(this) },
					_react2.default.createElement(
						_content2.default,
						{ title: 'Information', smallAside: smallAside },
						_react2.default.createElement(
							_formfitter2.default,
							{ className: 'span3 span5-tablet span11-mobile' },
							_react2.default.createElement(_text2.default, { ref: 'name', name: 'name', label: 'Card holder', placeholder: 'Name of card holder' }),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardNumberElement, createOptions())
							),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardExpiryElement, createOptions())
							),
							_react2.default.createElement(
								'div',
								{ className: 'stripe-input' },
								_react2.default.createElement(_reactStripeElements.CardCVCElement, createOptions())
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01', smallAside: smallAside },
						_react2.default.createElement(
							'div',
							{ className: 'span100p' },
							_react2.default.createElement(
								'div',
								{ className: 'account-process__button-area' },
								_react2.default.createElement(_submit2.default, { name: 'Complete payment', className: 'button--dark', disabled: this.state.submitting, waiting: this.state.submitting }),
								_react2.default.createElement(
									'span',
									{ className: 'account-process__button-area__button-desc' },
									'Complete payment using your credit/debit card.'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'stripeSubmit',
			value: function stripeSubmit(promise) {
				var _this4 = this;
	
				var token = void 0;
				_axios2.default.get(_baseUrl2.default + '/api/stripe/paymentintent?type=job').then(function (res) {
					var chargePromise = new Promise(function (resolve, reject) {
						promise.then(function () {
							_this4.props.stripe.createPaymentMethod('card').then(function (_ref) {
								var paymentMethod = _ref.paymentMethod;
							});
							_this4.props.stripe.createToken().then(function (response) {
								token = response.token;
							});
							_this4.props.stripe.handleCardPayment(res.data.intent_secret).then(function (result) {
								if (result.error) {
									_this4.setState(_extends({}, _this4.state, {
										submitting: false
									}));
									return;
								}
	
								var API_STRIPE_COMPLETE = '/api/stripe/complete';
								_axios2.default.post(_baseUrl2.default + API_STRIPE_COMPLETE, _qs2.default.stringify({
									type: 'job',
									stripeToken: token.id,
									id: result.paymentIntent.id
								}));
	
								// Make API call to populate order to add email
								_this4.setState(_extends({}, _this4.state, {
									submitting: false
								}));
								resolve();
							}).catch(function () {
								_this4.setState(_extends({}, _this4.state, {
									submitting: false
								}));
							});
						}).catch(function (res) {
							_this4.setState(_extends({}, _this4.state, {
								submitting: false
							}));
						});
					});
	
					_this4.setState(_extends({}, _this4.state, {
						submitting: true
					}));
	
					chargePromise.then(function () {}).catch(function () {
						_this4.setState(_extends({}, _this4.state, {
							submitting: false
						}));
					});
	
					return _this4.props.onSubmit(chargePromise);
				});
			}
		}, {
			key: 'stripeResponseHandler',
			value: function stripeResponseHandler(status, response, res, resolve, reject) {
				var _this5 = this;
	
				if (response.error) {
					this.props.dispatch((0, _errors.dispatchError)(response.error));
					reject(response);
				} else {
					var token = response.id;
					var API_STRIPE_CHARGE = '/api/stripe/charge';
	
					_axios2.default.post(_baseUrl2.default + API_STRIPE_CHARGE, _qs2.default.stringify({
						stripeToken: token,
						type: 'job'
					})).then(function (apiRes) {
						_this5.setState(_extends({}, _this5.state, {
							submitting: false
						}));
	
						resolve(apiRes.data);
					}).catch(function (apiRes) {
						if (apiRes.data && apiRes.data.message) {
							_this5.props.dispatch((0, _errors.dispatchError)(apiRes.data));
						}
	
						_this5.setState(_extends({}, _this5.state, {
							submitting: false
						}));
	
						reject(apiRes);
					});
				}
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'detectCardType',
			value: function detectCardType(number) {
				number = number.replace(/[^0-9.]/g, '');
	
				var re = {
					electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
					maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
					dankort: /^(5019)\d+$/,
					interpayment: /^(636)\d+$/,
					unionpay: /^(62|88)\d+$/,
					visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
					mastercard: /^5[1-5][0-9]{14}$/,
					amex: /^3[47][0-9]{13}$/,
					diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
					discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
					jcb: /^(?:2131|1800|35\d{3})\d{11}$/
				};
	
				if (re.electron.test(number)) {
					return CC_ELECTRON;
				} else if (re.visa.test(number)) {
					return CC_VISA;
				} else if (re.mastercard.test(number)) {
					return CC_MASTERCARD;
				} else if (re.amex.test(number)) {
					return CC_AMEX;
				} else {
					return undefined;
				}
			}
		}]);
	
		return AccountJobCreateStep3;
	}(_react.Component);
	
	AccountJobCreateStep3.propTypes = {
		activeStep: _react.PropTypes.number.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	AccountJobCreateStep3.defaultProps = {
		active: false,
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		}
	};
	exports.default = (0, _reactStripeElements.injectStripe)(AccountJobCreateStep3);

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _users = __webpack_require__(64);
	
	var _stepGeneric = __webpack_require__(172);
	
	var _stepGeneric2 = _interopRequireDefault(_stepGeneric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountJobCreateStep4 = function (_Component) {
		_inherits(AccountJobCreateStep4, _Component);
	
		function AccountJobCreateStep4() {
			_classCallCheck(this, AccountJobCreateStep4);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobCreateStep4).call(this));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(AccountJobCreateStep4, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.activeStep !== 4 && nextProps.activeStep === 4) {
					this.props.dispatch((0, _users.getLogin)());
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var text = (0, _translate2.default)('account/jobcreate/outro', true, false, '_self');
				text = text.replace('%job-link%', (0, _routes.jobsRoute)(this.props.slug));
	
				return _react2.default.createElement(
					_stepGeneric2.default,
					{
						active: this.props.activeStep === 4,
						stepNumber: '04',
						stepTitle: 'Confirmation'
					},
					_react2.default.createElement(
						_content2.default,
						{ title: 'Submission successful', smallAside: true },
						_react2.default.createElement('div', { className: 'span5 span100p-mobile', dangerouslySetInnerHTML: { __html: text } })
					)
				);
			}
		}]);
	
		return AccountJobCreateStep4;
	}(_react.Component);
	
	AccountJobCreateStep4.propTypes = {
		activeStep: _react.PropTypes.number.isRequired,
		onSubmit: _react.PropTypes.func.isRequired,
		slug: _react.PropTypes.string.isRequired,
		dispatch: _react.PropTypes.func.isRequired
	};
	AccountJobCreateStep4.defaultProps = {
		active: false,
		onSubmit: function onSubmit(promise) {
			promise.then(function () {}).catch(function () {});
		},
		slug: ''
	};
	exports.default = AccountJobCreateStep4;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _countdown = __webpack_require__(178);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _juryEntry = __webpack_require__(173);
	
	var _juryEntry2 = _interopRequireDefault(_juryEntry);
	
	var _juryVoteFOTX = __webpack_require__(603);
	
	var _juryVoteFOTX2 = _interopRequireDefault(_juryVoteFOTX);
	
	var _other = __webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountJuryFOTX = function (_Component) {
		_inherits(AccountJuryFOTX, _Component);
	
		function AccountJuryFOTX(props) {
			_classCallCheck(this, AccountJuryFOTX);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryFOTX).call(this));
	
			_this.state = {
				cases: props.cases,
				selected: _this.getSelected(props.currentVotes),
				comments: {},
				submitting: false
			};
			return _this;
		}
	
		_createClass(AccountJuryFOTX, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.cases !== nextProps.cases) {
					this.setState(_extends({}, this.state, {
						cases: nextProps.cases,
						selected: this.getSelected(nextProps.currentVotes)
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var VOTE_PATH = this.props.api + '/vote';
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_splitter2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content account-jury__voting-ends' },
						this.props.isVotingOpen ? 'Voting ends in:' : 'Voting starts in:'
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content' },
						_react2.default.createElement(_countdown2.default, { timeLeft: this.props.nextDate - new Date().getTime() / 1000, spans: 'span14' }),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(_splitter2.default, null),
					this.props.browser.window.width < 1200 && _react2.default.createElement(_other.AccountJuryMediaTitle, { browser: this.props.browser, caseCount: this.props.cases.length }),
					this.state.cases.map(function (item, i) {
						return _react2.default.createElement(_juryEntry2.default, {
							key: item.id,
							item: item,
							selected: _this2.state.selected,
							browser: _this2.props.browser,
							dispatch: _this2.props.dispatch,
							component: _juryVoteFOTX2.default,
							hideAfterSubmit: false,
							path: VOTE_PATH,
							onChangeVote: _this2.onChangeVote.bind(_this2),
							onSubmit: _this2.onSubmit.bind(_this2),
							data: _this2.getCurrentVote(item.id, _this2.props.currentVotes),
							waiting: _this2.state.submitting
						});
					})
				);
			}
		}, {
			key: 'getCurrentVote',
			value: function getCurrentVote(id, currentVotes) {
				for (var i = 0; i < currentVotes.length; i++) {
					if (currentVotes[i].caseId === id) {
						return currentVotes[i];
					}
				}
	
				return false;
			}
		}, {
			key: 'getSelected',
			value: function getSelected(currentVotes) {
				for (var i = 0; i < currentVotes.length; i++) {
					if (currentVotes[i].vote) {
						return currentVotes[i].caseId;
					}
				}
	
				return false;
			}
		}, {
			key: 'onChangeVote',
			value: function onChangeVote(val) {
				//console.log(val);
	
				this.setState(_extends({}, this.state, {
					selected: val.value ? val.id : false
				}));
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(res) {
				var _this3 = this;
	
				var newState = _extends({}, this.state, { submitting: res.id ? res.id : false });
				if (res.id && typeof res.comment === 'string') {
					newState.comments[res.id] = res.comment;
				}
	
				// post vote
				if (newState.selected) {
					_axios2.default.post(this.props.api + '/vote', _qs2.default.stringify({
						comments: newState.comments,
						vote: newState.selected
					})).then(function (res) {
						_this3.endSubmit(_this3.state);
						_this3.props.dispatch((0, _errors.dispatchMsg)(res.data));
					}).catch(function (res) {
						_this3.endSubmit(_this3.state);
						_this3.props.dispatch((0, _errors.dispatchError)(res.data));
					});
	
					this.setState(newState);
				}
			}
		}, {
			key: 'endSubmit',
			value: function endSubmit(state) {
				this.setState(_extends({}, state, {
					submitting: false
				}));
			}
		}]);
	
		return AccountJuryFOTX;
	}(_react.Component);
	
	AccountJuryFOTX.propTypes = {
		api: _react.PropTypes.string.isRequired,
		cases: _react.PropTypes.array.isRequired
	};
	AccountJuryFOTX.defaultProps = {
		nextDate: new Date().getTime() / 1000,
		isVotingOpen: false,
		currentVotes: [],
		cases: []
	};
	exports.default = AccountJuryFOTX;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDecorator = function (_Component) {
		_inherits(DefaultDecorator, _Component);
	
		function DefaultDecorator() {
			_classCallCheck(this, DefaultDecorator);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(DefaultDecorator).apply(this, arguments));
		}
	
		_createClass(DefaultDecorator, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var slideCodas = [];
				var slideClasses = this.props.slideClasses;
	
				var _loop = function _loop(i) {
					var isVid = false;
					var className = 'slide-coda__item';
					if (_this2.props.currentSlide === i) {
						className += ' slide-coda__item--active';
					}
	
					if (typeof slideClasses[i] === 'string') {
						className += slideClasses[i];
					}
	
					if (slideClasses.length && !!_this2.props.hasVideo && slideClasses[i].indexOf('is-video') > -1) {
						slideCodas.push(_react2.default.createElement(
							'a',
							{ key: i, onClick: function onClick() {
									_this2.playAndGo(i);
								} },
							_react2.default.createElement('span', { className: className })
						));
					} else {
						slideCodas.push(_react2.default.createElement(
							'a',
							{ key: i, onClick: function onClick() {
									_this2.props.goToSlide(i, true);
								} },
							_react2.default.createElement('span', { className: className })
						));
					}
				};
	
				for (var i = 0; i < this.props.slideCount; i++) {
					_loop(i);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'slide-coda' },
					slideCodas
				);
			}
		}, {
			key: 'playAndGo',
			value: function playAndGo(i) {
				this.props.onVideoPlay();
				//this.props.goToSlide(i, true);
			}
		}]);
	
		return DefaultDecorator;
	}(_react.Component);
	
	DefaultDecorator.propTypes = {
		nextSlide: _react.PropTypes.func.isRequired,
		previousSlide: _react.PropTypes.func.isRequired,
		goToSlide: _react.PropTypes.func.isRequired,
		slideCount: _react.PropTypes.number.isRequired,
		currentSlide: _react.PropTypes.number.isRequired
	};
	DefaultDecorator.defaultProps = {};
	
	
	var defaultDecoratorPkg = {
		component: DefaultDecorator,
		style: {}
	};
	
	exports.default = defaultDecoratorPkg;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _pluralize = __webpack_require__(160);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _caseElement = __webpack_require__(446);
	
	var _caseElement2 = _interopRequireDefault(_caseElement);
	
	var _getCategoryName = __webpack_require__(148);
	
	var _getCategoryName2 = _interopRequireDefault(_getCategoryName);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _placeholder = __webpack_require__(479);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//tmp
	
	
	var CaseElementGeneric = function (_Component) {
		_inherits(CaseElementGeneric, _Component);
	
		function CaseElementGeneric(props) {
			_classCallCheck(this, CaseElementGeneric);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseElementGeneric).call(this, props));
	
			_this.state = {
				readyClick: false
			};
			return _this;
		}
	
		_createClass(CaseElementGeneric, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props;
				var caseItem = _props.caseItem;
				var browser = _props.browser;
	
				var ContentComp = this.props.contentComp;
				var url = (0, _index.casesRoute)(caseItem.slug);
	
				var pointClass = 'span1 span2-mobile case-element__glitter-scorecard pixel-pattern';
				var imageClass = 'span3 span5-tablet span12-mobile case-element__glitter-img pixel-pattern pixel-pattern--dark';
	
				if (this.props.showPoints == 'true') {
					pointClass = 'span1 case-element__glitter-scorecard pixel-pattern';
					imageClass = 'span3 span5-tablet case-element__glitter-img span10-mobile pixel-pattern pixel-pattern--dark';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'case-element' },
					_react2.default.createElement(
						'div',
						{ className: 'case-element__glitter clearfix' },
						_react2.default.createElement(
							'div',
							{ className: imageClass },
							_react2.default.createElement(_image2.default, { img: caseItem.thumbnail, span: { desktop: 'span3', tablet: 'span5', mobile: 'span12' }, alt: '', browser: browser }),
							_react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-img__overlay', onClick: function onClick() {
										return _this2.caseClick();
									} },
								_react2.default.createElement(
									'div',
									{ className: 'case-element__glitter-img__overlay__aligner' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: url, className: 'button button--dark-to-light-anim', ref: 'seeCase', onClick: function onClick(event) {
												return _this2.caseLaunchClick(event);
											} },
										'See case'
									),
									_react2.default.createElement(
										'a',
										{ href: caseItem.url, target: '_blank', className: 'button button--light-to-dark-anim button--go', onClick: function onClick(event) {
												return _this2.caseLaunchClick(event);
											} },
										'Launch project'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: pointClass },
							caseItem.legacy == 0 && _react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-scorecard__score' },
								(0, _date.formatNumber)(caseItem.points),
								' ',
								_react2.default.createElement(
									'small',
									null,
									'Points'
								)
							),
							caseItem.legacy == 0 && _react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-scorecard__days' },
								(0, _date.formatNumber)(caseItem.days),
								' ',
								_react2.default.createElement(
									'small',
									null,
									'Days'
								)
							),
							caseItem.legacy == 0 && this.props.showJudges && _react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-scorecard__judges' },
								(0, _date.formatNumber)(caseItem.voteCount),
								' ',
								_react2.default.createElement(
									'small',
									null,
									(0, _pluralize2.default)('Judges', caseItem.voteCount)
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'case-element__details-alt clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'span3 span5-tablet case-element__details-alt-holder span12-mobile' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: url, className: 'case-element__details-alt__title' },
								_react2.default.createElement(
									'span',
									{ className: 'case-element__details-alt__title__category' },
									(0, _getCategoryName2.default)(caseItem.caseTypes, caseItem.bestViewedOn)
								),
								caseItem.title
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-element__details-alt__profile' },
								(0, _formatCredits2.default)(caseItem.profiles, false)
							),
							ContentComp && _react2.default.createElement(ContentComp, { caseItem: caseItem, browser: this.props.browser })
						),
						_react2.default.createElement('div', { className: 'span1 hide-tablet empty' })
					)
				);
			}
		}, {
			key: 'caseLaunchClick',
			value: function caseLaunchClick(event) {
				if (this.props.browser.window.width < 720 && !this.state.readyClick) {
					event.preventDefault();
					this.setState(_extends({}, this.state, { readyClick: true }));
				} else if (this.props.browser.window.width < 720) {
					this.setState(_extends({}, this.state, { readyClick: false }));
				} else {
					event.stopPropagation();
				}
			}
		}, {
			key: 'caseClick',
			value: function caseClick(event) {
	
				if (this.props.browser.window.width > 719) {
					_reactDom2.default.findDOMNode(this.refs.seeCase).click(event);
				} else {
					this.setState(_extends({}, this.state, { readyClick: true }));
				}
			}
		}, {
			key: 'getCaseTypes',
			value: function getCaseTypes(caseTypes) {
				if (caseTypes && caseTypes.name) {
					return caseTypes.name;
				}
	
				return '';
			}
		}]);
	
		return CaseElementGeneric;
	}(_react.Component);
	
	CaseElementGeneric.propTypes = {
		points: _react.PropTypes.number.isRequired,
		showPoints: _react.PropTypes.bool,
		showJudges: _react.PropTypes.bool,
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		title: _react.PropTypes.string.isRequired,
		browser: _react.PropTypes.object.isRequired,
		caseItem: _react.PropTypes.object.isRequired,
		contentComp: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.func]).isRequired
	};
	CaseElementGeneric.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		showPoints: false,
		showJudges: false,
		contentComp: false
	};
	exports.default = CaseElementGeneric;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	var _content = __webpack_require__(998);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _cornerLabel = __webpack_require__(177);
	
	var _cornerLabel2 = _interopRequireDefault(_cornerLabel);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _qa = __webpack_require__(618);
	
	var _qa2 = _interopRequireDefault(_qa);
	
	var _player = __webpack_require__(97);
	
	var _types = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorialContent = function (_Component) {
		_inherits(EditorialContent, _Component);
	
		function EditorialContent(props) {
			_classCallCheck(this, EditorialContent);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialContent).call(this));
	
			_this.mounted = true;
	
			_this.scrollHandler = _this.scrollHandler.bind(_this);
	
			_this.state = {
				placeholderHeight: 0,
				placeholderWidth: 0,
				posToStick: -1,
				posToStickEndStick: -1,
				isSticky: false,
				posToLinkStick: -1,
				isLinkSticky: false
			};
			return _this;
		}
	
		_createClass(EditorialContent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.browser.scroll.register(this.scrollHandler);
				this.updateDimensions();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.scrollHandler);
				this.mounted = false;
				clearTimeout(this.t);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width || this.props.editorial.id !== nextProps.editorial.id) {
	
					if (this.props.editorial.id !== nextProps.editorial.id) {
						this.resetSticky();
					}
	
					this.updateDimensions();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var _this2 = this;
	
				if (this.props.editorial.id !== prevProps.editorial.id) {
					clearTimeout(this.t);
	
					this.resetSticky();
					this.t = setTimeout(function () {
						_this2.updateDimensions();
					}, 100);
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.editorial.id !== this.props.editorial.id || this.state !== nextState;
			}
		}, {
			key: 'resetSticky',
			value: function resetSticky() {
				if (this.state.posToStick === -1) {
					return;
				}
	
				this.setState(_extends({}, this.state, {
					placeholderHeight: 0,
					placeholderWidth: 0,
					posToStick: -1,
					posToStickEndStick: -1,
					isSticky: false,
					posToLinkStick: -1,
					isLinkSticky: false
				}));
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var _this3 = this;
	
				var images = window.document.getElementsByTagName('img');
				for (var i = 0; i < images.length; i++) {
					if (!images[i].complete) {
						this.resetSticky();
						setTimeout(function () {
							_this3.updateDimensions();
						}, 25);
	
						return false;
					}
				}
	
				if (!this.mounted) {
					return false;
				}
	
				var newState = _extends({}, this.state);
	
				if (this.refs.stickyWrapper && this.refs.stickyPrimary) {
					var stWrapper = this.refs.stickyWrapper;
					var stPrimary = this.refs.stickyPrimary;
					var stPlaceholder = this.refs.stickyPlaceholder;
	
					newState.posToStick = (0, _getOffsetTop2.default)(stPlaceholder);
					newState.posToStickEndStick = newState.posToStick + stWrapper.clientHeight;
					newState.placeholderHeight = stPrimary.clientHeight;
					newState.placeholderWidth = stPrimary.clientWidth;
				}
	
				if (this.refs.stickyLinks) {
					newState.posToLinkStick = (0, _getOffsetTop2.default)(this.refs.stickyLinks);
				}
	
				this.mounted && this.setState(newState);
	
				return true;
			}
		}, {
			key: 'scrollHandler',
			value: function scrollHandler(e) {
				var scrollY = e.scrollY + (this.props.browser.window.width > 719 ? 61 : 50); // account for top-nav
	
				if (this.state.posToStick === -1) {
					return;
				}
	
				// if (scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick) {
				// 	console.log(this.refs.stickyWrapper.getAttribute('data-reactid').substr(-1, 2));
				// }
				var isSticky = scrollY > this.state.posToStick;
				var isMobile = this.props.browser.window.width <= 719;
				var isLinkSticky = scrollY > this.state.posToLinkStick && !isMobile;
				if ((isSticky !== this.state.isSticky || isLinkSticky !== this.state.isLinkSticky) && this.mounted) {
					this.setState(_extends({}, this.state, {
						isSticky: isSticky,
						isLinkSticky: isLinkSticky
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var _props$editorial = this.props.editorial;
				var contents = _props$editorial.contents;
				var sections = _props$editorial.sections;
				var layoutType = _props$editorial.layoutType;
	
	
				var phStyle = {};
				phStyle.height = (this.state.placeholderHeight > 0 ? this.state.placeholderHeight : 1) + 'px';
	
				if (!this.state.placeholderHeight) {
					setTimeout(function () {
						_this4.updateDimensions();
					}, 500);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'editorial-content editorial-content__sticky-wrapper', ref: 'stickyWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'span2 hide-mobile cf' },
						_react2.default.createElement('div', { ref: 'stickyPlaceholder', className: 'sticky-placeholder', style: phStyle }),
						this.getLabelArea(layoutType)
					),
					_react2.default.createElement(
						'div',
						{ className: 'span12 span14-mobile editorial-content__container' },
						_react2.default.createElement(
							'div',
							{ className: 'span8 span14-mobile editorial-content__content' },
							this.getContent(contents)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span14-mobile span4 editorial-content__aside' },
							this.getAside(sections)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span8 span14-mobile editorial-content__content' },
							_react2.default.createElement('div', { className: 'editorial-content__splitter pixel-pattern span8 span14-mobile' }),
							_react2.default.createElement(
								'section',
								{ className: 'editorial-content__section editorial-content__section__answer' },
								_react2.default.createElement(
									'div',
									{ className: 'span5 span7-tablet span12-mobile' },
									(0, _translate2.default)('editorials/editorialsCopyright')
								),
								_react2.default.createElement('div', { className: 'cf' })
							)
						)
					)
				);
			}
		}, {
			key: 'getContent',
			value: function getContent(contents) {
				var _this5 = this;
	
				return contents.map(function (content, i) {
					return _this5.getMainContent(content, i);
				});
			}
		}, {
			key: 'getLabelArea',
			value: function getLabelArea(type) {
				switch (type) {
					case _types.EDITORIAL_TYPE_QA:
						var qStyle = {
							width: 'inherit'
						};
						if (this.state.isSticky) {
							qStyle.top = (this.props.browser.window.width > 719 ? 61 : 50) + 'px';
							qStyle.position = 'fixed';
						} else {
							qStyle.position = 'absolute';
							qStyle.top = '0px';
						}
	
						return _react2.default.createElement(
							'div',
							{ ref: 'stickyPrimary', className: 'editorial-content__stickprimary' },
							_react2.default.createElement('div', { className: 'editorial-content__qa-block' }),
							_react2.default.createElement(
								'div',
								{ style: qStyle },
								_react2.default.createElement(
									'div',
									{ className: 'pixel-pattern editorial-content__qa-block' },
									_react2.default.createElement(_pixeltext2.default, { text: 'Q', textAnchor: 'right', x: '100%', y: '0px', className: 'editorial-content__qa-svg' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'pixel-pattern editorial-content__qa-block' },
									_react2.default.createElement(_pixeltext2.default, { text: 'A', textAnchor: 'right', x: '100%', y: '0px', className: 'editorial-content__qa-svg' })
								)
							)
						);
					default:
						return ' ';
				}
			}
		}, {
			key: 'getMainContent',
			value: function getMainContent(content, id) {
				switch (content.type.toUpperCase()) {
					case 'EDITORIAL-QA':
						return this.getQA(content, id);
					default:
						return this.getArticle(content, id);
				}
			}
		}, {
			key: 'getArticle',
			value: function getArticle(content, id) {
				if (content && (content.text === '<p></p>' || !content.text)) {
					return false;
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'editorial-content__section', key: 'art' + id },
					_react2.default.createElement('div', { className: 'span5 span7-tablet span12-mobile', dangerouslySetInnerHTML: { __html: content.text } }),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'getQA',
			value: function getQA(content, id) {
				if (content && (content.answer === '<p></p>' || content.question === '<p></p>')) {
					return false;
				}
	
				return _react2.default.createElement(_qa2.default, { content: content, key: id, browser: this.props.browser });
			}
		}, {
			key: 'getAside',
			value: function getAside(contents) {
				return _react2.default.createElement(
					'div',
					{ className: 'editorial-content__aside-block' },
					this.getAsideContent(contents),
					this.getAsideLinks(contents)
				);
			}
		}, {
			key: 'getAsideContent',
			value: function getAsideContent(contents) {
				var _this6 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					contents.map(function (content, i) {
						switch (content.type) {
							case _types.EDITORIAL_SIDEBAR_TYPE_IMAGE:
								return _this6.getAsideImage(content, i);
							case _types.EDITORIAL_SIDEBAR_TYPE_YOUTUBE:
								return _this6.renderVideo(i, content.youtube, content.description);
							case _types.EDITORIAL_SIDEBAR_TYPE_VIMEO:
								return _this6.renderVideo(i, content.vimeo, content.description);
						}
					})
				);
			}
		}, {
			key: 'renderVideo',
			value: function renderVideo(key, video, description) {
				var className = 'editorial-content__aside-block__video';
	
				if (description) {
					className += ' editorial-content__aside-block__video--wdesc';
				}
	
				return _react2.default.createElement(
					'div',
					{ key: key, className: 'hide-mobile' },
					_react2.default.createElement(_player.PlayerWithTrigger, { browser: this.props.browser, key: key, url: video, className: className }),
					_react2.default.createElement(
						'p',
						null,
						description
					)
				);
			}
		}, {
			key: 'getAsideLinks',
			value: function getAsideLinks(contents) {
				var _this7 = this;
	
				if (function () {
					for (var i = 0; i < contents.length; i++) {
						if (contents[i].type === _types.EDITORIAL_SIDEBAR_TYPE_LINK) {
							return false;
						}
					}
	
					return true;
				}()) {
					// if no links found
					return false;
				}
	
				var className = 'span14-mobile span4 editorial-content__aside__links';
				if (this.state.isLinkSticky) {
					className += ' editorial-content__aside__links--sticky';
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('hr', null),
					_react2.default.createElement(
						'div',
						{ className: className, ref: 'stickyLinks' },
						_react2.default.createElement(_cornerLabel2.default, { name: 'Links' }),
						contents.map(function (content, i) {
							switch (content.type) {
								case _types.EDITORIAL_SIDEBAR_TYPE_LINK:
									return _this7.getAsideLink(content, i);
							}
						})
					)
				);
			}
		}, {
			key: 'getAsideImage',
			value: function getAsideImage(content, i) {
				if (!content.image) {
					return false;
				}
	
				if (content.description !== '') {
					return _react2.default.createElement(
						'div',
						{ key: i, className: 'hide-mobile' },
						_react2.default.createElement(_image2.default, { img: content.image, alt: content.image_alt, span: 'span4', browser: this.props.browser, className: 'editorial-content__aside-block__img editorial-content__aside-block__img--wdesc' }),
						_react2.default.createElement(
							'p',
							null,
							content.description
						)
					);
				} else {
					return _react2.default.createElement(_image2.default, { key: i, img: content.image, alt: content.image_alt, span: 'span4', browser: this.props.browser, className: 'editorial-content__aside-block__img hide-mobile' });
				}
			}
		}, {
			key: 'getAsideLink',
			value: function getAsideLink(content, i) {
				if (!content.link_name && !content.link) {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ key: i },
					_react2.default.createElement(
						'a',
						{ className: 'button button--go', href: content.link, title: content.link_title, target: '_blank' },
						content.link_name
					)
				);
			}
		}]);
	
		return EditorialContent;
	}(_react.Component);
	
	EditorialContent.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		editorial: _react.PropTypes.object.isRequired
	};
	EditorialContent.defaultProps = {
		editorial: {}
	};
	exports.default = EditorialContent;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _pluralize = __webpack_require__(160);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _header = __webpack_require__(1000);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _date = __webpack_require__(14);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorialHeader = function (_Component) {
		_inherits(EditorialHeader, _Component);
	
		function EditorialHeader(props) {
			_classCallCheck(this, EditorialHeader);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialHeader).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(EditorialHeader, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!nextProps.editorial.image && !this.missingImage) {
					this.missingImage = true;
					nextProps.onLoad();
				} else {
					this.missingImage = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.editorial.id !== this.props.editorial.id;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props$editorial = this.props.editorial;
				var date = _props$editorial.date;
				var title = _props$editorial.title;
				var excerpt = _props$editorial.excerpt;
				var subtitle = _props$editorial.subtitle;
				var users = _props$editorial.users;
				var releaseDate = _props$editorial.releaseDate;
				var createdDate = _props$editorial.createdDate;
	
				var editorialDate = new _date.DateFormatter(releaseDate || createdDate);
	
				return _react2.default.createElement(
					'header',
					{ className: 'editorial-header' },
					!!this.props.editorial.image && _react2.default.createElement(
						'div',
						{ className: 'editorial-header__hero' },
						_react2.default.createElement(_image2.default, {
							img: this.props.editorial.image,
							alt: this.props.editorial.image_alt,
							span: 'span14',
							className: 'span14 editorial-header__hero__img',
							browser: this.props.browser,
							onLoad: function onLoad() {
								_this2.props.onLoad();
							}
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'span14-mobile pixel-pattern editorial-header__leftbox' },
						_react2.default.createElement(_pixeltext2.default, { text: editorialDate.date, className: 'editorial__fancytext' }),
						_react2.default.createElement(
							'div',
							{ className: 'editorial-header__leftbox__info editorial-header__leftbox__info--faded' },
							editorialDate.monthAndYear
						),
						_react2.default.createElement(
							'div',
							{ className: 'editorial-header__leftbox__info' },
							(0, _pluralize2.default)(this.props.editorial.types.name, 1)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'span14-mobile editorial-header__rightbox' },
						_react2.default.createElement(
							'div',
							{ className: 'editorial-header__rightbox__share' },
							_react2.default.createElement(_share2.default, { title: this.getTitle(), url: window.location.href, browser: this.props.browser })
						),
						_react2.default.createElement(
							'div',
							{ className: 'span10 span14-mobile editorial-header__rightbox__container' },
							_react2.default.createElement(
								'div',
								{ className: 'editorial-header__rightbox__type' },
								this.getTypeAndAuthor()
							),
							_react2.default.createElement(
								'h1',
								{ className: 'editorial-header__rightbox__title' },
								this.getTitle()
							),
							_react2.default.createElement(
								'p',
								{ className: 'editorial-header__rightbox__subtitle' },
								excerpt || subtitle
							)
						)
					)
				);
			}
		}, {
			key: 'getTitle',
			value: function getTitle() {
				//@TODO might need some logic to add article-type to title
				var _props$editorial2 = this.props.editorial;
				var title = _props$editorial2.title;
				var typeId = _props$editorial2.typeId;
	
	
				return title;
			}
		}, {
			key: 'getTypeAndAuthor',
			value: function getTypeAndAuthor() {
				var _props$editorial3 = this.props.editorial;
				var layoutType = _props$editorial3.layoutType;
				var users = _props$editorial3.users;
	
	
				if (!layoutType || !(users && users.name)) {
					return '';
				}
	
				switch (layoutType) {
					case 1:
						layoutType = 'Interview';
						break;
					case 2:
						layoutType = 'Article';
						break;
				}
	
				return layoutType + ' by ' + users.name;
			}
		}]);
	
		return EditorialHeader;
	}(_react.Component);
	
	EditorialHeader.propTypes = {
		editorial: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		onLoad: _react.PropTypes.func
	};
	EditorialHeader.defaultProps = {
		onLoad: function onLoad() {}
	};
	exports.default = EditorialHeader;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkbox = __webpack_require__(449);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputMultiCheckbox = function (_Component) {
		_inherits(InputMultiCheckbox, _Component);
	
		function InputMultiCheckbox(props) {
			_classCallCheck(this, InputMultiCheckbox);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputMultiCheckbox).call(this));
	
			_this.state = {
				canCheck: props.maxChecked ? props.maxChecked - _this.value.length > 0 : true
			};
			return _this;
		}
	
		_createClass(InputMultiCheckbox, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.value !== nextState.value || this.state.canCheck !== nextState.canCheck;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var inputClassName = 'custom-checkbox__input';
	
				if (this.props.className) {
					labelClassName += ' ' + this.props.className;
				}
	
				if (this.props.error) {
					inputClassName += ' custom-checkbox__input--error';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'custom-multicheckbox__container' },
					this.props.options.map(function (opt, i) {
						return _react2.default.createElement(InputMultiCheckboxItem, {
							option: opt,
							checked: opt.checked || _this2.props.value.indexOf(opt.id) !== -1 ? 1 : 0,
							canCheck: _this2.state.canCheck,
							onCheck: function onCheck(e) {
								return _this2.checkRemaining(e);
							},
							name: _this2.props.name,
							key: i,
							ref: 'cb' + i
						});
					}),
					this.props.children
				);
			}
		}, {
			key: 'checkRemaining',
			value: function checkRemaining() {
				if (!this.props.maxChecked) {
					return true;
				}
	
				this.setState(_extends({}, this.state, {
					canCheck: this.props.maxChecked - this.value.length > 0
				}));
			}
		}, {
			key: 'value',
			get: function get() {
				var values = [];
	
				if (this.refs) {
					var keys = Object.keys(this.refs);
					for (var i = 0; i < keys.length; i++) {
						var value = this.refs[keys[i]].value;
						if (value) {
							values.push(value);
						}
					}
				}
	
				return values;
	
				// ?test_name[]=11&test_name[]=22&test_name[]=33
			},
			set: function set(val) {}
		}]);
	
		return InputMultiCheckbox;
	}(_react.Component);
	
	InputMultiCheckbox.propTypes = {
		error: _react.PropTypes.bool,
		options: _react.PropTypes.array,
		value: _react.PropTypes.array,
		name: _react.PropTypes.string.isRequired,
		maxChecked: _react.PropTypes.number
	};
	InputMultiCheckbox.defaultProps = {
		error: undefined,
		options: [],
		maxChecked: 0,
		value: []
	};
	exports.default = InputMultiCheckbox;
	
	var InputMultiCheckboxItem = function (_Component2) {
		_inherits(InputMultiCheckboxItem, _Component2);
	
		function InputMultiCheckboxItem(props) {
			_classCallCheck(this, InputMultiCheckboxItem);
	
			var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(InputMultiCheckboxItem).call(this));
	
			_this3.value = props.checked || props.option.checked ? props.option.id : false;
	
			_this3.state = {
				value: _this3.value
			};
			return _this3;
		}
	
		_createClass(InputMultiCheckboxItem, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.checked !== nextProps.checked) {
					this.value = nextProps.checked || nextProps.option.checked ? nextProps.option.id : false;
	
					this.setState(_extends({}, this.state, {
						value: this.value
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var labelClassName = 'span2 span4-tablet span7-mobile custom-checkbox custom-multicheckbox__item';
				var inputClassName = 'custom-checkbox__input';
	
				if (this.props.className) {
					labelClassName += ' ' + this.props.className;
				}
	
				if (this.props.error) {
					inputClassName += ' custom-checkbox__input--error';
				}
	
				if (!this.props.canCheck && !this.state.value) {
					labelClassName += ' custom-multicheckbox__item--blocked';
				}
	
				return _react2.default.createElement(
					'label',
					{ htmlFor: this.props.option.id, className: labelClassName },
					_react2.default.createElement('input', {
						ref: 'input',
						type: 'checkbox',
						id: this.props.option.id,
						name: this.props.name,
						onChange: this.onChange.bind(this),
						className: inputClassName,
						checked: this.state.value
					}),
					_react2.default.createElement('div', { className: 'custom-checkbox__pseudo' }),
					this.props.option.label
				);
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				if (e && e.target) {
					this.value = e.target.checked && this.props.canCheck ? this.props.option.id : false;
				}
	
				this.setState(_extends({}, this.state, {
					value: this.value
				}));
	
				this.props.onCheck(e);
			}
		}]);
	
		return InputMultiCheckboxItem;
	}(_react.Component);
	
	InputMultiCheckboxItem.propTypes = {
		option: _react.PropTypes.object.isRequired,
		checked: _react.PropTypes.oneOf([1, 0, true, false]),
		name: _react.PropTypes.string.isRequired,
		canCheck: _react.PropTypes.bool
	};
	InputMultiCheckboxItem.defaultProps = {
		canCheck: true
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(35);
	
	var _switch = __webpack_require__(1006);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputSwitch = function (_Component) {
		_inherits(InputSwitch, _Component);
	
		function InputSwitch(props) {
			_classCallCheck(this, InputSwitch);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputSwitch).call(this));
	
			_this.valid = typeof props.error === 'undefined' ? true : !props.error;
			_this.value = props.value ? 1 : 0;
			_this.unique = (0, _lodash.uniqueId)();
	
			_this.state = {
				value: _this.value,
				valid: _this.valid
			};
			return _this;
		}
	
		_createClass(InputSwitch, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.valid !== nextState.valid || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.state.value) {
					this.value = nextProps.value ? 1 : 0;
					this.setState(_extends({}, this.state, {
						value: nextProps.value
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var labelClassName = 'custom-switch';
				var inputClassName = 'custom-switch__input';
				var onButtonClass = 'custom-switch__button button';
				var offButtonClass = 'custom-switch__button button';
	
				if (this.props.className) {
					labelClassName += ' ' + this.props.className;
				}
	
				if (this.state.value) {
					onButtonClass += ' button--dark';
				} else {
					offButtonClass += ' button--dark';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: labelClassName },
					_react2.default.createElement('input', {
						ref: 'input',
						type: 'checkbox',
						id: this.props.name + this.unique,
						name: this.props.name,
						className: inputClassName,
						checked: this.state.value,
						readOnly: true
					}),
					_react2.default.createElement(
						'div',
						{ className: onButtonClass, onClick: this.toggleOn.bind(this) },
						this.props.on
					),
					_react2.default.createElement(
						'div',
						{ className: offButtonClass, onClick: function onClick(e) {
								return _this2.props.allowToggleOff && _this2.toggleOff(e);
							} },
						this.props.off
					)
				);
			}
		}, {
			key: 'toggleOn',
			value: function toggleOn(e) {
				this.value = 1;
				this.setState(_extends({}, this.state, { value: true }));
	
				this.props.onChange(this.value);
			}
		}, {
			key: 'toggleOff',
			value: function toggleOff(e) {
				this.value = 0;
				this.setState(_extends({}, this.state, { value: false }));
	
				this.props.onChange(this.value);
			}
		}]);
	
		return InputSwitch;
	}(_react.Component);
	
	InputSwitch.propTypes = {
		name: _react.PropTypes.string.isRequired,
		on: _react.PropTypes.string,
		off: _react.PropTypes.string,
		onChange: _react.PropTypes.func,
		allowToggleOff: _react.PropTypes.bool
	};
	InputSwitch.defaultProps = {
		error: undefined,
		value: 0,
		allowToggleOff: true,
		onChange: function onChange() {}
	};
	exports.default = InputSwitch;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _range = __webpack_require__(1008);
	
	var _range2 = _interopRequireDefault(_range);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputRange = function (_Component) {
		_inherits(InputRange, _Component);
	
		function InputRange(props) {
			_classCallCheck(this, InputRange);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputRange).call(this));
	
			_this.value = props.value;
	
			_this.state = {
				value: props.value
			};
			return _this;
		}
	
		_createClass(InputRange, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state.value !== nextState.value;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.props.value) {
					this.value = nextProps.value;
					this.setState(_extends({}, this.nextState, {
						value: nextProps.value
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var className = 'custom-range';
				var rangeStyle = {};
				var nobStyle = {};
				var rangePercentage = this.calcPercentage();
				var NobContent = this.props.nobContent;
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (this.props.error) {
					className += ' invalid';
				}
	
				rangeStyle.width = rangePercentage + '%';
				nobStyle.left = rangeStyle.width;
	
				if (rangePercentage < this.props.lowThreshold) {
					className += ' custom-range--low';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement('input', {
						key: 'input',
						ref: 'input',
						type: 'range',
						id: this.props.name,
						min: this.props.min,
						max: this.props.max,
						value: this.state.value,
						onChange: this.onChange.bind(this),
						onMouseUp: this.triggerChange.bind(this),
						onTouchEnd: this.triggerChange.bind(this),
						className: 'custom-range__input'
					}),
					_react2.default.createElement(
						'div',
						{ className: 'custom-range__visual' },
						_react2.default.createElement('div', { className: 'custom-range__visual__range', style: rangeStyle }),
						_react2.default.createElement('div', { className: 'custom-range__visual__knob', style: nobStyle, 'data-value': this.state.value }),
						_react2.default.createElement(
							'div',
							{ className: 'custom-range__visual__warning', style: nobStyle },
							!!NobContent && _react2.default.createElement(NobContent, { value: this.state.value, data: this.props.extraData })
						)
					),
					this.renderError(this.props.error)
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(errors) {
				if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') {
					return false;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'custom-input__error' },
					errors.map(function (error, i) {
						return _react2.default.createElement(
							'span',
							{ key: i },
							error
						);
					})
				);
			}
		}, {
			key: 'calcPercentage',
			value: function calcPercentage() {
				var range = this.props.max - this.props.min;
				var unitVal = this.state.value - this.props.min;
				var percentage = 100 / range * unitVal;
	
				//console.log(`val: ${this.state.value} - perc: ${percentage}`);
	
				return percentage;
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				if (!e || !e.target) {
					return false;
				}
	
				this.setState(_extends({}, this.state, { value: e.target.value }));
			}
		}, {
			key: 'triggerChange',
			value: function triggerChange(e) {
				this.value = this.state.value;
				this.props.onChange(this.value);
			}
		}]);
	
		return InputRange;
	}(_react.Component);
	
	InputRange.propTypes = {
		name: _react.PropTypes.string.isRequired,
		value: _react.PropTypes.number,
		min: _react.PropTypes.number,
		max: _react.PropTypes.number,
		lowThreshold: _react.PropTypes.number,
	
		nobContent: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.func]),
		extraData: _react.PropTypes.object,
	
		onChange: _react.PropTypes.func
	};
	InputRange.defaultProps = {
		value: 80,
		min: 0,
		max: 100,
		lowThreshold: 80,
		hideLabel: false,
	
		nobContent: false,
		extraData: {},
	
		onChange: function onChange() {}
	};
	exports.default = InputRange;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _draftJs = __webpack_require__(195);
	
	var _draftJsExportHtml = __webpack_require__(908);
	
	var _draftJsImportHtml = __webpack_require__(913);
	
	var _striptags = __webpack_require__(1379);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _prompt = __webpack_require__(624);
	
	var _prompt2 = _interopRequireDefault(_prompt);
	
	var _iconBold = __webpack_require__(1086);
	
	var _iconBold2 = _interopRequireDefault(_iconBold);
	
	var _iconItalic = __webpack_require__(1087);
	
	var _iconItalic2 = _interopRequireDefault(_iconItalic);
	
	var _iconUnderline = __webpack_require__(1090);
	
	var _iconUnderline2 = _interopRequireDefault(_iconUnderline);
	
	var _iconList = __webpack_require__(1089);
	
	var _iconList2 = _interopRequireDefault(_iconList);
	
	var _iconLink = __webpack_require__(1088);
	
	var _iconLink2 = _interopRequireDefault(_iconLink);
	
	var _iconUnlink = __webpack_require__(1091);
	
	var _iconUnlink2 = _interopRequireDefault(_iconUnlink);
	
	var _iconMail = __webpack_require__(480);
	
	var _iconMail2 = _interopRequireDefault(_iconMail);
	
	var _wysiwyg = __webpack_require__(1012);
	
	var _wysiwyg2 = _interopRequireDefault(_wysiwyg);
	
	var _validate = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_VALUE = '<p><br></p>';
	var DEBUG = false;
	
	var findLinkEntities = function findLinkEntities(contentBlock, callback) {
		contentBlock.findEntityRanges(function (character) {
			var entityKey = character.getEntity();
			return entityKey !== null && _draftJs.Entity.get(entityKey).getType() === 'LINK';
		}, callback);
	};
	
	var Link = function Link(props) {
		var _Entity$get$getData = _draftJs.Entity.get(props.entityKey).getData();
	
		var url = _Entity$get$getData.url;
	
		return _react2.default.createElement(
			'a',
			{ href: url, onClick: function onClick(e) {
					return e.preventDefault();
				} },
			props.children
		);
	};
	
	var decorator = new _draftJs.CompositeDecorator([{
		strategy: findLinkEntities,
		component: Link
	}]);
	
	var InputWysiwyg = function (_Component) {
		_inherits(InputWysiwyg, _Component);
	
		function InputWysiwyg(props) {
			_classCallCheck(this, InputWysiwyg);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputWysiwyg).call(this));
	
			_this.state = {
				editorState: _draftJs.EditorState.createWithContent((0, _draftJsImportHtml.stateFromHTML)(props.value), decorator)
			};
	
			_this.logState = function () {
				var content = _this.state.editorState.getCurrentContent();
				console.log(_this.value());
			};
			return _this;
		}
	
		_createClass(InputWysiwyg, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.value !== this.props.value) {
					// console.log(nextProps.value);
					// console.log(stateFromHTML(nextProps.value));
					this.setState(_extends({}, this.state, {
						editorState: _draftJs.EditorState.push(this.state.editorState, (0, _draftJsImportHtml.stateFromHTML)(nextProps.value))
					}));
				}
	
				// this.setState({
				// 	...this.state,
				// 	value: nextProps.value,
				// });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'form-wysiwyg';
				var editorState = this.state.editorState;
	
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				//DEBUG && console.log('render: ' + this.internalValue);
				// DEBUG && console.log('render: ' + this.value());
	
				var styleButtonGroup = [{ title: 'Bold', style: 'BOLD', icon: _iconBold2.default, onToggle: function onToggle(cmd) {
						return _this2.toggleInlineStyle(cmd);
					} }, { title: 'Italic', style: 'ITALIC', icon: _iconItalic2.default, onToggle: function onToggle(cmd) {
						return _this2.toggleInlineStyle(cmd);
					} }, { title: 'Underline', style: 'UNDERLINE', icon: _iconUnderline2.default, onToggle: function onToggle(cmd) {
						return _this2.toggleInlineStyle(cmd);
					} }];
	
				var listButtonGroup = [{ title: 'List', style: 'unordered-list-item', icon: _iconList2.default, onToggle: function onToggle(cmd) {
						return _this2.toggleBlockStyle(cmd);
					} }];
	
				var linkButtonGroup = [{ title: 'Link', style: 'unordered-list-item', icon: _iconLink2.default, onToggle: function onToggle(cmd) {
						return _this2._promptForLink(cmd);
					} }, { title: 'Unlink', style: 'unordered-list-item', icon: _iconUnlink2.default, onToggle: function onToggle(cmd) {
						return _this2._removeLink(cmd);
					} }];
	
				var mailButtonGroup = [{ title: 'Mail to', style: 'unordered-list-item', icon: _iconMail2.default, onToggle: function onToggle(cmd) {
						return _this2._promptForEmail(cmd);
					} }];
	
				function blackStyleFn(contentBlock) {
					var type = contentBlock.getType();
					if (type === 'unstyled') {
						return 'paragraph';
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'div',
						{ className: 'form-wysiwyg__toolbar' },
						this.props.hasStyle && _react2.default.createElement(
							'div',
							{ className: 'form-wysiwyg__toolbar__group' },
							styleButtonGroup.map(function (item, i) {
								return _react2.default.createElement(InputWysiwygButton, _extends({ key: i }, item));
							})
						),
						this.props.hasLists && _react2.default.createElement(
							'div',
							{ className: 'form-wysiwyg__toolbar__group' },
							listButtonGroup.map(function (item, i) {
								return _react2.default.createElement(InputWysiwygButton, _extends({ key: i }, item));
							})
						),
						this.props.hasLinks && _react2.default.createElement(
							'div',
							{ className: 'form-wysiwyg__toolbar__group' },
							_react2.default.createElement(_prompt2.default, { ref: 'linkprompt' }),
							linkButtonGroup.map(function (item, i) {
								return _react2.default.createElement(InputWysiwygButton, _extends({ key: i }, item));
							})
						),
						this.props.hasLinks && _react2.default.createElement(
							'div',
							{ className: 'form-wysiwyg__toolbar__group' },
							_react2.default.createElement(_prompt2.default, { ref: 'mailprompt' }),
							mailButtonGroup.map(function (item, i) {
								return _react2.default.createElement(InputWysiwygButton, _extends({ key: i }, item));
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-wysiwyg__content' },
						_react2.default.createElement(_draftJs.Editor, { ref: 'editor', placeholder: this.props.placeholder, editorState: editorState, blockStyleFn: blackStyleFn, handleKeyCommand: function handleKeyCommand(cmd) {
								return _this2.handleKeyCommand(cmd);
							}, onChange: function onChange(edState) {
								return _this2.onChange(edState);
							} })
					),
					DEBUG && _react2.default.createElement('input', {
						onClick: this.logState,
						type: 'button',
						value: 'Log State'
					})
				);
			}
		}, {
			key: 'value',
			value: function value() {
				if (this.state.editorState) {
					var content = this.state.editorState.getCurrentContent();
					var html = (0, _draftJsExportHtml.stateToHTML)(content);
	
					html = html.replace(/<br>/gi, '<br/>');
					html = html.replace(/<ins>/gi, '<u>');
					html = html.replace(/<\/ins>/gi, '</u>');
					//html = html.replace(/<p>&nbsp;(?!&nbsp;)/gi, '<p>');
					html = (0, _striptags2.default)(html, ['p', 'ul', 'li', 'strong', 'em', 'b', 'i', 'u', 'a', 'br']);
	
					return html;
				}
	
				return DEFAULT_VALUE;
			}
		}, {
			key: 'handleKeyCommand',
			value: function handleKeyCommand(command) {
				// console.log(command);
				var newState = _draftJs.RichUtils.handleKeyCommand(this.state.editorState, command);
				if (newState) {
					this.onChange(newState);
					return true;
				}
				return false;
			}
		}, {
			key: 'onChange',
			value: function onChange(editorState) {
				this.setState(_extends({}, this.state, {
					editorState: editorState
				}));
	
				this.props.onChange({
					target: {
						value: this.value()
					}
				});
			}
		}, {
			key: 'toggleInlineStyle',
			value: function toggleInlineStyle(command, arg) {
				// console.log('INLINE:', command);
				this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, command));
			}
		}, {
			key: 'toggleBlockStyle',
			value: function toggleBlockStyle(command, arg) {
				// console.log('BLOCK:', command);
				this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, command));
			}
		}, {
			key: '_promptForLink',
			value: function _promptForLink() {
				var _this3 = this;
	
				var prompt = this.refs.linkprompt;
				var editorState = this.state.editorState;
	
				var selection = editorState.getSelection();
				var currentContent = editorState.getCurrentContent();
				var currentBlock = currentContent.getBlockForKey(selection.getStartKey());
	
				var start = selection.getStartOffset();
				var end = selection.getEndOffset();
				var selectedText = currentBlock.getText().slice(start, end);
	
				if (!selection.isCollapsed()) {
					prompt.prompt('Where would you like the link to go?', 'http://', [], selectedText).then(function (value) {
						if (value) {
							var newValue = value;
	
							if (value && !(value.indexOf('mailto:') === 0 || value.indexOf('http://') === 0 || value.indexOf('https://') === 0 || value.indexOf('ftp://') === 0)) {
								newValue = 'http://' + value;
							}
	
							// console.log(newValue);
							_this3._confirmLink(newValue);
						}
					}).catch(function () {
						// restore selection
					});
				}
			}
		}, {
			key: '_promptForEmail',
			value: function _promptForEmail() {
				var _this4 = this;
	
				var prompt = this.refs.linkprompt;
				var editorState = this.state.editorState;
	
				var selection = editorState.getSelection();
				var currentContent = editorState.getCurrentContent();
				var currentBlock = currentContent.getBlockForKey(selection.getStartKey());
	
				var start = selection.getStartOffset();
				var end = selection.getEndOffset();
				var selectedText = currentBlock.getText().slice(start, end);
	
				if (!selection.isCollapsed()) {
					prompt.prompt('Which email address would you like to link to?', 'mailto:', [], selectedText).then(function (value) {
						if (value) {
							var newValue = value;
	
							if (value && value.indexOf('mailto:') === -1) {
								newValue = 'mailto:' + value;
							}
	
							// console.log(newValue);
							_this4._confirmLink(newValue);
						}
					}).catch(function () {
						// restore selection
					});
				}
			}
		}, {
			key: '_confirmLink',
			value: function _confirmLink(urlValue) {
				var _this5 = this;
	
				var editorState = this.state.editorState;
	
				var entityKey = _draftJs.Entity.create('LINK', 'MUTABLE', { url: urlValue });
				this.setState(_extends({}, this.state, {
					editorState: _draftJs.RichUtils.toggleLink(editorState, editorState.getSelection(), entityKey)
				}), function () {
					setTimeout(function () {
						return _this5.refs.editor.focus();
					}, 0);
				});
			}
		}, {
			key: '_removeLink',
			value: function _removeLink() {
				var editorState = this.state.editorState;
	
				var selection = editorState.getSelection();
				if (!selection.isCollapsed()) {
					this.setState(_extends({}, this.state, {
						editorState: _draftJs.RichUtils.toggleLink(editorState, selection, null)
					}));
				}
			}
	
			// addParagraphs(text) {
			// 	let newHtml = text;
			// 	const paraStart = /^(<p>)/;
			// 	// const paraEnd = /(<\/p>)$/;
			// 	// const firstPara = /(<p>){1}/;
			// 	// const lastPara = /<\/p>(?!.*<\/p>)/;
			// 	const paraPresent = /(<p>)/;
			// 	// const attrRegex = /(\s+)(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi;
			//
			// 	newHtml = striptags(newHtml, ['p', 'ul', 'li', 'strong', 'em', 'b', 'i', 'u', 'a', 'br']);
			//
			// 	if (!newHtml.match(paraPresent)) {
			// 		newHtml = `<p>${newHtml}</p>`;
			// 	} else if (!newHtml.match(paraStart)) {
			// 		const insertEndParaAt = newHtml.indexOf('<p>') || newHtml.length;
			//
			// 		const pt1 = newHtml.substr(0, insertEndParaAt);
			// 		const pt2 = newHtml.substr(insertEndParaAt, newHtml.length);
			// 		newHtml = `<p>${pt1}</p>${pt2}`;
			// 	}
			//
			// 	return newHtml;
			// }
	
			// emitChange(e) {
			// 	let newHtml = this.refs.editor.innerHTML;
			//
			// 	newHtml = this.addParagraphs(newHtml);
			//
			// 	this.internalValue = newHtml;
			// 	this.value = newHtml;
			//
			// 	if (!this.internalValue) {
			// 		// if empty insert default empty paragraph and fix selection else contentEditable starts making DIVs instead of paragraphs
			// 		this.refs.editor.innerHTML = DEFAULT_VALUE;
			// 		this.internalValue = DEFAULT_VALUE;
			//
			// 		const el = ReactDOM.findDOMNode(this.refs.editor);
			//
			// 		if (document.createRange && window.getSelection) {
			// 			const range = document.createRange();
			// 			const sel = window.getSelection();
			// 			range.setStart(el.childNodes[0], 0);
			// 			range.collapse(true);
			// 			sel.removeAllRanges();
			// 			sel.addRange(range);
			// 		} /* else if (document.selection && document.selection.createRange) {
			// 			// old IE not supported
			// 			// document.selection.createRange();
			// 		}*/
			// 	}
			//
			// this.props.onChange({
			// 	target: {
			// 		value: newHtml,
			// 	},
			// });
			//
			// 	DEBUG && console.log('change: ' + this.internalValue);
			// }
	
			// onFocus() {
			// 	if (this.props.placeholder && this.props.placeholder === this.internalValue) {
			// 		DEBUG && console.log('focus:clear');
			// 		this.internalValue = DEFAULT_VALUE;
			//
			// 		this.forceUpdate();
			// 	}
			// }
			//
			// onBlur() {
			// 	if (this.props.placeholder && DEFAULT_VALUE === this.internalValue) {
			// 		DEBUG && console.log('blur:placehold');
			// 		DEBUG && console.log(this.props.placeholder);
			//
			// 		this.internalValue = this.props.placeholder;
			//
			// 		this.forceUpdate();
			// 	}
			// }
	
		}]);
	
		return InputWysiwyg;
	}(_react.Component);
	
	InputWysiwyg.propTypes = {
		value: _react2.default.PropTypes.string.isRequired,
		placeholder: _react2.default.PropTypes.string,
		onChange: _react2.default.PropTypes.func.isRequired,
		hasLists: _react2.default.PropTypes.bool.isRequired,
		hasLinks: _react2.default.PropTypes.bool.isRequired,
		hasStyle: _react2.default.PropTypes.bool.isRequired
	};
	InputWysiwyg.defaultProps = {
		value: '',
		placeholder: '',
		hasLists: true,
		hasLinks: true,
		hasStyle: true,
		onChange: function onChange() {}
	};
	exports.default = InputWysiwyg;
	
	var InputWysiwygButton = function (_Component2) {
		_inherits(InputWysiwygButton, _Component2);
	
		function InputWysiwygButton(props) {
			_classCallCheck(this, InputWysiwygButton);
	
			var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(InputWysiwygButton).call(this, props));
	
			_this6.onToggle = function (e) {
				e.preventDefault();
				_this6.props.onToggle(_this6.props.style);
			};
			return _this6;
		}
	
		_createClass(InputWysiwygButton, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'button',
					{ tabIndex: '-1', className: 'form-wysiwyg__toolbar__button', onMouseDown: this.onToggle, title: this.props.title },
					!!this.props.icon && _react2.default.createElement('img', _extends({}, this.props.icon, { alt: 'Bold' })) || _react2.default.createElement(
						'span',
						null,
						this.props.title
					)
				);
			}
		}]);
	
		return InputWysiwygButton;
	}(_react.Component);
	
	InputWysiwygButton.propTypes = {
		style: _react.PropTypes.string.isRequired,
		title: _react.PropTypes.string,
		icon: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
		onToggle: _react.PropTypes.func
	};
	InputWysiwygButton.defaultProps = {
		style: 'bold',
		title: '',
		icon: false,
		onToggle: function onToggle() {}
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _reactRouter = __webpack_require__(3);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _routes = __webpack_require__(4);
	
	var _relatedinterviews = __webpack_require__(1025);
	
	var _relatedinterviews2 = _interopRequireDefault(_relatedinterviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedInterviews = function (_Component) {
		_inherits(RelatedInterviews, _Component);
	
		function RelatedInterviews(props) {
			_classCallCheck(this, RelatedInterviews);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RelatedInterviews).call(this, props));
	
			_this.state = {
				showMore: false
			};
			return _this;
		}
	
		_createClass(RelatedInterviews, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'section',
					{ className: 'related-interviews span14' },
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__top' },
						_react2.default.createElement(
							'h2',
							{ className: 'related-interviews__title' },
							this.props.title
						)
					),
					_react2.default.createElement(
						'ul',
						{ className: 'related-interviews__interview-holder' },
						this.props.interviews.map(function (interview, i) {
							return _this2.renderInterview(interview, i);
						})
					),
					!this.state.showMore && this.props.interviews.length > 4 && _react2.default.createElement(
						'span',
						{ className: 'related-interviews__more pixel-pattern', onClick: function onClick() {
								_this2.setState(_extends({}, _this2.state, { showMore: true }));
							} },
						'Load more ',
						_react2.default.createElement('i', { className: 'related-interviews__more__arrow' })
					)
				);
			}
		}, {
			key: 'renderInterview',
			value: function renderInterview(interview, i) {
				var releaseDate = new _date.DateFormatter(interview.releaseDate || interview.createdDate);
				var uid = interview.uid || 'interview' + interview.id;
				var type = interview.types.name;
	
				if (type.slice(-1) == 's') {
					type = type.substr(0, type.length - 1);
				}
	
				if (!this.state.showMore && i >= 5) {
					return false;
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'related-interviews__interview' },
					_react2.default.createElement(_image2.default, { className: 'related-interviews__interview__image span5 hide-mobile', img: interview.image, span: 'span14', alt: '', browser: this.props.browser }),
					interview.image && _react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.generateURL)(interview.types.slug, interview.slug), className: 'related-interviews__interview__buttons-container span5 span14-mobile' },
						_react2.default.createElement(
							'div',
							{ className: 'related-interviews__interview__button button button--go' },
							'Read ',
							type.toLowerCase()
						)
					) || _react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.generateURL)(interview.types.slug, interview.slug), className: 'related-interviews__interview__buttons-container span14 span14-mobile' },
						_react2.default.createElement(
							'div',
							{ className: 'related-interviews__interview__button button button--go' },
							'Read ',
							type.toLowerCase()
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__interview__date span2 pixel-pattern hide-tablet hide-mobile' },
						_react2.default.createElement(_pixeltext2.default, { text: releaseDate.date, className: 'related-interviews__interview__day', y: '15px', textAnchor: 'end' }),
						_react2.default.createElement(
							'span',
							{ className: 'related-interviews__interview__month' },
							releaseDate.month,
							' ',
							releaseDate.year
						),
						_react2.default.createElement(
							'span',
							{ className: 'related-interviews__interview__award' },
							type + ' —'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__interview__right span7 span9-tablet span14-mobile' },
						_react2.default.createElement(
							'h4',
							{ className: 'related-interviews__interview__byline' },
							'By ',
							interview.users.name
						),
						_react2.default.createElement(
							'h4',
							{ className: 'related-interviews__interview__small-date hide-desktop' },
							releaseDate.date + ' ' + releaseDate.month + ', ' + releaseDate.year
						),
						_react2.default.createElement(
							'div',
							{ className: 'related-interviews__interview__content' },
							_react2.default.createElement(
								'h3',
								{ className: 'related-interviews__interview__title' },
								interview.title
							),
							_react2.default.createElement(
								'p',
								{ className: 'related-interviews__interview__text' },
								interview.excerpt
							)
						)
					)
				);
			}
		}]);
	
		return RelatedInterviews;
	}(_react.Component);
	
	RelatedInterviews.propTypes = {};
	exports.default = RelatedInterviews;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _relatedjobs = __webpack_require__(1026);
	
	var _relatedjobs2 = _interopRequireDefault(_relatedjobs);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _reactClamp = __webpack_require__(162);
	
	var _reactClamp2 = _interopRequireDefault(_reactClamp);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RelatedJobs = function (_Component) {
		_inherits(RelatedJobs, _Component);
	
		function RelatedJobs(props) {
			_classCallCheck(this, RelatedJobs);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(RelatedJobs).call(this, props));
		}
	
		_createClass(RelatedJobs, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'section',
					{ className: 'related-jobs span14' },
					_react2.default.createElement(
						'div',
						{ className: 'related-jobs__left span5 span14-mobile' },
						_react2.default.createElement(
							'h2',
							{ className: 'related-jobs__title span9-mobile' },
							this.props.title
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: 'button related-jobs__all-jobs', to: (0, _index.jobsRoute)() },
							'All jobs'
						)
					),
					this.props.jobs.length && _react2.default.createElement(
						'ul',
						{ className: 'related-jobs__job-holder span9 span14-mobile' },
						this.props.jobs.map(function (job, i) {
							return _this2.renderJob(job, i);
						})
					) || _react2.default.createElement(
						'ul',
						{ className: 'related-jobs__job-holder span9 span14-mobile' },
						_react2.default.createElement(
							'li',
							{ className: 'related-jobs__job related-jobs__job--sole span3 span9-tablet span14-mobile' },
							_react2.default.createElement(
								'h3',
								{ className: 'related-jobs__job__title hide-mobile' },
								'No current job vacancies posted on FWA'
							),
							_react2.default.createElement(
								'a',
								{ href: '#contact', className: 'related-jobs__job__btn button', onClick: function onClick(event) {
										return _this2.scroll(event);
									} },
								'Get in touch'
							)
						)
					)
				);
			}
		}, {
			key: 'scroll',
			value: function scroll(e) {
				e.preventDefault();
				var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
				scroller.to('#contact');
			}
		}, {
			key: 'renderJob',
			value: function renderJob(job, i) {
				var createdDate = new _date.DateFormatter(job.createdDate);
				var uid = job.uid || 'job' + job.id;
				var url = (0, _index.jobsRoute)(job.slug);
	
				if (i < 3) {
					return _react2.default.createElement(
						'li',
						{ key: uid, className: 'related-jobs__job span3 span9-tablet span14-mobile' },
						this.props.browser.window.width > 1199 && _react2.default.createElement(
							'h3',
							{ className: 'related-jobs__job__title' },
							job.title
						) || _react2.default.createElement(
							'h3',
							{ className: 'related-jobs__job__title' },
							_react2.default.createElement(
								_reactClamp2.default,
								{ clamp: 1, ellipsis: '…' },
								job.title
							)
						),
						_react2.default.createElement(
							'h4',
							{ className: 'related-jobs__job__city' },
							job.city,
							', ',
							job.country
						),
						_react2.default.createElement(
							'span',
							{ className: 'related-jobs__job__added' },
							'added: ' + createdDate.month + ', ' + createdDate.date + ' ' + createdDate.year
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url, className: 'related-jobs__job__overlay' },
							_react2.default.createElement(
								'div',
								{ className: 'button related-jobs__job__button' },
								'Read more'
							)
						)
					);
				}
			}
		}]);
	
		return RelatedJobs;
	}(_react.Component);
	
	RelatedJobs.propTypes = {};
	exports.default = RelatedJobs;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(640);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _classnames = __webpack_require__(269);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _threeimages = __webpack_require__(1030);
	
	var _threeimages2 = _interopRequireDefault(_threeimages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThreeImages = function (_Component) {
		_inherits(ThreeImages, _Component);
	
		function ThreeImages(props) {
			_classCallCheck(this, ThreeImages);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(ThreeImages).call(this, props));
		}
	
		_createClass(ThreeImages, [{
			key: 'render',
			value: function render() {
				var classNames = (0, _classnames2.default)({
					'span14': true,
					'three-images': true
				}, this.props.className);
	
				var sizeSettings = {
					containerSmallClass: 'three-images__container__small span14-mobile span5-tablet span5-desktop',
					imageSmallClass: 'three-images__image',
					imageSmallSpan: this.props.browser.window.width > 720 ? 'span5' : 'span14',
					containerLargeClass: 'three-images__container__large span14-mobile span9-tablet span9-desktop',
					imageLargeClass: 'three-images__image',
					imageLargeSpan: this.props.browser.window.width > 720 ? 'span9' : 'span14'
				};
	
				var component1 = {
					component: this.props.video1 ? _video2.default : _image2.default,
					props: this.getProps(this.props.video1, this.props.imgone, true, sizeSettings)
				};
	
				var component2 = {
					component: this.props.video2 ? _video2.default : _image2.default,
					props: this.getProps(this.props.video2, this.props.imgtwo, true, sizeSettings)
				};
	
				var component3 = {
					component: this.props.video3 ? _video2.default : _image2.default,
					props: this.getProps(this.props.video3, this.props.imgthree, false, sizeSettings)
				};
	
				return _react2.default.createElement(
					'div',
					{ className: classNames },
					_react2.default.createElement(
						'div',
						{ className: 'three-images__container' },
						_react2.default.createElement(
							'div',
							{ className: sizeSettings.containerSmallClass },
							this.getComponent(component1),
							this.getComponent(component2)
						),
						_react2.default.createElement(
							'div',
							{ className: sizeSettings.containerLargeClass },
							this.getComponent(component3)
						)
					)
				);
			}
		}, {
			key: 'getProps',
			value: function getProps(video, img, isSmall, settings) {
				if (video) {
					return {
						video: video,
						className: isSmall ? settings.imageSmallClass : settings.imageLargeClass
					};
				}
	
				return {
					img: img,
					className: isSmall ? settings.imageSmallClass : settings.imageLargeClass,
					span: isSmall ? settings.imageSmallSpan : settings.imageLargeSpan,
					alt: '',
					browser: this.props.browser
				};
			}
		}, {
			key: 'getComponent',
			value: function getComponent(comp) {
				if (comp.component && comp.props) {
					var _Component2 = comp.component;
					return _react2.default.createElement(_Component2, comp.props);
				}
	
				return false;
			}
		}]);
	
		return ThreeImages;
	}(_react.Component);
	
	ThreeImages.propTypes = {};
	exports.default = ThreeImages;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _introActivate = __webpack_require__(646);
	
	var _introActivate2 = _interopRequireDefault(_introActivate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineIntroElement = function (_Component) {
		_inherits(TimelineIntroElement, _Component);
	
		function TimelineIntroElement(props) {
			_classCallCheck(this, TimelineIntroElement);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineIntroElement).call(this, props));
		}
	
		_createClass(TimelineIntroElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.introActivate = (0, _introActivate2.default)(this.getElement.bind(this), this.props.browser, this.getIntroElement.bind(this), this.getIntroElementFade.bind(this), this.getIntroElementStopper.bind(this));
				this.props.browser.scroll.register(this.introActivate);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.introActivate);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps !== this.props;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.year) {
					return _react2.default.createElement(
						'div',
						{ className: 'timeline-hero-year__intro ' + this.props.before, ref: 'introWrap' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__intro__element', ref: 'introElement' },
							_react2.default.createElement(
								'p',
								{ className: 'timeline-hero-year__intro__content' },
								_react2.default.createElement(
									'span',
									{ ref: 'introElementStopper' },
									this.props.awardTitle + ' — ' + this.props.year + ':'
								),
								_react2.default.createElement(
									'strong',
									{ className: 'timeline-hero-year__intro__content--fade', ref: 'introElementFade' },
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero-year__intro__content--name' },
										this.props.title
									)
								)
							)
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'timeline-hero__intro ' + this.props.before, ref: 'introWrap' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__intro__element', ref: 'introElement' },
							_react2.default.createElement(
								'p',
								{ className: 'timeline-hero__intro__content' },
								_react2.default.createElement(
									'span',
									{ ref: 'introElementStopper' },
									this.props.winDate.month + ' — ' + this.props.winDate.year
								),
								_react2.default.createElement(
									'strong',
									{ className: 'timeline-hero__intro__content--fade', ref: 'introElementFade' },
									_react2.default.createElement(
										'span',
										null,
										this.props.awardTitle
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__intro__content--name' },
										this.props.title
									)
								)
							)
						)
					);
				}
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.introWrap;
			}
		}, {
			key: 'getIntroElement',
			value: function getIntroElement() {
				return this.refs.introElement;
			}
		}, {
			key: 'getIntroElementFade',
			value: function getIntroElementFade() {
				return this.refs.introElementFade;
			}
		}, {
			key: 'getIntroElementStopper',
			value: function getIntroElementStopper() {
				return this.refs.introElementStopper;
			}
		}]);
	
		return TimelineIntroElement;
	}(_react.Component);
	
	TimelineIntroElement.propTypes = {};
	TimelineIntroElement.defaultProps = {};
	exports.default = TimelineIntroElement;

/***/ },
/* 375 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getBreakpoint = getBreakpoint;
	exports.getColNumber = getColNumber;
	exports.getRow = getRow;
	exports.getCol = getCol;
	exports.getRankColOffset = getRankColOffset;
	exports.getElementDimensions = getElementDimensions;
	exports.getSplitterOffset = getSplitterOffset;
	var DEBUG = exports.DEBUG = false;
	var ANIMATION_DURATION = exports.ANIMATION_DURATION = 2500;
	
	var BP_DESKTOP_LARGE = exports.BP_DESKTOP_LARGE = 'BP_DESKTOP_LARGE';
	var BP_DESKTOP_SMALL = exports.BP_DESKTOP_SMALL = 'BP_DESKTOP_SMALL';
	var BP_TABLET_LARGE = exports.BP_TABLET_LARGE = 'BP_TABLET_LARGE';
	var BP_TABLET_SMALL = exports.BP_TABLET_SMALL = 'BP_TABLET_SMALL';
	var BP_MOBILE_LARGE = exports.BP_MOBILE_LARGE = 'BP_MOBILE_LARGE';
	var BP_MOBILE_SMALL = exports.BP_MOBILE_SMALL = 'BP_MOBILE_SMALL';
	
	function getBreakpoint(browser) {
		var wWidth = browser.window.wpWidth;
		if (wWidth <= 567) {
			return BP_MOBILE_SMALL;
		} else if (wWidth >= 567 && wWidth <= 719) {
			return BP_MOBILE_LARGE;
		} else if (wWidth >= 720 && wWidth <= 999) {
			return BP_TABLET_SMALL;
		} else if (wWidth >= 1000 && wWidth <= 1199) {
			return BP_TABLET_LARGE;
		} else if (wWidth >= 1200 && wWidth <= 1439) {
			return BP_DESKTOP_SMALL;
		} else {
			return BP_DESKTOP_LARGE;
		}
	}
	
	function getColNumber(bp) {
		var cols = 3;
	
		if (bp === BP_TABLET_LARGE || bp === BP_TABLET_SMALL) {
			cols = 2;
		} else if (bp === BP_MOBILE_LARGE || bp === BP_MOBILE_SMALL) {
			cols = 1;
		}
	
		return cols;
	}
	
	function getRow(rank, cols, rankOffset) {
		if (rank === 1) {
			return 0;
		}
	
		return Math.ceil((rank + rankOffset - 1) / cols);
	}
	
	function getCol(rank, cols, rankOffset) {
		if (rank === 1) {
			return 0;
		}
	
		return (rank + rankOffset - 2) % cols;
	}
	
	function getRankColOffset(rank, divideAt, cols) {
		if (rank > divideAt) {
			//rank += (cols - (((divideAt - 1) + (cols - 1)) % cols));
			if (cols === 1) {
				return 0;
			}
	
			switch (divideAt % cols) {
				case 0:
					return 1;
				case 1:
					return 0;
				case 2:
					return 2;
			}
		}
	
		return 0;
	}
	
	function getElementDimensions(bp) {
		switch (bp) {
			case BP_MOBILE_SMALL:
				return {
					w: 313,
					h: 305
				};
			case BP_MOBILE_LARGE:
				return {
					w: 537,
					h: 425
				};
			case BP_TABLET_SMALL:
				return {
					w: 303,
					h: 294
				};
			case BP_TABLET_LARGE:
				return {
					w: 411,
					h: 351
				};
			case BP_DESKTOP_SMALL:
				return {
					w: 322,
					h: 288
				};
			default:
				return {
					w: 390,
					h: 319
				};
		}
	}
	
	function getSplitterOffset(bp) {
		switch (bp) {
			case BP_MOBILE_SMALL:
				return 126 + 69;
			case BP_MOBILE_LARGE:
				return 126 + 69;
			case BP_TABLET_SMALL:
				return 202;
			case BP_TABLET_LARGE:
				return 202;
			case BP_DESKTOP_SMALL:
				return 388;
			default:
				return 388;
		}
	}

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _reactRedux = __webpack_require__(166);
	
	var _reactRouter = __webpack_require__(3);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _lodash = __webpack_require__(35);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _errors = __webpack_require__(29);
	
	var _routes = __webpack_require__(4);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _countdown = __webpack_require__(178);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _publicvoting = __webpack_require__(1050);
	
	var _publicvoting2 = _interopRequireDefault(_publicvoting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicVoting = function (_Component) {
		_inherits(PublicVoting, _Component);
	
		function PublicVoting(props) {
			_classCallCheck(this, PublicVoting);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PublicVoting).call(this, props));
	
			_this.mounted = true;
	
			_this.state = {
				cases: [],
				loading: true,
				data: {}
			};
			return _this;
		}
	
		_createClass(PublicVoting, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.getCases();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props;
				var browser = _props.browser;
				var sponsor = _props.sponsor;
				var ribbonStyle = _props.ribbonStyle;
				var _state = this.state;
				var data = _state.data;
				var cases = _state.cases;
				var alreadyVoted = data.alreadyVoted;
				var isVotingOpen = data.isVotingOpen;
				var roundText = data.roundText;
				var nextDate = data.nextDate;
				var linkAbout = data.linkAbout;
	
				var listClass = 'account-cases__list-container account-cases__list-container--active';
	
				if (this.state.loading || !data) {
					return _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' });
				}
	
				var sponsorImg = false;
				if (sponsor) {
					sponsorImg = _react2.default.createElement('img', _extends({}, sponsor, { alt: 'TCEAY Sponsor' }));
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'publicvoting' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Public Voting - ' + (0, _translate2.default)(this.props.head) }),
					_react2.default.createElement(
						'div',
						{ className: 'publicvoting__head' },
						_react2.default.createElement(
							'div',
							{ className: 'publicvoting__head__blurb push5 push0-tablet push0-mobile' },
							(0, _translate2.default)(this.props.blurb)
						),
						_react2.default.createElement(
							'div',
							{ className: 'publicvoting__head__share' },
							_react2.default.createElement(_share2.default, { browser: browser, title: (0, _translate2.default)(this.props.head) })
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: _react2.default.createElement(
								'span',
								{ className: 'publicvoting__head__sponsorlogo' },
								sponsorImg
							), className: 'publicvoting__head__text' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area span7 span10-tablet span14-mobile' },
							_react2.default.createElement(
								'strong',
								null,
								(0, _translate2.default)(this.props.head)
							),
							_react2.default.createElement('br', null),
							(0, _translate2.default)(this.props.subhead)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: _react2.default.createElement(
								'span',
								null,
								'About the voting process'
							), className: 'account-block-content--small-aside account-block-content--nopad' },
						_react2.default.createElement(
							'div',
							{ className: 'span7-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro' },
							_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)(this.props.about) } }),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							isVotingOpen && _react2.default.createElement(
								'button',
								{
									className: 'button--dark',
									onClick: function onClick() {
										var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
										var element = _reactDom2.default.findDOMNode(_this2.refs.msg);
										scroller.toElement(element);
									}
								},
								'Go to voting'
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement('div', { className: 'span0 span5-tablet hide-mobile account-jury__col1' }),
						_react2.default.createElement(
							'div',
							{ className: 'span7-tablet span14-mobile account-jury__col3', style: { paddingTop: 0 } },
							!!linkAbout && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									{ className: 'account-jury__linklist-head' },
									'Read more'
								),
								_react2.default.createElement(
									'ol',
									{ className: 'account-jury__linklist' },
									_react2.default.createElement(
										'li',
										{ className: 'account-jury__linklist__item' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: linkAbout.url },
											linkAbout.text
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_splitter2.default, null),
					_react2.default.createElement(
						_content2.default,
						{ title: roundText, className: 'publicvoting__votehead' },
						_react2.default.createElement(
							'span',
							{ className: 'publicvoting__votehead__status' },
							isVotingOpen ? 'Voting ends in:' : 'Voting starts in:'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'publicvoting__countdown' },
						_react2.default.createElement(_countdown2.default, { timeLeft: nextDate - Date.now() / 1000, spans: 'span14' })
					),
					_react2.default.createElement('div', { className: 'cf' }),
					_react2.default.createElement(_content2.default, { title: !!alreadyVoted ? 'Thank you for voting!' : '', className: 'publicvoting__spacer', ref: 'msg' }),
					_react2.default.createElement(
						'div',
						{ className: 'publicvoting__list-container' },
						_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
						_react2.default.createElement(
							'ul',
							{ className: 'publicvoting__case-holder span12 span14-mobile' },
							cases.map(function (caseItem, i) {
								var uid = 'case' + i;
								var credits = (0, _formatCredits2.default)(caseItem.profiles, false, false);
								return _react2.default.createElement(
									'li',
									{ key: uid, className: 'publicvoting__case span3 span6-tablet span14-mobile' },
									_react2.default.createElement(
										'div',
										{ className: 'contextual-menu__inner-list__cases__case contextual-menu__inner-list__cases__case--light span3 span6-tablet span14-mobile' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: (0, _routes.casesRoute)(caseItem.slug), target: '_blank', className: 'publicvoting__case__voteholder' },
											caseItem.thumbnail && _react2.default.createElement(
												'div',
												{ className: 'contextual-menu__inner-list__cases__case__image pixel-pattern pixel-pattern--darker' },
												_react2.default.createElement('div', { className: 'ribbon-' + ribbonStyle + ' ribbon-' + ribbonStyle + '--tr ribbon-' + ribbonStyle + '--small' }),
												_react2.default.createElement(_image2.default, { img: caseItem.thumbnail, span: { desktop: 'span4', tablet: 'span6', mobile: 'span14' }, browser: _this2.props.browser }),
												_react2.default.createElement(
													'div',
													{ className: 'publicvoting__case__voteholder__btns' },
													_react2.default.createElement(
														'div',
														{ className: 'publicvoting__case__voteholder__btns__pos' },
														_react2.default.createElement(
															'div',
															{ className: 'button button--dark-to-light-anim publicvoting__case__voteholder__btns__btn' },
															'See Case'
														),
														!alreadyVoted && _react2.default.createElement(
															'div',
															{ className: 'button button--light-to-dark-anim publicvoting__case__voteholder__btns__btn', onClick: function onClick(e) {
																	return _this2.submitVote(e, caseItem);
																} },
															'Vote'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'contextual-menu__inner-list__cases__case__content' },
												_react2.default.createElement(
													'h2',
													{ className: 'contextual-menu__inner-list__cases__case__title' },
													caseItem.title
												),
												_react2.default.createElement(
													'span',
													{ className: 'contextual-menu__inner-list__cases__case__byline' },
													credits
												)
											)
										)
									)
								);
							}),
							_react2.default.createElement('li', { className: 'publicvoting__case-fill span3 span6-tablet span14-mobile' }),
							_react2.default.createElement('li', { className: 'publicvoting__case-fill span3 span6-tablet span14-mobile' }),
							_react2.default.createElement('li', { className: 'publicvoting__case-fill span3 span6-tablet span14-mobile' })
						),
						_react2.default.createElement('div', { className: 'account-cases__fill span2 span2-plus hide-mobile' }),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'getCases',
			value: function getCases() {
				var _this3 = this;
	
				var success = arguments.length <= 0 || arguments[0] === undefined ? function () {} : arguments[0];
				var fail = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
	
				_axios2.default.get(this.props.voteUrl).then(function (res) {
					// console.log(res.data);
					if (res.data) {
						var newState = {
							loading: false,
							data: res.data
						};
	
						if (!_this3.state.cases.length) {
							newState.cases = (0, _lodash.shuffle)(res.data.cases) || [];
						}
	
						_this3.mounted && _this3.setState(newState);
	
						success();
					}
				}).catch(function (res) {
					_this3.mounted && _this3.setState({
						loading: false
					});
	
					if (res.data && res.data.message) {
						_this3.props.dispatch((0, _errors.dispatchError)(res.data));
					}
	
					fail();
				});
			}
		}, {
			key: 'submitVote',
			value: function submitVote(e, caseItem) {
				var _this4 = this;
	
				e.preventDefault();
				e.stopPropagation();
				// console.log(caseItem);
	
				this.refs.confirm.confirm((0, _translate2.default)(this.props.confirm).replace('%title%', caseItem.title), 'Yes', 'No').then(function () {
					_axios2.default.post(_this4.props.voteUrl + '/vote', _qs2.default.stringify({
						id: caseItem.id
					})).then(function (res) {
						if (res.data && res.data.message) {
							_this4.props.dispatch((0, _errors.dispatchMsg)(res.data));
							_this4.getCases(function () {
								var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
								var element = _reactDom2.default.findDOMNode(_this4.refs.msg);
								scroller.toElement(element);
							});
						}
					}).catch(function (res) {
						// show error msg
						if (res.data && res.data.message) {
							_this4.props.dispatch((0, _errors.dispatchError)(res.data));
							_this4.getCases();
						}
					});
				}).catch(function () {
					// do nothing
				});
			}
		}]);
	
		return PublicVoting;
	}(_react.Component);
	
	PublicVoting.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired,
	
		blurb: _react.PropTypes.string.isRequired,
		head: _react.PropTypes.string.isRequired,
		subhead: _react.PropTypes.string.isRequired,
		about: _react.PropTypes.string.isRequired,
		sponsor: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
		ribbonStyle: _react.PropTypes.string.isRequired,
		voteUrl: _react.PropTypes.string.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
		return { browser: state.browser };
	})(PublicVoting);

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _infiniteScroll = __webpack_require__(699);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _timelines = __webpack_require__(350);
	
	var TimelineActions = _interopRequireWildcard(_timelines);
	
	var _categories = __webpack_require__(584);
	
	var CategoryActions = _interopRequireWildcard(_categories);
	
	var _display = __webpack_require__(645);
	
	var _display2 = _interopRequireDefault(_display);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _states = __webpack_require__(239);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_Component) {
		_inherits(Timeline, _Component);
	
		function Timeline(props) {
			_classCallCheck(this, Timeline);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timeline).call(this));
	
			_this.contentUpdate = 0;
	
			_this.state = {
				contentTop: 0,
				contentHeight: 0,
				timelineActions: (0, _redux.bindActionCreators)(TimelineActions, props.dispatch),
				categoryActions: (0, _redux.bindActionCreators)(CategoryActions, props.dispatch),
				page: 0
			};
	
			_this.buttonHoverTimer = {
				timer: null,
				startTime: 0
			};
	
			_this.timelineUpdate = undefined;
			return _this;
		}
	
		_createClass(Timeline, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.state.timelineActions && typeof this.state.timelineActions.fetchTimeline === 'function') {
					var params = {
						limit: 20,
						offset: 0
					};
	
					if (this.props.router.params.pageNum) {
						this.state.initPage = parseInt(this.props.router.params.pageNum, 10);
						params.offset = (this.props.router.params.pageNum - 1) * 20;
					}
	
					this.state.timelineActions.fetchTimeline(params);
				}
	
				if (this.state.categoryActions && typeof this.state.categoryActions.fetchCategories === 'function') {
					this.state.categoryActions.fetchCategories();
				}
	
				this.setState(this.state);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props.browser && this.props.browser.window && nextProps.browser.window.width !== this.props.browser.window.width || this.props.timelines.update !== nextProps.timelines.update || this.dimensionsChanged || this.state.page !== nextState.page;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateStateIfDimensionsChanged(this.props, this.state);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (this.props.timelines.update !== this.timelineUpdate) {
					this.timelineUpdate = this.props.timelines.update;
					this.updateStateIfDimensionsChanged(this.props, this.state);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props$timelines = this.props.timelines;
				var items = _props$timelines.items;
				var next = _props$timelines.next;
				var prev = _props$timelines.prev;
				var filter = _props$timelines.filter;
				var isFetching = _props$timelines.isFetching;
				var skip = _props$timelines.skip;
				var startPage = _props$timelines.startPage;
				var fetchTimeline = this.state.timelineActions.fetchTimeline;
	
				var content = false;
	
				if (this.refs.timelinedisplay && this.refs.timelinedisplay.refs && this.refs.timelinedisplay.refs.container) {
					content = this.refs.timelinedisplay.refs.container;
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_infiniteScroll2.default,
						{
							dispatch: this.props.dispatch,
							next: next,
							prev: prev,
							browser: this.props.browser,
							contentHeight: this.state.contentHeight,
							contentTop: this.state.contentTop,
							update: this.props.timelines.update,
							isFetching: this.props.timelines.isFetching,
							fetch: function fetch(url, direction) {
								return fetchTimeline({}, url, direction);
							},
							pageUrl: (0, _routes.awardsRoute)(),
							pageCount: items.length / 21,
							page: this.state.page,
							initPage: this.state.initPage,
							hasPushState: !this.props.timelines.filters || this.props.timelines.filters === _states.STATE_ALL_ON,
							triggerElement: this.getTriggerElement.bind(this)(),
							disableManualTrigger: !!this.props.timelines.prev || this.props.timelines.items > 20
						},
						_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Awards' }),
						items && !items.length && _react2.default.createElement(_spinner2.default, { className: 'timeline__spinner', size: '80px' }),
						_react2.default.createElement(_display2.default, { ref: 'timelinedisplay', items: items, skip: skip, startPage: startPage, hasPushState: !this.props.timelines.filters || this.props.timelines.filters === _states.STATE_ALL_ON, browser: this.props.browser, updatePushState: this.triggerPushStateUpdate.bind(this) })
					)
				);
			}
		}, {
			key: 'getTriggerElement',
			value: function getTriggerElement() {
				return _react2.default.createElement(
					'div',
					{ className: 'timeline__infinite-trigger span2 span6-mobile pixel-pattern pixel-pattern--10' },
					_react2.default.createElement(
						'div',
						null,
						'Load more'
					),
					_react2.default.createElement(
						'div',
						{ className: 'arrow-container' },
						_react2.default.createElement('span', null)
					)
				);
			}
		}, {
			key: 'triggerPushStateUpdate',
			value: function triggerPushStateUpdate(page) {
				this.setState(_extends({}, this.state, { page: page }));
			}
		}, {
			key: 'getDimensions',
			value: function getDimensions(props) {
				var timelineElement = document.querySelector('ul.timeline');
				var dimensions = {
					contentTop: 0,
					contentHeight: 0
				};
	
				if (timelineElement) {
					dimensions.contentTop = timelineElement.offsetTop;
					dimensions.contentHeight = timelineElement.offsetHeight;
	
					// console.log(`%c TIMELINE: - update#: ${props.timelines.update} - height: ${this.state.contentHeight}`, 'background-color: black;color: white;');
				}
	
				return dimensions;
			}
		}, {
			key: 'updateStateIfDimensionsChanged',
			value: function updateStateIfDimensionsChanged(props, state) {
				var dim = this.getDimensions(props);
				this.dimensionsChanged = false;
	
				if (state.contentHeight !== dim.contentHeight) {
					this.dimensionsChanged = true;
	
					state.contentTop = dim.contentTop;
					state.contentHeight = dim.contentHeight;
	
					//triger re-render with correct dimensions
					this.setState(state);
				}
			}
		}]);
	
		return Timeline;
	}(_react.Component);
	
	Timeline.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		timelines: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _connect2.default)(Timeline);

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.EventEmitter = exports.BROWSER_SCROLLED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	// import rafScroll from '../utils/raf-scroll';
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _events = __webpack_require__(982);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// import throttle from 'lodash/throttle';
	
	var defaultState = {
		window: {
			width: getWidth(),
			height: getHeight()
		},
		scroll: {
			register: registerScrollEvents,
			deregister: deregisterScrollEvents
		}
	};
	
	var lastScroll = 0;
	var lastTime = new Date().getTime();
	var BROWSER_SCROLLED = exports.BROWSER_SCROLLED = 'BROWSER_SCROLLED';
	
	// ------------------------------------------------------------
	// Scroll stuff
	// ------------------------------------------------------------
	var EventEmitter = exports.EventEmitter = new _events2.default.EventEmitter();
	EventEmitter.setMaxListeners(0); // removed memory leak warning
	
	function registerScrollEvents(cb) {
		if (typeof cb === 'function') {
			EventEmitter.addListener(BROWSER_SCROLLED, cb);
		}
		// rafScroll.add(cb);
	}
	
	function deregisterScrollEvents(cb) {
		// console.log('before-remove: ' + EventEmitter.listenerCount(BROWSER_SCROLLED));
		if (typeof cb === 'function') {
			EventEmitter.removeListener(BROWSER_SCROLLED, cb);
		}
		// rafScroll.remove(cb);
		// console.log('after-remove: ' + EventEmitter.listenerCount(BROWSER_SCROLLED));
	}
	
	function emitScrollEvent() {
		var supportPageOffset = window.pageXOffset !== undefined;
		var isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
		// const x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
		var scrollY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
		var delta = scrollY - lastScroll;
		lastScroll = scrollY;
	
		var time = new Date().getTime();
		var deltaTime = time - lastTime;
		lastTime = time;
	
		EventEmitter.emit(BROWSER_SCROLLED, {
			scrollY: scrollY,
			delta: delta,
			deltaTime: deltaTime
		});
	}
	
	// Global scroll listener - throttled to only run max every
	// 60fps = 16.66ms pr. frame
	window.addEventListener('scroll', emitScrollEvent, false); // throttle(emitScrollEvent, 8, { leading: true, trailing: true }), false);
	
	// var perf = performance.now();
	// var test = (event) => {
	// 	// console.log('test: ' + (performance.now() - perf) + ' -- ' + event.scrollY);
	// 	// perf = performance.now();
	// 	console.log(event);
	// };
	
	// registerScrollEvents(test);
	// registerScrollEvents(test);
	
	// ------------------------------------------------------------
	// Browser-size stuff
	// ------------------------------------------------------------
	// function setDocumentElement(body) {
	// 	documentElement = body;
	// }
	
	function getWidth() {
		var documentElement = document.documentElement || document.body;
		if (documentElement && documentElement.clientHeight) {
			return documentElement.clientWidth;
		}
	
		return 0;
	}
	
	function getHeight() {
		var documentElement = document.documentElement || document.body;
		if (documentElement && documentElement.clientHeight) {
			return documentElement.clientHeight;
		}
	
		return 0;
	}
	
	function getWidthWiewport() {
		return window.window.innerWidth;
	}
	
	function getHeightWiewport() {
		return window.window.innerHeight;
	}
	
	function updateSizes(state) {
		// console.log(state);
		return _extends({}, state, {
			window: {
				width: getWidth(),
				height: getHeight(),
				wpWidth: getWidthWiewport(),
				wpHeight: getHeightWiewport()
			}
		});
	}
	
	// ------------------------------------------------------------
	// Action switch
	// ------------------------------------------------------------
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.BROWSER_RESIZE:
				return updateSizes(state);
			default:
				return state;
		}
	}

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'p',
				null,
				'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus quis egestas odio. Proin fringilla nibh a lacus lobortis dictum. Pellentesque iaculis massa eu nulla tempus ullamcorper. Vestibulum eget interdum lacus. Aenean felis neque, varius in orci id, blandit blandit leo. Nunc non interdum purus. Vestibulum a mattis lorem. Quisque sit amet hendrerit dui. Ut eu vestibulum ante, nec suscipit nisl.',
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				'Aliquam eu accumsan velit. Phasellus euismod eget nulla iaculis placerat. Donec eleifend accumsan commodo. Donec dignissim quis risus nec placerat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec consectetur elit eu est sodales, pellentesque maximus elit eleifend. Sed sodales finibus venenatis. In in sagittis mauris. Mauris iaculis ante sapien, vel suscipit elit efficitur vitae. Etiam maximus auctor ligula eu lacinia. In mollis arcu nec laoreet sollicitudin. Vestibulum cursus, nisl sit amet finibus placerat, odio nibh sagittis ex, vitae sagittis quam leo et nisi. Phasellus pulvinar laoreet eleifend. Vestibulum condimentum vehicula odio vel gravida.',
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				'Praesent quis erat placerat, posuere ex at, accumsan lectus. Sed auctor rutrum pulvinar. Ut elementum vehicula lorem. Praesent at erat ut turpis mollis commodo ac nec neque. In fermentum efficitur mi, ac ultrices odio facilisis ac. Nulla augue sapien, aliquet vitae tincidunt nec, facilisis at magna. Cras efficitur, ex ut mollis posuere, elit nunc tincidunt nisl, vel pharetra leo sapien id neque. Sed cursus, mi at rhoncus maximus, magna magna hendrerit enim, nec ultrices odio libero eget mauris. Mauris id scelerisque velit. Etiam laoreet vulputate dui a sodales. Proin lacinia mi sem, sed tempor odio consequat nec. Nunc justo magna, efficitur sit amet interdum consectetur, pulvinar sed diam. Pellentesque auctor lectus in nibh ornare, vel pretium augue varius. Quisque ornare nisl vitae consectetur molestie. Morbi dignissim, lacus sed commodo elementum, sapien justo malesuada ligula, ut bibendum leo dui at augue. Integer vestibulum vel enim sit amet blandit.'
			)
		);
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;

/***/ },
/* 380 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = relLinks;
	function relLinks() {
		var prev = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
		var next = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
		if (document.querySelector('link[rel="prev"]')) {
			document.querySelector('link[rel="prev"]').remove();
		}
	
		if (document.querySelector('link[rel="next"]')) {
			document.querySelector('link[rel="next"]').remove();
		}
	
		if (prev && prev !== '') {
			var link = '<link rel="prev" href="' + prev + '">';
			document.querySelector('head').insertAdjacentHTML('beforeend', link);
		}
	
		if (next && next !== '') {
			var _link = '<link rel="next" href="' + next + '">';
			document.querySelector('head').insertAdjacentHTML('beforeend', _link);
		}
	
		return false;
	};

/***/ },
/* 381 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StripeLoader = function () {
		function StripeLoader() {
			_classCallCheck(this, StripeLoader);
	
			this.API_KEY = false;
			this.load();
		}
	
		_createClass(StripeLoader, [{
			key: 'load',
			value: function load() {
				var _this = this;
	
				if (!this.isLoaded()) {
					// Inject facebook api
					(function (d, s, id) {
						var js,
						    fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s);js.id = id;
						/* js.src = 'https://js.stripe.com/v3/'; */ // added to main.js https://stripe.com/docs/stripe-js/reference#including-stripejs
						fjs.parentNode.insertBefore(js, fjs);
					})(document, 'script', 'stripe-sdk');
				}
	
				if (window.konfig.stripeKey) {
					this.interval = setInterval(function () {
						if (_this.isLoaded()) {
							/* this.API.setPublishableKey(window.konfig.stripeKey); */ // deprecated
							_this.API_KEY = window.konfig.stripeKey;
							clearInterval(_this.interval);
						}
					}, 100);
				}
			}
		}, {
			key: 'isLoaded',
			value: function isLoaded() {
				return typeof this.API_KEY !== 'boolean';
			}
		}, {
			key: 'getAPIKey',
			value: function getAPIKey() {
				return this.API_KEY;
			}
		}, {
			key: 'API',
			get: function get() {
				return window.Stripe;
			}
		}]);
	
		return StripeLoader;
	}();
	
	exports.default = StripeLoader;

/***/ },
/* 382 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var hexTable = function () {
	    var array = new Array(256);
	    for (var i = 0; i < 256; ++i) {
	        array[i] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
	    }
	
	    return array;
	}();
	
	exports.arrayToObject = function (source, options) {
	    var obj = options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
	            target[source] = true;
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (c === 0x2D || // -
	        c === 0x2E || // .
	        c === 0x5F || // _
	        c === 0x7E || // ~
	        c >= 0x30 && c <= 0x39 || // 0-9
	        c >= 0x41 && c <= 0x5A || // a-z
	        c >= 0x61 && c <= 0x7A // A-Z
	        ) {
	                out += string.charAt(i);
	                continue;
	            }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
	        out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && _typeof(obj[i]) === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (var j = 0; j < keys.length; ++j) {
	        var key = keys[j];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(66);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(117);
	var toLength = __webpack_require__(26);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(110);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(42);
	var toObject = __webpack_require__(37);
	var IObject = __webpack_require__(152);
	var toLength = __webpack_require__(26);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(42);
	var isObject = __webpack_require__(20);
	var invoke = __webpack_require__(393);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(34).f;
	var create = __webpack_require__(111);
	var redefineAll = __webpack_require__(115);
	var ctx = __webpack_require__(68);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(110);
	var $iterDefine = __webpack_require__(253);
	var step = __webpack_require__(396);
	var setSpecies = __webpack_require__(116);
	var DESCRIPTORS = __webpack_require__(27);
	var fastKey = __webpack_require__(101).fastKey;
	var validate = __webpack_require__(119);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(134);
	var from = __webpack_require__(385);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(115);
	var getWeak = __webpack_require__(101).getWeak;
	var anObject = __webpack_require__(10);
	var isObject = __webpack_require__(20);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(110);
	var createArrayMethod = __webpack_require__(79);
	var $has = __webpack_require__(53);
	var validate = __webpack_require__(119);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(184);
	var isObject = __webpack_require__(20);
	var toLength = __webpack_require__(26);
	var ctx = __webpack_require__(68);
	var IS_CONCAT_SPREADABLE = __webpack_require__(23)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(27) && !__webpack_require__(19)(function () {
	  return Object.defineProperty(__webpack_require__(246)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 393 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(20);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(10);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 396 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(255);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 398 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 399 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(27);
	var getKeys = __webpack_require__(113);
	var gOPS = __webpack_require__(188);
	var pIE = __webpack_require__(153);
	var toObject = __webpack_require__(37);
	var IObject = __webpack_require__(152);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(19)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34);
	var anObject = __webpack_require__(10);
	var getKeys = __webpack_require__(113);
	
	module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(56);
	var gOPN = __webpack_require__(112).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(53);
	var toIObject = __webpack_require__(56);
	var arrayIndexOf = __webpack_require__(181)(false);
	var IE_PROTO = __webpack_require__(260)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(27);
	var getKeys = __webpack_require__(113);
	var toIObject = __webpack_require__(56);
	var isEnum = __webpack_require__(153).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(112);
	var gOPS = __webpack_require__(188);
	var anObject = __webpack_require__(10);
	var Reflect = __webpack_require__(15).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(15).parseFloat;
	var $trim = __webpack_require__(137).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(263) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(15).parseInt;
	var $trim = __webpack_require__(137).trim;
	var ws = __webpack_require__(263);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(10);
	var isObject = __webpack_require__(20);
	var newPromiseCapability = __webpack_require__(257);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 410 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(26);
	var repeat = __webpack_require__(262);
	var defined = __webpack_require__(80);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(26);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(23);


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(388);
	var validate = __webpack_require__(119);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(182)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(258);
	__webpack_require__(2)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(27) && /./g.flags != 'g') __webpack_require__(34).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(151)
	});


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(388);
	var validate = __webpack_require__(119);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(182)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var each = __webpack_require__(79)(0);
	var redefine = __webpack_require__(48);
	var meta = __webpack_require__(101);
	var assign = __webpack_require__(400);
	var weak = __webpack_require__(390);
	var isObject = __webpack_require__(20);
	var validate = __webpack_require__(119);
	var NATIVE_WEAK_MAP = __webpack_require__(119);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(182)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(270);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(270);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ },
/* 421 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(421);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(421);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(270);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Constants = __webpack_require__(916);
	
	Object.keys(_Constants).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Constants[key];
	    }
	  });
	});
	Object.defineProperty(exports, 'Constants', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Constants).default;
	  }
	});
	
	var _getEntityRanges = __webpack_require__(918);
	
	Object.defineProperty(exports, 'getEntityRanges', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getEntityRanges).default;
	  }
	});
	
	var _getSelectedBlocks = __webpack_require__(271);
	
	Object.defineProperty(exports, 'getSelectedBlocks', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getSelectedBlocks).default;
	  }
	});
	
	var _selectionContainsEntity = __webpack_require__(919);
	
	Object.defineProperty(exports, 'selectionContainsEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_selectionContainsEntity).default;
	  }
	});
	
	var _callModifierForSelectedBlocks = __webpack_require__(917);
	
	Object.defineProperty(exports, 'callModifierForSelectedBlocks', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_callModifierForSelectedBlocks).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	var emptyFunction = __webpack_require__(57);
	var findRangesImmutable = __webpack_require__(197);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	var Record = Immutable.Record;
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentBlock = __webpack_require__(121);
	var DraftEditorLeaf = __webpack_require__(928);
	var DraftOffsetKey = __webpack_require__(196);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var Scroll = __webpack_require__(455);
	var SelectionState = __webpack_require__(138);
	var Style = __webpack_require__(281);
	var UnicodeBidi = __webpack_require__(456);
	var UnicodeBidiDirection = __webpack_require__(282);
	
	var cx = __webpack_require__(158);
	var getElementPosition = __webpack_require__(1062);
	var getScrollPosition = __webpack_require__(284);
	var getViewportDimensions = __webpack_require__(1065);
	var nullthrows = __webpack_require__(58);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	var DraftEditorBlock = (function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    _get(Object.getPrototypeOf(DraftEditorBlock.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  /**
	   * Return whether a block overlaps with either edge of the `SelectionState`.
	   */
	
	  _createClass(DraftEditorBlock, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	    }
	
	    /**
	     * When a block is mounted and overlaps the selection state, we need to make
	     * sure that the cursor is visible to match native behavior. This may not
	     * be the case if the user has pressed `RETURN` or pasted some content, since
	     * programatically creating these new blocks and setting the DOM selection
	     * will miss out on the browser natively scrolling to that position.
	     *
	     * To replicate native behavior, if the block overlaps the selection state
	     * on mount, force the scroll position. Check the scroll state of the scroll
	     * parent, and adjust it to align the entire block to the bottom of the
	     * scroll parent.
	     */
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var selection = this.props.selection;
	      var endKey = selection.getEndKey();
	      if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	        return;
	      }
	
	      var blockNode = ReactDOM.findDOMNode(this);
	      var scrollParent = Style.getScrollParent(blockNode);
	      var scrollPosition = getScrollPosition(scrollParent);
	      var scrollDelta;
	
	      if (scrollParent === window) {
	        var nodePosition = getElementPosition(blockNode);
	        var nodeBottom = nodePosition.y + nodePosition.height;
	        var viewportHeight = getViewportDimensions().height;
	        scrollDelta = nodeBottom - viewportHeight;
	        if (scrollDelta > 0) {
	          window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	        }
	      } else {
	        var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	        var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	        scrollDelta = blockBottom - scrollBottom;
	        if (scrollDelta > 0) {
	          Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	        }
	      }
	    }
	  }, {
	    key: '_renderChildren',
	    value: function _renderChildren() {
	      var _this = this;
	
	      var block = this.props.block;
	      var blockKey = block.getKey();
	      var text = block.getText();
	      var lastLeafSet = this.props.tree.size - 1;
	      var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	      return this.props.tree.map(function (leafSet, ii) {
	        var leavesForLeafSet = leafSet.get('leaves');
	        var lastLeaf = leavesForLeafSet.size - 1;
	        var leaves = leavesForLeafSet.map(function (leaf, jj) {
	          var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	          var start = leaf.get('start');
	          var end = leaf.get('end');
	          return React.createElement(DraftEditorLeaf, {
	            key: offsetKey,
	            offsetKey: offsetKey,
	            blockKey: blockKey,
	            start: start,
	            selection: hasSelection ? _this.props.selection : undefined,
	            forceSelection: _this.props.forceSelection,
	            text: text.slice(start, end),
	            styleSet: block.getInlineStyleAt(start),
	            customStyleMap: _this.props.customStyleMap,
	            isLast: ii === lastLeafSet && jj === lastLeaf
	          });
	        }).toArray();
	
	        var decoratorKey = leafSet.get('decoratorKey');
	        if (decoratorKey == null) {
	          return leaves;
	        }
	
	        if (!_this.props.decorator) {
	          return leaves;
	        }
	
	        var decorator = nullthrows(_this.props.decorator);
	
	        var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	        if (!DecoratorComponent) {
	          return leaves;
	        }
	
	        var decoratorProps = decorator.getPropsForKey(decoratorKey);
	        var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	        var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	        // Resetting dir to the same value on a child node makes Chrome/Firefox
	        // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	        var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this.props.direction);
	
	        return React.createElement(
	          DecoratorComponent,
	          _extends({}, decoratorProps, {
	            decoratedText: decoratedText,
	            dir: dir,
	            key: decoratorOffsetKey,
	            entityKey: block.getEntityAt(leafSet.get('start')),
	            offsetKey: decoratorOffsetKey }),
	          leaves
	        );
	      }).toArray();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var direction = _props.direction;
	      var offsetKey = _props.offsetKey;
	
	      var className = cx({
	        'public/DraftStyleDefault/block': true,
	        'public/DraftStyleDefault/ltr': direction === 'LTR',
	        'public/DraftStyleDefault/rtl': direction === 'RTL'
	      });
	
	      return React.createElement(
	        'div',
	        { 'data-offset-key': offsetKey, className: className },
	        this._renderChildren()
	      );
	    }
	  }]);
	
	  return DraftEditorBlock;
	})(React.Component);
	
	function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	}
	
	module.exports = DraftEditorBlock;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(24);
	
	var Record = Immutable.Record;
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = (function (_DraftEntityInstanceRecord) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceRecord);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    _get(Object.getPrototypeOf(DraftEntityInstance.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DraftEntityInstance, [{
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getMutability',
	    value: function getMutability() {
	      return this.get('mutability');
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      return this.get('data');
	    }
	  }]);
	
	  return DraftEntityInstance;
	})(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(1054);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'‘’]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ },
/* 431 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(121);
	var DefaultDraftBlockRenderMap = __webpack_require__(273);
	var DraftEntity = __webpack_require__(91);
	var Immutable = __webpack_require__(24);
	var URI = __webpack_require__(1055);
	
	var generateRandomKey = __webpack_require__(83);
	var getSafeBodyFromHTML = __webpack_require__(437);
	var invariant = __webpack_require__(7);
	var nullthrows = __webpack_require__(58);
	var sanitizeDraftText = __webpack_require__(278);
	
	var List = Immutable.List;
	var OrderedSet = Immutable.OrderedSet;
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var lastBlock;
	
	function getEmptyChunk() {
	  return {
	    text: '',
	    inlines: [],
	    entities: [],
	    blocks: []
	  };
	}
	
	function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities,
	    blocks: []
	  };
	}
	
	function getSoftNewlineChunk() {
	  return {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: []
	  };
	}
	
	function getBlockDividerChunk(block, depth) {
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [{
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    }]
	  };
	}
	
	function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	}
	
	function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  return blockRenderMap.map(function (config) {
	    return config.element;
	  }).valueSeq().toSet().filter(function (tag) {
	    return tag !== unstyledElement;
	  }).toArray().sort();
	}
	
	// custom element conversions
	function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	}
	
	function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (config) {
	    return config.element === tag || config.wrapper === tag;
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	}
	
	function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    (function () {
	      var htmlElement = node;
	      currentStyle = currentStyle.withMutations(function (style) {
	        if (htmlElement.style.fontWeight === 'bold') {
	          style.add('BOLD');
	        }
	
	        if (htmlElement.style.fontStyle === 'italic') {
	          style.add('ITALIC');
	        }
	
	        if (htmlElement.style.textDecoration === 'underline') {
	          style.add('UNDERLINE');
	        }
	
	        if (htmlElement.style.textDecoration === 'line-through') {
	          style.add('STRIKETHROUGH');
	        }
	      }).toOrderedSet();
	    })();
	  }
	  return currentStyle;
	}
	
	function joinChunks(A, B) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInB = B.text.slice(0, 1);
	
	  if (A.text.slice(-1) === '\r' && lastInB === '\r') {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (A.text.slice(-1) === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (lastInB === SPACE || lastInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	}
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	}
	
	function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : undefined;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:';
	}
	
	function genFragment(node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity) {
	  var nodeName = node.nodeName.toLowerCase();
	  var newBlock = false;
	  var nextBlockType = 'unstyled';
	  var lastLastBlock = lastBlock;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var text = node.textContent;
	    if (text.trim() === '' && inBlock !== 'pre') {
	      return getWhitespaceChunk(inEntity);
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      text = text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      text: text,
	      inlines: Array(text.length).fill(inlineStyle),
	      entities: Array(text.length).fill(inEntity),
	      blocks: []
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || getBlockTypeForTag(inBlock, lastList, blockRenderMap) === 'unstyled')) {
	      return getBlockDividerChunk('unstyled', depth);
	    }
	    return getSoftNewlineChunk();
	  }
	
	  var chunk = getEmptyChunk();
	  var newChunk = null;
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  // Block Tags
	  if (!inBlock && blockTags.indexOf(nodeName) !== -1) {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	  } else if (lastList && inBlock === 'li' && nodeName === 'li') {
	    chunk = getBlockDividerChunk(getBlockTypeForTag(nodeName, lastList, blockRenderMap), depth);
	    inBlock = nodeName;
	    newBlock = true;
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	  var href = null;
	
	  while (child) {
	    if (nodeName === 'a' && child.href && hasValidLinkText(child)) {
	      href = new URI(child.href).toString();
	      entityId = DraftEntity.create('LINK', 'MUTABLE', { url: href });
	    } else {
	      entityId = undefined;
	    }
	
	    newChunk = genFragment(child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity);
	
	    chunk = joinChunks(chunk, newChunk);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth));
	  }
	
	  return chunk;
	}
	
	function getChunkForHTML(html, DOMBuilder, blockRenderMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var chunk = genFragment(safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push({ type: 'unstyled', depth: 0 });
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return chunk;
	}
	
	function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length <= 1 || arguments[1] === undefined ? getSafeBodyFromHTML : arguments[1];
	  var blockRenderMap = arguments.length <= 2 || arguments[2] === undefined ? DefaultDraftBlockRenderMap : arguments[2];
	
	  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  var chunk = getChunkForHTML(html, DOMBuilder, blockRenderMap);
	
	  if (chunk == null) {
	    return null;
	  }
	  var start = 0;
	  return chunk.text.split('\r').map(function (textBlock, ii) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	    var end = start + textBlock.length;
	    var inlines = nullthrows(chunk).inlines.slice(start, end);
	    var entities = nullthrows(chunk).entities.slice(start, end);
	    var characterList = List(inlines.map(function (style, ii) {
	      var data = { style: style, entity: null };
	      if (entities[ii]) {
	        data.entity = entities[ii];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    return new ContentBlock({
	      key: generateRandomKey(),
	      type: nullthrows(chunk).blocks[ii].type,
	      depth: nullthrows(chunk).blocks[ii].depth,
	      text: textBlock,
	      characterList: characterList
	    });
	  });
	}
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(274);
	var Keys = __webpack_require__(280);
	var UserAgent = __webpack_require__(84);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier;
	var isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (hasCommandModifier(e)) {
	    return e.shiftKey ? 'redo' : 'undo';
	  }
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(275);
	var getSelectionOffsetKeyForNode = __webpack_require__(438);
	var getUpdatedSelectionState = __webpack_require__(440);
	var invariant = __webpack_require__(7);
	var nullthrows = __webpack_require__(58);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && getSelectionOffsetKeyForNode(node.firstChild)) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && getSelectionOffsetKeyForNode(node.lastChild)) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, node, childOffset) {
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : undefined;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : undefined;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(198);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	  if (!selectionState.isCollapsed()) {
	    return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	  }
	}
	
	module.exports = getFragmentFromSelection;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(84);
	
	var invariant = __webpack_require__(7);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : undefined;
	}
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(84);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node.
	 */
	function getSelectionOffsetKeyForNode(node) {
	  return node instanceof Element ? node.getAttribute('data-offset-key') : null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ },
/* 439 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * 
	 */
	
	'use strict';
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    callback(reader.result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(196);
	
	var nullthrows = __webpack_require__(58);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ },
/* 441 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * 
	 */
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	'use strict';
	
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ },
/* 442 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	        if (offset < leafStart) {
	          return false;
	        }
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ },
/* 443 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * 
	 */
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	'use strict';
	
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var DraftEntity = __webpack_require__(91);
	
	var findRangesImmutable = __webpack_require__(197);
	var invariant = __webpack_require__(7);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : undefined;
	  return removalRange;
	}
	
	function removeForBlock(block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = DraftEntity.get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset);
	
	      var start = _getRemovalRange.start;
	      var end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ },
/* 445 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 446 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 447 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 448 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 449 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 450 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 451 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 452 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(1053);
	
	var createArrayFromMixed = __webpack_require__(458);
	var emptyFunction = __webpack_require__(57);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(57);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 455 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(282);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-zªµºÀ-ÖØ-öø-ƺƻ' + 'Ƽ-ƿǀ-ǃǄ-ʓʔʕ-ʯʰ-ʸ' + 'ʻ-ˁː-ˑˠ-ˤˮͰ-ͳͶ-ͷ' + 'ͺͻ-ͽͿΆΈ-ΊΌΎ-Ρ' + 'Σ-ϵϷ-ҁ҂Ҋ-ԯԱ-Ֆՙ' + '՚-՟ա-և։ःऄ-हऻऽ' + 'ा-ीॉ-ौॎ-ॏॐक़-ॡ।-॥' + '०-९॰ॱॲ-ঀং-ঃঅ-ঌ' + 'এ-ঐও-নপ-রলশ-হঽ' + 'া-ীে-ৈো-ৌৎৗড়-ঢ়' + 'য়-ৡ০-৯ৰ-ৱ৴-৹৺ਃ' + 'ਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼' + 'ਵ-ਸ਼ਸ-ਹਾ-ੀਖ਼-ੜਫ਼੦-੯' + 'ੲ-ੴઃઅ-ઍએ-ઑઓ-નપ-ર' + 'લ-ળવ-હઽા-ીૉો-ૌૐ' + 'ૠ-ૡ૦-૯૰ଂ-ଃଅ-ଌଏ-ଐ' + 'ଓ-ନପ-ରଲ-ଳଵ-ହଽାୀ' + 'େ-ୈୋ-ୌୗଡ଼-ଢ଼ୟ-ୡ୦-୯' + '୰ୱ୲-୷ஃஅ-ஊஎ-ஐஒ-க' + 'ங-சஜஞ-டண-தந-பம-ஹ' + 'ா-ிு-ூெ-ைொ-ௌௐௗ' + '௦-௯௰-௲ఁ-ఃఅ-ఌఎ-ఐ' + 'ఒ-నప-హఽు-ౄౘ-ౙౠ-ౡ' + '౦-౯౿ಂ-ಃಅ-ಌಎ-ಐಒ-ನ' + 'ಪ-ಳವ-ಹಽಾಿೀ-ೄೆ' + 'ೇ-ೈೊ-ೋೕ-ೖೞೠ-ೡ೦-೯' + 'ೱ-ೲം-ഃഅ-ഌഎ-ഐഒ-ഺഽ' + 'ാ-ീെ-ൈൊ-ൌൎൗൠ-ൡ' + '൦-൯൰-൵൹ൺ-ൿං-ඃඅ-ඖ' + 'ක-නඳ-රලව-ෆා-ෑෘ-ෟ' + '෦-෯ෲ-ෳ෴ก-ะา-ำเ-ๅ' + 'ๆ๏๐-๙๚-๛ກ-ຂຄງ-ຈ' + 'ຊຍດ-ທນ-ຟມ-ຣລວ' + 'ສ-ຫອ-ະາ-ຳຽເ-ໄໆ' + '໐-໙ໜ-ໟༀ༁-༃༄-༒༓༔' + '༕-༗༚-༟༠-༩༪-༳༴༶༸' + '༾-༿ཀ-ཇཉ-ཬཿ྅ྈ-ྌ' + '྾-࿅࿇-࿌࿎-࿏࿐-࿔࿕-࿘' + '࿙-࿚က-ဪါ-ာေးျ-ြဿ' + '၀-၉၊-၏ၐ-ၕၖ-ၗၚ-ၝၡ' + 'ၢ-ၤၥ-ၦၧ-ၭၮ-ၰၵ-ႁ' + 'ႃ-ႄႇ-ႌႎႏ႐-႙ႚ-ႜ' + '႞-႟Ⴀ-ჅჇჍა-ჺ჻ჼ' + 'ჽ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈ' + 'ኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅ' + 'ወ-ዖዘ-ጐጒ-ጕጘ-ፚ፠-፨' + '፩-፼ᎀ-ᎏᎠ-Ᏼᐁ-ᙬ᙭-᙮' + 'ᙯ-ᙿᚁ-ᚚᚠ-ᛪ᛫-᛭ᛮ-ᛰ' + 'ᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱ᜵-᜶' + 'ᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳាើ-ៅ' + 'ះ-ៈ។-៖ៗ៘-៚ៜ០-៩' + '᠐-᠙ᠠ-ᡂᡃᡄ-ᡷᢀ-ᢨᢪ' + 'ᢰ-ᣵᤀ-ᤞᤣ-ᤦᤩ-ᤫᤰ-ᤱ' + 'ᤳ-ᤸ᥆-᥏ᥐ-ᥭᥰ-ᥴᦀ-ᦫ' + 'ᦰ-ᧀᧁ-ᧇᧈ-ᧉ᧐-᧙᧚ᨀ-ᨖ' + 'ᨙ-ᨚ᨞-᨟ᨠ-ᩔᩕᩗᩡᩣ-ᩤ' + 'ᩭ-ᩲ᪀-᪉᪐-᪙᪠-᪦ᪧ᪨-᪭' + 'ᬄᬅ-ᬳᬵᬻᬽ-ᭁᭃ-᭄ᭅ-ᭋ' + '᭐-᭙᭚-᭠᭡-᭪᭴-᭼ᮂᮃ-ᮠ' + 'ᮡᮦ-ᮧ᮪ᮮ-ᮯ᮰-᮹ᮺ-ᯥᯧ' + 'ᯪ-ᯬᯮ᯲-᯳᯼-᯿ᰀ-ᰣᰤ-ᰫ' + 'ᰴ-ᰵ᰻-᰿᱀-᱉ᱍ-ᱏ᱐-᱙' + 'ᱚ-ᱷᱸ-ᱽ᱾-᱿᳀-᳇᳓᳡' + 'ᳩ-ᳬᳮ-ᳱᳲ-ᳳᳵ-ᳶᴀ-ᴫ' + 'ᴬ-ᵪᵫ-ᵷᵸᵹ-ᶚᶛ-ᶿḀ-ἕ' + 'Ἐ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝ' + 'Ὗ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌ' + 'ῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‎' + 'ⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝ' + 'ℤΩℨK-ℭℯ-ℴℵ-ℸℹ' + 'ℼ-ℿⅅ-ⅉⅎ⅏Ⅰ-ↂↃ-ↄ' + 'ↅ-ↈ⌶-⍺⎕⒜-ⓩ⚬⠀-⣿' + 'Ⰰ-Ⱞⰰ-ⱞⱠ-ⱻⱼ-ⱽⱾ-ⳤ' + 'Ⳬ-ⳮⳲ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ' + '⵰ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾ' + 'ⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々〆〇' + '〡-〩〮-〯〱-〵〸-〺〻〼' + 'ぁ-ゖゝ-ゞゟァ-ヺー-ヾヿ' + 'ㄅ-ㄭㄱ-ㆎ㆐-㆑㆒-㆕㆖-㆟' + 'ㆠ-ㆺㇰ-ㇿ㈀-㈜㈠-㈩㈪-㉇' + '㉈-㉏㉠-㉻㉿㊀-㊉㊊-㊰㋀-㋋' + '㋐-㋾㌀-㍶㍻-㏝㏠-㏾㐀-䶵' + '一-鿌ꀀ-ꀔꀕꀖ-ꒌꓐ-ꓷꓸ-ꓽ' + '꓾-꓿ꔀ-ꘋꘌꘐ-ꘟ꘠-꘩ꘪ-ꘫ' + 'Ꙁ-ꙭꙮꚀ-ꚛꚜ-ꚝꚠ-ꛥꛦ-ꛯ' + '꛲-꛷Ꜣ-ꝯꝰꝱ-ꞇ꞉-꞊Ꞌ-ꞎ' + 'Ꞑ-ꞭꞰ-Ʇꟷꟸ-ꟹꟺꟻ-ꠁ' + 'ꠃ-ꠅꠇ-ꠊꠌ-ꠢꠣ-ꠤꠧ꠰-꠵' + '꠶-꠷ꡀ-ꡳꢀ-ꢁꢂ-ꢳꢴ-ꣃ' + '꣎-꣏꣐-꣙ꣲ-ꣷ꣸-꣺ꣻ꤀-꤉' + 'ꤊ-ꤥ꤮-꤯ꤰ-ꥆꥒ-꥓꥟ꥠ-ꥼ' + 'ꦃꦄ-ꦲꦴ-ꦵꦺ-ꦻꦽ-꧀꧁-꧍' + 'ꧏ꧐-꧙꧞-꧟ꧠ-ꧤꧦꧧ-ꧯ' + '꧰-꧹ꧺ-ꧾꨀ-ꨨꨯ-ꨰꨳ-ꨴ' + 'ꩀ-ꩂꩄ-ꩋꩍ꩐-꩙꩜-꩟ꩠ-ꩯ' + 'ꩰꩱ-ꩶ꩷-꩹ꩺꩻꩽꩾ-ꪯꪱ' + 'ꪵ-ꪶꪹ-ꪽꫀꫂꫛ-ꫜꫝ꫞-꫟' + 'ꫠ-ꫪꫫꫮ-ꫯ꫰-꫱ꫲꫳ-ꫴꫵ' + 'ꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ' + 'ꬰ-ꭚ꭛ꭜ-ꭟꭤ-ꭥꯀ-ꯢꯣ-ꯤ' + 'ꯦ-ꯧꯩ-ꯪ꯫꯬꯰-꯹가-힣' + 'ힰ-ퟆퟋ-ퟻ-豈-舘並-龎' + 'ﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚｦ-ｯｰ' + 'ｱ-ﾝﾞ-ﾟﾠ-ﾾￂ-ￇￊ-ￏ' + 'ￒ-ￗￚ-ￜ',
	
	  R: '֐־׀׃׆׈-׏א-ת׫-ׯ' + 'װ-ײ׳-״׵-׿߀-߉ߊ-ߪ' + 'ߴ-ߵߺ߻-߿ࠀ-ࠕࠚࠤࠨ' + '࠮-࠯࠰-࠾࠿ࡀ-ࡘ࡜-࡝࡞' + '࡟-࢟‏יִײַ-ﬨשׁ-זּ﬷טּ-לּ' + '﬽מּ﬿נּ-סּ﭂ףּ-פּ﭅צּ-ﭏ',
	
	  AL: '؈؋؍؛؜؝؞-؟ؠ-ؿـ' + 'ف-ي٭ٮ-ٯٱ-ۓ۔ەۥ-ۦ' + 'ۮ-ۯۺ-ۼ۽-۾ۿ܀-܍܎܏' + 'ܐܒ-ܯ݋-݌ݍ-ޥޱ޲-޿' + 'ࢠ-ࢲࢳ-ࣣﭐ-ﮱ﮲-﯁﯂-﯒' + 'ﯓ-ﴽ﵀-﵏ﵐ-ﶏ﶐-﶑ﶒ-ﷇ' + '﷈-﷏ﷰ-ﷻ﷼﷾-﷿ﹰ-ﹴ﹵' + 'ﹶ-ﻼ﻽-﻾'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ },
/* 457 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 461 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 462 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 464 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _DOMUtils = __webpack_require__(287);
	
	var _createHistory = __webpack_require__(468);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(139);
	
	var _PathUtils = __webpack_require__(123);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _DOMUtils = __webpack_require__(287);
	
	var _DOMStateStorage = __webpack_require__(286);
	
	var _createDOMHistory = __webpack_require__(466);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(123);
	
	var _AsyncUtils = __webpack_require__(1070);
	
	var _Actions = __webpack_require__(139);
	
	var _createLocation2 = __webpack_require__(1071);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(202);
	
	var _PathUtils = __webpack_require__(123);
	
	var _runTransitionHook = __webpack_require__(290);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(289);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc1.png",
	  width: 70,
	  height: 44,
	  bytes: 2727,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc1.png";
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc2.png",
	  width: 70,
	  height: 44,
	  bytes: 3606,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc2.png";
	};

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc3.png",
	  width: 70,
	  height: 44,
	  bytes: 5047,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc3.png";
	};

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc4.png",
	  width: 70,
	  height: 44,
	  bytes: 4312,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc4.png";
	};

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc1.png",
	  width: 70,
	  height: 44,
	  bytes: 2727,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc1.png";
	};

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc2.png",
	  width: 70,
	  height: 44,
	  bytes: 3606,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc2.png";
	};

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc3.png",
	  width: 70,
	  height: 44,
	  bytes: 5047,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc3.png";
	};

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "cc4.png",
	  width: 70,
	  height: 44,
	  bytes: 4312,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "cc4.png";
	};

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "placeholder.png",
	  width: 292,
	  height: 187,
	  bytes: 40534,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "placeholder.png";
	};

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-mail.png",
	  width: 29,
	  height: 29,
	  bytes: 254,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-mail.png";
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140),
	    root = __webpack_require__(103);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(291),
	    setCacheAdd = __webpack_require__(1184),
	    setCacheHas = __webpack_require__(1185);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(204),
	    stackClear = __webpack_require__(1187),
	    stackDelete = __webpack_require__(1188),
	    stackGet = __webpack_require__(1189),
	    stackHas = __webpack_require__(1190),
	    stackSet = __webpack_require__(1191);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(103);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 486 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(491),
	    isKey = __webpack_require__(207),
	    toKey = __webpack_require__(159);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(494);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1135),
	    isObject = __webpack_require__(104),
	    isObjectLike = __webpack_require__(141);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 490 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(72),
	    stringToPath = __webpack_require__(1193);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1145);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(483),
	    arraySome = __webpack_require__(1129);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 494 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 495 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 497 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 498 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	module.exports = reHasComplexSymbol;


/***/ },
/* 499 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return string.match(reComplexSymbol);
	}
	
	module.exports = stringToArray;


/***/ },
/* 500 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(209),
	    isObjectLike = __webpack_require__(141);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(72),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1124),
	    toInteger = __webpack_require__(504);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1206);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(300),
	    isObject = __webpack_require__(104),
	    isSymbol = __webpack_require__(211);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	// super simple module for the most common nodejs use case.
	exports.markdown = __webpack_require__(1210);
	exports.parse = exports.markdown.toHTML;


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(61)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(124)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 508 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(59)
	  , hide        = __webpack_require__(124)
	  , redefineAll = __webpack_require__(517)
	  , ctx         = __webpack_require__(214)
	  , anInstance  = __webpack_require__(508)
	  , defined     = __webpack_require__(215)
	  , forOf       = __webpack_require__(308)
	  , $iterDefine = __webpack_require__(310)
	  , step        = __webpack_require__(515)
	  , setSpecies  = __webpack_require__(1238)
	  , DESCRIPTORS = __webpack_require__(216)
	  , fastKey     = __webpack_require__(311).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(306)
	  , from    = __webpack_require__(1228);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(105)
	  , $export        = __webpack_require__(92)
	  , redefine       = __webpack_require__(125)
	  , redefineAll    = __webpack_require__(517)
	  , meta           = __webpack_require__(311)
	  , forOf          = __webpack_require__(308)
	  , anInstance     = __webpack_require__(508)
	  , isObject       = __webpack_require__(309)
	  , fails          = __webpack_require__(163)
	  , $iterDetect    = __webpack_require__(514)
	  , setToStringTag = __webpack_require__(218);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(164)
	  , ITERATOR   = __webpack_require__(61)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(305);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(61)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(125);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(105)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(215);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(306)
	  , ITERATOR  = __webpack_require__(61)('iterator')
	  , Iterators = __webpack_require__(164);
	module.exports = __webpack_require__(60).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(306)
	  , test    = {};
	test[__webpack_require__(61)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(125)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators     = __webpack_require__(1242)
	  , redefine       = __webpack_require__(125)
	  , global         = __webpack_require__(105)
	  , hide           = __webpack_require__(124)
	  , Iterators      = __webpack_require__(164)
	  , wks            = __webpack_require__(61)
	  , ITERATOR       = wks('iterator')
	  , TO_STRING_TAG  = wks('toStringTag')
	  , ArrayValues    = Iterators.Array;
	
	__webpack_require__(59).each.call(['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], function(NAME){
	  var Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	});

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e,t=__webpack_require__(1),n=(e=__webpack_require__(142))&&"object"==typeof e&&"default"in e?e.default:e;function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function i(e){return(i=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e,t){return(u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function c(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function s(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?c(e):t}function a(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=i(e);if(t){var o=i(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return s(this,n)}}var l="object"===("undefined"==typeof window||"undefined"==typeof window?"undefined":r(window)),f=l?document:{},d=["mousemove","keydown","wheel","DOMMouseScroll","mouseWheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange"];function v(e,t){var n;return function(){for(var r=arguments.length,o=new Array(r),i=0;i<r;i++)o[i]=arguments[i];n&&clearTimeout(n),n=setTimeout((function(){e.apply(void 0,o),n=null}),t)}}function p(e,t){var n=0;return function(){var r=(new Date).getTime();if(!(r-n<t))return n=r,e.apply(void 0,arguments)}}var h=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t)}(f,t.Component);var n,r,i,s=a(f);function f(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,f),(t=s.call(this,e)).state={idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null,pageX:null,pageY:null},t.tId=null,t.eventsBound=!1,e.debounce>0&&e.throttle>0)throw new Error("onAction can either be throttled or debounced (not both)");return e.debounce>0?t._onAction=v(e.onAction,e.debounce):e.throttle>0?t._onAction=p(e.onAction,e.throttle):e.onAction?t._onAction=e.onAction:t._onAction=function(){},e.eventsThrottle>0?t._handleEvent=p(t._handleEvent.bind(c(t)),e.eventsThrottle):t._handleEvent=t._handleEvent.bind(c(t)),e.startOnMount||(t.state.idle=!0),t._toggleIdleState=t._toggleIdleState.bind(c(t)),t.reset=t.reset.bind(c(t)),t.pause=t.pause.bind(c(t)),t.resume=t.resume.bind(c(t)),t.getRemainingTime=t.getRemainingTime.bind(c(t)),t.getElapsedTime=t.getElapsedTime.bind(c(t)),t.getLastActiveTime=t.getLastActiveTime.bind(c(t)),t.isIdle=t.isIdle.bind(c(t)),t}return n=f,(r=[{key:"componentDidMount",value:function(){this._bindEvents(),this.props.startOnMount&&this.reset()}},{key:"componentDidUpdate",value:function(e){e.debounce!==this.props.debounce&&(this._onAction=v(this._onAction,this.props.debounce)),e.throttle!==this.props.throttle&&(this._onAction=p(this._onAction,this.props.throttle)),e.eventsThrottle!==this.props.eventsThrottle&&(this._handleEvent=p(this._handleEvent,this.props.eventsThrottle))}},{key:"componentWillUnmount",value:function(){clearTimeout(this.tId),this._unbindEvents(!0)}},{key:"render",value:function(){return this.props.children||null}},{key:"_bindEvents",value:function(){var e=this;if(l){var t=this.props,n=t.element,r=t.events,o=t.passive,i=t.capture;this.eventsBound||(r.forEach((function(t){n.addEventListener(t,e._handleEvent,{capture:i,passive:o})})),this.eventsBound=!0)}}},{key:"_unbindEvents",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(l){var n=this.props,r=n.element,o=n.events,i=n.passive,u=n.capture;(this.eventsBound||t)&&(o.forEach((function(t){r.removeEventListener(t,e._handleEvent,{capture:u,passive:i})})),this.eventsBound=!1)}}},{key:"_toggleIdleState",value:function(e){var t=this;this.setState((function(e){return{idle:!e.idle}}),(function(){var n=t.props,r=n.onActive,o=n.onIdle,i=n.stopOnIdle;t.state.idle?(i&&(clearTimeout(t.tId),t.tId=null,t._unbindEvents()),o(e)):i||(t._bindEvents(),r(e))}))}},{key:"_handleEvent",value:function(e){var t=this.state,n=t.remaining,r=t.pageX,o=t.pageY,i=t.idle,u=this.props,c=u.timeout,s=u.stopOnIdle;if(this._onAction(e),!n){if("mousemove"===e.type){if(e.pageX===r&&e.pageY===o)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(this.getElapsedTime()<200)return}clearTimeout(this.tId),this.tId=null;var a=+new Date-this.getLastActiveTime();(i&&!s||!i&&a>c)&&this._toggleIdleState(e),this.setState({lastActive:+new Date,pageX:e.pageX,pageY:e.pageY}),i&&s||(this.tId=setTimeout(this._toggleIdleState,c))}}},{key:"reset",value:function(){clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null});var e=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,e)}},{key:"pause",value:function(){null===this.state.remaining&&(this._unbindEvents(),clearTimeout(this.tId),this.tId=null,this.setState({remaining:this.getRemainingTime()}))}},{key:"resume",value:function(){var e=this.state,t=e.remaining,n=e.idle;null!==t&&(this._bindEvents(),n||(this.tId=setTimeout(this._toggleIdleState,t),this.setState({remaining:null,lastActive:+new Date})))}},{key:"getRemainingTime",value:function(){var e=this.state,t=e.remaining,n=e.lastActive,r=this.props.timeout;if(null!==t)return t<0?0:t;var o=r-(+new Date-n);return o<0?0:o}},{key:"getElapsedTime",value:function(){var e=this.state.oldDate;return+new Date-e}},{key:"getLastActiveTime",value:function(){return this.state.lastActive}},{key:"isIdle",value:function(){return this.state.idle}}])&&o(n.prototype,r),i&&o(n,i),f}();function m(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.timeout,r=void 0===n?12e5:n,o=e.element,i=void 0===o?f:o,u=e.events,c=void 0===u?d:u,s=e.onIdle,a=void 0===s?function(){}:s,h=e.onActive,m=void 0===h?function(){}:h,b=e.onAction,g=void 0===b?function(){}:b,y=e.debounce,T=void 0===y?0:y,_=e.throttle,w=void 0===_?0:_,E=e.eventsThrottle,A=void 0===E?200:E,I=e.startOnMount,O=void 0===I||I,D=e.stopOnIdle,R=void 0!==D&&D,S=e.capture,k=void 0===S||S,M=e.passive,j=void 0===M||M,P=t.useRef(!1),L=t.useRef(!0),X=t.useRef(+new Date),Y=t.useRef(+new Date),x=t.useRef(null),B=t.useRef(null),q=t.useRef(null),C=t.useRef(null),U=t.useRef(a),W=t.useRef(m),z=t.useRef(g),F=function(e){var t=!L.current;L.current=t,t?(R&&(clearTimeout(C.current),C.current=null,J()),U.current(e)):R||(H(),W.current(e))},G=function(e){if(z.current(e),!x.current){if("mousemove"===e.type){if(e.pageX===B&&e.pageY===q)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(N()<200)return}clearTimeout(C.current),C.current=null;var t=+new Date-Q();(L.current&&!R||!L.current&&t>r)&&F(e),Y.current=+new Date,B.current=e.pageX,q.current=e.pageY,L.current&&R||(C.current=setTimeout(F,r))}},H=function(){l&&(P.current||(c.forEach((function(e){i.addEventListener(e,G,{capture:k,passive:j})})),P.current=!0))},J=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];l&&(P.current||e)&&(c.forEach((function(e){i.removeEventListener(e,G,{capture:k,passive:j})})),P.current=!1)},K=function(){if(null!==x.current)return x.current<0?0:x.current;var e=r-(+new Date-Y.current);return e<0?0:e},N=function(){return+new Date-X.current},Q=function(){return Y.current},V=function(){return L.current},Z=function(){clearTimeout(C.current),C.current=null,H(),L.current=!1,X.current=+new Date,Y.current=+new Date,x.current=null,C.current=setTimeout(F,r)},$=function(){null===x.current&&(J(),clearTimeout(C.current),C.current=null,x.current=K())},ee=function(){null!==x.current&&(H(),L.current||(C.current=setTimeout(F,x.current),x.current=null,Y.current=+new Date))};return t.useEffect((function(){if(T>0&&w>0)throw new Error("onAction can either be throttled or debounced (not both)");return A>0&&(G=p(G,A)),H(),O&&Z(),function(){clearTimeout(C.current),J(!0)}}),[]),t.useEffect((function(){U.current=a}),[a]),t.useEffect((function(){W.current=m}),[m]),t.useEffect((function(){z.current=T>0?v(g,T):w>0?p(g,w):g}),[g]),{isIdle:V,pause:$,reset:Z,resume:ee,getLastActiveTime:Q,getElapsedTime:N,getRemainingTime:K}}h.propTypes={timeout:n.number,events:n.arrayOf(n.string),onIdle:n.func,onActive:n.func,onAction:n.func,debounce:n.number,throttle:n.number,eventsThrottle:n.number,element:n.oneOfType([n.object,n.element]),startOnMount:n.bool,stopOnIdle:n.bool,passive:n.bool,capture:n.bool},h.defaultProps={timeout:12e5,element:f,events:d,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0},m.propTypes={timeout:n.number,events:n.arrayOf(n.string),onIdle:n.func,onActive:n.func,onAction:n.func,debounce:n.number,throttle:n.number,eventsThrottle:n.number,element:n.oneOfType([n.object,n.element]),startOnMount:n.bool,stopOnIdle:n.bool,passive:n.bool,capture:n.bool},m.defaultProps={timeout:12e5,element:f,events:d,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0},exports.default=h,exports.useIdleTimer=m;
	//# sourceMappingURL=index.min.js.map


/***/ },
/* 524 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var propTypes = exports.propTypes = {
	  url: _react.PropTypes.string,
	  playing: _react.PropTypes.bool,
	  volume: _react.PropTypes.number,
	  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  className: _react.PropTypes.string,
	  progressFrequency: _react.PropTypes.number,
	  soundcloudConfig: _react.PropTypes.shape({
	    clientId: _react.PropTypes.string
	  }),
	  youtubeConfig: _react.PropTypes.shape({
	    playerVars: _react.PropTypes.object,
	    preload: _react.PropTypes.bool
	  }),
	  vimeoConfig: _react.PropTypes.shape({
	    iframeParams: _react.PropTypes.object,
	    preload: _react.PropTypes.bool
	  }),
	  onPlay: _react.PropTypes.func,
	  onPause: _react.PropTypes.func,
	  onBuffer: _react.PropTypes.func,
	  onEnded: _react.PropTypes.func,
	  onError: _react.PropTypes.func,
	  onDuration: _react.PropTypes.func,
	  onProgress: _react.PropTypes.func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  volume: 0.8,
	  width: 640,
	  height: 360,
	  progressFrequency: 1000,
	  soundcloudConfig: {
	    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2'
	  },
	  youtubeConfig: {
	    playerVars: {},
	    preload: false
	  },
	  vimeoConfig: {
	    iframeParams: {},
	    preload: false
	  },
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onProgress: function onProgress() {}
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot handle clicks.') : (0, _invariant2.default)(false) : void 0;
	
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	      var state = _props.state;
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	      this.context.router.push(location);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(203);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(469);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1072);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(535);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(143);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(223);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(203);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(469);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 536 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(128);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(128);
	var ReactElement = __webpack_require__(73);
	
	var emptyFunction = __webpack_require__(57);
	var traverseAllChildren = __webpack_require__(342);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactComponent = __webpack_require__(540);
	var ReactElement = __webpack_require__(73);
	var ReactPropTypeLocations = __webpack_require__(229);
	var ReactPropTypeLocationNames = __webpack_require__(228);
	var ReactNoopUpdateQueue = __webpack_require__(552);
	
	var emptyObject = __webpack_require__(199);
	var invariant = __webpack_require__(7);
	var keyMirror = __webpack_require__(201);
	var keyOf = __webpack_require__(102);
	var warning = __webpack_require__(17);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.') : invariant(false) : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(552);
	var ReactInstrumentation = __webpack_require__(227);
	
	var canDefineProperty = __webpack_require__(333);
	var emptyObject = __webpack_require__(199);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : void 0;
	  if (false) {
	    ReactInstrumentation.debugTool.onSetState();
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(325);
	var ReactDOMIDOperations = __webpack_require__(1318);
	var ReactPerf = __webpack_require__(62);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	ReactPerf.measureMethods(ReactComponentBrowserEnvironment, 'ReactComponentBrowserEnvironment', {
	  replaceNodeWithMarkup: 'replaceNodeWithMarkup'
	});
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 542 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var LinkedValueUtils = __webpack_require__(328);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `select` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getNativeProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(73);
	var ReactPropTypeLocations = __webpack_require__(229);
	var ReactPropTypeLocationNames = __webpack_require__(228);
	var ReactCurrentOwner = __webpack_require__(107);
	
	var canDefineProperty = __webpack_require__(333);
	var getIteratorFn = __webpack_require__(338);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : void 0;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : void 0;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 545 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1322);
	
	var containsNode = __webpack_require__(283);
	var focusNode = __webpack_require__(459);
	var getActiveElement = __webpack_require__(200);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(145);
	var DOMProperty = __webpack_require__(127);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMContainerInfo = __webpack_require__(1313);
	var ReactDOMFeatureFlags = __webpack_require__(1317);
	var ReactElement = __webpack_require__(73);
	var ReactFeatureFlags = __webpack_require__(546);
	var ReactInstrumentation = __webpack_require__(227);
	var ReactMarkupChecksum = __webpack_require__(1334);
	var ReactPerf = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(146);
	var ReactUpdateQueue = __webpack_require__(554);
	var ReactUpdates = __webpack_require__(85);
	
	var emptyObject = __webpack_require__(199);
	var instantiateReactComponent = __webpack_require__(561);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(340);
	var shouldUpdateReactComponent = __webpack_require__(341);
	var warning = __webpack_require__(17);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  ReactReconciler.unmountComponent(instance, safely);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._nativeParent);
	  }
	}
	
	function getNativeRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevNativeInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevNativeInstance && !prevNativeInstance._nativeParent ? prevNativeInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getNativeRootInstanceInContainer(container);
	  return root ? root._nativeContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	  }
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(201);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var invariant = __webpack_require__(7);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(73);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  NATIVE: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.NATIVE;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : invariant(false) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(17);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(73);
	var ReactPropTypeLocationNames = __webpack_require__(228);
	
	var emptyFunction = __webpack_require__(57);
	var getIteratorFn = __webpack_require__(338);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactInstanceMap = __webpack_require__(331);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : invariant(false) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 555 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.0.1';

/***/ },
/* 556 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : void 0;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNativeComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(551);
	
	function getNativeComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.NATIVE) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getNativeComponentFromComposite;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactCompositeComponent = __webpack_require__(1309);
	var ReactEmptyComponent = __webpack_require__(545);
	var ReactNativeComponent = __webpack_require__(550);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getNativeNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 562 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	var escapeTextContentForBrowser = __webpack_require__(231);
	var setInnerHTML = __webpack_require__(340);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = routerStateEquals;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _constants = __webpack_require__(129);
	
	/**
	 * Check if two router states are equal. Ignores `location.key`.
	 * @returns {Boolean}
	 */
	
	function routerStateEquals(a, b) {
	  if (!a && !b) return true;
	  if (a && !b || !a && b) return false;
	  if (a[_constants.DOES_NEED_REFRESH] || b[_constants.DOES_NEED_REFRESH]) return false;
	
	  return a.location.pathname === b.location.pathname && a.location.search === b.location.search && _deepEqual2['default'](a.location.state, b.location.state);
	}
	
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(301);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1380);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 567 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 568 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var anglicize = __webpack_require__(571);
	
	module.exports = anglicize;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var charactersRE = __webpack_require__(573),
	    dict         = __webpack_require__(345);
	
	module.exports = anglicize;
	
	function anglicize(input){
	
	  return input.replace(charactersRE, function(character){
	    return dict[character] || character;
	  });
	
	}


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var dict = __webpack_require__(345);
	
	module.exports = Object.keys(dict);


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var characters = __webpack_require__(572);
	
	module.exports = new RegExp('[' + characters.join('') + ']', 'g');


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(347);
	var utils = __webpack_require__(86);
	var dispatchRequest = __webpack_require__(576);
	var InterceptorManager = __webpack_require__(575);
	
	var axios = module.exports = function (config) {
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge({
	    method: 'get',
	    headers: {},
	    timeout: defaults.timeout,
	    transformRequest: defaults.transformRequest,
	    transformResponse: defaults.transformResponse
	  }, config);
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || defaults.withCredentials;
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  axios.interceptors.request.forEach(function (interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  axios.interceptors.response.forEach(function (interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Expose defaults
	axios.defaults = defaults;
	
	// Expose all/spread
	axios.all = function (promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(580);
	
	// Expose interceptors
	axios.interceptors = {
	  request: new InterceptorManager(),
	  response: new InterceptorManager()
	};
	
	// Provide aliases for supported request methods
	(function () {
	  function createShortMethods() {
	    utils.forEach(arguments, function (method) {
	      axios[method] = function (url, config) {
	        return axios(utils.merge(config || {}, {
	          method: method,
	          url: url
	        }));
	      };
	    });
	  }
	
	  function createShortMethodsWithData() {
	    utils.forEach(arguments, function (method) {
	      axios[method] = function (url, data, config) {
	        return axios(utils.merge(config || {}, {
	          method: method,
	          url: url,
	          data: data
	        }));
	      };
	    });
	  }
	
	  createShortMethods('delete', 'get', 'head');
	  createShortMethodsWithData('post', 'put', 'patch');
	})();


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function (fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function (id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `remove`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function (fn) {
	  utils.forEach(this.handlers, function (h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function (resolve, reject) {
	    try {
	      // For browsers use XHR adapter
	      if ((typeof XMLHttpRequest !== 'undefined') || (typeof ActiveXObject !== 'undefined')) {
	        __webpack_require__(346)(resolve, reject, config);
	      }
	      // For node use HTTP adapter
	      else if (typeof process !== 'undefined') {
	        __webpack_require__(346)(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)))

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildUrl(url, params) {
	  if (!params) {
	    return url;
	  }
	
	  var parts = [];
	
	  utils.forEach(params, function (val, key) {
	    if (val === null || typeof val === 'undefined') {
	      return;
	    }
	
	    if (utils.isArray(val)) {
	      key = key + '[]';
	    }
	
	    if (!utils.isArray(val)) {
	      val = [val];
	    }
	
	    utils.forEach(val, function (v) {
	      if (utils.isDate(v)) {
	        v = v.toISOString();
	      }
	      else if (utils.isObject(v)) {
	        v = JSON.stringify(v);
	      }
	      parts.push(encode(key) + '=' + encode(v));
	    });
	  });
	
	  if (parts.length > 0) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
	  }
	
	  return url;
	};


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * WARNING:
	 *  This file makes references to objects that aren't safe in all environments.
	 *  Please see lib/utils.isStandardBrowserEnv before including this file.
	 */
	
	var utils = __webpack_require__(86);
	
	module.exports = {
	  write: function write(name, value, expires, path, domain, secure) {
	    var cookie = [];
	    cookie.push(name + '=' + encodeURIComponent(value));
	
	    if (utils.isNumber(expires)) {
	      cookie.push('expires=' + new Date(expires).toGMTString());
	    }
	
	    if (utils.isString(path)) {
	      cookie.push('path=' + path);
	    }
	
	    if (utils.isString(domain)) {
	      cookie.push('domain=' + domain);
	    }
	
	    if (secure === true) {
	      cookie.push('secure');
	    }
	
	    document.cookie = cookie.join('; ');
	  },
	
	  read: function read(name) {
	    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	    return (match ? decodeURIComponent(match[3]) : null);
	  },
	
	  remove: function remove(name) {
	    this.write(name, '', Date.now() - 86400000);
	  }
	};


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {}, key, val, i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 580 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function (arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(86);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  utils.forEach(fns, function (fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * WARNING:
	 *  This file makes references to objects that aren't safe in all environments.
	 *  Please see lib/utils.isStandardBrowserEnv before including this file.
	 */
	
	var utils = __webpack_require__(86);
	var msie = /(msie|trident)/i.test(navigator.userAgent);
	var urlParsingNode = document.createElement('a');
	var originUrl;
	
	/**
	 * Parse a URL to discover it's components
	 *
	 * @param {String} url The URL to be parsed
	 * @returns {Object}
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // IE needs attribute set twice to normalize properties
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	              urlParsingNode.pathname :
	              '/' + urlParsingNode.pathname
	  };
	}
	
	originUrl = urlResolve(window.location.href);
	
	/**
	 * Determine if a URL shares the same origin as the current location
	 *
	 * @param {String} requestUrl The URL to test
	 * @returns {boolean} True if URL shares the same origin, otherwise false
	 */
	module.exports = function urlIsSameOrigin(requestUrl) {
	  var parsed = (utils.isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	        parsed.host === originUrl.host);
	};


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.listenToBrowserResize = listenToBrowserResize;
	exports.updateBrowserSize = updateBrowserSize;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function listenToBrowserResize() {
		return function (dispatch) {
			var debounce = 0;
			var handleEvent = function handleEvent(e) {
				debounce && clearTimeout(debounce);
				debounce = setTimeout(function () {
					dispatch(updateBrowserSize());
				}, 100);
			};
	
			window.addEventListener('resize', handleEvent);
	
			return function () {
				window.removeEventListener('resize', handleEvent);
			};
		};
	}
	
	function updateBrowserSize() {
		return {
			type: actionTypes.BROWSER_RESIZE,
			payload: true
		};
	};

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchCategories = fetchCategories;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function g() {
		return { type: actionTypes.JOBS_REQ_DATA };
	};
	
	function receiveData(json) {
		return {
			type: _actions.CATEGORIES_RECV_DATA,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: _actions.CATEGORIES_RECV_ERROR,
			payload: json
		};
	};
	
	function fetchCategories() {
		return function (dispatch) {
			return _axios2.default.post(_baseUrl2.default + '/api/categories').then(function (response) {
				dispatch(receiveData(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
				//dispatch(pushState(null, '/error'));
			});
		};
	};

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchJury = fetchJury;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/jury/';
	
	var busy = false;
	
	function action(type) {
		return { type: type };
	};
	
	function respond(json, type) {
		//console.log(type);
		return {
			type: type,
			payload: json
		};
	};
	
	function fetchJury() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 36 : arguments[1];
		var q = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
		var queryParams = {
			offset: offset,
			limit: limit,
			q: q
		};
	
		if (busy) {
			return function (dispatch) {
				false;
			};
		}
	
		return function (dispatch) {
			busy = true;
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.JURY_RECV_DATA));
				busy = false;
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.JURY_RECV_ERROR));
				console.log('jury - fetch error');
				console.log(response);
				busy = false;
	
				//dispatch(pushState(null, '/error'));
			});
		};
	};

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchNews = fetchNews;
	exports.fetchNewsSingle = fetchNewsSingle;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/editorials/';
	
	function requestSingleData() {
		return { type: actionTypes.NEWS_REQ_DATA };
	};
	
	function requestSingleData() {
		return { type: actionTypes.NEWS_REQ_DATA_SINGLE };
	};
	
	function receiveData(json) {
		console.log('receiveData');
		return {
			type: actionTypes.NEWS_RECV_DATA,
			payload: json
		};
	};
	
	function receiveDataSingle(json) {
		return {
			type: actionTypes.NEWS_RECV_DATA_SINGLE,
			payload: json
		};
	};
	
	function receiveError(json) {
		return {
			type: actionTypes.NEWS_RECV_ERROR,
			payload: json
		};
	};
	
	function fetchNews() {
		var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		var limit = arguments.length <= 1 || arguments[1] === undefined ? 36 : arguments[1];
	
		return function (dispatch) {
			//dispatch(requestData());
			var queryParams = {
				offset: offset,
				limit: limit
			};
			return (0, _axios2.default)({
				url: url,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json',
				params: queryParams
			}).then(function (response) {
				dispatch(receiveData(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};
	
	function fetchNewsSingle(slug) {
		return function (dispatch) {
			//dispatch(requestSingleData());
			return (0, _axios2.default)({
				url: url + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(receiveDataSingle(response.data));
			}).catch(function (response) {
				dispatch(receiveError(response.data));
			});
		};
	};

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fetchPage = fetchPage;
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = _baseUrl2.default + '/api/basic/';
	
	function action(type) {
		return { type: type };
	};
	
	function respond(json, type) {
		//console.log(type);
		return {
			type: type,
			payload: json
		};
	};
	
	function fetchPage(slug) {
		if (!(typeof slug === 'number' || typeof slug === 'string' && slug.length)) {
			console.log('editorials - invalid slug');
			return function (dispatch) {
				dispatch((0, _reduxRouter.push)('/error'));
			};
		}
	
		//console.log('fetch single editorial - ' + url + slug);
	
		return function (dispatch) {
			dispatch(action(actionTypes.PAGES_REQ_SINGLE_DATA));
			return (0, _axios2.default)({
				url: url + slug,
				timeout: (false) || 10000,
				method: 'get',
				responseType: 'json'
			}).then(function (response) {
				dispatch(respond(response.data, actionTypes.PAGES_RECV_SINGLE_DATA));
			}).catch(function (response) {
				dispatch(respond(response.data, actionTypes.PAGES_RECV_ERROR));
	
				// console.log('Page - fetch error');
				// console.log(response);
	
				dispatch((0, _reduxRouter.push)('/error'));
			});
		};
	}

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _submit = __webpack_require__(352);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit3 = __webpack_require__(31);
	
	var _submit4 = _interopRequireDefault(_submit3);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _users = __webpack_require__(64);
	
	var _validate = __webpack_require__(76);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './account.scss';
	
	var AccountBasic = function (_Component) {
		_inherits(AccountBasic, _Component);
	
		function AccountBasic(props) {
			_classCallCheck(this, AccountBasic);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountBasic).call(this));
	
			_this.state = {
				waiting: false
			};
			return _this;
		}
	
		_createClass(AccountBasic, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				this.formElements = [];
				this.formElements.push(_react2.default.createElement(_text2.default, {
					className: 'span3 span11-mobile',
					ref: 'name',
					key: 'name',
					label: 'Name',
					name: 'name',
					placeholder: 'Full name',
					value: this.props.users.name,
					validate: [{ rule: _validate.VALIDATE_NOT_EMPTY }, { rule: _validate.VALIDATE_MIN_LENGTH, params: 2 }]
				}), _react2.default.createElement(_text2.default, {
					className: 'span3 span11-mobile',
					ref: 'email',
					key: 'email',
					label: 'Email',
					name: 'email',
					placeholder: 'Email',
					value: this.props.users.email,
					validate: [{ rule: _validate.VALIDATE_EMAIL }]
				}), _react2.default.createElement(
					_checkbox2.default,
					{ key: 'newsletter', name: 'newsletter', ref: 'newsletter', value: !!this.props.users.receiveNewsletter },
					(0, _translate2.default)('account/misc/newletter')
				), _react2.default.createElement(_text2.default, {
					className: 'span3 span11-mobile',
					ref: 'oldPassword',
					key: 'oldPassword',
					label: 'Old Password',
					name: 'oldPassword',
					type: 'password',
					placeholder: 'Password',
					manualValidate: true,
					validate: [{
						rule: _validate.VALIDATE_CUSTOM,
						params: function params(val) {
							if (val) {
								return val.length >= 6;
							} else {
								return true;
							}
						}
					}]
				}), _react2.default.createElement(_text2.default, {
					className: 'span3 span11-mobile',
					ref: 'newPassword',
					key: 'newPassword',
					label: 'New Password',
					name: 'newPassword',
					type: 'password',
					placeholder: 'Password',
					helpText: 'Minimum 6 Characters',
					manualValidate: true,
					validate: [{
						rule: _validate.VALIDATE_CUSTOM,
						params: function params(val) {
							if (_this2.refs.oldPassword && _this2.refs.oldPassword.value() && _this2.refs.oldPassword.testValidity()) {
								return val.length >= 6;
							} else {
								return !val.length;
							}
						}
					}]
				}));
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-edit' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						'form',
						{ onSubmit: this.handleSubmit.bind(this) },
						_react2.default.createElement(
							_content2.default,
							{ title: 'Your account details' },
							this.formElements.map(function (item) {
								return item;
							})
						),
						_react2.default.createElement(
							_submit2.default,
							null,
							_react2.default.createElement(
								'div',
								{ className: 'span3 span8-mobile' },
								_react2.default.createElement(_submit4.default, { name: 'Update settings', waiting: this.state.waiting })
							),
							_react2.default.createElement(
								'div',
								{ className: 'span4 account-block-submit__btw' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/', onClick: this.handleDelete.bind(this) },
									'Delete account'
								)
							),
							_react2.default.createElement('div', { className: 'cf' })
						)
					)
				);
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				var _this3 = this;
	
				e.preventDefault();
				var fields = [];
	
				for (var i = 0; i < this.formElements.length; i++) {
					// get actual element refs
					fields.push(this.refs[this.formElements[i].ref]);
				}
	
				if ((0, _validate.formIsValid)(fields)) {
					var data = {
						name: this.refs.name.value(),
						email: this.refs.email.value(),
						receiveNewsletter: this.refs.newsletter.value
					};
	
					if (this.refs.oldPassword.value() && this.refs.newPassword) {
						data.oldPassword = this.refs.oldPassword.value();
						data.newPassword = this.refs.newPassword.value();
					}
	
					this.props.dispatch((0, _users.updateLogin)(data, function () {
						//onSucces
						_this3.setState(_extends({}, _this3.state, { waiting: false }));
					}, function () {
						//onFail
						_this3.setState(_extends({}, _this3.state, { waiting: false }));
					}));
					this.setState(_extends({}, this.state, { waiting: true }));
				}
			}
		}, {
			key: 'handleDelete',
			value: function handleDelete(e) {
				var _this4 = this;
	
				e.preventDefault();
	
				this.refs.confirm.confirm('Are you sure you want to delete your account?').then(function () {
					_this4.props.dispatch((0, _users.deleteLogin)());
				}).catch(function () {});
			}
		}]);
	
		return AccountBasic;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountBasic);

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _reactIdleTimer = __webpack_require__(523);
	
	var _reactIdleTimer2 = _interopRequireDefault(_reactIdleTimer);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _step = __webpack_require__(354);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(355);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(234);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(356);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _popup = __webpack_require__(606);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _authorization = __webpack_require__(36);
	
	var _caseCreate = __webpack_require__(445);
	
	var _caseCreate2 = _interopRequireDefault(_caseCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pingURL = _baseUrl2.default + '/api/account/refresh';
	
	var CASE_STEP0 = 0;
	var CASE_STEP1 = 1;
	var CASE_STEP2 = 2;
	var CASE_STEP3 = 3;
	var CASE_STEP4 = 4;
	
	var AccountCaseCreate = function (_Component) {
		_inherits(AccountCaseCreate, _Component);
	
		function AccountCaseCreate(props) {
			_classCallCheck(this, AccountCaseCreate);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseCreate).call(this, props));
	
			var CLEAR_SESSION_PATH = _baseUrl2.default + '/api/account/projects/create';
			_axios2.default.get(CLEAR_SESSION_PATH).then(function () {}).catch(function () {});
	
			_this.idleTimer = null;
			_this.handleOnIdle = _this.handleOnIdle.bind(_this);
			_this.hideModal = _this.hideModal.bind(_this);
			_this.handleInactive = _this.handleInactive.bind(_this);
	
			// http://fwa.test:3000/account/profile/projects/create/
	
			_this.state = {
				skipPayment: !!(props.users.profile && props.users.profile.hasFreeSubmission),
				waiting: false,
				complete: false,
				step: props.router.location.query.step ? parseInt(props.router.location.query.step, 10) ? CASE_STEP1 : CASE_STEP0 : CASE_STEP0,
				customerInfo: {},
				slug: '',
				showTimeoutModal: false
			};
			return _this;
		}
	
		_createClass(AccountCaseCreate, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-process' },
					_react2.default.createElement(_reactIdleTimer2.default, {
						ref: function ref(_ref) {
							_this2.idleTimer = _ref;
						},
						timeout: 1000 * 60 * 55,
						onIdle: this.handleOnIdle,
						debounce: 250,
						events: []
					}),
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Submit Project' }),
					_react2.default.createElement(_popup2.default, {
						show: this.state.showTimeoutModal,
						handleClose: this.hideModal,
						handleInactive: this.handleInactive
					}),
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area' },
							_react2.default.createElement(
								'strong',
								null,
								(0, _translate2.default)('account/casecreate/head')
							),
							_react2.default.createElement('br', null),
							(0, _translate2.default)('account/casecreate/head2')
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/casecreate/introHead', true, true) } }), className: 'account-block-content--small-aside' },
						_react2.default.createElement('div', { className: 'account-process__description-area123123 span5 span100p-tablet span100p-mobile', dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/casecreate/intro', true) } })
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							this.state.step === CASE_STEP0 && _react2.default.createElement(
								'button',
								{ className: 'button--dark', onClick: function onClick() {
										return _this2.start();
									} },
								(0, _translate2.default)('account/casecreate/startButton')
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								_react2.default.createElement(
									'span',
									{ className: 'hide-mobile' },
									(0, _translate2.default)('account/casecreate/startText')
								),
								' ',
								(0, _translate2.default)('account/casecreate/startTextPrice')
							)
						)
					),
					_react2.default.createElement(_step2.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						goToStep: function goToStep() {
							return _this2.goToStep(CASE_STEP1);
						},
						goForward: function goForward() {
							return _this2.goForward(_this2.state);
						},
						onSubmit: function onSubmit(pr, st) {
							return _this2.onSubmit(pr, st);
						},
						user: this.props.users
					}),
					_react2.default.createElement(_step4.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						skipPayment: this.state.skipPayment,
						goToStep: function goToStep() {
							return _this2.goToStep(CASE_STEP2);
						},
						goForward: function goForward() {
							return _this2.goForward(_this2.state);
						},
						onSubmit: function onSubmit(pr, st) {
							return _this2.onSubmit(pr, st);
						},
						skipToEnd: function skipToEnd(st) {
							return _this2.goToStep(CASE_STEP4, st);
						}
					}),
					_react2.default.createElement(
						_reactStripeElements.Elements,
						null,
						_react2.default.createElement(_step6.default, {
							dispatch: this.props.dispatch,
							activeStep: this.state.step,
							customerInfo: this.state.customerInfo,
							goToStep: function goToStep() {
								return _this2.goToStep(CASE_STEP3);
							},
							goForward: function goForward() {
								return _this2.goForward(_this2.state);
							},
							onSubmit: function onSubmit(pr, st) {
								return _this2.onSubmit(pr, st);
							}
						})
					),
					_react2.default.createElement(_step8.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						goToStep: function goToStep() {
							return _this2.goToStep(CASE_STEP4);
						},
						goForward: function goForward() {
							return _this2.goForward(_this2.state);
						},
						onSubmit: function onSubmit(pr) {
							return _this2.onComplete(pr);
						},
						slug: this.state.slug
					})
				);
			}
		}, {
			key: 'showModal',
			value: function showModal() {
				this.setState({
					showTimeoutModal: true
				});
			}
		}, {
			key: 'hideModal',
			value: function hideModal() {
				this.resetTimer();
				this.pingServer();
				this.setState({
					showTimeoutModal: false
				});
			}
		}, {
			key: 'handleOnIdle',
			value: function handleOnIdle(event) {
				this.showModal();
			}
		}, {
			key: 'resetTimer',
			value: function resetTimer() {
				this.idleTimer.reset();
			}
		}, {
			key: 'handleInactive',
			value: function handleInactive() {
				var _props = this.props;
				var push = _props.history.push;
				var dispatch = _props.dispatch;
	
				dispatch(push('/'));
			}
		}, {
			key: 'pingServer',
			value: function pingServer() {
				_axios2.default.get(pingURL);
			}
		}, {
			key: 'start',
			value: function start() {
				if (this.state.step === CASE_STEP0) {
					this.setState(_extends({}, this.state, {
						step: CASE_STEP1
					}));
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this3 = this;
	
				var addedState = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				promise.then(function (res) {
					var newState = _extends({}, _this3.state, addedState);
	
					_this3.goForward(newState);
				}).catch(function () {});
			}
		}, {
			key: 'onComplete',
			value: function onComplete(promise) {
				var _this4 = this;
	
				promise.then(function (res) {
					_this4.setState(_extends({}, _this4.state, {
						complete: true
					}));
				}).catch(function () {});
			}
		}, {
			key: 'goForward',
			value: function goForward(state) {
				var nextStep = state.step + 1;
	
				if (nextStep === CASE_STEP3 && this.state.skipPayment) {
					nextStep++;
				}
	
				if (nextStep > CASE_STEP4) {
					return false;
				}
	
				if (nextStep < state.step) {
					return false;
				}
				this.setState(_extends({}, state, {
					step: nextStep
				}));
			}
		}, {
			key: 'goBackwards',
			value: function goBackwards() {
				var prevStep = this.state.step - 1;
				if (prevStep < CASE_STEP0) {
					return false;
				}
	
				this.setState(_extends({}, this.state, {
					step: prevStep
				}));
			}
		}, {
			key: 'goToStep',
			value: function goToStep(step) {
				var addedState = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				var minStep = CASE_STEP0;
				var maxStep = CASE_STEP4;
				if (!(step >= minStep && step <= maxStep)) {
					return false;
				}
	
				this.setState(_extends({}, this.state, addedState, {
					step: step
				}));
			}
		}, {
			key: 'cycleSteps',
			value: function cycleSteps() {
				var nextStep = (this.state.step + 1) % 5;
				this.setState(_extends({}, this.state, {
					step: nextStep
				}));
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountCaseCreate;
	}(_react.Component);
	
	AccountCaseCreate.propTypes = {
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _connect2.default)(AccountCaseCreate);

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _lodash = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _caseEditForm = __webpack_require__(353);
	
	var _caseEditForm2 = _interopRequireDefault(_caseEditForm);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _authorization = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	
	var AccountCaseEdit = function (_Component) {
		_inherits(AccountCaseEdit, _Component);
	
		function AccountCaseEdit(props) {
			_classCallCheck(this, AccountCaseEdit);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseEdit).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				submitting: false,
				showMore: false,
				case: {},
				caseId: props.router.params.id || 0
			};
			return _this;
		}
	
		_createClass(AccountCaseEdit, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var API_URL = _baseUrl2.default + ('/api/account/projects/' + this.state.caseId + '/form');
				_axios2.default.get(API_URL).then(function (res) {
					if (res.data) {
						var caseItem = res.data;
						caseItem.categories = ((0, _lodash.isArray)(caseItem.categories) ? caseItem.categories : []).map(function (obj) {
							return obj.id;
						});
	
						caseItem.credits = JSON.stringify(caseItem.profiles);
	
						_this2.mounted && _this2.setState(_extends({}, _this2.state, {
							waiting: false,
							case: caseItem
						}));
					}
				}).catch(function () {});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var API_URL = '/api/account/projects/' + this.state.caseId + '/form';
	
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-cases' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Projects - Edit' }),
					_react2.default.createElement(_caseEditForm2.default, {
						ref: 'form',
						path: API_URL,
						method: 'put',
						smallAside: false,
						'case': this.state.case,
						onSubmit: function onSubmit(promise) {
							promise.then(function () {
								_this3.setSubmitting(false);
							}).catch(function () {
								_this3.setSubmitting(false);
							});
						},
						head: this.renderHeader(),
						dispatch: this.props.dispatch
					})
				);
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				var _this4 = this;
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Edit project: ' + (this.state.case.title || ''), sticky: true, browser: this.props.browser },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content__content__buttons' },
						_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
						_react2.default.createElement(
							'button',
							{ className: 'button button--dark', onClick: function onClick(e) {
									return _this4.submitPreview(e);
								} },
							'Preview'
						),
						_react2.default.createElement(_submit2.default, { name: 'Update project', className: 'button', waiting: this.state.submitting, onClick: function onClick() {
								return _this4.setSubmitting(true);
							} })
					)
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'setSubmitting',
			value: function setSubmitting() {
				var val = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				this.mounted && this.setState(_extends({}, this.state, {
					submitting: val
				}));
			}
		}, {
			key: 'submitPreview',
			value: function submitPreview(e) {
				var _this5 = this;
	
				e.preventDefault();
				e.stopPropagation();
	
				if (!(this.refs.form && this.refs.form.refs && this.refs.form.refs.form)) {
					return false;
				}
	
				this.refs.confirm.confirm('Saving preview...', false, false);
	
				var API_URL = _baseUrl2.default + '/api/account/projects/' + this.state.caseId + '/preview';
				_axios2.default.put(API_URL, _qs2.default.stringify(_extends({}, this.refs.form.refs.form.serialize(), {
					preview: 1
				}))).then(function (res) {
					_this5.refs.confirm.confirm('Preview is ready', 'Open preview', false, (0, _routes.casesRoute)(res.data.case.slug) + '?preview=' + res.data.case.previewHash).then(function () {
						// if (res.data && res.data.case && res.data.case.slug && res.data.case.previewHash) {
						// 	window.open(casesRoute(res.data.case.slug) + '?preview=' + res.data.case.previewHash);
						// }
					}).catch(function () {});
				}).catch(function (res) {
					var text = 'Generating preview failed';
	
					if (res.data) {
						if (res.data.message) {
							text = res.data.message;
						}
	
						if (res.data.errors) {
							var errors = res.data.errors;
							var errorKeys = Object.keys(errors);
							for (var i = 0; i < errorKeys.length; i++) {
								text += '\n' + errors[errorKeys[i]];
							}
						}
					}
	
					_this5.refs.confirm.confirm(text, false);
				});
			}
		}]);
	
		return AccountCaseEdit;
	}(_react.Component);
	
	AccountCaseEdit.propTypes = {
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _connect2.default)(AccountCaseEdit);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AccountCaseListEditButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _relatedcases = __webpack_require__(238);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _caseList = __webpack_require__(987);
	
	var _caseList2 = _interopRequireDefault(_caseList);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _errors = __webpack_require__(29);
	
	var _account = __webpack_require__(348);
	
	var _authorization = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../utils/translate';
	
	//import * as actions from '../../actions/account';
	
	
	var AccountCaseList = function (_Component) {
		_inherits(AccountCaseList, _Component);
	
		function AccountCaseList(props) {
			_classCallCheck(this, AccountCaseList);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseList).call(this));
	
			_this.mounted = true;
			_this.state = {
				waiting: true,
				items: [],
				showMore: false
			};
			return _this;
		}
	
		_createClass(AccountCaseList, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				(0, _axios2.default)({
					url: _baseUrl2.default + '/api/account/profiles/cases',
					method: 'get',
					responseType: 'json'
				}).then(function (res) {
					var newState = _extends({}, _this2.state, {
						waiting: false
					});
					if (res.data && res.data.cases) {
						newState.items = res.data.cases;
					} else {
						_this2.props.dispatch((0, _errors.dispatchError)('Invalid data received.'));
					}
	
					if (_this2.mounted) {
						_this2.setState(newState);
					}
				}).catch(function (res) {
					if (res.data && res.data.message) {
						_this2.props.dispatch((0, _errors.dispatchError)(res.data));
					}
	
					if (_this2.mounted) {
						_this2.setState(_extends({}, _this2.state, {
							waiting: false
						}));
					}
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var listClass = 'account-cases__list-container';
				var loadmoreClass = 'related-cases__load-more span8 span100p-mobile pixel-pattern';
				if (this.state.showMore) {
					listClass += ' account-cases__list-container--active';
					loadmoreClass += ' active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-cases' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Projects' }),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Your projects', sticky: true, browser: this.props.browser },
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__content__buttons' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/profile/projects/create'), className: 'button button--dark ' },
								'Submit your project'
							)
						)
					),
					this.state.waiting && this.renderWaiting(),
					_react2.default.createElement(
						'div',
						{ className: listClass },
						_react2.default.createElement(_relatedcases.CaseList, { browser: this.props.browser, cases: this.state.items, contentComp: AccountCaseListEditButton }),
						_react2.default.createElement('div', { className: 'account-cases__fill span2' }),
						_react2.default.createElement('div', { className: 'cf' }),
						this.state.items.length > 6 && _react2.default.createElement(
							'a',
							{ href: 'javascript:void(0);', onClick: this.toggleMore.bind(this), className: loadmoreClass },
							_react2.default.createElement(
								'span',
								{ className: 'span2 related-cases__load-more__arrow-holder' },
								_react2.default.createElement('span', { className: 'related-cases__load-more__arrow' })
							),
							this.state.showMore ? _react2.default.createElement(
								'span',
								null,
								'Show less (',
								this.state.items.length,
								')'
							) : _react2.default.createElement(
								'span',
								null,
								'Show more (',
								this.state.items.length,
								')'
							)
						)
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'toggleMore',
			value: function toggleMore() {
				this.setState(_extends({}, this.state, {
					showMore: !this.state.showMore
				}));
			}
		}]);
	
		return AccountCaseList;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountCaseList);
	
	var AccountCaseListEditButton = exports.AccountCaseListEditButton = function (_Component2) {
		_inherits(AccountCaseListEditButton, _Component2);
	
		function AccountCaseListEditButton(props) {
			_classCallCheck(this, AccountCaseListEditButton);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountCaseListEditButton).call(this));
		}
	
		_createClass(AccountCaseListEditButton, [{
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ key: 'menu', className: 'account-cases__content' },
					_react2.default.createElement(
						'a',
						{ className: 'account-cases__content__button button button--action', ref: 'menu' },
						'...'
					),
					_react2.default.createElement(
						_dropdown2.default,
						{ key: 'dropdown', attachTo: function attachTo() {
								return _this4.refs.menu;
							}, pointTo: 'AUTO', browser: this.props.browser },
						_react2.default.createElement(
							'ol',
							{ key: 'dropdown-ol' },
							_react2.default.createElement(
								'li',
								{ key: 'link-edit' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.accountRoute)('/profile/projects/' + this.props.caseItem.id) },
									'Edit'
								)
							)
						)
					)
				);
			}
		}]);
	
		return AccountCaseListEditButton;
	}(_react.Component);
	
	AccountCaseListEditButton.propTypes = {
		caseItem: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired
	};

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _lodash = __webpack_require__(35);
	
	var _routes = __webpack_require__(4);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _dropzone = __webpack_require__(236);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	var _dropzoneVideo = __webpack_require__(623);
	
	var _dropzoneVideo2 = _interopRequireDefault(_dropzoneVideo);
	
	var _wysiwyg = __webpack_require__(370);
	
	var _wysiwyg2 = _interopRequireDefault(_wysiwyg);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _errors = __webpack_require__(29);
	
	var _types = __webpack_require__(88);
	
	var _authorization = __webpack_require__(36);
	
	var _editorials = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Splitter from './block/splitter';
	
	// import SubmitBlock from './block/submit';
	
	
	// import translate from '../../utils/translate';
	
	var AccountEditorialEdit = function (_Component) {
		_inherits(AccountEditorialEdit, _Component);
	
		function AccountEditorialEdit(props, context) {
			_classCallCheck(this, AccountEditorialEdit);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountEditorialEdit).call(this, props, context));
	
			_this.mounted = true;
			_this.routerWillLeave = _this.routerWillLeave.bind(_this);
			_this.windowWillLeave = _this.windowWillLeave.bind(_this);
	
			_this.state = {
				waiting: true,
				id: props.params && props.params.id ? props.params.id : false,
				type: props.params && props.params.type ? props.params.type : false,
				extraVisuals: _this.getVisualsFromEditorial(props.editorials.edit.editorials),
				extraLinks: _this.getLinksFromEditorial(props.editorials.edit.editorials),
				saved: false,
				busySaving: false
			};
			return _this;
		}
	
		_createClass(AccountEditorialEdit, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.isProfile() && (0, _authorization.redirectToAccountIfNoProfile)(this.props.dispatch, this.props.users);
	
				if (this.state.type) {
					this.props.dispatch((0, _editorials.editEditorial)(this.state.type, this.state.id));
				} else {
					// @TODO redirect -- what are you doing here?
				}
	
				if (this.context.router) {
					// console.log('setRouteLeaveHook');
					// console.log(this.props.route);
					this.removeRouteHook = this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
				}
	
				window.onbeforeunload = this.windowWillLeave;
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.setContentHash();
	
				if (this.props.editorials.edit && this.props.editorials.edit.editorials && this.props.editorials.edit.editorials.status === 'IN_REVIEW') {
					var basePath = this.isProfile() ? '/profile/editorial/' : '/editorial/';
					this.props.dispatch((0, _reduxRouter.push)((0, _routes.accountRoute)('' + basePath + this.state.type)));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				window.removeEventListener('beforeunload', this.windowWillLeave);
				if (typeof this.removeRouteHook === 'function') {
					this.removeRouteHook();
				}
			}
		}, {
			key: 'windowWillLeave',
			value: function windowWillLeave(e) {
				var hasUnsavedChanges = !this.isSaved();
				return hasUnsavedChanges ? 'You have unsaved changes, are you sure you want to leave?' : null;
			}
		}, {
			key: 'routerWillLeave',
			value: function routerWillLeave(e) {
				var _this2 = this;
	
				// console.log(e);
				var hasUnsavedChanges = !this.isSaved();
				// console.log('hasUnsavedChanges:', hasUnsavedChanges);
	
				if (this.actuallyLeave || !hasUnsavedChanges) {
					// return true; -- continue to end
				} else {
					if (this.refs.confirm) {
						this.refs.confirm.confirm('You have unsaved changes, are you sure you want to leave?', 'Yes').then(function () {
							_this2.actuallyLeave = true;
	
							switch (e.action) {
								case 'PUSH':
									_this2.props.dispatch((0, _reduxRouter.push)(e.pathname));
									break;
								case 'POP':
									window.history.back();
									break;
								default:
									window.location.href = e.pathname;
							}
						}).catch(function () {});
	
						return false;
					}
				}
	
				return true;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this3 = this;
	
				if (nextProps.editorials.edit && nextProps.editorials.edit.editorials && nextProps.editorials.edit.editorials.status === 'IN_REVIEW') {
					var basePath = this.isProfile() ? '/profile/editorial/' : '/editorial/';
					this.props.dispatch((0, _reduxRouter.push)((0, _routes.accountRoute)('' + basePath + this.state.type)));
				}
	
				if (nextProps.editorials.edit && nextProps.editorials.edit.editorialId) {
					var extraVisuals = this.state.extraVisuals;
	
					if (nextProps.editorials.edit.editorials && nextProps.editorials.edit.editorials.sections) {
	
						if (this.props.editorials.edit.editorials === undefined || this.props.editorials.edit.editorials && nextProps.editorials.edit.editorials.sections !== this.props.editorials.edit.editorials.sections) {
							extraVisuals = this.getVisualsFromEditorial(nextProps.editorials.edit.editorials);
						}
					}
	
					this.mounted && this.setState(_extends({}, this.state, {
						waiting: false,
						id: nextProps.editorials.edit.editorialId,
						extraVisuals: extraVisuals,
						extraLinks: this.getLinksFromEditorial(nextProps.editorials.edit.editorials)
					}));
				}
	
				setTimeout(function () {
					_this3.setContentHash();
				}, 100);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-editorial' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Editorial Edit' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this4.getRefs();
							}, method: 'put', action: '', ref: 'form' },
						_react2.default.createElement(
							_content2.default,
							{ title: this.props.editorials.edit.editorials.title, sticky: true, browser: this.props.browser },
							_react2.default.createElement(
								'div',
								{ className: 'account-block-content__content__buttons' },
								_react2.default.createElement(_submit2.default, { name: 'Save', className: 'button button--dark', onClick: function onClick(e) {
										e.preventDefault();_this4.saveEditorial(false);
									}, waiting: this.state.busySaving }),
								_react2.default.createElement(_submit2.default, { name: 'Save & Preview', className: 'button button--dark', onClick: function onClick(e) {
										e.preventDefault();_this4.getPreview();
									} }),
								_react2.default.createElement(_submit2.default, { name: 'Ready to Publish', className: 'button button--dark', onClick: function onClick(e) {
										e.preventDefault();_this4.saveEditorial(true);
									} })
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'Top Image' },
							_react2.default.createElement(_label2.default, { btw: '1364 · 620 jpg / png' }),
							_react2.default.createElement(_dropzone2.default, {
								ref: 'hero',
								aspect: 620 / 1364,
								width: 354,
								path: _baseUrl2.default + '/api/account/editorials/form/image',
								params: { editorialId: this.state.id },
								inputs: [{ name: 'hero', preview: this.props.editorials.edit.editorials.image }],
								accept: 'image/*',
								disableDelete: true
							})
						),
						this.props.editorials.edit.layoutType === _types.EDITORIAL_TYPE_QA && this.renderQAFields(),
						this.props.editorials.edit.layoutType === _types.EDITORIAL_TYPE_ARTICLE && this.renderArticleHeadlineFields(),
						this.props.editorials.edit.layoutType === _types.EDITORIAL_TYPE_ARTICLE && this.renderArticleBodyFields(),
						_react2.default.createElement(
							_content2.default,
							{ title: 'Extra visuals' },
							_react2.default.createElement(_label2.default, {
								label: '',
								btw: _react2.default.createElement(
									'span',
									null,
									'Add at least 4 visuals that add or in some way relate to the interview/article.',
									_react2.default.createElement('br', null),
									'Min. 430 pixels wide, max. 800 high.'
								)
							}),
							_react2.default.createElement(
								'div',
								{ className: 'account-block-content__extravisual' },
								this.state.extraVisuals.map(function (item) {
									return _react2.default.createElement(_dropzoneVideo2.default, {
										key: item.id || item.name,
										ref: item.name,
										name: item.name,
										preview: item.preview,
										video: item.video,
										mode: item.mode,
										aspect: 0.638888889,
										caption: item.caption,
										width: 354,
										params: {
											editorialId: _this4.state.id,
											sectionId: item.id
										},
										path: '/api/account/profiles/editorials/interview/form/image',
										accept: 'image/*',
										extraValue: {
											id: item.id,
											fid: item.fid
										},
										changeId: function changeId(newId, path) {
											return _this4.changeVisualId(item, newId, path);
										}
									});
								})
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ className: 'pixel-pattern pixel-pattern--01' },
							_react2.default.createElement(
								'button',
								{ className: 'button button--dark button--no-margin', onClick: function onClick(e) {
										return _this4.addVisuals(e);
									} },
								'Add more visuals'
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ title: 'Links' },
							_react2.default.createElement(
								'div',
								null,
								this.state.extraLinks.map(function (item, i) {
									var idName = item.name + '[id]';
									var titleName = item.name + '[title]';
									var urlName = item.name + '[url]';
	
									return _react2.default.createElement(
										'div',
										{ key: item.name, className: 'span3 cf account-block-content__extralink' },
										_react2.default.createElement(_text2.default, { type: 'hidden', ref: idName, name: idName, value: item.id || (0, _lodash.uniqueId)('new_') }),
										_react2.default.createElement('span', null),
										_react2.default.createElement(_text2.default, {
											type: 'text',
											ref: titleName,
											name: titleName,
											placeholder: 'Link name (as shown to the reader)',
											className: 'account-block-content__extralink__text',
											label: 'Link ' + (i + 1),
											btw: ' (optional)',
											value: item.title
										}),
										_react2.default.createElement('span', null),
										_react2.default.createElement(_text2.default, {
											type: 'url',
											ref: urlName,
											name: urlName,
											placeholder: 'Add URL',
											className: 'account-block-content__extralink__url',
											value: item.link
										})
									);
								})
							)
						),
						_react2.default.createElement(
							_content2.default,
							{ className: 'pixel-pattern pixel-pattern--01' },
							_react2.default.createElement(
								'button',
								{ className: 'button button--dark button--no-margin', onClick: function onClick(e) {
										return _this4.addLinks(e);
									} },
								'Add more links'
							)
						)
					)
				);
			}
		}, {
			key: 'changeVisualId',
			value: function changeVisualId(item, newId, path) {
				// console.log(item, newId);
				var newExtraVisuals = [].concat(_toConsumableArray(this.state.extraVisuals));
	
				if (item.id || item.fid) {
					var idToFind = item.id || item.fid;
					var idOrFid = !item.id && item.fid ? 'fid' : 'id';
	
					for (var i = 0; i < newExtraVisuals.length; i++) {
						if (newExtraVisuals[i][idOrFid] === idToFind) {
							var shouldNotClear = !!path;
							newExtraVisuals[i] = _extends({}, newExtraVisuals[i], {
								id: shouldNotClear ? parseInt(newId, 10) : (0, _lodash.uniqueId)('new_'),
								mode: shouldNotClear ? 'IMAGE' : 'NEUTRAL',
								preview: shouldNotClear ? path : '',
								caption: shouldNotClear ? item.caption : ''
							});
						}
					}
				}
	
				// console.table(newExtraVisuals);
	
				this.setState(_extends({}, this.state, {
					extraVisuals: newExtraVisuals
				}));
			}
		}, {
			key: 'getQAContent',
			value: function getQAContent(editorial) {
				var QAArray = [];
				var contents = editorial.contents;
	
				for (var i = 0; i < contents.length; i++) {
					if (contents[i].type === 'editorial-qa') {
						QAArray.push({
							id: contents[i].id,
							q: contents[i].question,
							a: contents[i].answer
						});
					}
				}
	
				return QAArray;
			}
		}, {
			key: 'renderQAFields',
			value: function renderQAFields() {
				var questions = this.getQAContent(this.props.editorials.edit.editorials);
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Q/A' },
					questions.map(function (question, i) {
						var name = 'answer[' + (question.id || i) + ']';
						return _react2.default.createElement(
							'div',
							{ key: name, className: 'account-block-content__question' },
							_react2.default.createElement(
								'div',
								{ className: 'account-block-content__question__q' },
								question.q
							),
							_react2.default.createElement(_wysiwyg2.default, { ref: name, name: name, value: question.a, placeholder: 'Answer', className: 'span5 span8-tablet span100p-mobile' })
						);
					})
				);
			}
		}, {
			key: 'renderArticleHeadlineFields',
			value: function renderArticleHeadlineFields() {
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Headlines' },
					_react2.default.createElement(
						'div',
						{ className: 'span7 span100p-mobile' },
						_react2.default.createElement(_textarea2.default, {
							type: 'text',
							ref: 'title',
							name: 'title',
							placeholder: 'Headline',
							rows: 2,
							label: 'Headline',
							className: 'custom-input__textarea--large-type',
							value: this.props.editorials.edit.editorials.title || '',
							autosize: true
						}),
						_react2.default.createElement(_textarea2.default, {
							type: 'text',
							ref: 'subtitle',
							name: 'subtitle',
							placeholder: 'Site of the Day, 12th June 2015',
							rows: 2,
							label: 'Sub headline',
							className: 'custom-input__textarea--large-type',
							value: this.props.editorials.edit.editorials.subtitle || '',
							autosize: true
						}),
						_react2.default.createElement(_textarea2.default, {
							type: 'text',
							ref: 'excerpt',
							name: 'excerpt',
							placeholder: 'An excerpt for the article',
							rows: 4,
							label: 'Excerpt',
							className: 'custom-input__textarea--medium-type',
							value: this.props.editorials.edit.editorials.excerpt || '',
							autosize: true
						})
					)
				);
			}
		}, {
			key: 'renderArticleBodyFields',
			value: function renderArticleBodyFields() {
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Body copy' },
					_react2.default.createElement(_label2.default, { name: 'content', label: 'Article' }),
					_react2.default.createElement(_wysiwyg2.default, {
						ref: 'content',
						name: 'content',
						value: this.getContents(),
						placeholder: '...',
						className: 'span5 span8-tablet span100p-mobile form-wysiwyg--large'
					})
				);
			}
		}, {
			key: 'getVisualsFromEditorial',
			value: function getVisualsFromEditorial(editorial) {
				if (!editorial) {
					return [];
				}
	
				// transform into usable format
				var visualsArray = function (sidebarSections) {
					var vsls = [];
					for (var i = 0; i < sidebarSections.length; i++) {
						var preview = sidebarSections[i].image ? sidebarSections[i].image : '';
	
						var video = function (sect) {
							switch (sect.type) {
								case 'YOUTUBE':
									return sect.youtube;
								case 'VIMEO':
									return sect.vimeo;
								default:
									return false;
							}
						}(sidebarSections[i]);
	
						vsls.push({
							id: sidebarSections[i].id,
							name: 'visuals[' + vsls.length + ']',
							mode: sidebarSections[i].type ? sidebarSections[i].type : 'NEUTRAL',
							caption: sidebarSections[i].description || '',
							video: video,
							preview: preview
						});
					}
	
					return vsls;
				}((0, _lodash.filter)(editorial.sections, function (o) {
					return o.type === 'IMAGE' || o.type === 'YOUTUBE' || o.type === 'VIMEO';
				}));
	
				while (visualsArray.length < 4) {
					var itemId = (0, _lodash.uniqueId)('new_');
					visualsArray.push({
						id: itemId,
						name: 'visuals[' + visualsArray.length + ']',
						preview: ''
					});
				}
	
				return visualsArray;
			}
		}, {
			key: 'getLinksFromEditorial',
			value: function getLinksFromEditorial(editorial) {
				if (!editorial) {
					return [];
				}
	
				// transform into usable format
				var linksArray = function (links) {
					var lnks = [];
					for (var i = 0; i < links.length; i++) {
						lnks.push({
							id: links[i].id,
							name: 'link[' + lnks.length + ']',
							link: links[i].link,
							title: links[i].link_name
						});
					}
	
					return lnks;
				}((0, _lodash.filter)(editorial.sections, function (o) {
					return o.type === 'LINK';
				}));
	
				if (!linksArray.length) {
					var itemId = (0, _lodash.uniqueId)('new_');
					linksArray.push({
						id: itemId,
						name: 'link[0]',
						link: '',
						title: ''
					});
				}
	
				return linksArray;
			}
		}, {
			key: 'getContents',
			value: function getContents() {
				var content = '';
				var contents = this.props.editorials.edit && this.props.editorials.edit.editorials && this.props.editorials.edit.editorials.contents && (0, _lodash.isArray)(this.props.editorials.edit.editorials.contents) ? this.props.editorials.edit.editorials.contents : [];
	
				for (var i = 0; i < contents.length; i++) {
					content += contents[i].text;
				}
	
				return content;
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'isProfile',
			value: function isProfile() {
				var props = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				var theProps = props || this.props;
				return theProps.router && theProps.router.routes && theProps.router.routes[3] && theProps.router.routes[3].source === 'profile';
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.mounted && this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'setContentHash',
			value: function setContentHash() {
				if (this.refs && this.refs.form) {
					this.hash = this.refs.form.serialize();
				} else {
					this.hash = false;
				}
				// console.log('SETTING HASH: ', this.hash);
			}
		}, {
			key: 'isSaved',
			value: function isSaved() {
				if (this.refs && this.refs.form) {
					// console.log('COMPARING::');
					// console.dir(this.hash);
					// console.dir(this.refs.form.serialize());
					// console.log('EQUAL: ', isEqual(this.hash, this.refs.form.serialize()));
	
					return (0, _lodash.isEqual)(this.hash, this.refs.form.serialize());
				}
	
				return true;
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'addVisuals',
			value: function addVisuals(e) {
				e.preventDefault();
	
				var extraVisuals = [].concat(_toConsumableArray(this.state.extraVisuals));
	
				extraVisuals.push({
					fid: (0, _lodash.uniqueId)('new_'),
					name: 'visuals[' + extraVisuals.length + ']',
					preview: ''
				});
	
				this.mounted && this.setState(_extends({}, this.state, {
					extraVisuals: extraVisuals
				}));
			}
		}, {
			key: 'addLinks',
			value: function addLinks(e) {
				e.preventDefault();
	
				var extraLinks = [].concat(_toConsumableArray(this.state.extraLinks));
	
				extraLinks.push({
					id: (0, _lodash.uniqueId)('new_'),
					name: 'link[' + extraLinks.length + ']',
					title: '',
					link: ''
				});
	
				this.mounted && this.setState(_extends({}, this.state, {
					extraLinks: extraLinks
				}));
			}
		}, {
			key: 'setBusySaving',
			value: function setBusySaving() {
				var val = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				this.mounted && this.setState(_extends({}, this.state, {
					busySaving: val
				}));
			}
		}, {
			key: 'isProfile',
			value: function isProfile() {
				var props = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				props = props || this.props;
				return this.props.router && this.props.router.routes && this.props.router.routes[3] && this.props.router.routes[3].source === 'profile';
			}
		}, {
			key: 'saveEditorial',
			value: function saveEditorial(isFinal) {
				var _this5 = this;
	
				var data = _extends({
					id: this.state.id,
					draft: !isFinal ? 1 : 0
				}, this.refs.form.serialize());
	
				this.setBusySaving(true);
	
				// console.table(data);
	
				return _axios2.default.put(_baseUrl2.default + '/api/account/editorials/' + this.state.type + '/form', _qs2.default.stringify(data)).then(function (res) {
					_this5.setContentHash();
					_this5.setBusySaving(false);
	
					if (res.data && res.data.message) {
						_this5.props.dispatch((0, _errors.dispatchMsg)(res.data));
					}
	
					if (isFinal) {
						var basePath = _this5.isProfile() ? '/profile/editorial/' : '/editorial/';
						_this5.setContentHash();
						_this5.props.dispatch((0, _reduxRouter.push)((0, _routes.accountRoute)('' + basePath + _this5.state.type)));
					} else {
						_this5.props.dispatch((0, _editorials.editEditorial)(_this5.state.type, _this5.state.id));
					}
				}).catch(function (res) {
					if (res.data && res.data.message) {
						_this5.props.dispatch((0, _errors.dispatchError)(res.data));
					}
	
					_this5.setBusySaving(false);
				});
			}
		}, {
			key: 'getPreview',
			value: function getPreview() {
				var _this6 = this;
	
				var data = _extends({
					id: this.state.id,
					draft: 1
				}, this.refs.form.serialize());
	
				this.refs.confirm.confirm('Saving preview...', false, false);
	
				return _axios2.default.put(_baseUrl2.default + '/api/account/editorials/' + this.state.type + '/form', _qs2.default.stringify(data)).then(function (res) {
					_this6.props.dispatch((0, _editorials.editEditorial)(_this6.state.type, _this6.state.id));
					_this6.setContentHash();
	
					_this6.refs.confirm.confirm('Preview is ready', 'Open preview', false, (0, _routes.editorialRoute)(res.data.slug) + '?preview=' + res.data.previewHash).then(function () {
						// if (res.data && res.data.previewHash && res.data.slug) {
						// 	window.open(`${editorialRoute(res.data.slug)}?preview=${res.data.previewHash}`);
						// }
					}).catch(function () {});
				}).catch(function (res) {
					var text = 'Generating preview failed';
	
					if (res.data) {
						if (res.data.message) {
							text = res.data.message;
						}
	
						if (res.data.errors) {
							var errors = res.data.errors;
							var errorKeys = Object.keys(errors);
							for (var i = 0; i < errorKeys.length; i++) {
								text += '\n' + errors[errorKeys[i]];
							}
						}
					}
	
					_this6.refs.confirm.confirm(text, false);
				});
			}
		}]);
	
		return AccountEditorialEdit;
	}(_react.Component);
	
	AccountEditorialEdit.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		users: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		params: _react.PropTypes.shape({
			id: _react.PropTypes.string,
			type: _react.PropTypes.string
		}),
		editorials: _react.PropTypes.shape({
			edit: _react.PropTypes.object.isRequired
		}).isRequired
	};
	AccountEditorialEdit.contextTypes = {
		router: _react.PropTypes.object
	};
	exports.default = (0, _connect2.default)(AccountEditorialEdit);

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.EditorialListItem = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _categoryList = __webpack_require__(351);
	
	var _categoryList2 = _interopRequireDefault(_categoryList);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _date = __webpack_require__(14);
	
	var _authorization = __webpack_require__(36);
	
	var _account = __webpack_require__(348);
	
	var actions = _interopRequireWildcard(_account);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import pluralize from 'pluralize';
	
	
	// import translate from '../../utils/translate';
	
	var UNPUBLISHED = 'UNPUBLISHED';
	var IN_REVIEW = 'IN_REVIEW';
	var PUBLISHED = 'PUBLISHED';
	
	var AccountEditorialList = function (_Component) {
		_inherits(AccountEditorialList, _Component);
	
		function AccountEditorialList(props) {
			_classCallCheck(this, AccountEditorialList);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountEditorialList).call(this));
	
			_this.state = {
				waiting: false,
				isProfile: undefined
			};
			return _this;
		}
	
		_createClass(AccountEditorialList, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var isProfile = this.isProfile();
				var fetchFunction = actions[isProfile ? 'fetchProfileEditorials' : 'fetchUserEditorials'];
	
				isProfile && (0, _authorization.redirectToAccountIfNoProfile)(this.props.dispatch, this.props.users);
	
				this.props.dispatch(actions.clearCollection());
				if (this.props.router.params.type) {
					this.state.isProfile = isProfile;
					this.setWaiting(true);
					this.props.dispatch(fetchFunction(this.props.router.params.type, function () {
						return _this2.setWaiting(false);
					}));
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this3 = this;
	
				var isProfile = this.isProfile(nextProps);
				var fetchFunction = actions[isProfile ? 'fetchProfileEditorials' : 'fetchUserEditorials'];
	
				if (this.props.router.params.type !== nextProps.router.params.type || this.state.isProfile !== isProfile) {
					this.props.dispatch(actions.clearCollection());
					this.state.isProfile = isProfile;
					this.setWaiting(true);
					this.props.dispatch(fetchFunction(nextProps.router.params.type, function () {
						return _this3.setWaiting(false);
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var editorialTypes = this.props.users.profile.editorials;
				var contentType = function (editorials, slug) {
					if (editorialTypes) {
						for (var i = 0; i < editorialTypes.length; i++) {
							if (editorialTypes[i].slug === slug) {
								return editorialTypes[i].name;
							}
						}
					}
	
					return '';
				}(editorialTypes, this.props.router.params.type);
				var title = contentType;
	
				if (this.isProfile() && this.props.users && this.props.users.profile && this.props.users.profile.name) {
					title += ' by ' + this.props.users.profile.name;
				}
	
				var contentTitles = {
					UNPUBLISHED: 'Unpublished',
					IN_REVIEW: 'In review',
					PUBLISHED: 'Published'
				};
	
				var content = {
					UNPUBLISHED: [],
					IN_REVIEW: [],
					PUBLISHED: []
				};
	
				for (var i = 0; i < this.props.account.editorials.length; i++) {
					if (this.props.account.editorials[i].status) {
						content[this.props.account.editorials[i].status].push(this.props.account.editorials[i]);
					} else {
						console.warn('Editorial has no status!');
					}
				}
	
				var isProfile = this.isProfile();
				var fetchFunction = actions[isProfile ? 'fetchProfileEditorials' : 'fetchUserEditorials'];
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-editorial' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						_content2.default,
						{ title: title, sticky: true, browser: this.props.browser },
						_react2.default.createElement('div', { className: 'account-block-content__content__buttons' })
					),
					this.state.waiting && this.renderWaiting(),
					!this.state.waiting && _react2.default.createElement(_splitter2.default, { className: 'hide-mobile' }),
					!this.state.waiting && Object.keys(contentTitles).map(function (key, i) {
						var title = contentTitles[key];
						return _react2.default.createElement(
							'div',
							{ key: title },
							_react2.default.createElement(_categoryList2.default, {
								browser: _this4.props.browser,
								compComponent: EditorialListItem,
								title: title,
								content: content[key],
								type: key,
								waiting: _this4.state.waiting,
								data: {
									dispatch: _this4.props.dispatch,
									refreshData: function refreshData() {
										_this4.setWaiting(true);
										_this4.props.dispatch(fetchFunction(_this4.props.router.params.type, function () {
											return _this4.setWaiting(false);
										}));
									},
									isProfile: isProfile
								}
							}),
							_react2.default.createElement(_splitter2.default, null)
						);
					})
				);
			}
		}, {
			key: 'isProfile',
			value: function isProfile() {
				var props = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				props = props || this.props;
				return this.props.router && this.props.router.routes && this.props.router.routes[3] && this.props.router.routes[3].source === 'profile';
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountEditorialList;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountEditorialList);
	
	var EditorialListItem = exports.EditorialListItem = function (_Component2) {
		_inherits(EditorialListItem, _Component2);
	
		function EditorialListItem() {
			_classCallCheck(this, EditorialListItem);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialListItem).apply(this, arguments));
		}
	
		_createClass(EditorialListItem, [{
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				var item = this.props.item;
	
				var STATUS_UNPUBLISHED = this.props.type === UNPUBLISHED || false;
				//let STATUS_IN_REVIEW = (this.props.type === IN_REVIEW) || false;
				//let STATUS_PUBLISHED = (this.props.type === PUBLISHED) || false;
				var CAN_EDIT = this.props.item.canEdit || false;
				var date = new _date.DateFormatter(this.props.type === PUBLISHED ? item.releaseDate : item.editedDate);
	
				var title = item.title || '';
				var userName = (item.user ? item.user.name : '') || '';
	
				//return (<div>{item.id}</div>);
				var basePath = this.props.data && this.props.data.isProfile ? '/profile/editorial/' : '/editorial/';
	
				return _react2.default.createElement(
					'div',
					{ className: 'editoriallist__content__item' },
					_react2.default.createElement(
						'h3',
						{ className: 'editoriallist__content__item__head' },
						title
					),
					_react2.default.createElement(
						'span',
						{ className: 'editoriallist__content__item__author' },
						'— ',
						userName
					),
					_react2.default.createElement(
						'span',
						{ className: 'editoriallist__content__item__foot' },
						this.props.type === PUBLISHED ? 'Published: ' : 'Last edited: ',
						date.monthDateAndYear
					),
					(STATUS_UNPUBLISHED || CAN_EDIT) && _react2.default.createElement(
						'a',
						{ key: 'menu', className: 'editoriallist__button button button--action', ref: 'menu' },
						'...'
					),
					(STATUS_UNPUBLISHED || CAN_EDIT) && _react2.default.createElement(
						_dropdown2.default,
						{ key: 'dropdown', attachTo: function attachTo() {
								return _this6.refs.menu;
							}, pointTo: 'AUTO', browser: this.props.browser },
						_react2.default.createElement(
							'ol',
							{ key: 'dropdown-ol' },
							_react2.default.createElement(
								'li',
								{ key: 'link-edit' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.accountRoute)('' + basePath + item.types.slug + '/' + item.id), onClick: function onClick(e) {
											return e.stopPropagation();
										} },
									'Edit'
								)
							),
							STATUS_UNPUBLISHED && _react2.default.createElement(
								'li',
								{ key: 'link-publish' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '', onClick: function onClick(e) {
											return _this6.publish(e, item);
										} },
									'Ready to publish'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'stopPropagation',
			value: function stopPropagation(e) {
				e.stopPropagation();
			}
		}, {
			key: 'publish',
			value: function publish(e, item) {
				var _this7 = this;
	
				e.preventDefault();
				// console.log('PUBLISH: ' + this.props.item.slug);
				// console.log(item, this.props);
				var type = this.props.item.types.slug;
	
				_axios2.default.post(_baseUrl2.default + '/api/account/editorials/' + item.id + '/publish', _qs2.default.stringify({
					type: type
				})).then(function (res) {
					_this7.catchMessage(res, false);
					if (_this7.props.data && _this7.props.data.refreshData) {
						_this7.props.data.refreshData();
					}
				}).catch(function (res) {
					_this7.catchMessage(res, true);
	
					// console.log(this.props);
					if (_this7.props.data && _this7.props.data.refreshData) {
						_this7.props.data.refreshData();
					}
				});
			}
		}, {
			key: 'catchMessage',
			value: function catchMessage(res) {
				var error = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
				var fn = error ? _errors.dispatchError : _errors.dispatchMsg;
				if (res.data && res.data.message) {
					this.props.data.dispatch(fn(res.data.message));
				}
			}
		}]);
	
		return EditorialListItem;
	}(_react.Component);
	
	EditorialListItem.propTypes = {
		type: _react.PropTypes.string.isRequired,
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		data: _react.PropTypes.object.isRequired
	};
	EditorialListItem.defaultProps = {
		type: '',
		item: {}
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _step = __webpack_require__(358);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(359);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(360);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(361);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _authorization = __webpack_require__(36);
	
	var _caseCreate = __webpack_require__(445);
	
	var _caseCreate2 = _interopRequireDefault(_caseCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../utils/translate';
	
	var JOB_STEP0 = 0;
	var JOB_STEP1 = 1;
	var JOB_STEP2 = 2;
	var JOB_STEP3 = 3;
	var JOB_STEP4 = 4;
	
	var AccountJobCreate = function (_Component) {
		_inherits(AccountJobCreate, _Component);
	
		function AccountJobCreate(props) {
			_classCallCheck(this, AccountJobCreate);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobCreate).call(this));
	
			_this.state = {
				waiting: false,
				step: JOB_STEP0,
				customerInfo: {},
				slug: '',
				skipPayment: !!(props.users.profile && props.users.profile.hasFreeSubmission)
			};
			return _this;
		}
	
		_createClass(AccountJobCreate, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var introText = (0, _translate2.default)('account/jobcreate/intro', true, true);
				//console.log(introText);
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-process' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Submit Job' }),
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement('div', { className: 'account-process__title-area', dangerouslySetInnerHTML: { __html: introText } })
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							this.state.step === JOB_STEP0 && _react2.default.createElement(
								'button',
								{ className: 'button--dark', onClick: function onClick() {
										return _this2.start();
									} },
								(0, _translate2.default)('account/jobcreate/startButton')
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								_react2.default.createElement(
									'span',
									{ className: 'hide-mobile' },
									(0, _translate2.default)('account/jobcreate/startText')
								),
								' ',
								(0, _translate2.default)('account/jobcreate/startTextPrice')
							)
						)
					),
					_react2.default.createElement(_step2.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						goToStep: function goToStep() {
							return _this2.goToStep(JOB_STEP1);
						},
						goForward: function goForward() {
							return _this2.goForward();
						},
						onSubmit: function onSubmit(pr, st) {
							return _this2.onSubmit(pr, st);
						},
						user: this.props.users
					}),
					_react2.default.createElement(_step4.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						skipPayment: this.state.skipPayment,
						goToStep: function goToStep() {
							return _this2.goToStep(JOB_STEP2);
						},
						goForward: function goForward() {
							return _this2.goForward();
						},
						onSubmit: function onSubmit(pr, st) {
							return _this2.onSubmit(pr, st);
						},
						skipToEnd: function skipToEnd(st) {
							return _this2.goToStep(JOB_STEP4, st);
						}
					}),
					_react2.default.createElement(
						_reactStripeElements.Elements,
						null,
						_react2.default.createElement(_step6.default, {
							dispatch: this.props.dispatch,
							activeStep: this.state.step,
							goToStep: function goToStep() {
								return _this2.goToStep(JOB_STEP3);
							},
							goForward: function goForward() {
								return _this2.goForward();
							},
							onSubmit: function onSubmit(pr, st) {
								return _this2.onSubmit(pr, st);
							}
						})
					),
					_react2.default.createElement(_step8.default, {
						dispatch: this.props.dispatch,
						activeStep: this.state.step,
						goToStep: function goToStep() {
							return _this2.goToStep(JOB_STEP4);
						},
						goForward: function goForward() {
							return _this2.goForward();
						},
						onSubmit: function onSubmit(pr, st) {
							return _this2.onSubmit(pr, st);
						},
						slug: this.state.slug
					})
				);
			}
		}, {
			key: 'start',
			value: function start() {
				if (this.state.step === JOB_STEP0) {
					this.setState(_extends({}, this.state, {
						step: JOB_STEP1
					}));
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this3 = this;
	
				var addedState = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				promise.then(function (res) {
					var newState = _extends({}, _this3.state, addedState);
	
					_this3.goForward(newState);
				}).catch(function () {});
			}
		}, {
			key: 'goForward',
			value: function goForward(state) {
				var nextStep = state.step + 1;
	
				if (nextStep === JOB_STEP3 && this.state.skipPayment) {
					nextStep++;
				}
	
				if (nextStep > JOB_STEP4) {
					return false;
				}
	
				if (nextStep < state.step) {
					return false;
				}
	
				this.setState(_extends({}, state, {
					step: nextStep
				}));
			}
		}, {
			key: 'goBackwards',
			value: function goBackwards() {
				var prevStep = this.state.step - 1;
				if (prevStep < JOB_STEP0) {
					return false;
				}
	
				this.setState(_extends({}, this.state, {
					step: prevStep
				}));
			}
		}, {
			key: 'goToStep',
			value: function goToStep(step) {
				var addedState = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				var minStep = JOB_STEP0;
				var maxStep = JOB_STEP4;
				if (!(step >= minStep && step <= maxStep)) {
					return false;
				}
	
				this.setState(_extends({}, this.state, addedState, {
					step: step
				}));
			}
		}, {
			key: 'cycleSteps',
			value: function cycleSteps() {
				var nextStep = (this.state.step + 1) % 5;
				this.setState(_extends({}, this.state, addedState, {
					step: nextStep
				}));
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountJobCreate;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountJobCreate);

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _lodash = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _jobEditForm = __webpack_require__(357);
	
	var _jobEditForm2 = _interopRequireDefault(_jobEditForm);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import translate from '../../utils/translate';
	// import * as actions from '../../actions/account';
	// import { redirectToAccountIfNoProfile } from '../../utils/authorization';
	
	var AccountJobEdit = function (_Component) {
		_inherits(AccountJobEdit, _Component);
	
		function AccountJobEdit(props) {
			_classCallCheck(this, AccountJobEdit);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobEdit).call(this));
	
			_this.state = {
				waiting: true,
				submitting: false,
				showMore: false,
				jobId: props.router.params.id || 0
			};
			return _this;
		}
	
		_createClass(AccountJobEdit, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var API_URL = _baseUrl2.default + ('/api/account/jobs/' + this.state.jobId + '/form');
				_axios2.default.get(API_URL).then(function (res) {
					if (res.data) {
						var jobItem = res.data;
	
						if (jobItem.profiles) {
							jobItem.profiles = JSON.stringify((0, _lodash.isArray)(jobItem.profiles) ? jobItem.profiles : [jobItem.profiles]);
						}
	
						_this2.setState(_extends({}, _this2.state, {
							waiting: false,
							job: jobItem
						}));
					}
				}).catch(function (res) {
					if (res.data && res.data.message) {
						_this2.props.dispatch((0, _errors.dispatchError)(res.data));
					}
	
					_this2.props.dispatch((0, _reduxRouter.push)((0, _routes.accountRoute)('/profile/jobs')));
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var API_URL = '/api/account/jobs/' + this.state.jobId + '/form';
	
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-cases' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Job - Edit' }),
					_react2.default.createElement(_jobEditForm2.default, {
						ref: 'form',
						path: API_URL,
						method: 'put',
						smallAside: false,
						job: this.state.job,
						user: this.props.users,
						onSubmit: function onSubmit(promise) {
							promise.then(function () {
								_this3.setSubmitting(false);
							}).catch(function () {
								_this3.setSubmitting(false);
							});
						},
						head: this.renderHeader(),
						dispatch: this.props.dispatch
					})
				);
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				var _this4 = this;
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Edit job', sticky: true, browser: this.props.browser },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content__content__buttons' },
						_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
						_react2.default.createElement(
							'button',
							{ className: 'button button--dark', onClick: function onClick(e) {
									return _this4.submitPreview(e);
								} },
							'Preview'
						),
						_react2.default.createElement(_submit2.default, { name: 'Update job', className: 'button', waiting: this.state.submitting, onClick: function onClick() {
								return _this4.setSubmitting(true);
							} })
					)
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'setSubmitting',
			value: function setSubmitting() {
				var val = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
				this.setState(_extends({}, this.state, {
					submitting: val
				}));
			}
		}, {
			key: 'submitPreview',
			value: function submitPreview(e) {
				var _this5 = this;
	
				e.preventDefault();
				e.stopPropagation();
	
				if (!(this.refs.form && this.refs.form.refs && this.refs.form.refs.form)) {
					return false;
				}
	
				this.refs.confirm.confirm('Saving preview...', false, false);
	
				var API_URL = _baseUrl2.default + '/api/account/jobs/' + this.state.jobId + '/preview';
				_axios2.default.put(API_URL, _qs2.default.stringify(_extends({}, this.refs.form.refs.form.serialize(), {
					preview: 1
				}))).then(function (res) {
					_this5.refs.confirm.confirm('Preview is ready', 'Open preview').then(function () {
						if (res.data && res.data.job && res.data.job.slug && res.data.job.previewHash) {
							window.open((0, _routes.jobsRoute)(res.data.job.slug) + '?preview=' + res.data.job.previewHash);
						}
					}).catch(function () {});
				}).catch(function (res) {
					var text = 'Generating preview failed';
	
					if (res.data) {
						if (res.data.message) {
							text = res.data.message;
						}
	
						if (res.data.errors) {
							var errors = res.data.errors;
							var errorKeys = Object.keys(errors);
							for (var i = 0; i < errorKeys.length; i++) {
								text += '\n' + errors[errorKeys[i]];
							}
						}
					}
	
					_this5.refs.confirm.confirm(text, false);
				});
	
				return true;
			}
		}]);
	
		return AccountJobEdit;
	}(_react.Component);
	
	AccountJobEdit.propTypes = {
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _connect2.default)(AccountJobEdit);

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _categoryList = __webpack_require__(351);
	
	var _categoryList2 = _interopRequireDefault(_categoryList);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _date = __webpack_require__(14);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _errors = __webpack_require__(29);
	
	var _authorization = __webpack_require__(36);
	
	var _jobListItem = __webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import translate from '../../utils/translate';
	
	
	var AccountJobList = function (_Component) {
		_inherits(AccountJobList, _Component);
	
		function AccountJobList() {
			_classCallCheck(this, AccountJobList);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJobList).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				items: []
			};
			return _this;
		}
	
		_createClass(AccountJobList, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				(0, _axios2.default)({
					url: _baseUrl2.default + '/api/account/profiles/jobs',
					method: 'get',
					responseType: 'json'
				}).then(function (res) {
					var newState = _extends({}, _this2.state, {
						waiting: false
					});
					if (res.data && res.data.jobs) {
						newState.items = res.data.jobs;
					} else {
						_this2.props.dispatch((0, _errors.dispatchError)('Invalid data received.'));
					}
	
					_this2.setState(newState);
				}).catch(function (res) {
					_this2.props.dispatch((0, _errors.dispatchError)(res.data));
					_this2.mounted && _this2.setState(_extends({}, _this2.state, {
						waiting: false
					}));
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var jobs = this.state.items;
				var contentTitles = {
					ACTIVE: 'Active',
					INACTIVE: 'Inactive',
					EXPIRED: 'Expired'
				};
	
				var content = {
					ACTIVE: [],
					INACTIVE: [],
					EXPIRED: []
				};
	
				for (var i = 0; i < jobs.length; i++) {
					var job = jobs[i];
					var createdDate = new _date.DateFormatter(job.createdDate);
					var cat = false;
	
					if (new Date().getTime() - createdDate.getTime() >= 90 * (24 * 60 * 60 * 1000)) {
						cat = 'EXPIRED';
					} else {
						cat = job.activated ? 'ACTIVE' : 'INACTIVE';
					}
	
					if (cat) {
						content[cat].push(job);
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-editorial' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Jobs' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Jobs posted by you', sticky: true, browser: this.props.browser },
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__content__buttons' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/profile/jobs/create'), className: 'button button--dark ' },
								'Post job vacancy'
							)
						)
					),
					this.state.waiting && this.renderWaiting(),
					!this.state.waiting && _react2.default.createElement(_splitter2.default, { className: 'hide-mobile' }),
					!this.state.waiting && Object.keys(contentTitles).map(function (key) {
						var title = contentTitles[key];
						return _react2.default.createElement(
							'div',
							{ key: title },
							_react2.default.createElement(_categoryList2.default, {
								browser: _this3.props.browser,
								compComponent: _jobListItem.JobListItem,
								title: title,
								content: content[key],
								type: key,
								waiting: _this3.state.waiting,
								data: {
									updateItems: function updateItems(items) {
										return _this3.updateItems(items);
									},
									dispatch: function dispatch(arg) {
										return _this3.props.dispatch(arg);
									}
								}
							}),
							_react2.default.createElement(_splitter2.default, null)
						);
					})
				);
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'updateItems',
			value: function updateItems(items) {
				this.setState(_extends({}, this.state, {
					items: items
				}));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountJobList;
	}(_react.Component);
	
	AccountJobList.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		users: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _connect2.default)(AccountJobList);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.JobListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _date = __webpack_require__(14);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import translate from '../../utils/translate';
	
	
	var JobListItem = exports.JobListItem = function (_Component) {
		_inherits(JobListItem, _Component);
	
		function JobListItem() {
			_classCallCheck(this, JobListItem);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(JobListItem).apply(this, arguments));
		}
	
		_createClass(JobListItem, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var IS_PUBLISHED = !!this.props.item.activated;
				var date = new _date.DateFormatter(this.props.item.createdDate);
				var expireDate = new _date.DateFormatter(date.getTime() + 90 * (24 * 60 * 60 * 1000));
				var IS_EXPIRED = expireDate.getTime() <= new Date().getTime();
	
				var profileString = '';
				var item = this.props.item;
				var profiles = item.profiles;
	
	
				if (profiles && profiles.name) {
					profileString += profiles.name;
	
					if (item.city) {
						profileString += ', ' + item.city;
					}
	
					if (item.country) {
						profileString += ', ' + item.country;
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'editoriallist__content__item' },
					_react2.default.createElement(
						'h3',
						{ className: 'editoriallist__content__item__head' },
						this.props.item.title
					),
					_react2.default.createElement(
						'span',
						{ className: 'editoriallist__content__item__author' },
						profileString
					),
					_react2.default.createElement(
						'span',
						{ className: 'editoriallist__content__item__foot' },
						'Added: ',
						date.monthDateAndYear,
						_react2.default.createElement('br', null),
						'Expires: ',
						expireDate.monthDateAndYear
					),
					!IS_EXPIRED && _react2.default.createElement(
						'a',
						{ key: 'menu', className: 'editoriallist__button button button--action', ref: 'menu' },
						'...'
					),
					!IS_EXPIRED && _react2.default.createElement(
						_dropdown2.default,
						{ key: 'dropdown', attachTo: function attachTo() {
								return _this2.refs.menu;
							}, pointTo: 'AUTO', browser: this.props.browser },
						_react2.default.createElement(
							'ol',
							{ key: 'dropdown-ol' },
							_react2.default.createElement(
								'li',
								{ key: 'link-edit' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.accountRoute)('/profile/jobs/' + this.props.item.id), onClick: this.stopPropagation },
									'Edit'
								)
							),
							_react2.default.createElement(
								'li',
								{ key: 'link-activate' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '', onClick: function onClick(e) {
											return _this2.toggle(e);
										} },
									IS_PUBLISHED ? 'Unpublish' : 'Publish'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'stopPropagation',
			value: function stopPropagation(e) {
				e.stopPropagation();
			}
		}, {
			key: 'toggle',
			value: function toggle(e) {
				var _this3 = this;
	
				e.preventDefault();
				e.stopPropagation();
	
				_axios2.default.post(_baseUrl2.default + '/api/account/profiles/jobs/' + this.props.item.id + '/toggle').then(function (res) {
					if (res.data && res.data.jobs && res.data.jobs.length) {
						_this3.props.data.updateItems(res.data.jobs);
					}
				}).catch(function (res) {
					var msg = 'An error occurred';
					if (res.data && res.data.message) {
						msg = res.data.message;
					}
	
					if (_this3.props.data && _this3.props.data.dispatch) {
						_this3.props.data.dispatch((0, _errors.dispatchError)(msg));
					}
				});
			}
		}]);
	
		return JobListItem;
	}(_react.Component);
	
	JobListItem.propTypes = {
		type: _react.PropTypes.string.isRequired,
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		data: _react.PropTypes.shape({
			updateItems: _react.PropTypes.func.isRequired,
			dispatch: _react.PropTypes.func.isRequired
		})
	};
	JobListItem.defaultProps = {
		type: '',
		item: {}
	};

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _authorization = __webpack_require__(36);
	
	var _jury = __webpack_require__(988);
	
	var _jury2 = _interopRequireDefault(_jury);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import translate from '../../utils/translate';
	
	//import * as actions from '../../actions/account';
	
	var AccountJury = function (_Component) {
		_inherits(AccountJury, _Component);
	
		function AccountJury(props) {
			_classCallCheck(this, AccountJury);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJury).call(this));
	
			_this.state = {
				waiting: true,
				showScorecard: false
			};
			return _this;
		}
	
		_createClass(AccountJury, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var isLoggedIn = this.props.users.isLoggedIn();
				var hasAccess = !this.props.users.canHas([_authorization.ROLE_JUDGE_FOTD, _authorization.ROLE_JUDGE_FOTM, _authorization.ROLE_JUDGE_FOTY, _authorization.ROLE_JUDGE_TCEA]);
	
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(isLoggedIn ? '' : '/login'), hasAccess, (0, _routes.accountRoute)('/jury'));
	
				this.redirectToAwardCategory(this.props);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.redirectToAwardCategory(nextProps);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-jury' },
					this.props.children
				);
			}
		}, {
			key: 'redirectToAwardCategory',
			value: function redirectToAwardCategory(props) {
				var currentRoute = props.router.routes[props.router.routes.length - 1];
				switch (currentRoute.path) {
					case 'fotd':
					case 'fotm':
					case 'foty':
					case 'tcea':
						break;
					default:
						if (props.users.canHas([_authorization.ROLE_JUDGE_FOTD])) {
							props.dispatch((0, _reduxRouter.replace)((0, _routes.accountRoute)('/jury/fotd')));
						} else if (props.users.canHas([_authorization.ROLE_JUDGE_FOTM])) {
							props.dispatch((0, _reduxRouter.replace)((0, _routes.accountRoute)('/jury/fotm')));
						} else if (props.users.canHas([_authorization.ROLE_JUDGE_FOTY])) {
							props.dispatch((0, _reduxRouter.replace)((0, _routes.accountRoute)('/jury/foty')));
						} else if (props.users.canHas([_authorization.ROLE_JUDGE_TCEA])) {
							props.dispatch((0, _reduxRouter.replace)((0, _routes.accountRoute)('/jury/tcea')));
						}
				}
			}
		}]);
	
		return AccountJury;
	}(_react.Component);
	
	AccountJury.propTypes = {
		users: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired,
		children: _react.PropTypes.any
	};
	exports.default = (0, _connect2.default)(AccountJury);

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(35);
	
	var _routes = __webpack_require__(4);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _juryEntry = __webpack_require__(173);
	
	var _juryEntry2 = _interopRequireDefault(_juryEntry);
	
	var _juryVoteFOTD = __webpack_require__(602);
	
	var _juryVoteFOTD2 = _interopRequireDefault(_juryVoteFOTD);
	
	var _juryNav = __webpack_require__(174);
	
	var _juryNav2 = _interopRequireDefault(_juryNav);
	
	var _jurySticky = __webpack_require__(175);
	
	var _jurySticky2 = _interopRequireDefault(_jurySticky);
	
	var _other = __webpack_require__(176);
	
	var _juryHelper = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../../utils/translate';
	//import * as actions from '../../../actions/account';
	
	//import css from './fotd.scss';
	
	var AccountJuryFOTD = function (_Component) {
		_inherits(AccountJuryFOTD, _Component);
	
		function AccountJuryFOTD() {
			_classCallCheck(this, AccountJuryFOTD);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryFOTD).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				showScorecard: false,
				cases: []
			};
			return _this;
		}
	
		_createClass(AccountJuryFOTD, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				var API_URL = _baseUrl2.default + '/api/account/jury/fotd';
				_axios2.default.get(API_URL).then(function (res) {
					if (_this2.mounted && res.data && res.data.cases) {
						_this2.setState(_extends({}, _this2.state, {
							cases: res.data.cases,
							waiting: false
						}));
					}
				}).catch(function () {});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var scorecardExpanderClass = 'icon-plus';
				var scorecardClass = 'account-block-content account-jury__scorecard-container span14';
	
				if (this.state.showScorecard) {
					scorecardExpanderClass += ' icon-plus--active';
					scorecardClass += ' account-jury__scorecard-container--active';
				}
	
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				var cases = (0, _juryHelper.caseFilterResponsive)(this.state.cases, this.props.browser);
	
				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content' },
						_react2.default.createElement(
							'div',
							{ className: 'span14 account-block-content__aside account-jury__head' },
							this.state.cases.length,
							' projects up for voting'
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(
							_jurySticky2.default,
							{ browser: this.props.browser, className: 'account-jury__sticky', update: this.state.showScorecard },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first' },
								_react2.default.createElement(_juryNav2.default, { users: this.props.users })
							),
							_react2.default.createElement('div', { className: 'hide-tablet hide-mobile account-jury__col2' }),
							_react2.default.createElement(
								'div',
								{ className: 'span9-tablet span14-mobile account-jury__col3 account-jury__subhead' },
								_react2.default.createElement(
									'ol',
									null,
									_react2.default.createElement(
										'li',
										{ onClick: function onClick() {
												return _this3.toggleScorecard();
											} },
										'Scorecard ',
										_react2.default.createElement('span', { className: scorecardExpanderClass })
									)
								)
							),
							_react2.default.createElement('div', { className: 'cf' }),
							_react2.default.createElement(
								'div',
								{ className: scorecardClass },
								_react2.default.createElement('div', { className: 'span5 span5-tablet hide-mobile account-jury__col1' }),
								_react2.default.createElement(
									'div',
									{ className: 'span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro' },
									_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/jury/fotd') } })
								),
								_react2.default.createElement(
									'div',
									{ className: 'span9-tablet span14-mobile push5-tablet account-jury__col3 account-jury__col3--scorecard' },
									_react2.default.createElement(
										'ol',
										{ className: 'account-jury__scorecard' },
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item account-jury__scorecard__item--green' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval1')
											),
											' ',
											(0, _translate2.default)('account/jury/score9000')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item account-jury__scorecard__item--green' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval2')
											),
											' ',
											(0, _translate2.default)('account/jury/score8089')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item account-jury__scorecard__item--green' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval3')
											),
											' ',
											(0, _translate2.default)('account/jury/score7079')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item account-jury__scorecard__item--orange' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval4')
											),
											' ',
											(0, _translate2.default)('account/jury/score4169')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item account-jury__scorecard__item--red' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval5')
											),
											' ',
											(0, _translate2.default)('account/jury/score2040')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval6')
											),
											' ',
											(0, _translate2.default)('account/jury/score0019')
										),
										_react2.default.createElement(
											'li',
											{ className: 'account-jury__scorecard__item' },
											_react2.default.createElement(
												'em',
												null,
												(0, _translate2.default)('account/jury/scoreInterval7')
											),
											' ',
											(0, _translate2.default)('account/jury/score0050')
										)
									)
								),
								_react2.default.createElement('div', { className: 'cf' })
							)
						)
					),
					_react2.default.createElement(_splitter2.default, null),
					this.props.browser.window.width < 1200 && _react2.default.createElement(_other.AccountJuryMediaTitle, { browser: this.props.browser, caseCount: cases.length }),
					cases.map(function (item) {
						return _react2.default.createElement(_juryEntry2.default, {
							key: item.id,
							item: item,
							browser: _this3.props.browser,
							dispatch: _this3.props.dispatch,
							component: _juryVoteFOTD2.default,
							hideAfterSubmit: true,
							removeItemCB: function removeItemCB() {
								return _this3.removeCase(item);
							}
						});
					}),
					this.props.browser.window.width < 1200 && _react2.default.createElement(_other.AccountJuryOther, { browser: this.props.browser, dispatch: this.props.dispatch, allCases: this.state.cases, cases: cases })
				);
			}
		}, {
			key: 'removeCase',
			value: function removeCase(item) {
				this.setState(_extends({}, this.state, {
					cases: (0, _lodash.difference)(this.state.cases, [item])
				}));
			}
		}, {
			key: 'toggleScorecard',
			value: function toggleScorecard() {
				this.mounted && this.setState(_extends({}, this.state, {
					showScorecard: !this.state.showScorecard
				}));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountJuryFOTD;
	}(_react.Component);
	
	AccountJuryFOTD.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired,
		users: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _connect2.default)(AccountJuryFOTD);

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _fotx = __webpack_require__(362);
	
	var _fotx2 = _interopRequireDefault(_fotx);
	
	var _juryNav = __webpack_require__(174);
	
	var _juryNav2 = _interopRequireDefault(_juryNav);
	
	var _jurySticky = __webpack_require__(175);
	
	var _jurySticky2 = _interopRequireDefault(_jurySticky);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _other = __webpack_require__(176);
	
	var _juryHelper = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../../utils/translate';
	//import * as actions from '../../../actions/account';
	
	//import css from './fotd.scss';
	var API_URL = _baseUrl2.default + '/api/account/jury/fotm';
	
	var AccountJuryFOTM = function (_Component) {
		_inherits(AccountJuryFOTM, _Component);
	
		function AccountJuryFOTM(props) {
			_classCallCheck(this, AccountJuryFOTM);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryFOTM).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				cases: []
			};
			return _this;
		}
	
		_createClass(AccountJuryFOTM, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.get(API_URL).then(function (res) {
					if (_this2.mounted && res.data && res.data.cases) {
						_this2.setState(_extends({}, _this2.state, res.data, {
							waiting: false
						}));
					}
				}).catch(function (res) {});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				var cases = (0, _juryHelper.caseFilterResponsive)(this.state.cases, this.props.browser);
				var _state = this.state;
				var currentVotes = _state.currentVotes;
				var isVotingOpen = _state.isVotingOpen;
				var nextDate = _state.nextDate;
				var linkAbout = _state.linkAbout;
	
	
				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content' },
						_react2.default.createElement(
							'div',
							{ className: 'span14 account-block-content__aside account-jury__head' },
							this.state.cases.length,
							' projects up for voting'
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(
							_jurySticky2.default,
							{ browser: this.props.browser, className: 'account-jury__sticky' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first' },
								_react2.default.createElement(_juryNav2.default, { users: this.props.users })
							),
							_react2.default.createElement('div', { className: 'hide-tablet hide-mobile account-jury__col2' }),
							_react2.default.createElement('div', { className: 'span9-tablet span14-mobile account-jury__col3 hide-mobile account-jury__subhead' }),
							_react2.default.createElement('div', { className: 'cf' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content account-jury__infoblock' },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span5-tablet hide-mobile account-jury__col1' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__col1__about' },
								'About'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro' },
							_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/jury/fotm') } })
						),
						_react2.default.createElement('div', { className: 'span0 span5-tablet hide-mobile account-jury__col1' }),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col3' },
							!!linkAbout && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									{ className: 'account-jury__linklist-head' },
									'Read more'
								),
								_react2.default.createElement(
									'ol',
									{ className: 'account-jury__linklist' },
									_react2.default.createElement(
										'li',
										{ className: 'account-jury__linklist__item' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: linkAbout.url },
											linkAbout.text
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(_fotx2.default, _extends({}, this.props, {
						api: API_URL,
						cases: cases,
						currentVotes: currentVotes,
						isVotingOpen: isVotingOpen,
						nextDate: nextDate
					})),
					this.props.browser.window.width < 1200 && _react2.default.createElement(_other.AccountJuryOther, {
						browser: this.props.browser,
						dispatch: this.props.dispatch,
						allCases: this.state.cases,
						cases: cases
					})
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountJuryFOTM;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountJuryFOTM);

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _fotx = __webpack_require__(362);
	
	var _fotx2 = _interopRequireDefault(_fotx);
	
	var _juryNav = __webpack_require__(174);
	
	var _juryNav2 = _interopRequireDefault(_juryNav);
	
	var _jurySticky = __webpack_require__(175);
	
	var _jurySticky2 = _interopRequireDefault(_jurySticky);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _other = __webpack_require__(176);
	
	var _juryHelper = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../../utils/translate';
	//import * as actions from '../../../actions/account';
	
	//import css from './fotd.scss';
	var API_URL = _baseUrl2.default + '/api/account/jury/foty';
	
	var AccountJuryFOTY = function (_Component) {
		_inherits(AccountJuryFOTY, _Component);
	
		function AccountJuryFOTY(props) {
			_classCallCheck(this, AccountJuryFOTY);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryFOTY).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				cases: []
			};
			return _this;
		}
	
		_createClass(AccountJuryFOTY, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.get(API_URL).then(function (res) {
					if (_this2.mounted && res.data && res.data.cases) {
						_this2.setState(_extends({}, _this2.state, res.data, {
							waiting: false
						}));
					}
				}).catch(function (res) {});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				var cases = (0, _juryHelper.caseFilterResponsive)(this.state.cases, this.props.browser);
				var _state = this.state;
				var currentVotes = _state.currentVotes;
				var isVotingOpen = _state.isVotingOpen;
				var nextDate = _state.nextDate;
				var linkAbout = _state.linkAbout;
	
	
				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content' },
						_react2.default.createElement(
							'div',
							{ className: 'span14 account-block-content__aside account-jury__head' },
							this.state.cases.length,
							' projects up for voting'
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(
							_jurySticky2.default,
							{ browser: this.props.browser, className: 'account-jury__sticky' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first' },
								_react2.default.createElement(_juryNav2.default, { users: this.props.users })
							),
							_react2.default.createElement('div', { className: 'hide-tablet hide-mobile account-jury__col2' }),
							_react2.default.createElement('div', { className: 'span9-tablet span14-mobile account-jury__col3 hide-mobile account-jury__subhead' }),
							_react2.default.createElement('div', { className: 'cf' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content account-jury__infoblock' },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span5-tablet hide-mobile account-jury__col1' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__col1__about' },
								'About'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro' },
							_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/jury/foty') } })
						),
						_react2.default.createElement('div', { className: 'span0 span5-tablet hide-mobile account-jury__col1' }),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col3' },
							!!linkAbout && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									{ className: 'account-jury__linklist-head' },
									'Read more'
								),
								_react2.default.createElement(
									'ol',
									{ className: 'account-jury__linklist' },
									_react2.default.createElement(
										'li',
										{ className: 'account-jury__linklist__item' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: linkAbout.url },
											linkAbout.text
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(_fotx2.default, _extends({}, this.props, { api: API_URL, cases: cases, currentVotes: currentVotes, isVotingOpen: isVotingOpen, nextDate: nextDate })),
					this.props.browser.window.width < 1200 && _react2.default.createElement(_other.AccountJuryOther, { browser: this.props.browser, dispatch: this.props.dispatch, allCases: this.state.cases, cases: cases })
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}]);
	
		return AccountJuryFOTY;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountJuryFOTY);

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _range = __webpack_require__(369);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JuryVoteFOTD = function (_Component) {
		_inherits(JuryVoteFOTD, _Component);
	
		function JuryVoteFOTD(props) {
			_classCallCheck(this, JuryVoteFOTD);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JuryVoteFOTD).call(this, props));
	
			_this.state = {
				waiting: false,
				showWarning: false,
				value: 80,
				reported: false
			};
			return _this;
		}
	
		_createClass(JuryVoteFOTD, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var PATH = '/api/account/jury/fotd/vote';
				var className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
				var item = this.props.item;
	
				var rangeSliderClass = '';
	
				if (this.props.browser.window.width < 720) {
					rangeSliderClass += 'custom-range--variable';
				} else if (this.props.browser.window.width < 1440) {
					rangeSliderClass += 'custom-range--maxi';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this2.getRefs();
							}, disableErrors: true, method: 'post', action: PATH, onSubmit: this.onSubmit.bind(this) },
						_react2.default.createElement(_text2.default, { name: 'id', ref: 'id', type: 'hidden', value: item.id }),
						_react2.default.createElement(_text2.default, { name: 'point', ref: 'point', type: 'hidden', value: this.state.value }),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__top pixel-pattern pixel-pattern--01' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__top__fotd-range' },
								_react2.default.createElement(_range2.default, { className: rangeSliderClass, name: 'point-range', value: this.state.value, extraData: { id: item.id }, nobContent: JuryVoteFOTDWarning, onChange: this.onChange.bind(this) })
							),
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__top__fotd-input' },
								_react2.default.createElement(_text2.default, { name: 'points', type: 'number', max: 100, min: 0, value: this.state.value, onChange: this.onChange.bind(this) })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__bottom ' },
							_react2.default.createElement(
								_checkbox2.default,
								{ name: 'nominateTCEA', ref: 'nominateTCEA' },
								'Nominate project for Adobe TCEA'
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-jury__entry__votation__bottom__report', onClick: function onClick() {
										return _this2.reportBroken({ id: item.id });
									} },
								this.state.reported ? 'Reported' : 'Report broken link'
							),
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__comment' },
								_react2.default.createElement(_textarea2.default, { name: 'comment', ref: 'comment', placeholder: 'Any comments or messages for Rob?', className: 'account-jury__entry__votation__comment__textarea', span: 'span100p' }),
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__votation__comment__vote' },
									_react2.default.createElement(
										'div',
										{ className: 'account-jury__entry__votation__comment__vote__flex' },
										_react2.default.createElement(_submit2.default, { name: 'Submit your vote', value: 'Submit your vote', waiting: this.state.waiting, className: 'button--light' })
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this3 = this;
	
				this.setState(_extends({}, this.state, { waiting: true }));
				this.props.onSubmit(new Promise(function (resolve, reject) {
					promise.then(function (res) {
						_this3.setState(_extends({}, _this3.state, { waiting: false }));
						resolve(res);
					}).catch(function (res) {
						_this3.setState(_extends({}, _this3.state, { waiting: false }));
						reject(res);
					});
				}));
			}
		}, {
			key: 'onChange',
			value: function onChange(val) {
				var newVal = val;
				newVal = parseInt(newVal, 10);
				newVal = isNaN(newVal) ? '' : newVal;
				this.setState(_extends({}, this.state, {
					value: Math.max(Math.min(100, newVal), 0)
				}));
			}
		}, {
			key: 'reportBroken',
			value: function reportBroken() {
				var _this4 = this;
	
				var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
				if (!this.state.reported && this.refs.confirm) {
					this.refs.confirm.confirm('Are you sure you want to report this link site as broken?').then(function () {
						_this4.setState(_extends({}, _this4.state, {
							reported: true
						}));
	
						_axios2.default.post(_baseUrl2.default + '/api/account/jury/report', _qs2.default.stringify(data));
					}).catch(function () {});
				}
			}
		}]);
	
		return JuryVoteFOTD;
	}(_react.Component);
	
	JuryVoteFOTD.propTypes = {
		item: _react.PropTypes.object.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	JuryVoteFOTD.defaultProps = {
		onSubmit: function onSubmit() {}
	};
	exports.default = JuryVoteFOTD;
	
	var JuryVoteFOTDWarning = function (_Component2) {
		_inherits(JuryVoteFOTDWarning, _Component2);
	
		function JuryVoteFOTDWarning(props) {
			_classCallCheck(this, JuryVoteFOTDWarning);
	
			var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(JuryVoteFOTDWarning).call(this, props));
	
			_this5.state = {
				notBroken: false
			};
			return _this5;
		}
	
		_createClass(JuryVoteFOTDWarning, [{
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				var className = 'account-jury__entry__warning';
				if (!(this.props.value <= 40) || this.state.notBroken) {
					className += ' account-jury__entry__warning--hide';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'p',
						null,
						'Is the link broken? If so, click YES to report broken link and DO NOT submit a score. Please try to judge again later.'
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-jury__entry__warning__buttons' },
						_react2.default.createElement(
							'a',
							{ className: 'button button--light', onClick: function onClick(e) {
									return _this6.bindReportBroken(e, true);
								} },
							'Yes - report broken link'
						),
						_react2.default.createElement(
							'a',
							{ className: 'button button--dark', onClick: function onClick(e) {
									return _this6.bindReportBroken(e, false);
								} },
							'No'
						)
					),
					_react2.default.createElement('div', { className: 'account-jury__entry__warning__arrow', style: { left: (this.props.value > 6 ? this.props.value : 6) + '%' } })
				);
			}
		}, {
			key: 'bindReportBroken',
			value: function bindReportBroken(e, val) {
				e.preventDefault();
				this.reportBroken(val);
			}
		}, {
			key: 'reportBroken',
			value: function reportBroken(val) {
				if (val) {
					_axios2.default.post(_baseUrl2.default + '/api/account/jury/report', _qs2.default.stringify(this.props.data || {}));
				}
	
				this.setState({
					notBroken: true
				});
			}
		}]);

		return JuryVoteFOTDWarning;
	}(_react.Component);

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _range = __webpack_require__(369);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(368);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JuryVoteFOTX = function (_Component) {
		_inherits(JuryVoteFOTX, _Component);
	
		function JuryVoteFOTX(props) {
			_classCallCheck(this, JuryVoteFOTX);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JuryVoteFOTX).call(this));
	
			_this.state = {
				selected: props.selected,
				showWarning: false,
				notBroken: false,
				value: !!(props.item.id === props.selected)
			};
			return _this;
		}
	
		_createClass(JuryVoteFOTX, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.selected !== nextProps.selected) {
					this.setState(_extends({}, this.state, {
						value: !!(nextProps.item.id === nextProps.selected)
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
				var item = this.props.item;
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this2.getRefs();
							}, disableErrors: true, method: 'post', action: this.props.path, onSubmit: this.onSubmit.bind(this), disableAjaxSubmit: true },
						_react2.default.createElement(_text2.default, { name: 'id', ref: 'id', type: 'hidden', value: item.id }),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__top' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__top__switch' },
								_react2.default.createElement(_switch2.default, { name: 'win', on: 'Yes', off: 'No', value: this.state.value, allowToggleOff: false, onChange: this.onChangeVote.bind(this) })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__bottom ' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__comment' },
								_react2.default.createElement(_textarea2.default, {
									name: 'comment',
									ref: 'comment',
									placeholder: 'Any comments or messages for Rob?',
									className: 'account-jury__entry__votation__comment__textarea account-jury__entry__votation__comment__textarea--fill',
									span: 'span100p',
									value: this.props.data ? this.props.data.comment : ''
								}),
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__votation__comment__vote' },
									_react2.default.createElement(
										'div',
										{ className: 'account-jury__entry__votation__comment__vote__flex' },
										_react2.default.createElement(_submit2.default, { name: 'Submit your vote', value: 'Submit your vote', waiting: this.props.waiting === item.id, className: 'button--light' })
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this3 = this;
	
				this.setState(_extends({}, this.state));
				this.props.onSubmit(new Promise(function (resolve, reject) {
					promise.then(function (res) {
						_this3.setState(_extends({}, _this3.state));
						resolve(res);
					}).catch(function (res) {
						_this3.setState(_extends({}, _this3.state));
						reject(res);
					});
				}));
			}
		}, {
			key: 'onChangeVote',
			value: function onChangeVote(val) {
				this.setState(_extends({}, this.state, {
					value: val
				}));
	
				this.props.onChangeVote({
					id: this.props.item.id,
					value: val
				});
			}
		}]);
	
		return JuryVoteFOTX;
	}(_react.Component);
	
	JuryVoteFOTX.propTypes = {
		item: _react.PropTypes.object.isRequired,
		waiting: _react.PropTypes.bool,
		selected: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf([false])]),
		path: _react.PropTypes.string.isRequired,
		onSubmit: _react.PropTypes.func.isRequired,
		onChangeVote: _react.PropTypes.func.isRequired
	};
	JuryVoteFOTX.defaultProps = {
		waiting: false,
		selected: false,
		onSubmit: function onSubmit(promise) {},
		onChangeVote: function onChangeVote(res) {}
	};
	exports.default = JuryVoteFOTX;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(35);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _juryNav = __webpack_require__(174);
	
	var _juryNav2 = _interopRequireDefault(_juryNav);
	
	var _juryEntry = __webpack_require__(173);
	
	var _juryEntry2 = _interopRequireDefault(_juryEntry);
	
	var _jurySticky = __webpack_require__(175);
	
	var _jurySticky2 = _interopRequireDefault(_jurySticky);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _switch = __webpack_require__(368);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _date = __webpack_require__(14);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { AccountJuryOther, AccountJuryMediaTitle} from './other';
	// import { caseFilterResponsive } from './juryHelper';
	
	var API_URL = _baseUrl2.default + '/api/account/jury/tcea';
	
	var MODE_CANDIDATES = 1;
	var MODE_WINNERS = 2;
	
	var AccountJuryTCEA = function (_Component) {
		_inherits(AccountJuryTCEA, _Component);
	
		function AccountJuryTCEA(props) {
			_classCallCheck(this, AccountJuryTCEA);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryTCEA).call(this));
	
			_this.mounted = true;
	
			_this.state = {
				waiting: true,
				caseWait: false,
				mode: MODE_CANDIDATES,
				candidates: [],
				winners: [],
				linkAbout: false
			};
			return _this;
		}
	
		_createClass(AccountJuryTCEA, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchData();
			}
		}, {
			key: 'fetchData',
			value: function fetchData(state) {
				var _this2 = this;
	
				if (this.mounted) {
					this.setState(_extends({}, this.state, state, {
						caseWait: true
					}));
				}
	
				_axios2.default.all([_axios2.default.get(API_URL), _axios2.default.get(API_URL + '/winners')]).then(_axios2.default.spread(function (candRes, winRes) {
					var data = _extends({
						candidates: [],
						winners: []
					}, _this2.applyData(MODE_WINNERS, winRes.data), _this2.applyData(MODE_CANDIDATES, candRes.data));
	
					if (_this2.mounted) {
						_this2.setState(_extends({}, _this2.state, state, {
							waiting: false,
							caseWait: false
						}, data));
					}
				})).catch(function () {
					if (_this2.mounted) {
						_this2.setState(_extends({}, _this2.state, state, {
							waiting: false,
							caseWait: false
						}));
					}
				});
			}
		}, {
			key: 'applyData',
			value: function applyData(mode, data) {
				var newData = {};
	
				if (mode === MODE_CANDIDATES) {
					if (data.cases) {
						newData.candidates = data.cases;
					}
				}
	
				if (mode === MODE_WINNERS) {
					if (data.cases) {
						newData.winners = (0, _lodash.sortBy)(data.cases, 'week');
					}
				}
	
				if (data.linkAbout) {
					newData.linkAbout = data.linkAbout;
				}
	
				if (data.nextDate) {
					newData.nextDate = data.nextDate;
				}
	
				return newData;
			}
		}, {
			key: 'updateData',
			value: function updateData(mode, state) {
				var _this3 = this;
	
				if (mode === MODE_CANDIDATES) {
					this.fetchData(state);
				} else {
					var API = mode !== MODE_WINNERS ? API_URL : API_URL + '/winners';
	
					_axios2.default.get(API).then(function (res) {
						_this3.setState(_extends({}, _this3.state, state, _this3.applyData(mode, res.data), {
							caseWait: false,
							waiting: false
						}));
					}).catch(function () {
						_this3.setState(_extends({}, _this3.state, state, {
							caseWait: false,
							waiting: false
						}));
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var inactiveTabClass = 'account-jury__tcea__tabs__tab';
				var activeTabClass = 'account-jury__tcea__tabs__tab account-jury__tcea__tabs__tab--active';
	
				if (this.state.waiting) {
					return this.renderWaiting();
				}
	
				var _state = this.state;
				var linkAbout = _state.linkAbout;
				var candidates = _state.candidates;
				var winners = _state.winners;
				var nextDate = _state.nextDate;
	
				var cases = this.state.mode === MODE_CANDIDATES ? candidates : winners;
	
				return _react2.default.createElement(
					'div',
					{ className: '' },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content' },
						_react2.default.createElement(
							'div',
							{ className: 'span14 account-block-content__aside account-jury__head' },
							candidates.length,
							' projects up for voting'
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(
							_jurySticky2.default,
							{ browser: this.props.browser, className: 'account-jury__sticky' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first' },
								_react2.default.createElement(_juryNav2.default, { users: this.props.users })
							),
							_react2.default.createElement('div', { className: 'hide-tablet hide-mobile account-jury__col2' }),
							_react2.default.createElement('div', { className: 'span9-tablet span14-mobile account-jury__col3 hide-mobile account-jury__subhead' }),
							_react2.default.createElement('div', { className: 'cf' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content account-jury__infoblock' },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span5-tablet hide-mobile account-jury__col1' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__col1__about' },
								'About'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro' },
							_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _translate2.default)('account/jury/tcea') } })
						),
						_react2.default.createElement('div', { className: 'span0 span5-tablet hide-mobile account-jury__col1' }),
						_react2.default.createElement(
							'div',
							{ className: 'span9-tablet span14-mobile account-jury__col3' },
							!!linkAbout && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									{ className: 'account-jury__linklist-head' },
									'Read more'
								),
								_react2.default.createElement(
									'ol',
									{ className: 'account-jury__linklist' },
									_react2.default.createElement(
										'li',
										{ className: 'account-jury__linklist__item' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: linkAbout.url },
											linkAbout.text
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-jury__tcea__tabs' },
						_react2.default.createElement(
							'a',
							{ href: '#', className: this.state.mode === MODE_CANDIDATES ? activeTabClass : inactiveTabClass, onClick: function onClick(e) {
									return _this4.switchMode(e, MODE_CANDIDATES);
								} },
							'Candidates'
						),
						_react2.default.createElement(
							'a',
							{ href: '#', className: this.state.mode === MODE_WINNERS ? activeTabClass : inactiveTabClass, onClick: function onClick(e) {
									return _this4.switchMode(e, MODE_WINNERS);
								} },
							'Winners'
						)
					),
					_react2.default.createElement(_splitter2.default, null),
					!!this.state.caseWait && this.renderWaiting(),
					!this.state.caseWait && cases.map(function (item, i) {
						return _react2.default.createElement(_juryEntry2.default, {
							key: item.id,
							item: item,
							browser: _this4.props.browser,
							dispatch: _this4.props.dispatch,
							component: _this4.state.mode === MODE_CANDIDATES ? TCEACandidateVote : TCEAWinnerVote,
							hideAfterSubmit: _this4.state.mode === MODE_CANDIDATES,
							onSubmit: _this4.onSubmit.bind(_this4),
							waiting: _this4.state.caseWait,
							data: {
								winners: winners,
								winnerCount: winners.length,
								nextDate: nextDate,
								refreshWinners: function refreshWinners(e) {
									return _this4.switchMode(e, MODE_WINNERS);
								}
							},
							path: API_URL + '/vote'
						});
					})
				);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(res) {
				var _this5 = this;
	
				_axios2.default.post(API_URL + '/vote', _qs2.default.stringify(res)).then(function (res) {
					if (_this5.state.mode === MODE_CANDIDATES) {
						_this5.state.winnerCount++;
					}
					_this5.fetchData();
				}).catch(function (res) {
					_this5.fetchData();
				});
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'switchMode',
			value: function switchMode(e, mode) {
				e && e.preventDefault();
	
				var newState = _extends({}, this.state, {
					mode: mode,
					caseWait: true
				});
	
				this.updateData(mode, newState);
			}
		}]);
	
		return AccountJuryTCEA;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountJuryTCEA);
	
	var TCEACandidateVote = function (_Component2) {
		_inherits(TCEACandidateVote, _Component2);
	
		function TCEACandidateVote(props) {
			_classCallCheck(this, TCEACandidateVote);
	
			var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(TCEACandidateVote).call(this));
	
			_this6.state = {
				value: undefined
			};
			return _this6;
		}
	
		_createClass(TCEACandidateVote, [{
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
				var _props = this.props;
				var item = _props.item;
				var data = _props.data;
	
	
				var oneDayInMs = 86400000;
				var oneWeekInMs = 86400000 * 7;
	
				var today = new _date.DateFormatter();
				var TCEADate = new _date.DateFormatter(data.nextDate * 1000 || 'today');
				var firstAvailableTCEAWeek = TCEADate.week;
	
				var lastDateOfYear = new _date.DateFormatter(today.year + '-12-29');
				var firstDateOfYear = new _date.DateFormatter(today.year + 1 + '-01-04');
				var lastWeekOfYear = lastDateOfYear.week > firstDateOfYear.week ? lastDateOfYear.week : firstDateOfYear.week;
				if (lastWeekOfYear === 1) {
					lastWeekOfYear = 52;
				}
	
				var weekOptions = [];
				var maxWeek = Math.min(data.winnerCount || 0, lastWeekOfYear);
				var winners = data.winners;
				for (var i = 0; i <= maxWeek; i++) {
					var TCEADateCalc = TCEADate.week;
	
					for (var k = 0; k < winners.length; k++) {
						var usedWeek = new _date.DateFormatter(winners[k].week * 1000).week;
						if (TCEADateCalc === usedWeek) {
							TCEADateCalc = false;
							break;
						}
					}
	
					if (TCEADateCalc) {
						weekOptions.push({
							label: TCEADate.dateMonthAndYear + ' - Week ' + TCEADateCalc,
							value: TCEADateCalc
						});
	
						firstAvailableTCEAWeek = TCEADateCalc;
					}
	
					TCEADate.addTime(oneWeekInMs);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this7.getRefs();
							}, disableErrors: true, method: 'post', action: this.props.path, onSubmit: this.onSubmit.bind(this), disableAjaxSubmit: true },
						_react2.default.createElement(_text2.default, { name: 'id', ref: 'id', type: 'hidden', value: item.id }),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__top' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__top__switch' },
								_react2.default.createElement(_switch2.default, { ref: 'vote', name: 'vote', on: 'Yes', off: 'No', value: this.state.value, onChange: this.onChangeVote.bind(this) }),
								!!this.state.value && _react2.default.createElement(_select2.default, { ref: 'week', name: 'week', options: weekOptions, value: firstAvailableTCEAWeek, placeholder: 'When should it win?', className: 'account-jury__entry__votation__top__switch__select' }),
								_react2.default.createElement('div', { className: 'cf' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__bottom ' },
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__comment' },
								_react2.default.createElement(_textarea2.default, { name: 'comments', ref: 'comments', placeholder: 'Any comments or messages for Rob?', className: 'account-jury__entry__votation__comment__textarea account-jury__entry__votation__comment__textarea--fill', span: 'span100p' }),
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__votation__comment__vote' },
									_react2.default.createElement(
										'div',
										{ className: 'account-jury__entry__votation__comment__vote__flex' },
										_react2.default.createElement(_submit2.default, { name: 'Submit your vote', value: 'Submit your vote', waiting: this.props.waiting, className: 'button--light' })
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'onChangeVote',
			value: function onChangeVote(val) {
				this.setState(_extends({}, this.state, {
					value: val
				}));
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this8 = this;
	
				this.setState(_extends({}, this.state, { waiting: true }));
				this.props.onSubmit(new Promise(function (resolve, reject) {
					promise.then(function (res) {
						_this8.setState(_extends({}, _this8.state, { waiting: false }));
						resolve(res);
					}).catch(function (res) {
						_this8.setState(_extends({}, _this8.state, { waiting: false }));
						reject(res);
					});
				}));
			}
		}]);
	
		return TCEACandidateVote;
	}(_react.Component);
	
	TCEACandidateVote.propTypes = {
		item: _react.PropTypes.object.isRequired,
		path: _react.PropTypes.string.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	TCEACandidateVote.defaultProps = {
		onSubmit: function onSubmit(promise) {}
	};
	
	var TCEAWinnerVote = function (_Component3) {
		_inherits(TCEAWinnerVote, _Component3);
	
		function TCEAWinnerVote(props) {
			_classCallCheck(this, TCEAWinnerVote);
	
			var _this9 = _possibleConstructorReturn(this, Object.getPrototypeOf(TCEAWinnerVote).call(this));
	
			_this9.mounted = true;
	
			_this9.state = {
				value: undefined,
				waiting: false
			};
			return _this9;
		}
	
		_createClass(TCEAWinnerVote, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this10 = this;
	
				var className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation relative';
				var _props2 = this.props;
				var item = _props2.item;
				var data = _props2.data;
	
	
				var oneDayInMs = 86400000;
				var oneWeekInMs = 86400000 * 7;
	
				var today = new _date.DateFormatter();
				var TCEADate = new _date.DateFormatter(data.nextDate * 1000);
	
				var firstAvailableTCEAWeek = TCEADate.week;
	
				var lastDateOfYear = new _date.DateFormatter(today.year + '-12-29');
				var firstDateOfYear = new _date.DateFormatter(today.year + 1 + '-01-04');
				var lastWeekOfYear = lastDateOfYear.week > firstDateOfYear.week ? lastDateOfYear.week : firstDateOfYear.week;
				if (lastWeekOfYear === 1) {
					lastWeekOfYear = 52;
				}
	
				var weekOptions = [];
				var maxWeek = Math.min(this.props.data.winnerCount + 8 || 0, lastWeekOfYear);
				for (var i = 0; i < maxWeek; i++) {
					var TCEADateCalc = TCEADate.week;
					weekOptions.push({
						label: TCEADate.dateShortMonthAndYear + ' - Week ' + TCEADateCalc,
						value: TCEADateCalc
					});
	
					TCEADate.addTime(oneWeekInMs);
				}
	
				var caseWinValue = new _date.DateFormatter(item.week * 1000).week;
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						_form2.default,
						{ getRefs: function getRefs() {
								return _this10.getRefs();
							}, disableErrors: true, method: 'post', action: this.props.path, onSubmit: this.onSubmit.bind(this), disableAjaxSubmit: true, className: 'account-jury__entry__votation__tceawin__form' },
						_react2.default.createElement(
							'div',
							{ className: 'account-jury__entry__votation__bottom account-jury__entry__votation__bottom--expanded' },
							_react2.default.createElement(_text2.default, { name: 'id', ref: 'id', type: 'hidden', value: item.id, hideLabel: true }),
							_react2.default.createElement(_text2.default, { name: 'update', ref: 'update', type: 'hidden', value: 1, hideLabel: true }),
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__tceawin__top hide-tablet hide-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__votation__tceawin__top__head' },
									'TCEA Winner'
								),
								_react2.default.createElement(
									'p',
									{ className: 'span4 account-jury__entry__votation__tceawin__top__text' },
									'This project will win TCEA in the week listed below. To change the week, select a new one in the dropdown and click “update”.'
								),
								_react2.default.createElement('div', { className: 'cf' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'account-jury__entry__votation__tceawin__bottom' },
								_react2.default.createElement(_select2.default, { ref: 'week', name: 'week', options: weekOptions, placeholder: 'When should it win?', value: caseWinValue, className: 'span2 span4-tablet span12-mobile account-jury__entry__votation__tceawin__bottom__select' }),
								_react2.default.createElement(
									'div',
									{ className: 'account-jury__entry__votation__tceawin__bottom__vote' },
									_react2.default.createElement(
										'div',
										{ className: 'account-jury__entry__votation__tceawin__bottom__vote__flex' },
										_react2.default.createElement(_submit2.default, { name: 'Update', value: 'Update', waiting: this.state.waiting || this.props.waiting, className: 'button--light' })
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'onChangeVote',
			value: function onChangeVote(val) {
				this.setState(_extends({}, this.state, {
					value: val
				}));
			}
		}, {
			key: 'refreshWinners',
			value: function refreshWinners() {
				if (this.props.data && this.props.data.refreshWinners) {
					return this.props.data.refreshWinners();
				}
	
				return false;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(promise) {
				var _this11 = this;
	
				this.setState(_extends({}, this.state, { waiting: true }));
				this.props.onSubmit(new Promise(function (resolve, reject) {
					promise.then(function (res) {
						_this11.mounted && _this11.setState(_extends({}, _this11.state, { waiting: false }));
						_this11.refreshWinners();
						resolve(res);
					}).catch(function (res) {
						_this11.mounted && _this11.setState(_extends({}, _this11.state, { waiting: false }));
						_this11.refreshWinners();
						reject(res);
					});
				}));
			}
		}]);
	
		return TCEAWinnerVote;
	}(_react.Component);
	
	TCEAWinnerVote.propTypes = {
		item: _react.PropTypes.object.isRequired,
		path: _react.PropTypes.string.isRequired,
		onSubmit: _react.PropTypes.func.isRequired
	};
	TCEAWinnerVote.defaultProps = {
		onSubmit: function onSubmit() {}
	};

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _lodash = __webpack_require__(35);
	
	var _pluralize = __webpack_require__(160);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _errors = __webpack_require__(29);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _iconMail = __webpack_require__(480);
	
	var _iconMail2 = _interopRequireDefault(_iconMail);
	
	var _juryOverview = __webpack_require__(989);
	
	var _juryOverview2 = _interopRequireDefault(_juryOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountJuryOverview = function (_Component) {
		_inherits(AccountJuryOverview, _Component);
	
		function AccountJuryOverview(props) {
			_classCallCheck(this, AccountJuryOverview);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountJuryOverview).call(this, props));
	
			_this.mounted = true;
			_this.state = {
				waiting: true,
				items: [],
				showMore: false,
				sortBy: 'id',
				sortOrder: 'desc',
				filter: '',
	
				// judge details
				userId: false,
				userShowing: false,
				waitingUser: false,
				userItems: []
			};
			return _this;
		}
	
		_createClass(AccountJuryOverview, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				// redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/login'), this.props.users.canHas(_routes.FWA_ADMIN), true);
	
				(0, _axios2.default)({
					url: _baseUrl2.default + '/api/account/admin/jury-overview',
					method: 'get',
					responseType: 'json'
				}).then(function (res) {
					var newState = _extends({}, _this2.state, {
						waiting: false
					});
					if (res.data && res.data.users) {
						newState.items = res.data.users;
					} else {
						_this2.props.dispatch((0, _errors.dispatchError)('Invalid data received.'));
					}
	
					if (_this2.mounted) {
						_this2.setState(newState);
					}
				}).catch(function (res) {
					if (res.data && res.data.message) {
						// this.props.dispatch(dispatchError(res.data));
					}
	
					if (_this2.mounted) {
						_this2.setState(_extends({}, _this2.state, {
							waiting: false
						}));
					}
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var listClass = 'account-cases__list-container';
				var loadmoreClass = 'related-cases__load-more span8 span100p-mobile pixel-pattern';
				if (this.state.showMore) {
					listClass += ' account-cases__list-container--active';
					loadmoreClass += ' active';
				}
	
				var isMobile = this.props.browser.window.width < 719;
	
				var regex = new RegExp(this.state.filter, 'i');
				var filteredItems = (0, _lodash.filter)(this.state.items, function (item) {
					if (_this3.state.filter) {
						return regex.test(item.name);
					}
	
					return true;
				});
	
				var judges = (0, _lodash.orderBy)(filteredItems, [this.state.sortBy], [this.state.sortOrder]);
	
				var fieldRepresentation = {
					name: { name: 'Name', sortable: 1 },
					daysSinceLastVote: { name: 'Last vote', sortable: 1 },
					votesMonth: { name: _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(
								'span',
								{ className: 'hide-mobile' },
								'# votes'
							),
							' last 30 days'
						), sortable: 1 },
					scoreAverageMonth: { name: 'Average Score', sortable: 1 },
					email: { name: 'Mail', sortable: 0 }
				};
				var fieldKeys = Object.keys(fieldRepresentation);
				var fields = [];
	
				fieldKeys.map(function (key) {
					var className = key;
					if (_this3.state.sortBy === key) {
						if (_this3.state.sortOrder === 'desc') {
							className += ' sort';
						} else {
							className += ' sort sort--asc';
						}
					}
	
					fields.push({
						key: key,
						field: fieldRepresentation[key],
						props: {
							className: className,
							onClick: function onClick() {
								return fieldRepresentation[key].sortable ? _this3.sortBy(key) : false;
							}
						}
					});
	
					return true;
				});
	
				if (isMobile) {
					fields = fields.filter(function (item) {
						return item.key !== 'votesMonth' && item.key !== 'email';
					});
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-cases' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Projects' }),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Jury overview', sticky: false, browser: this.props.browser, className: 'account-block-content account-block-content--fixed-height account-block-content--title-head' },
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__content__buttons' },
							_react2.default.createElement(_text2.default, { name: 'filter', placeholder: 'Filter', value: this.state.filter, onChange: function onChange(val) {
									return _this3.setState(_extends({}, _this3.state, { filter: val }));
								} })
						)
					),
					this.state.waiting && this.renderWaiting(),
					!this.state.waiting && _react2.default.createElement(
						'div',
						{ className: listClass },
						_react2.default.createElement(
							'div',
							{ className: 'jury-overview__block span14' },
							_react2.default.createElement(
								'table',
								{ sortable: true, className: 'jury-overview__table' },
								_react2.default.createElement(
									'thead',
									null,
									_react2.default.createElement(
										'tr',
										{ className: 'jury-overview__table__head' },
										fields.map(function (item, i) {
											return _react2.default.createElement(
												'th',
												_extends({ key: item.key }, i === 0 ? { colSpan: 2 } : {}, item.props),
												item.field.name
											);
										})
									)
								),
								_react2.default.createElement(
									'tbody',
									null,
									judges.map(function (item) {
										var items = [_react2.default.createElement(
											'tr',
											{ key: item.id, className: 'jury-overview__table__item' },
											_react2.default.createElement(
												'td',
												{ colSpan: '2', className: 'jury-overview__table__item__name', onClick: function onClick() {
														return _this3.fetchInfo(item.id);
													} },
												item.name,
												_this3.state.waitingUser === item.id && _react2.default.createElement(_spinner2.default, { size: '14', className: 'jury-overview__table__item__waiting' })
											),
											_react2.default.createElement(
												'td',
												null,
												item.daysSinceLastVote !== null ? item.daysSinceLastVote + ' ' + (0, _pluralize2.default)('days', item.daysSinceLastVote || 0) + ' ago' : '-'
											),
											!isMobile && _react2.default.createElement(
												'td',
												null,
												item.votesMonth + ' ' + (0, _pluralize2.default)('votes', item.votesMonth || 0)
											),
											_react2.default.createElement(
												'td',
												null,
												item.scoreAverageMonth ? item.scoreAverageMonth + ' ' + (0, _pluralize2.default)('pts', item.scoreAverageMonth || 0) + '.' : '-',
												' '
											),
											!isMobile && _react2.default.createElement(
												'td',
												{ className: 'jury-overview__table__item__email' },
												_react2.default.createElement(
													'div',
													{ ref: 'drop' + item.id },
													_react2.default.createElement('img', _extends({}, _iconMail2.default, { alt: '', className: 'jury-overview__table__item__email__icon' }))
												),
												_react2.default.createElement(
													_dropdown2.default,
													{ key: 'dropdown', attachTo: function attachTo() {
															return _this3.refs['drop' + item.id];
														}, pointTo: 'AUTO', browser: _this3.props.browser, width: 200 },
													_react2.default.createElement(
														'ol',
														{ key: 'dropdown-ol' },
														_react2.default.createElement(
															'li',
															{ key: 'link-mail-temp1' },
															_react2.default.createElement(
																'a',
																{ onClick: function onClick() {
																		return _this3.sendMail(item, 1);
																	} },
																'Send template 1 (activity)'
															)
														),
														_react2.default.createElement(
															'li',
															{ key: 'link-mail-temp2' },
															_react2.default.createElement(
																'a',
																{ onClick: function onClick() {
																		return _this3.sendMail(item, 2);
																	} },
																'Send template 2 (scoring)'
															)
														),
														_react2.default.createElement(
															'li',
															{ key: 'link-mailto' },
															_react2.default.createElement(
																'a',
																{ href: 'mailto:' + item.email },
																'Send mail (manual)'
															)
														)
													)
												)
											)
										)];
	
										if (_this3.state.userId === item.id && _this3.state.userShowing) {
											items.push(_react2.default.createElement(
												'tr',
												{ key: item.id + '--details', className: 'jury-overview__table__item jury-overview__table__item--details jury-overview__table__item--details--head pixel-pattern pixel-pattern--darker' },
												_react2.default.createElement(
													'td',
													null,
													'Thumb'
												),
												_react2.default.createElement(
													'td',
													{ colSpan: '2' },
													'Case'
												),
												_react2.default.createElement(
													'td',
													null,
													item.name.split(' ')[0] + '\'s score'
												),
												!isMobile && _react2.default.createElement(
													'td',
													null,
													'Case score'
												),
												!isMobile && _react2.default.createElement('td', { className: 'erase' })
											));
	
											(0, _lodash.forEach)(_this3.state.userItems, function (judgeItem) {
												items.push(_react2.default.createElement(
													'tr',
													{ key: judgeItem.id + '--details-' + 1, className: 'jury-overview__table__item jury-overview__table__item--details' },
													_react2.default.createElement(
														'td',
														{ className: 'jury-overview__table__item__image pixel-pattern pixel-pattern--darker' },
														_react2.default.createElement(_image2.default, {
															browser: _this3.props.browser,
															img: judgeItem.thumbnail,
															span: { desktop: 'span3', tablet: 'span5', mobile: 'span14' }
														})
													),
													_react2.default.createElement(
														'td',
														{ colSpan: '2', className: 'jury-overview__table__item__case' },
														_react2.default.createElement(
															'span',
															{ className: 'jury-overview__table__item__case__title' },
															judgeItem.title
														),
														(0, _formatCredits2.default)(judgeItem.profiles)
													),
													_react2.default.createElement(
														'td',
														null,
														judgeItem.judgeScored,
														' ',
														(0, _pluralize2.default)('pts', judgeItem.points),
														'.'
													),
													!isMobile && _react2.default.createElement(
														'td',
														null,
														judgeItem.points,
														' ',
														(0, _pluralize2.default)('pts', judgeItem.points),
														'.'
													),
													!isMobile && _react2.default.createElement('td', { className: 'erase' })
												));
											});
	
											if (!_this3.state.userItems.length) {
												items.push(_react2.default.createElement(
													'tr',
													{ key: 'empty', className: 'jury-overview__table__item jury-overview__table__item--details' },
													_react2.default.createElement(
														'td',
														{ colSpan: '5', className: 'jury-overview__table__item__case' },
														'No votes registered in the past 30 days.'
													),
													_react2.default.createElement('td', { className: 'erase' })
												));
											}
										}
	
										return items;
									})
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'sendMail',
			value: function sendMail(judge, templateId) {
				var _this4 = this;
	
				if (window.confirm('Are you sure you want to mail this judge? ' + judge.name)) {
					_axios2.default.post(_baseUrl2.default + '/api/account/admin/jury-overview/mail/', _qs2.default.stringify({
						judge: judge.id,
						template: templateId
					})).then(function (res) {}).catch(function (res) {
						if (res.data && res.data.message) {
							_this4.props.dispatch((0, _errors.dispatchError)(res.data));
						}
					});
				}
			}
		}, {
			key: 'fetchInfo',
			value: function fetchInfo(id) {
				var _this5 = this;
	
				var newState = _extends({}, this.state, {
					waitingUser: id
				});
	
				// if user requested is the one we already have fetched just toggle showing instead..
				if (this.state.userId === id) {
					newState.userShowing = !this.state.userShowing;
					newState.waitingUser = false;
	
					return this.setState(newState);
				}
	
				this.setState(newState);
	
				(0, _axios2.default)({
					url: _baseUrl2.default + '/api/account/admin/jury-overview/' + id,
					method: 'get',
					responseType: 'json'
				}).then(function (res) {
					var newState2 = _extends({}, _this5.state, {
						waitingUser: false
					});
					if (res.data && res.data.cases) {
						newState2.userItems = res.data.cases;
						newState2.userId = id;
						newState2.userShowing = true;
					} else {
						_this5.props.dispatch((0, _errors.dispatchError)('Invalid data received.'));
					}
	
					if (_this5.mounted) {
						_this5.setState(newState2);
					}
				}).catch(function (res) {
					if (res.data && res.data.message) {
						_this5.props.dispatch((0, _errors.dispatchError)(res.data));
					}
	
					if (_this5.mounted) {
						_this5.setState(_extends({}, _this5.state, {
							waitingUser: false
						}));
					}
				});
	
				return true;
			}
		}, {
			key: 'sortBy',
			value: function sortBy(field) {
				if (!field || typeof field !== 'string') {
					return false;
				}
	
				var newState = _extends({}, this.state);
	
				newState.sortBy = field;
	
				if (this.state.sortBy === field && this.state.sortOrder === 'desc') {
					newState.sortOrder = 'asc';
				} else {
					newState.sortOrder = 'desc';
				}
	
				return this.setState(newState);
			}
		}, {
			key: 'setWaiting',
			value: function setWaiting(state) {
				this.setState(_extends({}, this.state, { waiting: state }));
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'toggleMore',
			value: function toggleMore() {
				this.setState(_extends({}, this.state, {
					showMore: !this.state.showMore
				}));
			}
		}]);
	
		return AccountJuryOverview;
	}(_react.Component);
	
	AccountJuryOverview.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		users: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _connect2.default)(AccountJuryOverview);

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIdleTimer = __webpack_require__(523);
	
	var _reactIdleTimer2 = _interopRequireDefault(_reactIdleTimer);
	
	var _date = __webpack_require__(14);
	
	__webpack_require__(990);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseCreateModal = function (_Component) {
		_inherits(CaseCreateModal, _Component);
	
		function CaseCreateModal(props) {
			_classCallCheck(this, CaseCreateModal);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseCreateModal).call(this, props));
	
			_this.idleTimer = null;
			_this.handleOnIdle = _this.handleOnIdle.bind(_this);
			_this.state = {
				remaining: 1000 * 60 * 5
			};
			return _this;
		}
	
		_createClass(CaseCreateModal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				setInterval(function () {
					if (_this2.idleTimer) {
						_this2.setState({
							remaining: _this2.idleTimer.getRemainingTime()
						});
					}
				}, 1000);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var onboardClass = 'popup popup--active';
				if (!this.props.show) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: onboardClass, onClick: null },
					_react2.default.createElement(_reactIdleTimer2.default, {
						ref: function ref(_ref) {
							_this3.idleTimer = _ref;
						},
						timeout: 1000 * 60 * 5,
						onIdle: this.handleOnIdle,
						debounce: 250,
						events: []
					}),
					_react2.default.createElement(
						'div',
						{ className: 'popup__content span6 popup__container', onClick: function onClick(e) {
								e.stopPropagation();
							} },
						_react2.default.createElement(
							'h4',
							null,
							'Inactivity notifier'
						),
						_react2.default.createElement('div', { className: 'popup__seperator' }),
						_react2.default.createElement(
							'p',
							{ className: 'popup__text' },
							'You will be automatically redirected in ',
							(0, _date.millisToMinutesAndSeconds)(this.state.remaining)
						),
						_react2.default.createElement(
							'div',
							{ className: 'popup__actions' },
							_react2.default.createElement(
								'span',
								{
									className: 'popup__alternative',
									onClick: function onClick() {
										_this3.props.handleInactive();
									}
								},
								'Log out now'
							),
							_react2.default.createElement(
								'button',
								{
									className: 'button button--dark',
									onClick: function onClick() {
										_this3.props.handleClose();
									}
								},
								'Stay logged in'
							)
						)
					)
				);
			}
		}, {
			key: 'handleOnIdle',
			value: function handleOnIdle(event) {
				this.props.handleInactive();
			}
		}]);
	
		return CaseCreateModal;
	}(_react.Component);
	
	exports.default = CaseCreateModal;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _submit = __webpack_require__(352);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _submit3 = __webpack_require__(31);
	
	var _submit4 = _interopRequireDefault(_submit3);
	
	var _dropzone = __webpack_require__(236);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _countries = __webpack_require__(285);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _errors = __webpack_require__(29);
	
	var _users = __webpack_require__(64);
	
	var _formJoinProfile = __webpack_require__(608);
	
	var _profileRequest = __webpack_require__(609);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _profileEdit = __webpack_require__(991);
	
	var _profileEdit2 = _interopRequireDefault(_profileEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountProfileEdit = function (_Component) {
		_inherits(AccountProfileEdit, _Component);
	
		function AccountProfileEdit(props) {
			_classCallCheck(this, AccountProfileEdit);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountProfileEdit).call(this));
	
			_this.state = {
				waiting: false,
				loading: true,
				offices: [_this.newOffice()],
				formErrors: {},
				formValues: {},
				requests: [],
				userRequests: [],
				hasProfile: !!props.users.profile
			};
			return _this;
		}
	
		_createClass(AccountProfileEdit, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.loadData();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.unmounted = true;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!this.state.hasProfile && !!nextProps.users.profile) {
					this.state.hasProfile = true;
					this.loadData();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var formErrors = _typeof(this.state.formErrors) === 'object' ? this.state.formErrors : {};
				var formValues = _typeof(this.state.formValues) === 'object' ? this.state.formValues : {};
	
				if (this.state.loading) {
					return this.renderWaiting();
				}
	
				if (!this.state.hasProfile) {
					return this.renderHasNoProfile(formErrors, formValues);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'account-edit-profile' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Profile' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					this.renderLeaveProfile('Profile', formValues),
					!!(this.props.users.profile && this.props.users.profile.isPoor) && _react2.default.createElement(
						'div',
						{ className: 'form-errors', ref: 'errors' },
						_react2.default.createElement(
							'div',
							{ className: 'push5 span9' },
							_react2.default.createElement(
								'ol',
								null,
								_react2.default.createElement(
									'li',
									null,
									'Your profile is incomplete, please fill out the required fields'
								)
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Basic description' },
						_react2.default.createElement(_label2.default, { label: 'Accounts that are part of ' + formValues.name }),
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__default' },
							this.renderProfileUsers(formValues.users)
						)
					),
					!!(this.state.requests && this.state.requests.length) && this.state.requests.map(function (item, i) {
						return _react2.default.createElement(_profileRequest.ProfileRequest, {
							key: i,
							formValues: formValues,
							item: item,
							index: i,
							approve: function approve() {
								_this2.approve(item.user.id, item, 'Are you sure you want to approve ' + item.user.name + '?');
							},
							reject: function reject() {
								_this2.reject(item.user.id, item, 'Are you sure you want to reject ' + item.user.name + '?');
							} });
					}),
					this.renderProfileForm('', 'put', formErrors, formValues)
				);
			}
		}, {
			key: 'renderLeaveProfile',
			value: function renderLeaveProfile(title, formValues) {
				return _react2.default.createElement(
					_content2.default,
					{ title: title },
					_react2.default.createElement(
						'div',
						{ className: 'account-block-content__default' },
						_react2.default.createElement(
							'div',
							{ className: 'span3 span5-tablet span11-mobile account-block-content__default__element' },
							_react2.default.createElement(_text2.default, {
								name: 'fake-name',
								label: 'Your account is part of the profile:',
								value: formValues.name,
								disabled: true,
								className: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'span2 span100p-mobile account-block-content__default__element account-block-content__default__element--no-label' },
							_react2.default.createElement(_submit4.default, { name: 'Leave profile', onClick: this.leaveProfile.bind(this) })
						)
					)
				);
			}
		}, {
			key: 'renderProfileUsers',
			value: function renderProfileUsers(users) {
				return _react2.default.createElement(
					'ol',
					{ className: 'account-edit-profile__users ' },
					users && users.length && users.map(function (user, i) {
						return _react2.default.createElement(
							'li',
							{ key: user.id, className: 'account-edit-profile__users__item' },
							_react2.default.createElement(
								'div',
								{ className: 'account-edit-profile__users__item__name span3 span6-tablet span100p-mobile' },
								user.name,
								' ',
								user.isProfileAdmin ? '(Profile Admin)' : ''
							),
							_react2.default.createElement(
								'div',
								{ className: 'account-edit-profile__users__item__mail span3 span6-tablet span100p-mobile' },
								user.email
							)
						);
					})
				);
			}
		}, {
			key: 'renderProfileForm',
			value: function renderProfileForm(name, method, formErrors, formValues) {
				var _this3 = this;
	
				return _react2.default.createElement(
					_form2.default,
					{ getRefs: function getRefs() {
							return _this3.getRefs();
						}, method: method, action: '/api/account/profiles/form', ref: 'form', onSubmit: this.onFormSubmit.bind(this), className: 'account-block-container' },
					_react2.default.createElement(
						_content2.default,
						{ title: name },
						_react2.default.createElement(_label2.default, { label: '' }),
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__default' },
							_react2.default.createElement(
								'div',
								{ className: 'span3 span5-tablet span11-mobile account-block-content__default__section' },
								_react2.default.createElement(_text2.default, {
									name: 'name',
									ref: 'name',
									label: 'Name',
									value: formValues.name,
									error: formErrors.hasOwnProperty('name'),
									placeholder: '',
									className: ''
								}),
								_react2.default.createElement(_text2.default, {
									name: 'website',
									ref: 'website',
									label: 'Website URL',
									value: formValues.website,
									error: formErrors.hasOwnProperty('website'),
									placeholder: '',
									className: ''
								}),
								_react2.default.createElement(_text2.default, {
									name: 'contactEmail',
									ref: 'contactEmail',
									label: 'Contact email',
									value: formValues.contactEmail,
									error: formErrors.hasOwnProperty('contactEmail'),
									placeholder: '',
									className: ''
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'span5 span100p-mobile account-block-content__default__section' },
								_react2.default.createElement(_textarea2.default, {
									name: 'intro',
									ref: 'intro',
									label: 'Introduction text',
									value: formValues.intro,
									error: formErrors.hasOwnProperty('intro'),
									maxChars: 250,
									placeholder: '',
									rows: 5,
									className: ''
								}),
								_react2.default.createElement(_textarea2.default, {
									name: 'additional',
									ref: 'additional',
									label: 'Optional additional text',
									btw: ' (2 columns)',
									value: formValues.additional,
									error: formErrors.hasOwnProperty('additional'),
									placeholder: '',
									rows: 5,
									className: ''
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'span3 span5-tablet span11-mobile account-block-content__default__section' },
								_react2.default.createElement(_text2.default, {
									name: 'showreel',
									ref: 'showreel',
									type: 'url',
									label: 'Showreel URL',
									btw: ' (Vimeo or YouTube)',
									value: formValues.showreel,
									error: formErrors.hasOwnProperty('showreel'),
									placeholder: '',
									className: ''
								})
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Social links' },
						_react2.default.createElement(
							'div',
							{ className: 'account-block-content__default' },
							_react2.default.createElement(
								'div',
								{ className: 'span3 span5-tablet span11-mobile account-block-content__default__section' },
								_react2.default.createElement(_text2.default, {
									name: 'facebook',
									ref: 'facebook',
									label: 'Facebook URL',
									value: formValues.facebook,
									error: formErrors.hasOwnProperty('facebook'),
									placeholder: '',
									className: ''
								}),
								_react2.default.createElement(_text2.default, {
									name: 'twitter',
									ref: 'twitter',
									label: 'Twitter URL',
									value: formValues.twitter,
									error: formErrors.hasOwnProperty('twitter'),
									placeholder: '',
									className: ''
								}),
								_react2.default.createElement(_text2.default, {
									name: 'linkedin',
									ref: 'linkedin',
									label: 'LinkedIn URL',
									value: formValues.linkedin,
									error: formErrors.hasOwnProperty('linkedin'),
									placeholder: '',
									className: ''
								}),
								_react2.default.createElement(_text2.default, {
									name: 'instagram',
									ref: 'instagram',
									label: 'Instagram URL',
									value: formValues.instagram,
									error: formErrors.hasOwnProperty('instagram'),
									placeholder: '',
									className: ''
								})
							)
						)
					),
					_react2.default.createElement(_content2.default, { className: 'pixel-pattern pixel-pattern--01' }),
					this.state.offices && this.state.offices.map(function (office, i) {
						var officeIdStr = 'office[' + i + ']';
						var officeId = office.id;
	
						if (!officeId) {
							return false;
						}
	
						var formErrorsOffice = formErrors.offices && formErrors.offices[officeId] ? formErrors.offices[officeId] : {};
	
						return _react2.default.createElement(
							_content2.default,
							{ title: i === 0 ? 'Offices' : '', key: office.id },
							_react2.default.createElement(
								'div',
								{ className: 'account-block-content__default' },
								_react2.default.createElement(
									'div',
									{ className: 'span100p account-block-content__default__section' },
									_react2.default.createElement(
										'div',
										{ className: 'span3 span5-tablet span11-mobile account-block-content__default__element' },
										i === 0 && _react2.default.createElement(_label2.default, { label: 'Office(s)  Min 1. Required' }),
										_react2.default.createElement(_text2.default, {
											name: officeIdStr + '[name]',
											ref: officeIdStr + '[name]',
											value: office.name,
											error: formErrors[officeIdStr + '[name]'],
											label: 'Office ' + (i + 1),
											hideLabel: true,
											placeholder: 'City',
											className: ''
										})
									),
									i > 0 && _react2.default.createElement(
										'div',
										{ className: 'span2 span6-mobile account-block-content__default__element' },
										_react2.default.createElement(_submit4.default, { name: 'Remove Office', onClick: function onClick(e) {
												_this3.removeOffice(e, i);
											} })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'span3 span5-tablet span11-mobile account-block-content__default__section' },
									_react2.default.createElement(_text2.default, {
										name: officeIdStr + '[address1]',
										ref: officeIdStr + '[address1]',
										value: office.address1,
										error: formErrors[officeIdStr + '[address1]'],
										label: 'Address 1',
										placeholder: 'Address line 1',
										className: ''
									}),
									_react2.default.createElement(_text2.default, {
										name: officeIdStr + '[address2]',
										ref: officeIdStr + '[address2]',
										value: office.address2,
										error: formErrors[officeIdStr + '[address2]'],
										label: 'Address 2',
										placeholder: 'Address line 2',
										className: ''
									}),
									_react2.default.createElement(_text2.default, {
										name: officeIdStr + '[address3]',
										ref: officeIdStr + '[address3]',
										value: office.address3,
										error: formErrors[officeIdStr + '[address3]'],
										label: 'Address 3',
										placeholder: 'Address line 3',
										className: ''
									}),
									_react2.default.createElement(_text2.default, {
										name: officeIdStr + '[phone]',
										ref: officeIdStr + '[phone]',
										value: office.phone,
										error: formErrors[officeIdStr + '[phone]'],
										label: 'Phone',
										placeholder: 'Phone',
										className: ''
									}),
									_react2.default.createElement(_text2.default, {
										name: officeIdStr + '[email]',
										ref: officeIdStr + '[email]',
										value: office.email,
										error: formErrors[officeIdStr + '[email]'],
										label: 'Office Email',
										placeholder: 'Email',
										className: ''
									}),
									_react2.default.createElement(_label2.default, { label: 'Country' }),
									_react2.default.createElement(_select2.default, {
										name: officeIdStr + '[country]',
										ref: officeIdStr + '[country]',
										value: office.country,
										error: formErrors[officeIdStr + '[country]'],
										placeholder: 'Country',
										label: 'Country ' + (i + 1),
										className: '',
										ajaxOptionsUrl: _countries2.default
									})
								)
							)
						);
					}),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01' },
						_react2.default.createElement(
							'button',
							{ className: 'button button--dark button--no-margin', onClick: this.addOffice.bind(this) },
							'Add office'
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Profile header image' },
						_react2.default.createElement(_label2.default, { label: 'Header Image', btw: ' 1364 · 620 jpg / png' }),
						_react2.default.createElement(_dropzone2.default, {
							ref: 'hero',
							aspect: 620 / 1364,
							width: 354,
							path: '/api/account/profiles/form/image',
							inputs: [{ name: 'hero', preview: this.state.formValues.hero ? this.state.formValues.hero['538'].span14 : false, error: this.state.formErrors.hero }],
							recommended: {
								width: 1364,
								height: 620
							},
							accept: 'image/*'
						})
					),
					_react2.default.createElement(
						_content2.default,
						{ title: 'Logos' },
						_react2.default.createElement(
							'div',
							{ className: 'span2 span100p-tablet span100p-mobile account-edit-profile__logo__container' },
							_react2.default.createElement(_label2.default, { label: 'Profile list', btw: ' 194 · 128 jpg / png' }),
							_react2.default.createElement(_dropzone2.default, {
								ref: 'logo',
								aspect: 0.659793814,
								width: 97,
								path: '/api/account/profiles/form/image',
								inputs: [{ name: 'logo', preview: this.state.formValues.logo ? this.state.formValues.logo.normal.src : false, error: this.state.formErrors.logo }],
								accept: 'image/*',
								className: 'form-dropzone--logo-cont'
							}),
							_react2.default.createElement(
								'div',
								{ className: 'account-edit-profile__logo__text', onClick: function onClick(e) {
										_this3.refs.logo.open();
									} },
								this.props.browser.window.width <= 719 && _react2.default.createElement(
									'span',
									null,
									'Tap to upload a new image'
								) || _react2.default.createElement(
									'span',
									null,
									'Drag an image here or ',
									_react2.default.createElement(
										'a',
										{ href: '#' },
										'browse'
									),
									' to upload.'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span6 span100p-tablet span100p-mobile' },
							_react2.default.createElement(_label2.default, { label: 'Profile  page', btw: ' 428 · 80 jpg / png' }),
							_react2.default.createElement(_dropzone2.default, {
								ref: 'logoProfile',
								aspect: 0.186915888,
								width: 428,
								path: '/api/account/profiles/form/image',
								inputs: [{ name: 'logoProfile', preview: this.state.formValues.logoProfile ? this.state.formValues.logoProfile.normal.src : false, error: this.state.formErrors.logoProfile }],
								accept: 'image/*' })
						)
					),
					_react2.default.createElement(
						_submit2.default,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'span3 span8-mobile' },
							_react2.default.createElement(_submit4.default, { name: 'Save changes', waiting: this.state.waiting })
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'renderHasNoProfile',
			value: function renderHasNoProfile(formValues, formErrors) {
				return _react2.default.createElement(
					'div',
					{ className: 'account-edit-profile' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Profile' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(_formJoinProfile.FormJoinProfile, { dispatch: this.props.dispatch, userRequests: this.state.userRequests }),
					this.renderProfileForm('Create profile', 'post', formValues, formErrors)
				);
			}
		}, {
			key: 'loadData',
			value: function loadData() {
				var _this4 = this;
	
				if (this.state.hasProfile) {
					_axios2.default.all([_axios2.default.get(_baseUrl2.default + '/api/account/profiles/form')]).then(_axios2.default.spread(function (formResponse) {
						if (_this4.unmounted) {
							return false;
						}
	
						var newState = _extends({}, _this4.state, { loading: false });
						if (formResponse.data && formResponse.data.profile) {
							var profile = formResponse.data.profile;
							newState.formValues = profile;
	
							if (profile.offices && profile.offices.length) {
								newState.offices = profile.offices;
							}
						}
	
						if (formResponse.data && formResponse.data.requests) {
							newState.requests = formResponse.data.requests;
						}
	
						_this4.setState(newState);
					})).catch(function (res) {
						_this4.props.dispatch((0, _errors.dispatchError)(res.data && res.data.message ? res.data : 'An error occurred.'));
					});
				} else {
					_axios2.default.all([_axios2.default.get(_baseUrl2.default + '/api/account/profiles/form')]).then(_axios2.default.spread(function (formResponse) {
						if (_this4.unmounted) {
							return false;
						}
	
						var newState = _extends({}, _this4.state, { loading: false });
	
						if (formResponse.data && formResponse.data.requests && formResponse.data.requests[0]) {
							newState.userRequests = formResponse.data.requests;
						}
	
						_this4.setState(newState);
					})).catch(function (res) {
						_this4.props.dispatch((0, _errors.dispatchError)(res.data && res.data.message ? res.data : 'An error occurred.'));
						_this4.mounted && _this4.setState(_extends({}, _this4.state, {
							loading: false
						}));
					});
				}
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'leaveProfile',
			value: function leaveProfile(e) {
				var _this5 = this;
	
				e.preventDefault();
	
				this.refs.confirm && this.refs.confirm.confirm('Are you sure you want to leave the profile?').then(function () {
					_axios2.default.post(_baseUrl2.default + '/api/account/profiles/leave').then(function (res) {
						_this5.props.dispatch((0, _users.getLogin)());
						_this5.setState(_extends({}, _this5.state, {
							hasProfile: false,
							waiting: false,
							loading: false,
							offices: [_this5.newOffice()]
						}));
					}).catch(function (res) {
						_this5.props.dispatch((0, _errors.dispatchError)(res.data && res.data.message ? res.data : 'An error occurred.'));
					});
				}).catch(function () {});
			}
		}, {
			key: 'addOffice',
			value: function addOffice(e) {
				e.preventDefault();
				var newState = _extends({}, this.state, {
					offices: [].concat(_toConsumableArray(this.state.offices), [this.newOffice()])
				});
	
				this.setState(newState);
			}
		}, {
			key: 'removeOffice',
			value: function removeOffice(e, index) {
				var _this6 = this;
	
				e.preventDefault();
	
				this.refs.confirm && this.refs.confirm.confirm('Are you sure you want to remove this office?').then(function () {
					var newState = _extends({}, _this6.state);
	
					newState.offices.splice(index, 1);
					_this6.setState(newState);
				}).catch(function () {});
			}
		}, {
			key: 'newOffice',
			value: function newOffice() {
				return {
					id: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
					city: '',
					street: '',
					phone: '',
					country: ''
				};
			}
		}, {
			key: 'onFormSubmit',
			value: function onFormSubmit(promise) {
				var _this7 = this;
	
				if (this.refs.form && this.refs.form.serialize) {
					this.setState(_extends({}, this.state, { waiting: true }));
					promise.then(function (res) {
						_this7.setState(_extends({}, _this7.state, { waiting: false, formErrors: {} }));
	
						if (res.data && res.data.message) {
							_this7.props.dispatch((0, _errors.dispatchMsg)(res.data));
						}
	
						_this7.props.dispatch((0, _users.getLogin)());
					}).catch(function (res) {
						_this7.setState(_extends({}, _this7.state, {
							waiting: false,
							formErrors: _typeof(res.data.errors) === 'object' ? res.data.errors : {}
						}));
					});
				}
			}
		}, {
			key: 'approve',
			value: function approve(userId, item, msg) {
				if (!userId) {
					return false;
				}
	
				this.answerRequest(_baseUrl2.default + ('/api/account/profiles/user/' + userId + '/approve'), userId, item, msg);
			}
		}, {
			key: 'reject',
			value: function reject(userId, item, msg) {
				if (!userId) {
					return false;
				}
	
				this.answerRequest(_baseUrl2.default + ('/api/account/profiles/user/' + userId + '/reject'), userId, item, msg);
			}
		}, {
			key: 'answerRequest',
			value: function answerRequest(path, userId, item) {
				var _this8 = this;
	
				var msg = arguments.length <= 3 || arguments[3] === undefined ? 'Are you sure?' : arguments[3];
	
				this.refs.confirm && this.refs.confirm.confirm(msg).then(function () {
					_axios2.default.post(path, _qs2.default.stringify({
						userId: userId
					})).then(function () {
						var index = _this8.state.requests.indexOf(item);
						var nRequests = function () {
							var nRequests = [];
							for (var i = 0; i < _this8.state.requests.length; i++) {
								if (item !== _this8.state.requests[i]) {
									nRequests.push(_this8.state.requests[i]);
								}
							}
							return nRequests;
						}();
	
						_this8.setState(_extends({}, _this8.state, {
							requests: nRequests
						}));
	
						_this8.loadData();
					}).catch(function (res) {
						_this8.loadData();
					});
				}).catch(function (res) {});
			}
		}]);
	
		return AccountProfileEdit;
	}(_react.Component);
	
	AccountProfileEdit.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		users: _react.PropTypes.object.isRequired
	};
	AccountProfileEdit.defaultProps = {};
	exports.default = (0, _connect2.default)(AccountProfileEdit);

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FormJoinProfile = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _tagselect = __webpack_require__(179);
	
	var _tagselect2 = _interopRequireDefault(_tagselect);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormJoinProfile = exports.FormJoinProfile = function (_Component) {
		_inherits(FormJoinProfile, _Component);
	
		function FormJoinProfile(props) {
			_classCallCheck(this, FormJoinProfile);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FormJoinProfile).call(this));
	
			_this.state = {
				applied: false
			};
			return _this;
		}
	
		_createClass(FormJoinProfile, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var pendingRequestStatus = false;
				var profileName = '';
				if (this.props.userRequests && this.props.userRequests.length) {
					pendingRequestStatus = this.props.userRequests[0].stateAsText;
					profileName = this.props.userRequests[0].profileName;
				}
	
				return _react2.default.createElement(
					_content2.default,
					{ title: 'Join profile' },
					!pendingRequestStatus && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_tagselect2.default, {
							ref: 'profile',
							name: 'profile',
							placeholder: 'Type to search for FWA Profiles',
							maxSelected: 1,
							canDelete: false,
							path: '/api/profiles/search',
							onChange: function onChange(e) {
								return _this2.onSubmit(e);
							}
						}),
						_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
						_react2.default.createElement('div', { className: 'cf' }),
						!!this.state.applied && _react2.default.createElement(
							'p',
							null,
							'Request to join has been sent.'
						)
					) || _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'p',
							null,
							'Request to join ',
							profileName || 'a profile',
							' is pending.'
						)
					)
				);
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(e) {
				var _this3 = this;
	
				if (e.value && e.value.length) {
					if (this.lastProfileValue === e.value[0].id) {
						return false;
					}
					this.lastProfileValue = e.value[0].id;
	
					this.refs.confirm.confirm('Are you sure you want to join ' + e.value[0].name).then(function () {
						_axios2.default.post(_baseUrl2.default + '/api/account/profiles/join', _qs2.default.stringify({
							profile: e.value[0].id
						})).then(function (res) {
							_this3.setState(_extends({}, _this3.state, {
								applied: true
							}));
						}).catch(function (res) {
							_this3.props.dispatch(dispatchError(res.data));
						});
					}).catch(function () {
						console.log('PROFILE:');
						console.log(_this3.refs.profile);
						_this3.refs.profile.delete(e.value);
						_this3.lastProfileValue = false; // hack to make the same profile selectable again
					});
				}
			}
		}]);
	
		return FormJoinProfile;
	}(_react.Component);
	
	FormJoinProfile.propTypes = {
		dispatch: _react.PropTypes.func.isRequired,
		userRequests: _react.PropTypes.array
	};
	FormJoinProfile.defaultProps = {};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProfileRequest = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _label = __webpack_require__(65);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileRequest = exports.ProfileRequest = function (_Component) {
		_inherits(ProfileRequest, _Component);
	
		function ProfileRequest(props) {
			_classCallCheck(this, ProfileRequest);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProfileRequest).call(this));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(ProfileRequest, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props;
				var formValues = _props.formValues;
				var item = _props.item;
				var index = _props.index;
	
				var user = item.user;
	
				if (!user) {
					return null;
				}
	
				return _react2.default.createElement(
					_content2.default,
					{ title: '' },
					index === 0 && _react2.default.createElement(_label2.default, { label: 'Accounts requesting to join ' + formValues.name, className: 'account-edit-profile__request__label' }),
					_react2.default.createElement(_confirm2.default, { ref: 'confirm' }),
					_react2.default.createElement(
						'div',
						{ className: 'account-edit-profile__request' },
						_react2.default.createElement(
							'div',
							{ className: 'account-edit-profile__request__item span6 span6-tablet span100p-mobile' },
							user.name,
							' ( ',
							user.email,
							' )'
						),
						item.stateAsText === 'waiting' && _react2.default.createElement(
							'div',
							{ className: 'span100p account-edit-profile__request__actions' },
							_react2.default.createElement(
								'a',
								{ className: 'button button--dark', onClick: function onClick() {
										_this2.props.approve();
									} },
								'Approve'
							),
							' ',
							_react2.default.createElement(
								'a',
								{ className: 'button button--light', onClick: function onClick() {
										_this2.props.reject();
									} },
								'Reject'
							)
						)
					)
				);
			}
		}]);

		return ProfileRequest;
	}(_react.Component);

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _getCategoryName = __webpack_require__(148);
	
	var _getCategoryName2 = _interopRequireDefault(_getCategoryName);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _caseElement = __webpack_require__(446);
	
	var _caseElement2 = _interopRequireDefault(_caseElement);
	
	var _placeholder = __webpack_require__(479);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//tmp
	
	
	var CaseElementMenu = function (_Component) {
		_inherits(CaseElementMenu, _Component);
	
		function CaseElementMenu(props) {
			_classCallCheck(this, CaseElementMenu);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseElementMenu).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(CaseElementMenu, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var createdDate = new _date.DateFormatter(this.props.item.createdDate);
				var awardTitle = '';
				var awardType = '';
				var url = (0, _index.casesRoute)(this.props.item.slug);
	
				var ribbonClass = '';
	
				var caseAward = false;
				(0, _forEach2.default)(this.props.item.awards, function (award) {
					if (_this2.props.awardId === award.id) {
						caseAward = award;
					}
				});
	
				if (caseAward) {
					awardTitle = caseAward.name;
					awardType = caseAward.type.toLowerCase();
					ribbonClass = 'ribbon-' + awardType + ' ribbon-' + awardType + '--small ribbon-' + awardType + '--br';
				}
	
				var pointClass = 'span1 hide-tablet case-element__glitter-scorecard';
				var imageClass = 'span3 span4-tablet case-element__glitter-img pixel-pattern pixel-pattern--dark';
	
				if (!this.props.item.legacy) {
					pointClass = 'span1 case-element__glitter-scorecard';
					imageClass = 'span3 span4-tablet case-element__glitter-img pixel-pattern pixel-pattern--dark span10-mobile';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'case-element' },
					_react2.default.createElement(
						'div',
						{ className: 'case-element__glitter pixel-pattern clearfix' },
						_react2.default.createElement(
							'div',
							{ className: imageClass },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: url, onClick: function onClick(e) {
										_this2.props.menuActive && _this2.props.menuActions && _this2.props.menuActions.closeMenu();
									} },
								_react2.default.createElement(_image2.default, { img: this.props.item.thumbnail, span: { desktop: 'span3', tablet: 'span5' }, alt: '', browser: this.props.browser })
							),
							ribbonClass && _react2.default.createElement('div', { className: ribbonClass })
						),
						_react2.default.createElement(
							'div',
							{ className: pointClass },
							this.props.item.legacy == 0 && _react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-scorecard__score' },
								(0, _date.formatNumber)(this.props.item.points),
								' ',
								_react2.default.createElement(
									'small',
									null,
									'Points'
								)
							) || null,
							this.props.item.legacy == 0 && _react2.default.createElement(
								'div',
								{ className: 'case-element__glitter-scorecard__days' },
								this.props.item.days,
								' ',
								_react2.default.createElement(
									'small',
									null,
									'Days'
								)
							) || null
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'case-element__details clearfix' },
						_react2.default.createElement(
							'div',
							{ className: 'span3 span4-tablet case-element__details-holder span12-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'case-element__details-award' },
								awardTitle,
								_react2.default.createElement(
									'div',
									{ className: 'case-element__details-award__category' },
									awardType
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-element__details__title' },
								this.props.item.title
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-element__details__profile' },
								(0, _formatCredits2.default)(this.props.item.profiles, false)
							)
						),
						_react2.default.createElement('div', { className: 'span1 hide-tablet empty' })
					)
				);
			}
		}]);
	
		return CaseElementMenu;
	}(_react.Component);
	
	CaseElementMenu.propTypes = {
		points: _react.PropTypes.number.isRequired,
		showPoints: _react.PropTypes.bool,
		item: _react.PropTypes.shape({
			awards: _react.PropTypes.array.isRequired,
			profiles: _react.PropTypes.array.isRequired,
			createdDate: _react.PropTypes.string.isRequired,
			caseTypes: _react.PropTypes.shape({
				name: _react.PropTypes.string.isRequired
			}),
			title: _react.PropTypes.string.isRequired,
			categories: _react.PropTypes.array.isRequired,
			thumbnail: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.object]),
			legacy: _react.PropTypes.oneOf([0, 1, true, false]),
			days: _react.PropTypes.number.isRequired
		}).isRequired,
		browser: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		menuActive: _react.PropTypes.bool.isRequired
	};
	CaseElementMenu.defaultProps = {
		points: 0,
		item: {
			awards: [],
			profiles: [],
			createdDate: '',
			caseTypes: {
				name: ''
			},
			title: '',
			categories: [],
			thumbnail: false,
			legacy: 1,
			days: 0
		},
		showPoints: false,
		menuActive: false
	};
	exports.default = CaseElementMenu;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _comments = __webpack_require__(994);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _textarea = __webpack_require__(96);
	
	var _textarea2 = _interopRequireDefault(_textarea);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Form elements
	
	
	var Comments = function (_Component) {
		_inherits(Comments, _Component);
	
		function Comments(props) {
			_classCallCheck(this, Comments);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(Comments).call(this, props));
	
			_this2.state = {
				waiting: false,
				formErrors: {},
				formValues: {},
				comments: []
			};
			return _this2;
		}
	
		//@TODO: Fix lige noget should update på login/ud
	
		_createClass(Comments, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props.users._id !== nextProps.users._id || this.props.comments.length !== nextProps.comments.length || this.props.title !== nextProps.title || this.state !== nextState;
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state.comments = this.props.comments;
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				if (this.props.title !== nextProps.title) {
					this.state.comments = nextProps.comments;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var comments = this.state.comments;
				var formErrors = _typeof(this.state.formErrors) === 'object' ? this.state.formErrors : {};
				var formValues = _typeof(this.state.formValues) === 'object' ? this.state.formValues : {};
	
				return _react2.default.createElement(
					'section',
					{ className: 'comments span14', id: 'comments' },
					_react2.default.createElement(
						'div',
						{ className: 'comments__top span14' },
						_react2.default.createElement(
							'div',
							{ className: 'comments__top__share' },
							_react2.default.createElement(_share2.default, { title: this.props.title, url: window.location.href, browser: this.props.browser })
						),
						_react2.default.createElement(
							'h2',
							{ className: 'comments__title' },
							'Discuss the project'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'comments__bottom span14' },
						_react2.default.createElement(
							_form2.default,
							{ className: 'comments__reply span5 span14-mobile', getRefs: function getRefs() {
									return _this3.getRefs();
								}, commentForm: true, method: 'post', action: '/api/cases/' + this.props.slug + '/comments', ref: 'form', onSubmit: this.onFormSubmit.bind(this) },
							_react2.default.createElement(_textarea2.default, {
								name: 'comment',
								ref: 'comment',
								value: '',
								placeholder: 'Write a comment / question',
								rows: 5,
								className: 'comments__message'
							}),
							_react2.default.createElement(_submit2.default, { className: 'comments__send', name: 'Post Comment', value: 'Post Comment', waiting: this.state.waiting }),
							!this.props.users.isLoggedIn() && _react2.default.createElement(
								'a',
								{ href: '#', className: 'button comments__login', onClick: function onClick(event) {
										return _this3.login(event);
									} },
								'Login'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'comments__comments span9 span14-mobile' },
							_react2.default.createElement(
								'span',
								{ className: 'comments__count' },
								'(' + this.state.comments.length + ') COMMENTS'
							),
							this.state.comments && _react2.default.createElement(
								'ul',
								{ className: 'comments__comments-holder', ref: 'commentHolder' },
								this.state.comments.map(function (comment, i) {
									return _this3.renderComment(comment, i);
								})
							) || null,
							this.state.comments && this.state.comments.length > 2 && _react2.default.createElement(
								'a',
								{ href: '#', ref: 'commentMore', className: 'comments__more span9 pixel-pattern span14-mobile', onClick: function onClick(event) {
										_this3.commentsToggle(event);
									} },
								_react2.default.createElement(
									'span',
									{ className: 'comments__more__text hide-mobile' },
									'Load more (' + (this.state.comments.length - 2) + ')'
								),
								_react2.default.createElement(
									'span',
									{ className: 'comments__more__text hide-desktop hide-tablet' },
									'Load more'
								),
								_react2.default.createElement('span', { className: 'comments__more__arrow' })
							) || _react2.default.createElement('span', { href: '#', className: 'comments__more span9 pixel-pattern span14-mobile' })
						)
					)
				);
			}
		}, {
			key: 'login',
			value: function login(e) {
				e.preventDefault();
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/login'), !this.props.users.isLoggedIn(), true);
			}
		}, {
			key: 'onFormSubmit',
			value: function onFormSubmit(promise) {
				var _this4 = this;
	
				if (this.refs.form && this.refs.form.serialize) {
					this.setState(_extends({}, this.state, { waiting: true }));
	
					promise.then(function (resp) {
						var comment = resp.data.comments;
	
						comment.new = true;
	
						_this4.state.comments.unshift(comment);
	
						_this4.refs.comment.clear();
	
						if (_this4.state.comments[1]) {
							_this4.state.comments[1].new = false;
						}
	
						_this4.setState(_extends({}, _this4.state, {
							comments: _this4.state.comments,
							waiting: false,
							formErrors: {}
						}));
					}).catch(function (resp) {
						if (resp.status !== 401) {
							console.log(resp.data.errors);
							_this4.setState(_extends({}, _this4.state, {
								waiting: false,
								formErrors: _typeof(resp.data.errors) === 'object' ? resp.data.errors : {}
							}));
						} else {
							var error = {
								Login: ['You need to login!']
							};
	
							console.log(error);
							_this4.setState(_extends({}, _this4.state, {
								waiting: false,
								formErrors: error
							}));
						}
					});
				}
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return [this.refs.comment];
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'singleCommentToggle',
			value: function singleCommentToggle(e, reference) {
				e.preventDefault();
	
				var commentContent = this.refs[reference].childNodes[1];
				var commentHolder = this.refs.commentHolder;
				var height = commentContent.childNodes[0].offsetHeight + 40;
				height += 40;
				var holderHeight = 0;
	
				if (!this.hasClass(commentContent, 'active')) {
					commentContent.classList.add('active');
					holderHeight -= 117;
					holderHeight += height;
					commentContent.style.maxHeight = height + 'px';
				} else {
					commentContent.style.maxHeight = '76px';
					commentContent.classList.remove('active');
					holderHeight += 117;
					holderHeight -= height;
				}
	
				if (this.hasClass(commentHolder, 'active')) {
					(0, _forEach2.default)(commentHolder.childNodes, function (comment, i) {
						holderHeight += comment.offsetHeight;
					});
				} else {
					(0, _forEach2.default)(commentHolder.childNodes, function (comment, i) {
						if (i < 2) {
							holderHeight += comment.offsetHeight;
						}
					});
				}
	
				commentHolder.style.maxHeight = holderHeight + 'px';
			}
		}, {
			key: 'commentsToggle',
			value: function commentsToggle(e) {
				e.preventDefault();
	
				var commentHolder = this.refs.commentHolder;
				var commentMore = this.refs.commentMore;
				var holderHeight = 0;
	
				if (this.hasClass(commentHolder, 'active')) {
					commentHolder.classList.remove('active');
					(0, _forEach2.default)(commentHolder.childNodes, function (comment, i) {
						if (i < 2) {
							holderHeight += comment.offsetHeight;
						}
					});
				} else {
					commentHolder.classList.add('active');
					(0, _forEach2.default)(commentHolder.childNodes, function (comment, i) {
						holderHeight += comment.offsetHeight;
					});
				}
	
				if (this.hasClass(commentMore, 'active')) {
					commentMore.classList.remove('active');
				} else {
					commentMore.classList.add('active');
				}
	
				commentHolder.style.maxHeight = holderHeight + 'px';
			}
		}, {
			key: 'renderComment',
			value: function renderComment(comment, i) {
				var _this5 = this;
	
				var createdDate = new _date.DateFormatter(comment.timestamp * 1000);
				var uid = comment.id || 'comment' + i;
	
				var extra = '';
	
				if (comment.new) {
					(function () {
						extra += 'comments__comment--new';
	
						var _this = _this5;
	
						var timeout = setTimeout(function () {
							_this.refs[uid].classList.remove(extra);
						}, 500);
					})();
				}
	
				var returnNum = 0;
	
				if (comment.comment.split('\n')) {
					returnNum = comment.comment.split('\n').length;
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, ref: uid, className: 'comments__comment span9 span14-mobile ' + extra },
					_react2.default.createElement(
						'div',
						{ className: 'span2 span3-tablet comments__comment__left span14-mobile' },
						_react2.default.createElement(
							'h3',
							{ className: 'comments__comment__name' },
							comment.users.name
						),
						_react2.default.createElement(
							'h4',
							{ className: 'comments__comment__date' },
							createdDate.date,
							' ',
							createdDate.month,
							' ',
							createdDate.prettyTime
						)
					),
					(comment.comment.length > 177 || returnNum > 2) && _react2.default.createElement(
						'div',
						{ className: 'comments__comment__content span5 comments__comment__content--has-more span14-mobile' },
						_react2.default.createElement(
							'p',
							{ className: 'comments__comment__text span4 span12-mobile' },
							comment.comment
						),
						_react2.default.createElement(
							'a',
							{ href: '#', className: 'comments__comment__content--more button', onClick: function onClick(event) {
									_this5.singleCommentToggle(event, uid);
								} },
							'...'
						)
					) || _react2.default.createElement(
						'div',
						{ className: 'comments__comment__content span7 span14-mobile' },
						_react2.default.createElement(
							'p',
							{ className: 'comments__comment__text span4 span12-mobile' },
							comment.comment
						)
					)
				);
			}
		}]);
	
		return Comments;
	}(_react.Component);
	
	Comments.propTypes = {
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = Comments;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _routes = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualCaseSingle = function (_Component) {
		_inherits(ContextualCaseSingle, _Component);
	
		function ContextualCaseSingle(props) {
			_classCallCheck(this, ContextualCaseSingle);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualCaseSingle).call(this, props));
		}
	
		_createClass(ContextualCaseSingle, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props.id !== nextProps.id || this.props.case.id !== nextProps.case.id || this.props.browser.window.width !== nextProps.browser.window.width;
			}
		}, {
			key: 'render',
			value: function render() {
				var profiles = '';
				var _this = this;
	
				if (this.props.case.profiles) {
					(0, _forEach2.default)(this.props.case.profiles, function (profile, i) {
						if (i == _this.props.case.profiles.length - 1) {
							profiles += profile.name;
						} else {
							profiles += profile.name + ', ';
						}
					});
				}
	
				return _react2.default.createElement(
					'li',
					{ className: 'contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.casesRoute)(this.props.case.slug), onClick: this.props.onClick },
						this.props.case.thumbnail && _react2.default.createElement(
							'div',
							{ className: 'contextual-menu__inner-list__cases__case__image pixel-pattern pixel-pattern--darker' },
							_react2.default.createElement(_image2.default, { img: this.props.case.thumbnail, span: { desktop: 'span4', tablet: 'span4', mobile: 'span14' }, browser: this.props.browser })
						),
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__inner-list__cases__case__content' },
							_react2.default.createElement(
								'h2',
								{ className: 'contextual-menu__inner-list__cases__case__title' },
								this.props.case.title
							),
							_react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__cases__case__byline' },
								profiles
							)
						)
					)
				);
			}
		}]);
	
		return ContextualCaseSingle;
	}(_react.Component);
	
	ContextualCaseSingle.propTypes = {
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = ContextualCaseSingle;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _redux = __webpack_require__(25);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _cases = __webpack_require__(232);
	
	var _index = __webpack_require__(4);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _contextualCaseSingle = __webpack_require__(612);
	
	var _contextualCaseSingle2 = _interopRequireDefault(_contextualCaseSingle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualCases = function (_Component) {
		_inherits(ContextualCases, _Component);
	
		function ContextualCases(props) {
			_classCallCheck(this, ContextualCases);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualCases).call(this, props));
	
			_this2.state = {
				busy: false,
				searched: false,
				clearCases: false,
				start: 0,
				end: 0,
				active: false,
				searchFocus: false
			};
	
			_this2.cases = [];
			_this2.years = [];
			_this2.fetchNext = true;
			_this2.firstLaunch = true;
			return _this2;
		}
	
		_createClass(ContextualCases, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.enableCases) {
					this.fetchContCases = (0, _redux.bindActionCreators)(_cases.fetchContCases, this.props.dispatch);
					this.fetchContCases();
				}
	
				var startYear = 2000;
				var endYear = new Date().getFullYear();
	
				var yearsNum = endYear - startYear;
	
				for (var i = endYear; i >= startYear; i--) {
					var local = {
						label: i,
						value: i
					};
					this.years.push(local);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.querySelector('body').classList.remove('context-active');
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.enableCases !== this.props.enableCases) {
					this.fetchContCases();
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				var _this3 = this;
	
				this.state.searched = false;
	
				if (this.props.enableCases) {
					if (this.error || !this.props.cases.contCases || this.state.clearCases || !this.cases.length) {
						(function () {
							var _this = _this3;
							_this3.cases = [];
							_this3.state.clearCases = false;
							_this3.error = false;
	
							(0, _forEach2.default)(nextProps.cases.contCases, function (single) {
								_this.cases.push(single);
							});
						})();
					} else if (this.props.enableCases && nextProps.cases.contCases && nextProps.cases.contCases[0].id !== this.props.cases.contCases[0].id) {
						(function () {
							var _this = _this3;
	
							(0, _forEach2.default)(nextProps.cases.contCases, function (single) {
								_this.cases.push(single);
							});
						})();
					}
				}
	
				if (nextProps.cases.error) {
					this.cases = [];
					this.error = true;
					this.cases.push(this.props.cases.error);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var _this4 = this;
	
				if (this.props.enableCases && this.refs.casesHolder) {
					this.busy = false;
				}
	
				if (this.refs.casesHolder) {
	
					var singleCase = document.querySelector('.contextual-menu__inner-list__cases__case');
					var rows = Math.round(this.refs.casesHolder.offsetHeight / singleCase.offsetHeight);
					var columns = parseInt(this.refs.casesHolder.offsetWidth / singleCase.offsetWidth);
	
					var start = parseInt(this.refs.casesHolder.scrollTop / singleCase.offsetHeight);
	
					if (start > 1) {
						start *= columns;
					} else if (start == 1) {
						start = columns;
					}
	
					start += 1;
	
					var end = start + rows * columns - 1;
	
					if (this.props.editorials.total < end) {
						end = this.props.editorials.total;
					}
	
					if (start !== this.state.start || end !== this.state.end) {
						this.setState(_extends({}, this.state, {
							start: start,
							end: end
						}));
					}
	
					if (this.props.browser.window.height > this.refs.casesHolder.offsetHeight && this.fetchNext) {
						setTimeout(function () {
							var domNode = _reactDom2.default.findDOMNode(_this4.refs.nextTrigger);
							domNode && domNode.click();
							setTimeout(function () {
								if (_this4.refs.casesHolder && _this4.refs.casesHolder.scrollTop) {
									_this4.refs.casesHolder.scrollTop = 0;
								}
							}, 750);
						}, 500);
						this.fetchNext = false;
					}
				}
	
				if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
					this.refs.search.focus();
					this.firstLaunch = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState !== this.state || nextProps !== this.props || nextProps.cases.error !== this.props.cases.error || nextProps.cases.contCases.length !== this.props.cases.contCases.length || nextProps.cases.contCases.next !== this.props.cases.contCases.next;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var nextClass = 'span2 span4-mobile contextual-menu__next';
				var prevClass = 'span2 span4-mobile contextual-menu__prev';
				var toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
				var buttonClass = 'contextual-menu__toggle__button';
				var innerClass = 'contextual-menu__inner span14';
				var controlClass = 'contextual-menu__control span14';
	
				if (this.state.active) {
					nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
					prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
					toggleClass += ' contextual-menu__toggle--active';
					buttonClass += ' contextual-menu__toggle__button--active';
					innerClass += ' contextual-menu__inner--active';
					controlClass += ' contextual-menu__control--active';
				}
	
				if (this.props.seen || this.state.active) {
					controlClass += ' contextual-menu__control--seen';
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'contextual-menu span14' },
					_react2.default.createElement(
						'div',
						{ className: controlClass },
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__control__top' },
							this.props.prev && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this5.onLinkClick(event);
									}, to: (0, _index.casesRoute)(this.props.prev) },
								_react2.default.createElement(
									'div',
									{ className: prevClass },
									_react2.default.createElement(
										'span',
										{ className: 'contextual-menu__arrow__container' },
										_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
									)
								)
							) || _react2.default.createElement(
								'div',
								{ className: prevClass },
								_react2.default.createElement(
									'span',
									{ className: 'contextual-menu__arrow__container' },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								'div',
								{ className: toggleClass },
								_react2.default.createElement(
									'button',
									{ ref: 'contextualToggle', className: buttonClass, onClick: function onClick(event) {
											return _this5.onClick(event);
										} },
									_react2.default.createElement(
										'div',
										{ className: 'burger-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'close-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							this.props.next && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this5.onLinkClick(event);
									}, to: (0, _index.casesRoute)(this.props.next) },
								_react2.default.createElement(
									'div',
									{ className: nextClass },
									_react2.default.createElement(
										'span',
										{ className: 'contextual-menu__arrow__container' },
										_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
									)
								)
							) || _react2.default.createElement(
								'div',
								{ className: nextClass },
								_react2.default.createElement(
									'span',
									{ className: 'contextual-menu__arrow__container' },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
								)
							)
						),
						!this.props.seen && _react2.default.createElement(
							'span',
							{ className: 'contextual-menu__control__text' },
							'Discover more'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'contextualInner', className: innerClass },
						this.props.cases.contCases && !!this.props.cases.contCases.length && this.props.enableCases && this.renderCases(this.cases) || this.props.cases.error && this.props.enableCases && this.renderCases(this.props.cases.contCases) || _react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'profile-list__table__spinner__spinner', size: '80px' })
					)
				);
			}
		}, {
			key: 'caseScroll',
			value: function caseScroll(e) {
				var last = e.target.lastChild;
				if (!this.busy) {
	
					if (e.target.scrollTop - last.offsetTop > -2000) {
						this.busy = true;
						this.casesFetch(e.target.getAttribute('data-href'));
					}
				}
	
				if (e.target.scrollTop == 0) {
					this.refs.casePrevContainer.classList.add('contextual-menu__arrow__container--inactive');
				} else {
					this.refs.casePrevContainer.classList.remove('contextual-menu__arrow__container--inactive');
				}
	
				if (!e.target.getAttribute('data-href') && e.target.scrollTop - last.offsetTop > -900) {
					this.refs.caseNextContainer.classList.add('contextual-menu__arrow__container--inactive');
				} else {
					this.refs.caseNextContainer.classList.remove('contextual-menu__arrow__container--inactive');
				}
	
				var singleCase = document.querySelector('.contextual-menu__inner-list__cases__case');
				var rows = Math.round(e.target.offsetHeight / singleCase.offsetHeight);
				var columns = parseInt(e.target.offsetWidth / singleCase.offsetWidth);
	
				var start = parseInt(e.target.scrollTop / singleCase.offsetHeight);
	
				if (start > 1) {
					start *= columns;
				} else if (start == 1) {
					start = columns;
				}
	
				start += 1;
	
				var end = start + rows * columns - 1;
	
				document.querySelector('.contextual-menu__inner-list__right__title').innerHTML = start + ' — ' + end;
			}
		}, {
			key: 'renderCases',
			value: function renderCases(cases) {
				var _this6 = this;
	
				var uid = 'contextCases';
	
				var spinnerClass = 'contextual-menu__inner-list__cases__spinner';
	
				if (this.state.searched) {
					spinnerClass = 'contextual-menu__inner-list__cases__spinner contextual-menu__inner-list__cases__spinner--active';
				}
	
				var casesClass = 'contextual-menu__inner-list__cases span14-mobile';
				var rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--date hide-mobile';
	
				if (this.props.seen || this.state.active) {
					casesClass += ' contextual-menu__inner-list__cases--seen';
					rightClass += ' contextual-menu__inner-list__right--seen';
				}
	
				return _react2.default.createElement(
					'article',
					{ key: uid, className: 'contextual-menu__inner-list span14' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__top span14' },
						_react2.default.createElement(
							'h1',
							{ className: 'contextual-menu__inner-list__top__title' },
							'Winners'
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__top__number' },
							' (',
							this.props.cases.totalCases,
							')'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__filters span4-plus span6-tablet-plus span14-mobile-plus' },
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this6.dateInput(event);
							},
							name: '',
							ref: 'monthInput',
							placeholder: 'Month',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--month',
							options: [{ label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 }, { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 }, { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 }, { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }] }),
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this6.dateInput(event);
							},
							name: '',
							ref: 'yearInput',
							placeholder: 'Year',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--year',
							options: this.years })
					),
					_react2.default.createElement('input', { ref: 'search', onFocus: function onFocus() {
							return _this6.setState(_extends({}, _this6.state, { searchFocus: true }));
						}, onBlur: function onBlur() {
							return _this6.setState(_extends({}, _this6.state, { searchFocus: false }));
						}, className: 'contextual-menu__inner-list__search span8 hide-mobile', type: 'text', onInput: function onInput(event) {
							return _this6.caseSearch(event);
						}, placeholder: (0, _translate2.default)('contextual/caseSearch') }),
					!this.state.searchFocus && _react2.default.createElement('div', { className: 'contextual-menu__inner-list__search__cursor' }),
					_react2.default.createElement(
						'ul',
						{ ref: 'casesHolder', className: casesClass, onScroll: function onScroll(event) {
								return _this6.caseScroll(event);
							}, 'data-href': this.props.cases.next },
						_react2.default.createElement(
							'li',
							{ ref: 'profileSpinner', className: spinnerClass },
							_react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'profile-list__table__spinner__spinner', size: '80px' })
						),
						this.cases.map(function (single, i) {
							return _this6.renderSingleCase(single, i);
						}),
						this.props.cases.next && _react2.default.createElement(
							'li',
							{ ref: 'loadMoreSpinner', className: 'contextual-menu__inner-list__load-more' },
							_react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'contextual-menu__inner-list__load-more__spinner', size: '40px' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: rightClass },
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__byline' },
							'showing'
						),
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__right__title' },
							this.state.start + ' — ' + this.state.end
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__number' },
							'of ' + this.props.cases.total
						),
						_react2.default.createElement(
							'nav',
							{ className: 'contextual-menu__inner-list__right__nav' },
							_react2.default.createElement(
								'a',
								{ href: '#', onClick: function onClick(event) {
										return _this6.casesNavPrev(event);
									}, className: 'contextual-menu__inner-list__right__nav__prev' },
								_react2.default.createElement(
									'span',
									{ ref: 'casePrevContainer', className: 'contextual-menu__arrow__container' },
									_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive' })
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '#', onClick: function onClick(event) {
										return _this6.casesNav(event);
									}, className: 'contextual-menu__inner-list__right__nav__next', ref: 'nextTrigger' },
								_react2.default.createElement(
									'span',
									{ ref: 'caseNextContainer', className: 'contextual-menu__arrow__container' },
									_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow' })
								)
							)
						)
					)
				);
			}
		}, {
			key: 'renderSingleCase',
			value: function renderSingleCase(single, i) {
				var _this7 = this;
	
				var uid = 'contextualCase-' + i;
				return _react2.default.createElement(_contextualCaseSingle2.default, { key: uid, 'case': single, id: i, browser: this.props.browser, onClick: function onClick() {
						return _this7.onLinkClick();
					} });
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'casesFetch',
			value: function casesFetch(href) {
				if (href) {
					var parameters = href;
	
					parameters = parameters.split('/');
					parameters = parameters[parameters.length - 1];
	
					parameters = parameters.split('&');
	
					var offset = parameters[0].split('=')[1];
	
					var limit = parameters[1].split('=')[1];
	
					var month = null;
					if (parameters[2]) {
						month = parameters[2].split('=')[2];
					}
	
					var year = null;
					if (parameters[3]) {
						year = parameters[3].split('=')[3];
					}
	
					var query = '';
					if (parameters[4]) {
						query = parameters[4].split('=')[4];
					}
	
					this.offset = offset;
					this.limit = limit;
	
					this.fetchContCases(offset, limit, this.month, this.year, this.query);
				} else {
					console.log('Tried to caseFecth(null) - contextualCase:267');
				}
			}
		}, {
			key: 'dateInput',
			value: function dateInput(e) {
				this.month = this.refs.monthInput.value;
				this.year = this.refs.yearInput.value;
				this.refs.casesHolder.scrollTop = 0;
	
				this.fetchContCases(0, 36, this.month, this.year, this.query);
				this.setState(_extends({}, this.state, {
					searched: true,
					clearCases: true
				}));
			}
		}, {
			key: 'caseSearch',
			value: function caseSearch(e) {
				e.preventDefault();
	
				var state = this.state.searched;
				var _this = this;
				this.query = e.target.value;
				var m = this.refs.monthInput.value;
				var y = this.refs.yearInput.value;
	
				clearTimeout(this.inputTimeout);
	
				this.refs.casesHolder.scrollTop = 0;
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchContCases(0, 36, m, y, _this.query);
					_this.setState(_extends({}, this.state, {
						searched: true,
						clearCases: true
					}));
				}, 400);
			}
		}, {
			key: 'casesNavPrev',
			value: function casesNavPrev(e) {
				e.preventDefault();
	
				if (this.refs.casesHolder) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 }, this.refs.casesHolder);
					scroller.to("-=" + this.refs.casesHolder.offsetHeight);
				}
	
				//this.refs.casesHolder.scrollTop = this.refs.casesHolder.scrollTop - this.refs.casesHolder.offsetHeight;
			}
		}, {
			key: 'casesNav',
			value: function casesNav(e) {
				e.preventDefault();
	
				//this.refs.casesHolder.scrollTop = this.refs.casesHolder.lastChild.previousSibling.offsetTop;
				if (this.refs.casesHolder) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 }, this.refs.casesHolder);
					scroller.to("+=" + this.refs.casesHolder.offsetHeight);
	
					this.casesFetch(this.refs.casesHolder.getAttribute('data-href'));
				}
			}
		}, {
			key: 'onLinkClick',
			value: function onLinkClick(e) {
				document.querySelector('body').classList.remove('context-active');
	
				this.setState(_extends({}, this.state, {
					active: false
				}));
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
				document.querySelector('body').classList.toggle('context-active');
	
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
	
				this.setState(_extends({}, this.state, {
					active: !this.state.active
				}));
			}
		}]);
	
		return ContextualCases;
	}(_react.Component);
	
	ContextualCases.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualCases);

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _index = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _editorials = __webpack_require__(130);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _contextualEditorials = __webpack_require__(447);
	
	var _contextualEditorials2 = _interopRequireDefault(_contextualEditorials);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualDefault = function (_Component) {
		_inherits(ContextualDefault, _Component);
	
		function ContextualDefault(props) {
			_classCallCheck(this, ContextualDefault);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualDefault).call(this, props));
	
			_this2.state = {
				searchWord: '',
				searchResults: [],
				searched: false,
				busy: false,
				clearData: false,
				start: 0,
				end: 0,
				active: false
			};
	
			_this2.editorialsByType = [];
			_this2.years = [];
			_this2.introHidden = false;
			_this2.firstLaunch = true;
			return _this2;
		}
	
		_createClass(ContextualDefault, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.enableNews) {
					this.fetchEditorialsFromType = (0, _redux.bindActionCreators)(_editorials.fetchEditorialsFromType, this.props.dispatch);
					this.fetchEditorialsFromType(this.props.typeId);
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				var _this3 = this;
	
				if (this.props.editorials.editorialsByType && this.props.editorials.editorialsByType[0].types.id !== nextProps.editorials.editorialsByType[0].types.id) {
					this.editorialsByType = [];
				}
	
				if (this.error || this.editorialsByType.length <= 1 || !this.props.editorials.editorialsByType || this.state.clearData) {
					(function () {
						var _this = _this3;
						_this3.editorialsByType = [];
						_this3.error = false;
	
						_this3.state.clearData = false;
	
						(0, _forEach2.default)(nextProps.editorials.editorialsByType, function (single) {
							_this.editorialsByType.push(single);
						});
					})();
				} else if (nextProps.editorials.editorialsByType && nextProps.editorials.editorialsByType[0].id !== this.props.editorials.editorialsByType[0].id && nextProps.editorials.editorialsByType[0].id !== this.editorialsByType[0].id) {
					(function () {
						var _this = _this3;
	
						(0, _forEach2.default)(nextProps.editorials.editorialsByType, function (single) {
							_this.editorialsByType.push(single);
						});
					})();
				}
	
				if (nextProps.editorials.error) {
					this.editorialsByType = [];
					this.error = true;
					this.editorialsByType.push(nextProps.editorials.error);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.querySelector('body').classList.remove('context-active');
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.state.searched = false;
				if (nextProps.typeId !== this.props.typeId) {
					this.editorialsByType = [];
					this.fetchEditorialsFromType(nextProps.typeId);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.busy = false;
	
				if (this.state.active) {
					var name = this.props.name + '-seen';
					if (!localStorage.getItem(name)) {
						localStorage.setItem(name, 'seen');
					}
					this.introHidden = true;
				}
	
				if (this.refs.editorialsHolder) {
					var last = this.refs.editorialsHolder.lastChild;
	
					var target = document.querySelector('.contextual-editorials__news__news-single');
					if (!target) {
						return;
					}
	
					var startRow = Math.round(this.refs.editorialsHolder.scrollTop / target.offsetHeight);
					var noRows = Math.round(this.refs.editorialsHolder.offsetHeight / target.offsetHeight);
					var columns = Math.round(this.refs.editorialsHolder.offsetWidth / target.offsetWidth);
					var start = startRow * columns == 0 ? 1 : startRow * columns;
					var end = start + noRows * columns;
					end = start == 1 ? end - 1 : end;
	
					if (this.props.editorials.totalEditorials < end) {
						end = this.props.editorials.totalEditorials;
					}
	
					if (start !== this.state.start || end !== this.state.end) {
						this.setState({
							start: start,
							end: end
						});
					}
				}
	
				if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
					this.refs.search.focus();
					this.firstLaunch = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState !== this.state || nextProps !== this.props || nextProps.typeId !== this.props.typeId || nextProps.enableNews !== this.props.enableNews;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var news = null;
				var profiles = null;
				var allNews = null;
				var newsNum = null;
				var searchWord = null;
				var searchResults = null;
				var total = null;
				var thisNews = null;
				var next = null;
				var prev = null;
				this.extraClass = '';
	
				var localName = this.props.name + '-seen';
				var showIntro = false;
	
				if (this.props.intro && this.props.browser.window.width > 719 && !localStorage.getItem(localName) && !this.state.active) {
					this.extraClass = ' intro';
					showIntro = true;
				}
	
				if (this.props.editorials && this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length) {
					news = this.props.editorials.editorialsByType;
					allNews = this.state.start + ' — ' + this.state.end;
					newsNum = news.length;
					searchWord = this.state.searchWord;
					searchResults = [];
					total = newsNum;
					thisNews = this.props.interviewId;
					next = 0;
					prev = 0;
				}
	
				var startYear = 2000;
				var endYear = new Date().getFullYear();
	
				if (this.props.editorials && this.props.editorials.firstEditorial) {
					startYear = this.props.editorials.firstEditorial.split('-')[0];
				}
	
				this.years = [];
	
				var yearsNum = endYear - startYear;
	
				for (var i = endYear; i >= startYear; i--) {
					var local = {
						label: i,
						value: i
					};
					this.years.push(local);
				}
	
				var nextClass = 'span2 span4-mobile contextual-menu__next';
				var prevClass = 'span2 span4-mobile contextual-menu__prev';
				var toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
				var buttonClass = 'contextual-menu__toggle__button';
				var innerClass = 'contextual-menu__inner span14';
				var controlClass = 'contextual-menu__control span14';
	
				if (this.state.active) {
					nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
					prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
					toggleClass += ' contextual-menu__toggle--active';
					buttonClass += ' contextual-menu__toggle__button--active';
					innerClass += ' contextual-menu__inner--active';
					controlClass += ' contextual-menu__control--active';
				}
	
				if (this.props.seen || this.state.active) {
					controlClass += ' contextual-menu__control--seen';
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'contextual-menu span14' },
					_react2.default.createElement(
						'div',
						{ className: controlClass + this.extraClass },
						showIntro && _react2.default.createElement(
							'div',
							{ className: 'contextual-menu__intro hide-mobile' },
							this.props.intro
						) || null,
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__control__top' },
							this.props.prev && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.generateURL)(this.props.typeSlug, this.props.prev) },
								_react2.default.createElement(
									'div',
									{ className: prevClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: prevClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								'div',
								{ className: toggleClass },
								_react2.default.createElement(
									'button',
									{ ref: 'contextualToggle', className: buttonClass, onClick: function onClick(event) {
											return _this4.onClick(event);
										} },
									_react2.default.createElement(
										'div',
										{ className: 'burger-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'close-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							this.props.next && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.generateURL)(this.props.typeSlug, this.props.next) },
								_react2.default.createElement(
									'div',
									{ className: nextClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: nextClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
							)
						),
						!this.props.seen && _react2.default.createElement(
							'span',
							{ className: 'contextual-menu__control__text' },
							'Discover more'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'contextualInner', className: innerClass },
						this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length && this.renderNews(this.editorialsByType, newsNum, allNews, total) || null
					)
				);
			}
		}, {
			key: 'renderNews',
			value: function renderNews(news, newsNum, allNews, total) {
				var _this5 = this;
	
				var uid = 'contextNews';
	
				var spinnerClass = 'contextual-menu__inner-list__cases__spinner';
	
				if (this.state.searched) {
					spinnerClass = 'contextual-menu__inner-list__cases__spinner contextual-menu__inner-list__cases__spinner--active';
				}
	
				var selectClass = 'contextual-menu__inner-list__filters span4 hide-mobile hide-tablet hide-desktop';
				var inputClass = 'contextual-menu__inner-list__search span12-plus hide-mobile';
				var rightClass = 'span2-plus contextual-menu__inner-list__right hide-mobile';
	
				if (this.props.dateFilter == 1) {
					selectClass = 'contextual-menu__inner-list__filters span4-plus span6-tablet-plus span14-mobile-plus';
					inputClass = 'contextual-menu__inner-list__search span8 hide-mobile';
					rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--date hide-mobile';
				}
	
				if (this.props.seen || this.state.active) {
					rightClass += ' contextual-menu__inner-list__right--seen';
				}
	
				return _react2.default.createElement(
					'article',
					{ key: uid, className: 'contextual-menu__inner-list span14' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__top span14' },
						_react2.default.createElement(
							'h1',
							{ className: 'contextual-menu__inner-list__top__title' },
							this.props.name
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__top__number' },
							' (',
							this.props.editorials.totalEditorials,
							')'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: selectClass },
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this5.dateInput(event);
							},
							name: '',
							ref: 'yearInput',
							placeholder: 'Year',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--year',
							options: this.years }),
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this5.dateInput(event);
							},
							name: '',
							ref: 'monthInput',
							placeholder: 'Month',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--month',
							options: [{ label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 }, { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 }, { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 }, { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }] })
					),
					_react2.default.createElement('input', { ref: 'search', onChange: function onChange(event) {
							return _this5.onInput(event);
						}, className: inputClass, type: 'text', placeholder: (0, _translate2.default)('contextual/editorialSearch') }),
					_react2.default.createElement(
						'ul',
						{ onScroll: function onScroll(event) {
								return _this5.scrollEvent(event);
							}, ref: 'editorialsHolder', className: 'contextual-menu__inner-list__items span12-scroll span14-mobile' },
						_react2.default.createElement(
							'li',
							{ ref: 'profileSpinner', className: spinnerClass },
							_react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'profile-list__table__spinner__spinner', size: '80px' })
						),
						this.error && this.editorialsByType.map(function (single, i) {
							return _this5.renderError(single, i);
						}) || this.editorialsByType.map(function (single, i) {
							return _this5.renderSingle(single, i);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: rightClass },
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__byline' },
							'showing'
						),
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__right__title' },
							allNews
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__number' },
							this.props.editorials.total + ' in total'
						)
					)
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(single, i) {
				var uid = 'contextualJob' + i;
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__cases__case__content' },
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__cases__case__title' },
							single.title
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__cases__case__byline' },
							single.message
						)
					)
				);
			}
		}, {
			key: 'renderSingle',
			value: function renderSingle(single, i) {
				var _this6 = this;
	
				var uid = 'contextualJob' + i;
				var date = new _date.DateFormatter(single.releaseDate || single.createdDate);
				date = date.date + ' ' + date.month + ' ' + date.year;
				var url = (0, _index.generateURL)(single.types.slug, single.slug);
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-editorials__news__news-single contextual-editorials__news__news-single--contextual span4 span6-tablet span14-mobile' },
					_react2.default.createElement(
						'h2',
						{ className: 'contextual-editorials__news__news-single__title contextual-editorials__news__news-single__title--contextual span3 span5-tablet span12-mobile' },
						single.title
					),
					single.users && single.users.name && _react2.default.createElement(
						'span',
						{ className: 'contextual-editorials__news__news-single__profile' },
						'By ' + single.users.name
					),
					!!(single.releaseDate || single.createdDate) && _react2.default.createElement(
						'span',
						{ className: 'contextual-editorials__news__news-single__date contextual-editorials__news__news-single__date--contextual' },
						date
					),
					single.slug && this.props.browser.window.width > 719 && _react2.default.createElement(
						'div',
						{ className: 'contextual-editorials__news__news-single__overlay contextual-editorials__news__news-single__overlay--contextual' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: function onClick(event) {
									return _this6.onLinkClick(event);
								}, to: url, className: 'button contextual-editorials__news__news-single__button' },
							'Read more'
						)
					) || single.slug && _react2.default.createElement(_reactRouter.Link, { onClick: function onClick(event) {
							return _this6.onLinkClick(event);
						}, to: url, className: 'contextual-editorials__news__news-single__button--fill' })
				);
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'dateInput',
			value: function dateInput(e) {
				var month = this.refs.monthInput.value;
				var year = this.refs.yearInput.value;
	
				this.refs.editorialsHolder.scrollTop = 0;
	
				this.fetchEditorialsFromType(this.props.typeId, 0, 36, month, year, this.query);
	
				this.setState({
					searched: true,
					clearData: true
				});
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				e.preventDefault();
				var _this = this;
				this.query = e.target.value;
				var m = this.refs.monthInput.value;
				var y = this.refs.yearInput.value;
	
				this.refs.editorialsHolder.scrollTop = 0;
	
				clearTimeout(this.inputTimeout);
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchEditorialsFromType(_this.props.typeId, 0, 36, m, y, _this.query);
					_this.setState({
						searched: true,
						clearData: true
					});
				}, 400);
			}
		}, {
			key: 'scrollEvent',
			value: function scrollEvent(e) {
				var last = e.target.lastChild;
	
				var target = document.querySelector('.contextual-editorials__news__news-single');
	
				var startRow = Math.round(e.target.scrollTop / target.offsetHeight);
				var noRows = Math.round(e.target.offsetHeight / target.offsetHeight);
				var columns = Math.round(e.target.offsetWidth / target.offsetWidth);
				var start = startRow * columns == 0 ? 1 : startRow * columns;
				var end = start + noRows * columns;
				end = start == 1 ? end - 1 : end;
	
				this.setState({
					start: start,
					end: end
				});
	
				if (last.offsetTop - e.target.scrollTop < 1200 && !this.busy) {
					this.busy = true;
	
					var params = null;
					var type = this.props.typeId;
					var offset = '';
					var month = '';
					var limit = '';
					var year = '';
					var query = '';
	
					if (this.props.editorials.nextType) {
						params = this.props.editorials.nextType.split('&');
	
						offset = params[1].split('=')[1];
	
						if (params[2]) {
							limit = params[2].split('=')[1];
						}
	
						if (params[3]) {
							month = params[3].split('=')[1];
						}
	
						if (params[4]) {
							year = params[4].split('=')[1];
						}
	
						if (params[5]) {
							query = params[5].split('=')[1];
						}
	
						this.fetchEditorialsFromType(type, offset, limit, month, year, query);
					}
				}
			}
		}, {
			key: 'onLinkClick',
			value: function onLinkClick(e) {
				document.querySelector('body').classList.remove('context-active');
	
				this.setState({
					active: false
				});
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
				document.querySelector('body').classList.toggle('context-active');
	
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
	
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return ContextualDefault;
	}(_react.Component);
	
	ContextualDefault.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualDefault);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _index = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _editorials = __webpack_require__(130);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _contextualEditorials = __webpack_require__(447);
	
	var _contextualEditorials2 = _interopRequireDefault(_contextualEditorials);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualImage = function (_Component) {
		_inherits(ContextualImage, _Component);
	
		function ContextualImage(props) {
			_classCallCheck(this, ContextualImage);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualImage).call(this, props));
	
			_this2.state = {
				searchWord: '',
				searchResults: [],
				searched: false,
				busy: false,
				clearData: false,
				start: 0,
				end: 0
			};
	
			_this2.editorialsByType = [];
			_this2.years = [];
			_this2.introHidden = false;
			_this2.firstLaunch = true;
			return _this2;
		}
	
		_createClass(ContextualImage, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.enableNews) {
					this.fetchEditorialsFromType = (0, _redux.bindActionCreators)(_editorials.fetchEditorialsFromType, this.props.dispatch);
					this.fetchEditorialsFromType(this.props.typeId);
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				var _this3 = this;
	
				if (this.props.editorials.editorialsByType && this.props.editorials.editorialsByType[0].types.id !== nextProps.editorials.editorialsByType[0].types.id) {
					this.editorialsByType = [];
				}
	
				if (this.error || this.editorialsByType.length <= 1 || !this.props.editorials.editorialsByType || this.state.clearData) {
					(function () {
						var _this = _this3;
						_this3.editorialsByType = [];
						_this3.error = false;
	
						_this3.state.clearData = false;
	
						(0, _forEach2.default)(nextProps.editorials.editorialsByType, function (single) {
							_this.editorialsByType.push(single);
						});
					})();
				} else if (nextProps.editorials.editorialsByType && nextProps.editorials.editorialsByType[0].id !== this.props.editorials.editorialsByType[0].id && nextProps.editorials.editorialsByType[0].id !== this.editorialsByType[0].id) {
					(function () {
						var _this = _this3;
	
						(0, _forEach2.default)(nextProps.editorials.editorialsByType, function (single) {
							_this.editorialsByType.push(single);
						});
					})();
				}
	
				if (nextProps.editorials.error) {
					this.editorialsByType = [];
					this.error = true;
					this.editorialsByType.push(nextProps.editorials.error);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.querySelector('body').classList.remove('context-active');
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				this.state.searched = false;
				if (nextProps.typeId !== this.props.typeId) {
					this.editorialsByType = [];
					this.fetchEditorialsFromType(nextProps.typeId);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.busy = false;
	
				if (this.state.active) {
					var name = this.props.name + '-seen';
					if (!localStorage.getItem(name)) {
						localStorage.setItem(name, 'seen');
					}
					this.introHidden = true;
				}
	
				if (this.refs.editorialsHolder) {
					var last = this.refs.editorialsHolder.lastChild;
	
					var startRow = Math.round(this.refs.editorialsHolder.scrollTop / last.offsetHeight);
					var noRows = Math.round(this.refs.editorialsHolder.offsetHeight / last.offsetHeight);
					var columns = Math.round(this.refs.editorialsHolder.offsetWidth / last.offsetWidth);
					var start = startRow * columns == 0 ? 1 : startRow * columns;
					var end = start + noRows * columns;
					end = start == 1 ? end - 1 : end;
	
					if (start !== this.state.start || end !== this.state.end) {
						this.setState({
							start: start,
							end: end
						});
					}
				}
	
				if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
					this.refs.search.focus();
					this.firstLaunch = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState !== this.state || nextProps !== this.props || nextProps.typeId !== this.props.typeId || nextProps.enableNews !== this.props.enableNews;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var news = null;
				var profiles = null;
				var allNews = null;
				var newsNum = null;
				var searchWord = null;
				var searchResults = null;
				var total = null;
				var thisNews = null;
				var next = null;
				this.extraClass = '';
				var prev = null;
	
				var localName = this.props.name + '-seen';
				var showIntro = false;
	
				if (this.props.intro && this.props.browser.window.width > 719 && !localStorage.getItem(localName) && !this.state.active) {
					this.extraClass = ' intro';
					showIntro = true;
				}
	
				if (this.props.editorials && this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length) {
					news = this.props.editorials.editorialsByType;
					allNews = this.state.start + ' — ' + this.state.end;
					newsNum = news.length;
					searchWord = this.state.searchWord;
					searchResults = [];
					total = newsNum;
					thisNews = this.props.interviewId;
					next = 0;
					prev = 0;
				}
	
				var nextClass = 'span2 span4-mobile contextual-menu__next';
				var prevClass = 'span2 span4-mobile contextual-menu__prev';
				var toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
				var buttonClass = 'contextual-menu__toggle__button';
				var innerClass = 'contextual-menu__inner span14';
				var controlClass = 'contextual-menu__control span14';
	
				if (this.state.active) {
					nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
					prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
					toggleClass += ' contextual-menu__toggle--active';
					buttonClass += ' contextual-menu__toggle__button--active';
					innerClass += ' contextual-menu__inner--active';
					controlClass += ' contextual-menu__control--active';
				}
	
				if (this.props.seen || this.state.active) {
					controlClass += ' contextual-menu__control--seen';
				}
	
				this.years = [];
	
				var startYear = 2000;
				var endYear = new Date().getFullYear();
	
				if (this.props.editorials && this.props.editorials.firstEditorial) {
					startYear = this.props.editorials.firstEditorial.split('-')[0];
				}
	
				var yearsNum = endYear - startYear;
	
				for (var i = endYear; i >= startYear; i--) {
					var local = {
						label: i,
						value: i
					};
					this.years.push(local);
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'contextual-menu span14' },
					_react2.default.createElement(
						'div',
						{ className: controlClass + this.extraClass },
						showIntro && _react2.default.createElement(
							'div',
							{ className: 'contextual-menu__intro hide-mobile' },
							this.props.intro
						) || null,
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__control__top' },
							this.props.prev && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.generateURL)(this.props.typeSlug, this.props.prev) },
								_react2.default.createElement(
									'div',
									{ className: prevClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: prevClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								'div',
								{ className: toggleClass },
								_react2.default.createElement(
									'button',
									{ ref: 'contextualToggle', className: buttonClass, onClick: function onClick(event) {
											return _this4.onClick(event);
										} },
									_react2.default.createElement(
										'div',
										{ className: 'burger-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'close-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							this.props.next && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.generateURL)(this.props.typeSlug, this.props.next) },
								_react2.default.createElement(
									'div',
									{ className: nextClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: nextClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
							)
						),
						!this.props.seen && _react2.default.createElement(
							'span',
							{ className: 'contextual-menu__control__text' },
							'Discover more'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'contextualInner', className: innerClass },
						this.props.editorials.editorialsByType && this.props.editorials.editorialsByType.length && this.renderNews(this.editorialsByType, newsNum, allNews, total) || null
					)
				);
			}
		}, {
			key: 'renderNews',
			value: function renderNews(news, newsNum, allNews, total) {
				var _this5 = this;
	
				var uid = 'contextNews';
	
				var spinnerClass = 'contextual-menu__inner-list__cases__spinner';
	
				if (this.state.searched) {
					spinnerClass = 'contextual-menu__inner-list__cases__spinner contextual-menu__inner-list__cases__spinner--active';
				}
	
				var selectClass = 'contextual-menu__inner-list__filters span4 hide-mobile hide-tablet hide-desktop';
				var inputClass = 'contextual-menu__inner-list__search span12-plus hide-mobile';
				var rightClass = 'span2 contextual-menu__inner-list__right hide-mobile';
	
				if (this.props.dateFilter == 1) {
					selectClass = 'contextual-menu__inner-list__filters span4-plus span6-tablet-plus span14-mobile-plus';
					inputClass = 'contextual-menu__inner-list__search span8 hide-mobile';
					rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--date hide-mobile';
				}
	
				if (this.props.seen || this.state.active) {
					rightClass += ' contextual-menu__inner-list__right--seen';
				}
	
				return _react2.default.createElement(
					'article',
					{ key: uid, className: 'contextual-menu__inner-list span14' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__top span14' },
						_react2.default.createElement(
							'h1',
							{ className: 'contextual-menu__inner-list__top__title' },
							this.props.name
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__top__number' },
							' (',
							this.props.editorials.totalEditorials,
							')'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: selectClass },
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this5.dateInput(event);
							},
							name: '',
							ref: 'yearInput',
							placeholder: 'Year',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--year',
							options: this.years }),
						_react2.default.createElement(_select2.default, {
							onChange: function onChange(event) {
								return _this5.dateInput(event);
							},
							name: '',
							ref: 'monthInput',
							placeholder: 'Month',
							className: 'contextual-menu__inner-list__filters__filter contextual-menu__inner-list__filters__filter--month',
							options: [{ label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 }, { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 }, { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 }, { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }] })
					),
					_react2.default.createElement('input', { ref: 'search', onChange: function onChange(event) {
							return _this5.onInput(event);
						}, className: inputClass, type: 'text', placeholder: (0, _translate2.default)('contextual/editorialSearch') }),
					_react2.default.createElement(
						'ul',
						{ onScroll: function onScroll(event) {
								return _this5.scrollEvent(event);
							}, ref: 'editorialsHolder', className: 'contextual-menu__inner-list__cases span14-mobile' },
						_react2.default.createElement(
							'li',
							{ ref: 'profileSpinner', className: spinnerClass },
							_react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'profile-list__table__spinner__spinner', size: '80px' })
						),
						this.error && this.editorialsByType.map(function (single, i) {
							return _this5.renderError(single, i);
						}) || this.editorialsByType.map(function (single, i) {
							return _this5.renderSingle(single, i);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: rightClass },
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__byline' },
							'showing'
						),
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__right__title' },
							allNews
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__number' },
							this.props.editorials.total + ' in total'
						)
					)
				);
			}
		}, {
			key: 'renderError',
			value: function renderError(single, i) {
				var uid = 'contextualJob' + i;
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__cases__case__content' },
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__cases__case__title' },
							single.title
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__cases__case__byline' },
							single.message
						)
					)
				);
			}
		}, {
			key: 'renderSingle',
			value: function renderSingle(single, i) {
				var _this6 = this;
	
				var uid = 'contextualJob' + i;
				var url = (0, _index.generateURL)(single.types.slug, single.slug);
	
				var isJury = false;
	
				if (single.jury && single.jury[0]) {
					isJury = true;
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__inner-list__cases__case__image-holder' },
							this.props.browser.window.width > 719 && _react2.default.createElement(
								'div',
								{ className: 'contextual-menu__inner-list__cases__case__overlay' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ className: 'button button--go button--go', to: url, onClick: function onClick() {
											return _this6.onLinkClick();
										} },
									'See more'
								)
							) || _react2.default.createElement(_reactRouter.Link, { onClick: function onClick(event) {
									return _this6.onLinkClick(event);
								}, to: url, className: 'contextual-editorials__news__news-single__button--fill' }),
							single.image && _react2.default.createElement(_image2.default, { img: single.image, span: { desktop: 'span2', tablet: 'span4', mobile: 'span14' }, browser: this.props.browser })
						),
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__inner-list__cases__case__content' },
							_react2.default.createElement(
								'h2',
								{ className: 'contextual-menu__inner-list__cases__case__title' },
								single.title
							),
							isJury && single.jury[0].location && _react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__cases__case__byline' },
								single.jury[0].location
							),
							isJury && single.jury[0].partof && _react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__cases__case__partof' },
								single.jury[0].partof
							)
						)
					)
				);
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'dateInput',
			value: function dateInput(e) {
				var month = this.refs.monthInput.value;
				var year = this.refs.yearInput.value;
	
				this.refs.editorialsHolder.scrollTop = 0;
	
				this.fetchEditorialsFromType(this.props.typeId, 0, 36, month, year, this.query);
	
				this.setState({
					searched: true,
					clearData: true
				});
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				e.preventDefault();
				var _this = this;
				this.query = e.target.value;
				var m = this.refs.monthInput.value;
				var y = this.refs.yearInput.value;
	
				this.refs.editorialsHolder.scrollTop = 0;
	
				clearTimeout(this.inputTimeout);
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchEditorialsFromType(_this.props.typeId, 0, 36, m, y, _this.query);
					_this.setState({
						searched: true,
						clearData: true
					});
				}, 400);
			}
		}, {
			key: 'scrollEvent',
			value: function scrollEvent(e) {
				var last = e.target.lastChild;
	
				var target = document.querySelector('.contextual-menu__inner-list__cases__case');
	
				var startRow = Math.round(e.target.scrollTop / target.offsetHeight);
				var noRows = Math.round(e.target.offsetHeight / target.offsetHeight);
				var columns = Math.round(e.target.offsetWidth / target.offsetWidth);
				var start = startRow * columns == 0 ? 1 : startRow * columns;
				var end = start + noRows * columns;
				end = start == 1 ? end - 1 : end;
	
				this.setState({
					start: start,
					end: end
				});
	
				if (last.offsetTop - e.target.scrollTop < 1200 && !this.busy) {
					this.busy = true;
	
					var params = null;
					var type = this.props.typeId;
					var offset = '';
					var month = '';
					var limit = '';
					var year = '';
					var query = '';
	
					if (this.props.editorials.nextType) {
						params = this.props.editorials.nextType.split('&');
	
						offset = params[1].split('=')[1];
	
						if (params[2]) {
							limit = params[2].split('=')[1];
						}
	
						if (params[3]) {
							month = params[3].split('=')[1];
						}
	
						if (params[4]) {
							year = params[4].split('=')[1];
						}
	
						if (params[5]) {
							query = params[5].split('=')[1];
						}
	
						this.fetchEditorialsFromType(type, offset, limit, month, year, query);
					}
				}
			}
		}, {
			key: 'onLinkClick',
			value: function onLinkClick(e) {
				document.querySelector('body').classList.remove('context-active');
	
				this.setState({
					active: false
				});
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
				document.querySelector('body').classList.toggle('context-active');
	
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
	
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return ContextualImage;
	}(_react.Component);
	
	ContextualImage.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualImage);

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _index = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _jobs = __webpack_require__(170);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _relLinks = __webpack_require__(380);
	
	var _relLinks2 = _interopRequireDefault(_relLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualJobs = function (_Component) {
		_inherits(ContextualJobs, _Component);
	
		function ContextualJobs(props) {
			_classCallCheck(this, ContextualJobs);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualJobs).call(this, props));
	
			_this.state = {
				searchWord: '',
				searchResults: [],
				searched: false,
				active: false
			};
			_this.firstLaunch = true;
			return _this;
		}
	
		_createClass(ContextualJobs, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.enableJobs) {
					this.fetchJobs = (0, _redux.bindActionCreators)(_jobs.fetchJobs, this.props.dispatch);
					this.fetchJobs();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.querySelector('body').classList.remove('context-active');
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.enableJobs !== this.props.enableJobs) {
					this.fetchJobs();
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState !== this.state || nextProps !== this.props || nextProps.enableJobs !== this.props.enableJobs;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
					this.refs.search.focus();
					this.firstLaunch = false;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var jobs = null;
				var profiles = null;
				var allJobs = null;
				var jobsNum = null;
				var searchWord = null;
				var searchResults = null;
				var total = null;
				var thisJob = null;
				var next = null;
				var prev = null;
	
				if (this.props.jobs.items && this.props.jobs.items.length) {
					jobs = this.props.jobs.items;
					allJobs = 'All jobs';
					jobsNum = jobs.length;
					searchWord = this.state.searchWord;
					searchResults = [];
					total = jobsNum;
					thisJob = this.props.jobId;
					next = 0;
					prev = 0;
	
					(0, _forEach2.default)(jobs, function (job, i) {
						if (job.title.toLowerCase().indexOf(searchWord) > -1 || job.country.toLowerCase().indexOf(searchWord) > -1 || job.city.toLowerCase().indexOf(searchWord) > -1 || job.profiles.name && job.profiles.name.toLowerCase().indexOf(searchWord) > -1) {
							searchResults.push(job);
						}
	
						if (job.id == thisJob) {
							if (i == jobs.length - 1) {
								next = 0;
							} else {
								next = i + 1;
							}
	
							if (i == 0) {
								prev = jobs.length - 1;
							} else {
								prev = i - 1;
							}
						}
					});
	
					next = jobs[next].slug;
					prev = jobs[prev].slug;
	
					if (searchWord != '') {
						jobsNum = searchResults.length;
						allJobs = 'Found jobs';
	
						if (!searchResults.length) {
							searchResults.push({
								title: 'No results'
							});
						}
					}
				}
	
				var url = window.location.href;
				var remove = window.location.href.split('/')[window.location.href.split('/').length - 1];
	
				(0, _relLinks2.default)(url.replace(remove, prev), url.replace(remove, next));
	
				var nextClass = 'span2 span4-mobile contextual-menu__next';
				var prevClass = 'span2 span4-mobile contextual-menu__prev';
				var toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
				var buttonClass = 'contextual-menu__toggle__button';
				var innerClass = 'contextual-menu__inner span14';
				var controlClass = 'contextual-menu__control span14';
	
				if (this.state.active) {
					nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
					prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
					toggleClass += ' contextual-menu__toggle--active';
					buttonClass += ' contextual-menu__toggle__button--active';
					innerClass += ' contextual-menu__inner--active';
					controlClass += ' contextual-menu__control--active';
				}
	
				if (this.props.seen || this.state.active) {
					controlClass += ' contextual-menu__control--seen';
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'contextual-menu span14' },
					_react2.default.createElement(
						'div',
						{ className: controlClass },
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__control__top' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this2.onLinkClick(event);
									}, to: (0, _index.jobsRoute)(prev) },
								_react2.default.createElement(
									'div',
									{ className: prevClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								'div',
								{ className: toggleClass },
								_react2.default.createElement(
									'button',
									{ ref: 'contextualToggle', className: buttonClass, onClick: function onClick(event) {
											return _this2.onClick(event);
										} },
									_react2.default.createElement(
										'div',
										{ className: 'burger-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'close-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this2.onLinkClick(event);
									}, to: (0, _index.jobsRoute)(next) },
								_react2.default.createElement(
									'div',
									{ className: nextClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
								)
							)
						),
						!this.props.seen && _react2.default.createElement(
							'span',
							{ className: 'contextual-menu__control__text' },
							'Discover more'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'contextualInner', className: innerClass },
						this.props.jobs.items && this.props.jobs.items.length && searchResults && this.props.enableJobs && this.renderJobs(searchResults, jobsNum, allJobs, total) || this.props.jobs.items && this.props.jobs.items.length && this.props.enableJobs && this.renderJobs(jobs, jobsNum, allJobs, total) || null
					)
				);
			}
		}, {
			key: 'renderJobs',
			value: function renderJobs(jobs, jobsNum, allJobs, total) {
				var _this3 = this;
	
				var uid = 'contextJobs';
				var rightClass = 'span2-plus contextual-menu__inner-list__right hide-mobile';
	
				if (this.props.seen || this.state.active) {
					rightClass += ' contextual-menu__inner-list__right--seen';
				}
	
				return _react2.default.createElement(
					'article',
					{ key: uid, className: 'contextual-menu__inner-list span14' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__top span14' },
						_react2.default.createElement(
							'h1',
							{ className: 'contextual-menu__inner-list__top__title' },
							'Jobs'
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__top__number' },
							' (',
							total,
							')'
						)
					),
					_react2.default.createElement('input', { ref: 'search', onChange: function onChange(event) {
							return _this3.onInput(event);
						}, className: 'contextual-menu__inner-list__search span12 hide-mobile', type: 'text', placeholder: (0, _translate2.default)('contextual/jobsSearch') }),
					_react2.default.createElement(
						'ul',
						{ className: 'contextual-menu__inner-list__items span12-scroll span14-mobile' },
						jobs.map(function (job, i) {
							return _this3.renderJob(job, i);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: rightClass },
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__byline' },
							'showing'
						),
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__right__title' },
							allJobs
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__number' },
							jobsNum + ' in total'
						)
					)
				);
			}
		}, {
			key: 'renderJob',
			value: function renderJob(job, i) {
				var _this4 = this;
	
				var uid = 'contextualJob' + i;
				var date = new _date.DateFormatter(job.createdDate);
				date = date.date + ' ' + date.month + ' ' + date.year;
				var url = (0, _index.jobsRoute)(job.slug);
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-menu__inner-list__items__item span4 span6-tablet span14-mobile' },
					_react2.default.createElement(
						'h2',
						{ className: 'contextual-menu__inner-list__items__item__title' },
						job.title
					),
					job.profiles && job.profiles.name && _react2.default.createElement(
						'span',
						{ className: 'contextual-menu__inner-list__items__item__profile' },
						job.profiles.name
					),
					job.city && _react2.default.createElement(
						'span',
						{ className: 'contextual-menu__inner-list__items__item__location' },
						job.city + ', ' + job.country
					),
					job.createdDate && _react2.default.createElement(
						'span',
						{ className: 'contextual-menu__inner-list__items__item__date' },
						date
					),
					job.slug && this.props.browser.window.width > 719 && _react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__items__item__overlay' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: function onClick(event) {
									return _this4.onLinkClick(event);
								}, to: url, className: 'button contextual-menu__inner-list__items__item__button' },
							'Read more'
						)
					) || job.slug && _react2.default.createElement(_reactRouter.Link, { onClick: function onClick(event) {
							return _this4.onLinkClick(event);
						}, to: url, className: 'contextual-menu__inner-list__items__item__button--fill' })
				);
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				this.setState(_extends({}, this.state, {
					searchWord: e.target.value
				}));
			}
		}, {
			key: 'onLinkClick',
			value: function onLinkClick(e) {
				document.querySelector('body').classList.remove('context-active');
	
				this.setState({
					active: false
				});
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
				document.querySelector('body').classList.toggle('context-active');
	
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
	
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return ContextualJobs;
	}(_react.Component);
	
	ContextualJobs.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualJobs);

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _index = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _profiles = __webpack_require__(233);
	
	var _jobs = __webpack_require__(170);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _tooltip = __webpack_require__(180);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualProfiles = function (_Component) {
		_inherits(ContextualProfiles, _Component);
	
		function ContextualProfiles(props) {
			_classCallCheck(this, ContextualProfiles);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ContextualProfiles).call(this, props));
	
			_this2.state = {
				searchWord: '',
				searchResults: [],
				searched: false,
				busy: false,
				clearProfiles: false,
				active: false
			};
	
			_this2.busy = false;
			_this2.profiles = [];
			_this2.firstLaunch = true;
			return _this2;
		}
	
		_createClass(ContextualProfiles, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
	
				if (this.props.enableProfiles) {
					this.fetchProfiles = (0, _redux.bindActionCreators)(_profiles.fetchProfiles, this.props.dispatch);
					this.fetchProfiles();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.querySelector('body').classList.remove('context-active');
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.enableProfiles !== this.props.enableProfiles) {
					this.fetchProfiles();
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				var _this3 = this;
	
				this.state.searched = false;
				if (this.props.enableProfiles) {
					if (this.profiles.length <= 1 || !this.props.profiles.profiles || this.state.clearProfiles) {
						(function () {
							var _this = _this3;
							_this3.profiles = [];
	
							(0, _forEach2.default)(nextProps.profiles.profiles, function (profile) {
								_this.profiles.push(profile);
							});
	
							_this3.state.clearProfiles = false;
						})();
					} else if (this.props.enableProfiles && nextProps.profiles.profiles && nextProps.profiles.profiles[0].id !== this.props.profiles.profiles[0].id) {
						(function () {
							var _this = _this3;
	
							(0, _forEach2.default)(nextProps.profiles.profiles, function (profile) {
								_this.profiles.push(profile);
							});
						})();
					}
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.props.enableProfiles && this.refs.profilesHolder) {
					this.busy = false;
	
					this.profileHeight = document.querySelector('.contextual-menu__inner-list__profiles__profile').offsetHeight;
	
					this.visibleProfiles = parseInt(this.refs.profilesHolder.offsetHeight / this.profileHeight);
	
					var start = parseInt(this.refs.profilesHolder.scrollTop / this.profileHeight) || 0;
	
					start += 1;
	
					var finish = parseInt(start + this.visibleProfiles) - 1 || 0;
	
					var className = '.contextual-menu__inner-list__profiles__profile:nth-child(n+' + start + '):nth-child(-n+' + (finish + 1) + '):not(.contextual-menu__inner-list__profiles__profile--active)';
	
					var actives = document.querySelectorAll(className);
	
					(0, _forEach2.default)(actives, function (single) {
						single.classList.add('contextual-menu__inner-list__profiles__profile--active');
					});
				}
	
				if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
					this.refs.search.focus();
					this.firstLaunch = false;
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState !== this.state || nextProps !== this.props;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var profiles = null;
				var total = null;
	
				if (this.props.profiles) {
					profiles = this.props.profiles.profiles;
				}
	
				var nextClass = 'span2 span4-mobile contextual-menu__next';
				var prevClass = 'span2 span4-mobile contextual-menu__prev';
				var toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
				var buttonClass = 'contextual-menu__toggle__button';
				var innerClass = 'contextual-menu__inner span14';
				var controlClass = 'contextual-menu__control span14';
	
				if (this.state.active) {
					nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
					prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
					toggleClass += ' contextual-menu__toggle--active';
					buttonClass += ' contextual-menu__toggle__button--active';
					innerClass += ' contextual-menu__inner--active';
					controlClass += ' contextual-menu__control--active';
				}
	
				if (this.props.seen || this.state.active) {
					controlClass += ' contextual-menu__control--seen';
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'contextual-menu span14' },
					_react2.default.createElement(
						'div',
						{ className: controlClass },
						_react2.default.createElement(
							'div',
							{ className: 'contextual-menu__control__top' },
							this.props.enableProfiles && this.props.prevProfile && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.profilesRoute)(this.props.prevProfile) },
								_react2.default.createElement(
									'div',
									{ className: prevClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: prevClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--prev' })
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							_react2.default.createElement(
								'div',
								{ className: toggleClass },
								_react2.default.createElement(
									'button',
									{ ref: 'contextualToggle', className: buttonClass, onClick: function onClick(event) {
											return _this4.onClick(event);
										} },
									_react2.default.createElement(
										'div',
										{ className: 'burger-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'close-icon' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('i', null)
										)
									)
								)
							),
							_react2.default.createElement('div', { className: 'span4 span2-tablet hide-mobile contextual-menu__filler' }),
							this.props.enableProfiles && this.props.nextProfile && _react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick(event) {
										return _this4.onLinkClick(event);
									}, to: (0, _index.profilesRoute)(this.props.nextProfile) },
								_react2.default.createElement(
									'div',
									{ className: nextClass },
									_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
								)
							) || _react2.default.createElement(
								'div',
								{ className: nextClass },
								_react2.default.createElement('span', { className: 'contextual-menu__arrow contextual-menu__arrow--next' })
							)
						),
						!this.props.seen && _react2.default.createElement(
							'span',
							{ className: 'contextual-menu__control__text' },
							'Discover more'
						)
					),
					_react2.default.createElement(
						'div',
						{ ref: 'contextualInner', className: innerClass },
						this.props.profiles && !!this.props.profiles.profiles.length && this.props.enableProfiles && this.renderProfiles(this.profiles) || (this.props.profiles.error || !!this.props.profiles.profiles.error) && this.props.enableProfiles && this.renderProfiles(this.props.profiles.profiles) || null
					)
				);
			}
		}, {
			key: 'profilesScroll',
			value: function profilesScroll(e) {
				if (!this.busy) {
					var last = e.target.lastChild;
	
					if (e.target.scrollTop - last.offsetHeight > -2000) {
						this.profilesFetch(e.target.getAttribute('data-href'));
						this.busy = true;
					}
				}
	
				//this.refs.contextualHead.style.transform = 'translatey(' + (e.target.scrollTop - 52) + 'px)';
	
				var start = parseInt(e.target.scrollTop / this.profileHeight);
	
				start += 1;
	
				var finish = parseInt(start + this.visibleProfiles) - 1;
	
				var target = document.querySelector('.contextual-menu__inner-list__right__title');
	
				target.innerHTML = start + ' — ' + finish;
	
				var className = '.contextual-menu__inner-list__profiles__profile:nth-child(n+' + start + '):nth-child(-n+' + (finish + 1) + '):not(.contextual-menu__inner-list__profiles__profile--active)';
	
				var actives = document.querySelectorAll(className);
	
				if (!!actives.length) {
					(0, _forEach2.default)(actives, function (single) {
						single.classList.add('contextual-menu__inner-list__profiles__profile--active');
					});
				}
			}
		}, {
			key: 'renderProfiles',
			value: function renderProfiles(profiles) {
				var _this5 = this;
	
				var uid = 'contextProfiles';
				var offset = 0;
	
				var spinnerClass = 'contextual-menu__inner-list__profiles__table__spinner';
	
				if (this.state.searched) {
					spinnerClass = 'contextual-menu__inner-list__profiles__table__spinner profile-list__table__spinner--active';
				}
	
				var rightClass = 'span2-plus contextual-menu__inner-list__right contextual-menu__inner-list__right--profile hide-mobile';
				var profilesClass = 'contextual-menu__inner-list__profiles span12 span14-mobile';
	
				if (this.props.seen || this.state.active) {
					rightClass += ' contextual-menu__inner-list__right--seen';
					profilesClass += ' contextual-menu__inner-list__profiles--seen';
				}
	
				if (this.props.profiles.next) {
					var parameters = this.props.profiles.next;
					parameters = parameters.split('/');
					parameters = parameters[parameters.length - 1];
	
					parameters = parameters.split('&');
	
					offset = parameters[0].split('=')[1];
				};
	
				if (!this.props.profiles.next && this.props.profiles.prev) {
					var _parameters = this.props.profiles.prev;
					_parameters = _parameters.split('/');
					_parameters = _parameters[_parameters.length - 1];
	
					_parameters = _parameters.split('&');
	
					offset = _parameters[0].split('=')[1];
				}
	
				return _react2.default.createElement(
					'article',
					{ key: uid, className: 'contextual-menu__inner-list span14' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__top span14' },
						_react2.default.createElement(
							'h1',
							{ className: 'contextual-menu__inner-list__top__title' },
							'Profiles'
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__top__number' },
							' (',
							this.props.profiles.totalProfiles,
							')'
						)
					),
					_react2.default.createElement('input', { ref: 'search', onChange: function onChange(event) {
							return _this5.onProfileSearch(event);
						}, className: 'contextual-menu__inner-list__search span12 hide-mobile', type: 'text', placeholder: (0, _translate2.default)('contextual/profilesSearch') }),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__wrap' },
						_react2.default.createElement(
							'div',
							{ ref: 'profilesHolder', className: profilesClass, onScroll: function onScroll(event) {
									return _this5.profilesScroll(event);
								}, 'data-href': this.props.profiles.next },
							_react2.default.createElement(
								'div',
								{ ref: 'contextualHead', className: 'contextual-menu__inner-list__profiles__table__head span12 span14-mobile' },
								_react2.default.createElement('div', { className: 'contextual-menu__inner-list__profiles__table__head__title span1 hide-tablet hide-mobile' }),
								_react2.default.createElement(
									'div',
									{ className: 'contextual-menu__inner-list__profiles__table__head__title contextual-menu__inner-list__profiles__table__head__title--left span3-tablet span4 span10-mobile' },
									'Name'
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'total', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title contextual-menu__inner-list__profiles__table__head__title--total contextual-menu__inner-list__profiles__table__head__title--sort ' },
									_react2.default.createElement(
										'span',
										{ className: 'hide-mobile' },
										'Total'
									),
									_react2.default.createElement(
										'span',
										{ className: 'hide-tablet hide-desktop' },
										'Awards'
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'FOTD', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'FOTD' },
										'FOTD'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.FOTD;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/fotd/title')
										),
										(0, _translate2.default)('awards/fotd/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'TCEA', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'TCEA' },
										'TCEA'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.TCEA;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/tcea/title')
										),
										(0, _translate2.default)('awards/tcea/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'FOTM', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'FOTM' },
										'FOTM'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.FOTM;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/fotm/title')
										),
										(0, _translate2.default)('awards/fotm/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'FOTY', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'FOTY' },
										'FOTY'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.FOTY;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/foty/title')
										),
										(0, _translate2.default)('awards/foty/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'TCEAY', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'TCEAY' },
										'TCEAY'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.TCEAY;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/tceay/title')
										),
										(0, _translate2.default)('awards/tceay/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'PCA', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile' },
									_react2.default.createElement(
										'span',
										{ ref: 'PCA' },
										'PCA'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.PCA;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/pca/title')
										),
										(0, _translate2.default)('awards/pca/text')
									)
								),
								_react2.default.createElement(
									'div',
									{ 'data-sort': 'MOTD', onClick: function onClick(event) {
											return _this5.sortClick(event);
										}, className: 'contextual-menu__inner-list__profiles__table__head__title hide-mobile contextual-menu__inner-list__profiles__table__head__title--no-border' },
									_react2.default.createElement(
										'span',
										{ ref: 'MOTD' },
										'MOTD'
									),
									_react2.default.createElement(
										_tooltip2.default,
										{ attachTo: function attachTo() {
												return _this5.refs.MOTD;
											} },
										_react2.default.createElement(
											'header',
											null,
											'description:'
										),
										_react2.default.createElement(
											'h2',
											null,
											(0, _translate2.default)('awards/motd/title')
										),
										(0, _translate2.default)('awards/motd/text')
									)
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'contextual-menu__inner-list__profiles__table span12 span14-mobile' },
								_react2.default.createElement(
									'li',
									{ ref: 'profileSpinner', className: spinnerClass },
									_react2.default.createElement(_spinner2.default, { pathStroke: '#fff', className: 'profile-list__table__spinner__spinner', size: '80px' })
								),
								profiles.length && profiles.map(function (profile, i) {
									return _this5.renderProfile(profile, i);
								}) || profiles.error && _react2.default.createElement(
									'li',
									{ className: 'contextual-menu__inner-list__profiles__profile' },
									profiles.error.title,
									_react2.default.createElement(
										'span',
										{ className: 'profile-list__profile__name profile-list__profile__name__weak' },
										profiles.error.message
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: rightClass },
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__byline' },
							'showing'
						),
						_react2.default.createElement(
							'h2',
							{ className: 'contextual-menu__inner-list__right__title' },
							1 + ' — ' + 13
						),
						_react2.default.createElement(
							'span',
							{ className: 'contextual-menu__inner-list__right__number' },
							this.props.profiles.total + ' in total'
						),
						_react2.default.createElement(
							'nav',
							{ className: 'contextual-menu__inner-list__right__nav' },
							this.props.profiles.prev && _react2.default.createElement(
								'a',
								{ href: this.props.profiles.prev, onClick: function onClick(event) {
										return _this5.profilesPrev(event);
									}, className: 'contextual-menu__inner-list__right__nav__prev' },
								_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow' })
							) || _react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__right__nav__prev' },
								_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive' })
							),
							this.props.profiles.next && _react2.default.createElement(
								'a',
								{ href: this.props.profiles.next, onClick: function onClick(event) {
										return _this5.profilesNav(event);
									}, className: 'contextual-menu__inner-list__right__nav__next' },
								_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow' })
							) || _react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__right__nav__next' },
								_react2.default.createElement('span', { className: 'contextual-menu__inner-list__right__nav__arrow contextual-menu__inner-list__right__nav__arrow--inactive' })
							)
						)
					)
				);
			}
		}, {
			key: 'renderProfile',
			value: function renderProfile(profile, i) {
				var _this6 = this;
	
				var uid = 'contextualProfile' + i;
	
				var url = (0, _index.profilesRoute)(profile.slug);
	
				var offices = '';
	
				if (profile.offices.length) {
					for (var i = 0; i < profile.offices.length; i++) {
						if (i < profile.offices.length - 1) {
							offices += profile.offices[i].name + ', ';
						} else {
							offices += profile.offices[i].name;
						}
					}
				} else if (profile.legacyOffice && profile.legacyOffice !== '') {
					offices = profile.legacyOffice;
				}
	
				//single.classList.add('contextual-menu__inner-list__profiles__profile--active');
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'contextual-menu__inner-list__profiles__profile' },
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell contextual-menu__inner-list__profiles__profile__picture span1 hide-tablet hide-mobile' },
						profile.logo && profile.logo.normal && _react2.default.createElement(
							_reactRouter.Link,
							{ to: url, onClick: function onClick(event) {
									return _this6.onLinkClick(event);
								} },
							_react2.default.createElement('img', _extends({}, profile.logo.normal, { alt: profile.name }))
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell contextual-menu__inner-list__profiles__profile__name span3-tablet span4 span10-mobile' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url, className: 'contextual-menu__inner-list__profiles__profile__name__strong', onClick: function onClick(event) {
									return _this6.onLinkClick(event);
								} },
							profile.name,
							_react2.default.createElement(
								'span',
								{ className: 'contextual-menu__inner-list__profiles__profile__name contextual-menu__inner-list__profiles__profile__name__weak' },
								offices
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell' },
						profile.stats.total
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.FOTD
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.TCEA
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.FOTM
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.FOTY
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.TCEAY
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile' },
						profile.stats.PCA
					),
					_react2.default.createElement(
						'div',
						{ className: 'contextual-menu__inner-list__profiles__profile__cell hide-mobile contextual-menu__inner-list__profiles__profile__cell--no-border contextual-menu__inner-list__profiles__profile__cell--grey' },
						profile.stats.MOTD
					)
				);
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'profilesFetch',
			value: function profilesFetch(href) {
				if (href) {
					var parameters = href;
					parameters = parameters.split('/');
					parameters = parameters[parameters.length - 1];
	
					parameters = parameters.split('&');
	
					var offset = parameters[0].split('=')[1];
	
					var limit = parameters[1].split('=')[1];
	
					var query = parameters[2].split('=')[1];
	
					// this.setState({
					// 	searched: true,
					// });
	
					this.offset = offset;
					this.limit = limit;
					this.query = query;
	
					this.fetchProfiles(offset, limit, query, this.order, this.orderBy);
				}
			}
		}, {
			key: 'profilesPrev',
			value: function profilesPrev(e) {
				e.preventDefault();
	
				this.refs.profilesHolder.scrollTop = this.refs.profilesHolder.scrollTop - this.refs.profilesHolder.offsetHeight;
			}
		}, {
			key: 'profilesNav',
			value: function profilesNav(e) {
				e.preventDefault();
	
				var href = null;
	
				if (e.target.getAttribute('href')) {
					href = e.target.getAttribute('href');
				} else {
					href = e.target.parentNode.getAttribute('href');
				}
	
				this.refs.profilesHolder.scrollTop = this.refs.profilesHolder.lastChild.offsetHeight;
	
				this.profilesFetch(href);
	
				this.setState({
					active: false
				});
			}
		}, {
			key: 'sortClick',
			value: function sortClick(e) {
	
				var target = e.target;
	
				if (!this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title')) {
					target = target.parentNode;
	
					if (target.tagName !== 'DIV') {
						target = target.parentNode;
					}
				}
	
				this.orderBy = target.getAttribute('data-sort');
	
				if (this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title--sort')) {
					if (this.hasClass(target, 'contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
						this.order = '';
						target.classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
					} else {
						this.order = 'ASC';
						target.classList.add('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
					}
				} else {
					if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort')) {
						document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort');
					}
	
					if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
						document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
					}
	
					this.order = '';
					target.classList.add('contextual-menu__inner-list__profiles__table__head__title--sort');
				}
	
				this.setState({
					searched: true,
					clearProfiles: true
				});
	
				this.refs.profilesHolder.scrollTop = 0;
	
				this.fetchProfiles(0, 36, this.query, this.order, this.orderBy);
			}
		}, {
			key: 'onLinkClick',
			value: function onLinkClick(e) {
				document.querySelector('body').classList.remove('context-active');
	
				this.setState({
					active: false
				});
			}
		}, {
			key: 'onProfileSearch',
			value: function onProfileSearch(e) {
				var string = e.target.value;
	
				var state = this.state.searched;
				var _this = this;
	
				clearTimeout(this.inputTimeout);
	
				this.refs.profilesHolder.scrollTop = 0;
	
				this.query = string;
	
				if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort')) {
					document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort');
				}
	
				if (document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc')) {
					document.querySelector('.contextual-menu__inner-list__profiles__table__head__title--sort--asc').classList.remove('contextual-menu__inner-list__profiles__table__head__title--sort--asc');
				}
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchProfiles(0, 36, string, '', '');
					_this.setState({
						searched: true,
						clearProfiles: true
					});
				}, 400);
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				e.preventDefault();
				document.querySelector('body').classList.toggle('context-active');
	
				try {
					localStorage.setItem('context', 'seen');
				} catch (e) {}
	
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return ContextualProfiles;
	}(_react.Component);
	
	ContextualProfiles.propTypes = {};
	exports.default = (0, _connect2.default)(ContextualProfiles);

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './content.scss';
	
	var EditorialContentQA = function (_Component) {
		_inherits(EditorialContentQA, _Component);
	
		function EditorialContentQA(props) {
			_classCallCheck(this, EditorialContentQA);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialContentQA).call(this));
	
			_this.mounted = true;
	
			_this.scroll = _this.scroll.bind(_this);
	
			_this.state = {
				placeholderHeight: 0,
				placeholderWidth: 0,
				posToStick: -1,
				posToStickEndStick: -1,
				isSticky: false
			};
			return _this;
		}
	
		_createClass(EditorialContentQA, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.browser.scroll.register(this.scroll);
				this.updateDimensions();
				//this.stickify(this.refs.stickyPrimary, this.refs.stickyPlaceholder, this.refs.stickyWrapper);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.scroll);
				this.mounted = false;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (this.props.content.question !== prevProps.content.question) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props$content = this.props.content;
				var question = _props$content.question;
				var answer = _props$content.answer;
	
				var phStyle = {};
				var qStyle = {};
	
				phStyle.height = this.state.placeholderHeight + 'px';
				phStyle.height = this.state.placeholderHeight + 'px';
	
				if (this.state.isSticky) {
					qStyle.top = (this.props.browser.window.width > 719 ? 61 : 50) + 'px';
					qStyle.position = 'fixed';
				} else {
					qStyle.position = 'absolute';
					qStyle.top = '0px';
				}
	
				if (!this.state.placeholderHeight) {
					setTimeout(function () {
						_this2.updateDimensions();
					}, 500);
				}
	
				return _react2.default.createElement(
					'section',
					{ className: 'editorial-content__section__qa-wrapper', ref: 'stickyWrapper' },
					_react2.default.createElement('div', { className: 'placeholder', ref: 'stickyPlaceholder', style: phStyle }),
					_react2.default.createElement(
						'div',
						{ className: 'cf editorial-content__section editorial-content__section__question span8 span8-tablet span14-mobile', ref: 'stickyPrimary', style: qStyle },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span7-tablet span12-mobile' },
							_react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: question } })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'cf editorial-content__section editorial-content__section__answer' },
						_react2.default.createElement('div', { className: 'span5 span7-tablet span12-mobile', dangerouslySetInnerHTML: { __html: answer } })
					)
				);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var stWrapper = this.refs.stickyWrapper;
				var stPrimary = this.refs.stickyPrimary;
				var stPlaceholder = this.refs.stickyPlaceholder;
				var newState = _extends({}, this.state);
	
				if (!this.mounted) {
					return;
				}
	
				newState.posToStick = (0, _getOffsetTop2.default)(stPlaceholder);
				newState.posToStickEndStick = newState.posToStick + stWrapper.clientHeight;
				newState.placeholderHeight = stPrimary.clientHeight;
				newState.placeholderWidth = stPrimary.clientWidth;
	
				//console.log('update qa dims');
	
				this.mounted && this.setState(newState);
			}
		}, {
			key: 'scroll',
			value: function scroll(e) {
				var isMobile = this.props.browser.window.width <= 719;
				var scrollY = e.scrollY + (!isMobile ? 61 : 50); // account for top-nav
	
				// if (scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick) {
				// 	console.log(this.refs.stickyWrapper.getAttribute('data-reactid').substr(-1, 2));
				// }
	
				var isSticky = scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick;
				if (isSticky !== this.state.isSticky) {
					//console.log(isSticky ? 'stick' : 'unstick');
					this.mounted && this.setState(_extends({}, this.state, {
						isSticky: !isMobile && scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick
					}));
				}
			}
		}]);
	
		return EditorialContentQA;
	}(_react.Component);
	
	EditorialContentQA.PropTypes = {
		content: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired
	};
	EditorialContentQA.defaultProps = {
		content: {
			question: '',
			answer: ''
		}
	};
	exports.default = EditorialContentQA;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _truncate = __webpack_require__(1208);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _pluralize = __webpack_require__(160);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _routes = __webpack_require__(4);
	
	var _cornerLabel = __webpack_require__(177);
	
	var _cornerLabel2 = _interopRequireDefault(_cornerLabel);
	
	var _editorialElement = __webpack_require__(999);
	
	var _editorialElement2 = _interopRequireDefault(_editorialElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseElement = function (_Component) {
		_inherits(CaseElement, _Component);
	
		function CaseElement(props) {
			_classCallCheck(this, CaseElement);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseElement).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(CaseElement, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'editorial-element' },
					_react2.default.createElement(_cornerLabel2.default, { name: this.getCategory() }),
					_react2.default.createElement('div', { className: 'editorial-element__category' }),
					_react2.default.createElement(
						'div',
						{ className: 'editorial-element__content ' },
						_react2.default.createElement(
							'h2',
							{ className: 'editorial-element__content__title' },
							this.props.title
						),
						_react2.default.createElement(
							'p',
							{ className: 'editorial-element__content__excerpt' },
							this.props.excerpt.length > 90 ? (0, _truncate2.default)(this.props.excerpt, 82) + '…' : this.props.excerpt
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'editorial-element__author' },
						this.getAuthor()
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{
							to: (0, _routes.editorialRoute)(this.props.slug),
							className: 'editorial-element__link button',
							onClick: function onClick() {
								_this2.props.menuActive && _this2.props.menuActions && _this2.props.menuActions.closeMenu();
							} },
						'Read More'
					)
				);
			}
		}, {
			key: 'getCategory',
			value: function getCategory() {
				return this.props.types.name ? (0, _pluralize2.default)(this.props.types.name, 1) : '';
			}
		}, {
			key: 'getAuthor',
			value: function getAuthor() {
				if (this.props.users && this.props.users.name && this.props.users.name.length) {
					return 'By ' + this.props.users.name;
				}
	
				return '';
			}
		}]);
	
		return CaseElement;
	}(_react.Component);
	
	CaseElement.propTypes = {
		title: _react.PropTypes.string.isRequired,
		excerpt: _react.PropTypes.string.isRequired,
		slug: _react.PropTypes.string.isRequired,
		types: _react.PropTypes.object.isRequired,
		users: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		menuActive: _react.PropTypes.bool.isRequired
	};
	CaseElement.defaultProps = {
		title: '',
		excerpt: '',
		slug: '',
		types: {},
		users: {
			name: 'test'
		},
		menuActive: false
	};
	exports.default = CaseElement;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _graphDots = __webpack_require__(1080);
	
	var _graphDots2 = _interopRequireDefault(_graphDots);
	
	var _graphTextDots = __webpack_require__(1081);
	
	var _graphTextDots2 = _interopRequireDefault(_graphTextDots);
	
	var _evolution = __webpack_require__(1001);
	
	var _evolution2 = _interopRequireDefault(_evolution);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Evolution = function (_Component) {
		_inherits(Evolution, _Component);
	
		function Evolution(props) {
			_classCallCheck(this, Evolution);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Evolution).call(this, props));
		}
	
		_createClass(Evolution, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'section',
					{ className: 'evolution' },
					_react2.default.createElement(
						'div',
						{ className: 'evolution__top' },
						_react2.default.createElement(
							'div',
							{ className: 'evolution__left span9 span14-mobile' },
							_react2.default.createElement(
								'h2',
								{ className: 'evolution__title' },
								'Judging Evolution'
							),
							_react2.default.createElement(
								'h3',
								{ className: 'evolution__label' },
								'Points:'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'case-single__meta-scorecard span5 pixel-pattern hide-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'case-single__meta-scorecard__stats case-single__meta-scorecard__stats--evolution hide-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'case-single__meta-scorecard__title' },
									'FWA award stats:'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-single__meta-scorecard__points case-single__meta-scorecard__points--evolution', ref: 'pointsTooltipTablet' },
								_react2.default.createElement(
									'h3',
									{ className: 'case-single__meta-scorecard__title' },
									'Points:'
								),
								this.props.points && _react2.default.createElement(
									'span',
									{ className: 'case-single__meta-scorecard__number case-single__meta-scorecard__number--evolution' },
									(0, _date.formatNumber)(this.props.points)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-single__meta-scorecard__days case-single__meta-scorecard__days--evolution' },
								_react2.default.createElement(
									'h3',
									{ className: 'case-single__meta-scorecard__title' },
									'Days:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'case-single__meta-scorecard__number case-single__meta-scorecard__number--evolution' },
									this.props.days
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'evolution-graph span14 pixel-pattern' },
						_react2.default.createElement(
							'div',
							{ className: 'evolution-graph__left span2' },
							_react2.default.createElement(
								'div',
								{ className: 'evolution-graph__marker' },
								this.props.browser.window.width > 1200 && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_pixeltext2.default, { text: '100' }),
									_react2.default.createElement(_pixeltext2.default, { text: 'pts' })
								) || this.props.browser.window.width > 719 && _react2.default.createElement(_pixeltext2.default, { text: '100' }) || _react2.default.createElement(
									'span',
									null,
									'100'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'evolution-graph__marker fifty' },
								this.props.browser.window.width > 1200 && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_pixeltext2.default, { text: '50' }),
									_react2.default.createElement(_pixeltext2.default, { text: 'pts' })
								) || this.props.browser.window.width > 719 && _react2.default.createElement(_pixeltext2.default, { text: '50' }) || _react2.default.createElement(
									'span',
									null,
									'50'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'evolution-graph__marker null' },
								this.props.browser.window.width > 1200 && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_pixeltext2.default, { text: '00' }),
									_react2.default.createElement(_pixeltext2.default, { text: 'pts' })
								) || this.props.browser.window.width > 719 && _react2.default.createElement(_pixeltext2.default, { text: '00' }) || _react2.default.createElement(
									'span',
									null,
									'00'
								)
							)
						),
						this.renderEvolutions(this.props.evolution, this.props.awardDate, this.props.fotdText, this.props.hasFOTD)
					),
					_react2.default.createElement(
						'div',
						{ className: 'evolution-graph__labels span14' },
						_react2.default.createElement(
							'span',
							{ className: 'evolution-graph__labels__days hide-mobile' },
							'days'
						)
					)
				);
			}
		}, {
			key: 'renderEvolutions',
			value: function renderEvolutions(evolutions, awardDate, awardTitle, hasFOTD) {
				var _this2 = this;
	
				var height = 714;
				var width = 1079;
				var plusser = 50;
	
				if (this.props.browser.window.width < 1440) {
					width = 875;
				}
	
				if (this.props.browser.window.width < 1200) {
					width = 731;
					height = 304;
					plusser = 40;
				}
	
				if (this.props.browser.window.width < 1000) {
					width = 570;
				}
	
				if (this.props.browser.window.width < 720) {
					width = 431;
					height = 152;
					plusser = 13;
				}
	
				if (this.props.browser.window.width < 568) {
					width = 239;
				}
	
				var path = 'M0,' + height + ' L0,';
	
				var xmultiplier = width / (evolutions.length - 1);
	
				evolutions.map(function (evolution, i) {
					if (i == 0) {
						path += height - evolution.point * (height / 100) + plusser;
					} else if (i == evolutions.length - 1) {
						path += ' L' + width + ',' + (height - evolution.point * (height / 100) + plusser) + ' L' + width + ',' + height + ' Z';
					} else {
						path += ' L' + xmultiplier * i + ',' + (height - evolution.point * (height / 100) + plusser);
					}
				});
	
				return _react2.default.createElement(
					'svg',
					{ className: 'evolution-graph__grid span12' },
					_react2.default.createElement(
						'pattern',
						{ id: 'graphDots', patternUnits: 'userSpaceOnUse', width: 2, height: 2 },
						_react2.default.createElement('image', { width: _graphDots2.default.width, height: _graphDots2.default.height, xlinkHref: _graphDots2.default.src })
					),
					_react2.default.createElement(
						'pattern',
						{ id: 'graphTextDots', patternUnits: 'userSpaceOnUse', width: 2, height: 2 },
						_react2.default.createElement('image', { width: _graphTextDots2.default.width, height: _graphTextDots2.default.height, xlinkHref: _graphTextDots2.default.src })
					),
					_react2.default.createElement(
						'pattern',
						{ id: 'lineDots', patternUnits: 'userSpaceOnUse', width: 1, height: 2 },
						_react2.default.createElement('image', { width: _graphTextDots2.default.width, height: _graphTextDots2.default.height, xlinkHref: _graphTextDots2.default.src })
					),
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement('path', { className: 'evolution-graph__filler', d: path })
					),
					_react2.default.createElement(
						'g',
						null,
						evolutions.map(function (evolution, i) {
							return _this2.renderEvolution(evolution, i, evolutions.length, awardDate, awardTitle, hasFOTD);
						})
					)
				);
			}
		}, {
			key: 'renderEvolution',
			value: function renderEvolution(evolution, i, length, awardDate, awardTitle, hasFOTD) {
				var uid = evolution.uid || 'evolution' + i;
				var height = 714;
				var xmultiplier = 1079 / (length - 1);
				var days = i.toString();
				var labelDay = i.toString();
				var plusser = 50;
	
				if (labelDay < 10) {
					labelDay = labelDay.toString();
					labelDay = '0' + labelDay;
				}
	
				if (this.props.browser.window.width < 1440) {
					xmultiplier = 875 / (length - 1);
				}
	
				if (this.props.browser.window.width < 1200) {
					xmultiplier = 731 / (length - 1);
					height = 304;
					plusser = 40;
				}
	
				if (this.props.browser.window.width < 1000) {
					xmultiplier = 570 / (length - 1);
				}
	
				if (this.props.browser.window.width < 720) {
					xmultiplier = 431 / (length - 1);
					height = 152;
					plusser = 13;
				}
	
				if (this.props.browser.window.width < 568) {
					xmultiplier = 239 / (length - 1);
				}
	
				if (i < 10) {
					days = '0' + days;
				}
	
				return _react2.default.createElement(
					'g',
					{ key: uid },
					_react2.default.createElement(
						'pattern',
						{ id: 'middleDot', patternUnits: 'userSpaceOnUse', width: '8', height: '8' },
						_react2.default.createElement('rect', { width: '2', height: '2', fill: 'black', y: '50%', x: '50%' })
					),
					i == length - 1 && !hasFOTD && _react2.default.createElement(
						'g',
						{ className: 'evolution-graph__points--wrap', x: xmultiplier * i - 6, y: height - evolution.point * (height / 100) - 6 + plusser, width: '32', height: '32', rx: '4', ry: '4' },
						_react2.default.createElement('rect', { className: 'evolution-graph__hoverFill', x: xmultiplier * i - 16, y: height - evolution.point * (height / 100) - 16 + plusser, width: '32', height: '32' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points', x: xmultiplier * i - 6, y: height - evolution.point * (height / 100) - 6 + plusser, width: '12', height: '12', rx: '4', ry: '4' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points--middle', x: xmultiplier * i - 1, y: height - evolution.point * (height / 100) - 1 + plusser, width: '2', height: '2', rx: '3', ry: '3' })
					) || i == length - 1 && hasFOTD && _react2.default.createElement(
						'g',
						{ className: 'evolution-graph__points evolution-graph__points--wrap', x: xmultiplier * i - 6, y: height - evolution.point * (height / 100) - 6 + plusser, width: '32', height: '32', rx: '4', ry: '4' },
						_react2.default.createElement('rect', { className: 'evolution-graph__hoverFill', x: xmultiplier * i - 16, y: height - evolution.point * (height / 100) - 16 + plusser, width: '32', height: '32' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points evolution-graph__points--win', x: xmultiplier * i - 6, y: height - evolution.point * (height / 100) - 6 + plusser, width: '12', height: '12', rx: '4', ry: '4' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points--middle', x: xmultiplier * i - 1, y: height - evolution.point * (height / 100) - 1 + plusser, width: '2', height: '2', rx: '3', ry: '3' })
					) || _react2.default.createElement(
						'g',
						{ className: 'evolution-graph__points--wrap', x: xmultiplier * i - 4, y: height - evolution.point * (height / 100) - 4 + plusser },
						_react2.default.createElement('rect', { className: 'evolution-graph__hoverFill', x: xmultiplier * i - 16, y: height - evolution.point * (height / 100) - 16 + plusser, width: '32', height: '32' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points', x: xmultiplier * i - 4, y: height - evolution.point * (height / 100) - 4 + plusser, width: '8', height: '8', rx: '3', ry: '3' }),
						_react2.default.createElement('rect', { className: 'evolution-graph__points--middle', x: xmultiplier * i - 1, y: height - evolution.point * (height / 100) - 1 + plusser, width: '2', height: '2', rx: '3', ry: '3' })
					),
					_react2.default.createElement(
						'g',
						{ className: 'evolution-graph__label' },
						i == 0 && _react2.default.createElement(
							'text',
							{ className: 'evolution-graph__label__text hide-mobile', x: xmultiplier * i, y: height + 28 },
							labelDay
						) || i == length - 1 && _react2.default.createElement(
							'text',
							{ className: 'evolution-graph__label__text--last hide-mobile', x: xmultiplier * i - 9, y: height + 28 },
							labelDay
						) || _react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('line', { className: 'evolution-graph__label__line', x1: xmultiplier * i - 1, y1: height, x2: xmultiplier * i - 1, y2: height - 15 }),
							_react2.default.createElement('line', { className: 'evolution-graph__label__line hide-tablet hide-mobile', x1: xmultiplier * i - 1, y1: 0, x2: xmultiplier * i - 1, y2: 15 }),
							_react2.default.createElement(
								'text',
								{ className: 'evolution-graph__label__text hide-mobile', x: xmultiplier * i - 9, y: height + 28 },
								labelDay
							)
						)
					),
					i == length - 1 && !hasFOTD && this.props.browser.window.width < 1000 && _react2.default.createElement(
						'text',
						{ className: 'evolution-graph__current', x: xmultiplier * i - 60, y: height - evolution.point * (height / 100) - 27 + plusser },
						'current score'
					) || i == length - 1 && !hasFOTD && _react2.default.createElement(
						'text',
						{ className: 'evolution-graph__current', x: xmultiplier * i - 40, y: height - evolution.point * (height / 100) - 27 + plusser },
						'current score'
					) || null,
					i == length - 1 && hasFOTD && this.props.browser.window.width < 1000 && _react2.default.createElement(
						'text',
						{ className: 'evolution-graph__current', x: xmultiplier * i - 60, y: height - evolution.point * (height / 100) - 27 + plusser },
						awardTitle
					) || i == length - 1 && hasFOTD && _react2.default.createElement(
						'text',
						{ className: 'evolution-graph__current', x: xmultiplier * i - 40, y: height - evolution.point * (height / 100) - 27 + plusser },
						awardTitle
					) || null,
					i == length - 1 && hasFOTD && this.props.browser.window.width < 1000 && _react2.default.createElement(
						'g',
						{ className: 'evolution-graph__text-holder hide-mobile' },
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text', x: xmultiplier * i - 90, y: height - evolution.point * (height / 100) - 80 },
							evolution.point
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text--small', x: xmultiplier * i - 30, y: height - evolution.point * (height / 100) - 80 },
							'Pts'
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text', x: xmultiplier * i - 90, y: height - evolution.point * (height / 100) - 20 },
							days
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text--small', x: xmultiplier * i - 30, y: height - evolution.point * (height / 100) - 20 },
							'Days'
						)
					) || _react2.default.createElement(
						'g',
						{ className: 'evolution-graph__text-holder hide-mobile' },
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text', x: xmultiplier * i - 40, y: height - evolution.point * (height / 100) - 80 },
							evolution.point
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text--small', x: xmultiplier * i + 30, y: height - evolution.point * (height / 100) - 80 },
							'Pts'
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text', x: xmultiplier * i - 40, y: height - evolution.point * (height / 100) - 20 },
							days
						),
						_react2.default.createElement(
							'text',
							{ className: 'evolution-graph__text--small', x: xmultiplier * i + 30, y: height - evolution.point * (height / 100) - 20 },
							'Days'
						)
					)
				);
			}
		}]);
	
		return Evolution;
	}(_react.Component);
	
	Evolution.propTypes = {};
	exports.default = Evolution;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _footer = __webpack_require__(1002);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _fwaLogo = __webpack_require__(1082);
	
	var _fwaLogo2 = _interopRequireDefault(_fwaLogo);
	
	var _rackfish = __webpack_require__(1083);
	
	var _rackfish2 = _interopRequireDefault(_rackfish);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _routes = __webpack_require__(4);
	
	var _gaTrack = __webpack_require__(241);
	
	var _gaTrack2 = _interopRequireDefault(_gaTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './header.scss';
	
	var Footer = function (_Component) {
		_inherits(Footer, _Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Footer).call(this, props));
		}
	
		_createClass(Footer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				//menuActionCreator.updateStickyFooter();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var year = new Date();
				year = year.getFullYear();
	
				return _react2.default.createElement(
					'footer',
					{ className: 'footer-container span14' },
					_react2.default.createElement(
						'div',
						{ className: 'footer-container__column footer-container__column--no-border hide-mobile span2 span3-tablet' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: 'footer-container__column__logo', to: (0, _routes.genericRoute)(false, '', false) },
							_react2.default.createElement('img', { src: _fwaLogo2.default.src })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'footer-container__column__flex' },
						_react2.default.createElement(
							'div',
							{ className: 'footer-container__column span10 span8-tablet span7-mobile' },
							_react2.default.createElement(
								'ul',
								{ className: 'footer-container__menu' },
								this.props.footerItems.map(function (link, i) {
									return _this2.renderLink(link, i);
								})
							),
							_react2.default.createElement(
								'span',
								{ className: 'footer-container__notice hide-mobile' },
								'All rights reserved © 2000—',
								year,
								'  The FWA'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'footer-container__column span2 span3-tablet span7-mobile' },
							_react2.default.createElement(
								'a',
								{ href: 'http://www.rackfish.com/', target: '_blank', onClick: function onClick() {
										return (0, _gaTrack2.default)('event', 'ads', 'rackfish');
									}, className: 'footer-container__sponsor' },
								_react2.default.createElement('img', { src: _rackfish2.default.src })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'footer-container__column footer-container__column--big span14 hide-tablet hide-desktop' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: 'footer-container__column__logo', to: (0, _routes.genericRoute)(false, '', false) },
							_react2.default.createElement('img', { src: _fwaLogo2.default.src })
						),
						_react2.default.createElement(
							'span',
							{ className: 'footer-container__notice' },
							'All rights reserved © 2000—',
							year,
							'  The FWA'
						)
					)
				);
			}
		}, {
			key: 'renderLink',
			value: function renderLink(link, i) {
				return _react2.default.createElement(
					'li',
					{ className: 'footer-container__menu__link', key: 'footer-link-' + i },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.genericRoute)(link.slug) },
						link.name
					)
				);
			}
		}]);
	
		return Footer;
	}(_react.Component);
	
	Footer.propTypes = {};
	Footer.defaultProps = {
		footerItems: {}
	};
	exports.default = Footer;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(213);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dropzoneDisplay = __webpack_require__(237);
	
	var _dropzoneDisplay2 = _interopRequireDefault(_dropzoneDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputDropzoneGrid = function (_Component) {
		_inherits(InputDropzoneGrid, _Component);
	
		function InputDropzoneGrid() {
			_classCallCheck(this, InputDropzoneGrid);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(InputDropzoneGrid).apply(this, arguments));
		}
	
		_createClass(InputDropzoneGrid, [{
			key: 'render',
			value: function render() {
				var className = 'form-dropzone-grid pixel-pattern pixel-pattern--10';
				var inputs = this.props.inputs;
	
	
				if (inputs.length !== 3) {
					return false;
				}
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (!inputs.length) {
					return false;
				}
	
				// 487x280 >>         >> 290 x 167
				// 877x560 >> 522x326 >> 522 x 333
				//
				// aspect: ,624521073
	
				// multiplier: ,595210946
				//
				// 522 x 334
				// 290 x 167
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'div',
						{ className: 'form-dropzone-grid__container' },
						_react2.default.createElement(
							'div',
							{ className: 'form-dropzone-grid__lcol' },
							_react2.default.createElement(_dropzoneDisplay2.default, _extends({}, this.props, { key: inputs[0].name, name: inputs[0].name, preview: inputs[0].preview, aspect: inputs[0].aspect, recommended: inputs[0].recommended })),
							_react2.default.createElement(_dropzoneDisplay2.default, _extends({}, this.props, { key: inputs[1].name, name: inputs[1].name, preview: inputs[1].preview, aspect: inputs[1].aspect, recommended: inputs[1].recommended }))
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-dropzone-grid__rcol' },
							_react2.default.createElement(_dropzoneDisplay2.default, _extends({}, this.props, { key: inputs[2].name, name: inputs[2].name, preview: inputs[2].preview, aspect: inputs[2].aspect, recommended: inputs[2].recommended }))
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}]);
	
		return InputDropzoneGrid;
	}(_react.Component);
	
	InputDropzoneGrid.propTypes = {
		path: _react.PropTypes.string.isRequired,
		inputs: _react.PropTypes.array.isRequired,
		disableClick: _react.PropTypes.bool,
		multiple: _react.PropTypes.bool,
		accept: _react.PropTypes.string,
		recommended: _react.PropTypes.shape({
			width: _react.PropTypes.number.isRequired,
			height: _react.PropTypes.number.isRequired
		})
	};
	InputDropzoneGrid.defaultProps = {
		inputs: [],
		disableClick: false,
		multiple: false,
		accept: '',
		recommended: {
			width: 0,
			height: 0
		}
	};
	exports.default = InputDropzoneGrid;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(213);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _lodash = __webpack_require__(35);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dropzoneDisplay = __webpack_require__(237);
	
	var _dropzoneDisplay2 = _interopRequireDefault(_dropzoneDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REGEX_EXTRACT_YT_ID = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	var REGEX_EXTRACT_VIMEO_ID = /vimeo.*?([0-9]+$)/i;
	var REGEX_EXTRACT_VIMEO_PREVIEW = /<thumbnail_large>(.*?)<\/thumbnail_large>/i;
	
	var MODE_NEUTRAL = 'NEUTRAL';
	var MODE_IMAGE = 'IMAGE';
	var MODE_VIDEO_YOUTUBE = 'YOUTUBE';
	var MODE_VIDEO_VIMEO = 'VIMEO';
	
	var InputDropzoneVideo = function (_Component) {
		_inherits(InputDropzoneVideo, _Component);
	
		function InputDropzoneVideo(props) {
			_classCallCheck(this, InputDropzoneVideo);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InputDropzoneVideo).call(this));
	
			_this.mounted = true;
			var previewString = props.preview;
			var youtubeId = false;
			if (props.video && props.mode === MODE_VIDEO_YOUTUBE) {
				youtubeId = _this.getYoutubeID(props.video);
				previewString = _this.getYoutubePreview(youtubeId);
			}
	
			var vimeoId = false;
			if (props.video && props.mode === MODE_VIDEO_VIMEO) {
				vimeoId = _this.getVimeoID(props.video);
				previewString = _this.getVimeoPreview(vimeoId);
			}
	
			_this.state = {
				mode: props.mode === MODE_IMAGE || props.mode === MODE_VIDEO_YOUTUBE || props.mode === MODE_VIDEO_VIMEO ? props.mode : MODE_NEUTRAL,
				value: props.caption || '',
				captionValue: props.caption || '',
				preview: previewString,
				youtube: youtubeId,
				vimeo: vimeoId
			};
	
			_this.setValue(_this.state, props);
			return _this;
		}
	
		_createClass(InputDropzoneVideo, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = _extends({}, this.state);
	
				// console.log(!nextProps.mode);
				if (nextProps.mode === MODE_IMAGE || !nextProps.mode) {
					var preview = nextProps.preview;
					if (_typeof(nextProps.preview) === 'object') {
						var resolutions = Object.keys(nextProps.preview);
						var firstRes = nextProps.preview[resolutions[0]];
						if ((typeof firstRes === 'undefined' ? 'undefined' : _typeof(firstRes)) === 'object') {
							var spans = Object.keys(firstRes);
							var firstSpan = firstRes[spans[0]];
	
							if (firstSpan) {
								preview = firstSpan;
							}
						}
					}
					newState.preview = preview;
				}
	
				// if (this.props.name === 'visuals[3]') {
				// 	console.log('## UPDATE ##');
				// 	console.log(this.props.preview);
				// 	console.log(nextProps.preview);
				// 	console.log(newState.preview);
				// }
	
				if (nextProps.mode !== this.props.mode) {
					newState.mode = nextProps.mode === MODE_IMAGE || nextProps.mode === MODE_VIDEO_YOUTUBE || nextProps.mode === MODE_VIDEO_VIMEO ? nextProps.mode : MODE_NEUTRAL;
	
					if (nextProps.video) {
						if (nextProps.mode === MODE_VIDEO_YOUTUBE) {
							// console.log('YOUTUUUBE');
							var youtubeID = this.getYoutubeID(nextProps.video);
	
							newState = _extends({}, newState, {
								preview: this.getYoutubePreview(youtubeID),
								youtube: youtubeID
							});
						}
	
						if (nextProps.mode === MODE_VIDEO_VIMEO) {
							// console.log('VIIIIMEO');
							var vimeoID = this.getVimeoID(nextProps.video);
	
							newState = _extends({}, newState, {
								preview: this.getYoutubePreview(vimeoID),
								vimeo: vimeoID
							});
						}
	
						if (nextProps.mode === MODE_NEUTRAL) {
							newState.preview = '';
						}
					}
				}
	
				this.setValue(newState, nextProps);
				this.mounted && this.setState(newState);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'form-dropzone-video pixel-pattern pixel-pattern--10';
				var name = this.props.name;
	
				var aspect = false;
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				// 487x280 >>         >> 290 x 167
				// 877x560 >> 522x326 >> 522 x 333
				//
				// aspect: ,624521073
	
				// multiplier: ,595210946
				//
				// 522 x 334
				// 290 x 167
	
				//console.log(preview);
	
				var placeholder = '...';
				var captionClass = 'form-dropzone-video__input__caption';
				var inputAction = function inputAction() {};
	
				switch (this.state.mode) {
					case MODE_NEUTRAL:
						inputAction = this.setVideoInput.bind(this);
						break;
					case MODE_IMAGE:
						placeholder = 'Add image caption (optional)';
						inputAction = this.setElementCaption.bind(this);
						captionClass += ' ' + captionClass + '--active';
						break;
					case MODE_VIDEO_YOUTUBE:
						placeholder = 'Add video caption (optional)';
						inputAction = this.setElementCaption.bind(this);
						captionClass += ' ' + captionClass + '--active';
						aspect = 0.75;
						break;
					case MODE_VIDEO_VIMEO:
						placeholder = 'Add video caption (optional)';
						inputAction = this.setElementCaption.bind(this);
						captionClass += ' ' + captionClass + '--active';
						aspect = 0.5625;
						break;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'div',
						{ className: 'form-dropzone-video__container' },
						_react2.default.createElement(
							'div',
							{ className: 'form-dropzone-video__file' },
							_react2.default.createElement(_dropzoneDisplay2.default, _extends({ key: name }, this.props, { preview: this.state.preview, aspect: aspect || this.props.aspect, onClear: function onClear() {
									return _this2.onDropzoneClear();
								}, onUpload: function onUpload(res) {
									return _this2.onDropzoneUpload(res);
								}, params: this.props.params }))
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-dropzone-video__input' },
						_react2.default.createElement('input', { type: 'text', className: captionClass, value: this.state.captionValue, placeholder: placeholder, onChange: this.setElementCaption.bind(this) }),
						_react2.default.createElement('input', { type: 'text', className: 'form-dropzone-video__input__video', value: this.state.value, placeholder: 'Or add youtube or vimeo url', onChange: this.setVideoInput.bind(this) })
					)
				);
			}
		}, {
			key: 'onDropzoneClear',
			value: function onDropzoneClear() {
				this.setStateEnhanced(_extends({}, this.state, {
					mode: MODE_NEUTRAL,
					preview: '',
					youtube: false,
					vimeo: false,
					captionValue: '',
					value: ''
				}), this.props);
	
				var id = 0;
				if (this.props.extraValue) {
					id = this.props.extraValue.id || this.props.extraValue.fid;
				}
	
				this.props.changeId(id, '');
			}
		}, {
			key: 'onDropzoneUpload',
			value: function onDropzoneUpload(res) {
				// console.log('UPLOAD HAPPND');
				this.setStateEnhanced(_extends({}, this.state, {
					mode: MODE_IMAGE,
					youtube: false,
					vimeo: false,
					captionValue: '',
					value: ''
				}), this.props);
	
				if (res && res.data && res.data.sectionId) {
					var preview = '';
	
					if (res.data.path) {
						preview = res.data.path;
					}
	
					this.props.changeId(res.data.sectionId, preview);
				}
			}
		}, {
			key: 'setVideoInput',
			value: function setVideoInput(e) {
				var newValue = e.target.value;
				var youtubeID = this.getYoutubeID(newValue);
				var vimeoID = this.getVimeoID(newValue);
	
				var model = _extends({}, this.state, {
					value: newValue,
					preview: '',
					youtube: false,
					vimeo: false
				});
	
				if (youtubeID) {
					//console.log('## YOUTUBE VIDEO -- SET PREVIEW');
					this.setStateEnhanced(_extends({}, model, {
						mode: MODE_VIDEO_YOUTUBE,
						preview: this.getYoutubePreview(youtubeID),
						youtube: youtubeID
					}), this.props);
				} else if (vimeoID) {
					//console.log('## VIMEO VIDEO -- GETTING PREVIEW');
					this.getVimeoPreview(vimeoID, _extends({}, model, {
						mode: MODE_VIDEO_VIMEO,
						vimeo: vimeoID
					}));
				} else {
					this.setStateEnhanced(model, this.props);
				}
			}
		}, {
			key: 'setElementCaption',
			value: function setElementCaption(e) {
				this.setStateEnhanced(_extends({}, this.state, {
					captionValue: e.target.value
				}), this.props);
			}
		}, {
			key: 'getYoutubeID',
			value: function getYoutubeID(string) {
				var extracted = REGEX_EXTRACT_YT_ID.exec(string);
	
				if (extracted && extracted.length > 1) {
					return extracted[1];
				} else if (string.length >= 10 && string.length <= 12) {
					return string;
				}
	
				return false;
			}
		}, {
			key: 'getYoutubePreview',
			value: function getYoutubePreview(youtubeID) {
				if (!youtubeID) {
					return '';
				}
	
				var previewUrl = 'https://img.youtube.com/vi/' + youtubeID + '/hqdefault.jpg';
	
				return previewUrl;
			}
		}, {
			key: 'getVimeoID',
			value: function getVimeoID(string) {
				var extracted = REGEX_EXTRACT_VIMEO_ID.exec(string);
	
				if (extracted && extracted.length > 1) {
					return extracted[1];
				} else if (/^[0-9]*$/.exec(string)) {
					return string;
				}
	
				return false;
			}
		}, {
			key: 'getVimeoPreview',
			value: function getVimeoPreview(vimeoID) {
				var _this3 = this;
	
				var model = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				if (!vimeoID || vimeoID === '0') {
					return '';
				}
	
				var thumbnailDataUrl = 'https://vimeo.com/api/v2/video/' + vimeoID + '.xml';
	
				_axios2.default.get(thumbnailDataUrl).then(function (response) {
					var extracted = REGEX_EXTRACT_VIMEO_PREVIEW.exec(response.data);
					if (extracted && extracted.length > 0) {
						//console.log('## VIMEO VIDEO -- SETTING PREVIEW');
						_this3.setStateEnhanced(_extends({}, _this3.state, model, {
							preview: extracted[1]
						}), _this3.props);
					} else {
						//console.log('## VIMEO VIDEO -- NO PREVIEW');
						_this3.vimeoFail(model);
					}
				}).catch(function (response) {
					//console.log('## VIMEO VIDEO -- FAIL PREVIEW');
					_this3.vimeoFail(model);
				});
			}
		}, {
			key: 'vimeoFail',
			value: function vimeoFail(model) {
				this.setStateEnhanced(_extends({}, model, {
					preview: ''
				}), this.props);
			}
		}, {
			key: 'setStateEnhanced',
			value: function setStateEnhanced(state, props) {
				this.mounted && this.setState(state);
				this.setValue(state, props);
			}
		}, {
			key: 'setValue',
			value: function setValue(state, props) {
				// console.log(props.extraValue);
				// console.log('SET VALUE ####');
				// console.log(props.extraValue);
				this.value = _extends({}, (0, _lodash.pick)(props.extraValue, 'id'), {
					type: state.mode,
					caption: state.captionValue,
					youtube: state.youtube ? state.youtube : 0,
					vimeo: state.vimeo ? state.vimeo : 0
				});
			}
		}]);
	
		return InputDropzoneVideo;
	}(_react.Component);
	
	InputDropzoneVideo.propTypes = {
		path: _react.PropTypes.string.isRequired,
		disableClick: _react.PropTypes.bool,
		multiple: _react.PropTypes.bool,
		accept: _react.PropTypes.string,
		mode: _react.PropTypes.string,
		name: _react.PropTypes.string.isRequired,
		preview: _react.PropTypes.oneOfType([_react.PropTypes.oneOf([false]), _react.PropTypes.string, _react.PropTypes.object]).isRequired,
		caption: _react.PropTypes.string,
		extraValue: _react.PropTypes.object,
		changeId: _react.PropTypes.func,
		params: _react.PropTypes.object
	};
	InputDropzoneVideo.defaultProps = {
		disableClick: false,
		multiple: false,
		accept: '',
		preview: '',
		name: '',
		caption: '',
		mode: '',
		changeId: function changeId() {},
		extraValue: {},
		params: {}
	};
	exports.default = InputDropzoneVideo;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _confirm = __webpack_require__(448);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromptDialog = function (_Component) {
		_inherits(PromptDialog, _Component);
	
		function PromptDialog(props) {
			_classCallCheck(this, PromptDialog);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PromptDialog).call(this));
	
			_this.promiseResolve = function () {};
			_this.promiseReject = function () {};
	
			_this.newPromise();
			_this._handleEscKey = _this._handleEscKey.bind(_this);
	
			_this.state = {
				show: false,
				text: 'Are you sure?',
				placeholder: '',
				validate: [],
				value: ''
			};
			return _this;
		}
	
		_createClass(PromptDialog, [{
			key: 'render',
			value: function render() {
				var className = 'confirm-dialog';
	
				if (this.state.show) {
					className += ' confirm-dialog--show';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className, onClick: this.handleCancel.bind(this) },
					_react2.default.createElement(
						'div',
						{ className: 'confirm-dialog__dialog', onClick: function onClick(e) {
								return e.stopPropagation();
							} },
						_react2.default.createElement(
							'div',
							{ className: 'confirm-dialog__dialog__content' },
							_react2.default.createElement(
								'div',
								null,
								this.state.text
							),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(_text2.default, { tabIndex: this.state.show ? 0 : -1, type: 'text', name: 'text', ref: 'input', placeholder: this.state.placeholder, validate: this.state.validate, onInput: this.onTextInput.bind(this), value: this.state.value })
						),
						_react2.default.createElement(
							'div',
							{ className: 'confirm-dialog__dialog__actions' },
							_react2.default.createElement(
								'button',
								{ tabIndex: this.state.show ? 0 : -1, onClick: this.handleOK.bind(this), ref: 'confirm' },
								'Confirm'
							),
							_react2.default.createElement(
								'button',
								{ tabIndex: this.state.show ? 0 : -1, onClick: this.handleCancel.bind(this), className: 'button--dark' },
								'Cancel'
							)
						)
					)
				);
			}
		}, {
			key: 'onTextInput',
			value: function onTextInput(e) {
				this.setState(_extends({}, this.state, {
					value: e.target.value
				}));
			}
		}, {
			key: 'handleOK',
			value: function handleOK(e) {
				e.preventDefault();
	
				if (this.refs.input.testValidity()) {
					this.promiseResolve(this.state.value);
					this.setState(_extends({}, this.state, {
						show: false,
						value: ''
					}));
				} else {
					console.log('invalid');
				}
			}
		}, {
			key: 'handleCancel',
			value: function handleCancel(e) {
				e.preventDefault();
				this.promiseReject();
				this.setState(_extends({}, this.state, {
					show: false,
					value: ''
				}));
			}
		}, {
			key: 'newPromise',
			value: function newPromise() {
				var _this2 = this;
	
				this.promise = new Promise(function (resolve, reject) {
					_this2.promiseResolve = resolve;
					_this2.promiseReject = reject;
				});
			}
		}, {
			key: 'prompt',
			value: function prompt(text) {
				var placeholder = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
				var _this3 = this;
	
				var validate = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
				var value = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
	
				this.newPromise();
				this.setState(_extends({}, this.state, {
					show: true,
					text: text,
					value: value,
					placeholder: placeholder,
					validate: validate
				}));
				this.refs.confirm && this.refs.confirm.focus();
	
				document.addEventListener('keydown', this._handleEscKey, false);
	
				this.promise.then(function () {
					document.removeEventListener('keydown', _this3._handleEscKey, false);
				}).catch(function () {
					document.removeEventListener('keydown', _this3._handleEscKey, false);
				});
	
				return this.promise;
			}
		}, {
			key: '_handleEscKey',
			value: function _handleEscKey(e) {
				if (e.keyCode === 27) {
					this.handleCancel(e);
				}
			}
		}]);
	
		return PromptDialog;
	}(_react.Component);
	
	PromptDialog.propTypes = {
		text: _react.PropTypes.string
	};
	PromptDialog.defaultProps = {
		text: 'Enter value:'
	};
	exports.default = PromptDialog;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _map = __webpack_require__(1200);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _multiselect = __webpack_require__(1009);
	
	var _multiselect2 = _interopRequireDefault(_multiselect);
	
	var _states = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiSelect = function (_Component) {
		_inherits(MultiSelect, _Component);
	
		function MultiSelect(props) {
			_classCallCheck(this, MultiSelect);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiSelect).call(this, props));
	
			_this.state = {
				isActive: false,
				groupShow: _this.constructGroups(props.options),
				groupState: _this.constructGroups(props.options),
				options: props.options,
				showMoreGroups: false
			};
	
			_this.state.value = _this.constructOptions(props.options, _this.state), _this.state.internalOptions = _this.constructOptions(props.options, _this.state);
			_this.state.status = _this.getCurrentStatus(_this.state);
			return _this;
		}
	
		_createClass(MultiSelect, [{
			key: 'constructGroups',
			value: function constructGroups(options) {
				var groups = {};
	
				options.map(function (item, i) {
					groups[item.name] = i > 1;
				});
	
				return groups;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps) {
				var _this2 = this;
	
				// if options changed we update the internal representation - and discard any old selection
				if (!(0, _deepEqual2.default)(nProps.options, this.props.options)) {
					(function () {
						var newState = _extends({}, _this2.state, {
							options: nProps.options,
							groupShow: _this2.constructGroups(nProps.options),
							groupState: _this2.constructGroups(nProps.options)
						});
	
						newState.internalOptions = _this2.constructOptions(nProps.options, newState);
	
						var defaultFilterState = nProps.defaultFilterState;
	
						if (defaultFilterState) {
							(0, _forEach2.default)(newState.internalOptions, function (filter, filterName) {
								if (newState.internalOptions[filterName]) {
									(0, _forEach2.default)(newState.internalOptions[filterName], function (value, key) {
										if (defaultFilterState[filterName] && typeof defaultFilterState[filterName][key] !== 'undefined') {
											newState.internalOptions[filterName][key] = defaultFilterState[filterName][key];
											if (defaultFilterState[filterName][key]) {
												newState.showMoreGroups = true;
											}
										}
									});
								}
							});
						}
	
						_this2.setState(newState);
					})();
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'render',
			value: function render() {
				var className = 'multiselect';
				var dropdownClass = 'multiselect__options';
	
				if (this.props.className) {
					className += ' ' + this.props.className;
				}
	
				if (this.props.allowToggleAll) {
					className += ' multiselect--toggleall';
				}
	
				if (this.state.isActive) {
					className += ' multiselect--active';
					dropdownClass += ' multiselect__options--active';
				}
	
				if (this.props.dropdownClass) {
					dropdownClass += ' ' + this.props.dropdownClass;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					this.renderSelected(),
					this.state.isActive && _react2.default.createElement('div', { className: 'multiselect__closer', onClick: this.close.bind(this) }),
					_react2.default.createElement(
						'div',
						{ className: dropdownClass },
						this.props.showSpinner && _react2.default.createElement(_spinner2.default, { className: 'multiselect__spinner' }),
						this.state.options.map(this.renderOption.bind(this))
					)
				);
			}
		}, {
			key: 'renderSelected',
			value: function renderSelected() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'multiselect__activator', onClick: function onClick() {
							_this3.toggleDropdown();
						} },
					this.state.label || this.props.placeholder
				);
			}
		}, {
			key: 'renderOption',
			value: function renderOption(opt, i) {
				var _this4 = this;
	
				var className = 'multiselect__option';
				var isCollection = opt.value && typeof opt.value.map === 'function';
				var _options = this.state.internalOptions;
	
				if (opt.disabled) {
					className += ' multiselect__option--disabled';
				}
	
				if (opt.reset) {
					className += ' multiselect__option--reset';
				}
	
				if (typeof _options[opt.name] !== 'undefined' && typeof _options[opt.name][opt.value] !== 'undefined' && _options[opt.name][opt.value] || opt.reset && this.state.status === _states.STATE_ALL_ON) {
					className += ' multiselect__option--selected';
				}
	
				if (isCollection) {
					// console.log(opt);
	
					var groupClass = 'multiselect__group multiselect__group' + i;
					var groupHeadClass = 'multiselect__group__head';
	
					if (this.state.groupShow[opt.name]) {
						groupClass += ' multiselect__group--active';
						groupHeadClass += ' multiselect__group__head--selected';
					}
	
					if (this.state.showMoreGroups) {
						groupClass += ' multiselect__group--showmore';
					}
	
					return _react2.default.createElement(
						'div',
						{ key: i, className: groupClass },
						_react2.default.createElement(
							'div',
							{ className: groupHeadClass, onClick: function onClick() {
									return _this4.toggleGroupCollapse(opt);
								} },
							_react2.default.createElement(_checkbox2.default, { name: 'toggleGroup', className: 'multiselect__group__head__checkbox', onChange: function onChange(val) {
									return _this4.toggleGroupItems(val, opt);
								}, value: this.state.groupState[opt.name] }),
							opt.label
						),
						_react2.default.createElement(
							'div',
							{ className: 'multiselect__group__items' },
							opt.value.map(this.renderOption.bind(this))
						)
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ key: i, className: className, onClick: function onClick() {
							!opt.disabled && _this4.selectOption(opt);
						} },
					opt.label
				);
			}
		}, {
			key: 'toggleGroupItems',
			value: function toggleGroupItems(val, opt) {
				if (this.state.internalOptions[opt.name]) {
					var intOptions = _extends({}, this.state.internalOptions);
					var keys = Object.keys(intOptions[opt.name]);
	
					for (var i = 0; i < keys.length; i++) {
						intOptions[opt.name][keys[i]] = !!val;
					}
					var newState = _extends({}, this.state, {
						internalOptions: intOptions
					});
	
					newState.showMoreGroups = this.getShowMoreStatus(newState);
					newState.internalOptions = this.fixCaseTypeStates(newState);
					newState.groupState = this.getGroupStatus(newState);
	
					this.setState(newState);
					this.onChange();
				}
			}
		}, {
			key: 'toggleGroupCollapse',
			value: function toggleGroupCollapse(opt) {
				var newState = _extends({}, this.state, {
					groupShow: _extends({}, this.state.groupShow)
				});
	
				newState.groupShow[opt.name] = !newState.groupShow[opt.name];
	
				this.setState(newState);
			}
		}, {
			key: 'constructOptions',
			value: function constructOptions(options, state) {
				var _this5 = this;
	
				if (typeof options.reduce === 'function' && options.length) {
					var _ret2 = function () {
						var processItem = function processItem(item, oldResult) {
							var newResult = _extends({}, oldResult);
	
							if (item.label) {
								if (item.value && typeof item.value.reduce === 'function') {
									// value is array
									newResult[item.name] = _extends({}, _this5.constructOptions(item.value, state));
								} else {
									newResult[item.value] = typeof state.groupShow[item.name] !== 'undefined' ? state.groupShow[item.name] : _this5.props.defaultState;
								}
							}
	
							return newResult;
						};
	
						var structuredOptions = options.reduce(function (previousResult, currentItem, currentIndex, init) {
							var result = void 0;
	
							if (currentIndex === 1) {
								result = processItem(previousResult, result);
							} else {
								result = previousResult;
							}
	
							result = processItem(currentItem, result);
	
							// console.log(result);
							return result;
						});
	
						return {
							v: structuredOptions
						};
					}();
	
					if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
				}
	
				// console.log({});
				return {};
			}
		}, {
			key: 'addToggleAll',
			value: function addToggleAll(props) {
				if (props.allowToggleAll) {
					return [{
						reset: true,
						label: 'Show Everything',
						value: 'toggleAll'
					}].concat(_toConsumableArray(props.options));
				}
	
				return [].concat(_toConsumableArray(props.options));
			}
		}, {
			key: 'close',
			value: function close() {
				this.state.isActive = false;
				this.setState(this.state);
			}
		}, {
			key: 'toggleDropdown',
			value: function toggleDropdown() {
				this.state.isActive = !this.state.isActive;
				this.setState(this.state);
			}
		}, {
			key: 'selectOption',
			value: function selectOption(opt) {
				if (opt.reset) {
					this.toggleAllOptions();
				} else {
					//select normally
					this.toggleValue(opt.name, opt.value);
				}
	
				//this.close();
			}
		}, {
			key: 'toggleAllOptions',
			value: function toggleAllOptions() {
				var setTo = null;
	
				switch (this.state.status) {
					case _states.STATE_ALL_ON:
						setTo = false;
						//return false;
						this.state.status = _states.STATE_ALL_OFF;
						break;
					case _states.STATE_ALL_OFF:
					case _states.STATE_UNDETERMINED:
						setTo = true;
						this.state.status = _states.STATE_ALL_ON;
						break;
					default:
						setTo = this.props.defaultState;
						this.state.status = this.props.defaultState ? _states.STATE_ALL_ON : _states.STATE_ALL_OFF;
				}
	
				var keys = Object.keys(this.state.internalOptions);
				var newState = _extends({}, this.state, {
					internalOptions: _extends({}, this.state.internalOptions)
				});
				for (var i = 0; i < keys.length; i++) {
					var newKey = Object.keys(newState.internalOptions[keys[i]]);
					for (var k = 0; k < newKey.length; k++) {
						newState.internalOptions[keys[i]][newKey[k]] = setTo;
					}
				}
	
				this.setState(newState);
				this.onChange();
	
				//console.log(this.state.internalOptions);
				//console.log(JSON.stringify({...this.state.internalOptions}));
			}
		}, {
			key: 'getCurrentStatus',
			value: function getCurrentStatus(state) {
				var keys = Object.keys(state.internalOptions);
				var prevVal = void 0;
				for (var i = 0; i < keys.length; i++) {
					var newKey = Object.keys(state.internalOptions[keys[i]]);
					for (var k = 0; k < newKey.length; k++) {
						if (prevVal !== undefined && prevVal !== state.internalOptions[keys[i]][newKey[k]]) {
							return _states.STATE_UNDETERMINED;
						}
	
						prevVal = state.internalOptions[keys[i]][newKey[k]];
					}
				}
	
				return prevVal ? _states.STATE_ALL_ON : _states.STATE_ALL_OFF;
			}
		}, {
			key: 'toggleValue',
			value: function toggleValue(groupName, value) {
				var _this6 = this;
	
				if (groupName && value && typeof this.state.internalOptions[groupName] !== 'undefined' && typeof this.state.internalOptions[groupName][value] !== 'undefined') {
					var _ret3 = function () {
	
						var newState = _extends({}, _this6.state, {
							internalOptions: _extends({}, _this6.state.internalOptions)
						});
	
						if (value === 'top100') {
							(0, _forEach2.default)(_this6.state.internalOptions[groupName], function (groupItemValue, groupItemKey) {
								if (groupItemKey !== 'top100') {
									newState.internalOptions[groupName][groupItemKey] = false;
								}
							});
						}
	
						newState.internalOptions[groupName][value] = !_this6.state.internalOptions[groupName][value];
	
						// console.log(`options[${groupName}][${value}] = ${this.state.internalOptions[groupName][value]}`);
	
						// check toggle all status
						newState.status = _this6.getCurrentStatus(newState);
	
						newState.showMoreGroups = _this6.getShowMoreStatus(newState);
						newState.internalOptions = _this6.fixCaseTypeStates(newState);
	
						// check group status
						newState.groupState = _this6.getGroupStatus(newState);
	
						_this6.setState(newState);
						_this6.onChange();
	
						return {
							v: true
						};
					}();
	
					if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
				}
	
				return false;
			}
		}, {
			key: 'fixCaseTypeStates',
			value: function fixCaseTypeStates(state) {
				var internalOptions = _extends({}, state.internalOptions);
	
				if (this.state.showMoreGroups !== state.showMoreGroups) {
					var groupName = 'caseTypes';
					var keys = Object.keys(internalOptions[groupName]);
	
					for (var i = 0; i < keys.length; i++) {
						// console.log(groupName, keys[i]);
						internalOptions[groupName][keys[i]] = true;
					}
				}
	
				return internalOptions;
			}
		}, {
			key: 'getShowMoreStatus',
			value: function getShowMoreStatus(state) {
				var groupName = 'awards';
				var STATUS = false;
				if (state.internalOptions[groupName]) {
					var keys = Object.keys(state.internalOptions[groupName]);
	
					for (var i = 0; i < keys.length; i++) {
						if (state.internalOptions[groupName][keys[i]]) {
							// if any awards are checked.. show more == true
							STATUS = true;
						}
					}
				}
	
				return STATUS;
			}
		}, {
			key: 'getGroupStatus',
			value: function getGroupStatus(state) {
				var groupState = _extends({}, state.groupState);
	
				var groups = Object.keys(state.internalOptions);
				for (var k = 0; k < groups.length; k++) {
					var groupName = groups[k];
					var STATUS = true;
	
					if (state.internalOptions[groupName]) {
						var keys = Object.keys(state.internalOptions[groupName]);
	
						for (var i = 0; i < keys.length; i++) {
							if (!state.internalOptions[groupName][keys[i]]) {
								STATUS = false;
							}
						}
					}
	
					groupState[groupName] = STATUS;
				}
	
				// console.log(groupState);
	
				return groupState;
			}
		}, {
			key: 'onChange',
			value: function onChange() {
				if (typeof this.props.onChange === 'function') {
					return this.props.onChange(this.value());
				}
			}
		}, {
			key: 'value',
			value: function value() {
				// deepClone using JSON stringify->parse
				var clone = JSON.parse(JSON.stringify(this.state.internalOptions));
				return clone;
			}
		}]);
	
		return MultiSelect;
	}(_react.Component);
	
	MultiSelect.propTypes = {
		options: _react.PropTypes.array,
		defaultFilterState: _react.PropTypes.shape({}),
		placeholder: _react.PropTypes.string,
		className: _react.PropTypes.string,
		defaultState: _react.PropTypes.bool,
		allowToggleAll: _react.PropTypes.bool,
		onChange: _react.PropTypes.func,
		showSpinner: _react.PropTypes.bool
	};
	MultiSelect.defaultProps = {
		options: [],
		placeholder: 'multiselect...',
		className: '',
		defaultState: false,
		allowToggleAll: true,
		onChange: function onChange() {},
		showSpinner: true
	};
	exports.default = MultiSelect;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _popup = __webpack_require__(1013);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrontpageOnboarding = function (_Component) {
		_inherits(FrontpageOnboarding, _Component);
	
		function FrontpageOnboarding(props) {
			_classCallCheck(this, FrontpageOnboarding);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FrontpageOnboarding).call(this));
	
			_this.handleLinkClick = function (e) {
				// if click on the DIV (not A!)
				if (e.target.classList.contains('timeline-hero__meta-more__button')) {
					// find the anchor, and click it
					e.target.querySelector('a').click();
					_this.toggle(_this.state.show);
				} else {
					_this.toggle(_this.state.show);
				}
			};
	
			_this.toggleCheckBox = function () {
				_this.setState({ checked: !_this.state.checked });
			};
	
			_this.state = {
				show: false,
				checked: false
			};
			return _this;
		}
	
		_createClass(FrontpageOnboarding, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.get('/api/popup/open').then(function (res) {
					if (res.data.show) {
						document.body.classList.add('body--context-menu');
					}
					return _this2.setState(_extends({}, res.data));
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.body.classList.remove('body--context-menu');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var onboardClass = 'popup';
				if (this.state.show) {
					onboardClass += ' popup--active';
					// document.body.classList.add('body--context-menu');
				} else {
					document.body.classList.remove('body--context-menu');
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: onboardClass, onClick: function onClick(e) {
							_this3.toggle(_this3.state.show);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'popup__content span10', onClick: function onClick(e) {
								e.stopPropagation();
							} },
						_react2.default.createElement(
							'a',
							{
								className: 'popup__content__close',
								onClick: function onClick(e) {
									e.preventDefault();
									_this3.toggle(_this3.state.show);
								}
							},
							''
						),
						_react2.default.createElement(
							'div',
							{ className: 'popup__content__checkbox__wrapper' },
							_react2.default.createElement(
								_checkbox2.default,
								{ name: 'closepopup', label: 'Hide this notice', onChange: this.toggleCheckBox },
								'Hide this notice'
							)
						),
						_react2.default.createElement('div', { className: 'popup__content__controls' }),
						_react2.default.createElement(
							'div',
							{ className: 'popup__frontpage__wrapper' },
							_react2.default.createElement(
								'h3',
								{ className: 'popup__content__title' },
								this.state.title
							),
							this.state.body && _react2.default.createElement('p', { className: 'popup__content__text', dangerouslySetInnerHTML: { __html: this.state.body } }),
							this.state.link && _react2.default.createElement('div', {
								onClick: this.handleLinkClick,
								className: 'timeline-hero__meta-more__button button--go button--dark button popup__button',
								dangerouslySetInnerHTML: { __html: this.state.link }
							})
						)
					)
				);
			}
		}, {
			key: 'toggle',
			value: function toggle() {
				var checked = this.state.checked;
	
				var formData = new FormData();
				formData.append('closepopup', +checked);
				_axios2.default.post('/api/popup/close', formData).catch(function (err) {
					alert('something went wrong, check your internet connection');
				});
				var show = this.state.show;
	
				this.setState({
					show: !show
				});
			}
		}]);
	
		return FrontpageOnboarding;
	}(_react.Component);
	
	exports.default = FrontpageOnboarding;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _menu = __webpack_require__(629);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _jobList = __webpack_require__(628);
	
	var _jobList2 = _interopRequireDefault(_jobList);
	
	var _slider = __webpack_require__(633);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _globalNav = __webpack_require__(1014);
	
	var _globalNav2 = _interopRequireDefault(_globalNav);
	
	var _lorem = __webpack_require__(379);
	
	var _lorem2 = _interopRequireDefault(_lorem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GlobalNav = function (_Component) {
		_inherits(GlobalNav, _Component);
	
		function GlobalNav() {
			_classCallCheck(this, GlobalNav);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(GlobalNav).apply(this, arguments));
		}
	
		_createClass(GlobalNav, [{
			key: 'render',
			value: function render() {
				var selMenu = this.props.selectedMenu;
				var slideContext = selMenu && typeof selMenu.type === 'string' ? selMenu.type : '';
	
				return _react2.default.createElement(
					'nav',
					{ className: this.hiddenClass() },
					_react2.default.createElement(
						'div',
						{ className: 'app-container--width globalnav__container' },
						_react2.default.createElement(
							'div',
							{ className: 'globalnav-menu' },
							_react2.default.createElement(_menu2.default, this.props)
						),
						_react2.default.createElement(
							'div',
							{ className: 'globalnav-sidebar' },
							_react2.default.createElement(
								'div',
								{ className: 'globalnav-sidebar__jobs' },
								_react2.default.createElement(_jobList2.default, { dispatch: this.props.dispatch })
							),
							_react2.default.createElement(
								'div',
								{ className: 'globalnav-sidebar__context' },
								_react2.default.createElement(_slider2.default, _extends({ browser: this.props.browser }, this.props, { context: slideContext, menuActive: this.props.menuActive }))
							)
						)
					)
				);
			}
		}, {
			key: 'isMenuActive',
			value: function isMenuActive() {
				return this.props.menuActive;
			}
		}, {
			key: 'hiddenClass',
			value: function hiddenClass() {
				return this.isMenuActive() ? 'globalnav' : 'globalnav globalnav--hide';
			}
		}]);
	
		return GlobalNav;
	}(_react.Component);
	
	GlobalNav.propTypes = {
		menuActive: _react.PropTypes.bool.isRequired,
		mainMenu: _react.PropTypes.object.isRequired,
		subMenu: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		selectedMenu: _react.PropTypes.object,
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = GlobalNav;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _jobList = __webpack_require__(1015);
	
	var _jobList2 = _interopRequireDefault(_jobList);
	
	var _cornerLabel = __webpack_require__(177);
	
	var _cornerLabel2 = _interopRequireDefault(_cornerLabel);
	
	var _postVacancy = __webpack_require__(642);
	
	var _postVacancy2 = _interopRequireDefault(_postVacancy);
	
	var _listing = __webpack_require__(641);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _index = __webpack_require__(4);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var url = _baseUrl2.default + '/api/jobs?offset=0&limit=3';
	
	var GlobalNavJobList = function (_Component) {
		_inherits(GlobalNavJobList, _Component);
	
		function GlobalNavJobList(props) {
			_classCallCheck(this, GlobalNavJobList);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GlobalNavJobList).call(this));
	
			_this.state = {
				jobs: []
			};
			return _this;
		}
	
		_createClass(GlobalNavJobList, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.get(url).then(function (response) {
					var _jobs = [];
	
					(0, _forEach2.default)(response.data.jobs, function (job) {
						var local = {
							id: job.id,
							title: job.title,
							profileName: job.profiles ? job.profiles.name : '',
							postedDate: job.createdDate,
							slug: job.slug,
							location: job.city + ', ' + job.country
						};
	
						_jobs.push(local);
					});
	
					_this2.setState(_extends({}, _this2.state, {
						jobs: _jobs
					}));
				}).catch(function (response) {
					console.log('fetching global nav jobs error');
					console.log(response);
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				//console.log(jobs);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'globalnav__joblist' },
					_react2.default.createElement(
						'div',
						{ className: 'globalnav__joblist__head' },
						_react2.default.createElement(_cornerLabel2.default, { name: 'Jobs' }),
						_react2.default.createElement(_postVacancy2.default, { dispatch: this.props.dispatch })
					),
					_react2.default.createElement(
						'ul',
						{ className: 'globalnav__joblist__list' },
						this.state.jobs.map(function (job) {
							if (!job.id) {
								return false;
							}
	
							return _react2.default.createElement(
								'li',
								{ key: job.id },
								_react2.default.createElement(_listing2.default, { job: job, listStyle: 1, className: '', dispatch: _this3.props.dispatch })
							);
						})
					)
				);
			}
		}]);
	
		return GlobalNavJobList;
	}(_react.Component);
	
	GlobalNavJobList.propTypes = {};
	exports.default = GlobalNavJobList;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _menu = __webpack_require__(1016);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _lorem = __webpack_require__(379);
	
	var _lorem2 = _interopRequireDefault(_lorem);
	
	var _profile = __webpack_require__(630);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _routes = __webpack_require__(4);
	
	var _types = __webpack_require__(88);
	
	var MenuType = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GlobalNavMenu = function (_Component) {
		_inherits(GlobalNavMenu, _Component);
	
		function GlobalNavMenu(props) {
			_classCallCheck(this, GlobalNavMenu);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(GlobalNavMenu).call(this, props));
		}
	
		_createClass(GlobalNavMenu, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.state = {
					sideMenuHeight: 0,
					activeMenuTop: 0,
					headerHeight: 60
				};
	
				this.setState(this.state);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var sideMenu = this.refs.sidemenu;
	
				if (sideMenu) {
					var height = sideMenu.getBoundingClientRect().height;
					var header = document.querySelector('header.header-main');
	
					if (this.state.sideMenuHeight !== height) {
						if (header) {
							this.state.headerHeight = header.getBoundingClientRect().height;
						}
	
						this.state.sideMenuHeight = height;
						this.setState(this.state);
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var menulistClass = 'mainmenu__nav__menu-link-list';
				var profileBoxClass = 'mainmenu__nav__bottom span5 span10-tablet span14-mobile';
	
				if (this.isMenuLinkActive()) {
					menulistClass += ' mainmenu__nav__menu-link-list--active';
					profileBoxClass += ' mainmenu__nav__bottom--fade';
				}
	
				var flexerClass = 'mainmenu-flexer';
				if (this.props.selectedMenu) {
					flexerClass += ' ' + flexerClass + '--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'mainmenu-container' },
					_react2.default.createElement(
						'div',
						{ className: flexerClass },
						_react2.default.createElement(
							'div',
							{ className: 'mainmenu__nav' },
							_react2.default.createElement(
								'div',
								{ className: 'push2 push1-tablet mainmenu__nav__top' },
								_react2.default.createElement(
									'ul',
									{ className: menulistClass },
									this.buildMenu(this.props.mainMenu, true)
								),
								_react2.default.createElement(
									'ul',
									{ className: 'mainmenu__nav__social-link-list' },
									this.buildMenu(this.props.socialLinks, false)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: profileBoxClass },
								_react2.default.createElement(
									'div',
									{ className: 'push2 push1-tablet' },
									_react2.default.createElement(_profile2.default, _extends({}, this.props.userActions, this.props.menuActions, { user: this.props.user, dispatch: this.props.dispatch, menuActive: this.props.menuActive }))
								)
							)
						)
					)
				);
			}
		}, {
			key: 'toggleMenu',
			value: function toggleMenu() {
				this.props.menuActions.toggleMenu();
			}
		}, {
			key: 'isMenuLinkActive',
			value: function isMenuLinkActive() {
				if (this.props.selectedMenu) {
					var mmItems = this.props.mainMenu.items;
					for (var i = 0; i < mmItems.length; i++) {
						if (this.props.selectedMenu === mmItems[i]) {
							return true;
						}
					}
				}
	
				return false;
			}
		}, {
			key: 'buildMenu',
			value: function buildMenu(menu, hasSubmenu) {
				var _this2 = this;
	
				var parent = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
				//if (parent) {
				//	menu = {...menu};
				//	parent.appendClass = 'category-header';
				//	menu.items.unshift(parent);
				//}
	
				if (menu && menu.items && menu.items.length > 0) {
					return menu.items.map(function (link, i) {
						if (!link.name || link.name.length === 0) {
							return false;
						}
						return _this2.renderMenuLink(link, i, hasSubmenu && link.items && link.items.length > 0, hasSubmenu, parent);
					});
				}
			}
		}, {
			key: 'renderMenuLink',
			value: function renderMenuLink(link, i, isCollection, hasSubmenu, parent) {
				var _this3 = this;
	
				var isHttpLink = /(http|https)/.test(link.url);
				var liClass = this.props.selectedMenu === link ? 'is-active' : '';
				liClass += isCollection ? ' collection' : '';
	
				var linkString = '' + link.name;
	
				if (typeof link.appendClass === 'string') {
					liClass += ' ' + link.appendClass;
				}
	
				var url = link.slug;
				if (parent && parent.slug && link.type === 'templates') {
					url = parent.slug + '/' + url;
				}
	
				if (link.type === 'external') {
					return _react2.default.createElement(
						'li',
						{ key: link.id + i, className: liClass },
						_react2.default.createElement(
							'a',
							{ href: link.url, title: link.title || '' },
							link.name,
							_react2.default.createElement('span', null)
						)
					);
				} else {
					return _react2.default.createElement(
						'li',
						{ key: link.slug + i, className: liClass },
						(!link.items && !isHttpLink || link.type !== MenuType.TYPE_NONE && link.type !== MenuType.TYPE_CONTAINER && link.type !== MenuType.TYPE_EDITORIAL_LIST) && _react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.generateURL)(link.type, url), title: link.title || '', onClick: function onClick() {
									_this3.props.menuActions.setActiveMenu(link);
								} },
							linkString
						) || _react2.default.createElement(
							'a',
							{
								href: isHttpLink ? link.url : 'javascript:void(0);',
								title: link.title || '',
								onClick: function onClick(e) {
									e.preventDefault();
									_this3.state.activeMenuTop = e.target.getBoundingClientRect().top;
									_this3.props.menuActions.setActiveMenu(link);
								}
							},
							linkString,
							_react2.default.createElement('span', null)
						),
						link.items && link.items.length > 0 && hasSubmenu && _react2.default.createElement(
							'ul',
							null,
							this.buildMenu(link, false, link)
						)
					);
				}
			}
		}]);
	
		return GlobalNavMenu;
	}(_react.Component);
	
	GlobalNavMenu.propTypes = {
		menuActive: _react.PropTypes.bool.isRequired,
		mainMenu: _react.PropTypes.object.isRequired,
		subMenu: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = GlobalNavMenu;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _profileSignedIn = __webpack_require__(632);
	
	var _profileSignedIn2 = _interopRequireDefault(_profileSignedIn);
	
	var _profileNotSignedIn = __webpack_require__(631);
	
	var _profileNotSignedIn2 = _interopRequireDefault(_profileNotSignedIn);
	
	var _profile = __webpack_require__(1017);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import InputText from '../../../form/input/text';
	//import InputSubmit from '../../../form/input/submit';
	//import lorem from '../../../../utils/lorem';
	
	var Profile = function (_Component) {
		_inherits(Profile, _Component);
	
		function Profile(props) {
			_classCallCheck(this, Profile);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Profile).call(this));
	
			_this.state = {
				showLogin: false
			};
			return _this;
		}
	
		_createClass(Profile, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'nav-profile' },
					(!this.state.showLogin || this.props.user.isLoggedIn()) && _react2.default.createElement(
						'div',
						{ className: 'nav-profile__submit-case' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.genericRoute)(false, 'submit/project'), className: 'button button--dark button--go', onClick: this.props.toggleMenu },
							'Submit your project'
						)
					),
					this.props.user.isLoggedIn() ? _react2.default.createElement(_profileSignedIn2.default, this.props) : _react2.default.createElement(_profileNotSignedIn2.default, _extends({ showLogin: this.state.showLogin, showLoginToggle: function showLoginToggle() {
							_this2.setState(_extends({}, _this2.state, { showLogin: true }));
						} }, this.props))
				);
			}
		}]);
	
		return Profile;
	}(_react.Component);
	
	Profile.PropTypes = {
		user: _react.PropTypes.object,
		toggleMenu: _react.PropTypes.func
	};
	exports.default = Profile;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _validate = __webpack_require__(76);
	
	var _routes = __webpack_require__(4);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _google = __webpack_require__(149);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileNotSignedIn = function (_Component) {
		_inherits(ProfileNotSignedIn, _Component);
	
		function ProfileNotSignedIn(props) {
			_classCallCheck(this, ProfileNotSignedIn);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProfileNotSignedIn).call(this));
	
			_this.FB = new _fb2.default();
			_this.GGL = new _google2.default();
			_this.TWT = new _twitter2.default();
	
			_this.state = {
				waiting: false
			};
			return _this;
		}
	
		_createClass(ProfileNotSignedIn, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this2 = this;
	
				if (nextProps.menuActive) {
					setTimeout(function () {
						_this2.FB.load();
						_this2.GGL.load();
					}, 701);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'profile-signup' },
					this.props.showLogin && _react2.default.createElement(
						'div',
						{ className: 'hide-mobile' },
						_react2.default.createElement(
							'form',
							{ onSubmit: function onSubmit(e) {
									_this3.submitHandler(e);
								}, className: 'profile-signup', key: '0' },
							_react2.default.createElement(_text2.default, {
								ref: 'email',
								name: 'email',
								type: 'text',
								placeholder: 'Email',
								manualValidate: true,
								validate: [{ rule: _validate.VALIDATE_EMAIL }]
							}),
							_react2.default.createElement('span', null),
							_react2.default.createElement(_text2.default, {
								ref: 'password',
								name: 'password',
								type: 'password',
								placeholder: 'Password',
								manualValidate: true,
								validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }]
							}),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_submit2.default, { name: 'Sign in', className: 'button--go', waiting: this.state.waiting })
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/recover'), className: 'nav-profile__account-links', onClick: this.props.toggleMenu },
								'Forgot password'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/register'), className: 'nav-profile__account-links', onClick: this.props.toggleMenu },
								'Sign up'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'nav-profile__social' },
							_react2.default.createElement(
								'div',
								{ className: 'nav-profile__social__head' },
								'Or use social sign in'
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'button',
									{ className: 'button button--fb', onClick: this.loginFB.bind(this) },
									'Facebook'
								),
								_react2.default.createElement(
									'button',
									{ className: 'button button--twt', onClick: this.loginTWT.bind(this) },
									'Twitter'
								),
								_react2.default.createElement(
									'button',
									{ className: 'button button--ggl', onClick: this.loginGGL.bind(this) },
									'Google'
								)
							)
						)
					) || _react2.default.createElement(
						'div',
						{ className: 'hide-mobile span13-mobile mainmenu__nav__bottom__desktop-signin' },
						_react2.default.createElement(
							'button',
							{ onClick: this.props.showLoginToggle, className: 'button button--go' },
							'Sign in'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/recover'), onClick: this.props.toggleMenu },
								'Forgot password'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/register'), onClick: this.props.toggleMenu },
								'Sign Up'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'hide-desktop hide-tablet span13-mobile mainmenu__nav__bottom__mobile-signin' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/login'), onClick: this.props.toggleMenu, className: 'button button--go' },
							'Sign in'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.accountRoute)('/recover'), onClick: this.props.toggleMenu },
								'Forgot password'
							)
						)
					)
				);
			}
		}, {
			key: 'submitHandler',
			value: function submitHandler(e) {
				var _this4 = this;
	
				e.preventDefault();
	
				if ((0, _validate.formIsValid)([this.refs.email, this.refs.password])) {
					this.setState(_extends({}, this.state, { waiting: true }));
	
					this.props.login(this.refs.email.value(), this.refs.password.value(), 1, function () {
						// component will have unmounted when this code is reached... so don't use state/props
						//Remove closing menu
	
					}, function () {
						_this4.setState(_extends({}, _this4.state, { waiting: false }));
					});
				}
	
				return false;
			}
		}, {
			key: 'loginFB',
			value: function loginFB() {
				this.FB.login(this.props.dispatch);
			}
		}, {
			key: 'loginGGL',
			value: function loginGGL() {
				this.GGL.login(this.props.dispatch);
			}
		}, {
			key: 'loginTWT',
			value: function loginTWT() {
				this.TWT.login(this.props.dispatch);
			}
		}]);
	
		return ProfileNotSignedIn;
	}(_react.Component);
	
	exports.default = ProfileNotSignedIn;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _routes = __webpack_require__(4);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileSignedIn = function (_Component) {
		_inherits(ProfileSignedIn, _Component);
	
		function ProfileSignedIn() {
			_classCallCheck(this, ProfileSignedIn);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(ProfileSignedIn).apply(this, arguments));
		}
	
		_createClass(ProfileSignedIn, [{
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: '' },
						_react2.default.createElement(
							'div',
							{ className: 'nav-profile__label' },
							'Signed in as:'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)(''), className: 'nav-profile__name', onClick: function onClick() {
									return _this3.props.toggleMenu();
								} },
							this.props.user.name
						),
						_react2.default.createElement(
							'a',
							{ className: 'button button--go nav-profile__button-signout', onClick: function onClick() {
									_this3.props.logout();
									var _this = _this3;
	
									_this3.props.dispatch((0, _errors.dispatchMsg)({
										message: 'Successfully logged out.'
									}));
	
									setTimeout(function () {
										_this.props.toggleMenu();
									}, 2000);
								} },
							'Sign out'
						)
					)
				);
			}
		}]);
	
		return ProfileSignedIn;
	}(_react.Component);
	
	ProfileSignedIn.PropTypes = {
		user: _react.PropTypes.object.isRequired
	};
	exports.default = ProfileSignedIn;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slider = __webpack_require__(1018);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _cornerLabel = __webpack_require__(177);
	
	var _cornerLabel2 = _interopRequireDefault(_cornerLabel);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _caseElementMenu = __webpack_require__(610);
	
	var _caseElementMenu2 = _interopRequireDefault(_caseElementMenu);
	
	var _editorialElement = __webpack_require__(619);
	
	var _editorialElement2 = _interopRequireDefault(_editorialElement);
	
	var _types = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GlobalNavSlider = function (_Component) {
		_inherits(GlobalNavSlider, _Component);
	
		function GlobalNavSlider() {
			_classCallCheck(this, GlobalNavSlider);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(GlobalNavSlider).call(this));
	
			_this.forceCompUpdate = true;
	
			_this.state = {
				head: '',
				content: []
			};
			return _this;
		}
	
		_createClass(GlobalNavSlider, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				// if (!this.props.cases.isFetching && this.props.cases.winners.length < 1) {
				// 	this.props.caseActions.fetchWinners(0, 3);
				// }
	
				if (!this.props.editorials.isFetching && this.props.editorials.editorials.length < 1) {
					this.props.editorialActions.fetchEditorials(0, 3);
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				// only re-render if context has changed
				return !!(nextProps.context !== this.props.context || nextProps.menuActive !== this.props.menuActive || this.forceCompUpdate);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'global-nav__context' },
					_react2.default.createElement(
						'div',
						{ className: 'global-nav__context__head' },
						_react2.default.createElement(_cornerLabel2.default, { name: this.getHead() })
					),
					_react2.default.createElement(
						_carousel2.default,
						{ autoplay: this.props.menuActive },
						this.getSlideContent()
					)
				);
			}
		}, {
			key: 'shouldAutoplay',
			value: function shouldAutoplay() {
				return !!this.props.menuActive;
			}
		}, {
			key: 'getHead',
			value: function getHead() {
				switch (this.props.context) {
					case _types.TYPE_EDITORIAL_LIST:
						return 'Featured editorial';
					default:
						return 'Recent winners';
				}
			}
		}, {
			key: 'getSlideContent',
			value: function getSlideContent(props) {
				switch (this.props.context) {
					case _types.TYPE_EDITORIAL_LIST:
						return this.getEditorialComponent(props);
					default:
						return this.getCaseComponent(props);
				}
			}
		}, {
			key: 'getCaseComponent',
			value: function getCaseComponent(props) {
				var _this2 = this;
	
				var content = [];
	
				if (this.props.cases.winners.length) {
					content = this.props.cases.winners.slice(0, 3).map(function (item, i) {
						return _react2.default.createElement(_caseElementMenu2.default, _extends({ key: i, browser: _this2.props.browser }, item, { menuActions: _this2.props.menuActions, menuActive: _this2.props.menuActive }));
					});
				}
	
				this.forceCompUpdate = !content.length;
	
				return content;
			}
		}, {
			key: 'getEditorialComponent',
			value: function getEditorialComponent(props) {
				var _this3 = this;
	
				var content = [];
	
				if (this.props.editorials.editorials.length) {
					content = this.props.editorials.editorials.slice(0, 3).map(function (item, i) {
						return _react2.default.createElement(_editorialElement2.default, _extends({ key: i }, item, { menuActions: _this3.props.menuActions, menuActive: _this3.props.menuActive }));
					});
				}
	
				this.forceCompUpdate = !content.length;
	
				return content;
			}
		}]);
	
		return GlobalNavSlider;
	}(_react.Component);
	
	GlobalNavSlider.propTypes = {
		context: _react.PropTypes.string,
		caseActions: _react.PropTypes.object.isRequired,
		editorialActions: _react.PropTypes.object.isRequired,
		cases: _react.PropTypes.object.isRequired,
		editorials: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		menuActive: _react.PropTypes.bool.isRequired
	};
	GlobalNavSlider.defaultProps = {
		context: '',
		cases: {}
	};
	exports.default = GlobalNavSlider;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _errorToaster = __webpack_require__(1019);
	
	var _errorToaster2 = _interopRequireDefault(_errorToaster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import fwaLogo from './fwa-logo.png';
	//import BurgerIcon from './burger.png';
	//import BurgerIconClose from './burger-close.png';
	//import Burger from 'babel!svg-react!./burger.svg?name=Burger';
	
	var ErrorToaster = function (_Component) {
		_inherits(ErrorToaster, _Component);
	
		function ErrorToaster(props) {
			_classCallCheck(this, ErrorToaster);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ErrorToaster).call(this, props));
	
			_this.timer = 0;
	
			_this.state = {
				msg: '',
				show: false,
				error: false
			};
			return _this;
		}
	
		_createClass(ErrorToaster, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps, nState) {
				var _this2 = this;
	
				if (nProps.show && this.props.message !== nProps.message) {
					clearTimeout(this.timer);
					this.timer = setTimeout(function () {
						_this2.props.clearErrors();
					}, 8000);
				}
	
				this.setState({
					msg: nProps.message,
					show: nProps.show,
					error: nProps.show ? nProps.error : this.state.error
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'error-toaster' + (this.state.show ? ' error-toaster--show' : '') + (this.state.error ? ' error-toaster--error' : '') },
					_react2.default.createElement(
						'div',
						{ className: 'error-toaster__shift' },
						this.state.msg
					)
				);
			}
		}]);
	
		return ErrorToaster;
	}(_react.Component);
	
	ErrorToaster.propTypes = {
		error: _react.PropTypes.bool,
		message: _react.PropTypes.string,
		show: _react.PropTypes.bool,
		clearErrors: _react.PropTypes.func
	};
	ErrorToaster.defaultProps = {
		error: false,
		message: '',
		show: false,
		clearErrors: function clearErrors() {}
	};
	exports.default = ErrorToaster;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _globalNav = __webpack_require__(627);
	
	var _globalNav2 = _interopRequireDefault(_globalNav);
	
	var _routes = __webpack_require__(4);
	
	var _headerFilter = __webpack_require__(636);
	
	var _headerFilter2 = _interopRequireDefault(_headerFilter);
	
	var _errorToaster = __webpack_require__(634);
	
	var _errorToaster2 = _interopRequireDefault(_errorToaster);
	
	var _searchPage = __webpack_require__(637);
	
	var _searchPage2 = _interopRequireDefault(_searchPage);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _header = __webpack_require__(1020);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _gaTrack = __webpack_require__(241);
	
	var _gaTrack2 = _interopRequireDefault(_gaTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import fwaLogo from './fwa-logo.png';
	//import BurgerIcon from './burger.png';
	//import BurgerIconClose from './burger-close.png';
	//import Burger from 'babel!svg-react!./burger.svg?name=Burger';
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Header).call(this, props));
	
			_this.state = {
				firstRender: true
			};
			return _this;
		}
	
		_createClass(Header, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var _this2 = this;
	
				if (this.state.firstRender) {
					this.t && clearTimeout(this.t);
					this.t = setTimeout(function () {
						_this2.setState({
							firstRender: false
						});
					}, 50);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var menuButtonClass = 'header-main__logo-area__menu-button';
				if (this.isMenuActive()) {
					menuButtonClass += ' header-main__logo-area__menu-button--active';
				}
	
				if (this.state.firstRender) {
					menuButtonClass += ' header-main__logo-area__menu-button--before-entering';
				}
	
				var logoClassName = 'span2 span4-tablet span14-mobile header-main__logo-area';
	
				/* TabIndex: 0 = FOCUSABLE : -1 = NOT FOCUSABLE */
	
				return _react2.default.createElement(
					'div',
					{
						className: 'header-container',
						tabIndex: this.props.menuActive || this.props.searchActive ? '0' : '-1',
						onClick: function onClick(e) {
							e.stopPropagation();
						},
	
						onKeyUp: function onKeyUp(e) {
							if (e.keyCode === 27) {
								// ESC
								if (_this3.props.menuActive || _this3.props.searchActive) _this3.props.dispatch({ type: 'MENU_CLOSE' });
							}
						}
					},
					_react2.default.createElement(
						'header',
						{ className: 'full-span--wborder header-main' },
						_react2.default.createElement(
							'div',
							{ className: logoClassName },
							_react2.default.createElement(_reactRouter.Link, { to: (0, _routes.genericRoute)(false, '', false), onClick: function onClick() {
									_this3.isMenuActive() && _this3.props.menuActions.toggleMenu();
								}, className: 'header-main__logo-area__home-link' }),
							_react2.default.createElement(
								'button',
								{ onClick: this.props.menuActions.toggleMenu, className: menuButtonClass },
								_react2.default.createElement(
									'div',
									{ className: 'burger-icon' },
									_react2.default.createElement(
										'span',
										null,
										_react2.default.createElement('i', null)
									),
									_react2.default.createElement(
										'span',
										null,
										_react2.default.createElement('i', null)
									),
									_react2.default.createElement(
										'span',
										null,
										_react2.default.createElement('i', null)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'close-icon' },
									_react2.default.createElement(
										'span',
										null,
										_react2.default.createElement('i', null)
									),
									_react2.default.createElement(
										'span',
										null,
										_react2.default.createElement('i', null)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span8 span6-tablet push14-mobile header-main__search-area' },
							_react2.default.createElement(_errorToaster2.default, _extends({}, this.props.errors, { clearErrors: this.props.errorActions.clearErrors })),
							_react2.default.createElement(_reactRouter.Link, { to: (0, _routes.genericRoute)(false, 'search', false), className: 'header-main__search-area__search-icon' + (this.props.searchActive ? ' header-main__search-area__search-icon--active' : ''), onClick: function onClick(e) {
									e.preventDefault();
									_this3.props.menuActions.toggleSearchMenu();
								} }),
							this.renderAdvertiseHere()
						),
						this.renderPromoArea(),
						this.props.showTimelineFilter && _react2.default.createElement(_headerFilter2.default, { categories: this.props.categories, timelineActions: this.props.timelineActions, isFetching: this.props.timelines.isFetching, browser: this.props.browser })
					),
					_react2.default.createElement(_globalNav2.default, this.props),
					_react2.default.createElement(_searchPage2.default, this.props)
				);
			}
		}, {
			key: 'isMenuActive',
			value: function isMenuActive() {
				return this.props.menuActive;
			}
		}, {
			key: 'renderAdvertiseHere',
			value: function renderAdvertiseHere() {
				var _this4 = this;
	
				if (this.isMenuActive()) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.genericRoute)(false, 'advertise', false), className: 'header-main__search-area__advert hide-mobile', onClick: function onClick() {
								_this4.props.dispatch({ type: 'MENU_CLOSE' });
							} },
						'Advertise Here'
					);
				}
			}
		}, {
			key: 'renderPromoArea',
			value: function renderPromoArea() {
				var _this5 = this;
	
				var startingSlide = Math.floor(Math.random() * this.props.ads.items.length);
				var className = 'span4 span4-mobile push5-mobile header-main__promo-area';
	
				if (this.props.menuActive || this.props.searchActive) {
					className += ' header-main__promo-area--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						_carousel2.default,
						{ autoplay: true, timer: 5000, decorators: false, startingSlide: startingSlide },
						this.props.ads.items.map(function (item, i) {
							return _react2.default.createElement(
								'a',
								{ key: i, href: item.url, onClick: function onClick() {
										return (0, _gaTrack2.default)('event', 'ads', item.url);
									}, target: '_blank' },
								_react2.default.createElement(_image2.default, {
									img: item.image,
									useExactBreakpoint: true,
									browser: _this5.props.browser,
									startingSlide: Math.floor(Math.random() * _this5.props.ads.items.length),
									span: 'span4',
									className: 'span4'
								})
							);
						})
					)
				);
			}
		}]);
	
		return Header;
	}(_react.Component);
	
	Header.propTypes = {
		menuActive: _react.PropTypes.bool.isRequired,
		mainMenu: _react.PropTypes.object.isRequired,
		subMenu: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired,
		categories: _react.PropTypes.object.isRequired,
		errors: _react.PropTypes.object.isRequired
	};
	exports.default = Header;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _debounce = __webpack_require__(298);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reduce = __webpack_require__(1205);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _pick = __webpack_require__(1203);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _multiselect = __webpack_require__(625);
	
	var _multiselect2 = _interopRequireDefault(_multiselect);
	
	var _date = __webpack_require__(14);
	
	var _states = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { genericRoute } from '../../routes';
	
	
	// import css from './header.scss';
	
	var HeaderFilter = function (_Component) {
		_inherits(HeaderFilter, _Component);
	
		function HeaderFilter(props) {
			_classCallCheck(this, HeaderFilter);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HeaderFilter).call(this, props));
	
			var state = {
				filter: {
					filter: {},
					date: ''
				},
				show: false
			};
	
			_this.toggleShow = _this.toggleShow.bind(_this);
			var query = _qs2.default.parse(location.search.slice(1));
			if (typeof query.filterDate !== 'undefined' && typeof query.filterAwards !== 'undefined' && typeof query.filterCaseTypes !== 'undefined' && typeof query.filterEditorials !== 'undefined') {
				var date = query.filterDate || '';
				var awards = _this.filterDataParse(query.filterAwards) || {};
				var caseTypes = _this.filterDataParse(query.filterCaseTypes) || {};
				var editorials = _this.filterDataParse(query.filterEditorials) || {};
	
				state.filter.filter = {
					awards: awards,
					caseTypes: caseTypes,
					editorials: editorials
				};
	
				state.filter.date = date;
	
				setTimeout(function () {
					_this.fetchTimeline({ filter: state.filter });
				}, 0);
			}
	
			_this.state = state;
			return _this;
		}
	
		_createClass(HeaderFilter, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.props.browser.scroll.register(this.toggleShow);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.toggleShow);
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nProps, nState) {
				var _this2 = this;
	
				if (function () {
					// check if filter has changed by looping through it - or assume it has i size has changed
					if (_this2.state.filter.length && nState.filter.length && _this2.state.filter.filter.length !== nState.filter.filter.length) {
						return true;
					}
	
					var keys = Object.keys(nState.filter.filter);
					for (var i = 0; i < keys.length; i++) {
						var prev = _this2.state.filter.filter[keys[i]];
						var next = nState.filter.filter[keys[i]];
	
						// if (keys[i] == 'awards') {
						// 	console.log(keys[i]);
						// 	console.log(prev);
						// 	console.log(next);
						// }
	
						if (!(0, _deepEqual2.default)(prev, next)) {
							return true;
						}
					}
	
					return false;
				}() || // or if date has changed
				this.state.filter.date !== nState.filter.date) {
	
					if (typeof this.props.timelineActions.setFilter === 'function') {
						var getCurrentStatus = function getCurrentStatus(filter) {
							var keys = Object.keys(filter);
							var prevVal = void 0;
							for (var i = 0; i < keys.length; i++) {
								var newKey = Object.keys(filter[keys[i]]);
								for (var k = 0; k < newKey.length; k++) {
									if (prevVal !== undefined && prevVal !== filter[keys[i]][newKey[k]]) {
										return _states.STATE_UNDETERMINED;
									}
	
									prevVal = filter[keys[i]][newKey[k]];
								}
							}
	
							return prevVal ? _states.STATE_ALL_ON : _states.STATE_ALL_OFF;
						};
	
						this.props.timelineActions.setFilter(getCurrentStatus(nState.filter.filter));
					}
	
					var modFilter = function (filter) {
						var newFilter = _extends({}, filter);
						var keys = Object.keys(newFilter);
	
						var allFalse = true;
						for (var i = 0; i < Math.min(keys.length, 2); i++) {
							var iKeys = Object.keys(newFilter[keys[i]]);
							for (var k = 0; k < iKeys.length; k++) {
								if (newFilter[keys[i]][iKeys[k]]) {
									allFalse = false;
									break;
								}
							}
						}
	
						for (var _i = 0; _i < keys.length; _i++) {
							var _iKeys = Object.keys(newFilter[keys[_i]]);
							if (allFalse) {
								for (var _k = 0; _k < _iKeys.length; _k++) {
									newFilter[keys[_i]][_iKeys[_k]] = true;
								}
							}
						}
	
						return newFilter;
					}(nState.filter.filter);
	
					var newFilter = _extends({}, nState.filter, {
						filter: modFilter
					});
	
					// then fetch timeline
					this.fetchTimeline({
						filter: JSON.stringify(newFilter)
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var date = new Date();
				var className = 'span4 span6-tablet span14-mobile header-main__filter';
	
				if (this.state.show || this.filtersActive()) {
					className += ' header-main__filter--show';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(_multiselect2.default, {
						ref: 'filters',
						placeholder: 'Filters',
						className: 'nav-filter-select',
						dropdownClass: 'span6-plus span10-tablet-plus span14-mobile-plus',
						options: this.getCategories(),
						defaultState: true,
						allowToggleAll: true,
						showSpinner: this.props.isFetching,
						defaultFilterState: this.state.filter.filter,
						onChange: function onChange(value) {
							return _this3.updateFilterValue(value, 'filter');
						}
					}),
					_react2.default.createElement(_select2.default, {
						ref: 'date',
						placeholder: 'Date',
						className: 'nav-date-select hide-mobile',
						options: [{
							label: 'Latest',
							value: date.getFullYear() + '-' + (date.getMonth() + 1)
						}].concat(this.getMonthArray()),
						value: this.state.filter.date,
						onChange: function onChange(value) {
							return _this3.updateFilterValue(value, 'date');
						}
					})
				);
			}
		}, {
			key: 'filtersActive',
			value: function filtersActive() {
				if (this.refs.filters && this.refs.date) {
					return this.refs.filters.state.isActive || this.refs.date.state.isActive;
				}
	
				return false;
			}
		}, {
			key: 'toggleShow',
			value: function toggleShow(e) {
				var show = e.scrollY > 10;
	
				if (show !== this.state.show) {
					this.setState(_extends({}, this.state, {
						show: show
					}));
				}
			}
		}, {
			key: 'updateFilterValue',
			value: function updateFilterValue(value, index) {
				if (value && index) {
					var filter = _extends({}, this.state.filter);
					filter[index] = value;
	
					var date = filter.date;
					var _filter$filter = filter.filter;
					var awards = _filter$filter.awards;
					var caseTypes = _filter$filter.caseTypes;
					var editorials = _filter$filter.editorials;
	
	
					var filterDate = date;
					var filterAwards = this.filterDataStringify(awards);
					var filterCaseTypes = this.filterDataStringify(caseTypes);
					var filterEditorials = this.filterDataStringify(editorials);
					var filterString = _qs2.default.stringify({
						filterDate: filterDate,
						filterAwards: filterAwards,
						filterCaseTypes: filterCaseTypes,
						filterEditorials: filterEditorials
					});
	
					history.replaceState({}, '', location.pathname + '?' + filterString);
	
					this.setState({ filter: filter });
				}
			}
		}, {
			key: 'getJsonFromUrl',
			value: function getJsonFromUrl() {
				var query = location.search.substr(1);
				var result = {};
				query.split('&').forEach(function (part) {
					var item = part.split('=');
					result[item[0]] = decodeURIComponent(item[1]);
				});
	
				return result;
			}
		}, {
			key: 'filterDataStringify',
			value: function filterDataStringify(data) {
				return (0, _reduce2.default)(data, function (result, value, key) {
					var computedValue = value;
					if (typeof computedValue === 'boolean') {
						computedValue = computedValue ? '1' : '0';
					}
					return '' + result + (result ? '-' : '') + key + '.' + computedValue;
				}, '');
			}
		}, {
			key: 'filterDataParse',
			value: function filterDataParse(dataStr) {
				var dataArray = dataStr.split('-').map(function (keyValueStr) {
					var keyValue = keyValueStr.split('.');
					return { key: keyValue[0], value: keyValue[1] };
				});
	
				var data = {};
				for (var index = 0; index < dataArray.length; index++) {
					var item = dataArray[index];
					var value = item.value;
					if (value === '0' || value === '1') {
						value = !!parseInt(value, 10);
					}
	
					data[item.key] = value;
				}
	
				return data;
			}
		}, {
			key: 'getMonthArray',
			value: function getMonthArray() {
				var nowDate = new Date();
				var beginDate = new Date('2000-06-01');
				var dates = [];
				var addHeader = null;
	
				function daysInMonth(month, year) {
					return new Date(year, month, 0).getDate();
				}
	
				nowDate.setMonth(nowDate.getMonth() - 1); // set to previous month
	
				while (beginDate.getTime() < nowDate.getTime()) {
					if (addHeader !== nowDate.getFullYear()) {
						dates.push({
							label: nowDate.getFullYear(),
							value: 0,
							disabled: true
						});
					}
	
					dates.push({
						label: _date.locales.en.monthNames[nowDate.getMonth()] + ' ' + nowDate.getFullYear(),
						value: nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1)
					});
	
					addHeader = nowDate.getFullYear();
					nowDate.setDate(-1, nowDate.getFullYear());
				}
	
				return dates;
			}
		}, {
			key: 'getCategories',
			value: function getCategories() {
				var wanted = ['awards', 'editorials', 'caseTypes']; // this array decides the order
				var names = ['Awards', 'Editorial', 'Project types'];
				var categories = [];
				var constructed = [];
	
				categories = (0, _pick2.default)(this.props.categories, wanted);
	
				var _loop = function _loop(i) {
					var catKey = wanted[i];
					var currentCategory = categories[catKey];
	
					if (!currentCategory) {
						return 'continue';
					}
	
					constructed.push({
						label: names[i],
						name: wanted[i],
						value: currentCategory.map(function (item, i) {
							return {
								id: item.id,
								label: item.title || item.name,
								name: catKey,
								value: item.id || item.slug
							};
						})
					});
				};
	
				for (var i = 0; i < wanted.length; i++) {
					var _ret = _loop(i);
	
					if (_ret === 'continue') continue;
				}
	
				// console.log(constructed);
				return constructed;
			}
		}, {
			key: 'fetchTimeline',
			value: function fetchTimeline(filter) {
				if (typeof this.fetchDebounce !== 'function' && typeof this.props.timelineActions.fetchTimeline === 'function') {
					// debounce fetching of timeline, so it doesn't happen on every button toggle in the filter
	
					this.fetchDebounce = (0, _debounce2.default)(this.props.timelineActions.fetchTimeline, 1000);
				}
	
				if (typeof this.fetchDebounce === 'function') {
					this.fetchDebounce(filter);
				}
			}
		}]);
	
		return HeaderFilter;
	}(_react.Component);
	
	HeaderFilter.propTypes = {
		categories: _react.PropTypes.object.isRequired,
		timelineActions: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		isFetching: _react.PropTypes.bool
	};
	HeaderFilter.defaultProps = {
		categories: {},
		isFetching: false
	};
	exports.default = HeaderFilter;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(35);
	
	var _reactRouter = __webpack_require__(3);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _date = __webpack_require__(14);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _searchPage = __webpack_require__(1021);
	
	var _searchPage2 = _interopRequireDefault(_searchPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE_CASE = 'cases';
	var TYPE_EDITORIAL = 'editorials';
	var TYPE_OTHER = 'other';
	var DEFAULT_STATE = {
		fetching: false,
		init: true,
		value: '',
		results: {
			cases: [],
			editorials: [],
			other: []
		},
		totalCases: 0,
		totalEditorials: 0,
		totalOther: 0,
		totalCount: 0
	};
	
	var SearchPage = function (_Component) {
		_inherits(SearchPage, _Component);
	
		function SearchPage(props) {
			_classCallCheck(this, SearchPage);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchPage).call(this, props));
	
			_this.fetchResults = (0, _lodash.debounce)(_this.fetchResults.bind(_this), 500);
	
			_this.state = DEFAULT_STATE;
			return _this;
		}
	
		_createClass(SearchPage, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (!prevProps.searchActive && this.props.searchActive) {
					this.refs.search && this.refs.search.focus();
	
					// TODO: Fix in a... better way
					document.querySelector('body').scrollTop = 0;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var className = 'search-page full-span--wborder';
	
				if (this.props.searchActive) {
					className += ' search-page--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'div',
						{ className: 'search-page__head' },
						'Search the FWA'
					),
					_react2.default.createElement(
						'div',
						{ className: 'search-page__input pixel-pattern pixel-pattern--01' },
						_react2.default.createElement('input', { ref: 'search', type: 'text', className: '', style: { tabIndex: 0 }, value: this.state.value, placeholder: 'Search for cases, agencies, people, locations etc.', onInput: this.searchInput.bind(this) })
					),
					_react2.default.createElement(
						'div',
						{ className: 'search-page__result-head' },
						this.state.fetching ? _react2.default.createElement(_spinner2.default, { size: '24', className: 'search-page__result-head__spinner' }) : !this.state.init && _react2.default.createElement(
							'span',
							null,
							'Results ',
							_react2.default.createElement(
								'span',
								{ className: 'search-page__result-head__count' },
								'(',
								this.state.totalCount,
								')'
							)
						)
					),
					_react2.default.createElement(SearchPageCategory, {
						key: 'cases',
						items: this.state.results.cases,
						title: 'Cases',
						component: SearchPageCase,
						browser: this.props.browser,
						toggleMenu: this.toggleSearchMenu.bind(this),
						query: this.state.value,
						type: TYPE_CASE,
						totalCount: this.state.totalCases || 0
					}),
					_react2.default.createElement(SearchPageCategory, {
						key: 'editorial',
						items: this.state.results.editorials,
						title: 'Editorial',
						component: SearchPageEditorial,
						browser: this.props.browser,
						toggleMenu: this.toggleSearchMenu.bind(this),
						query: this.state.value,
						type: TYPE_EDITORIAL,
						totalCount: this.state.totalEditorials || 0
					}),
					_react2.default.createElement(SearchPageCategory, {
						key: 'other',
						items: this.state.results.other,
						title: 'Other',
						component: SearchPageOther,
						browser: this.props.browser,
						toggleMenu: this.toggleSearchMenu.bind(this),
						query: this.state.value,
						type: TYPE_OTHER,
						totalCount: this.state.totalOther || 0
					}),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'toggleSearchMenu',
			value: function toggleSearchMenu() {
				this.props.menuActions && this.props.menuActions.toggleSearchMenu && this.props.menuActions.toggleSearchMenu();
			}
		}, {
			key: 'searchInput',
			value: function searchInput(e) {
				if (!e || !e.target) {
					return false;
				}
	
				this.fetchResults();
	
				this.setState(_extends({}, this.state, {
					init: false,
					value: e.target.value,
					fetching: true
				}));
			}
		}, {
			key: 'fetchResults',
			value: function fetchResults() {
				var _this2 = this;
	
				_axios2.default.get(_baseUrl2.default + '/api/search', {
					params: {
						q: this.state.value,
						limit: 6
					}
				}).then(function (res) {
					if (res.data && res.data.results && res.data.total !== undefined) {
						_this2.setState(_extends({}, _this2.state, {
							results: res.data.results,
							totalCount: res.data.total,
							totalCases: res.data.totalCases,
							totalEditorials: res.data.totalEditorials,
							totalOther: res.data.totalOther,
							fetching: false
						}));
					}
				}).catch(function (res) {
					// error
					_this2.setState(_extends({}, _this2.state, {
						fetching: false
					}));
				});
			}
		}]);
	
		return SearchPage;
	}(_react.Component);
	
	SearchPage.propTypes = {
		searchActive: _react.PropTypes.bool.isRequired,
		browser: _react.PropTypes.object.isRequired,
		menuActions: _react.PropTypes.object.isRequired
	};
	SearchPage.defaultProps = {
		searchActive: false
	};
	exports.default = SearchPage;
	
	var SearchPageCategory = function (_Component2) {
		_inherits(SearchPageCategory, _Component2);
	
		function SearchPageCategory(props) {
			_classCallCheck(this, SearchPageCategory);
	
			var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchPageCategory).call(this, props));
	
			_this3.state = {
				fetching: false,
				offset: 0,
				items: _this3.props.items,
				shown: []
			};
			return _this3;
		}
	
		_createClass(SearchPageCategory, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = _extends({}, this.state);
	
				if (this.props.query !== nextProps.query) {
					newState.offset = 6;
				}
	
				if (this.props.items !== nextProps.items) {
					newState.items = nextProps.items;
					newState.shown = [];
				}
	
				this.setState(newState);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				if (!this.state.items.length) {
					return false;
				}
	
				var delay = 0;
				var className = 'search-page__result-cat';
				var Component = this.props.component;
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					_react2.default.createElement(
						'aside',
						{ className: 'search-page__result-cat__aside span2 span100p-mobile' },
						this.props.title,
						' ',
						_react2.default.createElement(
							'span',
							{ className: 'search-page__result-cat__aside__count' },
							'(',
							this.props.totalCount,
							')'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'span14' },
						_react2.default.createElement('div', { className: 'search-page__result-cat__pusher span2 span0-mobile' }),
						_react2.default.createElement(
							'div',
							{ className: 'search-page__result-cat__container span12 span100p-mobile' },
							_react2.default.createElement(
								'ol',
								{ className: 'search-page__items' },
								!!this.state.items.length && this.state.items.map(function (item, i) {
									// base-delay if component is already show
									var _delay = 0;
	
									if (!(0, _lodash.find)(_this4.state.shown, function (str) {
										return str === 'item' + item.id;
									})) {
										// if component hasn't been rendered before we add a delay of +50ms compared to the last element that was delayed
										_delay = delay += 50;
										_this4.state.shown.push('item' + item.id);
									}
	
									return _react2.default.createElement(Component, {
										key: 'item' + item.id,
										item: item,
										browser: _this4.props.browser,
										toggleMenu: _this4.props.toggleMenu,
										delay: _delay
									});
								})
							)
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement('div', { className: 'search-page__result-cat__pusher span2 span0-mobile' }),
						this.state.items.length < this.props.totalCount && _react2.default.createElement(
							'a',
							{ className: 'search-page__result-cat__loadmore-cont', onClick: this.fetchMore.bind(this) },
							_react2.default.createElement(
								'div',
								{ className: 'span2 span4-tablet span4-mobile pixel-pattern search-page__result-cat__loadmore' },
								_react2.default.createElement(_spinner2.default, { size: '32', className: 'search-page__waiting' + (this.state.fetching ? ' search-page__waiting--show' : '') }),
								_react2.default.createElement('span', { className: 'search-page__result-cat__loadmore__arrow' + (!this.state.fetching ? ' search-page__result-cat__loadmore__arrow--show' : '') })
							),
							_react2.default.createElement(
								'div',
								{ className: 'span10 span8-tablet span10-mobile pixel-pattern search-page__result-cat__loadmore' },
								_react2.default.createElement(
									'span',
									null,
									'View more results (',
									this.props.totalCount - this.state.items.length,
									')'
								)
							),
							_react2.default.createElement('div', { className: 'cf' })
						) || _react2.default.createElement(
							'a',
							{ className: 'search-page__result-cat__loadmore-cont' },
							_react2.default.createElement('div', { className: 'cf' })
						)
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'fetchMore',
			value: function fetchMore(e) {
				var _this5 = this;
	
				if (this.state.fetching) {
					return false;
				}
	
				this.setState(_extends({}, this.state, {
					fetching: true
				}));
	
				_axios2.default.get(_baseUrl2.default + '/api/search', {
					params: {
						q: this.props.query,
						offset: this.state.offset,
						filter: this.props.type,
						limit: 24
					}
				}).then(function (res) {
					if (res.data && res.data.results && res.data.results[_this5.props.type]) {
						var newItems = (0, _lodash.uniqBy)((0, _lodash.concat)([], _this5.state.items, res.data.results[_this5.props.type]), function (item) {
							return item.id;
						});
	
						_this5.setState(_extends({}, _this5.state, {
							items: newItems,
							offset: _this5.state.offset + 24,
							fetching: false
						}));
					}
				}).catch(function (res) {
					// error
					//console.log(res);
					_this5.setState(_extends({}, _this5.state, {
						fetching: false
					}));
				});
			}
		}]);
	
		return SearchPageCategory;
	}(_react.Component);
	
	SearchPageCategory.propTypes = {
		items: _react.PropTypes.array.isRequired,
		type: _react.PropTypes.string.isRequired,
		totalCount: _react.PropTypes.number.isRequired,
		title: _react.PropTypes.string.isRequired,
		component: _react.PropTypes.func.isRequired,
		browser: _react.PropTypes.object.isRequired,
		toggleMenu: _react.PropTypes.func.isRequired
	};
	SearchPageCategory.defaultProps = {
		type: 0,
		items: [],
		title: '',
		toggleMenu: function toggleMenu() {}
	};
	
	var SearchPageCase = function (_Component3) {
		_inherits(SearchPageCase, _Component3);
	
		function SearchPageCase(props) {
			_classCallCheck(this, SearchPageCase);
	
			var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchPageCase).call(this, props));
	
			_this6.state = {
				visible: false
			};
			return _this6;
		}
	
		_createClass(SearchPageCase, [{
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var className = 'search-page__items__item search-page__items__case span2 span4-tablet span14-mobile';
				var item = this.props.item;
	
				if (!this.state.visible) {
					setTimeout(function () {
						_this7.setState(_extends({}, _this7.state, {
							visible: true
						}));
					}, 1);
				} else {
					className += ' search-page__items__item--active';
				}
	
				var profileNames = (0, _formatCredits2.default)(item.profiles, false, false);
	
				return _react2.default.createElement(
					'li',
					{ className: className, style: { transitionDelay: this.props.delay + 'ms' } },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.casesRoute)(item.slug), onClick: this.props.toggleMenu, className: 'search-page__items__case__link' },
						_react2.default.createElement(
							'div',
							{ className: 'search-page__items__case__img-holder pixel-pattern pixel-pattern--dark' },
							item.slide1 && _react2.default.createElement(_image2.default, { img: item.thumbnail, span: { desktop: 'span4', tablet: 'span4', mobile: 'span14' }, browser: this.props.browser }),
							item.slug && _react2.default.createElement(
								'div',
								{ className: 'search-page__items__case__overlay' },
								_react2.default.createElement(
									'div',
									{ className: 'button button--dark-to-light-anim search-page__items__case__overlay__button' },
									'See case'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'search-page__items__case__content' },
							_react2.default.createElement(
								'h2',
								{ className: 'search-page__items__case__title' },
								item.title
							),
							_react2.default.createElement(
								'span',
								{ className: 'search-page__items__case__byline' },
								profileNames
							)
						)
					)
				);
			}
		}]);
	
		return SearchPageCase;
	}(_react.Component);
	
	SearchPageCase.propTypes = {
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		delay: _react.PropTypes.number,
		toggleMenu: _react.PropTypes.func.isRequired
	};
	SearchPageCase.defaultProps = {
		delay: 0,
		toggleMenu: function toggleMenu() {}
	};
	
	var SearchPageEditorial = function (_Component4) {
		_inherits(SearchPageEditorial, _Component4);
	
		function SearchPageEditorial(props) {
			_classCallCheck(this, SearchPageEditorial);
	
			var _this8 = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchPageEditorial).call(this, props));
	
			_this8.state = {
				visible: false
			};
			return _this8;
		}
	
		_createClass(SearchPageEditorial, [{
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var className = 'search-page__items__item search-page__items__editorial search-page__items__editorial__news-single search-page__items__editorial__news-single--contextual span4 span6-tablet span14-mobile';
				var item = this.props.item;
				var date = new _date.DateFormatter(item.createdDate || '');
	
				if (!this.state.visible) {
					setTimeout(function () {
						_this9.setState(_extends({}, _this9.state, {
							visible: true
						}));
					}, 1);
				} else {
					className += ' search-page__items__item--active';
				}
	
				var userName = item.users && item.users.name ? item.users.name : 'Uncredited';
	
				return _react2.default.createElement(
					'li',
					{ className: className, style: { transitionDelay: this.props.delay + 'ms' } },
					_react2.default.createElement(
						'h2',
						{ className: 'search-page__items__editorial__news-single__title span100p' },
						item.title
					),
					(item.users && item.users.name || true) && _react2.default.createElement(
						'span',
						{ className: 'search-page__items__editorial__news-single__profile' },
						'By ',
						userName
					),
					item.createdDate && _react2.default.createElement(
						'span',
						{ className: 'search-page__items__editorial__news-single__date' },
						date.dateMonthAndYear
					),
					item.slug && _react2.default.createElement(
						'div',
						{ className: 'search-page__items__editorial__news-single__overlay' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: this.props.toggleMenu, to: (0, _routes.generateURL)(item.types ? item.types.slug : '', item.slug), className: 'button button--light-to-dark-anim button--light-to-dark-anim--solid search-page__items__editorial__news-single__button' },
							'Read more'
						)
					)
				);
			}
		}]);
	
		return SearchPageEditorial;
	}(_react.Component);
	
	SearchPageEditorial.propTypes = {
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		delay: _react.PropTypes.number,
		toggleMenu: _react.PropTypes.func.isRequired
	};
	SearchPageEditorial.defaultProps = {
		delay: 0,
		toggleMenu: function toggleMenu() {}
	};
	
	var SearchPageOther = function (_Component5) {
		_inherits(SearchPageOther, _Component5);
	
		function SearchPageOther(props) {
			_classCallCheck(this, SearchPageOther);
	
			var _this10 = _possibleConstructorReturn(this, Object.getPrototypeOf(SearchPageOther).call(this, props));
	
			_this10.state = {
				visible: false
			};
			return _this10;
		}
	
		_createClass(SearchPageOther, [{
			key: 'render',
			value: function render() {
				var _this11 = this;
	
				var className = 'search-page__items__item search-page__items__editorial search-page__items__editorial--other search-page__items__editorial__news-single search-page__items__editorial__news-single--contextual span4 span6-tablet span14-mobile';
				var item = this.props.item;
	
				if (!this.state.visible) {
					setTimeout(function () {
						_this11.setState(_extends({}, _this11.state, {
							visible: true
						}));
					}, 1);
				} else {
					className += ' search-page__items__item--active';
				}
	
				var routeFn = function routeFn() {
					return '/';
				};
				var text = 'Read more';
				switch (item.type) {
					case 'templates':
						routeFn = _routes.pageRoute;
						text = 'Go to page';
						break;
					case 'jobs':
						routeFn = _routes.jobsRoute;
						text = 'View job';
						break;
					case 'profiles':
						routeFn = _routes.profilesRoute;
						text = 'View profile';
						break;
				}
	
				return _react2.default.createElement(
					'li',
					{ className: className, style: { transitionDelay: this.props.delay + 'ms' } },
					_react2.default.createElement(
						'h2',
						{ className: 'search-page__items__editorial__news-single__title span100p' },
						item.title
					),
					item.slug && _react2.default.createElement(
						'div',
						{ className: 'search-page__items__editorial__news-single__overlay' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ onClick: this.props.toggleMenu, to: routeFn(item.slug), className: 'button button--light-to-dark-anim button--light-to-dark-anim--solid search-page__items__editorial__news-single__button' },
							text
						)
					)
				);
			}
		}]);
	
		return SearchPageOther;
	}(_react.Component);
	
	SearchPageOther.propTypes = {
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		delay: _react.PropTypes.number,
		toggleMenu: _react.PropTypes.func.isRequired
	};
	SearchPageOther.defaultProps = {
		delay: 0,
		toggleMenu: function toggleMenu() {}
	};

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _date = __webpack_require__(14);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _profile = __webpack_require__(639);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _hof = __webpack_require__(451);
	
	var _hof2 = _interopRequireDefault(_hof);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _lodash = __webpack_require__(35);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var url = _baseUrl2.default + '/api/hof';
	
	var Hof = function (_Component) {
		_inherits(Hof, _Component);
	
		function Hof(props) {
			_classCallCheck(this, Hof);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Hof).call(this, props));
	
			_this.uniq = (0, _lodash.uniqueId)();
	
			_this.state = {
				profiles: [],
				active: false
			};
			return _this;
		}
	
		_createClass(Hof, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				_axios2.default.get(url).then(function (response) {
					_this2.setState({
						profiles: response.data.profiles
					});
				}).catch(function (response) {
					console.log('fetching hof error');
					console.log(response);
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				if (this.state.profiles) {
					var profiles = this.state.profiles;
	
					return _react2.default.createElement(
						'section',
						{ className: 'hof hof span14' },
						_react2.default.createElement(
							'ul',
							{ className: 'hof__interview-holder' },
							profiles.map(function (profile, i) {
								return _this3.renderProfile(profile, i);
							})
						)
					);
				} else {
					return _react2.default.createElement(
						'section',
						{ className: 'hof hof span14' },
						'Loading...'
					);
				}
			}
		}, {
			key: 'renderProfile',
			value: function renderProfile(profile, i) {
				var uid = 'hof-profile-' + i;
	
				return _react2.default.createElement(_profile2.default, { browser: this.props.browser, key: uid, profile: profile, className: 'hof__interview' });
			}
		}, {
			key: 'moreClick',
			value: function moreClick(e, text, content, right) {
				e.preventDefault();
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return Hof;
	}(_react.Component);
	
	Hof.propTypes = {};
	exports.default = Hof;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _date = __webpack_require__(14);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _hof = __webpack_require__(451);
	
	var _hof2 = _interopRequireDefault(_hof);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _lodash = __webpack_require__(35);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var url = _baseUrl2.default + '/api/hof';
	
	var HofProfile = function (_Component) {
		_inherits(HofProfile, _Component);
	
		function HofProfile(props) {
			_classCallCheck(this, HofProfile);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HofProfile).call(this, props));
	
			_this.state = {
				active: false
			};
			return _this;
		}
	
		_createClass(HofProfile, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var profile = this.props.profile;
				var createdDate = new _date.DateFormatter(profile.hofSince);
				var charNum = 285;
				var w = this.props.browser.window.width;
	
				if (w < 1441) {
					charNum = 230;
				}
	
				if (w < 1201) {
					charNum = 97;
				}
	
				if (w < 1000) {
					charNum = 74;
				}
	
				if (w < 720) {
					charNum = 170;
				}
	
				if (w < 568) {
					charNum = 90;
				}
	
				var truncated = profile.hofText.substr(0, charNum);
	
				//re-trim if we are in the middle of a word
				truncated = truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf(' ')));
	
				return _react2.default.createElement(
					'li',
					{ key: this.props.uid, className: 'hof__interview' },
					profile.logoHoF.normal && _react2.default.createElement(
						'div',
						{ className: 'hof__interview__image-holder span5 span14-mobile' },
						_react2.default.createElement('img', _extends({ className: 'hof__interview__image' }, profile.logoHoF.normal))
					),
					_react2.default.createElement(
						'div',
						{ className: 'hof__interview__buttons-container span5 span14-mobile' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _index.profilesRoute)(profile.slug), className: 'hof__interview__button button button--light-to-dark-anim button--go' },
							'Agency profile'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'hof__interview__date span2 pixel-pattern hide-tablet hide-mobile' },
						_react2.default.createElement(_pixeltext2.default, { text: createdDate.date, className: 'hof__interview__day', y: '5px', textAnchor: 'end' }),
						_react2.default.createElement(
							'span',
							{ className: 'hof__interview__month' },
							createdDate.month + ' ' + createdDate.year
						),
						_react2.default.createElement(
							'span',
							{ className: 'hof__interview__award' },
							'BECAME MEMBER —'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'hof__interview__right span7 span9-tablet span14-mobile' },
						_react2.default.createElement(
							'h4',
							{ className: 'hof__interview__byline' },
							'By Rob Ford'
						),
						_react2.default.createElement(
							'h4',
							{ className: 'hof__interview__small-date hide-desktop' },
							createdDate.date + ' ' + createdDate.month + ', ' + createdDate.year
						),
						_react2.default.createElement(
							'div',
							{ className: 'hof__interview__content' },
							_react2.default.createElement(
								'h3',
								{ className: 'hof__interview__title' },
								profile.name
							),
							!this.state.active && _react2.default.createElement(
								'p',
								{ className: 'hof__interview__text span6 span12-mobile hof__interview__text--more' },
								truncated,
								' ',
								_react2.default.createElement(
									'a',
									{ className: 'hof__interview__more button', onClick: function onClick(event) {
											return _this2.moreClick(event);
										}, href: '#' },
									'...'
								)
							) || _react2.default.createElement(
								'p',
								{ className: 'hof__interview__text span6 span12-mobile' },
								profile.hofText,
								' ',
								_react2.default.createElement(
									'a',
									{ className: 'hof__interview__more button', onClick: function onClick(event) {
											return _this2.moreClick(event);
										}, href: '#' },
									'...'
								)
							)
						)
					)
				);
			}
		}, {
			key: 'moreClick',
			value: function moreClick(e) {
				e.preventDefault();
				this.setState({
					active: !this.state.active
				});
			}
		}]);
	
		return HofProfile;
	}(_react.Component);
	
	HofProfile.propTypes = {};
	exports.default = HofProfile;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(269);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_Component) {
		_inherits(Video, _Component);
	
		function Video() {
			_classCallCheck(this, Video);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(Video).apply(this, arguments));
		}
	
		_createClass(Video, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var isMobile = this.props.browser.window.width <= 719;
				if (isMobile && this.refs.video) {
					this.refs.video.setAttribute('playsInline', true);
					this.refs.video.play();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var isMobile = this.props.browser.window.width <= 719;
				var classNames = (0, _classnames2.default)({
					video: true
				}, this.props.className);
	
				return _react2.default.createElement(
					'div',
					{ className: classNames },
					_react2.default.createElement(
						'video',
						{ ref: 'video', autoPlay: !isMobile, muted: true, loop: true, preload: 'auto' },
						_react2.default.createElement('source', { src: this.props.video, type: 'video/mp4' }),
						_react2.default.createElement(
							'div',
							null,
							'Your browser does not support the video tag.'
						)
					)
				);
			}
		}]);
	
		return Video;
	}(_react.Component);
	
	Video.propTypes = {};
	exports.default = (0, _connect2.default)(Video);

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _listing = __webpack_require__(1022);
	
	var _listing2 = _interopRequireDefault(_listing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobListing = function (_Component) {
		_inherits(JobListing, _Component);
	
		function JobListing() {
			_classCallCheck(this, JobListing);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(JobListing).apply(this, arguments));
		}
	
		_createClass(JobListing, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var className = 'job-listing';
				var isSmall = this.props.listStyle === 1;
	
				if (isSmall) {
					className += ' job-listing--small';
				}
	
				return _react2.default.createElement(
					_reactRouter.Link,
					{ to: (0, _routes.jobsRoute)(this.props.job.slug), className: className, onClick: function onClick() {
							_this2.props.dispatch({ type: 'MENU_CLOSE' });
						} },
					_react2.default.createElement(
						'div',
						{ className: 'job-listing__title' },
						this.props.job.title
					),
					isSmall && _react2.default.createElement(
						'div',
						{ className: 'job-listing__location' },
						this.props.job.profileName,
						' ',
						this.props.job.location
					),
					!isSmall && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'job-listing__profile' },
							this.props.job.profileName
						),
						_react2.default.createElement(
							'div',
							{ className: 'job-listing__posted' },
							this.props.job.postedDate
						),
						_react2.default.createElement(
							'div',
							{ className: 'job-listing__location' },
							this.props.job.location
						)
					)
				);
			}
		}]);
	
		return JobListing;
	}(_react.Component);
	
	JobListing.propTypes = {};
	exports.default = JobListing;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _menus = __webpack_require__(349);
	
	var _postVacancy = __webpack_require__(1023);
	
	var _postVacancy2 = _interopRequireDefault(_postVacancy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostVacancy = function (_Component) {
		_inherits(PostVacancy, _Component);
	
		function PostVacancy() {
			_classCallCheck(this, PostVacancy);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(PostVacancy).apply(this, arguments));
		}
	
		_createClass(PostVacancy, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactRouter.Link,
					{ to: (0, _routes.genericRoute)(false, 'submit/job'), className: 'button button-postvacancy', onClick: this.closeMenu.bind(this) },
					'Post a job vacancy'
				);
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				this.props.dispatch((0, _menus.toggleMenu)());
			}
		}]);
	
		return PostVacancy;
	}(_react.Component);
	
	PostVacancy.propTypes = {};
	exports.default = PostVacancy;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _step = __webpack_require__(354);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(355);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(234);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(356);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _authorization = __webpack_require__(36);
	
	var _login = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../utils/translate';
	
	var CASE_STEP0 = 0;
	var CASE_STEP1 = 1;
	var CASE_STEP2 = 2;
	var CASE_STEP3 = 3;
	var CASE_STEP4 = 4;
	
	var CaseSubmitNotLoggedIn = function (_Component) {
		_inherits(CaseSubmitNotLoggedIn, _Component);
	
		function CaseSubmitNotLoggedIn(props) {
			_classCallCheck(this, CaseSubmitNotLoggedIn);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CaseSubmitNotLoggedIn).call(this));
	
			_this.state = {
				waiting: false,
				step: CASE_STEP0
			};
			return _this;
		}
	
		_createClass(CaseSubmitNotLoggedIn, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/profile/projects/create'), this.props.users.isLoggedIn(), false);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/profile/projects/create'), this.props.users.isLoggedIn(), { step: '1' });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-process account-process--standalone' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Submit Project' }),
					this.state.step === CASE_STEP0 && this.renderStep0(),
					this.state.step === CASE_STEP1 && this.renderStep1(),
					_react2.default.createElement(_step2.default, { activeStep: 0, goToStep: function goToStep() {}, goForward: function goForward() {}, dispatch: this.props.dispatch, user: this.props.users }),
					_react2.default.createElement(_step4.default, { activeStep: 0, goToStep: function goToStep() {}, goForward: function goForward() {}, dispatch: this.props.dispatch }),
					_react2.default.createElement(
						_reactStripeElements.Elements,
						null,
						_react2.default.createElement(_step6.default, { activeStep: 0, goToStep: function goToStep() {}, goForward: function goForward() {}, dispatch: this.props.dispatch })
					),
					_react2.default.createElement(_step8.default, { activeStep: 0, goToStep: function goToStep() {}, goForward: function goForward() {}, dispatch: this.props.dispatch, slug: '' })
				);
			}
		}, {
			key: 'renderStep0',
			value: function renderStep0() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area' },
							_react2.default.createElement(
								'strong',
								null,
								'We award the best there is'
							),
							_react2.default.createElement('br', null),
							'FWA is where you go to experience cutting-edge innovation in digital design and development. It’s a space that encourages the digital industry to push the boundaries of technology, to show people what is possible.'
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							_react2.default.createElement(
								'button',
								{ className: 'button--dark', onClick: this.start.bind(this) },
								'Submit to FWA'
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								_react2.default.createElement(
									'span',
									{ className: 'hide-mobile' },
									'Submit to FWA:'
								),
								' £70.50 GBP'
							)
						)
					)
				);
			}
		}, {
			key: 'renderStep1',
			value: function renderStep1() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area' },
							_react2.default.createElement(
								'strong',
								null,
								'Log in to submit project'
							),
							_react2.default.createElement('br', null),
							'Don’t worry, your login just enables you to edit and update your project at a later point.'
						)
					),
					_react2.default.createElement(_login.AccountLoginForm, this.props)
				);
			}
		}, {
			key: 'start',
			value: function start() {
				if (this.state.step === CASE_STEP0) {
					this.setState(_extends({}, this.state, {
						step: CASE_STEP1
					}));
				} else {
					//@TODO remove this when form is hooked up
					this.cycleSteps();
				}
			}
		}]);
	
		return CaseSubmitNotLoggedIn;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(CaseSubmitNotLoggedIn);

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _confirm = __webpack_require__(30);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _step = __webpack_require__(358);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(359);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(360);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(361);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _authorization = __webpack_require__(36);
	
	var _login = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import translate from '../../utils/translate';
	
	var JOB_STEP0 = 0;
	var JOB_STEP1 = 1;
	var JOB_STEP2 = 2;
	var JOB_STEP3 = 3;
	var JOB_STEP4 = 4;
	
	var JobSubmitNotLoggedIn = function (_Component) {
		_inherits(JobSubmitNotLoggedIn, _Component);
	
		function JobSubmitNotLoggedIn(props) {
			_classCallCheck(this, JobSubmitNotLoggedIn);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JobSubmitNotLoggedIn).call(this));
	
			_this.state = {
				waiting: false,
				step: JOB_STEP0
			};
			return _this;
		}
	
		_createClass(JobSubmitNotLoggedIn, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/profile/jobs/create'), this.props.users.isLoggedIn(), false);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/profile/jobs/create'), this.props.users.isLoggedIn(), { step: '1' });
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-process account-process--standalone' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account - Submit Project' }),
					this.state.step === JOB_STEP0 && this.renderStep0(),
					this.state.step === JOB_STEP1 && this.renderStep1()
				);
			}
		}, {
			key: 'renderStep0',
			value: function renderStep0() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area' },
							_react2.default.createElement(
								'strong',
								null,
								'Post jobs where people are looking'
							),
							_react2.default.createElement('br', null),
							'FWA is where you go to experience cutting-edge innovation in digital design and development. It’s a space that encourages the digital industry to push the boundaries of technology, to show people what is possible.'
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ className: 'pixel-pattern pixel-pattern--01' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__button-area' },
							_react2.default.createElement(
								'button',
								{ className: 'button--dark', onClick: this.start.bind(this) },
								'Post job vacancy'
							),
							_react2.default.createElement(
								'span',
								{ className: 'account-process__button-area__button-desc' },
								_react2.default.createElement(
									'span',
									{ className: 'hide-mobile' },
									'Post job vacancy for 90 days on FWA: '
								),
								' £70.50 GBP'
							)
						)
					)
				);
			}
		}, {
			key: 'renderStep1',
			value: function renderStep1() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_content2.default,
						{ title: '' },
						_react2.default.createElement(
							'div',
							{ className: 'account-process__title-area' },
							_react2.default.createElement(
								'strong',
								null,
								'Log in to post job vacancy'
							),
							_react2.default.createElement('br', null),
							'Don’t worry, your login just enables you to edit and update your job vacancy at a later point.'
						)
					),
					_react2.default.createElement(_login.AccountLoginForm, this.props)
				);
			}
		}, {
			key: 'start',
			value: function start() {
				if (this.state.step === JOB_STEP0) {
					this.setState(_extends({}, this.state, {
						step: JOB_STEP1
					}));
				} else {
					//@TODO remove this when form is hooked up
					this.cycleSteps();
				}
			}
		}]);
	
		return JobSubmitNotLoggedIn;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(JobSubmitNotLoggedIn);

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timelineCase = __webpack_require__(648);
	
	var _timelineCase2 = _interopRequireDefault(_timelineCase);
	
	var _timelineHero = __webpack_require__(652);
	
	var _timelineHero2 = _interopRequireDefault(_timelineHero);
	
	var _timelineHeroMonth = __webpack_require__(653);
	
	var _timelineHeroMonth2 = _interopRequireDefault(_timelineHeroMonth);
	
	var _timelineHeroYear = __webpack_require__(654);
	
	var _timelineHeroYear2 = _interopRequireDefault(_timelineHeroYear);
	
	var _timelineEditorial = __webpack_require__(649);
	
	var _timelineEditorial2 = _interopRequireDefault(_timelineEditorial);
	
	var _timelineEditorialImage = __webpack_require__(651);
	
	var _timelineEditorialImage2 = _interopRequireDefault(_timelineEditorialImage);
	
	var _timelineEditorialArticle = __webpack_require__(650);
	
	var _timelineEditorialArticle2 = _interopRequireDefault(_timelineEditorialArticle);
	
	var _timelineJobs = __webpack_require__(655);
	
	var _timelineJobs2 = _interopRequireDefault(_timelineJobs);
	
	var _pageSplitter = __webpack_require__(647);
	
	var _pageSplitter2 = _interopRequireDefault(_pageSplitter);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _display = __webpack_require__(1031);
	
	var _display2 = _interopRequireDefault(_display);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineDisplay = function (_Component) {
		_inherits(TimelineDisplay, _Component);
	
		function TimelineDisplay(props) {
			_classCallCheck(this, TimelineDisplay);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineDisplay).call(this));
	
			_this.containerHeight = 0;
			_this.state = _this.state || {};
			return _this;
		}
	
		_createClass(TimelineDisplay, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				// this.scrollY = window.scrollY;
	
				// update on init
				if (!this.props.items.length && nextProps.items.length) {
					return true;
				}
	
				// browser changed
				if (this.props.browser && this.props.browser.window && nextProps.browser.window.width !== this.props.browser.window.width) {
					return true;
				}
	
				// update on change
				if (this.props.items.length !== nextProps.items.length) {
					return true;
				}
	
				for (var i = 0; i < nextProps.items.length; i++) {
					if (typeof this.props.items[i] === 'undefined' || this.props.items[i].uid !== nextProps.items[i].uid) {
						return true;
					}
				}
	
				// stay the same
				return false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				this.elementCount = 0;
				this.pageCount = 0;
				this.uids = [];
	
				return _react2.default.createElement(
					'ul',
					{ className: 'timeline', ref: 'container' },
					this.props.items.map(function (item, i) {
						return item && _this2.renderItem(item, i);
					}),
					_react2.default.createElement('li', { className: 'clearfix' })
				);
			}
		}, {
			key: 'renderItem',
			value: function renderItem(item, i) {
				var _this3 = this;
	
				if ((i < this.props.skip || item.hidden) && item.type !== 'page-indicator') {
					return null;
				}
	
				var same = '';
	
				if (item.sortDate == this.sameTest && this.props.browser.window.width < 720 && item.hero != 1) {
					same = 'same';
				} else if (item.sortDate == this.sameTest && item.hero != 1) {
					same = 'same';
					this.elementCount++;
				} else {
					this.elementCount++;
				}
	
				var before = this.elementCount % 2 ? 'even' : 'odd';
	
				if (item.hero == 1) {
					this.elementCount = 0;
					this.sameTest = 0;
				}
	
				var className = this.elementCount % 2 ? 'odd' : 'even';
				var uid = item.uid;
	
				this.sameTest = item.sortDate;
	
				switch (item.type) {
					case 'page-indicator':
						uid = item.uid || 'page' + i;
						this.elementCount--;
						this.pageCount++;
	
						(0, _forEach2.default)(this.uids, function (single) {
							if (uid == single) {
								uid = uid + 1;
								console.log('I WORK');
							}
						});
	
						this.uids.push(uid);
	
						return _react2.default.createElement(_pageSplitter2.default, { key: uid, ref: 'splitter' + (this.pageCount + this.props.startPage), hasPushState: this.props.hasPushState, lastSplitter: function lastSplitter(page) {
								return _this3.refs['splitter' + page];
							}, page: this.pageCount - 1 + this.props.startPage, updatePushState: this.props.updatePushState, browser: this.props.browser });
					case 'awards':
						uid = item.uid || 'case' + item.item.id;
	
						(0, _forEach2.default)(this.uids, function (single) {
							if (uid == single) {
								uid = uid + 1;
							}
						});
	
						this.uids.push(uid);
	
						if (item.hero == 1) {
							if (item.month == 1) {
								return _react2.default.createElement(_timelineHeroMonth2.default, _extends({}, item.item, { before: before, awardId: item.awardId, isFirstHero: i === 0, sortDate: item.sortDate, browser: this.props.browser, key: uid }));
							} else if (item.year == 1) {
								return _react2.default.createElement(_timelineHeroYear2.default, _extends({}, item.item, { before: before, awardId: item.awardId, isFirstHero: i === 0, sortDate: item.sortDate, browser: this.props.browser, key: uid }));
							} else {
								return _react2.default.createElement(_timelineHero2.default, _extends({}, item.item, { before: before, awardId: item.awardId, isFirstHero: i === 0, sortDate: item.sortDate, browser: this.props.browser, key: uid }));
							}
						} else {
							return _react2.default.createElement(_timelineCase2.default, _extends({}, item.item, { same: same, awardId: item.awardId, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid }));
						}
	
						break;
					case 'editorials':
						uid = item.uid || 'editorial' + item.item.id;
	
						(0, _forEach2.default)(this.uids, function (single) {
							if (uid == single) {
								uid = uid + 1;
								console.log('I WORK');
							}
						});
	
						this.uids.push(uid);
	
						switch (item.item.timelineType) {
							case 'IMAGE':
								return _react2.default.createElement(_timelineEditorialImage2.default, _extends({}, item.item, { same: same, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid }));
								break;
							case 'HEADLINE':
								return _react2.default.createElement(_timelineEditorialArticle2.default, _extends({}, item.item, { same: same, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid }));
								break;
							case 'EXCERPT':
								return _react2.default.createElement(_timelineEditorial2.default, _extends({}, item.item, { same: same, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid }));
								break;
							default:
								return _react2.default.createElement(_timelineEditorialImage2.default, _extends({}, item.item, { same: same, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid }));
						}
						break;
					case 'jobs':
						uid = item.uid || 'jobs' + item.id;
	
						(0, _forEach2.default)(this.uids, function (single) {
							if (uid == single) {
								uid = uid + 1;
								console.log('I WORK');
							}
						});
	
						this.uids.push(uid);
	
						return _react2.default.createElement(_timelineJobs2.default, { item: item, same: same, sortDate: item.sortDate, browser: this.props.browser, className: className, key: uid });
					default:
						console.log('FAULTY ITEM::');
						console.log(item);
						return null;
				}
			}
		}]);
	
		return TimelineDisplay;
	}(_react.Component);
	
	TimelineDisplay.propTypes = {
		items: _react.PropTypes.array.isRequired,
		browser: _react.PropTypes.object.isRequired,
		updatePushState: _react.PropTypes.func
	};
	TimelineDisplay.defaultProps = {
		items: [],
		updatePushState: function updatePushState() {}
	};
	exports.default = TimelineDisplay;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (elementWrap, browser, elementToPush, elementToFade, elementToRespect) {
		//event.scrollY
		elementWrap = typeof elementWrap === 'function' ? elementWrap() : elementWrap;
		elementToPush = typeof elementToPush === 'function' ? elementToPush() : elementToPush;
		elementToFade = typeof elementToFade === 'function' ? elementToFade() : elementToFade;
		elementToRespect = typeof elementToRespect === 'function' ? elementToRespect() : elementToRespect;
		// let _DEBUG_ID = DEBUG_ID++;
	
		var tryScroll = function tryScroll(event) {
			//return false;
			// console.log(`[ID:${_DEBUG_ID}] tryScroll`);
			// let perf = performance.now() / 1000;
			// console.log(`[ID:${_DEBUG_ID}] START: ${perf}`);
			if (event && event.deltaY === 0) {
				return false;
			}
	
			event = event || { scrollY: window.scrollY };
	
			var splitter = 310;
	
			if (browser.window.width < 1200) {
				splitter = 150;
			}
	
			if (browser.window.width < 720) {
				splitter = 100;
			}
	
			var trigger = (0, _getOffsetTop2.default)(elementWrap) - 100;
			var ready = event.scrollY >= trigger && event.scrollY < trigger + browser.window.height;
			var top = 0;
			var opacity = 1;
			var denominator = splitter;
			if (elementToRespect.offsetHeight + 50 > splitter) {
				denominator = elementToPush.offsetHeight - elementToRespect.offsetHeight - 50;
			} else {
				denominator = elementToPush.offsetHeight - splitter;
			}
	
			if (ready) {
				top = event.scrollY - trigger;
				if (top < 0) {
					top = 0;
				} else if (top < denominator) {
					top = top;
				} else {
					top = denominator;
				}
	
				opacity -= top / denominator;
	
				top += 'px';
				top = 'translatey(' + top + ')';
				elementToPush.style.transform = top;
				elementToPush.style.WebkitTransform = top;
				elementToPush.style.MozTransform = top;
				elementToFade.style.opacity = opacity;
	
				// console.log('RLY');
				// elementWrap.className += ' active132';
				// browser.scroll.deregister(tryScroll);
			}
	
			// let newPerf = (performance.now() / 1000);
			// console.log(`[ID:${_DEBUG_ID}] END: ${newPerf} - DIFF: ${newPerf - perf}`);
	
			return ready;
		};
	
		return tryScroll;
	};
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	// let DEBUG_ID = 0;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _getOffsetTop = __webpack_require__(108);
	
	var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);
	
	var _pageSplitter = __webpack_require__(1032);
	
	var _pageSplitter2 = _interopRequireDefault(_pageSplitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelinePageSplitter = function (_Component) {
		_inherits(TimelinePageSplitter, _Component);
	
		function TimelinePageSplitter(props) {
			_classCallCheck(this, TimelinePageSplitter);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelinePageSplitter).call(this));
	
			_this.lastValue = false;
	
			_this.state = {
				isActivePage: false
			};
			return _this;
		}
	
		_createClass(TimelinePageSplitter, [{
			key: 'componentWillMount',
			value: function componentWillMount() {}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var elementTrigger = (0, _getOffsetTop2.default)(this.refs.splitter);
				// let debug = document.createElement('div');
	
				// if (__DEBUG__) {
				// 	debug.style.position = 'absolute';
				// 	debug.style.top = elementTrigger + 'px';
				// 	debug.style.height = '20px';
				// 	debug.style.width = '100%';
				// 	debug.style.backgroundColor = 'tomato';
				// 	document.body.appendChild(debug);
				// }
	
				this.scrollHandler = function (event) {
					var spanFrom = 0;
					var spanTo = 0;
	
					if (!this.props.lastSplitter(this.props.page) || !this.refs.splitter || event && event.deltaY === 0) {
						this.setState(_extends({}, this.state, {
							isActivePage: false
						}));
	
						return false;
					}
	
					var fixedEvent = event || { scrollY: window.scrollY };
	
					spanFrom = (0, _getOffsetTop2.default)(this.props.lastSplitter(this.props.page).getElement());
					spanTo = (0, _getOffsetTop2.default)(this.refs.splitter);
	
					var scrolledIntoSpan = fixedEvent.scrollY >= spanFrom;
					var scrolledPastSpan = fixedEvent.scrollY >= spanTo;
	
					// if (__DEBUG__) {
					// 	debug.style.top = spanTo + 'px'
					// 	//console.log(`%c ${this.props.page} :: (${fixedEvent.scrollY} >= ${spanFrom}) && !(${fixedEvent.scrollY} >= ${spanTo})`, (scrolledIntoSpan && !scrolledPastSpan) ? 'font-weight: bold; color: green;': 'font-weight: bold; color: red;');
					// }
	
					var isActivePage = scrolledIntoSpan && !scrolledPastSpan;
					this.setState(_extends({}, this.state, {
						isActivePage: isActivePage
					}));
	
					if (isActivePage) {
						var url = '/awards/' + window.location.search;
	
						if (this.props.hasPushState) {
							url = '/awards/page/' + this.props.page + '/' + window.location.search;
						}
	
						this.replaceHistoryState(url);
					}
				}.bind(this);
	
				this.props.browser.scroll.register(this.scrollHandler);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.scrollHandler);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'li',
					{ className: 'span6 page-splitter', 'data-page': this.props.page, ref: 'splitter', id: this.props.page },
					this.state.isActivePage && _react2.default.createElement(_reactHelmet2.default, { link: function () {
							return _this2.getRelLinks();
						}() })
				);
			}
		}, {
			key: 'replaceHistoryState',
			value: function replaceHistoryState(path) {
				if (!!(window.history && window.history.replaceState) && path !== window.location.pathname + window.location.search) {
					window.history.replaceState(window.history.state || {}, window.document.title, path);
				}
			}
		}, {
			key: 'getRelLinks',
			value: function getRelLinks() {
				var relLinks = [];
				var pageNum = this.props.page;
				var hasPushState = this.props.hasPushState;
	
				if (hasPushState && this.state.isActivePage) {
					if (pageNum > 1) {
						relLinks.push({
							rel: 'prev',
							href: window.location.origin + '/awards/page/' + (pageNum - 1) + window.location.search
						});
					}
	
					if (pageNum > 0) {
						relLinks.push({
							rel: 'next',
							href: window.location.origin + '/awards/page/' + (pageNum + 1) + window.location.search
						});
					}
	
					relLinks.push({
						rel: 'canonical',
						href: window.location.origin + '/awards/page/' + pageNum + window.location.search
					});
	
					// console.log(pageNum, relLinks);
				}
	
				return relLinks;
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.splitter;
			}
		}]);
	
		return TimelinePageSplitter;
	}(_react.Component);
	
	TimelinePageSplitter.propTypes = {
		page: _react.PropTypes.number,
		browser: _react.PropTypes.object.isRequired,
		updatePushState: _react.PropTypes.func,
		lastSplitter: _react.PropTypes.func
	};
	TimelinePageSplitter.defaultProps = {
		page: 1,
		updatePushState: function updatePushState() {}
	};
	exports.default = TimelinePageSplitter;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _date = __webpack_require__(14);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _timelineCase = __webpack_require__(1033);
	
	var _timelineCase2 = _interopRequireDefault(_timelineCase);
	
	var _buttonHoverWhite = __webpack_require__(1092);
	
	var _buttonHoverWhite2 = _interopRequireDefault(_buttonHoverWhite);
	
	var _buttonHover = __webpack_require__(1093);
	
	var _buttonHover2 = _interopRequireDefault(_buttonHover);
	
	var _player = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineCaseElement = function (_Component) {
		_inherits(TimelineCaseElement, _Component);
	
		function TimelineCaseElement(props) {
			_classCallCheck(this, TimelineCaseElement);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineCaseElement).call(this, props));
	
			_this2.boundingRect = false;
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
			_this2.state = {
				autoPlayVid: false,
				readyClick: false
			};
	
			var num = Math.floor(Math.random() * 4) + 1;
			return _this2;
		}
	
		_createClass(TimelineCaseElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				function hasClass(element, cls) {
					return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
				}
	
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return(
					//nProps.browser.window.width !== this.props.browser.window.width ||
					nProps.createdDate !== this.props.createdDate || nState.showVideo !== this.state.showVideo || nState.autoPlayVid !== this.state.autoPlayVid || nProps.title !== this.props.title || nProps.showreelUrl !== this.props.showreelUrl || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width
				);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var winDate = new _date.DateFormatter(this.props.sortDate);
				var awardTitle = '';
				var awardType = '';
				var _this = this;
	
				var url = (0, _index.casesRoute)(this.props.slug);
	
				//console.log(casesRoute(this.props.slug));
	
				var month = winDate.month;
	
				if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
					month = winDate.monthShort;
				}
	
				(0, _forEach2.default)(this.props.awards, function (award) {
					if (award.id == _this.props.awardId) {
						awardTitle = award.name;
						awardType = award.type;
					}
				});
	
				awardType = awardType.toLowerCase();
	
				var ribbonClass = 'ribbon-' + awardType + ' ribbon-' + awardType + '--small';
				if (this.props.className == 'even') {
					ribbonClass += ' ribbon-' + awardType + '--bl';
				} else {
					ribbonClass += ' ribbon-' + awardType + '--br';
				}
	
				var imgSpan = { desktop: 'span5', tablet: 'span5', mobile: 'span10' };
	
				var slides = [];
	
				for (var i = 1; i <= 3; i++) {
					this.props['slide' + i] && slides.push(_react2.default.createElement(
						_reactRouter.Link,
						{ to: url, key: 'slide' + i },
						_react2.default.createElement(_image2.default, { img: this.props['slide' + i], span: imgSpan, alt: '', browser: this.props.browser })
					));
				}
	
				!!this.props.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { ref: 'slideVideo', onUpdate: function onUpdate() {
						_this.setState(_extends({}, _this.state, { autoPlayVid: _this.refs.slideVideo }));
					}, key: 'slideVideo', url: this.props.showreelUrl, codaClass: 'slide-coda__item--is-video', onClick: function onClick(e) {
						_this3.setState(_extends({}, _this3.state, {
							showVideo: true
						}));
					} }));
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same, ref: 'timelineElement' },
					_react2.default.createElement(
						'time',
						{ className: 'timeline-case__date span1 span4-mobile' },
						_react2.default.createElement(
							'span',
							{ className: 'timeline-case__date--day' },
							winDate.date
						),
						_react2.default.createElement(
							'span',
							{ className: 'timeline-case__date--month' },
							month
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'timeline-case', ref: 'timelineCase' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-case__glitter pixel-pattern clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 timeline-case__glitter-img span10-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-case__glitter-img__buttons-container', onClick: function onClick(event) {
											return _this3.caseClick(event);
										} },
									this.props.url && _react2.default.createElement(
										_reactRouter.Link,
										{ to: url, className: 'timeline-case__glitter-img__button-light', ref: 'seeCase', onClick: function onClick(event) {
												return _this3.caseLaunchClick(event);
											} },
										'See Case'
									) || _react2.default.createElement(
										_reactRouter.Link,
										{ to: url, className: 'timeline-case__glitter-img__button-light timeline-case__glitter-img__button-light--solo', ref: 'seeCase', onClick: function onClick(event) {
												return _this3.caseLaunchClick(event);
											} },
										'See Case'
									),
									this.props.url && _react2.default.createElement(
										'a',
										{ href: this.props.url, target: '_blank', className: 'timeline-case__glitter-img__button-dark', onClick: function onClick(event) {
												return _this3.caseLaunchClick(event);
											} },
										'Launch',
										_react2.default.createElement(
											'span',
											{ className: 'hide-mobile' },
											' project'
										),
										' ',
										_react2.default.createElement('i', { className: 'arrow' })
									)
								),
								_react2.default.createElement(
									_carousel2.default,
									{ autoplay: false, hasVideo: true, autoPlayVid: this.state.autoPlayVid, browser: this.props.browser, sliderClass: 'pixel-pattern pixel-pattern--01 pixel-pattern--dark', decoClass: this.props.legacy ? 'legacy' : '' },
									slides
								),
								_react2.default.createElement('div', { className: ribbonClass })
							),
							_react2.default.createElement(
								'div',
								{ className: 'span1 span2-mobile timeline-case__glitter-scorecard' + (this.props.legacy ? ' timeline-case__glitter-scorecard--legacy' : '') },
								!this.props.legacy && _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ className: 'timeline-case__glitter-scorecard__score' },
										(0, _date.formatNumber)(this.props.points),
										' ',
										_react2.default.createElement(
											'small',
											null,
											'Points'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'timeline-case__glitter-scorecard__days' },
										this.props.days,
										' ',
										_react2.default.createElement(
											'small',
											null,
											'Days'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-case__details clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span10-mobile timeline-case__details-holder ' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-case__details-award' },
									awardTitle,
									_react2.default.createElement(
										'div',
										{ className: 'timeline-case__details-award__category' },
										this.props.caseTypes.name
									)
								),
								_react2.default.createElement(
									'h2',
									{ className: 'timeline-case__details__title' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: url },
										this.props.title
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-case__details__profile' },
									(0, _formatCredits2.default)(this.props.profiles, false)
								)
							),
							_react2.default.createElement('div', { className: 'span1 hide-tablet empty' })
						)
					),
					!!this.props.showreelUrl && _react2.default.createElement(_player.Player, { browser: this.props.browser, url: this.props.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
							_this3.setState(_extends({}, _this3.state, { showVideo: false }));
						} })
				);
			}
		}, {
			key: 'caseLaunchClick',
			value: function caseLaunchClick(event) {
				if (this.props.browser.window.width < 720 && !this.state.readyClick) {
					event.preventDefault();
					this.setState(_extends({}, this.state, { readyClick: true }));
				} else if (this.props.browser.window.width < 720) {
					this.setState(_extends({}, this.state, { readyClick: false }));
				} else {
					event.stopPropagation();
				}
			}
		}, {
			key: 'caseClick',
			value: function caseClick(event) {
	
				if (this.props.browser.window.width > 719) {
					_reactDom2.default.findDOMNode(this.refs.seeCase).click(event);
				} else {
					this.setState(_extends({}, this.state, { readyClick: true }));
				}
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return TimelineCaseElement;
	}(_react.Component);
	
	TimelineCaseElement.propTypes = {
		points: _react.PropTypes.number.isRequired,
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		caseTypes: _react.PropTypes.object.isRequired,
		title: _react.PropTypes.string.isRequired,
		slide1: _react.PropTypes.oneOfType([_react.PropTypes.object.isRequired, _react.PropTypes.oneOf([false])]),
		slide2: _react.PropTypes.oneOfType([_react.PropTypes.object.isRequired, _react.PropTypes.oneOf([false])]),
		slide3: _react.PropTypes.oneOfType([_react.PropTypes.object.isRequired, _react.PropTypes.oneOf([false])]),
		className: _react.PropTypes.string,
		browser: _react.PropTypes.object.isRequired,
		awards: _react.PropTypes.array.isRequired,
		awardId: _react.PropTypes.number.isRequired,
		sortDate: _react.PropTypes.string.isRequired,
		same: _react.PropTypes.string.isRequired
	};
	TimelineCaseElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		caseTypes: { name: '' },
		title: 'Unknown',
		slide1: '',
		className: ''
	};
	exports.default = TimelineCaseElement;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _reactClamp = __webpack_require__(162);
	
	var _reactClamp2 = _interopRequireDefault(_reactClamp);
	
	var _timelineEditorial = __webpack_require__(279);
	
	var _timelineEditorial2 = _interopRequireDefault(_timelineEditorial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorialElement = function (_Component) {
		_inherits(EditorialElement, _Component);
	
		function EditorialElement(props) {
			_classCallCheck(this, EditorialElement);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialElement).call(this, props));
	
			_this.state = {
				clamped: false
			};
			return _this;
		}
	
		_createClass(EditorialElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
	
				if (!this.state.clamped) {
					this.setState({
						clamped: true
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'render',
			value: function render() {
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var winDate = new _date.DateFormatter(); //@TODO set real winDate
				var awardType = 'FWA of the Day';
				var byText = 'By ';
				var smallTitle = '';
	
				var month = createdDate.month;
	
				if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
					month = createdDate.monthShort;
				}
	
				if (this.props.types.seriesName != '') {
					smallTitle = this.props.types.seriesName;
				} else {
					smallTitle = this.props.types.name;
				}
	
				if (this.props.users.name) {
					byText += this.props.users.name;
				} else {
					byText += 'Unknown';
				}
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same, ref: 'timelineElement' },
					_react2.default.createElement(
						'time',
						{ className: 'timeline-editorial__date span1 span4-mobile' },
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--day' },
							createdDate.date
						),
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--month' },
							month
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.generateURL)(this.props.types.slug, this.props.slug), className: 'timeline-editorial', ref: 'timelineEditorial' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__interview clearfix span6 span12-mobile' },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-editorial__interview-type' },
								smallTitle
							),
							_react2.default.createElement(
								'div',
								{ className: 'span6 span4-tablet span12-mobile timeline-editorial__interview-description' },
								_react2.default.createElement(
									'h2',
									{ className: 'span4 span8-mobile timeline-editorial__interview-title' },
									_react2.default.createElement(
										_reactClamp2.default,
										{ clamp: 2, ellipsis: '…' },
										this.props.title
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'span4 span8-mobile timeline-editorial__interview-excerpt' },
									_react2.default.createElement(
										_reactClamp2.default,
										{ clamp: 4, ellipsis: '…' },
										this.props.excerpt
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-editorial__interview-profile' },
									byText
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__interview__details push2-mobile push1' },
							_react2.default.createElement(
								'div',
								{ className: 'button button--dark' },
								'Read Article'
							)
						)
					)
				);
			}
		}, {
			key: 'getCategoryName',
			value: function getCategoryName(categories) {
				var cat = '';
				if (categories && (typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object' && categories.length) {
					cat = categories.slice(0, 1).map(function (item) {
						return item.name;
					});
				}
	
				return cat;
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return EditorialElement;
	}(_react.Component);
	
	EditorialElement.propTypes = {
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		excerpt: _react.PropTypes.string.isRequired,
		browser: _react.PropTypes.object.isRequired,
		types: _react.PropTypes.object.isRequired,
		sortDate: _react.PropTypes.string.isRequired,
		className: _react.PropTypes.string,
		same: _react.PropTypes.string.isRequired
	};
	EditorialElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		className: ''
	};
	exports.default = EditorialElement;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _reactClamp = __webpack_require__(162);
	
	var _reactClamp2 = _interopRequireDefault(_reactClamp);
	
	var _timelineEditorial = __webpack_require__(279);
	
	var _timelineEditorial2 = _interopRequireDefault(_timelineEditorial);
	
	var _case = __webpack_require__(1094);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _case3 = __webpack_require__(1095);
	
	var _case4 = _interopRequireDefault(_case3);
	
	var _case5 = __webpack_require__(1096);
	
	var _case6 = _interopRequireDefault(_case5);
	
	var _case7 = __webpack_require__(1097);
	
	var _case8 = _interopRequireDefault(_case7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorialArticleElement = function (_Component) {
		_inherits(EditorialArticleElement, _Component);
	
		function EditorialArticleElement(props) {
			_classCallCheck(this, EditorialArticleElement);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialArticleElement).call(this, props));
	
			_this.state = {
				clamped: false
			};
			return _this;
		}
	
		_createClass(EditorialArticleElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
	
				if (!this.state.clamped) {
					this.setState({
						clamped: true
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'render',
			value: function render() {
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var winDate = new _date.DateFormatter(); //@TODO set real winDate
				var awardType = 'FWA of the Day';
	
				var smallTitle = '';
	
				var month = createdDate.month;
	
				if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
					month = createdDate.monthShort;
				}
	
				if (this.props.types.seriesName != '') {
					smallTitle = this.props.types.seriesName;
				} else {
					smallTitle = this.props.types.name;
				}
	
				var byText = 'by ';
	
				if (this.props.users.name) {
					byText += this.props.users.name;
				} else {
					byText += 'John Doe';
				}
	
				this.slides = this.props.image;
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same, ref: 'timelineElement' },
					_react2.default.createElement(
						'time',
						{ className: 'timeline-editorial__date span1 span4-mobile' },
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--day' },
							createdDate.date
						),
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--month' },
							month
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.generateURL)(this.props.types.slug, this.props.slug), className: 'timeline-editorial', ref: 'timelineEditorial' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__interview clearfix span6 span12-mobile' },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-editorial__interview-type' },
								smallTitle
							),
							_react2.default.createElement(
								'div',
								{ className: 'span6 span4-tablet span12-mobile timeline-editorial__interview-description' },
								_react2.default.createElement(
									'h2',
									{ className: 'timeline-editorial__article-title span6-mobile' },
									_react2.default.createElement(
										_reactClamp2.default,
										{ ref: 'clampText', clamp: 4, ellipsis: '…' },
										this.props.title
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-editorial__interview-profile' },
									byText
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__interview__details push2-mobile push1' },
							_react2.default.createElement(
								'div',
								{ className: 'button button--dark' },
								'Read Article'
							)
						)
					)
				);
			}
		}, {
			key: 'getCategoryName',
			value: function getCategoryName(categories) {
				var cat = '';
				if (categories && (typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object' && categories.length) {
					cat = categories.slice(0, 1).map(function (item) {
						return item.name;
					});
				}
	
				return cat;
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return EditorialArticleElement;
	}(_react.Component);
	
	EditorialArticleElement.propTypes = {
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		image: _react.PropTypes.oneOfType([_react.PropTypes.object.isRequired, _react.PropTypes.oneOf([false])]),
		browser: _react.PropTypes.object.isRequired,
		types: _react.PropTypes.object.isRequired,
		excerpt: _react.PropTypes.string.isRequired,
		users: _react.PropTypes.object.isRequired,
		className: _react.PropTypes.string,
		sortDate: _react.PropTypes.string.isRequired,
		same: _react.PropTypes.string.isRequired
	};
	EditorialArticleElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		image: '',
		excerpt: '',
		className: ''
	};
	exports.default = EditorialArticleElement;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	var _date = __webpack_require__(14);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _timelineEditorial = __webpack_require__(279);
	
	var _timelineEditorial2 = _interopRequireDefault(_timelineEditorial);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditorialImageElement = function (_Component) {
		_inherits(EditorialImageElement, _Component);
	
		function EditorialImageElement(props) {
			_classCallCheck(this, EditorialImageElement);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialImageElement).call(this, props));
	
			_this.state = {};
			return _this;
		}
	
		_createClass(EditorialImageElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'render',
			value: function render() {
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var winDate = new _date.DateFormatter(); //@TODO set real winDate
				var awardType = 'FWA of the Day';
	
				var smallTitle = '';
	
				var month = createdDate.month;
	
				if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
					month = createdDate.monthShort;
				}
	
				if (this.props.types.seriesName != '') {
					smallTitle = this.props.types.seriesName;
				} else {
					smallTitle = this.props.types.name;
				}
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same, ref: 'timelineElement' },
					_react2.default.createElement(
						'time',
						{ className: 'timeline-editorial__date span1 span4-mobile' },
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--day' },
							createdDate.date
						),
						_react2.default.createElement(
							'span',
							{ className: 'timeline-editorial__date--month' },
							month
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _routes.editorialRoute)(this.props.slug), className: 'timeline-editorial', ref: 'timelineEditorial' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__glitter pixel-pattern clearfix' },
							_react2.default.createElement(
								_image2.default,
								{ img: this.props.image, span: 'span14', alt: '', style: { background: this.bg }, browser: this.props.browser, renderToDiv: true, className: 'span6 span12-mobile timeline-editorial__glitter-img' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-case__glitter-img__buttons-container' },
									_react2.default.createElement(
										'div',
										{ className: 'timeline-case__glitter-img__button-light' },
										'Read More ',
										_react2.default.createElement('i', { className: 'arrow' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-editorial__details clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 span4-tablet span11-mobile timeline-editorial__details-holder ' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-editorial__details-award' },
									smallTitle
								),
								_react2.default.createElement(
									'h2',
									{ className: 'timeline-editorial__details__title' },
									this.props.title
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-editorial__details__profile' },
									this.props.subtitle
								)
							),
							_react2.default.createElement('div', { className: 'span1 hide-tablet empty' })
						)
					)
				);
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return EditorialImageElement;
	}(_react.Component);
	
	EditorialImageElement.propTypes = {
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		image: _react.PropTypes.oneOfType([_react.PropTypes.object.isRequired, _react.PropTypes.oneOf([false])]),
		browser: _react.PropTypes.object.isRequired,
		types: _react.PropTypes.object.isRequired,
		className: _react.PropTypes.string,
		sortDate: _react.PropTypes.string.isRequired,
		same: _react.PropTypes.string.isRequired
	};
	EditorialImageElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		image: '',
		className: ''
	};
	exports.default = EditorialImageElement;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _reactClamp = __webpack_require__(162);
	
	var _reactClamp2 = _interopRequireDefault(_reactClamp);
	
	var _tooltip = __webpack_require__(180);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _getCategoryName = __webpack_require__(148);
	
	var _getCategoryName2 = _interopRequireDefault(_getCategoryName);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _timelineHero = __webpack_require__(452);
	
	var _timelineHero2 = _interopRequireDefault(_timelineHero);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _player = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineHeroElement = function (_Component) {
		_inherits(TimelineHeroElement, _Component);
	
		function TimelineHeroElement(props) {
			_classCallCheck(this, TimelineHeroElement);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineHeroElement).call(this, props));
	
			_this2.boundingRect = false;
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
			_this2.state = {
				showVideo: false,
				showCredits: false,
				clamped: false
			};
	
			_this2.child = '';
	
			if (_this2.props.isFirstHero) {
				_this2.child = ' first';
			}
			return _this2;
		}
	
		_createClass(TimelineHeroElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
	
				if (!this.state.clamped) {
					this.setState({
						clamped: true
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var awardedForDate = new _date.DateFormatter();
				var awardTitle = '';
				var awardType = '';
				var _this = this;
	
				(0, _forEach2.default)(this.props.awards, function (award) {
					if (award.id == _this.props.awardId) {
						awardTitle = award.name;
						awardType = award.type;
						awardedForDate = new _date.DateFormatter(award.awardFor);
					}
				});
	
				awardType = awardType.toLowerCase();
	
				var ribbonClass = 'ribbon-' + awardType;
				ribbonClass += ' ribbon-' + awardType + '--tr';
	
				var url = (0, _index.casesRoute)(this.props.slug);
	
				var imgSpan = { desktop: 'span9', tablet: 'span14', mobile: 'span12' };
	
				//console.log('width: ' + this.props.browser.window.width);
	
				//Scorecard things
	
				/*<div className='span1 hide-tablet timeline-hero__glitter-scorecard'>
	   	<div className='timeline-hero__glitter-scorecard__score'>
	   		{formatNumber(this.props.points)} <small>Points</small>
	   	</div>
	   	<div className='timeline-hero__glitter-scorecard__days'>
	   		{createdDate.calculateDaysBetweenString(winDate)} <small>Days</small>
	   	</div>
	   	<div className='timeline-hero__details__profile'>{formatCredits(this.props.profiles)}</div>
	   </div>*/
	
				var slides = [];
				for (var i = 1; i <= 3; i++) {
					this.props['slide' + i] && slides.push(_react2.default.createElement(
						_reactRouter.Link,
						{ to: url, key: 'slide' + i },
						_react2.default.createElement(_image2.default, { img: this.props['slide' + i], span: imgSpan, alt: '', browser: this.props.browser })
					));
				}
	
				!!this.props.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { key: 'slideVideo', url: this.props.showreelUrl, codaClass: 'slide-coda__item--is-video', skipSlide: true, onClick: function onClick(e) {
						_this3.setState(_extends({}, _this3.state, {
							showVideo: !_this3.state.showVideo
						}));
					} }));
	
				var showPoints = !this.props.legacy;
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__hero span14', ref: 'timelineElement' },
					_react2.default.createElement(
						'div',
						{ className: 'timeline-hero' + this.child, ref: 'timelineCase' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__details span5 span14-tablet span14-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__details-top' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__details-award span2 span4-tablet span14-mobile pixel-pattern' },
									_react2.default.createElement(_pixeltext2.default, { text: awardedForDate.date, className: 'timeline-hero__details-award--day', y: '15px' }),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__details-award--month' },
										awardedForDate.month
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__details-award--type' },
										awardTitle
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__details-share hide-mobile' },
									_react2.default.createElement(_share2.default, _defineProperty({ title: this.props.title, url: 'http://' + window.location.host + (0, _index.casesRoute)(this.props.slug), browser: this.props.browser }, 'browser', this.props.browser))
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__details-description' },
								_react2.default.createElement(
									'section',
									{ className: 'timeline-hero__details-description__content span5' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: url },
										_react2.default.createElement(
											'h3',
											{ className: 'timeline-hero__details__category' },
											(0, _getCategoryName2.default)(this.props.caseTypes.name, this.props.bestViewedOn)
										),
										_react2.default.createElement(
											'h2',
											{ className: 'timeline-hero__details__title span4' },
											_react2.default.createElement(
												_reactClamp2.default,
												{ clamp: 2, ellipsis: '…' },
												this.props.title
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'timeline-hero__details__excerpt span4' },
											_react2.default.createElement(
												_reactClamp2.default,
												{ clamp: 3, ellipsis: '…' },
												this.props.description
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span14-tablet span12-mobile span9 timeline-hero__slider-holder pixel-pattern pixel-pattern--dark' },
							_react2.default.createElement(
								_carousel2.default,
								{ autoplay: true },
								slides
							),
							_react2.default.createElement('div', { className: ribbonClass }),
							!!this.props.showreelUrl && _react2.default.createElement(_player.Player, { url: this.props.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
									_this3.setState(_extends({}, _this3.state, { showVideo: false }));
								}, browser: this.props.browser })
						),
						_react2.default.createElement('div', { className: 'span2 hide-desktop hide-tablet timeline-hero__slider-buttons' + (showPoints ? ' timeline-hero__slider-buttons--wpoints' : '') }),
						showPoints && _react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-scorecard span4 span8-tablet span12-mobile pixel-pattern hide-tablet hide-desktop' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__meta-scorecard__stats hide-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero__meta-scorecard__title' },
									'FWA award stats:'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__meta-scorecard__points span2 span4-tablet span6-mobile', ref: 'pointsTooltipMobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero__meta-scorecard__title' },
									'Points:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero__meta-scorecard__number' },
									(0, _date.formatNumber)(this.props.points)
								)
							),
							_react2.default.createElement(
								_tooltip2.default,
								{ attachTo: function attachTo() {
										return _this3.getRef('pointsTooltipMobile');
									} },
								_react2.default.createElement(
									'header',
									null,
									(0, _translate2.default)('tooltips/points/title')
								),
								_react2.default.createElement(
									'h2',
									null,
									(0, _translate2.default)('tooltips/points/head')
								),
								(0, _translate2.default)('tooltips/points/text')
							),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__meta-scorecard__days span2 span4-tablet span6-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero__meta-scorecard__title' },
									'Days:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero__meta-scorecard__number' },
									this.props.days
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__details-description--tablet span10 span14-mobile' },
							_react2.default.createElement(
								'section',
								{ className: 'timeline-hero__details-description__content span8 span12-mobile' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: url },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__details__category' },
										(0, _getCategoryName2.default)(this.props.caseTypes.name, this.props.bestViewedOn)
									),
									_react2.default.createElement(
										'h2',
										{ className: 'timeline-hero__details__title span6-tablet' },
										this.props.title
									),
									_react2.default.createElement(
										'p',
										{ className: 'timeline-hero__details__excerpt span8-tablet span8-mobile' },
										this.props.description
									)
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero__meta-credit span5 span4-tablet hide-mobile' },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-hero__meta-credit__title' },
								'Credits:'
							),
							_react2.default.createElement(
								'span',
								{ className: 'timeline-hero__meta-credit__name' },
								(0, _formatCredits2.default)(this.props.profiles)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-scorecard span4 span8-tablet span12-mobile pixel-pattern hide-mobile' },
							!this.props.legacy && _react2.default.createElement(
								'div',
								{ style: { height: '100%' } },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__stats hide-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__points span2 span4-tablet span6-mobile', ref: 'pointsTooltipTablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Points:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										(0, _date.formatNumber)(this.props.points)
									)
								),
								_react2.default.createElement(
									_tooltip2.default,
									{ closer: true, attachTo: function attachTo() {
											return _this3.getRef('pointsTooltipTablet');
										} },
									_react2.default.createElement(
										'header',
										null,
										(0, _translate2.default)('tooltips/points/title')
									),
									_react2.default.createElement(
										'h2',
										null,
										(0, _translate2.default)('tooltips/points/head')
									),
									(0, _translate2.default)('tooltips/points/text')
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__days span2 span4-tablet span6-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										this.props.days
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-more span5 span6-tablet span14-mobile' },
							_react2.default.createElement(
								'a',
								{ className: 'timeline-hero__meta-more__button button--credit button hide-tablet hide-desktop', onClick: function onClick() {
										return _this3.setState(_extends({}, _this3.state, { showCredits: !_this3.state.showCredits }));
									} },
								this.state.showCredits ? 'Credits -' : 'Credits +'
							),
							this.props.url && _react2.default.createElement(
								'a',
								{ href: this.props.url, target: '_blank', className: 'timeline-hero__meta-more__button button--go button--dark button' },
								'Launch Project'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: url, className: 'timeline-hero__meta-more__button button' },
								'See Case'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__down span8 span10-mobile' },
							_react2.default.createElement('div', { className: 'timeline-hero__down__left span6' }),
							_react2.default.createElement(
								'a',
								{ href: '#', className: 'timeline-hero__down__right span2', onClick: function onClick(event) {
										return _this3.scroll(event);
									} },
								_react2.default.createElement('span', { className: 'timeline-hero__down__arrow' })
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero__meta-credit span14 hide-tablet hide-desktop' + (this.state.showCredits ? '' : ' timeline-hero__meta-credit--hide') },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-hero__meta-credit__title' },
								'Credits:'
							),
							_react2.default.createElement(
								'span',
								{ className: 'timeline-hero__meta-credit__name' },
								(0, _formatCredits2.default)(this.props.profiles)
							)
						)
					)
				);
			}
		}, {
			key: 'scroll',
			value: function scroll(e) {
				e.preventDefault();
	
				if (this.refs.timelineElement) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
					var scroll = this.refs.timelineElement.offsetHeight + this.refs.timelineElement.offsetTop;
					scroller.to(scroll);
				}
			}
		}, {
			key: 'getRef',
			value: function getRef(name) {
				return this.refs[name];
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return TimelineHeroElement;
	}(_react.Component);
	
	TimelineHeroElement.propTypes = {
		points: _react.PropTypes.number.isRequired,
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		description: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		slide1: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.oneOf([false])]).isRequired,
		slide2: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.oneOf([false])]).isRequired,
		slide3: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.oneOf([false])]).isRequired,
		browser: _react.PropTypes.object.isRequired,
		awards: _react.PropTypes.array.isRequired,
		awardId: _react.PropTypes.number.isRequired,
		sortDate: _react.PropTypes.string.isRequired,
		isFirstHero: _react.PropTypes.bool.isRequired,
		showreelUrl: _react.PropTypes.string.isRequired
	};
	TimelineHeroElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		slide1: ''
	};
	exports.default = TimelineHeroElement;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _timelineIntroElement = __webpack_require__(374);
	
	var _timelineIntroElement2 = _interopRequireDefault(_timelineIntroElement);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _getCategoryName = __webpack_require__(148);
	
	var _getCategoryName2 = _interopRequireDefault(_getCategoryName);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _timelineHero = __webpack_require__(452);
	
	var _timelineHero2 = _interopRequireDefault(_timelineHero);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _player = __webpack_require__(97);
	
	var _case = __webpack_require__(1099);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _case3 = __webpack_require__(1100);
	
	var _case4 = _interopRequireDefault(_case3);
	
	var _case5 = __webpack_require__(1101);
	
	var _case6 = _interopRequireDefault(_case5);
	
	var _case7 = __webpack_require__(1102);
	
	var _case8 = _interopRequireDefault(_case7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Motion, spring } from 'react-motion';
	
	var DEBUG_ID = 0;
	
	var TimelineHeroMonthElement = function (_Component) {
		_inherits(TimelineHeroMonthElement, _Component);
	
		function TimelineHeroMonthElement(props) {
			_classCallCheck(this, TimelineHeroMonthElement);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineHeroMonthElement).call(this, props));
	
			_this2.mounted = true;
			_this2.boundingRect = false;
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
			_this2.state = {
				introElementOffset: 0,
				showVideo: false,
				showCredits: false
			};
	
			_this2.componentFirstClass = '';
	
			if (_this2.props.isFirstHero) {
				_this2.componentFirstClass = ' first';
			}
			return _this2;
		}
	
		_createClass(TimelineHeroMonthElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.DEBUG = DEBUG_ID++;
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var winDate = new _date.DateFormatter();
				var days = this.props.days;
				var awardTitle = '';
				var awardType = '';
				var _this = this;
	
				var url = (0, _index.casesRoute)(this.props.slug);
	
				(0, _forEach2.default)(this.props.awards, function (award) {
					if (award.id == _this.props.awardId) {
						awardTitle = award.name;
						awardType = award.type;
						winDate = new _date.DateFormatter(award.awardFor);
					}
				});
	
				awardType = awardType.toLowerCase();
	
				var ribbonClass = 'ribbon-' + awardType;
				ribbonClass += ' ribbon-' + awardType + '--tr';
	
				var imgSpan = { desktop: 'span9', tablet: 'span14', mobile: 'span12' };
	
				//Scorecard things
	
				/*<div className='span1 hide-tablet timeline-hero__glitter-scorecard'>
	   	<div className='timeline-hero__glitter-scorecard__score'>
	   		{formatNumber(this.props.points)} <small>Points</small>
	   	</div>
	   	<div className='timeline-hero__glitter-scorecard__days'>
	   		{days} <small>Days</small>
	   	</div>
	   	<div className='timeline-hero__details__profile'>{formatCredits(this.props.profiles)}</div>
	   </div>*/
	
				var slides = [];
				for (var i = 1; i <= 3; i++) {
					this.props['slide' + i] && slides.push(_react2.default.createElement(
						_reactRouter.Link,
						{ to: url, key: 'slide' + i },
						_react2.default.createElement(_image2.default, { img: this.props['slide' + i], span: imgSpan, alt: '', browser: this.props.browser })
					));
				}
	
				!!this.props.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { key: 'slideVideo', url: this.props.showreelUrl, codaClass: 'slide-coda__item--is-video', skipSlide: true, onClick: function onClick(e) {
						_this3.setState(_extends({}, _this3.state, {
							showVideo: !_this3.state.showVideo
						}));
					} }));
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__hero span14', ref: 'timelineElement' },
					_react2.default.createElement(_timelineIntroElement2.default, { before: this.props.before, browser: this.props.browser, title: this.props.title, timelineElement: this.getElement(), child: this.child, awardTitle: awardTitle, winDate: winDate }),
					_react2.default.createElement(
						'div',
						{ className: 'timeline-hero' + this.componentFirstClass, ref: 'timelineCase' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__details span5 span14-tablet' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__details-top' },
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__details-award month span2 span4-tablet pixel-pattern span14-mobile' },
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__details-award--type' },
										awardTitle + ' —'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__details-award--month month' },
										winDate.month
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__details-share' },
									_react2.default.createElement(_share2.default, { title: this.props.title, url: window.location.protocol + '//' + window.location.host + (0, _index.casesRoute)(this.props.slug), browser: this.props.browser })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero__details-description' },
								_react2.default.createElement(
									'section',
									{ className: 'timeline-hero__details-description__content span4' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__details__category' },
										(0, _getCategoryName2.default)(this.props.caseTypes.name, this.props.bestViewedOn)
									),
									_react2.default.createElement(
										'h2',
										{ className: 'timeline-hero__details__title' },
										this.props.title
									),
									_react2.default.createElement(
										'p',
										{ className: 'timeline-hero__details__excerpt' },
										this.props.description
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span14-tablet timeline-hero__slider-holder span9 span12-mobile pixel-pattern pixel-pattern--dark pixel-pattern--01' },
							_react2.default.createElement(
								_carousel2.default,
								{ autoplay: false },
								slides
							),
							_react2.default.createElement('div', { className: ribbonClass }),
							!!this.props.showreelUrl && _react2.default.createElement(_player.Player, { url: this.props.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
									_this3.setState(_extends({}, _this3.state, { showVideo: false }));
								}, browser: this.props.browser })
						),
						_react2.default.createElement('div', { className: 'span2 hide-desktop hide-tablet timeline-hero__slider-buttons' }),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-scorecard span4 span8-tablet span12-mobile pixel-pattern hide-tablet hide-desktop' },
							!this.props.legacy && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__stats hide-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__points span2 span4-tablet span6-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Points:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										(0, _date.formatNumber)(this.props.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__days span2 span4-tablet span6-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										days
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__details-description--tablet span10 span14-mobile' },
							_react2.default.createElement(
								'section',
								{ className: 'timeline-hero__details-description__content span8 span12-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero__details__category' },
									(0, _getCategoryName2.default)(this.props.caseTypes.name, this.props.bestViewedOn)
								),
								_react2.default.createElement(
									'h2',
									{ className: 'timeline-hero__details__title' },
									this.props.title
								),
								_react2.default.createElement(
									'p',
									{ className: 'timeline-hero__details__excerpt span8-tablet' },
									this.props.description
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero__meta-credit span5 span4-tablet hide-mobile' },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-hero__meta-credit__title' },
								'Credits:'
							),
							_react2.default.createElement(
								'span',
								{ className: 'timeline-hero__meta-credit__name' },
								(0, _formatCredits2.default)(this.props.profiles)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-scorecard span4 span8-tablet pixel-pattern hide-mobile' },
							!this.props.legacy && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__stats' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__points span2 span4-tablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Points:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										(0, _date.formatNumber)(this.props.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__days span2 span4-tablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										days
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-more span5 span6-tablet span14-mobile' },
							_react2.default.createElement(
								'a',
								{ className: 'timeline-hero__meta-more__button button--credit button hide-tablet hide-desktop', onClick: function onClick() {
										return _this3.setState(_extends({}, _this3.state, { showCredits: !_this3.state.showCredits }));
									} },
								this.state.showCredits ? 'Credits -' : 'Credits +'
							),
							this.props.url && _react2.default.createElement(
								'a',
								{ href: this.props.url, target: '_blank', className: 'timeline-hero__meta-more__button button--go button--dark button' },
								'Launch Project'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: url, className: 'timeline-hero__meta-more__button button' },
								'See Case'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__down span8 span10-mobile' },
							_react2.default.createElement('div', { className: 'timeline-hero__down__left span6' }),
							_react2.default.createElement(
								'a',
								{ href: '#', className: 'timeline-hero__down__right span2', onClick: function onClick(event) {
										return _this3.scroll(event);
									} },
								_react2.default.createElement('span', { className: 'timeline-hero__down__arrow' })
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero__meta-credit span14 hide-tablet hide-desktop' + (this.state.showCredits ? '' : ' timeline-hero__meta-credit--hide') },
							_react2.default.createElement(
								'h3',
								{ className: 'timeline-hero__meta-credit__title' },
								'Credits:'
							),
							_react2.default.createElement(
								'span',
								{ className: 'timeline-hero__meta-credit__name' },
								(0, _formatCredits2.default)(this.props.profiles)
							)
						)
					)
				);
			}
		}, {
			key: 'scroll',
			value: function scroll(e) {
				e.preventDefault();
	
				if (this.refs.timelineElement) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
					var scroll = this.refs.timelineElement.offsetHeight + this.refs.timelineElement.offsetTop;
					scroller.to(scroll);
				}
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}, {
			key: 'getIntroElement',
			value: function getIntroElement() {
				return this.refs.introElement;
			}
		}, {
			key: 'getIntroElementFade',
			value: function getIntroElementFade() {
				return this.refs.introElementFade;
			}
		}, {
			key: 'getIntroElementStopper',
			value: function getIntroElementStopper() {
				return this.refs.introElementStopper;
			}
		}]);
	
		return TimelineHeroMonthElement;
	}(_react.Component);
	
	TimelineHeroMonthElement.propTypes = {
		points: _react.PropTypes.number.isRequired,
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		description: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		slide1: _react.PropTypes.object,
		slide2: _react.PropTypes.object,
		slide3: _react.PropTypes.object,
		browser: _react.PropTypes.object.isRequired,
		awards: _react.PropTypes.array.isRequired,
		awardId: _react.PropTypes.number.isRequired,
		sortDate: _react.PropTypes.string.isRequired,
		isFirstHero: _react.PropTypes.bool.isRequired,
		showreelUrl: _react.PropTypes.string.isRequired,
		before: _react.PropTypes.string.isRequired
	};
	TimelineHeroMonthElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		slide1: ''
	};
	exports.default = TimelineHeroMonthElement;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _index = __webpack_require__(4);
	
	var _reactRouter = __webpack_require__(3);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _timelineIntroElement = __webpack_require__(374);
	
	var _timelineIntroElement2 = _interopRequireDefault(_timelineIntroElement);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _timelineHeroYear = __webpack_require__(1034);
	
	var _timelineHeroYear2 = _interopRequireDefault(_timelineHeroYear);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _player = __webpack_require__(97);
	
	var _adobeMicro = __webpack_require__(1098);
	
	var _adobeMicro2 = _interopRequireDefault(_adobeMicro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineHeroYearElement = function (_Component) {
		_inherits(TimelineHeroYearElement, _Component);
	
		function TimelineHeroYearElement(props) {
			_classCallCheck(this, TimelineHeroYearElement);
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineHeroYearElement).call(this, props));
	
			_this2.state = {
				showVideo: false,
				showCredits: false
			};
	
			_this2.child = '';
	
			if (_this2.props.isFirstHero) {
				_this2.child = ' first';
			}
			return _this2;
		}
	
		_createClass(TimelineHeroYearElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState.showVideo !== this.state.showVideo || nState.showCredits !== this.state.showCredits || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var awardedForDate = createdDate;
				var days = this.props.days;
				var awardTitle = '';
				var awardType = '';
				var _this = this;
				var url = (0, _index.casesRoute)(this.props.slug);
	
				(0, _forEach2.default)(this.props.awards, function (award) {
					if (award.id == _this.props.awardId) {
						awardTitle = award.name;
						awardType = award.type;
						awardedForDate = new _date.DateFormatter(award.awardFor);
					}
				});
	
				awardType = awardType.toLowerCase();
	
				var imgSpan = { desktop: 'span12', tablet: 'span14', mobile: 'span12' };
	
				var ribbonClass = 'ribbon-' + awardType;
				ribbonClass += ' ribbon-' + awardType + '--tl';
	
				//Scorecard things
	
				/*<div className='span1 hide-tablet timeline-hero-year__glitter-scorecard'>
	   	<div className='timeline-hero-year__glitter-scorecard__score'>
	   		{formatNumber(this.props.points)} <small>Points</small>
	   	</div>
	   	<div className='timeline-hero-year__glitter-scorecard__days'>
	   		{days} <small>Days</small>
	   	</div>
	   	<div className='timeline-hero-year__details__profile'>{formatCredits(this.props.profiles)}</div>
	   </div>*/
	
				var slides = [];
				for (var i = 1; i <= 3; i++) {
					this.props['slide' + i] && slides.push(_react2.default.createElement(
						_reactRouter.Link,
						{ to: url, key: 'slide' + i },
						_react2.default.createElement(_image2.default, { img: this.props['slide' + i], span: imgSpan, alt: '', browser: this.props.browser })
					));
				}
	
				!!this.props.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { key: 'slideVideo', url: this.props.showreelUrl, codaClass: 'slide-coda__item--is-video', skipSlide: true, onClick: function onClick(e) {
						_this3.setState(_extends({}, _this3.state, {
							showVideo: !_this3.state.showVideo
						}));
					} }));
	
				// console.log(this.state.showCredits);
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__hero span13 span14-tablet span14-mobile', ref: 'timelineElement' },
					_react2.default.createElement(_timelineIntroElement2.default, { before: this.props.before, browser: this.props.browser, title: this.props.title, child: this.child, awardTitle: awardTitle, year: awardedForDate.year }),
					_react2.default.createElement(
						'div',
						{ className: 'timeline-hero-year' + this.child, ref: 'timelineCase' },
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__slider-holder span12 span14-tablet pixel-pattern pixel-pattern--dark pixel-pattern--01' },
							_react2.default.createElement(
								_carousel2.default,
								{ autoplay: true },
								slides
							),
							_react2.default.createElement('div', { className: ribbonClass }),
							!!this.props.showreelUrl && _react2.default.createElement(_player.Player, { url: this.props.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
									_this3.setState(_extends({}, _this3.state, { showVideo: false }));
								}, browser: this.props.browser })
						),
						_react2.default.createElement('div', { className: 'timeline-hero-year__slider-holder__buttons span1-plus span2-mobile-plus hide-tablet' }),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero__meta-scorecard span4 span8-tablet span12-mobile pixel-pattern hide-tablet hide-desktop' },
							!this.props.legacy && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__stats hide-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__points span2 span4-tablet span6-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Points:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										(0, _date.formatNumber)(this.props.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero__meta-scorecard__days span2 span4-tablet span6-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero__meta-scorecard__number' },
										days
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__meta-scorecard--stats push0 span12-mobile pixel-pattern hide-tablet hide-desktop' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero-year__meta-scorecard__points span12-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero-year__meta-scorecard__title' },
									'Year:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero-year__meta-scorecard__number' },
									awardedForDate.year
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__details span5 span10-tablet span14-mobile' },
							awardType == 'tceay' && _react2.default.createElement('img', { className: 'timeline-hero-year__details__adobe', src: _adobeMicro2.default.src }),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero-year__details-description span8-tablet' },
								_react2.default.createElement(
									'section',
									{ className: 'timeline-hero-year__details-description__content' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero-year__details__category' },
										this.props.caseTypes.name
									),
									_react2.default.createElement(
										'h2',
										{ className: 'timeline-hero-year__details__title' },
										this.props.title
									),
									_react2.default.createElement(
										'p',
										{ className: 'timeline-hero-year__details__excerpt hide-mobile' },
										this.props.description
									)
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero-year__meta-credit--tablet span4 hide-desktop hide-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'span4' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero-year__meta-credit__title' },
									'Credits:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero-year__meta-credit__name' },
									(0, _formatCredits2.default)(this.props.profiles)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__meta-scorecard--stats span3 pixel-pattern span6-tablet hide-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero-year__meta-scorecard__stats--stats hide-tablet' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero-year__meta-scorecard__title' },
									awardTitle + ':'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero-year__meta-scorecard__points span3 span6-tablet' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero-year__meta-scorecard__title' },
									'Year:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero-year__meta-scorecard__number' },
									awardedForDate.year
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__meta-scorecard span4 pixel-pattern span8-tablet hide-mobile' },
							!this.props.legacy && _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero-year__meta-scorecard__stats hide-tablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero-year__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero-year__meta-scorecard__points span2 span4-tablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero-year__meta-scorecard__title' },
										'Points:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero-year__meta-scorecard__number' },
										(0, _date.formatNumber)(this.props.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'timeline-hero-year__meta-scorecard__days span2 span4-tablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'timeline-hero-year__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'timeline-hero-year__meta-scorecard__number' },
										days
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'timeline-hero-year__meta-more span8 span14-tablet span14-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'timeline-hero-year__details-share hide-mobile' },
								_react2.default.createElement(_share2.default, { title: this.props.title, url: 'http://' + window.location.host + (0, _index.casesRoute)(this.props.slug), browser: this.props.browser })
							),
							_react2.default.createElement(
								'a',
								{ className: 'timeline-hero-year__details-share button--credit button hide-tablet hide-desktop', onClick: function onClick() {
										return _this3.setState(_extends({}, _this3.state, { showCredits: !_this3.state.showCredits }));
									} },
								this.state.showCredits ? 'Credits -' : 'Credits +'
							),
							this.props.url && _react2.default.createElement(
								'a',
								{ href: this.props.url, target: '_blank', className: 'timeline-hero-year__meta-more__button button--go button--dark button' },
								'Launch Project'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: url, className: 'timeline-hero-year__meta-more__button button' },
								'See Case'
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'timeline-hero-year__meta-credit span7 span8-tablet span10-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'span5 hide-tablet hide-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero-year__meta-credit__title' },
									'Credits:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero-year__meta-credit__name' },
									(0, _formatCredits2.default)(this.props.profiles)
								)
							),
							_react2.default.createElement('div', { className: 'hide-desktop span6 timeline-hero-year__down--fill' }),
							_react2.default.createElement(
								'a',
								{ href: '#', className: 'timeline-hero-year__down__right span2', onClick: function onClick(event) {
										return _this3.scroll(event);
									} },
								_react2.default.createElement('span', { className: 'timeline-hero-year__down__arrow' })
							),
							_react2.default.createElement(
								'section',
								{ className: 'timeline-hero__meta-credit span14 hide-tablet hide-desktop' + (this.state.showCredits ? '' : ' timeline-hero__meta-credit--hide') },
								_react2.default.createElement(
									'h3',
									{ className: 'timeline-hero__meta-credit__title' },
									'Credits:'
								),
								_react2.default.createElement(
									'span',
									{ className: 'timeline-hero__meta-credit__name' },
									(0, _formatCredits2.default)(this.props.profiles)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'scroll',
			value: function scroll(e) {
				e.preventDefault();
	
				if (this.refs.timelineElement) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
					var scroll = this.refs.timelineElement.offsetHeight + this.refs.timelineElement.offsetTop;
					scroller.to(scroll);
				}
			}
		}, {
			key: 'getCategoryName',
			value: function getCategoryName(categories) {
				var cat = '';
				if (categories && (typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object' && categories.length) {
					cat = categories.slice(0, 1).map(function (item) {
						return item.name;
					});
				}
	
				return cat;
			}
		}]);
	
		return TimelineHeroYearElement;
	}(_react.Component);
	
	TimelineHeroYearElement.propTypes = {
		points: _react.PropTypes.number.isRequired,
		profiles: _react.PropTypes.array.isRequired,
		createdDate: _react.PropTypes.string.isRequired,
		description: _react.PropTypes.string.isRequired,
		categories: _react.PropTypes.array.isRequired,
		title: _react.PropTypes.string.isRequired,
		slide1: _react.PropTypes.object,
		slide2: _react.PropTypes.object,
		slide3: _react.PropTypes.object,
		browser: _react.PropTypes.object.isRequired,
		caseTypes: _react.PropTypes.object.isRequired,
		awards: _react.PropTypes.array.isRequired,
		awardId: _react.PropTypes.number.isRequired,
		sortDate: _react.PropTypes.string.isRequired,
		isFirstHero: _react.PropTypes.bool.isRequired,
		showreelUrl: _react.PropTypes.string.isRequired,
		before: _react.PropTypes.string.isRequired
	};
	TimelineHeroYearElement.defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		slide1: ''
	};
	exports.default = TimelineHeroYearElement;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _date = __webpack_require__(14);
	
	var _scrollActivate = __webpack_require__(132);
	
	var _scrollActivate2 = _interopRequireDefault(_scrollActivate);
	
	var _reactRouter = __webpack_require__(3);
	
	var _index = __webpack_require__(4);
	
	var _reactClamp = __webpack_require__(162);
	
	var _reactClamp2 = _interopRequireDefault(_reactClamp);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _timelineJobs = __webpack_require__(1035);
	
	var _timelineJobs2 = _interopRequireDefault(_timelineJobs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineJobsElement = function (_Component) {
		_inherits(TimelineJobsElement, _Component);
	
		function TimelineJobsElement(props) {
			_classCallCheck(this, TimelineJobsElement);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimelineJobsElement).call(this, props));
	
			_this.boundingRect = false;
	
			//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
			_this.state = {
				clamped: false
			};
	
			_this.tryActivateElem = function (scrollTop) {
				function hasClass(element, cls) {
					return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
				}
	
				_this.boundingRect = _this.refs.timelineJobs.getBoundingClientRect();
				var shouldActivate = _this.boundingRect.top <= _this.props.browser.window.height + 150;
	
				if (shouldActivate) {
					if (!hasClass(_this.refs.timelineElement, 'active')) {
						_this.refs.timelineElement.className += ' active';
						_this.props.browser.scroll.deregister(_this.tryActivateElem);
					}
				}
	
				return shouldActivate;
			};
			return _this;
		}
	
		_createClass(TimelineJobsElement, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.tryActivateElem = (0, _scrollActivate2.default)(this.getElement.bind(this), this.props.browser);
				if (!this.tryActivateElem()) {
					this.props.browser.scroll.register(this.tryActivateElem);
				}
	
				if (!this.state.clamped) {
					this.setState({
						clamped: true
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.tryActivateElem);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nProps, nState) {
				return nState !== this.state || nProps.browser.window.width !== this.props.browser.window.width || nProps.createdDate !== this.props.createdDate || nProps.title !== this.props.title || nProps.className !== this.props.className || nProps.browser.window.width !== this.props.browser.window.width;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				//let { title, categories, profiles, points, createdDate } = this.props.item;
				var createdDate = new _date.DateFormatter(this.props.sortDate);
				var jobs = this.props.item.items;
	
				var month = createdDate.month;
	
				if (this.props.browser.window.width < 1200) {
					month = createdDate.monthShort;
				}
	
				return _react2.default.createElement(
					'li',
					{ className: 'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same, ref: 'timelineElement' },
					_react2.default.createElement(
						'time',
						{ className: 'timeline-jobs__date span1' },
						_react2.default.createElement(
							'span',
							{ className: 'timeline-jobs__date--day' },
							createdDate.date
						),
						_react2.default.createElement(
							'span',
							{ className: 'timeline-jobs__date--month' },
							month
						)
					),
					_react2.default.createElement('div', { className: 'timeline-jobs__filler--before span2' }),
					_react2.default.createElement(
						'ul',
						{ className: 'timeline-jobs span4 span6-tablet span12-mobile', ref: 'timelineJobs' },
						_react2.default.createElement(
							'li',
							{ className: 'timeline-jobs__description' },
							_react2.default.createElement(
								'span',
								{ className: 'timeline-jobs__description--title' },
								'Jobs'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _index.jobsRoute)(), className: 'timeline-jobs__description--link' },
								'All Jobs'
							)
						),
						jobs.map(function (item, i) {
							return _this2.renderJob(item, i);
						})
					),
					_react2.default.createElement('div', { className: 'timeline-jobs__filler--after span2' })
				);
			}
		}, {
			key: 'renderJob',
			value: function renderJob(job, i) {
				var uid = job.uid || 'job' + job.id;
				var profile = '';
	
				if (job.item.profiles) {
					profile = job.item.profiles.name + ', ';
				}
	
				var string = profile + job.item.city + ', ' + job.item.country;
	
				return _react2.default.createElement(
					'li',
					{ key: uid },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: (0, _index.jobsRoute)(job.item.slug), className: 'timeline-jobs__job span4 span6-tablet span12-mobile' },
						this.props.browser.window.width < 720 && _react2.default.createElement(
							'h3',
							null,
							_react2.default.createElement(
								_reactClamp2.default,
								{ clamp: 1, ellipsis: '…' },
								job.item.title
							)
						) || _react2.default.createElement(
							'h3',
							null,
							job.item.title
						),
						_react2.default.createElement(
							_reactClamp2.default,
							{ className: 'timeline-jobs__job__trunc', clamp: 1, ellipsis: '…' },
							string
						)
					)
				);
			}
		}, {
			key: 'getCategoryName',
			value: function getCategoryName(categories) {
				var cat = '';
				if (categories && (typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object' && categories.length) {
					cat = categories.slice(0, 1).map(function (item) {
						return item.name;
					});
				}
	
				return cat;
			}
		}, {
			key: 'getElement',
			value: function getElement() {
				return this.refs.timelineElement;
			}
		}]);
	
		return TimelineJobsElement;
	}(_react.Component);
	
	TimelineJobsElement.propTypes = {
		item: _react.PropTypes.object.isRequired,
		browser: _react.PropTypes.object.isRequired,
		className: _react.PropTypes.string,
		sortDate: _react.PropTypes.string.isRequired,
		same: _react.PropTypes.string.isRequired
	};
	TimelineJobsElement.defaultProps = {
		points: 0,
		className: ''
	};
	exports.default = TimelineJobsElement;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _errors = __webpack_require__(29);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _users = __webpack_require__(64);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _splitter = __webpack_require__(32);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _account = __webpack_require__(1038);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SHOW_USER_HEAD = 0;
	var SHOW_PROFILE_HEAD = 1;
	
	var Account = function (_Component) {
		_inherits(Account, _Component);
	
		function Account(props) {
			_classCallCheck(this, Account);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Account).call(this));
	
			_this.state = {
				show: SHOW_USER_HEAD
			};
			return _this;
		}
	
		_createClass(Account, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)('/login'), !this.props.users.isLoggedIn(), location.pathname);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps) {
				(0, _authorization.redirectToPathIf)(nProps.dispatch, (0, _routes.accountRoute)('/login'), !nProps.users.isLoggedIn(), location.pathname);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				if (this.props.router && this.props.router.location && this.props.router.location.query && this.props.router.location.query.c) {
					_axios2.default.post(_baseUrl2.default + '/api/account/changerequest/' + this.props.router.location.query.c).then(function (res) {
						if (res.data && res.data.message) {
							_this2.props.dispatch((0, _errors.dispatchMsg)(res.data));
						}
					}).catch(function (res) {
						if (res.data && res.data.message) {
							_this2.props.dispatch((0, _errors.dispatchError)(res.data));
						}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'account' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account' }),
					_react2.default.createElement(
						'div',
						{ className: 'account__head' + (this.state.show === SHOW_USER_HEAD ? ' account__head--user-active' : ' account__head--profile-active') },
						_react2.default.createElement(
							'div',
							{ className: 'span5 span14-mobile account__head__user' },
							_react2.default.createElement(
								'div',
								{ className: 'account__signout hide-desktop hide-tablet' },
								_react2.default.createElement(
									'button',
									{ className: 'button button--dark', onClick: this.signOut.bind(this) },
									'Sign out'
								)
							),
							this.renderHeadSwitcher('Company profile', 'button--go'),
							_react2.default.createElement(
								'header',
								{ className: 'hide-mobile account__head__label' },
								'Your user'
							),
							_react2.default.createElement(
								'h2',
								{ className: 'account__head__name' },
								this.props.users.name
							),
							_react2.default.createElement(
								'ol',
								{ className: 'account__head__menu' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/settings'), activeClassName: 'active' },
										'Account'
									)
								),
								this.props.users.canHas([_authorization.ROLE_JUDGE_FOTD, _authorization.ROLE_JUDGE_FOTM, _authorization.ROLE_JUDGE_FOTY, _authorization.ROLE_JUDGE_TCEA]) && _react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/jury'), activeClassName: 'active' },
										'Jury'
									)
								),
								this.props.users.editorials && !!this.props.users.editorials.length && _react2.default.createElement(
									'li',
									{ className: 'account__head__menu__expanded' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/editorial'), activeClassName: 'active', onClick: function onClick(e) {
												return e.preventDefault();
											} },
										_react2.default.createElement(
											'span',
											{ ref: 'accountEditorial' },
											'Editorial'
										)
									),
									_react2.default.createElement(
										_dropdown2.default,
										{ attachTo: function attachTo() {
												return _this3.getRef('accountEditorial');
											}, pointTo: 'TOP_LEFT', browser: this.props.browser },
										_react2.default.createElement(
											'ol',
											null,
											this.props.users.editorials.map(function (item, i) {
												return _react2.default.createElement(
													'li',
													{ key: i },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: (0, _routes.accountRoute)('/editorial/' + item.slug) },
														item.name
													)
												);
											})
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span9 span14-mobile account__head__profile' },
							_react2.default.createElement(
								'div',
								{ className: 'account__signout' },
								_react2.default.createElement(
									'button',
									{ className: 'button button--dark', onClick: this.signOut.bind(this) },
									'Sign out'
								)
							),
							this.renderHeadSwitcher('User profile', 'button--go-back'),
							this.isPartOfProfile() && _react2.default.createElement(
								'header',
								{ className: 'hide-mobile account__head__label' },
								'Part of the profile'
							),
							this.isPartOfProfile() && _react2.default.createElement(
								'h2',
								{ className: 'account__head__name' },
								this.props.users.profile.name
							),
							_react2.default.createElement(
								'ol',
								{ className: 'account__head__menu' },
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/profile/settings'), activeClassName: 'active' },
										'Profile'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/profile/projects'), activeClassName: 'active' },
										'Projects'
									)
								),
								_react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/profile/jobs'), activeClassName: 'active' },
										'Jobs'
									)
								),
								this.isPartOfProfile() && this.props.users.profile.editorials && !!this.props.users.profile.editorials.length && _react2.default.createElement(
									'li',
									{ className: 'account__head__menu__expanded' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/profile/editorial'), activeClassName: 'active', onClick: function onClick(e) {
												return e.preventDefault();
											} },
										_react2.default.createElement(
											'span',
											{ ref: 'profileEditorial' },
											'Editorial'
										)
									),
									_react2.default.createElement(
										_dropdown2.default,
										{ attachTo: function attachTo() {
												return _this3.getRef('profileEditorial');
											}, browser: this.props.browser },
										_react2.default.createElement(
											'ol',
											null,
											this.props.users.profile.editorials.map(function (item, i) {
												return _react2.default.createElement(
													'li',
													{ key: i },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: (0, _routes.accountRoute)('/profile/editorial/' + item.slug) },
														item.name
													)
												);
											})
										)
									)
								),
								this.props.users.canHas([_authorization.FWA_ADMIN]) && _react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: (0, _routes.accountRoute)('/admin'), activeClassName: 'active', onClick: function onClick(e) {
												return e.preventDefault();
											} },
										_react2.default.createElement(
											'span',
											{ ref: 'accountAdmin' },
											'Admin'
										)
									),
									_react2.default.createElement(
										_dropdown2.default,
										{ attachTo: function attachTo() {
												return _this3.getRef('accountAdmin');
											}, pointTo: 'TOP_LEFT', browser: this.props.browser },
										_react2.default.createElement(
											'ol',
											null,
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: (0, _routes.accountRoute)('/admin/jury-overview') },
													'Jury Overview'
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(_splitter2.default, null),
					this.props.children || _react2.default.createElement('div', null)
				);
			}
		}, {
			key: 'getRef',
			value: function getRef(name) {
				return this.refs[name];
			}
		}, {
			key: 'isPartOfProfile',
			value: function isPartOfProfile() {
				return !!this.props.users.profile;
			}
		}, {
			key: 'renderHeadSwitcher',
			value: function renderHeadSwitcher(text) {
				var buttonClass = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
				return _react2.default.createElement(
					'div',
					{ className: 'hide-desktop hide-tablet account__head-switch' },
					_react2.default.createElement(
						'button',
						{ className: 'button ' + (buttonClass ? ' ' + buttonClass : ''), onClick: this.switchActiveHead.bind(this) },
						text
					)
				);
			}
		}, {
			key: 'switchActiveHead',
			value: function switchActiveHead() {
				this.setState(_extends({}, this.state, {
					show: this.state.show === SHOW_USER_HEAD ? SHOW_PROFILE_HEAD : SHOW_USER_HEAD
				}));
			}
		}, {
			key: 'signOut',
			value: function signOut() {
				this.props.dispatch((0, _users.logout)());
			}
		}]);
	
		return Account;
	}(_react.Component);
	
	Account.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		router: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _connect2.default)(Account);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _validate = __webpack_require__(76);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _users = __webpack_require__(64);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _google = __webpack_require__(149);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountActivate = function (_Component) {
		_inherits(AccountActivate, _Component);
	
		function AccountActivate(props) {
			_classCallCheck(this, AccountActivate);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountActivate).call(this));
	
			_this2.FB = new _fb2.default();
			_this2.GGL = new _google2.default();
			_this2.TWT = new _twitter2.default();
	
			_this2.state = {
				msg: 0,
				error: false,
				waiting: false,
				fieldValidity: {
					emailInvalid: false,
					passwordInvalid: false
				}
			};
			return _this2;
		}
	
		_createClass(AccountActivate, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this3 = this;
	
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(''), this.props.users.isLoggedIn());
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(''), !this.props.router.params.hash);
	
				this.FB.load();
				this.GGL.load();
	
				if (this.props.router.params.hash) {
					setTimeout(function () {
						_this3.props.dispatch(_this3.confirmEmail(_this3.props.router.params.hash));
					}, 2000);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps, nState) {
				(0, _authorization.redirectToPathIf)(nProps.dispatch, this.props.router.location.query.returnTo || (0, _routes.accountRoute)(''), nProps.users.isLoggedIn());
	
				if (nProps.errors.error) {
					this.setState(_extends({}, nState, { waiting: false }));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'section',
					{ className: 'account-flow' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account activation' }),
					_react2.default.createElement(
						'header',
						{ className: 'span14 account-flow__head' },
						_react2.default.createElement(
							'div',
							{ className: 'span7 span13-mobile push5-desktop' },
							_react2.default.createElement(
								'h1',
								{ className: 'account-flow__head__title' },
								(0, _translate2.default)('account/activate/header' + this.state.msg)
							),
							_react2.default.createElement(
								'h2',
								{ className: 'account-flow__head__title account-flow__head__title--faded' },
								this.state.error ? this.state.error : (0, _translate2.default)('account/activate/subheader' + this.state.msg)
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: (0, _translate2.default)('account/activate/aside') },
						!this.state.msg && _react2.default.createElement(
							'div',
							{ className: 'span6 account-flow__form' },
							_react2.default.createElement(_spinner2.default, { size: '128px' })
						),
						!!this.state.msg && this.renderLogin(),
						!!this.state.msg && this.renderSocialLogin(),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'renderLogin',
			value: function renderLogin() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'span4 span6-tablet span14-mobile account-flow__form' },
					_react2.default.createElement(
						'header',
						{ className: 'block-label--relative' },
						(0, _translate2.default)('account/activate/formtitle')
					),
					_react2.default.createElement(
						'form',
						{ action: '', onSubmit: function onSubmit(e) {
								return _this4.handleSubmit(e);
							}, noValidate: true },
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span11-mobile account-flow__form__input',
							name: 'email',
							ref: 'email',
							type: 'email',
							required: 'required',
							placeholder: 'Email',
							manualValidate: true,
							validate: [{ rule: _validate.VALIDATE_EMAIL }]
						}),
						_react2.default.createElement('span', null),
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span11-mobile account-flow__form__input',
							name: 'password',
							ref: 'password',
							type: 'password',
							required: 'required',
							placeholder: 'Password',
							pattern: '^.{6,}$',
							manualValidate: true,
							validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }]
						}),
						_react2.default.createElement(
							_checkbox2.default,
							{ name: 'remember', ref: 'remember' },
							'Remember me next time'
						),
						_react2.default.createElement(_submit2.default, { name: 'Sign in', waiting: this.state.waiting, className: 'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go') })
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-flow__form__btw' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/recover'), className: 'account-flow__form__btw__link' },
							'Forgot password'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/register'), className: 'account-flow__form__btw__link' },
							'Sign up'
						)
					)
				);
			}
		}, {
			key: 'renderSocialLogin',
			value: function renderSocialLogin() {
				return _react2.default.createElement(
					'div',
					{ className: 'span3 span4-tablet span100p-mobile span account-flow__social' },
					_react2.default.createElement(
						'header',
						{ className: 'block-label--relative' },
						(0, _translate2.default)('account/activate/social')
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--fb account-flow__social__button', onClick: this.loginFB.bind(this) },
							'Facebook'
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--twt account-flow__social__button', onClick: this.loginTWT.bind(this) },
							'Twitter'
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--ggl account-flow__social__button', onClick: this.loginGGL.bind(this) },
							'Google'
						)
					)
				);
			}
		}, {
			key: 'confirmEmail',
			value: function confirmEmail(token) {
				var _this = this;
				return function (dispatch) {
					//dispatch(requestData());
					return _axios2.default.get(_baseUrl2.default + '/api/account/confirm', {
						params: {
							hash: token
						}
					}).then(function (response) {
						_this.setState(_extends({}, _this.state, { msg: 1 }));
					}).catch(function (response) {
						// do something on fail?!
						var error = false;
						if (response.data.hasOwnProperty('message')) {
							error = response.data.message;
						}
	
						_this.setState(_extends({}, _this.state, { msg: 2, error: error }));
					});
				};
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
				var fieldsToCheck = [this.refs.email, this.refs.password];
	
				if ((0, _validate.formIsValid)(fieldsToCheck)) {
					this.props.dispatch((0, _users.login)(this.refs.email.value(), this.refs.password.value(), this.refs.remember.value, this.stopWaiting.bind(this), this.stopWaiting.bind(this)));
					this.setState(_extends({}, this.state, { waiting: true }));
				} else {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'stopWaiting',
			value: function stopWaiting() {
				this.setState(_extends({}, this.state, { waiting: false }));
			}
		}, {
			key: 'loginFB',
			value: function loginFB() {
				this.FB.login(this.props.dispatch);
			}
		}, {
			key: 'loginGGL',
			value: function loginGGL() {
				this.GGL.login(this.props.dispatch);
			}
		}, {
			key: 'loginTWT',
			value: function loginTWT() {
				this.TWT.login(this.props.dispatch);
			}
		}]);
	
		return AccountActivate;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountActivate);

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _authorization = __webpack_require__(36);
	
	var _users = __webpack_require__(64);
	
	var _routes = __webpack_require__(4);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountLogout = function (_Component) {
		_inherits(AccountLogout, _Component);
	
		function AccountLogout(props) {
			_classCallCheck(this, AccountLogout);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(AccountLogout).call(this));
		}
	
		_createClass(AccountLogout, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.awardsRoute)(), !this.props.users.isLoggedIn());
	
				this.props.dispatch((0, _users.logout)());
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'account-logout' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Logout' })
				);
			}
		}]);
	
		return AccountLogout;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountLogout);

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _validate = __webpack_require__(76);
	
	var _authorization = __webpack_require__(36);
	
	var _routes = __webpack_require__(4);
	
	var _users = __webpack_require__(64);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _google = __webpack_require__(149);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountRecovery = function (_Component) {
		_inherits(AccountRecovery, _Component);
	
		function AccountRecovery(props) {
			_classCallCheck(this, AccountRecovery);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountRecovery).call(this));
	
			_this.FB = new _fb2.default();
			_this.GGL = new _google2.default();
			_this.TWT = new _twitter2.default();
	
			_this.state = {
				reset: false,
				waiting: false,
				done: false
			};
			return _this;
		}
	
		_createClass(AccountRecovery, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(''), this.props.users.isLoggedIn());
	
				this.FB.load();
				this.GGL.load();
	
				var reset = this.props.router.params.hash && /[\S]{64}-[0-9]*/.test(this.props.router.params.hash);
				this.setState(_extends({}, this.state, { reset: reset }));
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps, nState) {
				(0, _authorization.redirectToPathIf)(nProps.dispatch, this.props.router.location.query.returnTo || (0, _routes.accountRoute)(''), nProps.users.isLoggedIn());
	
				var reset = nProps.router.params.hash && /[\S]{64}-[0-9]*/.test(nProps.router.params.hash);
				this.setState(_extends({}, this.state, { reset: reset }));
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'section',
					{ className: 'account-flow' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Account recovery' }),
					_react2.default.createElement(
						'header',
						{ className: 'span14 account-flow__head' },
						_react2.default.createElement(
							'div',
							{ className: 'span7 span13-mobile push5-desktop' },
							_react2.default.createElement(
								'h1',
								{ className: 'account-flow__head__title' },
								(0, _translate2.default)('account/recover/header')
							),
							_react2.default.createElement(
								'h2',
								{ className: 'account-flow__head__title account-flow__head__title--faded' },
								(0, _translate2.default)('account/recover/subheader')
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: (0, _translate2.default)('account/recover/aside') },
						_react2.default.createElement(
							'div',
							{ className: 'span4 span6-tablet span100p-mobile account-flow__form' },
							_react2.default.createElement(
								'header',
								{ className: 'block-label--relative' },
								(0, _translate2.default)('account/recover/formtitle')
							),
							!this.state.reset && this.renderRequestResetForm(),
							this.state.reset && this.renderResetForm(),
							!this.state.done && _react2.default.createElement(
								'div',
								{ className: 'account-flow__form__btw' },
								'Don\'t have an account? ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.accountRoute)('/register'), className: 'account-flow__form__btw__link' },
									'Sign up'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'span3 span4-tablet span100p-mobile span account-flow__social' },
							_react2.default.createElement(
								'header',
								{ className: 'block-label--relative' },
								(0, _translate2.default)('account/recover/social')
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'button',
									{ className: 'button--fb account-flow__social__button', onClick: this.loginFB.bind(this) },
									'Facebook'
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'button',
									{ className: 'button--twt account-flow__social__button', onClick: this.loginTWT.bind(this) },
									'Twitter'
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'button',
									{ className: 'button--ggl account-flow__social__button', onClick: this.loginGGL.bind(this) },
									'Google'
								)
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'renderRequestResetForm',
			value: function renderRequestResetForm() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'form',
					{ action: '', onSubmit: function onSubmit(e) {
							return _this2.handleRequestResetSubmit(e);
						}, noValidate: true },
					_react2.default.createElement(_text2.default, {
						className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
						name: 'email',
						ref: 'email',
						type: 'email',
						required: 'required',
						placeholder: 'Email',
						manualValidate: true,
						validate: [{ rule: _validate.VALIDATE_EMAIL }]
					}),
					_react2.default.createElement(_submit2.default, { name: !this.state.done ? 'Reset password' : 'Instructions sent', waiting: this.state.waiting, className: 'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go') })
				);
			}
		}, {
			key: 'handleRequestResetSubmit',
			value: function handleRequestResetSubmit(e) {
				var _this3 = this;
	
				e.preventDefault();
	
				if (this.state.done) {
					return false;
				}
	
				var fieldsToValidate = [this.refs.email];
	
				if ((0, _validate.formIsValid)(fieldsToValidate)) {
					this.props.dispatch((0, _users.requestRecovery)(this.refs.email.value(), function () {
						_this3.setState(_extends({}, _this3.state, { waiting: false, done: true }));
					}, function () {
						_this3.setState(_extends({}, _this3.state, { waiting: false }));
					}));
	
					this.setState(_extends({}, this.state, { waiting: true }));
				} else {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'renderResetForm',
			value: function renderResetForm() {
				var _this4 = this;
	
				if (this.state.done) {
					_react2.default.createElement(
						'div',
						null,
						'Password was reset.'
					);
				}
	
				return _react2.default.createElement(
					'form',
					{ action: '', onSubmit: function onSubmit(e) {
							return _this4.handleResetSubmit(e);
						}, noValidate: true },
					_react2.default.createElement(_text2.default, {
						className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
						name: 'password',
						ref: 'password',
						type: 'password',
						required: 'required',
						placeholder: 'Enter new password',
						manualValidate: true,
						validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }]
					}),
					_react2.default.createElement('span', null),
					_react2.default.createElement(_text2.default, {
						className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
						name: 'password2',
						ref: 'password2',
						type: 'password',
						required: 'required',
						placeholder: 'Confirm new password',
						manualValidate: true,
						validate: [{ rule: _validate.VALIDATE_EQUALS_FIELD, params: function params() {
								return _this4.refs.password;
							} }]
					}),
					_react2.default.createElement(_submit2.default, { name: 'Reset password', waiting: this.state.waiting, className: 'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go') })
				);
			}
		}, {
			key: 'handleResetSubmit',
			value: function handleResetSubmit(e) {
				var _this5 = this;
	
				e.preventDefault();
	
				var fieldsToValidate = [this.refs.password, this.refs.password2];
	
				if ((0, _validate.formIsValid)(fieldsToValidate)) {
					this.props.dispatch((0, _users.resetPassword)(this.props.router.params.hash, this.refs.password.value(), function () {
						// done
						_this5.setState(_extends({}, _this5.state, { waiting: false, done: true }));
						_this5.props.dispatch((0, _users.getLogin)());
					}, function () {
						// on fail
						_this5.setState(_extends({}, _this5.state, { waiting: false }));
					}));
					this.setState(_extends({}, this.state, { waiting: true }));
				} else {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'loginFB',
			value: function loginFB() {
				this.FB.login(this.props.dispatch);
			}
		}, {
			key: 'loginGGL',
			value: function loginGGL() {
				this.GGL.login(this.props.dispatch);
			}
		}, {
			key: 'loginTWT',
			value: function loginTWT() {
				this.TWT.login(this.props.dispatch);
			}
		}]);
	
		return AccountRecovery;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountRecovery);

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(38);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _checkbox = __webpack_require__(50);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _content = __webpack_require__(12);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _validate = __webpack_require__(76);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _authorization = __webpack_require__(36);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _routes = __webpack_require__(4);
	
	var _fb = __webpack_require__(133);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _google = __webpack_require__(149);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _errors = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './login.scss';
	
	var AccountRegister = function (_Component) {
		_inherits(AccountRegister, _Component);
	
		function AccountRegister(props) {
			_classCallCheck(this, AccountRegister);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(AccountRegister).call(this));
	
			_this2.FB = new _fb2.default();
			_this2.GGL = new _google2.default();
			_this2.TWT = new _twitter2.default();
	
			_this2.state = {
				waiting: false,
				fieldValidity: {
					nameInvalid: false,
					tosInvalid: false,
					passwordInvalid: false,
					emailInvalid: false
				},
				signupComplete: false,
				name: false
			};
			return _this2;
		}
	
		_createClass(AccountRegister, [{
			key: 'componentWillMount',
			value: function componentWillMount(props) {
				(0, _authorization.redirectToPathIf)(this.props.dispatch, (0, _routes.accountRoute)(''), this.props.users.isLoggedIn());
	
				this.FB.load();
				this.GGL.load();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps, nState) {
				(0, _authorization.redirectToPathIf)(nProps.dispatch, (0, _routes.accountRoute)(''), nProps.users.isLoggedIn());
	
				if (nProps.users.msg) {
					this.setState(_extends({}, nState, { waiting: false }));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'section',
					{ className: 'account-flow' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Sign up' }),
					_react2.default.createElement(
						'header',
						{ className: 'span14 account-flow__head' },
						_react2.default.createElement(
							'div',
							{ className: 'span7 span13-mobile push5-desktop' },
							_react2.default.createElement(
								'h1',
								{ className: 'account-flow__head__title' },
								(0, _translate2.default)('account/register/header')
							),
							_react2.default.createElement(
								'h2',
								{ className: 'account-flow__head__title account-flow__head__title--faded' },
								(0, _translate2.default)('account/register/subheader')
							)
						)
					),
					_react2.default.createElement(
						_content2.default,
						{ title: (0, _translate2.default)('account/register/aside') },
						!this.state.signupComplete && this.renderSignup.bind(this)(),
						!this.state.signupComplete && this.renderSocialSignup.bind(this)(),
						this.state.signupComplete && this.renderSignupComplete.bind(this)(),
						_react2.default.createElement('div', { className: 'cf' })
					)
				);
			}
		}, {
			key: 'renderSignup',
			value: function renderSignup() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'span4 span6-tablet span100p-mobile account-flow__form' },
					_react2.default.createElement(
						'header',
						{ className: 'block-label--relative' },
						(0, _translate2.default)('account/register/formtitle')
					),
					_react2.default.createElement(
						'form',
						{ action: '', onSubmit: function onSubmit(e) {
								return _this3.handleSubmit(e);
							}, noValidate: true },
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
							name: 'name',
							ref: 'name',
							type: 'name',
							required: 'required',
							placeholder: 'Full name',
							validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 2 }]
						}),
						_react2.default.createElement('span', null),
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
							name: 'email',
							ref: 'email',
							type: 'email',
							required: 'required',
							placeholder: 'Email',
							manualValidate: true,
							validate: [{ rule: _validate.VALIDATE_EMAIL }]
						}),
						_react2.default.createElement('span', null),
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
							name: 'password',
							ref: 'password',
							type: 'password',
							required: 'required',
							placeholder: 'Password',
							pattern: '^.{6,}$',
							manualValidate: true,
							validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }]
						}),
						_react2.default.createElement('span', null),
						_react2.default.createElement(_text2.default, {
							className: 'span3 span4-tablet span100p-mobile account-flow__form__input',
							name: 'password2',
							ref: 'password2',
							type: 'password',
							required: 'required',
							placeholder: 'Confirm password',
							pattern: '^.{6,}$',
							manualValidate: true,
							validate: [{ rule: _validate.VALIDATE_MIN_LENGTH, params: 6 }, { rule: _validate.VALIDATE_EQUALS_FIELD, params: function params() {
									return _this3.refs.password;
								} }]
						}),
						_react2.default.createElement(
							_checkbox2.default,
							{
								name: 'tos',
								ref: 'tos',
								manualValidate: true,
								validate: [{ rule: _validate.VALIDATE_CHECKED }]
							},
							'I am aware of the ',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.genericRoute)(false, 'terms-conditions'), target: '_blank' },
								'FWA Terms'
							),
							' and ',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: (0, _routes.genericRoute)(false, 'privacy-statement'), target: '_blank' },
								'Privacy Statement'
							)
						),
						_react2.default.createElement(_submit2.default, {
							name: 'Sign up',
							waiting: this.state.waiting,
							className: 'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go')
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'account-flow__form__btw' },
						'Already a user? ',
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.accountRoute)('/login'), className: 'account-flow__form__btw__link' },
							'Sign in'
						)
					)
				);
			}
		}, {
			key: 'renderSocialSignup',
			value: function renderSocialSignup() {
				return _react2.default.createElement(
					'div',
					{ className: 'span3 span4-tablet span100p-mobile span account-flow__social' },
					_react2.default.createElement(
						'header',
						{ className: 'block-label--relative' },
						(0, _translate2.default)('account/register/social')
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--fb account-flow__social__button', onClick: this.registerFB.bind(this) },
							'Facebook'
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--twt account-flow__social__button', onClick: this.registerTWT.bind(this) },
							'Twitter'
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'button--ggl account-flow__social__button', onClick: this.registerGGL.bind(this) },
							'Google'
						)
					)
				);
			}
		}, {
			key: 'renderSignupComplete',
			value: function renderSignupComplete() {
				return _react2.default.createElement(
					'div',
					{ className: 'span4 span6-tablet span100p-mobile account-flow__form' },
					'Great, ',
					this.state.name ? this.state.name + ',' : '',
					' your user account has been created.',
					_react2.default.createElement('br', null),
					'We\'ve sent an email from where you can activate it.'
				);
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
				var fieldsToValidate = [this.refs.name, this.refs.email, this.refs.password, this.refs.password2, this.refs.tos];
	
				if ((0, _validate.formIsValid)(fieldsToValidate)) {
					this.setState(_extends({}, this.state, { waiting: true }));
					this.register.bind(this)(this.refs.name.value(), this.refs.email.value(), this.refs.password.value());
				} else {
					this.setState(_extends({}, this.state, { waiting: false }));
				}
			}
		}, {
			key: 'register',
			value: function register(name, email, password) {
				var _this4 = this;
	
				var _this = this;
				return _axios2.default.post(_baseUrl2.default + '/api/account/signup', _qs2.default.stringify({
					name: name,
					email: email,
					password: password
				})).then(function (response) {
					_this4.setState(_extends({}, _this4.state, { signupComplete: true, waiting: false, name: name }));
				}).catch(function (response) {
					_this4.setState(_extends({}, _this4.state, { signupComplete: false, waiting: false }));
	
					_this4.props.dispatch((0, _errors.dispatchError)(response.data));
				});
			}
		}, {
			key: 'registerFB',
			value: function registerFB() {
				this.FB.register(this.props.dispatch);
			}
		}, {
			key: 'registerGGL',
			value: function registerGGL() {
				this.GGL.register(this.props.dispatch);
			}
		}, {
			key: 'registerTWT',
			value: function registerTWT() {
				this.TWT.register(this.props.dispatch);
			}
		}]);
	
		return AccountRegister;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(AccountRegister);

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _browser = __webpack_require__(378);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _header = __webpack_require__(635);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(621);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _frontpageonboard = __webpack_require__(626);
	
	var _frontpageonboard2 = _interopRequireDefault(_frontpageonboard);
	
	var _timeline = __webpack_require__(377);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _notice = __webpack_require__(664);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	var _errors = __webpack_require__(29);
	
	var ErrorActions = _interopRequireWildcard(_errors);
	
	var _browser2 = __webpack_require__(583);
	
	var BrowserActions = _interopRequireWildcard(_browser2);
	
	var _menus = __webpack_require__(349);
	
	var MenuActions = _interopRequireWildcard(_menus);
	
	var _cases = __webpack_require__(232);
	
	var CaseActions = _interopRequireWildcard(_cases);
	
	var _editorials = __webpack_require__(130);
	
	var EditorialActions = _interopRequireWildcard(_editorials);
	
	var _users = __webpack_require__(64);
	
	var UserActions = _interopRequireWildcard(_users);
	
	var _timelines = __webpack_require__(350);
	
	var TimelineActions = _interopRequireWildcard(_timelines);
	
	var _without = __webpack_require__(1209);
	
	var _without2 = _interopRequireDefault(_without);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { connect } from 'react-redux';
	
	
	var MENU_CLASSES = ['', 'body--menu', 'body--context-menu'];
	
	var App = function (_Component) {
		_inherits(App, _Component);
	
		function App(props) {
			_classCallCheck(this, App);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this, props));
	
			(0, _redux.bindActionCreators)(BrowserActions.listenToBrowserResize, props.dispatch)();
			_this.footerMagic = _this.footerMagic.bind(_this);
	
			setTimeout(function () {
				props.dispatch(BrowserActions.updateBrowserSize());
			}, 100);
	
			_this.actions = {
				errorActions: (0, _redux.bindActionCreators)(ErrorActions, props.dispatch),
				menuActions: (0, _redux.bindActionCreators)(MenuActions, props.dispatch),
				caseActions: (0, _redux.bindActionCreators)(CaseActions, props.dispatch),
				editorialActions: (0, _redux.bindActionCreators)(EditorialActions, props.dispatch),
				userActions: (0, _redux.bindActionCreators)(UserActions, props.dispatch),
				timelineActions: (0, _redux.bindActionCreators)(TimelineActions, props.dispatch)
			};
	
			if (!props.users.id) {
				_this.actions.userActions.getLogin();
			}
	
			if (props.params.menuactive) {
				_this.state.menuActive = true;
			}
			return _this;
		}
	
		_createClass(App, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				// if (!this.props.menu.mainMenu.length) {
				// 	this.actions.menuActions.fetchMenu('header');
				// }
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.browser.scroll.register(this.footerMagic);
				// this.props.browser.setDocumentElement(this.refs.appscroller);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var _document$body$classL;
	
				var removeClasses = _without2.default.apply(undefined, [MENU_CLASSES].concat(['', this.getMenuActiveClass()]));
	
				// console.log(this.state.menuActive + ' - ' + this.getMenuActiveClass());
				removeClasses.length && (_document$body$classL = document.body.classList).remove.apply(_document$body$classL, _toConsumableArray(removeClasses));
				if (this.getMenuActiveClass()) {
					document.body.classList.add(this.getMenuActiveClass());
				}
	
				this.footerMagic();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.browser.scroll.deregister(this.footerMagic);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				// let stickyFooterStyles = {};
				// if (this.state.footerHeight) {
				// 	stickyFooterStyles = {
				// 		paddingBottom: this.state.footerHeight + 'px',
				// 		marginBottom: '-' + this.state.footerHeight + 'px',
				// 	};
				// }
	
				return _react2.default.createElement(
					'div',
					{
						ref: 'appContainer',
						onClick: function onClick() {
							if (_this2.props.menu.menuActive || _this2.props.menu.searchActive) _this2.props.dispatch({ type: 'MENU_CLOSE' });
						}
					},
					_react2.default.createElement(
						'div',
						{ className: 'app-container' },
						_react2.default.createElement(_header2.default, _extends({
							browser: this.props.browser
						}, this.actions, this.props.menu, {
							editorials: this.props.editorials,
							cases: this.props.cases,
							categories: this.props.categories,
							showTimelineFilter: this.isTimeline(),
							timelines: this.props.timelines,
							user: this.props.users,
							ads: this.props.ads,
							dispatch: this.props.dispatch,
							errors: this.props.errors
						})),
						_react2.default.createElement(_frontpageonboard2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'main-container' },
							this.props.children || _react2.default.createElement(_timeline2.default, null)
						),
						_react2.default.createElement(_footer2.default, { footerItems: this.props.menu.footer && this.props.menu.footer.items ? this.props.menu.footer.items : [] }),
						_react2.default.createElement(_notice2.default, null)
					)
				);
			}
		}, {
			key: 'isTimeline',
			value: function isTimeline() {
				if (this.props.router && this.props.router.routes && this.props.router.routes.length) {
					return this.props.router.routes[this.props.router.routes.length - 1].showFilter;
				}
	
				// return (
				//	(typeof this.props.children === 'undefined') ||
				//	(this.props.children.type.displayName === 'Connect(Timeline)')
				// );
				return false;
			}
		}, {
			key: 'onScroll',
			value: function onScroll() {
				_browser.EventEmitter.emit(_browser.BROWSER_SCROLLED, {
					scrollY: this.refs.appscroller.scrollTop
				});
				// let newPerf = performance.now();
				// console.log(this.refs.appscroller.scrollTop + ' - DIFF: ' + (newPerf - oldPerf));
				// oldPerf = newPerf;
			}
		}, {
			key: 'getMenuActiveClass',
			value: function getMenuActiveClass() {
				return this.props.menu.menuActive || this.props.menu.searchActive ? MENU_CLASSES[1] : MENU_CLASSES[0];
			}
	
			// _handleResize() {
			// 	var footerHeight = document.querySelector('.footer-container').clientHeight;
			// }
	
		}, {
			key: 'footerMagic',
			value: function footerMagic(scroll) {
				var contextualMenu = document.querySelector('.contextual-menu__control');
				var footerContainer = document.querySelector('.footer-container');
	
				if (contextualMenu && footerContainer && scroll) {
					var context = contextualMenu;
					var footer = footerContainer;
	
					if (scroll.scrollY + this.props.browser.window.height >= footer.offsetTop) {
						var push = -(scroll.scrollY + this.props.browser.window.height - footer.offsetTop);
						push += 'px';
						push = 'translatey(' + push + ')';
						context.style.transform = push;
					} else {
						var _push = 0;
						_push += 'px';
						_push = 'translatey(' + _push + ')';
						context.style.transform = _push;
					}
				}
			}
		}]);
	
		return App;
	}(_react.Component);
	
	App.propTypes = {
		browser: _react.PropTypes.object.isRequired,
		dispatch: _react.PropTypes.func.isRequired,
		users: _react.PropTypes.object.isRequired,
		params: _react.PropTypes.object.isRequired,
		menu: _react.PropTypes.object.isRequired,
		editorials: _react.PropTypes.object.isRequired,
		cases: _react.PropTypes.object.isRequired,
		categories: _react.PropTypes.object.isRequired,
		timelines: _react.PropTypes.object.isRequired,
		ads: _react.PropTypes.object.isRequired,
		errors: _react.PropTypes.object.isRequired,
		router: _react.PropTypes.object.isRequired,
		children: _react.PropTypes.object
	};
	exports.default = (0, _connect2.default)(App);

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _date = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _index = __webpack_require__(4);
	
	var _formatCredits = __webpack_require__(78);
	
	var _formatCredits2 = _interopRequireDefault(_formatCredits);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _threeimages = __webpack_require__(373);
	
	var _threeimages2 = _interopRequireDefault(_threeimages);
	
	var _comments = __webpack_require__(611);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _evolution = __webpack_require__(620);
	
	var _evolution2 = _interopRequireDefault(_evolution);
	
	var _relatedinterviews = __webpack_require__(371);
	
	var _relatedinterviews2 = _interopRequireDefault(_relatedinterviews);
	
	var _relatedcases = __webpack_require__(238);
	
	var _relatedcases2 = _interopRequireDefault(_relatedcases);
	
	var _relatedjobs = __webpack_require__(372);
	
	var _relatedjobs2 = _interopRequireDefault(_relatedjobs);
	
	var _contextual = __webpack_require__(147);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _player = __webpack_require__(97);
	
	var _countdown = __webpack_require__(178);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _getCategoryName = __webpack_require__(148);
	
	var _getCategoryName2 = _interopRequireDefault(_getCategoryName);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _case = __webpack_require__(1040);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _cases = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components Import
	
	
	// Extra
	
	
	var Case = function (_Component) {
		_inherits(Case, _Component);
	
		function Case(props) {
			_classCallCheck(this, Case);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Case).call(this));
	
			_this.state = {
				timeLeft: 0,
				loading: true,
				showVideo: false,
				autoplay: true
			};
	
			_this.timeInterval = false;
			_this.metaDesc = '';
			_this.didScroll = false;
			_this.shouldAutoplay = _this.shouldAutoplay.bind(_this);
			return _this;
		}
	
		_createClass(Case, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.timeInterval);
				this.clearCases();
				this.props.browser.scroll.deregister(this.shouldAutoplay);
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchSingle = (0, _redux.bindActionCreators)(_cases.fetchSingleCase, this.props.dispatch);
				this.clearCases = (0, _redux.bindActionCreators)(_cases.clearAction, this.props.dispatch);
	
				var preview = false;
				if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
					preview = this.props.router.location.query.preview;
				}
	
				if (this.props.routeParams.slug && this.props.routeParams.slug !== this.props.cases.single.slug) {
					this.fetchSingle(this.props.routeParams.slug, preview);
					if (!this.state.loading) {
						this.setState({
							loading: true
						});
					}
				}
	
				this.props.browser.scroll.register(this.shouldAutoplay);
			}
		}, {
			key: 'shouldAutoplay',
			value: function shouldAutoplay(ev) {
				if (ev.scrollY > 850 && this.state.autoplay) {
					this.setState({
						autoplay: false
					});
				} else if (ev.scrollY < 850 && this.state.autoplay === false) {
					this.setState({
						autoplay: true
					});
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps, nextState) {
				var preview = false;
				var newState = {};
				if (nextProps.router.location && nextProps.router.location.query && nextProps.router.location.query.preview) {
					preview = nextProps.router.location.query.preview;
				}
	
				if (this.props.routeParams.slug !== nextProps.routeParams.slug) {
					this.fetchSingle(nextProps.routeParams.slug, preview);
					if (!this.state.loading) {
						newState.loading = true;
					}
				}
	
				if (nextState.loading && nextProps.routeParams.slug === nextProps.cases.single.slug && (!nextProps.cases.single.slide1 || !nextProps.cases.single.slide2 || !nextProps.cases.single.slide3)) {
					newState.loading = false;
				}
	
				Object.keys(newState).length && this.setState(newState);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextState.showVideo !== this.state.showVideo || nextProps.browser.window.width !== this.props.browser.window.width || nextProps.cases.single.id !== this.props.cases.single.id || this.props.users._id !== nextProps.users._id || nextState !== this.state;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				// if (
				// 	this.state.loading === true &&
				// 	nextProps.cases.single.id !== this.props.cases.single.id
				// ) {
				// 	this.setState({
				// 		loading: false,
				// 	});
				// }
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (window.location.hash && window.location.hash == '#case-extras' && !this.didScroll) {
					var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -100, duration: 700 });
					scroller.to('#case-extras');
					this.didScroll = true;
					// console.log('Hall');
				}
			}
	
			// componentWillReceiveProps(nextProps) {
			// 	if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
			// 		//this.fetchSingle(nextProps.routeParams.slug);
			// 	}
			// }
	
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var item = this.props.cases.single;
				var awardTitle = '';
	
				var createdDate = new _date.DateFormatter(item.sortedDate);
	
				var winDate = new _date.DateFormatter();
				var awardDate = 0;
	
				var awardDates = [];
				var awards = [];
	
				var hasFOTD = false;
				var hasMOTD = false;
				var fotdText = '';
				var fotdDate = '';
	
				var transitionClass = 'page__transition';
	
				if (this.state.loading) {
					transitionClass += ' page__transition--transitioning';
				}
	
				var otherAwards = [];
	
				(0, _forEach2.default)(item.awards, function (award, i) {
					awardDates[i] = award.awardedDate;
					awards[award.awardedDate] = award.name;
	
					if (award.type == 'FOTD') {
						hasFOTD = true;
						fotdText = award.name;
						fotdDate = award.awardedDate;
					} else {
	
						if (award.type == 'MOTD' && !hasFOTD) {
							hasMOTD = true;
							fotdText = award.name;
							fotdDate = award.awardedDate;
						} else {
							otherAwards.push(award);
						}
					}
				});
	
				if (!hasFOTD && !hasMOTD) {
					fotdText = 'submitted project -';
					fotdDate = item.timestamp * 1000;
				}
	
				var isVoting = false;
	
				var evolutionShow = false;
				var pointsShow = false;
	
				awardDates.sort();
	
				awardTitle = awards[awardDates[awardDates.length - 1]];
				awardDate = awardDates[awardDates.length - 1];
	
				var useDate = new _date.DateFormatter(fotdDate);
	
				if (!item.awards && item.days < 15) {
					isVoting = true;
				}
	
				if (item.evolution && item.evolution.length && hasFOTD || item.evolution && item.evolution.length && isVoting) {
					evolutionShow = true;
				}
	
				if (!item.legacy && hasFOTD || !item.legacy && isVoting) {
					pointsShow = true;
				}
	
				var leftString = '';
	
				var imgSpan = { desktop: 'span9', tablet: 'span14', mobile: 'span12' };
				var slides = [];
	
				//pointsShow = true;
				for (var i = 1; i <= 3; i++) {
					var currentImage = item['slide' + i];
					currentImage && slides.push(_react2.default.createElement(_image2.default, { key: 'slide' + i, img: currentImage, span: imgSpan, alt: '', browser: this.props.browser, onLoad: function onLoad() {
							return _this2.onImageLoaded();
						} }));
				}
	
				!!item.showreelUrl && slides.push(_react2.default.createElement(_player.PlayerTrigger, { key: 'slideVideo', url: item.showreelUrl, codaClass: 'slide-coda__item--is-video', skipSlide: true, onClick: function onClick(e) {
						_this2.setState(_extends({}, _this2.state, {
							showVideo: !_this2.state.showVideo
						}));
					} }));
	
				if (item.meta && item.meta.description !== this.metaDesc) {
					(0, _meta2.default)(item.meta.description);
					this.metaDesc = item.meta.description;
				}
	
				return _react2.default.createElement(
					'div',
					null,
					item.title && _react2.default.createElement(
						'article',
						{ className: 'case-single span14 margin-bottom-contextual' },
						_react2.default.createElement(_reactHelmet2.default, { title: item.title + ' - The FWA' }),
						_react2.default.createElement(
							'div',
							{ className: transitionClass },
							item.secondsLeftFotd && _react2.default.createElement(
								'div',
								{ className: 'case-single__time-left span14' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__time-left__left span5 span4-tablet span14-mobile' },
									_react2.default.createElement(
										'span',
										{ className: 'case-single__time-left__left__title' },
										'Time left in front of the jury:'
									)
								),
								_react2.default.createElement(_countdown2.default, { timeLeft: item.secondsLeftFotd, spans: 'span9 span10-tablet span14-mobile' }),
								_react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5 hide-tablet hide-mobile' }),
								_react2.default.createElement('div', { className: 'case-single__spacer case-single__spacer--white span7-mobile span5 hide-tablet hide-desktop' })
							),
							!!otherAwards.length && _react2.default.createElement(
								'div',
								{ className: 'case-single__extra-awards span14' },
								_react2.default.createElement('div', { className: 'case-single__extra-awards__left span5 span4-tablet span2-mobile' }),
								_react2.default.createElement(
									_carousel2.default,
									{ autoplay: true, timer: 6000, sliderClass: 'case-single__extra-awards__slider span9 span10-tablet span12-mobile', decoClass: 'case-single__extra-awards__deco' },
									otherAwards.map(function (award, i) {
										return _this2.renderAward(award, i);
									})
								),
								_react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5 hide-tablet hide-mobile' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-single__details span5 span14-tablet span14-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__details__top' },
									_react2.default.createElement(
										'div',
										{ className: 'case-single__details__top__share' },
										_react2.default.createElement(_share2.default, { handle: this.shareHandle, title: item.title, url: window.location.href, browser: this.props.browser })
									),
									_react2.default.createElement(
										'div',
										{ className: 'case-single__details__top__date span2 span4-tablet span4-tablet-plus span14-mobile pixel-pattern' },
										_react2.default.createElement(_pixeltext2.default, { text: useDate.date, className: 'case-single__details__day' }),
										_react2.default.createElement(
											'span',
											{ className: 'case-single__details__month' },
											useDate.month,
											' ',
											useDate.year !== new Date().getYear() ? useDate.year : ''
										),
										_react2.default.createElement(
											'span',
											{ className: 'case-single__details__award' },
											fotdText
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__details__bottom hide-tablet hide-mobile' },
									_react2.default.createElement(
										'div',
										{ className: 'case-single__details__content' },
										item.title && _react2.default.createElement(
											'span',
											{ className: 'case-single__details__type' },
											(0, _getCategoryName2.default)(item.caseTypes.name, item.bestViewedOn)
										),
										_react2.default.createElement(
											'h1',
											{ className: 'case-single__details__title' },
											item.title
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'span14-tablet span12-mobile case-single__slider-holder span9 pixel-pattern pixel-pattern--dark' },
								_react2.default.createElement(
									_carousel2.default,
									{ autoplay: this.state.autoplay },
									slides
								),
								hasFOTD && _react2.default.createElement('div', { className: 'ribbon-fotd ribbon-fotd--br' }),
								!!item.showreelUrl && _react2.default.createElement(_player.Player, { url: item.showreelUrl, showVideo: this.state.showVideo, onClose: function onClose() {
										_this2.setState(_extends({}, _this2.state, { showVideo: false }));
									}, browser: this.props.browser })
							),
							_react2.default.createElement('div', { className: 'span2 hide-desktop hide-tablet case-single__slider-dots' + (pointsShow ? ' case-single__slider-dots--wpoints' : '') }),
							pointsShow && _react2.default.createElement(
								'div',
								{ className: 'case-single__meta-scorecard span5 span8-tablet pixel-pattern span12-mobile hide-tablet hide-desktop' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__stats hide-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__points', ref: 'pointsTooltipTablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'Points:'
									),
									item.points && _react2.default.createElement(
										'span',
										{ className: 'case-single__meta-scorecard__number' },
										(0, _date.formatNumber)(item.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__days' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'case-single__meta-scorecard__number' },
										item.days
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'case-single__details--small span8 hide-desktop span14-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__details--small__content' },
									item.title && _react2.default.createElement(
										'span',
										{ className: 'case-single__details__type' },
										(0, _getCategoryName2.default)(item.caseTypes.name, item.bestViewedOn)
									),
									_react2.default.createElement(
										'h1',
										{ className: 'case-single__details__title span5 span100p-mobile' },
										item.title
									)
								)
							),
							pointsShow && _react2.default.createElement(
								'div',
								{ className: 'case-single__meta-scorecard span5 span8-tablet pixel-pattern hide-mobile' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__stats hide-mobile' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'FWA award stats:'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__points', ref: 'pointsTooltipTablet' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'Points:'
									),
									item.points && _react2.default.createElement(
										'span',
										{ className: 'case-single__meta-scorecard__number' },
										(0, _date.formatNumber)(item.points)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__meta-scorecard__days' },
									_react2.default.createElement(
										'h3',
										{ className: 'case-single__meta-scorecard__title' },
										'Days:'
									),
									_react2.default.createElement(
										'span',
										{ className: 'case-single__meta-scorecard__number' },
										item.days
									)
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'span14 case-single__description' },
								_react2.default.createElement(
									'div',
									{ className: 'case-single__description__buttons span14-mobile' },
									item.comments && _react2.default.createElement(
										'a',
										{ href: '#comments', onClick: function onClick(event) {
												return _this2.sweetScroll(event);
											}, className: 'case-single__description__button button' },
										'Discuss the project (',
										item.comments.length,
										')'
									),
									item.url && _react2.default.createElement(
										'a',
										{ href: item.url, target: '_blank', className: 'case-single__description__button button--go button--dark button' },
										'Launch Project'
									) || _react2.default.createElement(
										'span',
										{ className: 'case-single__description__button button--dark button' },
										'Project offline'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'case-single__description__content span10 span14-mobile' },
									_react2.default.createElement(
										'h2',
										{ className: 'case-single__description__title' },
										'description:'
									),
									_react2.default.createElement(
										'p',
										{ className: 'case-single__description__text' },
										item.description
									)
								)
							),
							(item.extraText || item.extraTitle) && _react2.default.createElement(
								'section',
								{ className: 'span14 case-single__extra', id: 'case-extras' },
								_react2.default.createElement(
									'div',
									{ className: 'span5 span14-tablet span14-mobile' },
									_react2.default.createElement(
										'h2',
										{ className: 'case-single__extra__title span3 span5-tablet span11-mobile' },
										item.extraTitle
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'span9 span14-tablet span14-mobile' },
									_react2.default.createElement(
										'p',
										{ className: 'span8 span13-tablet span13-mobile case-single__extra__text' },
										item.extraText
									)
								)
							),
							!item.legacy && _react2.default.createElement(
								'section',
								{ className: 'span9 case-single__credits span14-mobile' },
								_react2.default.createElement(
									'h2',
									{ className: 'case-single__credits__title' },
									'Credits:'
								),
								_react2.default.createElement(
									'p',
									{ className: 'case-single__credits__profiles' },
									(0, _formatCredits2.default)(item.profiles)
								)
							) || _react2.default.createElement(
								'section',
								{ className: 'span5 case-single__credits solo span14-mobile' },
								_react2.default.createElement(
									'h2',
									{ className: 'case-single__credits__title' },
									'Credits:'
								),
								_react2.default.createElement(
									'p',
									{ className: 'case-single__credits__profiles' },
									(0, _formatCredits2.default)(item.profiles)
								)
							),
							(item.extra1 || item.extra1Video) && (item.extra2 || item.extra2Video) && (item.extra3 || item.extra3Video) && _react2.default.createElement(_threeimages2.default, {
								imgone: item.extra1,
								imgtwo: item.extra2,
								imgthree: item.extra3,
								video1: item.extra1Video,
								video2: item.extra2Video,
								video3: item.extra3Video,
								browser: this.props.browser
							}),
							item.extra1 && item.extra2 && item.extra3 && _react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5' }),
							_react2.default.createElement('div', { className: 'cf' }),
							!!evolutionShow && _react2.default.createElement(_evolution2.default, { evolution: item.evolution, awardDate: awardDate, fotdText: fotdText, hasFOTD: hasFOTD, points: item.points, days: item.days, browser: this.props.browser }),
							evolutionShow && _react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5' }),
							!!(item.relatedInterviews && item.relatedInterviews.length) && _react2.default.createElement(_relatedinterviews2.default, { interviews: item.relatedInterviews, browser: this.props.browser, title: 'Related Interviews' }),
							!!(item.relatedInterviews && item.relatedInterviews.length) && _react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5' }),
							!!(item.relatedJobs && item.relatedJobs.length) && _react2.default.createElement(_relatedjobs2.default, { jobs: item.relatedJobs, title: 'Related Jobs', browser: this.props.browser }),
							!!(item.relatedJobs && item.relatedJobs.length) && _react2.default.createElement('div', { className: 'case-single__spacer span7-mobile pixel-pattern span5' }),
							_react2.default.createElement('div', { className: 'cf' }),
							_react2.default.createElement(_comments2.default, { slug: item.slug, dispatch: this.props.dispatch, title: item.title, users: this.props.users, comments: item.comments, browser: this.props.browser }),
							!!(item.relatedCases && item.relatedCases.length) && _react2.default.createElement('div', { className: 'case-single__spacer span7-mobile case-single__spacer span7-mobile--border pixel-pattern span5' }),
							!!(item.relatedCases && item.relatedCases.length) && _react2.default.createElement(_relatedcases2.default, {
								id: item.id,
								typeSlug: 'cases',
								parentSlug: item.slug,
								cases: item.relatedCases,
								browser: this.props.browser,
								names: item.profiles.map(function (profile, i) {
									return _this2.profileWithUrl(profile, i, item.profiles);
								}),
								total: item.relatedCasesCount
							}),
							_react2.default.createElement('div', { className: 'cf' })
						),
						!!(otherAwards.length || hasFOTD || hasMOTD) && _react2.default.createElement(_contextual2.default, { next: item.next, prev: item.prev, enableCases: true })
					)
				);
			}
		}, {
			key: 'onImageLoaded',
			value: function onImageLoaded() {
				if (this.state.loading) {
					this.setState({
						loading: false
					});
				}
			}
		}, {
			key: 'renderAward',
			value: function renderAward(award, i) {
				var uid = 'extraAward' + i;
				var date = new _date.DateFormatter(award.awardFor);
	
				return _react2.default.createElement(
					'div',
					{ key: uid, className: 'case-single__extra-awards__award span9 span10-tablet span12-mobile' },
					_react2.default.createElement('div', { className: 'ribbon-' + award.type.toLowerCase() + ' ribbon-' + award.type.toLowerCase() + '--tr' }),
					_react2.default.createElement(
						'span',
						{ className: 'case-single__extra-awards__award__name' },
						award.name + ' '
					),
					award.type == 'FOTM' && _react2.default.createElement(
						'span',
						{ className: 'case-single__extra-awards__award__date' },
						date.month + ' ' + date.year
					),
					award.type == 'TCEA' && _react2.default.createElement(
						'span',
						{ className: 'case-single__extra-awards__award__date' },
						date.date + ' ' + date.monthShort + ' ' + date.year
					),
					award.type == 'FOTY' && _react2.default.createElement(
						'span',
						{ className: 'case-single__extra-awards__award__date' },
						date.year
					),
					award.type == 'TCEAY' && _react2.default.createElement(
						'span',
						{ className: 'case-single__extra-awards__award__date' },
						date.year
					)
				);
			}
		}, {
			key: 'sweetScroll',
			value: function sweetScroll(e) {
				e.preventDefault();
				var scroller = new _sweetScroll2.default({ easing: 'easeOutQuint', offset: -60, duration: 700 });
				scroller.to('#comment');
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'renderInterview',
			value: function renderInterview(interview, i) {
				var createdDate = new _date.DateFormatter(interview.createdDate);
				var uid = interview.uid || 'interview' + interview.id;
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'related-interviews__interview' },
					_react2.default.createElement(_image2.default, { className: 'related-interviews__interview__image span5 hide-mobile', img: interview.image, span: 'span14', alt: '', browser: this.props.browser }),
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__interview__buttons-container span5 span14-mobile' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _index.editorialRoute)(interview.slug), className: 'related-interviews__interview__button button' },
							'Read Interview ',
							_react2.default.createElement('i', { className: 'arrow' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__interview__date span2 pixel-pattern hide-tablet hide-mobile' },
						_react2.default.createElement(_pixeltext2.default, { text: createdDate.date, className: 'related-interviews__interview__day', y: '15px', textAnchor: 'end' }),
						_react2.default.createElement(
							'span',
							{ className: 'related-interviews__interview__month' },
							createdDate.month
						),
						_react2.default.createElement(
							'span',
							{ className: 'related-interviews__interview__award' },
							'Interview —'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'related-interviews__interview__right span7 span9-tablet span14-mobile' },
						_react2.default.createElement(
							'h4',
							{ className: 'related-interviews__interview__byline' },
							'By ',
							interview.users.name
						),
						_react2.default.createElement(
							'h4',
							{ className: 'related-interviews__interview__small-date hide-desktop' },
							createdDate.date + ' ' + createdDate.month + ', ' + createdDate.year
						),
						_react2.default.createElement(
							'div',
							{ className: 'related-interviews__interview__content' },
							_react2.default.createElement(
								'h3',
								{ className: 'related-interviews__interview__title' },
								interview.title
							),
							_react2.default.createElement(
								'p',
								{ className: 'related-interviews__interview__text' },
								interview.excerpt
							)
						)
					)
				);
			}
		}, {
			key: 'formatProfiles',
			value: function formatProfiles() {
				var profiles = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
				var names = [];
	
				for (var i = 0; i < profiles.length; i++) {
					if (profiles[i].name) {
						names.push(profiles[i].name);
					}
				}
	
				return names.join(', ');
			}
		}, {
			key: 'profileWithUrl',
			value: function profileWithUrl(profile, i, profiles) {
				var uid = 'profile' + i;
				var url = (0, _index.profilesRoute)(profile.slug);
				var split = '';
	
				if (profiles.length > 1) {
					split = ', ';
				}
	
				if (i == profiles.length - 1) {
					split = '';
				} else if (i == profiles.length - 2) {
					split = ' and ';
				}
	
				return _react2.default.createElement(
					'span',
					{ key: uid, className: 'related-cases__agencies' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: url },
						profile.name
					),
					split
				);
			}
		}]);
	
		return Case;
	}(_react.Component);
	
	Case.propTypes = {
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _connect2.default)(Case);

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.accountPages = undefined;
	
	var _app = __webpack_require__(661);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _timeline = __webpack_require__(377);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _livejudging = __webpack_require__(671);
	
	var _livejudging2 = _interopRequireDefault(_livejudging);
	
	var _case = __webpack_require__(662);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _profile = __webpack_require__(677);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _profiles = __webpack_require__(678);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _editorial = __webpack_require__(665);
	
	var _editorial2 = _interopRequireDefault(_editorial);
	
	var _page = __webpack_require__(676);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _errorPage = __webpack_require__(666);
	
	var _errorPage2 = _interopRequireDefault(_errorPage);
	
	var _jobs = __webpack_require__(668);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _news = __webpack_require__(673);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _newsSingle = __webpack_require__(674);
	
	var _newsSingle2 = _interopRequireDefault(_newsSingle);
	
	var _job = __webpack_require__(667);
	
	var _job2 = _interopRequireDefault(_job);
	
	var _jury = __webpack_require__(669);
	
	var _jury2 = _interopRequireDefault(_jury);
	
	var _account = __webpack_require__(656);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(240);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(660);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _activate = __webpack_require__(657);
	
	var _activate2 = _interopRequireDefault(_activate);
	
	var _logout = __webpack_require__(658);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _recover = __webpack_require__(659);
	
	var _recover2 = _interopRequireDefault(_recover);
	
	var _basic = __webpack_require__(588);
	
	var _basic2 = _interopRequireDefault(_basic);
	
	var _jury3 = __webpack_require__(598);
	
	var _jury4 = _interopRequireDefault(_jury3);
	
	var _fotd = __webpack_require__(599);
	
	var _fotd2 = _interopRequireDefault(_fotd);
	
	var _fotm = __webpack_require__(600);
	
	var _fotm2 = _interopRequireDefault(_fotm);
	
	var _foty = __webpack_require__(601);
	
	var _foty2 = _interopRequireDefault(_foty);
	
	var _tcea = __webpack_require__(604);
	
	var _tcea2 = _interopRequireDefault(_tcea);
	
	var _editorialList = __webpack_require__(593);
	
	var _editorialList2 = _interopRequireDefault(_editorialList);
	
	var _editorialEdit = __webpack_require__(592);
	
	var _editorialEdit2 = _interopRequireDefault(_editorialEdit);
	
	var _profileEdit = __webpack_require__(607);
	
	var _profileEdit2 = _interopRequireDefault(_profileEdit);
	
	var _caseList = __webpack_require__(591);
	
	var _caseList2 = _interopRequireDefault(_caseList);
	
	var _caseCreate = __webpack_require__(589);
	
	var _caseCreate2 = _interopRequireDefault(_caseCreate);
	
	var _caseEdit = __webpack_require__(590);
	
	var _caseEdit2 = _interopRequireDefault(_caseEdit);
	
	var _juryOverview = __webpack_require__(605);
	
	var _juryOverview2 = _interopRequireDefault(_juryOverview);
	
	var _jobList = __webpack_require__(596);
	
	var _jobList2 = _interopRequireDefault(_jobList);
	
	var _jobCreate = __webpack_require__(594);
	
	var _jobCreate2 = _interopRequireDefault(_jobCreate);
	
	var _jobEdit = __webpack_require__(595);
	
	var _jobEdit2 = _interopRequireDefault(_jobEdit);
	
	var _caseSubmit = __webpack_require__(643);
	
	var _caseSubmit2 = _interopRequireDefault(_caseSubmit);
	
	var _jobSubmit = __webpack_require__(644);
	
	var _jobSubmit2 = _interopRequireDefault(_jobSubmit);
	
	var _tceay = __webpack_require__(680);
	
	var _tceay2 = _interopRequireDefault(_tceay);
	
	var _pca = __webpack_require__(679);
	
	var _pca2 = _interopRequireDefault(_pca);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		App: _app2.default,
		Timeline: _timeline2.default,
		LiveJudging: _livejudging2.default,
		Case: _case2.default,
		ProfilePage: _profile2.default,
		Profiles: _profiles2.default,
		Editorial: _editorial2.default,
		Page: _page2.default,
		ErrorPage: _errorPage2.default,
		Jobs: _jobs2.default,
		News: _news2.default,
		NewsSingle: _newsSingle2.default,
		JobPage: _job2.default,
		Jury: _jury2.default,
	
		Account: _account2.default,
		AccountLogin: _login2.default,
		AccountRegister: _register2.default,
		AccountActivate: _activate2.default,
		AccountLogout: _logout2.default,
		AccountRecover: _recover2.default,
	
		SubmitCaseNotLoggedIn: _caseSubmit2.default,
		SubmitJobNotLoggedIn: _jobSubmit2.default,
	
		TCEAYVote: _tceay2.default,
		PCAVote: _pca2.default
	};
	var accountPages = exports.accountPages = {
		AccountBasic: _basic2.default,
		AccountJury: _jury4.default,
		AccountJuryFOTD: _fotd2.default,
		AccountJuryFOTM: _fotm2.default,
		AccountJuryFOTY: _foty2.default,
		AccountJuryTCEA: _tcea2.default,
	
		//AccountEditorial: AccountEditorial,
		ProfileEdit: _profileEdit2.default,
	
		ProfileEditorial: _editorialList2.default,
		EditorialEdit: _editorialEdit2.default,
	
		CaseList: _caseList2.default,
		CaseCreate: _caseCreate2.default,
		CaseEdit: _caseEdit2.default,
	
		JobList: _jobList2.default,
		JobCreate: _jobCreate2.default,
		JobEdit: _jobEdit2.default,
	
		AdminJuryOverview: _juryOverview2.default
	};

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(166);
	
	var _actions = __webpack_require__(13);
	
	var _classnames = __webpack_require__(269);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(3);
	
	var _routes = __webpack_require__(4);
	
	__webpack_require__(1041);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COOKIE_DURATION = 365;
	var COOKIE_NAME = 'cookies_accepted';
	
	var Notice = function (_Component) {
		_inherits(Notice, _Component);
	
		function Notice() {
			var _Object$getPrototypeO;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Notice);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Notice)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.accept = function () {
				var date = new Date();
				date.setTime(date.getTime() + COOKIE_DURATION * 24 * 60 * 60 * 1000);
				var expires = '; expires=' + date.toGMTString();
				document.cookie = COOKIE_NAME + '=true' + expires + '; path=/';
				_this.props.dispatch({ type: _actions.COOKIES_ACCEPT });
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Notice, [{
			key: 'render',
			value: function render() {
				if (this.props.cookie.cookiesAccepted) return null;
				var classNames = (0, _classnames2.default)({
					span14: true,
					'cookie-notice': true,
					'cookie-notice--hidden': !this.props.cookie.showNotice
				});
				return _react2.default.createElement(
					'div',
					{ className: classNames },
					_react2.default.createElement(
						'p',
						null,
						'This website uses cookies to ensure you get the best experience on our website. ',
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: (0, _routes.genericRoute)(false, 'cookie-policy'), target: '_blank' },
							'Learn more'
						)
					),
					_react2.default.createElement(
						'button',
						{ onClick: this.accept },
						'Accept cookies'
					)
				);
			}
		}]);
	
		return Notice;
	}(_react.Component);
	
	Notice.propTypes = {
		cookie: _react.PropTypes.shape({ cookiesAccepted: _react.PropTypes.bool.isRequired, showNotice: _react.PropTypes.bool.isRequired }).isRequired,
		dispatch: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
		return { cookie: state.cookie, dispatch: state.dispatch };
	})(Notice);

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _reactMotion = __webpack_require__(1255);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _editorials = __webpack_require__(130);
	
	var _header = __webpack_require__(366);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content = __webpack_require__(365);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _contextual = __webpack_require__(147);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import css from './editorial.scss';
	
	var EditorialPage = function (_Component) {
		_inherits(EditorialPage, _Component);
	
		function EditorialPage(props) {
			_classCallCheck(this, EditorialPage);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorialPage).call(this, props));
	
			_this.mounted = true;
	
			_this.state = {
				transitioning: true,
				initialLoad: true
			};
			return _this;
		}
	
		_createClass(EditorialPage, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchSingle = (0, _redux.bindActionCreators)(_editorials.fetchSingleEditorial, this.props.dispatch);
	
				var preview = false;
				if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
					preview = this.props.router.location.query.preview;
				}
	
				if (this.props.routeParams.slug && (this.props.routeParams.slug !== this.props.editorials.single.slug || this.state.initialLoad)) {
					if (!this.state.transitioning) {
						this.setState({
							transitioning: true
						});
					}
	
					this.fetchSingle(this.props.routeParams.slug, this.loadSuccess.bind(this), this.loadFail.bind(this), preview);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
					if (!this.state.transitioning) {
						this.setState({
							transitioning: true
						});
					}
	
					this.fetchSingle(nextProps.routeParams.slug, this.loadSuccess.bind(this), this.loadFail.bind(this));
				}
			}
		}, {
			key: 'loadSuccess',
			value: function loadSuccess() {
				this.mounted && this.setState({
					initialLoad: false
				});
			}
		}, {
			key: 'loadFail',
			value: function loadFail() {
				this.props.dispatch((0, _reduxRouter.push)('/error'));
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.editorials.single.id !== this.props.editorials.single.id || nextProps.routeParams.slug !== this.props.routeParams.slug || nextState !== this.state;
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				this.props.dispatch((0, _editorials.clearSingleEditorial)());
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (!this.state.initialLoad) {
					var browser = this.props.browser;
	
					var editorial = this.props.editorials.single;
	
					if (editorial.meta && editorial.meta.description !== this.metaDesc) {
						(0, _meta2.default)(editorial.meta.description);
						this.metaDesc = editorial.meta.description;
					}
	
					var transitionClass = 'page__transition';
	
					if (this.state.transitioning && editorial.image) {
						transitionClass += ' page__transition--transitioning';
					}
	
					return _react2.default.createElement(
						'article',
						{ className: 'cf margin-bottom-contextual' },
						_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - ' + this.getTitle() }),
						_react2.default.createElement(
							'div',
							{ className: transitionClass },
							_react2.default.createElement(_header2.default, { editorial: editorial, browser: browser, onLoad: function onLoad() {
									return _this2.onHeaderImageLoaded();
								} }),
							_react2.default.createElement(_content2.default, { editorial: editorial, browser: browser })
						),
						_react2.default.createElement(_contextual2.default, { dateFilter: editorial.types.contextDate, typeSlug: editorial.types.slug, next: editorial.next, prev: editorial.prev, thisId: editorial.id, intro: editorial.types.contextIntro, typeId: editorial.typeId, editorial: true, type: editorial.types.contextType, name: editorial.types.name })
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - ' + this.getTitle() }),
					this.renderWaiting()
				);
			}
		}, {
			key: 'onHeaderImageLoaded',
			value: function onHeaderImageLoaded() {
				if (this.state.initialLoad || this.state.transitioning) {
					this.setState({
						initialLoad: false,
						transitioning: false
					});
				}
			}
		}, {
			key: 'getTransitionStyle',
			value: function getTransitionStyle(ips) {
				var opacity = ips.opacity;
				var top = ips.top;
				// console.log(this.state.transitioning, opacity, top);
	
				return {
					position: 'relative',
					opacity: opacity,
					top: top + 'px'
				};
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'getTitle',
			value: function getTitle() {
				if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.title) {
					return this.props.editorials.single.title;
				}
	
				return 'Editorial';
			}
		}]);
	
		return EditorialPage;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(EditorialPage);

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorPage = function (_Component) {
		_inherits(ErrorPage, _Component);
	
		function ErrorPage(props) {
			_classCallCheck(this, ErrorPage);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(ErrorPage).call(this, props));
		}
	
		_createClass(ErrorPage, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'article',
					{ className: 'page' },
					_react2.default.createElement(
						'section',
						{ className: 'page__description' },
						_react2.default.createElement(
							'h1',
							{ className: 'page__head' },
							(0, _translate2.default)('error404/title')
						),
						_react2.default.createElement(
							'p',
							{ className: 'page__excerpt span8' },
							(0, _translate2.default)('error404/text')
						)
					)
				);
			}
		}]);
	
		return ErrorPage;
	}(_react.Component);
	
	ErrorPage.propTypes = {};
	exports.default = (0, _connect2.default)(ErrorPage);

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _index = __webpack_require__(4);
	
	var _job = __webpack_require__(1042);
	
	var _job2 = _interopRequireDefault(_job);
	
	var _date = __webpack_require__(14);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _contextual = __webpack_require__(147);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _jobs = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var JobPage = function (_Component) {
		_inherits(JobPage, _Component);
	
		function JobPage(props) {
			_classCallCheck(this, JobPage);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(JobPage).call(this));
	
			_this.metaDesc = '';
			_this.state = {
				loading: Date.now()
			};
			return _this;
		}
	
		_createClass(JobPage, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//console.log('editorial will mount');
				this.fetchJob = (0, _redux.bindActionCreators)(_jobs.fetchJob, this.props.dispatch);
	
				var preview = false;
				if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
					preview = this.props.router.location.query.preview;
				}
	
				if (this.props.routeParams.slug && this.props.routeParams.slug !== this.props.jobs.single.slug) {
					this.fetchJob(this.props.routeParams.slug, preview);
					if (!this.state.loading) {
						this.setState({
							loading: Date.now()
						});
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var _this2 = this;
	
				var newState = {};
				if (nextProps.routeParams.slug !== this.props.routeParams.slug || this.props.items && nextProps.items.length !== this.props.items.length) {
					this.fetchJob(nextProps.routeParams.slug);
					if (!this.state.loading) {
						newState.loading = Date.now();
					}
				}
	
				if (this.state.loading && nextProps.routeParams.slug === nextProps.jobs.single.slug) {
					newState.loading = false;
				}
	
				Object.keys(newState).length && setTimeout(function () {
					_this2.setState(newState);
				}, Date.now() - this.state.loading < 500 ? 500 - (Date.now() - this.state.loading) : 0);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.jobs.single.id !== this.props.jobs.single.id || nextProps.routeParams.slug !== this.props.routeParams.slug || nextProps.jobs.items.length !== this.props.jobs.items.length || nextState.loading !== this.state.loading || nextState !== this.state;
			}
		}, {
			key: 'render',
			value: function render() {
				var job = this.props.jobs.single;
				var jobs = this.props.jobs.items;
				var date = new _date.DateFormatter(job.createdDate);
	
				if (job.meta && job.meta.description !== this.metaDesc) {
					(0, _meta2.default)(job.meta.description);
					this.metaDesc = job.meta.description;
				}
	
				var transitionClass = 'page__transition';
	
				if (this.state.loading) {
					transitionClass += ' page__transition--transitioning';
				}
	
				return _react2.default.createElement(
					'div',
					null,
					job.id && _react2.default.createElement(
						'article',
						{ className: 'job span14 margin-bottom-contextual' },
						_react2.default.createElement(_reactHelmet2.default, { title: job.title + ' - Jobs - The FWA' }),
						_react2.default.createElement(
							'div',
							{ className: transitionClass },
							_react2.default.createElement(
								'header',
								{ className: 'job__top' },
								_react2.default.createElement(
									'div',
									{ className: 'job__top__share' },
									_react2.default.createElement(_share2.default, { title: job.title, url: window.location.href, browser: this.props.browser })
								),
								_react2.default.createElement(
									'div',
									{ className: 'span2 job__top__date pixel-pattern span14-mobile' },
									_react2.default.createElement(_pixeltext2.default, { x: '0', text: date.date, className: 'job__top__date__day' }),
									_react2.default.createElement(
										'span',
										{ className: 'job__top__date__month' },
										date.month + ', ' + date.year
									),
									_react2.default.createElement(
										'span',
										{ className: 'job__top__date__text' },
										'Job added — '
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'span12 job__top__right  span14-mobile' },
									_react2.default.createElement(
										'h1',
										{ className: 'job__top__title' },
										job.title
									),
									_react2.default.createElement(
										'h2',
										{ className: 'job__top__subtitle' },
										job.profiles.name
									)
								)
							),
							_react2.default.createElement('div', { className: 'job__fill span2 hide-mobile' }),
							_react2.default.createElement(
								'section',
								{ className: 'job__content span8 span14-mobile' },
								_react2.default.createElement(
									'h2',
									{ className: 'span5 span11-mobile span7-tablet job__content__headline' },
									'Job description'
								),
								_react2.default.createElement('div', { className: 'span5 span11-mobile span7-tablet job__content__text', dangerouslySetInnerHTML: { __html: job.description } }),
								_react2.default.createElement(
									'h2',
									{ className: 'span5 span11-mobile span7-tablet job__content__headline' },
									'How to apply'
								),
								_react2.default.createElement('div', { className: 'span5 span11-mobile span7-tablet job__content__text', dangerouslySetInnerHTML: { __html: job.howTo } }),
								_react2.default.createElement('div', { className: 'span8 hide-mobile job__content__splitter pixel-pattern' }),
								_react2.default.createElement(
									'div',
									{ className: 'span8 hide-mobile job__content__terms' },
									(0, _translate2.default)('jobs/jobsCopyright')
								)
							),
							_react2.default.createElement(
								'aside',
								{ className: 'job__aside span4 span14-mobile' },
								!!(job.profiles && job.profiles.logoProfile && job.profiles.logoProfile.normal) && _react2.default.createElement(
									'div',
									{ className: 'job__aside__top' },
									_react2.default.createElement(_image2.default, _extends({ className: 'profile__meta__image' }, job.profiles.logoProfile.normal, { img: job.profiles.logoProfile.normal.src, span: '', alt: job.profiles.name }))
								),
								_react2.default.createElement(
									'section',
									{ className: 'job__aside__website' },
									_react2.default.createElement(
										'h2',
										{ className: 'job__aside__website__name' },
										job.profiles.name
									),
									_react2.default.createElement(
										'a',
										{ className: 'job__aside__website__url', href: job.profiles.website },
										job.profiles.website
									)
								),
								_react2.default.createElement('div', { className: 'job__aside__splitter pixel-pattern' }),
								_react2.default.createElement(
									'section',
									{ className: 'job__aside__location' },
									_react2.default.createElement(
										'h2',
										{ className: 'job__aside__location__title' },
										'job location'
									),
									_react2.default.createElement(
										'span',
										{ className: 'job__aside__location__name' },
										job.city
									),
									_react2.default.createElement(
										'span',
										{ className: 'job__aside__location__street' },
										job.address
									),
									_react2.default.createElement(
										'span',
										{ className: 'job__aside__location__city' },
										job.zip + ' ' + job.city
									),
									_react2.default.createElement(
										'span',
										{ className: 'job__aside__location__country' },
										job.country
									)
								)
							),
							_react2.default.createElement('div', { className: 'hide-desktop hide-tablet clear-mobile job__aside__splitter pixel-pattern' }),
							_react2.default.createElement(
								'div',
								{ className: 'hide-desktop hide-tablet span14-mobile job__content__terms' },
								(0, _translate2.default)('jobs/jobsCopyright')
							)
						),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(_contextual2.default, { jobId: job.id, enableJobs: true })
					) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' })
				);
			}
		}]);
	
		return JobPage;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(JobPage);

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _index = __webpack_require__(4);
	
	var _jobs = __webpack_require__(1043);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _routes = __webpack_require__(4);
	
	var _jobs3 = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var Jobs = function (_Component) {
		_inherits(Jobs, _Component);
	
		function Jobs(props) {
			_classCallCheck(this, Jobs);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Jobs).call(this, props));
	
			_this.mounted = true;
			_this.scrollHandler = _this.scrollHandler.bind(_this);
	
			_this.state = {
				searchWord: '',
				searchResults: [],
				isSticky: false,
				stickAtPos: 0,
				stickyHeight: 0,
				headerHeight: 0
			};
			return _this;
		}
	
		_createClass(Jobs, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchJobs = (0, _redux.bindActionCreators)(_jobs3.fetchJobs, this.props.dispatch);
	
				this.fetchJobs();
	
				if (this.props.browser) {
					this.props.browser.scroll.register(this.scrollHandler);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateDimensions();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.jobs.items.length !== this.props.jobs.items.length || nextState !== this.state;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				if (this.props.browser) {
					this.props.browser.scroll.deregister(this.scrollHandler);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var jobs = this.props.jobs.items;
				var allJobs = 'All jobs';
				var jobsNum = jobs.length;
	
				var searchWord = this.state.searchWord;
				var searchResults = [];
	
				searchWord = searchWord.toLowerCase();
	
				(0, _forEach2.default)(jobs, function (job) {
					if (job.title.toLowerCase().indexOf(searchWord) > -1 || job.country.toLowerCase().indexOf(searchWord) > -1 || job.city.toLowerCase().indexOf(searchWord) > -1 || job.profiles.name && job.profiles.name.toLowerCase().indexOf(searchWord) > -1) {
						searchResults.push(job);
					}
				});
	
				if (searchWord != '') {
					jobsNum = searchResults.length;
					allJobs = 'Found jobs';
	
					if (!searchResults.length) {
						searchResults.push({
							title: 'No results'
						});
					}
				}
	
				var title = '';
	
				if (this.props.jobs.meta && this.props.jobs.meta.description !== this.metaDesc) {
					(0, _meta2.default)(this.props.jobs.meta.description);
					this.metaDesc = this.props.jobs.meta.description;
					title = this.props.jobs.meta.title;
				}
	
				var stickyStyle = {};
				var placeholderStyle = {};
	
				if (this.state.isSticky) {
					placeholderStyle.height = this.state.stickyHeight;
	
					stickyStyle.position = 'fixed';
					stickyStyle.top = this.state.headerHeight;
					stickyStyle.height = this.state.stickyHeight;
					stickyStyle.zIndex = 1;
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactHelmet2.default, { title: title }),
					this.props.jobs && _react2.default.createElement(
						'article',
						{ className: 'jobs-list span14' },
						_react2.default.createElement('div', { style: placeholderStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'jobs-list__sticky', ref: 'stickyElement', style: stickyStyle },
							_react2.default.createElement(
								'div',
								{ className: 'jobs-list__top span14' },
								_react2.default.createElement(
									'h1',
									{ className: 'jobs-list__top__title' },
									'Jobs'
								),
								_react2.default.createElement(
									'span',
									{ className: 'jobs-list__top__number' },
									' (',
									jobs.length,
									')'
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.genericRoute)(false, 'submit/job'), className: 'button jobs-list__top__submit' },
									'Post a job vacancy'
								)
							),
							_react2.default.createElement('input', { onChange: function onChange(e) {
									return _this2.onInput(e);
								}, className: 'jobs-list__search span12 pixel-pattern hide-mobile', type: 'text', placeholder: (0, _translate2.default)('contextual/jobsSearch') }),
							_react2.default.createElement(
								'div',
								{ className: 'span2 jobs-list__right--small hide-mobile' },
								_react2.default.createElement(
									'span',
									{ className: 'jobs-list__right__byline' },
									'showing'
								),
								_react2.default.createElement(
									'h2',
									{ className: 'jobs-list__right__title' },
									allJobs
								),
								_react2.default.createElement(
									'span',
									{ className: 'jobs-list__right__number' },
									jobsNum + ' in total'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'jobs-list__flex' },
							_react2.default.createElement(
								'ul',
								{ className: 'jobs-list__jobs span12 span14-mobile' },
								(searchWord ? searchResults : jobs).map(function (job, i) {
									return _this2.renderJob(job, i);
								})
							),
							_react2.default.createElement('div', { className: 'span2 jobs-list__right hide-mobile' })
						)
					) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' })
				);
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				this.setState(_extends({}, this.state, {
					searchWord: e.target.value
				}));
			}
		}, {
			key: 'renderJob',
			value: function renderJob(job, i) {
				var uid = 'job-' + i;
				var date = new _date.DateFormatter(job.createdDate);
				date = date.date + ' ' + date.month + ' ' + date.year;
				var url = (0, _index.jobsRoute)(job.slug);
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'jobs-list__jobs__job span4 span6-tablet span14-mobile' },
					_react2.default.createElement(
						'h2',
						{ className: 'jobs-list__jobs__job__title' },
						job.title
					),
					job.profiles && job.profiles.name && _react2.default.createElement(
						'span',
						{ className: 'jobs-list__jobs__job__profile' },
						job.profiles.name
					),
					job.city && _react2.default.createElement(
						'span',
						{ className: 'jobs-list__jobs__job__location' },
						job.city + ', ' + job.country
					),
					job.createdDate && _react2.default.createElement(
						'span',
						{ className: 'jobs-list__jobs__job__date' },
						date
					),
					job.slug && this.props.browser.window.width > 719 && _react2.default.createElement(
						'div',
						{ className: 'jobs-list__jobs__job__overlay' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url, className: 'button jobs-list__jobs__job__button' },
							'Read more'
						)
					) || job.slug && _react2.default.createElement(_reactRouter.Link, { to: url, className: 'jobs-list__jobs__job__button--fill' })
				);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var _this3 = this;
	
				var headerHeight = document.querySelector('.header-main').offsetHeight;
				var mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
				var distanceToMenu = mainOffsetTop - headerHeight ? mainOffsetTop - headerHeight : 9999;
	
				var stickyHeight = this.refs.stickyElement ? this.refs.stickyElement.offsetHeight : 0;
	
				if (distanceToMenu === 9999) {
					setTimeout(function () {
						_this3.updateDimensions();
					}, 200);
				}
	
				this.mounted && this.setState(_extends({}, this.state, {
					stickAtPos: distanceToMenu,
					stickyHeight: stickyHeight,
					headerHeight: headerHeight
				}));
			}
		}, {
			key: 'scrollHandler',
			value: function scrollHandler(e) {
				if (e.scrollY === this.prevSrollY) {
					return false; // noop
				} else {
					this.prevSrollY = e.scrollY;
				}
	
				var isMobile = this.props.browser.window.width <= 719;
				var isSticky = e.scrollY >= this.state.stickAtPos && !isMobile;
	
				if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
					return this.updateDimensions();
				}
	
				// stop setting state if not necessary
				if (this.state.isSticky === isSticky) {
					return false; // noop
				}
	
				this.setState(_extends({}, this.state, {
					isSticky: isSticky
				}));
			}
		}]);
	
		return Jobs;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(Jobs);

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _jury = __webpack_require__(1044);
	
	var _jury2 = _interopRequireDefault(_jury);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _dropdown = __webpack_require__(95);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _index = __webpack_require__(4);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _jury3 = __webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var Jury = function (_Component) {
		_inherits(Jury, _Component);
	
		function Jury(props) {
			_classCallCheck(this, Jury);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(Jury).call(this, props));
	
			_this2.mounted = true;
			_this2.scrollHandler = _this2.scrollHandler.bind(_this2);
	
			_this2.state = {
				searched: true,
				isSticky: false,
				stickAtPos: 0,
				stickyHeight: 0,
				headerHeight: 0
			};
	
			_this2.query = '';
			_this2.offset = '';
			_this2.limit = '';
			_this2.order = '';
			_this2.orderBy = '';
			_this2.jury = [];
			_this2.already = [];
			return _this2;
		}
	
		_createClass(Jury, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//console.log('editorial will mount');
				this.fetchJury = (0, _redux.bindActionCreators)(_jury3.fetchJury, this.props.dispatch);
	
				this.fetchJury();
	
				if (this.props.browser) {
					this.props.browser.scroll.register(this.scrollHandler);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateDimensions();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.jury.jury !== this.props.jury.jury || nextState !== this.state;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				this.state.searched = false;
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				if (this.props.browser) {
					this.props.browser.scroll.deregister(this.scrollHandler);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var spinnerClass = 'jury-list__spinner';
	
				if (this.state.searched) {
					spinnerClass += ' jury-list__spinner--active';
				}
	
				var extra = 0;
	
				var rowNum = 6;
	
				if (this.props.browser.window.width < 1200) {
					rowNum = 3;
				}
	
				if (this.props.browser.window.width >= 720 && this.props.jury.jury && this.props.jury.jury.length !== 36) {
					if (this.props.jury.jury.length < rowNum) {
						extra = rowNum - this.props.jury.jury.length;
					} else {
						extra = rowNum - this.props.jury.jury.length % rowNum;
					}
				}
	
				var fillJury = [];
	
				for (var i = 0; i < extra; i++) {
					fillJury[i] = {
						name: 'fill',
						location: 'fill'
					};
				}
	
				var startNum = 1;
				var total = this.props.jury.jury.length;
	
				var offset = 0;
	
				if (this.props.jury.next) {
					var parameters = this.props.jury.next;
					parameters = parameters.split('/');
					parameters = parameters[parameters.length - 1];
	
					parameters = parameters.split('&');
	
					offset = parameters[0].split('=')[1];
	
					startNum = offset - this.props.jury.jury.length + 1;
	
					total = offset;
				};
	
				if (!this.props.jury.next && this.props.jury.prev) {
					var _parameters = this.props.jury.prev;
					_parameters = _parameters.split('/');
					_parameters = _parameters[_parameters.length - 1];
	
					_parameters = _parameters.split('&');
	
					offset = _parameters[0].split('=')[1];
	
					startNum = parseInt(offset) + 37;
	
					total = parseInt(offset) + 36 + this.props.jury.jury.length;
				}
	
				var _this = this;
	
				var jury = this.props.jury.jury;
				var used = false;
	
				if (jury.length) {
					if (!this.already.length) {
						(0, _forEach2.default)(jury, function (single, i) {
							_this.jury.push(single);
						});
						this.already.push(jury[0].id);
					} else {
						(0, _forEach2.default)(this.already, function (already) {
							if (already == jury[0].id) {
								used = true;
							}
						});
	
						if (!used) {
							(0, _forEach2.default)(jury, function (single, i) {
								_this.jury.push(single);
							});
	
							this.already.push(jury[0].id);
						}
					}
				}
	
				var stickyStyle = {};
				var placeholderStyle = {};
	
				if (this.state.isSticky) {
					placeholderStyle.height = this.state.stickyHeight;
	
					stickyStyle.position = 'fixed';
					stickyStyle.top = this.state.headerHeight;
					stickyStyle.height = this.state.stickyHeight;
					stickyStyle.zIndex = 1;
				}
	
				return this.props.jury.jury && _react2.default.createElement(
					'article',
					{ className: 'jobs-list span14' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'Jury members - The FWA' }),
					_react2.default.createElement('div', { style: placeholderStyle }),
					_react2.default.createElement(
						'div',
						{ className: 'jobs-list__sticky', ref: 'stickyElement', style: stickyStyle },
						_react2.default.createElement(
							'div',
							{ className: 'jobs-list__top span14' },
							_react2.default.createElement(
								'h1',
								{ className: 'jobs-list__top__title' },
								'Jury members'
							),
							_react2.default.createElement(
								'span',
								{ className: 'jobs-list__top__number' },
								' (',
								this.props.jury.totalJury,
								')'
							)
						),
						_react2.default.createElement('input', { className: 'jobs-list__search span12 pixel-pattern hide-mobile', ref: 'stickyInput', onChange: function onChange(event) {
								return _this3.jurySearch(event);
							}, type: 'text', placeholder: (0, _translate2.default)('jury/jurySearch') }),
						_react2.default.createElement(
							'div',
							{ className: 'span2 jury-list__right hide-mobile' },
							_react2.default.createElement(
								'span',
								{ className: 'jobs-list__right__byline' },
								'showing'
							),
							_react2.default.createElement(
								'h2',
								{ className: 'jobs-list__right__title' },
								startNum + ' — ' + total
							),
							_react2.default.createElement(
								'span',
								{ className: 'jobs-list__right__number' },
								this.props.jury.total + ' in total'
							),
							_react2.default.createElement(
								'nav',
								{ className: 'profile-list__right__nav' },
								this.props.jury.prev && _react2.default.createElement(
									'a',
									{ href: this.props.jury.prev, onClick: function onClick(event) {
											return _this3.juryNav(event);
										}, className: 'profile-list__right__nav__prev pixel-pattern' },
									_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
								) || _react2.default.createElement(
									'span',
									{ className: 'profile-list__right__nav__prev pixel-pattern' },
									_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive' })
								),
								this.props.jury.next && _react2.default.createElement(
									'a',
									{ href: this.props.jury.next, onClick: function onClick(event) {
											return _this3.juryNav(event);
										}, className: 'profile-list__right__nav__next pixel-pattern' },
									_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
								) || _react2.default.createElement(
									'span',
									{ className: 'profile-list__right__nav__next pixel-pattern' },
									_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive' })
								)
							)
						)
					),
					_react2.default.createElement(
						'ul',
						{ className: 'jobs-list__jobs span12 span14-mobile jury-list' },
						_react2.default.createElement(
							'li',
							{ className: spinnerClass },
							_react2.default.createElement(_spinner2.default, { className: 'jury-list__spinner__spinner', size: '80px' })
						),
						this.props.jury.error && !this.props.jury.jury.length && _react2.default.createElement(
							'li',
							{ className: 'jury-list__jury jury-list__jury--error span12 span12-tablet span14-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'jury-list__jury__content' },
								_react2.default.createElement(
									'h2',
									{ className: 'jury-list__jury__name' },
									this.props.jury.error.error.title
								),
								_react2.default.createElement(
									'span',
									{ className: 'jury-list__jury__location' },
									this.props.jury.error.error.message
								)
							)
						) || this.props.browser.window.width < 720 && this.jury.map(function (jury, i) {
							return _this3.renderJury(jury, i);
						}) || this.props.jury.jury.map(function (jury, i) {
							return _this3.renderJury(jury, i);
						}),
						fillJury.map(function (extra, i) {
							return _this3.renderExtra(extra, i);
						})
					),
					this.props.browser.window.width < 720 && this.props.jury.next && _react2.default.createElement(
						'a',
						{ href: this.props.jury.next, onClick: function onClick(event) {
								return _this3.juryNav(event);
							}, className: 'profile-list__right__nav__next pixel-pattern' },
						_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
					)
				) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' });
			}
		}, {
			key: 'renderExtra',
			value: function renderExtra(extra, i) {
				return _react2.default.createElement('li', { key: 'extra-' + i, className: 'jury-list__jury span2 span4-tablet span14-mobile' });
			}
		}, {
			key: 'renderJury',
			value: function renderJury(jury, i) {
				var _this4 = this;
	
				var uid = 'jury-' + i;
				var ref = 'more-' + i;
	
				if (jury.name == 'Anders Nielsen West') {
					console.log(jury);
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'jury-list__jury span2 span4-tablet span14-mobile', onClick: function onClick() {
							return _this4.juryClick(ref);
						} },
					jury.image && _react2.default.createElement(_image2.default, { className: 'jury-list__jury__img', img: jury.image, span: { desktop: 'span2', tablet: 'span4', mobile: 'span14' }, browser: this.props.browser }),
					_react2.default.createElement(
						'div',
						{ className: 'jury-list__jury__content' },
						_react2.default.createElement(
							'h2',
							{ className: 'jury-list__jury__name' },
							jury.name
						),
						_react2.default.createElement(
							'span',
							{ className: 'jury-list__jury__location' },
							jury.location
						),
						_react2.default.createElement(
							'button',
							{ ref: ref, onClick: function onClick(event) {
									event.stopPropagation();
								}, className: 'jury-list__jury__more' },
							'...'
						),
						_react2.default.createElement(
							_dropdown2.default,
							{ key: 'dropdown', attachTo: function attachTo() {
									return _this4.refs[ref];
								}, pointTo: 'BOTTOM_LEFT', disablePattern: true, browser: this.props.browser },
							_react2.default.createElement(
								'ol',
								{ key: 'dropdown-ol' },
								jury.website !== '' && _react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: jury.website },
										'Personal/Company website'
									)
								),
								jury.twitter !== '' && _react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: jury.twitter },
										'Twitter'
									)
								),
								jury.linkedin !== '' && _react2.default.createElement(
									'li',
									null,
									_react2.default.createElement(
										'a',
										{ href: jury.linkedin },
										'LinkedIn'
									)
								),
								!!jury.editorials.length && _react2.default.createElement('li', { className: 'jury-list__jury__more__seperator pixel-pattern--darker pixel-pattern--01' }),
								jury.editorials.map(function (editorial, i) {
									return _react2.default.createElement(
										'li',
										{ key: 'editorial' + i },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: (0, _index.generateURL)(editorial.types.slug, editorial.slug) },
											editorial.types.seriesName
										)
									);
								})
							)
						),
						_react2.default.createElement(
							'span',
							{ className: 'jury-list__jury__partof' },
							jury.partof
						)
					)
				);
			}
		}, {
			key: 'juryClick',
			value: function juryClick(ref) {
				if (this.props.browser.window.width < 720) {
					console.log(ref);
					_reactDom2.default.findDOMNode(this.refs[ref]).click();
				}
			}
		}, {
			key: 'juryNav',
			value: function juryNav(e) {
				e.preventDefault();
				var href = null;
	
				if (e.target.getAttribute('href')) {
					href = e.target.getAttribute('href');
				} else {
					href = e.target.parentNode.getAttribute('href');
				}
	
				var parameters = href;
				parameters = parameters.split('/');
				parameters = parameters[parameters.length - 1];
	
				parameters = parameters.split('&');
	
				var offset = parameters[0].split('=')[1];
	
				var limit = parameters[1].split('=')[1];
	
				var query = parameters[2].split('=')[1];
	
				this.setState({
					searched: true
				});
	
				this.offset = offset;
				this.limit = limit;
				this.query = query;
	
				this.fetchJury(offset, limit, query);
			}
		}, {
			key: 'jurySearch',
			value: function jurySearch(e) {
				var string = e.target.value;
	
				var state = this.state.searched;
				var _this = this;
	
				clearTimeout(this.inputTimeout);
	
				this.query = string;
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchJury(0, 36, string);
					_this.setState({
						searched: true
					});
				}, 400);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var _this5 = this;
	
				var headerHeight = document.querySelector('.header-main').offsetHeight;
				var mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
				var distanceToMenu = mainOffsetTop - headerHeight ? mainOffsetTop - headerHeight : 9999;
	
				var stickyHeight = this.refs.stickyElement ? this.refs.stickyElement.offsetHeight : 0;
				var inputHeight = this.refs.stickyInput ? this.refs.stickyInput.offsetHeight : 0;
	
				if (distanceToMenu === 9999) {
					setTimeout(function () {
						_this5.updateDimensions();
					}, 200);
				}
	
				this.mounted && this.setState(_extends({}, this.state, {
					stickAtPos: distanceToMenu,
					stickyHeight: stickyHeight + inputHeight,
					headerHeight: headerHeight
				}));
			}
		}, {
			key: 'scrollHandler',
			value: function scrollHandler(e) {
				if (e.scrollY === this.prevSrollY) {
					return false; // noop
				} else {
					this.prevSrollY = e.scrollY;
				}
	
				var isMobile = this.props.browser.window.width <= 719;
				var isSticky = e.scrollY >= this.state.stickAtPos && !isMobile;
	
				if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
					return this.updateDimensions();
				}
	
				// stop setting state if not necessary
				if (this.state.isSticky === isSticky) {
					return false; // noop
				}
	
				this.setState(_extends({}, this.state, {
					isSticky: isSticky
				}));
			}
		}]);
	
		return Jury;
	}(_react.Component);
	
	Jury.propTypes = {
		browser: _react.PropTypes.object.isRequired
	};
	exports.default = (0, _connect2.default)(Jury);

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _caseElementGeneric = __webpack_require__(364);
	
	var _caseElementGeneric2 = _interopRequireDefault(_caseElementGeneric);
	
	var _livehelper = __webpack_require__(375);
	
	var helper = _interopRequireWildcard(_livehelper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LiveJudgingCase = function (_Component) {
		_inherits(LiveJudgingCase, _Component);
	
		function LiveJudgingCase(props) {
			_classCallCheck(this, LiveJudgingCase);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LiveJudgingCase).call(this));
	
			_this.timer = 0;
			_this.color = '#' + Math.floor(Math.random() * 16777215).toString(16);
	
			_this.state = {
				rank: props.rank,
				prevRank: props.rank,
				goingUp: false
			};
			return _this;
		}
	
		_createClass(LiveJudgingCase, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.rank !== this.props.rank) {
					this.setState(_extends({}, this.state, {
						rank: nextProps.rank,
						prevRank: this.props.rank,
						goingUp: nextProps.rank < this.props.rank,
						isTransitioning: nextProps.rank < this.props.rank
					}));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearTimeout(this.timer);
			}
		}, {
			key: 'render',
			value: function render() {
				var style = {};
	
				if (helper.DEBUG) {
					style.backgroundColor = this.color;
				}
	
				var bp = helper.getBreakpoint(this.props.browser);
				var colNumber = helper.getColNumber(bp);
				var rankColOffset = helper.getRankColOffset(this.state.rank, this.props.divideAt, colNumber);
	
				var row = helper.getRow(this.state.rank, colNumber, rankColOffset);
				var col = helper.getCol(this.state.rank, colNumber, rankColOffset);
				var elDims = helper.getElementDimensions(bp);
	
				var splitterOffset = this.state.rank > this.props.divideAt ? helper.getSplitterOffset(bp) : 0;
	
				var topOffset = row * elDims.h + splitterOffset;
				var leftOffset = col * elDims.w;
	
				if (bp === helper.BP_MOBILE_LARGE || bp === helper.BP_MOBILE_SMALL) {
					if (this.state.rank > 1) {
						topOffset += 70;
					}
				}
	
				style.transform = 'translate3d(' + leftOffset + 'px, ' + topOffset + 'px, 0px)';
	
				// console.log(`row: ${row} --- col: ${col}`);
				var itemClass = 'live-judging__grid__item';
				//itemClass += ' live-judging__grid__item--transition'; //tmp
				var isTransitioning = this.state.isTransitioning;
				if (isTransitioning) {
					itemClass += ' live-judging__grid__item--transition';
					style.zIndex = 10;
				}
	
				if (this.state.prevRank !== this.state.rank) {
					this.state.prevRank = this.state.rank;
					this.setNextRank(isTransitioning);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: itemClass, style: style },
					_react2.default.createElement(
						'div',
						{ className: 'live-judging__grid__item__mvmt-overlay' },
						_react2.default.createElement(
							'div',
							{ className: 'live-judging__grid__item__mvmt-overlay__info' },
							this.props.item.points
						),
						_react2.default.createElement(
							'div',
							{ className: 'live-judging__grid__item__mvmt-overlay__info' },
							this.state.goingUp ? 'Up' : 'Down'
						)
					),
					_react2.default.createElement(_caseElementGeneric2.default, { ref: 'caseElement', caseItem: this.props.item, browser: this.props.browser, showPoints: true, showJudges: true, contentComp: false })
				);
			}
		}, {
			key: 'setNextRank',
			value: function setNextRank(isTransitioning) {
				var _this2 = this;
	
				this.timer = setTimeout(function () {
					_this2.setState(_extends({}, _this2.state, {
						isTransitioning: false
					}));
				}, helper.ANIMATION_DURATION);
	
				// this.setState({
				// 	...this.state,
				// 	rank: this.state.nextRank,
				// 	isTransitioning: isTransitioning,
				// });
			}
		}]);
	
		return LiveJudgingCase;
	}(_react.Component);
	
	LiveJudgingCase.propTypes = {
		item: _react.PropTypes.object.isRequired,
		rank: _react.PropTypes.number.isRequired,
		browser: _react.PropTypes.object.isRequired,
		isTop: _react.PropTypes.bool.isRequired,
		divideAt: _react.PropTypes.number.isRequired
	};
	LiveJudgingCase.defaultProps = {
		isTop: false
	};
	exports.default = LiveJudgingCase;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(35);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _routes = __webpack_require__(4);
	
	var _countdown = __webpack_require__(178);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _liveJudgingCase = __webpack_require__(670);
	
	var _liveJudgingCase2 = _interopRequireDefault(_liveJudgingCase);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _onboarding = __webpack_require__(672);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _livehelper = __webpack_require__(375);
	
	var helper = _interopRequireWildcard(_livehelper);
	
	var _livejudging = __webpack_require__(1045);
	
	var _livejudging2 = _interopRequireDefault(_livejudging);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LiveJudging = function (_Component) {
		_inherits(LiveJudging, _Component);
	
		function LiveJudging(props) {
			_classCallCheck(this, LiveJudging);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LiveJudging).call(this));
	
			_this.minHeight = 0;
			_this.metaDesc = '';
	
			_this.state = {
				nextFOTD: 0,
				initialized: 0,
				cases: [],
				meta: []
			};
			return _this;
		}
	
		_createClass(LiveJudging, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _this2 = this;
	
				this.mounted = true;
	
				_axios2.default.get(_baseUrl2.default + '/api/live/cases').then(function (res) {
					if (res.data && res.data.cases) {
						_this2.scheduleUpdate();
	
						_this2.setState(_extends({}, _this2.state, {
							initialized: 1,
							nextFOTD: res.data.nextFOTD - new Date().getTime() / 1000,
							cases: res.data.cases,
							meta: res.data.meta
						}));
					}
				}).catch(function (res) {
					_this2.setState(_extends({}, _this2.state, {
						initialized: 2
					}));
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				this.cancelScheduleUpdate();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				if (!this.state.initialized) {
					return this.renderWaiting();
				}
	
				var bp = helper.getBreakpoint(this.props.browser);
				var elDims = helper.getElementDimensions(bp);
				var colNumber = helper.getColNumber(bp);
	
				var highestRankAbove50 = function (cases) {
					var curHigh = 0;
					for (var i = 0; i < cases.length; i++) {
						if (cases[i].points > 50 && cases[i].rank > curHigh) {
							curHigh = cases[i].rank;
						}
					}
	
					return curHigh;
				}(this.state.cases);
	
				var rankColOffset = helper.getRankColOffset(this.state.cases.length, highestRankAbove50, colNumber);
				var rows = helper.getRow(this.state.cases.length, colNumber, rankColOffset) + 1;
				var splitRows = helper.getRow(highestRankAbove50 + 1, colNumber, rankColOffset);
				var splitterOffset = helper.getSplitterOffset(bp);
				var splitOffsetTop = elDims.h * splitRows;
				var lowerEntriesOffsetTop = elDims.h * (splitRows - 1);
				var height = elDims.h * rows + (highestRankAbove50 < this.state.cases.length ? splitterOffset : 0);
	
				var isMobile = bp === helper.BP_MOBILE_LARGE || bp === helper.BP_MOBILE_SMALL;
	
				if (isMobile) {
					splitOffsetTop += 70;
					lowerEntriesOffsetTop += 70;
					height += 70;
				}
	
				if (highestRankAbove50 === 0 && this.state.cases.length) {
					highestRankAbove50 = this.state.cases.length;
				}
	
				if (this.state.meta && this.state.meta.description !== this.metaDesc) {
					(0, _meta2.default)(this.state.meta.description);
					this.metaDesc = this.state.meta.description;
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'live-judging' },
					this.state.meta && this.state.meta.title && _react2.default.createElement(_reactHelmet2.default, { title: this.state.meta.title }) || _react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - Live Judging' }),
					_react2.default.createElement(_onboarding2.default, { ref: 'onboard', name: 'intro', browser: this.props.browser }),
					_react2.default.createElement(
						'div',
						{ className: 'live-judging__head span14' },
						isMobile && _react2.default.createElement(_countdown2.default, { timeLeft: this.state.nextFOTD }),
						_react2.default.createElement(
							'div',
							{ className: 'live-judging__head__aside span4 span6-tablet span14-mobile' },
							'Current Leader'
						),
						_react2.default.createElement(
							'div',
							{ className: 'live-judging__head__content span10 span8-tablet hide-mobile' },
							_react2.default.createElement(
								'div',
								{ className: 'live-judging__head__content__buttons' },
								_react2.default.createElement(
									'a',
									{
										className: 'button',
										onClick: function onClick(e) {
											e.preventDefault();
											_this3.refs.onboard.toggle(false);
										} },
									'Learn more'
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: (0, _routes.genericRoute)(false, 'submit/project'), className: 'button button--dark button--go' },
									'Submit your project'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'live-judging__head__content__announcement' },
								_react2.default.createElement(
									'span',
									{ className: 'live-judging__head__content__announcement__text' },
									'Next FWA of the Day announced in:'
								),
								_react2.default.createElement(
									'div',
									{ className: 'live-judging__head__content__announcement__grid' },
									_react2.default.createElement(
										'div',
										{ className: 'live-judging__head__content__announcement__grid__item' },
										'Hours'
									),
									_react2.default.createElement(
										'div',
										{ className: 'live-judging__head__content__announcement__grid__item' },
										'Minutes'
									),
									_react2.default.createElement(
										'div',
										{ className: 'live-judging__head__content__announcement__grid__item' },
										'Seconds'
									)
								),
								!isMobile && _react2.default.createElement(_countdown2.default, { timeLeft: this.state.nextFOTD })
							)
						),
						_react2.default.createElement('div', { className: 'cf' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'live-judging__grid', style: { height: height + 'px' } },
						this.state.cases.map(function (item, i) {
							return _react2.default.createElement(_liveJudgingCase2.default, { key: item.id, rank: item.rank, divideAt: highestRankAbove50, item: item, browser: _this3.props.browser, isTop: true });
						}),
						_react2.default.createElement(
							'div',
							{ className: 'live-judging__grid__aside span2 span6-mobile', style: { top: elDims.h + 'px' } },
							highestRankAbove50 >= 4 && _react2.default.createElement(
								'div',
								{ className: 'live-judging__grid__aside__top' },
								_react2.default.createElement(
									'div',
									null,
									'Top'
								),
								_react2.default.createElement(
									'div',
									null,
									'entries'
								)
							),
							highestRankAbove50 < this.state.cases.length && _react2.default.createElement(
								'div',
								{ className: 'live-judging__grid__aside__lower', style: { top: lowerEntriesOffsetTop + 'px' } },
								_react2.default.createElement(
									'div',
									null,
									'Low',
									_react2.default.createElement(
										'span',
										{ className: 'live-judging__grid__aside__lower__unnecessary' },
										'er'
									)
								),
								_react2.default.createElement(
									'div',
									null,
									'entries'
								)
							)
						),
						!!highestRankAbove50 && highestRankAbove50 < this.state.cases.length && _react2.default.createElement(
							'div',
							{ className: 'live-judging__grid__50split pixel-pattern-overlay pixel-pattern-overlay--01 span12 span14-mobile', style: { top: splitOffsetTop + 'px' } },
							'50 pts—'
						)
					)
				);
			}
		}, {
			key: 'renderWaiting',
			value: function renderWaiting() {
				return _react2.default.createElement(
					'div',
					{ key: 'spinner', style: { textAlign: 'center', width: '100%', marginTop: '50px' } },
					_react2.default.createElement(_spinner2.default, { size: '60' })
				);
			}
		}, {
			key: 'scheduleUpdate',
			value: function scheduleUpdate() {
				var _this4 = this;
	
				var grace = arguments.length <= 0 || arguments[0] === undefined ? 10000 : arguments[0];
	
				//console.debug('Timer scheduled in ' + grace + 'ms');
				this.updateTimer = setTimeout(function () {
					(0, _axios2.default)(_baseUrl2.default + '/api/live/updates').then(function (res) {
						if (_this4.mounted && res.data.cases) {
							_this4.grace = 10000;
							_this4.sortByUpdatedScore(_this4.state.cases, res.data.cases);
						}
					}).catch(function (res) {
						// fail
						setTimeout(function () {
							_this4.scheduleUpdate();
						}, 10000);
					});
				}, grace);
			}
		}, {
			key: 'cancelScheduleUpdate',
			value: function cancelScheduleUpdate() {
				clearTimeout(this.updateTimer);
				clearTimeout(this.sortTimer);
			}
		}, {
			key: 'getUpdateActions',
			value: function getUpdateActions(oldCases, newCases) {
				var actions = [];
				var _union = (0, _lodash.unionBy)(oldCases, newCases, function (item) {
					return item.id;
				});
	
				var FOUND_OLD = 'FOUND_OLD';
				var FOUND_NEW = 'FOUND_NEW';
				var NOT_FOUND_OLD = 'NOT_FOUND_OLD';
				var NOT_FOUND_NEW = 'NOT_FOUND_NEW';
	
				//console.debug(oldCases, newCases, _union);
	
				for (var i = 0; i < _union.length; i++) {
					var oldStatus = NOT_FOUND_OLD;
					for (var k = 0; k < oldCases.length; k++) {
						if (oldCases[k].id === _union[i].id) {
							oldStatus = FOUND_OLD;
						}
					}
	
					var newStatus = NOT_FOUND_NEW;
					for (var k = 0; k < newCases.length; k++) {
						if (newCases[k].id === _union[i].id) {
							newStatus = FOUND_NEW;
						}
					}
	
					// console.debug(oldStatus, newStatus);
	
					if (oldStatus === NOT_FOUND_OLD && newStatus === FOUND_NEW) {
						actions.push({
							action: 'ADD',
							id: _union[i].id
						});
					} else if (oldStatus === FOUND_OLD && newStatus === NOT_FOUND_NEW) {
						actions.push({
							action: 'REMOVE',
							id: _union[i].id
						});
					}
				}
	
				//console.debug('ACTIONS:', actions);
	
				return actions;
			}
		}, {
			key: 'runUpdateActions',
			value: function runUpdateActions(actions, oldCases) {
				var _newCasesCache = [];
				var _oldCases = [].concat(_toConsumableArray(oldCases));
	
				var actionPromise = new Promise(function (resolve, reject) {
					var AJAXIsDonePromise = new Promise(function (aResolve, aReject) {
						var ajax = false;
						for (var i = 0; i < actions.length; i++) {
							if (actions[i].action === 'ADD') {
								ajax = true;
							}
						}
	
						if (ajax) {
							// console.debug('NEED NEW CASES - FETCHING');
							_axios2.default.get(_baseUrl2.default + '/api/live/cases').then(function (res) {
								// console.debug('FETCH COMPLETE');
								if (res.data.cases && res.data.cases.length) {
									_newCasesCache = res.data.cases;
								}
	
								aResolve();
							}).catch(function (res) {
								// console.debug('FETCH FAILED');
								aResolve();
							});
						} else {
							// console.debug('FETCH NOT NEEDED');
							aResolve();
						}
					});
	
					AJAXIsDonePromise.then(function () {
						for (var i = 0; i < actions.length; i++) {
							if (actions[i].action === 'ADD') {
								// find new case
								// console.debug('ADDING CASE');
								for (var k = 0; k < _newCasesCache.length; k++) {
									// console.debug(`CHECKING (${k})`);
									if (_newCasesCache[k].id === actions[i].id) {
										// console.debug(`CASE FOUND ${actions[i].id}: ADDING`);
										var caseBeingAdded = _newCasesCache[k];
										caseBeingAdded.rank = oldCases.length + 1;
										_oldCases.push(caseBeingAdded);
										break; // 1 thing pr. action
									}
								}
							} else if (actions[i].action === 'REMOVE') {
								// console.debug('REMOVING CASE');
								for (var _k = 0; _k < _oldCases.length; _k++) {
									if (_oldCases[_k].id === actions[i].id) {
										// console.debug(`CASE FOUND ${actions[i].id} - ${k}: REMOVING`);
										//console.debug([..._oldCases]);
										_oldCases.splice(_k, 1);
										//console.debug([..._oldCases]);
										break; // 1 thing pr. action
									}
								}
							}
						}
	
						// console.debug('DONE RUNNING UPDATES');
						// console.debug([..._oldCases]);
	
						resolve(_oldCases);
					}).catch(function (e) {
						// console.debug(e);
						resolve(_oldCases);
					});
				});
	
				return actionPromise;
			}
		}, {
			key: 'sortByUpdatedScore',
			value: function sortByUpdatedScore(oldCases, newCases) {
				var _this5 = this;
	
				//console.debug('sortScores');
				var updateActions = this.getUpdateActions(oldCases, newCases);
				var updateActionPromise = Promise.resolve(oldCases);
				if (updateActions.length) {
					// console.debug('MISMATCH - RUNNING UPDATE ACTIONS');
					updateActionPromise = this.runUpdateActions(updateActions, oldCases);
				}
	
				// console.debug(updateActionPromise);
				updateActionPromise.then(function (_oldCases) {
	
					// console.debug('PROMISES RESOLVED:');
					// console.debug(_oldCases);
	
					for (var i = 0; i < newCases.length; i++) {
						var newCase = newCases[i];
	
						for (var _i = 0; _i < _oldCases.length; _i++) {
							var oldCase = _oldCases[_i];
	
							if (oldCase.id === newCase.id && newCase.rank < oldCase.rank) {
	
								return _this5.promoteCase(oldCase, newCase, _oldCases, newCases);
							} else if (oldCase.id === newCase.id && (newCase.rank !== oldCase.rank || newCase.voteCount !== oldCase.voteCount || newCase.points !== oldCase.points)) {
								return _this5.promoteCase(oldCase, newCase, _oldCases, newCases);
							}
						}
					}
	
					// in case of removal
					if (_oldCases.length !== _this5.state.cases.length) {
						return _this5.fixCases(_oldCases, newCases);
					}
	
					_this5.scheduleUpdate(_this5.grace);
				}).catch(function (e) {
					// console.debug(e);
				});
			}
		}, {
			key: 'fixCases',
			value: function fixCases(allCaseItems, allNewCases) {
				var _this6 = this;
	
				//console.debug(`IN ${helper.ANIMATION_DURATION}ms SORT AGAIN`);
				this.sortTimer = setTimeout(function () {
					_this6.grace = _this6.grace > helper.ANIMATION_DURATION ? _this6.grace - helper.ANIMATION_DURATION : 0;
					_this6.sortByUpdatedScore(allCaseItems, allNewCases);
				}, helper.ANIMATION_DURATION + 500);
	
				// console.debug('SETTING STATE:', allCaseItems);
	
				this.setState(_extends({}, this.state, {
					cases: [].concat(_toConsumableArray(allCaseItems))
				}));
			}
		}, {
			key: 'promoteCase',
			value: function promoteCase(caseItem, newCase, allCaseItems, allNewCases) {
				var _this7 = this;
	
				var promoteFromRank = caseItem.rank;
				var promoteToRank = newCase.rank;
	
				var allNewCasesById = function (newCases) {
					var formattedObj = {};
					for (var i = 0; i < newCases.length; i++) {
						formattedObj[newCases[i].id] = newCases[i];
					}
	
					return formattedObj;
				}(allNewCases);
	
				// for all cases between the rank we are promoting to
				// and the rank we are promoting from.. set rank--
				for (var i = 0; i < allCaseItems.length; i++) {
					if (allCaseItems[i].rank <= promoteFromRank && allCaseItems[i].rank >= promoteToRank) {
						var newRank = allCaseItems[i].rank + 1;
						allCaseItems[i] = (0, _lodash.merge)(allCaseItems[i], allNewCasesById[allCaseItems[i].id]);
						allCaseItems[i].rank = newRank;
					}
				}
	
				// find case and set to new rank
				for (var i = 0; i < allCaseItems.length; i++) {
					if (allCaseItems[i].id === caseItem.id) {
						allCaseItems[i] = (0, _lodash.merge)(allCaseItems[i], newCase);
					}
				}
	
				//console.debug(`IN ${helper.ANIMATION_DURATION}ms SORT AGAIN`);
				this.sortTimer = setTimeout(function () {
					_this7.grace = _this7.grace > helper.ANIMATION_DURATION ? _this7.grace - helper.ANIMATION_DURATION : 0;
					_this7.sortByUpdatedScore(allCaseItems, allNewCases);
				}, helper.ANIMATION_DURATION + 500);
	
				// console.debug('SETTING STATE:', allCaseItems);
	
				this.setState(_extends({}, this.state, {
					cases: [].concat(_toConsumableArray(allCaseItems))
				}));
			}
		}]);
	
		return LiveJudging;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(LiveJudging);

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(3);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _carousel = __webpack_require__(87);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _defaultDecorator = __webpack_require__(363);
	
	var _defaultDecorator2 = _interopRequireDefault(_defaultDecorator);
	
	var _step = __webpack_require__(1105);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1106);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1107);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1108);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(1109);
	
	var _step10 = _interopRequireDefault(_step9);
	
	var _step11 = __webpack_require__(1110);
	
	var _step12 = _interopRequireDefault(_step11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Onboarding = function (_Component) {
		_inherits(Onboarding, _Component);
	
		function Onboarding(props) {
			_classCallCheck(this, Onboarding);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Onboarding).call(this));
	
			_this.state = {
				show: !(localStorage[props.name] === 'seen')
			};
			return _this;
		}
	
		_createClass(Onboarding, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				document.body.classList.remove('body--context-menu');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var onboardClass = 'onboarding';
				if (this.state.show) {
					onboardClass += ' onboarding--active';
					document.body.classList.add('body--context-menu');
				} else {
					document.body.classList.remove('body--context-menu');
				}
	
				var decorators = [_defaultDecorator2.default, PaginationDecoratorPkg];
	
				return _react2.default.createElement(
					'div',
					{ className: onboardClass, onClick: function onClick(e) {
							_this2.toggle(_this2.state.show);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'onboarding__content span14', onClick: function onClick(e) {
								e.stopPropagation();
							} },
						_react2.default.createElement('a', { className: 'onboarding__content__close', onClick: function onClick(e) {
								e.preventDefault();
								_this2.toggle(_this2.state.show);
							} }),
						_react2.default.createElement('div', { className: 'onboarding__content__controls' }),
						_react2.default.createElement(
							_carousel2.default,
							{ autoplay: false, sliderClass: 'span100p', sliderListClass: 'span100p', decorators: decorators, decoratorData: { toggle: function toggle(val) {
										return _this2.toggle(val);
									} }, direction: _carousel.DIRECTION_VERTICAL },
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step2.default, title: (0, _translate2.default)('livejudging/step1Title'), text: (0, _translate2.default)('livejudging/step1Text') }),
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step4.default, title: (0, _translate2.default)('livejudging/step2Title'), text: (0, _translate2.default)('livejudging/step2Text') }),
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step6.default, title: (0, _translate2.default)('livejudging/step3Title'), text: (0, _translate2.default)('livejudging/step3Text') }),
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step8.default, title: (0, _translate2.default)('livejudging/step4Title'), text: (0, _translate2.default)('livejudging/step4Text') }),
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step10.default, title: (0, _translate2.default)('livejudging/step5Title'), text: (0, _translate2.default)('livejudging/step5Text') }),
							_react2.default.createElement(OnboardingItem, { browser: this.props.browser, img: _step12.default, title: (0, _translate2.default)('livejudging/step6Title'), text: (0, _translate2.default)('livejudging/step6Text') }),
							_react2.default.createElement(
								'div',
								{ className: 'onboarding__content__wrapper' },
								_react2.default.createElement(
									'div',
									{ className: 'onboarding__content__col' },
									_react2.default.createElement(
										'div',
										{ className: 'onboarding__content__col__cat' },
										'FWA Live Judging'
									),
									_react2.default.createElement(
										'div',
										{ className: 'onboarding__content__twocol' },
										_react2.default.createElement(
											'div',
											{ className: 'onboarding__content__twocol__item' },
											_react2.default.createElement(
												'h3',
												{ className: 'onboarding__content__twocol__title' },
												(0, _translate2.default)('livejudging/step7Title1')
											),
											_react2.default.createElement('p', { className: 'onboarding__content__twocol__text', dangerouslySetInnerHTML: { __html: (0, _translate2.default)('livejudging/step7Text1') } })
										),
										_react2.default.createElement(
											'div',
											{ className: 'onboarding__content__twocol__item' },
											_react2.default.createElement(
												'h3',
												{ className: 'onboarding__content__twocol__title' },
												(0, _translate2.default)('livejudging/step7Title2')
											),
											_react2.default.createElement('p', { className: 'onboarding__content__twocol__text', dangerouslySetInnerHTML: { __html: (0, _translate2.default)('livejudging/step7Text2') } })
										),
										_react2.default.createElement(
											'div',
											{ className: 'onboarding__content__twocol__item' },
											_react2.default.createElement(
												'h3',
												{ className: 'onboarding__content__twocol__title' },
												(0, _translate2.default)('livejudging/step7Title3')
											),
											_react2.default.createElement('p', { className: 'onboarding__content__twocol__text', dangerouslySetInnerHTML: { __html: (0, _translate2.default)('livejudging/step7Text3') } })
										)
									)
								)
							)
						)
					)
				);
			}
		}, {
			key: 'toggle',
			value: function toggle() {
				var val = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
				val = val ? 'seen' : 0;
				try {
					localStorage.setItem(this.props.name, val);
				} catch (e) {
					console.log(e);
				} finally {
					this.setState(_extends({}, this.state, {
						show: !(val === 'seen')
					}));
				}
			}
		}]);
	
		return Onboarding;
	}(_react.Component);
	
	Onboarding.propTypes = {
		name: _react.PropTypes.string
	};
	Onboarding.defaultProps = {
		name: 'onboard'
	};
	exports.default = Onboarding;
	
	var OnboardingItem = function (_Component2) {
		_inherits(OnboardingItem, _Component2);
	
		function OnboardingItem() {
			_classCallCheck(this, OnboardingItem);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(OnboardingItem).apply(this, arguments));
		}
	
		_createClass(OnboardingItem, [{
			key: 'render',
			value: function render() {
				var retina = 1;
				if (this.props.browser && this.props.browser.window.width < 720) {
					retina = 2;
				}
	
				var width = this.props.img.width / retina;
				var height = this.props.img.height / retina;
	
				return _react2.default.createElement(
					'div',
					{ className: 'onboarding__content__wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'onboarding__content__col' },
						_react2.default.createElement(
							'div',
							{ className: 'onboarding__content__col__cat' },
							'FWA Live Judging'
						),
						_react2.default.createElement(
							'h3',
							{ className: 'onboarding__content__col__title' },
							this.props.title
						),
						_react2.default.createElement('p', { className: 'onboarding__content__col__text', dangerouslySetInnerHTML: { __html: this.props.text } })
					),
					_react2.default.createElement(
						'div',
						{ className: 'onboarding__content__col onboarding__content__col--img' },
						_react2.default.createElement('img', _extends({}, this.props.img, { width: width, height: height }))
					)
				);
			}
		}]);
	
		return OnboardingItem;
	}(_react.Component);
	
	var PaginationDecorator = function (_Component3) {
		_inherits(PaginationDecorator, _Component3);
	
		function PaginationDecorator() {
			_classCallCheck(this, PaginationDecorator);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(PaginationDecorator).apply(this, arguments));
		}
	
		_createClass(PaginationDecorator, [{
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var prevClass = 'onboarding__pagination__prev';
				var nextClass = 'onboarding__pagination__next';
	
				if (this.props.currentSlide > 0) {
					prevClass += ' onboarding__pagination__prev--active';
				}
	
				if (this.props.currentSlide < this.props.slideCount - 1) {
					nextClass += ' onboarding__pagination__next--active';
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'onboarding__pagination' },
					_react2.default.createElement(
						'a',
						{ href: '', className: prevClass, onClick: function onClick(e) {
								e.preventDefault();_this5.props.previousSlide();
							} },
						_react2.default.createElement('div', { className: 'onboarding__pagination__arrow onboarding__pagination__arrow--up' })
					),
					_react2.default.createElement(
						'a',
						{
							href: '',
							className: nextClass,
							onClick: function onClick(e) {
								e.preventDefault();
								// console.log(`${this.props.currentSlide} < ${this.props.slideCount - 1}`);
								if (_this5.props.currentSlide < _this5.props.slideCount - 1) {
									_this5.props.nextSlide();
								} else {
									if (_this5.props.decoratorData && _this5.props.decoratorData.toggle && typeof _this5.props.decoratorData.toggle === 'function') {
										_this5.props.decoratorData.toggle(true);
									}
								}
							}
						},
						_react2.default.createElement('div', { className: 'onboarding__pagination__arrow onboarding__pagination__arrow--down' })
					)
				);
			}
		}]);
	
		return PaginationDecorator;
	}(_react.Component);
	
	PaginationDecorator.propTypes = {
		nextSlide: _react.PropTypes.func.isRequired,
		previousSlide: _react.PropTypes.func.isRequired,
		goToSlide: _react.PropTypes.func.isRequired,
		slideCount: _react.PropTypes.number.isRequired,
		currentSlide: _react.PropTypes.number.isRequired,
		decoratorData: _react.PropTypes.object
	};
	PaginationDecorator.defaultProps = {};
	
	
	var PaginationDecoratorPkg = {
		component: PaginationDecorator,
		style: {}
	};

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _index = __webpack_require__(4);
	
	var _news = __webpack_require__(1046);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _date = __webpack_require__(14);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _news3 = __webpack_require__(586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var News = function (_Component) {
		_inherits(News, _Component);
	
		function News(props) {
			_classCallCheck(this, News);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(News).call(this));
	
			_this.state = {
				searchWord: '',
				searchResults: []
			};
			return _this;
		}
	
		_createClass(News, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchNews = (0, _redux.bindActionCreators)(_news3.fetchNews, this.props.dispatch);
	
				this.fetchNews();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.news.news.length !== this.props.news.news.length || nextState !== this.state;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var news = this.props.news.news;
				var allJobs = 'All news';
				var jobsNum = news.length;
	
				var searchWord = this.state.searchWord;
				var searchResults = [];
	
				searchWord = searchWord.toLowerCase();
	
				(0, _forEach2.default)(news, function (single) {
					var date = new _date.DateFormatter(single.createdDate);
					date = date.date + ' ' + date.month + ' ' + date.year;
					if (date.toLowerCase().indexOf(searchWord) > -1 || single.title.toLowerCase().indexOf(searchWord) > -1 || single.users.name && single.users.name.toLowerCase().indexOf(searchWord) > -1) {
						searchResults.push(single);
					}
				});
	
				if (searchWord != '') {
					jobsNum = searchResults.length;
					allJobs = 'Found news';
	
					if (!searchResults.length) {
						searchResults.push({
							title: 'No results'
						});
					}
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_reactHelmet2.default, { title: 'News - The FWA' }),
					news.length && _react2.default.createElement(
						'article',
						{ className: 'news-list span14' },
						_react2.default.createElement(
							'div',
							{ className: 'news-list__top span14' },
							_react2.default.createElement(
								'h1',
								{ className: 'news-list__top__title' },
								'News'
							),
							_react2.default.createElement(
								'span',
								{ className: 'news-list__top__number' },
								' (',
								news.length,
								')'
							)
						),
						_react2.default.createElement('input', { onChange: function onChange(event) {
								return _this2.onInput(event);
							}, className: 'news-list__search span12 pixel-pattern hide-mobile', type: 'text', placeholder: 'Search for news...' }),
						_react2.default.createElement(
							'div',
							{ className: 'span2 news-list__right--small hide-mobile' },
							_react2.default.createElement(
								'span',
								{ className: 'news-list__right__byline' },
								'showing'
							),
							_react2.default.createElement(
								'h2',
								{ className: 'news-list__right__title' },
								allJobs
							),
							_react2.default.createElement(
								'span',
								{ className: 'news-list__right__number' },
								jobsNum + ' in total'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'news-list__flex' },
							searchResults && _react2.default.createElement(
								'ul',
								{ className: 'news-list__news span12 span14-mobile' },
								searchResults.map(function (news, i) {
									return _this2.renderNewsSingle(news, i);
								})
							) || _react2.default.createElement(
								'ul',
								{ className: 'news-list__news span12 span14-mobile' },
								news.map(function (news, i) {
									return _this2.renderNewsSingle(news, i);
								})
							),
							_react2.default.createElement('div', { className: 'span2 news-list__right hide-mobile' })
						)
					) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' })
				);
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				this.setState(_extends({}, this.state, {
					searchWord: e.target.value
				}));
			}
		}, {
			key: 'renderNewsSingle',
			value: function renderNewsSingle(single, i) {
				var uid = 'news-' + i;
				var date = new _date.DateFormatter(single.createdDate);
				date = date.date + ' ' + date.month + ' ' + date.year;
				var url = (0, _index.newsRoute)(single.slug);
	
				return _react2.default.createElement(
					'li',
					{ key: uid, className: 'news-list__news__news-single span4 span6-tablet span14-mobile' },
					_react2.default.createElement(
						'h2',
						{ className: 'news-list__news__news-single__title span3 span5-tablet span12-mobile' },
						single.title
					),
					single.users && single.users.name && _react2.default.createElement(
						'span',
						{ className: 'news-list__news__news-single__profile' },
						'By ' + single.users.name
					),
					single.createdDate && _react2.default.createElement(
						'span',
						{ className: 'news-list__news__news-single__date' },
						date
					),
					single.slug && _react2.default.createElement(
						'div',
						{ className: 'news-list__news__news-single__overlay' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url, className: 'button news-list__news__news-single__button' },
							'Read more'
						)
					)
				);
			}
		}]);
	
		return News;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(News);

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _editorials = __webpack_require__(130);
	
	var _header = __webpack_require__(366);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content = __webpack_require__(365);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _contextual = __webpack_require__(147);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var NewsSingle = function (_Component) {
		_inherits(NewsSingle, _Component);
	
		function NewsSingle(props) {
			_classCallCheck(this, NewsSingle);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(NewsSingle).call(this));
		}
	
		_createClass(NewsSingle, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//console.log('editorial will mount');
				this.fetchSingle = (0, _redux.bindActionCreators)(_editorials.fetchSingleEditorial, this.props.dispatch);
	
				if (this.props.routeParams.slug && this.props.routeParams.slug !== this.props.editorials.single.slug) {
					this.fetchSingle(this.props.routeParams.slug);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
					this.fetchSingle(nextProps.routeParams.slug);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.id) {
					var editorial = this.props.editorials.single;
	
					return _react2.default.createElement(
						'article',
						{ className: 'cf margin-bottom-contextual' },
						_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - ' + this.getTitle() }),
						_react2.default.createElement(_header2.default, { editorial: editorial, browser: this.props.browser }),
						_react2.default.createElement(_content2.default, { editorial: editorial, browser: this.props.browser }),
						_react2.default.createElement('div', { className: 'cf' }),
						_react2.default.createElement(_contextual2.default, { newsId: this.props.editorials.single.id, enableNews: true })
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - ' + this.getTitle() }),
						_react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' })
					);
				}
			}
		}, {
			key: 'getTitle',
			value: function getTitle() {
				if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.title) {
					return this.props.editorials.single.title;
				}
	
				return 'News';
			}
		}]);
	
		return NewsSingle;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(NewsSingle);

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _reactRouter = __webpack_require__(3);
	
	var _threeimages = __webpack_require__(373);
	
	var _threeimages2 = _interopRequireDefault(_threeimages);
	
	var _hof = __webpack_require__(638);
	
	var _hof2 = _interopRequireDefault(_hof);
	
	var _form = __webpack_require__(46);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _text = __webpack_require__(33);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _submit = __webpack_require__(31);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//Form elements for newsletter
	
	
	var PageContent = function (_Component) {
		_inherits(PageContent, _Component);
	
		function PageContent(props) {
			_classCallCheck(this, PageContent);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PageContent).call(this, props));
	
			_this.state = {
				waiting: false,
				formErrors: {},
				submitted: false
			};
			return _this;
		}
	
		_createClass(PageContent, [{
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return this.props !== nextProps || this.state !== nextState;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (document.querySelector('.page__section__item__text__manchet')) {
					(function () {
						var h = document.querySelector('.page__section__item__text__manchet').clientHeight;
	
						(0, _forEach2.default)(document.querySelectorAll('.page__section__item__text__manchet--fill'), function (fill) {
							fill.style.height = h + 'px';
						});
					})();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (document.querySelector('.page__section__item__text__manchet')) {
					(function () {
						var h = document.querySelector('.page__section__item__text__manchet').clientHeight;
	
						(0, _forEach2.default)(document.querySelectorAll('.page__section__item__text__manchet--fill'), function (fill) {
							fill.style.height = h + 'px';
						});
					})();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var uid = 'page-content';
	
				var content = this.props.content;
	
				return content.type == 2 && this.twoColumns(content, uid) || content.type == 3 && this.threeColumns(content, uid) || content.type == 'seperator' && _react2.default.createElement('div', { key: uid, className: 'page__splitter span5 pixel-pattern' }) || content.type == 'images' && _react2.default.createElement(_threeimages2.default, { className: 'page__section', key: uid, imgone: content.image1, imgtwo: content.image2, imgthree: content.image3, browser: this.props.browser }) || content.type == 'image' && _react2.default.createElement(
					'div',
					{ key: uid, className: 'page__section page__section--force-full span14' },
					_react2.default.createElement(_image2.default, { img: content.image, span: 'span14', alt: '', browser: this.props.browser })
				) || content.type == 'hof' && _react2.default.createElement(_hof2.default, { key: uid, browser: this.props.browser }) || null;
			}
		}, {
			key: 'twoColumns',
			value: function twoColumns(content, uid) {
				var columnOne = [];
				var columnTwo = [];
	
				(0, _forEach2.default)(content, function (con, key) {
					if (key.indexOf('column1') > -1) {
						if (key == 'column1') {
							columnOne['text'] = con;
						} else {
							columnOne[key.replace('column1', '')] = con;
						}
					} else if (key.indexOf('column2') > -1) {
						if (key == 'column2') {
							columnTwo['text'] = con;
						} else {
							columnTwo[key.replace('column2', '')] = con;
						}
					}
				});
	
				var hasAHead = false;
				var hasManchet = false;
	
				if (columnOne.SubHeadline !== '' || columnTwo.SubHeadline !== '') {
					hasAHead = true;
				}
	
				var multiple = '';
	
				if (columnOne.Headline !== '' && columnTwo.Headline !== '') {
					multiple = ' page__section__two-column--multiple';
				}
	
				var hasAny = false;
				var borderClass = '';
	
				if (columnOne.Headline !== '' || columnTwo.Headline !== '') {
					hasAny = true;
					borderClass = ' page__section__content__content--border';
				}
	
				return _react2.default.createElement(
					'section',
					{ key: uid, className: 'page__section page__section__two-wrap' },
					_react2.default.createElement(
						'div',
						{ className: 'page__section__two-column span7 span14-mobile' + multiple },
						columnOne.Headline != '' && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
						columnOne.Headline != '' && _react2.default.createElement(
							'h1',
							{ className: 'page__section__head' },
							columnOne.Headline
						),
						_react2.default.createElement(
							'div',
							{ className: 'page__section__content__content' + borderClass },
							this.renderColumn(columnOne, 'span7 span14-mobile page__section__item--border', true, hasAHead, hasManchet)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'page__section__two-column span7 span14-mobile' + multiple },
						columnTwo.Headline != '' && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
						columnTwo.Headline != '' && _react2.default.createElement(
							'h1',
							{ className: 'page__section__head' },
							columnTwo.Headline
						) || hasAny && _react2.default.createElement('div', { className: 'page__section__head page__section__head--hide-left hide-mobile' }),
						_react2.default.createElement(
							'div',
							{ className: 'page__section__content__content' + borderClass },
							this.renderColumn(columnTwo, 'span7 span14-mobile', true, hasAHead, hasManchet)
						)
					)
				);
			}
		}, {
			key: 'threeColumns',
			value: function threeColumns(content, uid) {
				var columnOne = [];
				var columnTwo = [];
				var columnThree = [];
	
				(0, _forEach2.default)(content, function (con, key) {
					if (key.indexOf('column1') > -1) {
						if (key == 'column1') {
							columnOne['text'] = con;
						} else {
							columnOne[key.replace('column1', '')] = con;
						}
					} else if (key.indexOf('column2') > -1) {
						if (key == 'column2') {
							columnTwo['text'] = con;
						} else {
							columnTwo[key.replace('column2', '')] = con;
						}
					} else if (key.indexOf('column3') > -1) {
						if (key == 'column3') {
							columnThree['text'] = con;
						} else {
							columnThree[key.replace('column3', '')] = con;
						}
					}
				});
	
				var hasAHead = false;
				var borderClass = '';
				var hasManchet = false;
	
				if (columnOne.SubHeadline !== '' || columnTwo.SubHeadline !== '' || columnThree.SubHeadline !== '') {
					hasAHead = true;
	
					if (this.props.isHof !== 1) {
						borderClass = ' page__section__content__content--border';
					}
				}
	
				if (content.head !== '') {
					borderClass = ' page__section__content__content--border';
				}
	
				if (columnOne.Manchet !== '' || columnTwo.Manchet !== '' || columnThree.Manchet !== '') {
					hasManchet = true;
				}
	
				return _react2.default.createElement(
					'section',
					{ key: uid, className: 'page__section' },
					_react2.default.createElement(
						'div',
						{ className: 'page__section__content' },
						content.head != '' && this.props.isHof != 1 && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
						content.head != '' && _react2.default.createElement(
							'h1',
							{ className: 'page__section__head' },
							content.head
						),
						_react2.default.createElement(
							'div',
							{ className: 'page__section__content__content' + borderClass },
							_react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
							this.renderColumn(columnOne, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet),
							this.renderColumn(columnTwo, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet),
							this.props.isHof == 1 && this.renderColumn(columnThree, 'span4 span7-tablet span14-mobile', false, hasAHead, hasManchet) || this.renderColumn(columnThree, 'span4 span7-tablet span14-mobile clear-tablet', false, hasAHead, hasManchet),
							_react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' })
						)
					)
				);
			}
		}, {
			key: 'renderColumn',
			value: function renderColumn(column, extraClass, filler, hasAHead, hasManchet) {
				return column.Type == 'TEXT' && this.renderText(column, extraClass, filler, hasAHead, hasManchet) || column.Type == 'IMAGE' && this.renderImage(column, extraClass, filler, hasAHead, hasManchet) || column.Type == 'LINK' && this.renderLinks(column, extraClass, filler, hasAHead, hasManchet) || column.Type == 'NEWSLETTER' && this.renderNewsletter(column, extraClass, filler, hasAHead, hasManchet) || null;
			}
		}, {
			key: 'renderNewsletter',
			value: function renderNewsletter(column, extraClass, filler, hasAHead) {
				var _this2 = this;
	
				var className = 'page__section__item ' + extraClass;
				return _react2.default.createElement(
					'div',
					{ className: className },
					filler && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
					column.SubHeadline != '' && _react2.default.createElement(
						'h2',
						{ className: 'page__section__sub-head' },
						column.SubHeadline
					) || hasAHead && _react2.default.createElement('div', { className: 'page__section__sub-head' }),
					!this.state.submitted && _react2.default.createElement(
						_form2.default,
						{ className: 'page__section__item__newsletter span4 span6-tablet span14-mobile', getRefs: function getRefs() {
								return _this2.getRefs();
							}, newsletterForm: true, method: 'post', action: '/api/newsletter', ref: 'form', onSubmit: this.onFormSubmit.bind(this) },
						_react2.default.createElement(_text2.default, { name: 'name', ref: 'name', className: 'page__section__item__newsletter__input span3 span5-tablet span10-mobile', type: 'text', placeholder: 'Full Name' }),
						_react2.default.createElement('span', null),
						_react2.default.createElement(_text2.default, { name: 'email', ref: 'email', className: 'page__section__item__newsletter__input span3 span5-tablet span10-mobile', type: 'email', placeholder: 'Email' }),
						_react2.default.createElement(_submit2.default, { className: 'page__section__item__newsletter__submit button-go', name: 'Subscribe', value: 'Subscribe', waiting: this.state.waiting })
					) || _react2.default.createElement(
						'p',
						{ className: 'page__section__item__text' },
						column.NewsletterMessage
					)
				);
			}
		}, {
			key: 'onFormSubmit',
			value: function onFormSubmit(promise) {
				var _this3 = this;
	
				if (this.refs.form && this.refs.form.serialize) {
					this.setState(_extends({}, this.state, { waiting: true }));
	
					promise.then(function (resp) {
						_this3.setState(_extends({}, _this3.state, {
							submitted: true,
							waiting: false,
							formErrors: {}
						}));
					}).catch(function (resp) {
						_this3.setState(_extends({}, _this3.state, {
							waiting: false,
							formErrors: _typeof(resp.data.errors) === 'object' ? resp.data.errors : {}
						}));
					});
				}
			}
		}, {
			key: 'getRefs',
			value: function getRefs() {
				return this.refs;
			}
		}, {
			key: 'renderLinks',
			value: function renderLinks(column, extraClass, filler, hasAHead, hasManchet) {
				var _this4 = this;
	
				var links = [];
	
				for (var i = 1; i < 5; i++) {
					var key = 'Link' + i;
					if (column[key]) {
						var link = {
							link: column[key],
							text: column[key + '_name'],
							alt: column[key + '_title']
						};
						links.push(link);
					}
				}
	
				var className = 'page__section__item ' + extraClass;
	
				return _react2.default.createElement(
					'div',
					{ className: className },
					filler && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
					column.SubHeadline != '' && _react2.default.createElement(
						'h2',
						{ className: 'page__section__sub-head' },
						column.SubHeadline
					) || hasAHead && _react2.default.createElement('div', { className: 'page__section__sub-head' }),
					hasManchet && _react2.default.createElement('p', { className: 'page__section__item__text__manchet--fill' }),
					_react2.default.createElement(
						'ul',
						{ className: 'page__section__item__links span4 span6-tablet span14-mobile' },
						links.map(function (link, i) {
							return _this4.renderLink(link, i);
						})
					)
				);
			}
		}, {
			key: 'renderLink',
			value: function renderLink(link, i) {
				var uid = 'link' + i;
	
				if (link.link.indexOf(window.location.hostname) > -1) {
					var url = link.link.replace(/^.*\/\/[^\/]+/, '');
	
					return _react2.default.createElement(
						'li',
						{ key: uid, className: 'page__section__item__links__link' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url, title: link.alt, alt: link.alt },
							link.text
						)
					);
				} else {
					return _react2.default.createElement(
						'li',
						{ key: uid, className: 'page__section__item__links__link' },
						_react2.default.createElement(
							'a',
							{ href: link.link, title: link.alt, alt: link.alt },
							link.text
						)
					);
				}
			}
		}, {
			key: 'renderImage',
			value: function renderImage(column, extraClass, filler, hasAHead, hasManchet) {
				var className = 'page__section__item ' + extraClass;
				return _react2.default.createElement(
					'div',
					{ className: className },
					filler && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
					column.SubHeadline != '' && _react2.default.createElement(
						'h2',
						{ className: 'page__section__sub-head' },
						column.SubHeadline
					) || hasAHead && _react2.default.createElement('div', { className: 'page__section__sub-head' }),
					hasManchet && _react2.default.createElement('p', { className: 'page__section__item__text__manchet--fill' }),
					_react2.default.createElement(_image2.default, { className: 'page__section__item__image span4 span6-tablet span14-mobile', img: column.Image, span: 'span14', alt: '', browser: this.props.browser })
				);
			}
		}, {
			key: 'renderText',
			value: function renderText(column, extraClass, filler, hasAHead, hasManchet) {
				var className = 'page__section__item ' + extraClass;
	
				var extraHtml = '';
	
				if (column.Manchet != '' && hasManchet) {
					extraHtml = '<p class="page__section__item__text__manchet">' + column.Manchet + '</p>';
				} else if (hasManchet) {
					extraHtml = '<p class="page__section__item__text__manchet--fill"></p>';
				}
	
				if (this.props.isHof == 1 && column.SubHeadline != '') {
					className += ' page__section__item--hof';
				}
	
				if (column.SubHeadline != '' || column.text != '') {
					return _react2.default.createElement(
						'div',
						{ className: className },
						filler && _react2.default.createElement('div', { className: 'page__section__fill span1 hide-tablet hide-mobile' }),
						column.SubHeadline != '' && this.props.isHof == 1 && _react2.default.createElement(
							'h2',
							{ className: 'page__section__sub-head page__section__sub-head--hof' },
							column.SubHeadline
						) || column.SubHeadline !== '' && _react2.default.createElement(
							'h2',
							{ className: 'page__section__sub-head' },
							column.SubHeadline
						) || hasAHead && _react2.default.createElement('div', { className: 'page__section__sub-head' }),
						_react2.default.createElement('div', { className: 'page__section__item__text span4 span6-tablet span14-mobile', dangerouslySetInnerHTML: { __html: extraHtml + column.text } })
					);
				} else {
					return false;
				}
			}
		}]);
	
		return PageContent;
	}(_react.Component);
	
	PageContent.propTypes = {};
	exports.default = PageContent;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _page = __webpack_require__(1047);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _content = __webpack_require__(675);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _page3 = __webpack_require__(587);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
		_inherits(Page, _Component);
	
		function Page(props) {
			_classCallCheck(this, Page);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Page).call(this, props));
	
			_this.manchettes = [];
	
			_this.state = {
				waiting: false,
				formErrors: {},
				submitted: false
			};
	
			_this.metaDesc = '';
			return _this;
		}
	
		_createClass(Page, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchPage = (0, _redux.bindActionCreators)(_page3.fetchPage, this.props.dispatch);
	
				this.fetchPage(this.props.routeParams.splat);
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				if (this.props.routeParams.splat !== nextProps.routeParams.splat) {
					this.fetchPage(nextProps.routeParams.splat);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var page = false;
	
				if (this.props.page.single) {
					page = this.props.page.single;
	
					if (page.meta && page.meta.description !== this.metaDesc) {
						(0, _meta2.default)(page.meta.description);
						this.metaDesc = page.meta.description;
					}
				}
	
				return page.head && _react2.default.createElement(
					'article',
					{ className: 'page' },
					_react2.default.createElement(_reactHelmet2.default, { title: 'The FWA - ' + page.head }),
					page.hero && _react2.default.createElement(_image2.default, { className: 'page__hero', img: page.hero, span: 'span14', alt: '', browser: this.props.browser }),
					page.isHall == 1 && _react2.default.createElement(
						'section',
						{ className: 'page__description page__description--hof' },
						_react2.default.createElement(
							'div',
							{ className: 'page__share' },
							_react2.default.createElement(_share2.default, { title: page.head, url: window.location.href, browser: this.props.browser })
						),
						_react2.default.createElement(
							'div',
							{ className: 'span5 page__description__left page__description__left--hof' },
							_react2.default.createElement(_image2.default, { img: page.hofImage, span: 'span14', alt: '', browser: this.props.browser })
						),
						_react2.default.createElement(
							'div',
							{ className: 'span9 span10-tablet span12-mobile page__description__right page__description__right--hof' },
							_react2.default.createElement(
								'h1',
								{ className: 'page__head' },
								page.head
							),
							_react2.default.createElement(
								'h2',
								{ className: 'page__description__hof' },
								'Hall of fame'
							),
							_react2.default.createElement(
								'p',
								{ className: 'page__excerpt page__excerpt--hof span8 span10-tablet span12-mobile' },
								page.excerpt
							)
						)
					) || _react2.default.createElement(
						'section',
						{ className: 'page__description' },
						_react2.default.createElement(
							'div',
							{ className: 'page__share' },
							_react2.default.createElement(_share2.default, { title: page.head, url: window.location.href, browser: this.props.browser })
						),
						_react2.default.createElement(
							'h1',
							{ className: 'page__head' },
							page.head
						),
						_react2.default.createElement(
							'p',
							{ className: 'page__excerpt span8 span12-mobile' },
							page.excerpt
						)
					),
					page.content && page.content.map(function (content, i) {
						return _react2.default.createElement(_content2.default, { browser: _this2.props.browser, isHof: page.isHall, key: 'page-content' + i, content: content });
					})
				) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' });
			}
		}]);
	
		return Page;
	}(_react.Component);
	
	Page.propTypes = {};
	exports.default = (0, _connect2.default)(Page);

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _topPlaceholder = __webpack_require__(1114);
	
	var _topPlaceholder2 = _interopRequireDefault(_topPlaceholder);
	
	var _logoPlaceholder = __webpack_require__(1113);
	
	var _logoPlaceholder2 = _interopRequireDefault(_logoPlaceholder);
	
	var _profile = __webpack_require__(1048);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _pixeltext = __webpack_require__(52);
	
	var _pixeltext2 = _interopRequireDefault(_pixeltext);
	
	var _date = __webpack_require__(14);
	
	var _index = __webpack_require__(4);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _relatedcases = __webpack_require__(238);
	
	var _relatedcases2 = _interopRequireDefault(_relatedcases);
	
	var _relatedinterviews = __webpack_require__(371);
	
	var _relatedinterviews2 = _interopRequireDefault(_relatedinterviews);
	
	var _relatedjobs = __webpack_require__(372);
	
	var _relatedjobs2 = _interopRequireDefault(_relatedjobs);
	
	var _contextual = __webpack_require__(147);
	
	var _contextual2 = _interopRequireDefault(_contextual);
	
	var _player = __webpack_require__(97);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _share = __webpack_require__(77);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _graphTextDots = __webpack_require__(1112);
	
	var _graphTextDots2 = _interopRequireDefault(_graphTextDots);
	
	var _tooltip = __webpack_require__(180);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _profiles = __webpack_require__(233);
	
	var _fwaLogo = __webpack_require__(1111);
	
	var _fwaLogo2 = _interopRequireDefault(_fwaLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var ProfilePage = function (_Component) {
		_inherits(ProfilePage, _Component);
	
		function ProfilePage(props) {
			_classCallCheck(this, ProfilePage);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ProfilePage).call(this));
	
			_this2.nextInterval = 0;
			_this2.prevInterval = 0;
	
			_this2.state = {
				loading: true,
				activeOffice: 0,
				cases: false,
				extraHistoryHeight: 0
			};
	
			_this2.metaDesc = '';
			_this2.extraHistoryHeight = 0;
			return _this2;
		}
	
		_createClass(ProfilePage, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.fetchSingle = (0, _redux.bindActionCreators)(_profiles.fetchSingleProfile, this.props.dispatch);
				this.fetchCases = (0, _redux.bindActionCreators)(_profiles.fetchProfileCases, this.props.dispatch);
				this.flushProfile = (0, _redux.bindActionCreators)(_profiles.flushProfile, this.props.dispatch);
	
				if (this.props.routeParams.slug && this.props.routeParams.slug !== this.props.profiles.single.slug) {
					if (!this.state.loading) {
						this.setState({
							loading: true
						});
					}
	
					this.fetchSingle(this.props.routeParams.slug);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var newState = {};
				if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
					newState.loading = true;
	
					this.fetchSingle(nextProps.routeParams.slug);
				}
	
				if (nextProps.profiles.cases && nextProps.profiles.cases.cases) {
					newState.cases = nextProps.profiles.cases.cases;
				}
	
				if (this.state.loading && nextProps.routeParams.slug === nextProps.profiles.single.slug && nextProps.profiles.single && !nextProps.profiles.single.hero) {
					this.setState({
						loading: false
					});
				}
	
				Object.keys(newState).length && this.setState(newState);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.profiles.single.id !== this.props.profiles.single.id || nextProps.profiles.single.name !== this.props.profiles.single.name || nextProps.profiles.cases !== this.props.profiles.cases || nextState !== this.state;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (this.props.profiles.single.relatedCasesCount > 0 && this.props.profiles.single.id !== prevProps.profiles.single.id) {
					this.fetchCases(this.props.routeParams.slug);
				}
	
				if (this.state.cases && this.state.cases.length) {
					this.extraHistoryHeight = 0;
					if (this.refs.awardHistory) {
						this.refs.awardHistory.scrollLeft = 100000;
					}
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.flushProfile();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var profile = this.props.profiles.single;
				var browser = this.props.browser;
	
	
				var transitionClass = 'page__transition';
	
				if (this.state.loading) {
					transitionClass += ' page__transition--transitioning';
				}
	
				if (this.props.profiles.cases && this.props.profiles.cases.cases) {
					profile.cases = this.props.profiles.cases.cases;
				}
	
				var loadingRelated = false;
	
				if (profile.relatedCasesCount > 0 && !profile.cases) {
					loadingRelated = true;
				}
	
				if (profile.meta && profile.meta.description !== this.metaDesc) {
					(0, _meta2.default)(profile.meta.description);
					this.metaDesc = profile.meta.description;
				}
	
				return _react2.default.createElement(
					'div',
					null,
					profile.name && _react2.default.createElement(
						'article',
						{ className: 'profile margin-bottom-contextual' },
						_react2.default.createElement(_reactHelmet2.default, { title: profile.name + ' - The FWA' }),
						_react2.default.createElement(
							'div',
							{ className: transitionClass },
							_react2.default.createElement(_image2.default, { className: 'profile__hero-image span14', img: profile.hero, span: 'span14', browser: browser, onLoad: function onLoad() {
									return _this3.onImageLoaded();
								} }),
							_react2.default.createElement(
								'section',
								{ className: 'profile__info span14' },
								_react2.default.createElement(
									'h3',
									{ className: 'profile__info__type' },
									'Profile'
								),
								_react2.default.createElement(
									'h1',
									{ className: 'profile__info__title' },
									profile.name
								),
								_react2.default.createElement(
									'div',
									{ className: 'profile__info__btns hide-mobile' },
									profile.showreel && _react2.default.createElement(_player.PlayerButtonTrigger, { browser: browser, className: 'profile__info__btns__btn', text: 'Agency Reel', url: profile.showreel }),
									profile.website && _react2.default.createElement(
										'a',
										{ className: 'button button--dark button--go', href: profile.website, target: '_blank' },
										'Agency website'
									)
								)
							),
							(profile.showreel || profile.website) && _react2.default.createElement(
								'div',
								{ className: 'profile__info__btns span14-mobile hide-desktop hide-tablet' },
								profile.showreel && _react2.default.createElement(_player.PlayerButtonTrigger, { browser: browser, className: 'profile__info__btns__btn', text: 'Agency Reel', url: profile.showreel }),
								profile.website && _react2.default.createElement(
									'a',
									{ className: 'button button--dark button--go', href: profile.website, target: '_blank' },
									'Agency website'
								)
							),
							!!profile.stats.count && this.renderStats(profile.stats),
							profile.isHof === 1 && profile.isHundred === 1 && _react2.default.createElement(
								'div',
								{ className: 'span6 span9-tablet span14-mobile profile__hof-hundred' },
								_react2.default.createElement(
									'div',
									{ className: 'profile__hof profile__hof--hundred profile__hof--one-of' },
									_react2.default.createElement('img', { className: 'profile__hof__img profile__hof__img--one-of', src: _fwaLogo2.default.src, role: 'presentation' }),
									'Member ',
									_react2.default.createElement(
										'span',
										{ className: 'profile__hof__weak' },
										'FWA Club 100'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'profile__hof profile__hof--one-of' },
									_react2.default.createElement('img', { className: 'profile__hof__img profile__hof__img--one-of', src: _fwaLogo2.default.src, role: 'presentation' }),
									'Member ',
									_react2.default.createElement(
										'span',
										{ className: 'profile__hof__weak' },
										'FWA Hall of fame'
									)
								)
							) || profile.isHof === 1 && _react2.default.createElement(
								'div',
								{ className: 'profile__hof span5 span7-tablet span14-mobile' },
								_react2.default.createElement('img', { className: 'profile__hof__img', src: _fwaLogo2.default.src, role: 'presentation' }),
								'Member ',
								_react2.default.createElement(
									'span',
									{ className: 'profile__hof__weak' },
									'FWA Hall of fame'
								),
								_react2.default.createElement(
									'span',
									{ className: 'profile__hof__since' },
									'Since ',
									profile.hofSince.split('-')[0]
								)
							) || profile.isHundred === 1 && _react2.default.createElement(
								'div',
								{ className: 'profile__hof profile__hof--hundred span5' },
								_react2.default.createElement('img', { className: 'profile__hof__img', src: _fwaLogo2.default.src, role: 'presentation' }),
								'Member ',
								_react2.default.createElement(
									'span',
									{ className: 'profile__hof__weak' },
									'FWA Club 100'
								)
							) || _react2.default.createElement('div', { className: 'profile__spacer span5 pixel-pattern hide-mobile' }),
							profile.intro && _react2.default.createElement(
								'section',
								{ className: 'profile__description span14' },
								_react2.default.createElement(
									'div',
									{ className: 'profile__description__share' },
									_react2.default.createElement(_share2.default, { title: profile.name, url: window.location.href, browser: browser })
								),
								_react2.default.createElement(
									'h3',
									{ className: 'profile__description__title' },
									'Description:'
								),
								_react2.default.createElement(
									'p',
									{ className: 'profile__description__text span9 span10-tablet span12-mobile' },
									profile.intro
								)
							),
							profile.additional && _react2.default.createElement(
								'section',
								{ className: 'profile__extra span14' },
								_react2.default.createElement('div', { className: 'profile__extra__left span5 hide-tablet hide-mobile' }),
								_react2.default.createElement(
									'p',
									{ className: 'profile__extra__content span8 span13-tablet span12-mobile' },
									profile.additional
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'profile__meta hide-mobile', id: 'contact' },
								_react2.default.createElement('div', { className: 'cf' }),
								_react2.default.createElement(
									'div',
									{ className: 'profile__meta__left span5 span7-tablet span14-mobile' },
									profile.logoProfile && profile.logoProfile.normal && _react2.default.createElement('img', _extends({ className: 'profile__meta__image' }, profile.logoProfile.normal, { alt: profile.name }))
								),
								_react2.default.createElement(
									'div',
									{ className: 'profile__meta__offices span9 span7-tablet span14-mobile' },
									(profile.instagram || profile.linkedin || profile.twitter || profile.facebook) && _react2.default.createElement(
										'div',
										{ className: 'profile__meta__social-wrap hide-tablet hide-mobile' },
										profile.facebook && _react2.default.createElement(
											'a',
											{ className: 'button profile__meta__social', href: profile.facebook },
											'Facebook'
										),
										profile.twitter && _react2.default.createElement(
											'a',
											{ className: 'button profile__meta__social', href: profile.twitter },
											'Twitter'
										),
										profile.linkedin && _react2.default.createElement(
											'a',
											{ className: 'button profile__meta__social', href: profile.linkedin },
											'LinkedIn'
										),
										profile.instagram && _react2.default.createElement(
											'a',
											{ className: 'button profile__meta__social', href: profile.instagram },
											'Instagram'
										)
									),
									profile.offices && profile.offices.length && this.renderOffices(profile.offices, profile)
								)
							),
							(profile.instagram || profile.linkedin || profile.twitter || profile.facebook) && _react2.default.createElement(
								'div',
								{ className: 'profile__meta__social-wrap hide-desktop' },
								profile.facebook && _react2.default.createElement(
									'a',
									{ className: 'button profile__meta__social', href: profile.facebook },
									'Facebook'
								),
								profile.twitter && _react2.default.createElement(
									'a',
									{ className: 'button profile__meta__social', href: profile.twitter },
									'Twitter'
								),
								profile.linkedin && _react2.default.createElement(
									'a',
									{ className: 'button profile__meta__social', href: profile.linkedin },
									'LinkedIn'
								),
								profile.instagram && _react2.default.createElement(
									'a',
									{ className: 'button profile__meta__social', href: profile.instagram },
									'Instagram'
								)
							),
							loadingRelated && browser.window.width > 719 && _react2.default.createElement(
								'section',
								{ className: 'profile__award-history__wrapper span14' },
								profile.name.slice(-1) != 's' && _react2.default.createElement(
									'h2',
									{ className: 'profile__award-history__title' },
									profile.name + '\'s FWA History '
								) || _react2.default.createElement(
									'h2',
									{ className: 'profile__award-history__title' },
									profile.name + '\' FWA History '
								),
								_react2.default.createElement(
									'h3',
									{ className: 'profile__award-history__sub-title' },
									'timeline:'
								),
								_react2.default.createElement(_spinner2.default, { size: '40px', className: 'profile__loading' })
							),
							profile.cases && profile.cases.length && browser.window.width > 719 && _react2.default.createElement(
								'section',
								{ className: 'profile__award-history__wrapper span14' },
								profile.name.slice(-1) != 's' && _react2.default.createElement(
									'h2',
									{ className: 'profile__award-history__title' },
									profile.name + '\'s FWA History '
								) || _react2.default.createElement(
									'h2',
									{ className: 'profile__award-history__title' },
									profile.name + '\' FWA History '
								),
								_react2.default.createElement(
									'h3',
									{ className: 'profile__award-history__sub-title' },
									'timeline:'
								),
								_react2.default.createElement('a', {
									href: '#',
									className: 'profile__award-history__prev',
									onClick: function onClick(event) {
										return _this3.awardPrevent(event);
									},
									onMouseDown: function onMouseDown(event) {
										return _this3.awardHoldPrev(event);
									},
									onTouchStart: function onTouchStart(event) {
										return _this3.awardHoldPrev(event);
									},
									onMouseUp: function onMouseUp(event) {
										return _this3.awardReleasePrev(event);
									},
									onTouchEnd: function onTouchEnd(event) {
										return _this3.awardReleasePrev(event);
									},
									onDragOver: function onDragOver() {
										return _this3.awardDrag();
									}
								}),
								_react2.default.createElement(
									'section',
									{ className: 'profile__award-history span14', ref: 'awardHistory' },
									this.renderAwardHistory(profile.cases)
								),
								_react2.default.createElement('a', {
									href: '#',
									className: 'profile__award-history__next',
									onClick: function onClick(event) {
										return _this3.awardPrevent(event);
									},
									onMouseDown: function onMouseDown(event) {
										return _this3.awardHoldNext(event);
									},
									onTouchStart: function onTouchStart(event) {
										return _this3.awardHoldNext(event);
									},
									onMouseUp: function onMouseUp(event) {
										return _this3.awardReleaseNext(event);
									},
									onTouchEnd: function onTouchEnd(event) {
										return _this3.awardReleaseNext(event);
									},
									onDragOver: function onDragOver() {
										return _this3.awardDrag();
									}
								})
							) || null,
							profile.editorials && !!profile.editorials.length && _react2.default.createElement('div', { className: 'profile__spacer span5 pixel-pattern' }) || null,
							profile.editorials && !!profile.editorials.length && _react2.default.createElement(_relatedinterviews2.default, { interviews: profile.editorials, browser: browser, title: 'Editorials by ' + profile.name }) || null,
							_react2.default.createElement('div', { className: 'profile__spacer span5 pixel-pattern' }),
							_react2.default.createElement(_relatedjobs2.default, { jobs: profile.jobs, title: 'Jobs at ' + profile.name, browser: browser }),
							profile.cases && !!profile.cases.length && _react2.default.createElement('div', { className: 'profile__spacer span5 pixel-pattern' }),
							loadingRelated && _react2.default.createElement(_spinner2.default, { size: '40px', className: 'profile__loading profile__loading--relative' }),
							profile.cases && !!profile.cases.length && _react2.default.createElement(_relatedcases2.default, { profile: true, parentSlug: profile.slug, typeSlug: 'profiles', cases: profile.cases, names: profile.name, browser: browser }),
							_react2.default.createElement('div', { className: 'cf' })
						),
						_react2.default.createElement(_contextual2.default, { enableProfiles: true, nextProfile: profile.next, prevProfile: profile.prev })
					)
				);
			}
		}, {
			key: 'onImageLoaded',
			value: function onImageLoaded() {
				if (this.state.loading && this.props.routeParams.slug === this.props.profiles.single.slug) {
					this.setState({
						loading: false
					});
				}
			}
		}, {
			key: 'renderStats',
			value: function renderStats(stats) {
				var _this4 = this;
	
				var extra = [];
				var statsArr = [];
				var count = stats.count;
	
				(0, _forEach2.default)(stats.awards, function (award, key) {
					var local = {
						name: key,
						number: award
					};
	
					statsArr.push(local);
				});
	
				if (statsArr.length < 8) {
					for (var i = 0; i < 8 - statsArr.length; i++) {
						extra.push('placeholder');
					};
				}
	
				if (count < 10) {
					count = '0' + count;
				}
	
				return _react2.default.createElement(
					'div',
					{ key: 'stats', className: 'profile__stats span14' },
					_react2.default.createElement(
						'div',
						{ className: 'profile__stats__left span10' },
						statsArr.map(function (stat, i) {
							return _this4.renderStat(stat, i);
						}),
						extra.map(function () {
							return _this4.renderStat.apply(_this4, arguments);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'profile__stats__stat profile__stats__stat--big pixel-pattern span4 span7-mobile' },
						_react2.default.createElement(
							'h3',
							{ className: 'profile__stats__stat__title' },
							'AWARDS:'
						),
						_react2.default.createElement(_pixeltext2.default, { text: count.toString(), className: 'profile__stats__stat__number' })
					),
					_react2.default.createElement('div', { className: 'cf' })
				);
			}
		}, {
			key: 'renderStat',
			value: function renderStat(stat, i) {
				var _this5 = this;
	
				var uid = 'stat -' + i;
				var number = 0;
	
				if (stat.number) {
					number = stat.number;
	
					if (number < 10) {
						number = '0' + number;
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ key: uid, className: 'profile__stats__stat pixel-pattern hide-mobile' },
					stat.name && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h3',
							{ className: 'profile__stats__stat__title', ref: stat.name.toLowerCase() },
							stat.name,
							':'
						),
						_react2.default.createElement(
							_tooltip2.default,
							{ attachTo: function attachTo() {
									return _this5.getRef(stat.name.toLowerCase());
								} },
							_react2.default.createElement(
								'header',
								null,
								'description:'
							),
							_react2.default.createElement(
								'h2',
								null,
								(0, _translate2.default)('awards/' + stat.name.toLowerCase() + '/title')
							),
							(0, _translate2.default)('awards/' + stat.name.toLowerCase() + '/text')
						),
						_react2.default.createElement(_pixeltext2.default, { text: number.toString(), className: 'profile__stats__stat__number' })
					) || null
				);
			}
		}, {
			key: 'renderOffices',
			value: function renderOffices(offices, profile) {
				var _this6 = this;
	
				var options = [];
	
				offices.map(function (office, i) {
					//Add +1 to value, to not have value: 0 in <select>
					options.push({
						label: office.name,
						value: i + 1
					});
				});
	
				return _react2.default.createElement(
					'div',
					null,
					offices.length > 1 && _react2.default.createElement(_select2.default, {
						onChange: function onChange(event) {
							return _this6.officeChange(event);
						},
						ref: 'officeInput',
						className: 'span2 span3-tablet span12-mobile',
						placeholder: 'Other offices',
						options: options }),
					_react2.default.createElement(
						'ul',
						{ className: 'profile__meta__offices__office-holder' },
						offices.map(function (office, i) {
							return _this6.renderOffice(office, i, profile);
						})
					)
				);
			}
		}, {
			key: 'officeChange',
			value: function officeChange(e) {
				//We need to substract one, as we added on above. All due to value:0 being regarded as nothing in a select.
	
				this.setState({
					activeOffice: this.refs.officeInput.value - 1
				});
			}
		}, {
			key: 'renderOffice',
			value: function renderOffice(office, i, profile) {
				var uid = 'office-' + i;
				var className = 'profile__meta__offices__office';
				if (this.state.activeOffice == i) {
					className += ' profile__meta__offices__office--active';
				}
	
				var email = profile.contactEmail;
	
				if (office.email && office.email !== '') {
					email = office.email;
				}
	
				return _react2.default.createElement(
					'li',
					{ key: uid, ref: uid, className: className },
					_react2.default.createElement(
						'div',
						{ className: 'profile__meta__offices__office__location span2 span3-tablet span8-mobile' },
						_react2.default.createElement(
							'h2',
							{ className: 'profile__meta__offices__office__name' },
							profile.name + ' ' + office.name
						),
						_react2.default.createElement(
							'span',
							null,
							office.address1
						),
						_react2.default.createElement(
							'span',
							null,
							office.address2
						),
						_react2.default.createElement(
							'span',
							null,
							office.address3
						),
						_react2.default.createElement(
							'span',
							null,
							office.country
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'profile__meta__offices__office__contact span2 span3-tablet span8-mobile' },
						_react2.default.createElement(
							'span',
							null,
							office.phone
						),
						_react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(
								'a',
								{ href: 'mailto:' + profile.contactEmail },
								email
							)
						),
						_react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(
								'a',
								{ href: profile.website },
								profile.website
							)
						)
					)
				);
			}
		}, {
			key: 'awardPrevent',
			value: function awardPrevent(e) {
				e.preventDefault();
			}
		}, {
			key: 'awardHoldNext',
			value: function awardHoldNext(e) {
				var _this = this;
				clearInterval(this.prevInterval);
				clearInterval(this.nextInterval);
	
				this.nextInterval = setInterval(function () {
					_this.refs.awardHistory.scrollLeft += 5;
				}, 10);
			}
		}, {
			key: 'awardReleaseNext',
			value: function awardReleaseNext(e) {
				clearInterval(this.prevInterval);
				clearInterval(this.nextInterval);
			}
		}, {
			key: 'awardHoldPrev',
			value: function awardHoldPrev(e) {
				var _this = this;
				clearInterval(this.nextInterval);
				clearInterval(this.prevInterval);
	
				this.prevInterval = setInterval(function () {
					_this.refs.awardHistory.scrollLeft -= 5;
				}, 10);
			}
		}, {
			key: 'awardReleasePrev',
			value: function awardReleasePrev(e) {
				clearInterval(this.prevInterval);
				clearInterval(this.nextInterval);
			}
		}, {
			key: 'awardHover',
			value: function awardHover(uid) {
	
				var all = document.querySelectorAll('.profile__award-history__award');
	
				for (var i = 0; i < all.length; i++) {
					all[i].classList.add('inactive');
				}
	
				this.refs[uid].classList.remove('inactive');
			}
		}, {
			key: 'awardHoverOut',
			value: function awardHoverOut() {
	
				var all = document.querySelectorAll('.profile__award-history__award');
	
				for (var i = 0; i < all.length; i++) {
					all[i].classList.remove('inactive');
				}
			}
		}, {
			key: 'awardDrag',
			value: function awardDrag() {
				//People accidently dragged the button :(
	
				clearInterval(this.prevInterval);
				clearInterval(this.nextInterval);
			}
		}, {
			key: 'renderAwardHistory',
			value: function renderAwardHistory(awards) {
				var _this7 = this;
	
				var years = [];
	
				this.yearNum = -1;
	
				this.yearsCount = 0;
	
				var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	
				awards.map(function (award, i) {
					award.awards.map(function (aw) {
						var awardYear = aw.awardedDate;
						var dontAdd = false;
						awardYear = awardYear.split('-');
						awardYear = awardYear[0];
						if (years[awardYear]) {
							years[awardYear].map(function (idTest) {
								if (idTest.id == award.id) {
									dontAdd = true;
								}
							});
							if (!dontAdd) {
								var localAward = years[awardYear];
								localAward.push(award);
								years[awardYear] = localAward;
							}
						} else {
							years[awardYear] = new Array(award);
							_this7.yearsCount += 1;
						}
					});
				});
	
				years.map(function (test, i) {
					months.map(function (month) {
						var localNum = 0;
						test.map(function (awards) {
							awards.awards.map(function (tests) {
								if (tests.awardedDate.split('-')[1] == month && tests.awardedDate.split('-')[0] == i) {
									localNum++;
								}
							});
						});
						if (localNum > 7) {
							var localHeight = localNum * 20 + 20 + 38;
							if (localHeight > _this7.extraHistoryHeight) {
								_this7.extraHistoryHeight = localHeight;
							}
						}
					});
				});
	
				var extraW = 98;
	
				if (this.props.browser.window.width < 1200) {
					extraW = 50;
				}
	
				if (this.props.browser.window.width < 720) {
					extraW = 0;
				}
	
				if (this.yearsCount == 1) {
					extraW = 520;
	
					if (this.props.browser.window.width < 1000) {
						extraW = 0;
					}
				}
	
				var yearStyle = {};
				var historyStyle = { width: this.yearsCount * 650 + extraW + 'px' };
	
				if (this.extraHistoryHeight != 0) {
					yearStyle = { height: this.extraHistoryHeight + 'px' };
					historyStyle = _extends({}, historyStyle, yearStyle);
				}
	
				return _react2.default.createElement(
					'svg',
					{ key: 'awardHistory', className: 'pixel-pattern profile__award-history__holder', scrollLeft: '300px', style: historyStyle },
					_react2.default.createElement(
						'pattern',
						{ id: 'lineDots', patternUnits: 'userSpaceOnUse', width: 1, height: 2 },
						_react2.default.createElement('image', { width: _graphTextDots2.default.width, height: _graphTextDots2.default.height, xlinkHref: _graphTextDots2.default.src })
					),
					years.map(function (year, key) {
						return _this7.renderYear(year, key);
					})
				);
			}
		}, {
			key: 'renderYear',
			value: function renderYear(awards, year, yearStyle) {
				var _this8 = this;
	
				var uid = 'award-' + year;
	
				var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	
				this.yearNum += 1;
	
				var yearWidth = 650;
	
				if (this.yearsCount == 1 && this.props.browser.window.width > 1000) {
					yearWidth = 1170;
				}
	
				return _react2.default.createElement(
					'svg',
					{ key: uid, x: this.yearNum * yearWidth, style: yearStyle, className: 'profile__award-history__year' },
					this.extraHistoryHeight != 0 && _react2.default.createElement(
						'text',
						{ x: '30', y: this.extraHistoryHeight - 48, className: 'profile__award-history__year__text--awards' },
						year
					) || _react2.default.createElement(
						'text',
						{ x: '30', y: '130', className: 'profile__award-history__year__text--awards' },
						year
					),
					this.extraHistoryHeight != 0 && _react2.default.createElement(
						'text',
						{ x: '30', y: this.extraHistoryHeight - 28, className: 'profile__award-history__year__text--year' },
						'awards'
					) || _react2.default.createElement(
						'text',
						{ x: '30', y: '150', className: 'profile__award-history__year__text--year' },
						'awards'
					),
					this.yearNum > 0 && this.extraHistoryHeight != 0 && _react2.default.createElement('line', { className: 'profile__award-history__year-line', x1: '0', x2: '0', y1: '0', y2: this.extraHistoryHeight }) || this.yearNum > 0 && _react2.default.createElement('line', { className: 'profile__award-history__year-line', x1: '0', x2: '0', y1: '0', y2: '178' }),
					months.map(function (month, i) {
						var uid = 'month-' + i;
						var thisMonth = [];
						var monthNum = i;
						var between = 50;
	
						if (_this8.yearsCount == 1 && _this8.props.browser.window.width > 1000) {
							between = 95;
						}
	
						var lineDistance = between / 4 - 1;
						var bottomDistance = between / 4;
	
						var monthX = 50 + i * between;
	
						awards.map(function (award, i) {
							award.awards.map(function (aw, i) {
	
								if (aw.awardedDate.split('-')[1] == month && aw.awardedDate.split('-')[0] == year) {
									var localAward = {
										date: aw.awardedDate,
										type: aw.type,
										award: award
									};
									thisMonth.push(localAward);
								}
							});
	
							// if (award.createdDate.split('-')[1] == month){
							// 	thisMonth.push(award);
							// }
						});
	
						if (thisMonth.length > 7) {
							var localHeight = (thisMonth.length - 7) * 20 + 20;
							if (_this8.extraHistoryHeight < localHeight) {
								_this8.extraHistoryHeight = localHeight;
							}
						}
	
						return _react2.default.createElement(
							'g',
							{ key: uid },
							_react2.default.createElement('line', { x1: monthX + 6, x2: monthX + 6, y1: '0', y2: '25', className: 'profile__award-history__month__line' }),
							month == '01' && _this8.extraHistoryHeight != 0 && _react2.default.createElement(
								'g',
								null,
								_react2.default.createElement('line', { x1: monthX - 6, x2: monthX - 6, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 17, x2: monthX - 17, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 28, x2: monthX - 28, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 39, x2: monthX - 39, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 6, x2: monthX - 6, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 17, x2: monthX - 17, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 28, x2: monthX - 28, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 39, x2: monthX - 39, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' })
							) || month == '01' && _react2.default.createElement(
								'g',
								null,
								_react2.default.createElement('line', { x1: monthX - 6, x2: monthX - 6, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 17, x2: monthX - 17, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 28, x2: monthX - 28, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 39, x2: monthX - 39, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 6, x2: monthX - 6, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 17, x2: monthX - 17, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 28, x2: monthX - 28, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX - 39, x2: monthX - 39, y1: '178', y2: '168', className: 'profile__award-history__month__line' })
							),
							_react2.default.createElement('line', { x1: monthX + lineDistance * 1, x2: monthX + lineDistance * 1, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
							_react2.default.createElement('line', { x1: monthX + lineDistance * 2, x2: monthX + lineDistance * 2, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
							_react2.default.createElement('line', { x1: monthX + lineDistance * 3, x2: monthX + lineDistance * 3, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
							_react2.default.createElement('line', { x1: monthX + lineDistance * 4, x2: monthX + lineDistance * 4, y1: '0', y2: '10', className: 'profile__award-history__month__line' }),
							_this8.extraHistoryHeight != 0 && _react2.default.createElement(
								'g',
								null,
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 1, x2: monthX + bottomDistance * 1, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 2, x2: monthX + bottomDistance * 2, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 3, x2: monthX + bottomDistance * 3, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 4, x2: monthX + bottomDistance * 4, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 5, x2: monthX + bottomDistance * 5, y1: _this8.extraHistoryHeight, y2: _this8.extraHistoryHeight - 10, className: 'profile__award-history__month__line' })
							) || _react2.default.createElement(
								'g',
								null,
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 1, x2: monthX + bottomDistance * 1, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 2, x2: monthX + bottomDistance * 2, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 3, x2: monthX + bottomDistance * 3, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 4, x2: monthX + bottomDistance * 4, y1: '178', y2: '168', className: 'profile__award-history__month__line' }),
								_react2.default.createElement('line', { x1: monthX + bottomDistance * 5, x2: monthX + bottomDistance * 5, y1: '178', y2: '168', className: 'profile__award-history__month__line' })
							),
							_react2.default.createElement(
								'g',
								null,
								_react2.default.createElement(
									'text',
									{ className: 'profile__award-history__award__text profile__award-history__award__text--safari', x: '325', y: '163' },
									'safari bugfix'
								)
							),
							thisMonth.map(function (award, i) {
								var uid = 'singleAward-' + _this8.yearNum + '-' + monthNum + '-' + i;
								var date = new _date.DateFormatter(award.date);
								var awardClass = 'profile__award-history__award__' + award.type.toLowerCase() + ' profile__award-history__award__single';
								var url = '';
	
								if (award.award.slug && (0, _index.casesRoute)(award.award.slug) && !!(0, _index.casesRoute)(award.award.slug).length && !!award.award.slug.length) {
									url = (0, _index.casesRoute)(award.award.slug);
								}
	
								//@TODO add real URL again! :) - Figure out why it crashes everything (jam3 -> big spaceship)
	
								return _react2.default.createElement(
									'g',
									{ onMouseEnter: function onMouseEnter() {
											_this8.awardHover(uid);
										}, onMouseLeave: function onMouseLeave() {
											_this8.awardHoverOut();
										}, key: uid, ref: uid, className: 'profile__award-history__award' },
									_react2.default.createElement(
										'a',
										{ xlinkHref: url, onClick: function onClick(e) {
												e.preventDefault();
												_this8.props.dispatch((0, _reduxRouter.push)(url));
											} },
										award.award.thumbnail[1364] && _react2.default.createElement('g', { className: 'profile__award-history__award__image', dangerouslySetInnerHTML: { __html: "<image x=" + (monthX - 68) + " y=" + (30 + i * 20 - 90) + " width='146' height='93' xlink:href=" + award.award.thumbnail[1364].span3 + " />" } }),
										_react2.default.createElement('rect', { className: 'profile__award-history__award__dot', x: monthX + 5, y: 30 + i * 20 + 5, width: '2', height: '2' }),
										_this8.extraHistoryHeight != 0 && _react2.default.createElement(
											'text',
											{ className: 'profile__award-history__award__text', x: '325', y: _this8.extraHistoryHeight - 15 },
											award.type + ' ' + date.date + ' ' + date.month.substr(0, 3)
										) || _react2.default.createElement(
											'text',
											{ className: 'profile__award-history__award__text', x: '325', y: '163' },
											award.type + ' ' + date.date + ' ' + date.month.substr(0, 3)
										)
									),
									_react2.default.createElement('rect', { className: awardClass, x: monthX, y: 30 + i * 20, width: '12', height: '12', rx: '5', ry: '5' })
								);
							})
						);
					}),
					this.yearNum > 0 && _react2.default.createElement('line', { className: 'profile__award-history__year-line', x1: this.yearNum * 650, x2: this.yearNum * 650, y1: '0', y2: '178' })
				);
			}
		}, {
			key: 'getRef',
			value: function getRef(name) {
				return this.refs[name];
			}
		}]);
	
		return ProfilePage;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(ProfilePage);

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sweetScroll = __webpack_require__(63);
	
	var _sweetScroll2 = _interopRequireDefault(_sweetScroll);
	
	var _lodash = __webpack_require__(35);
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _spinner = __webpack_require__(9);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _index = __webpack_require__(4);
	
	var _profiles = __webpack_require__(1049);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _profilePlaceholder = __webpack_require__(1115);
	
	var _profilePlaceholder2 = _interopRequireDefault(_profilePlaceholder);
	
	var _tooltip = __webpack_require__(180);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _translate = __webpack_require__(16);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _meta = __webpack_require__(98);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _connect = __webpack_require__(8);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _profiles3 = __webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import css from './editorial.scss';
	
	var Profiles = function (_Component) {
		_inherits(Profiles, _Component);
	
		function Profiles(props) {
			_classCallCheck(this, Profiles);
	
			var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(Profiles).call(this));
	
			_this2.scrollHandler = _this2.scrollHandler.bind(_this2);
			_this2.mounted = true;
	
			_this2.state = {
				searched: false,
				isSticky: false,
				stickAtPos: 0,
				stickyHeight: 0,
				headerHeight: 0
			};
	
			_this2.query = '';
			_this2.offset = '';
			_this2.limit = '';
			_this2.order = '';
			_this2.orderBy = '';
			_this2.profiles = [];
			_this2.already = [];
			return _this2;
		}
	
		_createClass(Profiles, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				//console.log('editorial will mount');
				this.fetchProfiles = (0, _redux.bindActionCreators)(_profiles3.fetchProfiles, this.props.dispatch);
	
				this.fetchProfiles();
	
				if (this.props.browser) {
					this.props.browser.scroll.register(this.scrollHandler);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
				if (this.props.browser) {
					this.props.browser.scroll.deregister(this.scrollHandler);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (this.props.browser.window.width !== nextProps.browser.window.width) {
					this.updateDimensions();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateDimensions();
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return nextProps.browser.window.width !== this.props.browser.window.width || nextProps.profiles.next !== this.props.profiles.next || nextProps.profiles.profiles.length !== this.props.profiles.profiles.length || nextProps.profiles.profiles !== this.props.profiles.profiles || nextState !== this.state;
	
				// update on init
				// if ((!this.props.items.length && nextProps.items.length)) {
				// 	return true;
				// }
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				this.state.searched = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var profiles = this.props.profiles.profiles;
				var spinnerClass = 'profile-list__table__spinner';
				var startNum = 1;
				var total = profiles.length;
				var used = false;
	
				var _this = this;
	
				if (profiles.length) {
					if (!this.already.length) {
						(0, _lodash.forEach)(profiles, function (single, i) {
							_this.profiles.push(single);
						});
						this.already.push(profiles[0].id);
					} else {
						(0, _lodash.forEach)(this.already, function (already) {
							if (already == profiles[0].id) {
								used = true;
							}
						});
	
						if (!used) {
							(0, _lodash.forEach)(profiles, function (single, i) {
								_this.profiles.push(single);
							});
	
							this.already.push(profiles[0].id);
						}
					}
				}
	
				if (!this.profiles.length || profiles.length && profiles[0].id !== this.profiles[0].id) {}
	
				if (this.state.searched) {
					spinnerClass = 'profile-list__table__spinner profile-list__table__spinner--active';
				}
	
				var offset = 0;
	
				if (this.props.profiles.next) {
					var parameters = this.props.profiles.next;
					parameters = parameters.split('/');
					parameters = parameters[parameters.length - 1];
	
					parameters = parameters.split('&');
	
					offset = parameters[0].split('=')[1];
	
					startNum = offset - profiles.length + 1;
	
					total = offset;
				};
	
				if (!this.props.profiles.next && this.props.profiles.prev) {
					var _parameters = this.props.profiles.prev;
					_parameters = _parameters.split('/');
					_parameters = _parameters[_parameters.length - 1];
	
					_parameters = _parameters.split('&');
	
					offset = _parameters[0].split('=')[1];
	
					startNum = parseInt(offset) + 37;
	
					total = parseInt(offset) + 36 + profiles.length;
				}
	
				this.inputTimeout = false;
	
				//console.log(this.props.profiles);
	
				if (this.props.profiles.meta && this.props.profiles.meta.description !== this.metaDesc) {
					(0, _meta2.default)(this.props.profiles.meta.description);
					this.metaDesc = this.props.profiles.meta.description;
				}
	
				var stickyStyle = {};
				var placeholderStyle = {};
	
				if (this.state.isSticky) {
					placeholderStyle.height = this.state.stickyHeight;
	
					stickyStyle.position = 'fixed';
					stickyStyle.top = this.state.headerHeight;
					stickyStyle.height = this.state.stickyHeight;
				}
	
				return _react2.default.createElement(
					'div',
					null,
					(!!profiles.length || profiles.error) && _react2.default.createElement(
						'article',
						{ className: 'profile-list span14' },
						_react2.default.createElement(_reactHelmet2.default, { title: this.props.profiles.meta.title }),
						_react2.default.createElement('div', { className: 'profile-list__sticky-placeholder', style: placeholderStyle }),
						_react2.default.createElement(
							'div',
							{ className: 'profile-list__sticky', ref: 'stickyElement', style: stickyStyle },
							_react2.default.createElement(
								'div',
								{ className: 'profile-list__top span14' },
								_react2.default.createElement(
									'h1',
									{ className: 'profile-list__top__title' },
									'Profiles'
								),
								_react2.default.createElement(
									'span',
									{ className: 'profile-list__top__number' },
									' (',
									this.props.profiles.totalProfiles,
									')'
								)
							),
							_react2.default.createElement('input', { className: 'profile-list__search span12 pixel-pattern hide-mobile', onChange: function onChange(event) {
									return _this3.onInput(event);
								}, type: 'text', placeholder: (0, _translate2.default)('contextual/profilesSearch') }),
							_react2.default.createElement(
								'div',
								{ className: 'profile-list__right span2 hide-mobile' },
								_react2.default.createElement(
									'h3',
									{ className: 'profile-list__right__title' },
									'showing'
								),
								!profiles.error && _react2.default.createElement(
									'h2',
									{ className: 'profile-list__right__number' },
									startNum + ' — ' + total
								) || _react2.default.createElement(
									'h2',
									{ className: 'profile-list__right__number' },
									'None'
								),
								_react2.default.createElement(
									'h2',
									{ className: 'profile-list__right__total' },
									'of ' + this.props.profiles.total
								),
								_react2.default.createElement(
									'nav',
									{ className: 'profile-list__right__nav' },
									this.props.profiles.prev && _react2.default.createElement(
										'a',
										{ href: '#head', onClick: function onClick(event) {
												return _this3.profilesNav(event, _this3.props.profiles.prev);
											}, className: 'profile-list__right__nav__prev pixel-pattern' },
										_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
									) || _react2.default.createElement(
										'span',
										{ className: 'profile-list__right__nav__prev pixel-pattern' },
										_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive' })
									),
									this.props.profiles.next && _react2.default.createElement(
										'a',
										{ href: '#head', onClick: function onClick(event) {
												return _this3.profilesNav(event, _this3.props.profiles.next);
											}, className: 'profile-list__right__nav__next pixel-pattern' },
										_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
									) || _react2.default.createElement(
										'span',
										{ className: 'profile-list__right__nav__next pixel-pattern' },
										_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive' })
									)
								)
							)
						),
						_react2.default.createElement(
							'table',
							{ sortable: true, className: 'profile-list__table span12 span14-mobile', ref: 'tableHead', id: 'head' },
							_react2.default.createElement(
								'thead',
								null,
								_react2.default.createElement(
									'tr',
									null,
									_react2.default.createElement('th', { className: 'profile-list__table__head__title hide-tablet hide-mobile' }),
									_react2.default.createElement(
										'th',
										{ className: 'profile-list__table__head__title profile-list__table__head__title--left' },
										'Name'
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'total', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title profile-list__table__head__title--total profile-list__table__head__title--sort ' },
										_react2.default.createElement(
											'span',
											{ className: 'hide-mobile' },
											'Total'
										),
										_react2.default.createElement(
											'span',
											{ className: 'hide-tablet hide-desktop' },
											'Awards'
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'FOTD', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'FOTD' },
											'FOTD'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.FOTD;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/fotd/title')
											),
											(0, _translate2.default)('awards/fotd/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'TCEA', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'TCEA' },
											'TCEA'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.TCEA;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/tcea/title')
											),
											(0, _translate2.default)('awards/tcea/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'FOTM', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'FOTM' },
											'FOTM'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.FOTM;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/fotm/title')
											),
											(0, _translate2.default)('awards/fotm/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'FOTY', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'FOTY' },
											'FOTY'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.FOTY;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/foty/title')
											),
											(0, _translate2.default)('awards/foty/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'TCEAY', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'TCEAY' },
											'TCEAY'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.TCEAY;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/tceay/title')
											),
											(0, _translate2.default)('awards/tceay/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'PCA', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile' },
										_react2.default.createElement(
											'span',
											{ ref: 'PCA' },
											'PCA'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.PCA;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/pca/title')
											),
											(0, _translate2.default)('awards/pca/text')
										)
									),
									_react2.default.createElement(
										'th',
										{ 'data-sort': 'MOTD', onClick: function onClick(event) {
												return _this3.sortClick(event);
											}, className: 'profile-list__table__head__title hide-mobile profile-list__table__head__title--no-border' },
										_react2.default.createElement(
											'span',
											{ ref: 'MOTD' },
											'MOTD'
										),
										_react2.default.createElement(
											_tooltip2.default,
											{ attachTo: function attachTo() {
													return _this3.refs.MOTD;
												} },
											_react2.default.createElement(
												'header',
												null,
												'Description:'
											),
											_react2.default.createElement(
												'h2',
												null,
												(0, _translate2.default)('awards/motd/title')
											),
											(0, _translate2.default)('awards/motd/text')
										)
									)
								)
							),
							_react2.default.createElement(
								'tbody',
								null,
								_react2.default.createElement(
									'tr',
									{ ref: 'profileSpinner', className: spinnerClass },
									_react2.default.createElement(
										'td',
										null,
										_react2.default.createElement(_spinner2.default, { className: 'profile-list__table__spinner__spinner', size: '80px' })
									)
								),
								this.props.browser.window.width < 720 && this.profiles.map(function (profile, i) {
									return _this3.renderProfile(profile, i);
								}) || profiles.length && profiles.map(function (profile, i) {
									return _this3.renderProfile(profile, i);
								}) || profiles.error && _react2.default.createElement(
									'tr',
									{ className: 'profile-list__profile' },
									_react2.default.createElement('td', { className: 'profile-list__profile__cell profile-list__profile__picture span1 hide-tablet hide-mobile' }),
									_react2.default.createElement(
										'td',
										{ className: 'profile-list__profile__cell profile-list__profile__name span4 span10-mobile' },
										profiles.error.title,
										_react2.default.createElement(
											'span',
											{ className: 'profile-list__profile__name profile-list__profile__name__weak' },
											profiles.error.message
										)
									),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile' }),
									_react2.default.createElement('td', { className: 'profile-list__profile__cell hide-mobile profile-list__profile__cell--no-border profile-list__profile__cell--grey' })
								)
							)
						),
						this.props.browser.window.width < 720 && this.props.profiles.next && _react2.default.createElement(
							'a',
							{ href: '#head', onClick: function onClick(event) {
									return _this3.profilesNav(event, _this3.props.profiles.next);
								}, className: 'profile-list__right__nav__next pixel-pattern' },
							_react2.default.createElement('span', { className: 'profile-list__right__nav__arrow' })
						)
					) || _react2.default.createElement(_spinner2.default, { className: 'case-single__spinner', size: '80px' })
				);
			}
		}, {
			key: 'hasClass',
			value: function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}
		}, {
			key: 'sortClick',
			value: function sortClick(e) {
	
				var target = e.target;
	
				if (!this.hasClass(target, 'profile-list__table__head__title')) {
					target = target.parentNode;
				}
	
				//console.log(target);
	
				this.orderBy = target.getAttribute('data-sort');
	
				if (this.hasClass(target, 'profile-list__table__head__title--sort')) {
					target.classList.toggle('profile-list__table__head__title--sort--asc');
					if (this.order == '') {
						this.order = 'ASC';
					} else {
						this.order = '';
					}
				} else {
					if (document.querySelector('.profile-list__table__head__title--sort')) {
						document.querySelector('.profile-list__table__head__title--sort').classList.remove('profile-list__table__head__title--sort');
					}
	
					if (document.querySelector('.profile-list__table__head__title--sort--asc')) {
						document.querySelector('.profile-list__table__head__title--sort--asc').classList.remove('profile-list__table__head__title--sort--asc');
					}
	
					target.classList.add('profile-list__table__head__title--sort');
				}
	
				this.setState({
					searched: true
				});
	
				this.fetchProfiles(0, 36, this.query, this.order, this.orderBy);
			}
		}, {
			key: 'renderProfile',
			value: function renderProfile(profile, i) {
				var uid = 'profile-' + i;
				var url = (0, _index.profilesRoute)(profile.slug);
	
				var offices = '';
	
				if (profile.offices.length) {
					for (var i = 0; i < profile.offices.length; i++) {
						if (i < profile.offices.length - 1) {
							offices += profile.offices[i].name + ', ';
						} else {
							offices += profile.offices[i].name;
						}
					}
				} else if (profile.legacyOffice && profile.legacyOffice !== '') {
					offices = profile.legacyOffice;
				}
	
				return _react2.default.createElement(
					'tr',
					{ key: uid, className: 'profile-list__profile' },
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell profile-list__profile__picture span1 hide-tablet hide-mobile' },
						profile.logo && profile.logo.normal && _react2.default.createElement(
							_reactRouter.Link,
							{ to: url },
							_react2.default.createElement('img', _extends({}, profile.logo.normal, { alt: profile.name }))
						)
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell profile-list__profile__name span4 span10-mobile' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: url },
							profile.name,
							_react2.default.createElement(
								'span',
								{ className: 'profile-list__profile__name profile-list__profile__name__weak' },
								offices
							)
						)
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell' },
						profile.stats.total
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.FOTD
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.TCEA
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.FOTM
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.FOTY
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.TCEAY
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile' },
						profile.stats.PCA
					),
					_react2.default.createElement(
						'td',
						{ className: 'profile-list__profile__cell hide-mobile profile-list__profile__cell--no-border profile-list__profile__cell--grey' },
						profile.stats.MOTD
					)
				);
			}
		}, {
			key: 'profilesNav',
			value: function profilesNav(e) {
				var href = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				e.preventDefault();
				var parameters = href;
				parameters = parameters.split('/');
				parameters = parameters[parameters.length - 1];
	
				parameters = parameters.split('&');
	
				var offset = parameters[0].split('=')[1];
	
				var limit = parameters[1].split('=')[1];
	
				var query = parameters[2].split('=')[1];
	
				this.setState({
					searched: true
				});
	
				this.offset = offset;
				this.limit = limit;
				this.query = query;
	
				if (this.props.browser.window.width > 719) {
					var element = _reactDom2.default.findDOMNode(this.refs.tableHead);
					if (element && typeof element.getAttribute === 'function') {
						// console.log(element.offsetTop);
						var scroller = new _sweetScroll2.default({ offset: -element.offsetTop, duration: 500 });
						scroller.to('#' + element.getAttribute('id'));
					}
				}
	
				this.fetchProfiles(offset, limit, query, this.order, this.orderBy);
			}
		}, {
			key: 'onInput',
			value: function onInput(e) {
				var string = e.target.value;
	
				var state = this.state.searched;
				var _this = this;
	
				clearTimeout(this.inputTimeout);
	
				if (document.querySelector('.profile-list__table__head__title--sort')) {
					document.querySelector('.profile-list__table__head__title--sort').classList.remove('profile-list__table__head__title--sort');
				}
	
				if (document.querySelector('.profile-list__table__head__title--sort--asc')) {
					document.querySelector('.profile-list__table__head__title--sort--asc').classList.remove('profile-list__table__head__title--sort--asc');
				}
	
				document.querySelector('.profile-list__table__head__title--total').classList.add('profile-list__table__head__title--sort');
	
				this.query = string;
	
				this.inputTimeout = setTimeout(function () {
					_this.fetchProfiles(0, 36, string, '', '');
					_this.setState({
						searched: true
					});
				}, 400);
			}
		}, {
			key: 'updateDimensions',
			value: function updateDimensions() {
				var _this4 = this;
	
				var headerHeight = document.querySelector('.header-main').offsetHeight;
				var mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
				var distanceToMenu = mainOffsetTop - headerHeight ? mainOffsetTop - headerHeight : 1000;
	
				var stickyHeight = this.refs.stickyElement ? this.refs.stickyElement.offsetHeight : 0;
	
				if (distanceToMenu === 1000) {
					setTimeout(function () {
						_this4.updateDimensions();
					}, 200);
				}
	
				this.mounted && this.setState(_extends({}, this.state, {
					stickAtPos: distanceToMenu,
					stickyHeight: stickyHeight,
					headerHeight: headerHeight
				}));
			}
		}, {
			key: 'scrollHandler',
			value: function scrollHandler(e) {
				if (e.scrollY === this.prevSrollY) {
					return false; // noop
				} else {
					this.prevSrollY = e.scrollY;
				}
	
				var isMobile = this.props.browser.window.width <= 719;
				var isSticky = e.scrollY >= this.state.stickAtPos && !isMobile;
	
				if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
					return this.updateDimensions();
				}
	
				// stop setting state if not necessary
				if (this.state.isSticky === isSticky) {
					return false; // noop
				}
	
				this.setState(_extends({}, this.state, {
					isSticky: isSticky
				}));
			}
		}]);
	
		return Profiles;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(Profiles);

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _publicvoting = __webpack_require__(376);
	
	var _publicvoting2 = _interopRequireDefault(_publicvoting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PCA = function (_Component) {
		_inherits(PCA, _Component);
	
		function PCA(props) {
			_classCallCheck(this, PCA);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PCA).call(this, props));
	
			_this.state = {
				blurb: 'pca/blurb',
				head: 'pca/head',
				subhead: 'pca/subhead',
				confirm: 'pca/confirm',
				about: 'pca/about',
				ribbonStyle: 'fotm',
				voteUrl: _baseUrl2.default + '/api/account/jury/pca',
				sponsor: false
			};
			return _this;
		}
	
		_createClass(PCA, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_publicvoting2.default, this.state);
			}
		}]);
	
		return PCA;
	}(_react.Component);
	
	PCA.propTypes = {};
	exports.default = PCA;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseUrl = __webpack_require__(6);
	
	var _baseUrl2 = _interopRequireDefault(_baseUrl);
	
	var _publicvoting = __webpack_require__(376);
	
	var _publicvoting2 = _interopRequireDefault(_publicvoting);
	
	var _tceaySponsor = __webpack_require__(1116);
	
	var _tceaySponsor2 = _interopRequireDefault(_tceaySponsor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TCEAY = function (_Component) {
		_inherits(TCEAY, _Component);
	
		function TCEAY(props) {
			_classCallCheck(this, TCEAY);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TCEAY).call(this, props));
	
			_this.state = {
				blurb: 'tceay/blurb',
				head: 'tceay/head',
				subhead: 'tceay/subhead',
				confirm: 'tceay/confirm',
				about: 'tceay/about',
				ribbonStyle: 'tcea',
				voteUrl: _baseUrl2.default + '/api/account/jury/tceay',
				sponsor: _tceaySponsor2.default
			};
			return _this;
		}
	
		_createClass(TCEAY, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_publicvoting2.default, this.state);
			}
		}]);
	
		return TCEAY;
	}(_react.Component);
	
	TCEAY.propTypes = {};
	exports.default = TCEAY;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _raven = __webpack_require__(701);
	
	var _raven2 = _interopRequireDefault(_raven);
	
	var _createBrowserHistory = __webpack_require__(288);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _useStandardScroll = __webpack_require__(1376);
	
	var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);
	
	__webpack_require__(704);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _redux = __webpack_require__(25);
	
	var _reactRedux = __webpack_require__(166);
	
	var _index = __webpack_require__(689);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reduxThunk = __webpack_require__(1371);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactStripeElements = __webpack_require__(144);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _routes = __webpack_require__(4);
	
	var _normalize = __webpack_require__(1052);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	var _main = __webpack_require__(1051);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _gaTrack = __webpack_require__(241);
	
	var _gaTrack2 = _interopRequireDefault(_gaTrack);
	
	var _step = __webpack_require__(234);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var browserHistory = (0, _useStandardScroll2.default)(_createBrowserHistory2.default);
	
	//import { devTools } from 'redux-devtools';
	//import { DevTools, DebugPanel, LogMonitor } from 'redux-devtools/lib/react';
	
	// ROUTE
	
	
	//connect(state => ({ routerState: state.router }));
	
	var history = browserHistory();
	
	var storeCompose = [(0, _redux.applyMiddleware)(_reduxThunk2.default), (0, _reduxRouter.reduxReactRouter)({
		createHistory: function createHistory() {
			return history;
		}
	}),  false ? window.devToolsExtension() : function (f) {
		return f;
	}];
	
	// Add DEBUG panel if run with 'ENV DEBUG=true'
	//__DEBUG__ && storeCompose.push(devTools());
	var store = _redux.compose.apply(undefined, storeCompose)(_redux.createStore)(_index2.default);
	
	try {
		_reactDom2.default.render(_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(
				_reactStripeElements.StripeProvider,
				{ apiKey: window.konfig.stripeKey },
				_react2.default.createElement(
					_reduxRouter.ReduxRouter,
					null,
					_routes.routes
				)
			)
		), document.getElementById('root'));
	} catch (e) {
		(0, _raven2.default)(e, {
			screenDimensions: screen.width + 'x' + screen.height,
			windowDimensions: window.innerWidth + 'x' + window.innerHeight
		});
	}
	
	history && history.listen(function (e) {
		// console.log('HISTORY!');
		(0, _gaTrack2.default)();
	
		if (!('remove' in Element.prototype)) {
			// FIX Browser not supporting Element.remove(); -- Looking at you IE!
			Element.prototype.remove = function remove() {
				if (this.parentNode) {
					this.parentNode.removeChild(this);
				}
			};
		}
	
		if (document.querySelector('link[rel="prev"]')) {
			document.querySelector('link[rel="prev"]').remove();
		}
		if (document.querySelector('link[rel="next"]')) {
			document.querySelector('link[rel="next"]').remove();
		}
		if (document.querySelector('link[rel="canonical"]')) {
			document.querySelector('link[rel="canonical"]').remove();
		}
	
		if (document.querySelector('meta[name="description"].inserted')) {
			document.querySelector('meta[name="description"].inserted').remove();
		}
		var link = '<link rel="canonical" href="' + window.location.href + '">';
	
		if (e.pathname !== '/' && e.pathname.indexOf('/awards/') == -1) {
			document.querySelector('head').insertAdjacentHTML('beforeend', link);
		}
	});
	
	//select={state => state.menu}

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = accountReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		items: [],
		single: false,
		cases: [],
		editorials: [],
		jobs: []
	};
	
	// Collections
	function receiveCollection(state, payload) {
		var key = arguments.length <= 2 || arguments[2] === undefined ? 'items' : arguments[2];
	
		if (payload.length) {
			var newState = _extends({}, state);
			newState[key] = payload;
	
			return newState;
		}
	
		return state;
	}
	
	function clearCollection(state, payload) {
		return _extends({}, defaultState);
	}
	
	// Singles
	function receiveSingle(state, payload) {
		return _extends({}, state, { single: payload });
	}
	
	function clearSingle(state, payload) {
		return _extends({}, state, { single: false });
	}
	
	function accountReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.ACCOUNT_RECV_COLLECTION:
				return receiveCollection(state, action.payload, action.key);
				break;
			case actionTypes.ACCOUNT_CLEAR_COLLECTION:
				return clearCollection(state, action.payload);
				break;
			case actionTypes.ACCOUNT_RECV_SINGLE:
				return receiveSingle(state, action.payload);
				break;
			case actionTypes.ACCOUNT_CLEAR_SINGLE:
				return clearSingle(state, action.payload);
				break;
			default:
				return state;
		}
	}

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = adsReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		items: formatAdImages(konfig.advertising) || []
	}; // REDUCER
	
	
	function formatAdImages(items) {
		var _items = [];
		for (var i = 0; i < items.length; i++) {
			if (items[i].mobile1 && items[i].mobile1.normal && items[i].mobile1.normal.src && items[i].mobile2 && items[i].mobile2.normal && items[i].mobile2.normal.src && items[i].tablet1 && items[i].tablet1.normal && items[i].tablet1.normal.src && items[i].tablet2 && items[i].tablet2.normal && items[i].tablet2.normal.src && items[i].desktop1 && items[i].desktop1.normal && items[i].desktop1.normal.src && items[i].desktop2 && items[i].desktop2.normal && items[i].desktop2.normal.src) {
				var item = {
					url: items[i].link,
					image: {
						314: { span4: items[i].mobile1.normal.src },
						538: { span4: items[i].mobile2.normal.src },
						706: { span4: items[i].tablet1.normal.src },
						958: { span4: items[i].tablet2.normal.src },
						1126: { span4: items[i].desktop1.normal.src },
						1364: { span4: items[i].desktop2.normal.src }
					}
				};
	
				_items.push(item);
			}
		}
	
		return _items;
	}
	
	function adsReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			default:
				return state;
		}
	}

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = caseReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _lodash = __webpack_require__(35);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		cases: [],
		winners: (0, _lodash.filter)(konfig.caseMenu, ['type', 'awards']) || [],
		single: {},
		isFetching: false
	};
	
	function casesReceived(state, payload) {
		//@TODO: set winners for real on it's own
		state = winnersReceived(state, payload);
		state = setBusy(state, false);
	
		if (payload.hasOwnProperty('cases')) {
			return _extends({}, state, { cases: payload.cases, next: payload.next, prev: payload.prev });
		}
	
		return state;
	}
	
	function contextualCasesReceived(state, payload) {
		state = setBusy(state, false);
	
		if (payload.cases && payload.cases.length) {
			return _extends({}, state, { contCases: payload.cases, next: payload.next, prev: payload.prev, error: null, totalCases: payload.totalCases, total: payload.total });
		}
	
		if (payload.error) {
			return _extends({}, state, { error: payload.error, contCases: null });
		}
	
		return _extends({}, state);
	}
	
	function winnersReceived(state, payload) {
		if (payload.hasOwnProperty('cases')) {
			return _extends({}, state, { winners: payload.cases });
		}
	
		return state;
	}
	
	function singleCaseReceived(state, payload) {
		state = setBusy(state, false);
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('id') && payload.hasOwnProperty('typeId')) {
			if (!payload.hasOwnProperty('contents')) {
				payload.contents = [];
			}
	
			if (!payload.hasOwnProperty('sections')) {
				payload.sections = [];
			}
	
			return _extends({}, state, { single: payload });
		}
	
		return state;
	}
	
	function setBusy(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		return _extends({}, state, { isFetching: payload });
	}
	
	function reqSingleCase(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		state = setBusy(state, true);
	
		return _extends({}, state, { single: {} });
	}
	
	function caseReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.CASES_RECV_DATA:
				return casesReceived(state, action.payload);
				break;
			case actionTypes.CASES_RECV_DATA_CONT:
				return contextualCasesReceived(state, action.payload);
			case actionTypes.CASES_REQ_DATA:
				return setBusy(state, true);
			case actionTypes.CASES_RECV_ERROR:
				return setBusy(state, false);
			case actionTypes.CASES_RECV_SINGLE_DATA:
				return singleCaseReceived(state, action.payload);
			case actionTypes.CASES_REQ_SINGLE_DATA:
				return reqSingleCase(state);
			case actionTypes.CASES_CLEAR_DATA:
				return _extends({}, state, { single: {}, update: 0 });
			default:
				return state;
		}
	}

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = categoriesReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {};
	
	function categoriesReceived(state, payload) {
		return _extends({}, state, payload);
	}
	
	function categoriesReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.CATEGORIES_RECV_DATA:
				return categoriesReceived(state, action.payload);
				break;
			default:
				return state;
		}
	}

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = cookieReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var COOKIE_NAME = 'cookies_accepted';
	var cookiesAccepted = document.cookie.length > 0 && document.cookie.indexOf(COOKIE_NAME + '=') !== -1;
	
	var defaultState = {
		cookiesAccepted: cookiesAccepted,
		showNotice: !cookiesAccepted
	};
	
	function acceptCookies(state) {
		return _extends({}, state, { showNotice: false });
	}
	
	function cookieReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.COOKIES_ACCEPT:
				return acceptCookies(state);
				break;
			default:
				return state;
		}
	}

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; // REDUCER
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		editorials: [],
		single: {},
		edit: {},
		isFetching: false
	};
	
	function editorialsReceived(state, payload) {
		state = setBusy(state, false);
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('editorials')) {
			return _extends({}, state, { editorials: payload.editorials });
		}
	
		return state;
	}
	
	function editorialsTypeReceived(state, payload) {
		state = setBusy(state, false);
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('editorials')) {
			return _extends({}, state, { error: false, editorialsByType: payload.editorials, firstEditorial: payload.firstEditorial, nextType: payload.next, prevType: payload.prev, total: payload.total, totalEditorials: payload.totalEditorials });
		}
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('error')) {
			return _extends({}, state, { error: payload.error, nextType: null, prevType: null, total: 0 });
		}
	
		return state;
	}
	
	function singleEditorialReceived(state, payload) {
		state = setBusy(state, false);
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('id') && payload.hasOwnProperty('typeId')) {
			if (!payload.hasOwnProperty('contents')) {
				payload.contents = [];
			}
	
			if (!payload.hasOwnProperty('sections')) {
				payload.sections = [];
			}
	
			return _extends({}, state, { single: payload });
		}
	
		return state;
	}
	
	function editEditorialReceived(state, payload) {
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object') {
			return _extends({}, state, {
				edit: payload
			});
		}
	
		return state;
	}
	
	function setBusy(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		return _extends({}, state, { isFetching: payload });
	}
	
	function reqSingleEditorial(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		state = setBusy(state, true);
	
		return _extends({}, state, { single: {} });
	}
	
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.EDITORIALS_RECV_DATA:
				return editorialsReceived(state, action.payload);
			case actionTypes.EDITORIALS_RECV_TYPE_DATA:
				return editorialsTypeReceived(state, action.payload);
			case actionTypes.EDITORIALS_RECV_SINGLE_DATA:
				return singleEditorialReceived(state, action.payload);
			case actionTypes.EDITORIALS_REQ_DATA:
				return setBusy(state, true);
			case actionTypes.EDITORIALS_REQ_SINGLE_DATA:
				return reqSingleEditorial(state);
			case actionTypes.EDITORIALS_RECV_ERROR:
				return setBusy(state, false);
			// Editorial creation
			case actionTypes.ACCOUNT_EDITORIAL_RECV_DATA:
				return editEditorialReceived(state, action.payload);
			case actionTypes.EDITORIALS_CLEAR_SINGLE:
				return _extends({}, state, { single: {} });
			default:
				return state;
		}
	}

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = errorsReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		message: '',
		error: false,
		show: false
	};
	
	function errorReceived(state, payload) {
		if (payload) {
			var message = '';
			if (payload.hasOwnProperty('message')) {
				message = payload.message;
			} else if (typeof payload === 'string') {
				message = payload;
			}
			return _extends({}, state, { message: message, error: true, show: true });
		}
	
		return _extends({}, state, { message: '', error: false, show: false });
	}
	
	function msgReceived(state, payload) {
		if (payload.hasOwnProperty('message')) {
			return _extends({}, state, { message: payload.message, error: false, show: true });
		}
	
		return _extends({}, state, { message: '', error: false, show: false });
	}
	
	function clearErrors() {
		return _extends({}, defaultState);
	}
	
	function errorsReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.RECV_ERROR:
				return errorReceived(state, action.payload);
			case actionTypes.RECV_MSG:
				return msgReceived(state, action.payload);
			case actionTypes.CLEAR_ERROR:
				return clearErrors();
			default:
				return state;
		}
	}

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _redux = __webpack_require__(25);
	
	var _reduxRouter = __webpack_require__(74);
	
	var _errors = __webpack_require__(688);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _browser = __webpack_require__(378);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _menu = __webpack_require__(692);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _jobs = __webpack_require__(690);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _news = __webpack_require__(693);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _cases = __webpack_require__(684);
	
	var _cases2 = _interopRequireDefault(_cases);
	
	var _profiles = __webpack_require__(695);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _editorials = __webpack_require__(687);
	
	var _editorials2 = _interopRequireDefault(_editorials);
	
	var _users = __webpack_require__(697);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _timelines = __webpack_require__(696);
	
	var _timelines2 = _interopRequireDefault(_timelines);
	
	var _categories = __webpack_require__(685);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _account = __webpack_require__(682);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _page = __webpack_require__(694);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _jury = __webpack_require__(691);
	
	var _jury2 = _interopRequireDefault(_jury);
	
	var _adverts = __webpack_require__(683);
	
	var _adverts2 = _interopRequireDefault(_adverts);
	
	var _cookie = __webpack_require__(686);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import reducers
	// --------------------------------------------------------------------------------------------------------------------
	// The root-reducer
	// --------------------------------------------------------------------------------------------------------------------
	
	
	var rootReducer = (0, _redux.combineReducers)({
		errors: _errors2.default,
		browser: _browser2.default,
		router: _reduxRouter.routerStateReducer,
		menu: _menu2.default,
		jobs: _jobs2.default,
		news: _news2.default,
		cases: _cases2.default,
		profiles: _profiles2.default,
		editorials: _editorials2.default,
		users: _users2.default,
		timelines: _timelines2.default,
		categories: _categories2.default,
		account: _account2.default,
		page: _page2.default,
		jury: _jury2.default,
		ads: _adverts2.default,
		cookie: _cookie2.default
	});
	
	exports.default = rootReducer;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		items: [],
		single: {}
	};
	
	function jobsReceived(state, payload) {
		if (payload.hasOwnProperty('items')) {
			return _extends({}, state, { mainMenu: payload });
		}
	
		return state;
	}
	
	function allJobsReceived(state, payload) {
		return _extends({}, state, { items: payload.jobs, meta: payload.meta });
	
		return state;
	}
	
	function jobReceived(state, payload) {
		return _extends({}, state, { single: payload });
	
		return state;
	}
	
	function jobsRequested(state) {
		//We clear the data to always have it freshhh
		return _extends({}, state, { items: [] });
	}
	
	function jobsRequestedSingle(state) {
		//We clear the data to always have it freshhh
		return _extends({}, state, { single: {} });
	}
	
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.JOBS_FETCH:
				return jobsReceived(state, action.payload);
			case actionTypes.JOBS_RECV_DATA:
				return allJobsReceived(state, action.payload);
			case actionTypes.JOBS_RECV_DATA_SINGLE:
				return jobReceived(state, action.payload);
			case actionTypes.JOBS_REQ_DATA:
				return jobsRequested(state);
			case actionTypes.JOBS_REQ_DATA_SINGLE:
				return jobsRequestedSingle(state);
				break;
			default:
				return state;
		}
	}

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; // REDUCER
	
	
	exports.default = juryReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		jury: [],
		isFetching: false
	};
	
	function juryReceived(state, payload) {
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('jury')) {
			return _extends({}, state, { jury: payload.jury, prev: payload.prev, next: payload.next, total: payload.total, totalJury: payload.totalJury });
		}
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('error')) {
	
			var error = payload;
	
			return _extends({}, state, { error: error, jury: [] });
		}
	
		return state;
	}
	
	function juryReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.JURY_RECV_DATA:
				return juryReceived(state, action.payload);
			default:
				return state;
		}
	}

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		menuActive: false,
		selectedMenu: null,
		mainMenu: konfig.navigation || {},
		subMenu: {},
		footer: konfig.footer || {},
		searchActive: false,
		socialLinks: konfig.socialLinks || {}
	};
	
	function toggleMenu(state) {
		return _extends({}, state, {
			menuActive: !state.menuActive,
			searchActive: false,
	
			selectedMenu: null,
			subMenu: {}
		});
	}
	
	function toggleSearchMenu(state) {
		return _extends({}, state, {
			searchActive: !state.searchActive,
			menuActive: false
		});
	}
	
	function menuReceivedData(state, payload) {
		if (payload.mainMenu.hasOwnProperty('items')) {
			return _extends({}, state, { mainMenu: payload.mainMenu, socialLinks: payload.socialLinks });
		}
	
		return state;
	}
	
	function activateSubmenu(state, payload) {
		var menu = {
			items: []
		};
	
		if (payload.hasOwnProperty('items') && payload.items.length) {
			//if the same menu was clicked treat it as a toggle
			if (!(0, _deepEqual2.default)(state.subMenu.items, payload.items)) {
				menu.items = payload.items;
			}
		} else {
			// if the activated menu-item has no sub-items we just navigated there, so we can close the menu.
			state = toggleMenu(state);
		}
	
		return _extends({}, state, {
			subMenu: menu,
			selectedMenu: menu.items.length ? payload : null
		});
	}
	
	function closeMenu(state) {
		return _extends({}, state, {
			menuActive: false,
			searchActive: false,
	
			selectedMenu: null,
			subMenu: {}
		});
	}
	
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.MENU_TOGGLE:
				return toggleMenu(state);
				break;
			case actionTypes.MENU_CLOSE:
				return closeMenu(state);
				break;
			case actionTypes.MENU_TOGGLE_SEARCH:
				return toggleSearchMenu(state);
				break;
			case actionTypes.MENU_RECV_DATA:
				return menuReceivedData(state, action.payload);
			case actionTypes.MENU_UPDATE_SUB:
				return activateSubmenu(state, action.payload);
			default:
				return state;
		}
	}

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // REDUCER
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		news: [],
		single: {}
	};
	
	function newsReceived(state, payload) {
		console.log('newsReceived');
		return _extends({}, state, { news: payload.editorials });
	}
	
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.NEWS_RECV_DATA:
				return newsReceived(state, action.payload);
				break;
			default:
				return state;
		}
	}

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; // REDUCER
	
	
	exports.default = pageReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		single: {},
		isFetching: false
	};
	
	function pageReceived(state, payload) {
		state = setBusy(state, false);
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('id')) {
			if (!payload.hasOwnProperty('content')) {
				payload.content = [];
			}
	
			return _extends({}, state, { single: payload });
		}
	
		return state;
	}
	
	function setBusy(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		return _extends({}, state, { isFetching: payload });
	}
	
	function reqPage(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		state = setBusy(state, true);
	
		return _extends({}, state);
	}
	
	function pageReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.PAGES_RECV_SINGLE_DATA:
				return pageReceived(state, action.payload);
			case actionTypes.PAGES_REQ_SINGLE_DATA:
				return reqPage(state);
			case actionTypes.PAGES_RECV_ERROR:
				return setBusy(state, false);
			default:
				return state;
		}
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; // REDUCER
	
	
	exports.default = menuReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var defaultState = {
		profiles: [],
		single: {},
		isFetching: false
	};
	
	function profilesReceived(state, payload) {
		state = setBusy(state, false);
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('profiles')) {
			return _extends({}, state, { profiles: payload.profiles, prev: payload.prev, next: payload.next, total: payload.total, totalProfiles: payload.totalProfiles, meta: payload.meta });
		}
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('error')) {
	
			var error = payload;
	
			return _extends({}, state, { profiles: error });
		}
	
		return state;
	}
	
	function singleProfileReceived(state, payload) {
		state = setBusy(state, false);
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.hasOwnProperty('id')) {
			return _extends({}, state, { single: payload });
		}
	
		return state;
	}
	
	function singleProfileCasesReceived(state, payload) {
		state = setBusy(state, false);
	
		if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object') {
			return _extends({}, state, { cases: payload });
		}
	
		return state;
	}
	
	function setBusy(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		return _extends({}, state, { isFetching: payload });
	}
	
	function reqSingleProfile(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		state = setBusy(state, true);
	
		return _extends({}, state);
	}
	
	function reqProfiles(state) {
		var payload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		state = setBusy(state, true);
	
		return _extends({}, state);
	}
	
	function menuReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.PROFILES_RECV_SINGLE_DATA:
				return singleProfileReceived(state, action.payload);
			case actionTypes.PROFILES_RECV_CASE_DATA:
				return singleProfileCasesReceived(state, action.payload);
			case actionTypes.PROFILES_REQ_SINGLE_DATA:
				return reqSingleProfile(state);
			case actionTypes.PROFILES_RECV_DATA:
				return profilesReceived(state, action.payload);
			case actionTypes.PROFILES_REQ_DATA:
				return reqProfiles(state);
			case actionTypes.PROFILES_CLEAR_DATA:
				return _extends({}, state, { single: [], update: 0 });
			default:
				return state;
		}
	}

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	// REDUCER
	
	
	exports.default = timelineReducer;
	
	var _lodash = __webpack_require__(35);
	
	var _actions = __webpack_require__(13);
	
	var defaultState = {
		update: 0,
		filters: false,
		items: getPageSplitter(),
		next: null,
		prev: null,
		isFetching: false,
		skip: 0,
		startPage: 0
	};
	
	function getPageSplitter() {
		return [{
			type: 'page-indicator',
			uid: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
		}];
	}
	
	function timelineReceived(state, payload, append) {
		var init = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		// console.log(payload);
		// let perfNow = performance.now() / 1000;
		// console.log((performance.now() / 1000) - perfNow + ' - reducer: ');
	
		if (payload && payload.hasOwnProperty('items')) {
			var currentItems = state.items;
			var payloadItems = payload.items;
			var nextItems = void 0;
			var pagination = {
				prev: state.prev,
				next: state.next
			};
			var startPage = 0;
	
			// console.log((performance.now() / 1000) - perfNow + ' - reducer: before ne');
			payloadItems = append ? payloadItems.concat(getPageSplitter()) : getPageSplitter().concat(payloadItems);
	
			if (init) {
				pagination.next = payload.next;
				pagination.prev = payload.prev;
				nextItems = getPageSplitter().concat(payloadItems);
			} else {
				// console.log(`${append ? 'next' : 'prev'}: ${append ? payload.next : payload.prev}`);
				nextItems = append ? currentItems.concat(payloadItems) : payloadItems.concat(currentItems);
				pagination[append ? 'next' : 'prev'] = append ? payload.next : payload.prev;
			}
			// console.log((performance.now() / 1000) - perfNow + ' - reducer: nextItems created');
	
			if (pagination.prev) {
				var offsetStr = pagination.prev;
				startPage = parseInt(offsetStr.substr(offsetStr.indexOf('offset=') + 7, offsetStr.length), 10) / 20;
			}
	
			nextItems = (0, _lodash.uniq)(nextItems, function (n) {
				return n.uid;
			});
	
			nextItems = (0, _lodash.difference)(nextItems, [false, undefined, null]);
			// console.log((performance.now() / 1000) - perfNow + ' - reducer: validation');
	
			var skipCount = 0;
			for (var i = 0; i < nextItems.length; i++) {
				if (_typeof(nextItems[i]) === 'object' && nextItems[i].hasOwnProperty('hero') && nextItems[i].hero) {
					break;
				}
	
				skipCount++;
			}
			// console.log((performance.now() / 1000) - perfNow + ' - reducer: skip counted');
	
			var returnValue = _extends({}, state, pagination, {
				update: state.update + 1,
				isFetching: false,
				items: nextItems,
				skip: skipCount,
				startPage: startPage
			});
			// console.log((performance.now() / 1000) - perfNow + ' - reducer: return value created');
	
			return returnValue;
		}
	
		return state;
	}
	
	function initData(state, payload, append) {
		var stateHolder = state;
	
		if (payload.hasOwnProperty('filter') && Object.keys(payload.filter).length) {
			stateHolder = _extends({}, state, {
				filters: payload.filter
			});
		}
	
		return timelineReceived(stateHolder, payload.data, append, true);
	}
	
	function timelineSetFilter(state, payload) {
		//console.log(payload);
		return _extends({}, state, {
			filters: payload
		});
	}
	
	function timelineReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		//console.log('%c------------', action.type === TIMELINE_RECV_INIT_DATA ? 'color: red;' : '');
		//console.log(action.type);
		//console.log('%c------------', action.type === TIMELINE_RECV_INIT_DATA ? 'color: red;' : '');
	
		switch (action.type) {
			case _actions.TIMELINE_RECV_INIT_DATA:
				return initData(state, action.payload, true);
			case _actions.TIMELINE_RECV_NEXT_DATA:
				return timelineReceived(state, action.payload, true);
			case _actions.TIMELINE_RECV_PREV_DATA:
				return timelineReceived(state, action.payload, false);
			case _actions.TIMELINE_REQ_DATA:
				return _extends({}, state, { isFetching: true });
			case _actions.TIMELINE_RECV_ERROR:
				return _extends({}, state, { isFetching: false, update: state.update + 1 });
			case _actions.TIMELINE_CLEAR_DATA:
				return _extends({}, state, { items: [], next: null, prev: null, update: 0 });
			case _actions.TIMELINE_FILTER:
				return timelineSetFilter(state, action.payload);
			default:
				return state;
		}
	}

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = userReducer;
	
	var _actions = __webpack_require__(13);
	
	var actionTypes = _interopRequireWildcard(_actions);
	
	var _authorization = __webpack_require__(36);
	
	var _authorization2 = _interopRequireDefault(_authorization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// REDUCER
	
	
	var defaultState = new _authorization2.default(konfig.user || {});
	
	function userReceived(state, payload) {
		if (payload.hasOwnProperty('user') || payload.hasOwnProperty('message')) {
			return new _authorization2.default(payload.user);
		}
	
		return state;
	}
	
	function logout() {
		return new _authorization2.default({});
	};
	
	function userReducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case actionTypes.USERS_LOGIN:
			case actionTypes.USERS_LOGIN_INIT:
			case actionTypes.USERS_ERROR:
			case actionTypes.USERS_LOGIN_FB:
			case actionTypes.USERS_LOGIN_TWITTER:
			case actionTypes.USERS_LOGIN_GOOGLE:
				return userReceived(state, action.payload);
			case actionTypes.USERS_LOGOUT:
				return logout();
			default:
				return state;
		}
	}

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createBrowserHistory = __webpack_require__(288);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createBrowserHistory2.default)();

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(39);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _forEach = __webpack_require__(22);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _infiniteScrollTrigger = __webpack_require__(700);
	
	var _infiniteScrollTrigger2 = _interopRequireDefault(_infiniteScrollTrigger);
	
	var _history = __webpack_require__(698);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _actions = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteScroll = function (_Component) {
		_inherits(InfiniteScroll, _Component);
	
		function InfiniteScroll(props) {
			_classCallCheck(this, InfiniteScroll);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InfiniteScroll).call(this));
	
			_this.direction = _actions.TIMELINE_FETCH_NEXT;
			_this.contentLength = 0;
			_this.scrollY = 0;
	
			_this.contentHeight = 0;
			_this.contentTop = 0;
			_this.contentHeight = 0;
	
			// console.log('initPage: ' + props.pageInit);
	
			_this.pageBounds = {
				lower: props.initPage || 1,
				upper: props.initPage || 1
			};
	
			_this.state = {
				page: props.page,
				contentIteration: 0
			};
			return _this;
		}
	
		_createClass(InfiniteScroll, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// this.scrollHandler = (event) => {
				// 	//this.props.contentTop + this.props.contentHeight
				// 	if (!this.props.contentHeight || event.deltaY === 0) {
				// 		return;
				// 	}
				//
				// 	let percentageScrolled = (1 / this.props.contentHeight) * (event.scrollY - this.props.contentTop);
				// 	let boundedPages = 1 + (this.pageBounds.upper - this.pageBounds.lower);
				// 	let pageNum = ((this.pageBounds.lower - 1) + this.props.page) || 0;
				// 	//console.log(this.pageBounds);
				//
				//
				// 	if (this.props.page && pageNum && pageNum !== this.prevPageNum && this.props.hasPushState) {
				// 		//console.log(`${this.props.pageUrl}page/${pageNum}/`);
				// 		window.history.state && History.replaceState(window.history.state, `${this.props.pageUrl}page/${pageNum}/`);
				// 	} else if(!this.props.page || !pageNum && pageNum !== this.prevPageNum) {
				// 		window.history.state && History.replaceState(window.history.state, this.props.pageUrl);
				// 	}
				//
				// 	this.prevPageNum = pageNum;
				//
				// };
				//
				// this.props.browser.scroll.register(this.scrollHandler);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				// this.props.browser.scroll.deregister(this.scrollHandler);
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				//this.updateDimensions(nextProps);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nProps) {
				if (this.props.initPage !== nProps.initPage) {
					this.pageBounds = {
						lower: nProps.initPage || 1,
						upper: nProps.initPage || 1
					};
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var currentContentHeight = this.props.contentHeight;
				//console.log(`${this.direction} === TIMELINE_FETCH_PREV && ${this.contentHeight} < ${currentContentHeight}`);
				if (this.direction === _actions.TIMELINE_FETCH_PREV && this.contentHeight < currentContentHeight) {
					var scrollY = window.scrollY;
	
					scrollY = scrollY + (currentContentHeight - this.contentHeight);
	
					window.scrollTo(0, scrollY);
				}
	
				this.contentHeight = currentContentHeight;
	
				if (prevProps.browser.window.width !== this.props.browser.window.width) {
					if (document.querySelectorAll('.timeline__element').length) {
						(0, _forEach2.default)(document.querySelectorAll('.timeline__element'), function (el, i) {
							el.classList.add('active');
						});
					}
				}
	
				//this.scrollHandler({ deltaY: 1, scrollY: window.scrollY });
	
				// if (this.props.hasPushState) {
				// 	this.updatePushState();
				// } else {
				// 	if (prevProps.hasPushState !== this.props.hasPushState && this.props.pageUrl) {
				// 		// reset url
				// 		this.replaceState(this.props.pageUrl);
				// 	}
				// }
			}
		}, {
			key: 'render',
			value: function render() {
				//console.log(`prev: ${(!!this.props.prev).toString()} - next: ${(!!this.props.next).toString()}`);
				//console.log('InfiniteScroll - render');
				//console.log(History);
	
				//this.props.browser.scroll.registerScrollEvents();
	
				return _react2.default.createElement(
					'div',
					{ className: 'infintescroll' },
					this.props.prev && _react2.default.createElement(_infiniteScrollTrigger2.default, {
						key: 'prev',
						browser: this.props.browser,
						contentUpdate: this.props.update,
						contentTrigger: this.props.contentTop,
						direction: _actions.TIMELINE_FETCH_PREV,
						callback: this.fetchPrev.bind(this)
					}),
					this.props.children,
					this.props.next && _react2.default.createElement(_infiniteScrollTrigger2.default, {
						key: 'next',
						browser: this.props.browser,
						contentUpdate: this.props.update,
						contentTrigger: this.props.contentTop + this.props.contentHeight,
						direction: _actions.TIMELINE_FETCH_NEXT,
						callback: this.fetchNext.bind(this),
						manualTrigger: this.pageBounds.lower === 1 && this.pageBounds.upper === 1 && !this.props.disableManualTrigger,
						triggerElement: this.props.triggerElement || false
					})
				);
			}
	
			// updatePushState() {
			// 	//console.log('updatePushState()');
			// 	let pageNum = ((this.pageBounds.lower - 1) + this.props.page) || 0;
			//
			// 	//console.log(this.pageBounds);
			//
			// 	if (pageNum && pageNum !== this.prevPageNum) {
			// 		//console.log(`${this.props.pageUrl}page/${pageNum}/`);
			// 		//console.log(`${this.pageBounds.lower} <> ${this.pageBounds.upper} ==> ${(this.pageBounds.lower - 1) + this.props.page} (${this.props.page})`);
			//
			// 		this.prevPageNum = pageNum;
			//
			// 		if (window.location.pathname) {
			//
			// 		}
			// 		this.replaceState(`${this.props.pageUrl}page/${pageNum}/`);
			// 	} else if (!this.props.page || !pageNum && pageNum !== this.prevPageNum) {
			// 		this.prevPageNum = pageNum;
			// 		this.replaceState(this.props.pageUrl);
			// 	}
			// }
			//
			// replaceState(path) {
			// 	if (
			// 		!!(window.history && window.history.replaceState) &&
			// 		path !== window.location.pathname
			// 	) {
			// 		window.history.replaceState(window.history.state || {}, window.document.title, path);
			// 	}
			// }
	
		}, {
			key: 'fetchPrev',
			value: function fetchPrev() {
				//console.log(`isFetching: ${this.props.isFetching}`);
				if (!this.props.isFetching) {
					this.props.fetch(this.props.prev, _actions.TIMELINE_FETCH_PREV);
					this.direction = _actions.TIMELINE_FETCH_PREV;
					if (this.pageBounds.lower > 1) {
						this.pageBounds.lower--;
					}
				}
			}
		}, {
			key: 'fetchNext',
			value: function fetchNext() {
				//console.log(`isFetching: ${this.props.isFetching}`);
				if (!this.props.isFetching) {
					this.props.fetch(this.props.next, _actions.TIMELINE_FETCH_NEXT);
					this.direction = _actions.TIMELINE_FETCH_NEXT;
					this.pageBounds.upper++;
				}
			}
		}, {
			key: 'nextPage',
			value: function nextPage() {
				this.setState({
					page: this.state.page++
				});
			}
		}, {
			key: 'prevPage',
			value: function prevPage() {
				this.setState({
					page: this.state.page--
				});
			}
		}]);
	
		return InfiniteScroll;
	}(_react.Component);
	
	InfiniteScroll.propTypes = {
		prev: _react.PropTypes.string,
		next: _react.PropTypes.string,
		fetch: _react.PropTypes.func,
		browser: _react.PropTypes.object.isRequired,
		pageUrl: _react.PropTypes.string,
		initPage: _react.PropTypes.number,
		page: _react.PropTypes.number,
		contentHeight: _react.PropTypes.number.isRequired,
		isFetching: _react.PropTypes.bool,
		disableManualTrigger: _react.PropTypes.bool
	};
	InfiniteScroll.defaultProps = {
		prev: '',
		next: '',
		browser: {},
		hasPushState: false,
		pageUrl: '',
		page: 1,
		initPage: 1,
		isFetching: false,
		disableManualTrigger: false,
		fetch: function fetch(url, direction) {}
	};
	exports.default = InfiniteScroll;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actions = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfiniteScrollTrigger = function (_Component) {
		_inherits(InfiniteScrollTrigger, _Component);
	
		function InfiniteScrollTrigger(props) {
			_classCallCheck(this, InfiniteScrollTrigger);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InfiniteScrollTrigger).call(this));
	
			_this.DEBUG = false;
			_this.scrollPos = 0;
			return _this;
		}
	
		_createClass(InfiniteScrollTrigger, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var triggerElem = this.refs.trigger || this.triggerElem;
	
				this.deregisterScroll = this.handleScroll.bind(this);
	
				var scroll = this.props.browser.scroll;
				scroll && scroll.register(this.deregisterScroll);
	
				//this.saveInternalBounds(this.props);
	
				if (this.props.direction === _actions.TIMELINE_FETCH_PREV && triggerElem) {
					var scrollY = window.scrollY;
					window.scrollTo(0, scrollY + triggerElem.offsetHeight);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var scroll = this.props.browser.scroll;
				scroll && scroll.deregister(this.deregisterScroll);
	
				//console.log('unmounting - ' + this.props.direction);
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {}
	
			//shouldComponentUpdate(nextProps, nextState) {
			//	return (
			//		(this.props.contentUpdate !== nextProps.contentUpdate) ||
			//		(this.props.browser.window.width !== nextProps.browser.window.width)
			//	);
			//}
	
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				//this.saveInternalBounds(nextProps);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				//console.log(this.state.scrollPos);
			}
		}, {
			key: 'render',
			value: function render() {
				var triggerOffset = this.props.contentTrigger + (this.props.direction === _actions.TIMELINE_FETCH_NEXT ? -Math.round(this.props.browser.window.height * 2) : Math.round(this.props.browser.window.height * 2));
	
				//console.log('%cTrigger: ' + triggerOffset, 'background: red; color: white;');
	
				var debugStyle = {
					display: 'block',
					width: '100%',
					position: 'absolute',
					top: triggerOffset + 'px',
					left: 0,
					borderTop: '1px solid ' + (this.props.direction === _actions.TIMELINE_FETCH_NEXT ? 'green' : 'red')
				};
	
				var className = 'infinitescroll-trigger';
				var contClass = 'infinitescroll-trigger-cont';
	
				switch (this.props.direction) {
					case _actions.TIMELINE_FETCH_PREV:
						className += ' infinitescroll-trigger--prev';
						contClass += ' infinitescroll-trigger-cont--prev';
						break;
					case _actions.TIMELINE_FETCH_NEXT:
					default:
						className += ' infinitescroll-trigger--next';
						contClass += ' infinitescroll-trigger-cont--next';
						break;
				}
	
				if (this.props.manualTrigger) {
					contClass = '';
				}
	
				var styleAutoTrigger = this.props.manualTrigger ? {} : { height: this.props.browser.window.height / 4 + 'px' };
	
				return _react2.default.createElement(
					'div',
					{ style: styleAutoTrigger, className: contClass },
					this.DEBUG && _react2.default.createElement('div', { style: debugStyle, className: this.props.direction }),
					_react2.default.createElement(
						'div',
						{ ref: 'trigger', className: className },
						this.props.manualTrigger && _react2.default.createElement(
							'div',
							{ onClick: this.props.callback, className: 'infinitescroll-trigger__clicker' },
							this.getTriggerElement.bind(this)()
						)
					)
				);
			}
		}, {
			key: 'getTriggerElement',
			value: function getTriggerElement() {
				if (this.props.triggerElement) {
					return this.props.triggerElement;
				} else {
					return false;
				}
			}
		}, {
			key: 'handleScroll',
			value: function handleScroll(event) {
				var buffer = Math.round(this.props.browser.window.height * 2);
				var scrollBottom = event.scrollY + this.props.browser.window.height;
	
				if (this.props.direction === _actions.TIMELINE_FETCH_NEXT) {
					// Check if top-trigger is above window bottom
					//console.log(`${event.scrollY} > ${this.props.contentTrigger - buffer}`);
					if (event.scrollY > this.props.contentTrigger - buffer) {
						this.fetchNewContent();
					}
				}
	
				if (this.props.direction === _actions.TIMELINE_FETCH_PREV) {
					// Check if bottom-trigger is below window top
					if (scrollBottom < this.props.contentTrigger + buffer) {
						this.fetchNewContent();
					}
				}
			}
	
			// saveInternalBounds(props) {
			// 	let triggerElem = this.refs.trigger ||  this.triggerElem;
			//
			// 	if (triggerElem) {
			// 		this.offsets = {
			// 			top: triggerElem.offsetTop,
			// 			bottom: triggerElem.offsetTop + triggerElem.offsetHeight,
			// 		};
			//
			// 		//if (this.props.direction === TIMELINE_FETCH_NEXT) {
			// 		//	console.log(this.offsets.top);
			// 		//}
			// 	}
			//
			// 	//console.log('save bounds : ' + props.contentUpdate);
			// 	//console.log(this.offsets);
			// }
	
		}, {
			key: 'fetchNewContent',
			value: function fetchNewContent() {
				if ((!this.lastFetch || this.lastFetch !== this.props.contentUpdate) && !this.props.manualTrigger) {
					//console.log('trigger infinite content');
					this.props.callback();
					this.lastFetch = this.props.contentUpdate;
				}
			}
		}]);
	
		return InfiniteScrollTrigger;
	}(_react.Component);
	
	InfiniteScrollTrigger.propTypes = {
		callback: _react.PropTypes.func.isRequired,
		browser: _react.PropTypes.object.isRequired,
		contentTrigger: _react.PropTypes.number.isRequired,
		direction: _react.PropTypes.string
	};
	InfiniteScrollTrigger.defaultProps = {
		direction: _actions.TIMELINE_FETCH_NEXT,
		callback: function callback() {}
	};
	exports.default = InfiniteScrollTrigger;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Raven = undefined;
	exports.default = logException;
	
	var _ravenJs = __webpack_require__(1216);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sentryDSN = false;
	// if (false __SENTRYLOG__ === 'production') {
	// 	// Set to production DSN
	// 	sentryDSN = 'http://0632e37d65214a839bba85a3ebda2013@sentry.konform.com/32';
	// } else if (false __SENTRYLOG__ === 'development') {
	// 	// Set to development DSN
	// 	sentryDSN = 'http://4a47a67c6c1142679b9d4c3859bb5734@sentry.konform.com/17';
	// }
	
	sentryDSN && _ravenJs2.default.config(sentryDSN, {
		//whitelistUrls: ['example.com/scripts/'],
		// Will cause a deprecation warning, but the demise of `ignoreErrors` is still under discussion.
		// See: https://github.com/getsentry/raven-js/issues/73
		ignoreErrors: [
		// Random plugins/extensions
		'top.GLOBALS',
		// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
		'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose',
		// Facebook borked
		'fb_xd_fragment',
		// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
		// See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
		'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
		// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
		'conduitPage',
		// Generic error code from errors outside the security sandbox
		// You can delete this if using raven.js > 1.0, which ignores these automatically.
		'Script error.'],
		ignoreUrls: [
		// Facebook flakiness
		/graph\.facebook\.com/i,
		// Facebook blocked
		/connect\.facebook\.net\/en_US\/all\.js/i,
		// Woopra flakiness
		/eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i,
		// Chrome extensions
		/extensions\//i, /^chrome:\/\//i,
		// Other plugins
		/127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
		/webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i]
	}).install();
	
	exports.Raven = _ravenJs2.default;
	function logException(ex, context) {
		_ravenJs2.default.isSetup() && _ravenJs2.default.captureException(ex, {
			extra: context
		});
		/*eslint no-console:0*/
		window.console && console.error && console.error(ex);
	}

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Utils = __webpack_require__(382);
	
	var defaults = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000,
	    strictNullHandling: false,
	    plainObjects: false,
	    allowPrototypes: false,
	    allowDots: false,
	    decoder: Utils.decode
	};
	
	var parseValues = function parseValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[options.decoder(part)] = '';
	
	            if (options.strictNullHandling) {
	                obj[options.decoder(part)] = null;
	            }
	        } else {
	            var key = options.decoder(part.slice(0, pos));
	            var val = options.decoder(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty.call(obj, key)) {
	                obj[key] = [].concat(obj[key]).concat(val);
	            } else {
	                obj[key] = val;
	            }
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObject(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^\.\[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1])) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            if (!options.allowPrototypes) {
	                continue;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj, options);
	    }
	
	    return Utils.compact(obj);
	};

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var Utils = __webpack_require__(382);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var defaults = {
	    delimiter: '&',
	    strictNullHandling: false,
	    skipNulls: false,
	    encode: true,
	    encoder: Utils.encode
	};
	
	var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || Utils.isBuffer(obj)) {
	        if (encoder) {
	            return [encoder(prefix) + '=' + encoder(obj)];
	        }
	        return [prefix + '=' + String(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
	        } else {
	            values = values.concat(stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = encode ? typeof options.encoder === 'function' ? options.encoder : defaults.encoder : null;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var objKeys;
	    var filter;
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        objKeys = filter = options.filter;
	    }
	
	    var keys = [];
	
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots));
	    }
	
	    return keys.join(delimiter);
	};

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(904);
	
	__webpack_require__(1375);
	
	__webpack_require__(705);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(712);
	module.exports = __webpack_require__(67).RegExp.escape;


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	var isArray = __webpack_require__(184);
	var SPECIES = __webpack_require__(23)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(19);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(10);
	var toPrimitive = __webpack_require__(82);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(113);
	var gOPS = __webpack_require__(188);
	var pIE = __webpack_require__(153);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(154)('native-function-to-string', Function.toString);


/***/ },
/* 711 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(711)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(384) });
	
	__webpack_require__(99)('copyWithin');


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(79)(4);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(243) });
	
	__webpack_require__(99)('fill');


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(79)(2);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(79)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(99)(KEY);


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(79)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(99)(KEY);


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(79)(0);
	var STRICT = __webpack_require__(69)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(68);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var call = __webpack_require__(395);
	var isArrayIter = __webpack_require__(251);
	var toLength = __webpack_require__(26);
	var createProperty = __webpack_require__(245);
	var getIterFn = __webpack_require__(267);
	
	$export($export.S + $export.F * !__webpack_require__(186)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(181)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(184) });


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(56);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(152) != Object || !__webpack_require__(69)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(56);
	var toInteger = __webpack_require__(70);
	var toLength = __webpack_require__(26);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(79)(1);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(245);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(19)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(386);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(386);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(249);
	var cof = __webpack_require__(66);
	var toAbsoluteIndex = __webpack_require__(117);
	var toLength = __webpack_require__(26);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(19)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(79)(3);
	
	$export($export.P + $export.F * !__webpack_require__(69)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(42);
	var toObject = __webpack_require__(37);
	var fails = __webpack_require__(19);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(69)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(116)('Array');


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(707);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(82);
	
	$export($export.P + $export.F * __webpack_require__(19)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(23)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(47)(proto, TO_PRIMITIVE, __webpack_require__(708));


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(48)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(387) });


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	var getPrototypeOf = __webpack_require__(55);
	var HAS_INSTANCE = __webpack_require__(23)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(34).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(34).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(27) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(398);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(255);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(254);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(397) });


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(19)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(398) });


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(255) });


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(254);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(19)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(254);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var has = __webpack_require__(53);
	var cof = __webpack_require__(66);
	var inheritIfRequired = __webpack_require__(250);
	var toPrimitive = __webpack_require__(82);
	var fails = __webpack_require__(19);
	var gOPN = __webpack_require__(112).f;
	var gOPD = __webpack_require__(54).f;
	var dP = __webpack_require__(34).f;
	var $trim = __webpack_require__(137).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(111)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(27) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(48)(global, NUMBER, $Number);
	}


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(15).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(394) });


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(394);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(406);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(407);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(70);
	var aNumberValue = __webpack_require__(383);
	var repeat = __webpack_require__(262);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(19)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(19);
	var aNumberValue = __webpack_require__(383);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(400) });


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(111) });


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperties: __webpack_require__(401) });


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(20);
	var meta = __webpack_require__(101).onFreeze;
	
	__webpack_require__(81)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(56);
	var $getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	__webpack_require__(81)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(81)('getOwnPropertyNames', function () {
	  return __webpack_require__(402).f;
	});


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(37);
	var $getPrototypeOf = __webpack_require__(55);
	
	__webpack_require__(81)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(20);
	
	__webpack_require__(81)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(20);
	
	__webpack_require__(81)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(20);
	
	__webpack_require__(81)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(410) });


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(37);
	var $keys = __webpack_require__(113);
	
	__webpack_require__(81)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(20);
	var meta = __webpack_require__(101).onFreeze;
	
	__webpack_require__(81)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(20);
	var meta = __webpack_require__(101).onFreeze;
	
	__webpack_require__(81)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(259).set });


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(134);
	var test = {};
	test[__webpack_require__(23)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(48)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(406);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(407);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(100);
	var global = __webpack_require__(15);
	var ctx = __webpack_require__(68);
	var classof = __webpack_require__(134);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(20);
	var aFunction = __webpack_require__(42);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(110);
	var speciesConstructor = __webpack_require__(155);
	var task = __webpack_require__(264).set;
	var microtask = __webpack_require__(256)();
	var newPromiseCapabilityModule = __webpack_require__(257);
	var perform = __webpack_require__(408);
	var userAgent = __webpack_require__(194);
	var promiseResolve = __webpack_require__(409);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(23)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(115)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(136)($Promise, PROMISE);
	__webpack_require__(116)(PROMISE);
	Wrapper = __webpack_require__(67)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(186)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(42);
	var anObject = __webpack_require__(10);
	var rApply = (__webpack_require__(15).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(19)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(111);
	var aFunction = __webpack_require__(42);
	var anObject = __webpack_require__(10);
	var isObject = __webpack_require__(20);
	var fails = __webpack_require__(19);
	var bind = __webpack_require__(387);
	var rConstruct = (__webpack_require__(15).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(34);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(10);
	var toPrimitive = __webpack_require__(82);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(19)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(54).f;
	var anObject = __webpack_require__(10);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(10);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(252)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(54);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(10);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(55);
	var anObject = __webpack_require__(10);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(54);
	var getPrototypeOf = __webpack_require__(55);
	var has = __webpack_require__(53);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(20);
	var anObject = __webpack_require__(10);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(10);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(405) });


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(10);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(259);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(34);
	var gOPD = __webpack_require__(54);
	var getPrototypeOf = __webpack_require__(55);
	var has = __webpack_require__(53);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(114);
	var anObject = __webpack_require__(10);
	var isObject = __webpack_require__(20);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var inheritIfRequired = __webpack_require__(250);
	var dP = __webpack_require__(34).f;
	var gOPN = __webpack_require__(112).f;
	var isRegExp = __webpack_require__(185);
	var $flags = __webpack_require__(151);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(27) && (!CORRECT_NEW || __webpack_require__(19)(function () {
	  re2[__webpack_require__(23)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(48)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(116)('RegExp');


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(10);
	var toLength = __webpack_require__(26);
	var advanceStringIndex = __webpack_require__(242);
	var regExpExec = __webpack_require__(189);
	
	// @@match logic
	__webpack_require__(183)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(10);
	var toObject = __webpack_require__(37);
	var toLength = __webpack_require__(26);
	var toInteger = __webpack_require__(70);
	var advanceStringIndex = __webpack_require__(242);
	var regExpExec = __webpack_require__(189);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(183)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(10);
	var sameValue = __webpack_require__(410);
	var regExpExec = __webpack_require__(189);
	
	// @@search logic
	__webpack_require__(183)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(185);
	var anObject = __webpack_require__(10);
	var speciesConstructor = __webpack_require__(155);
	var advanceStringIndex = __webpack_require__(242);
	var toLength = __webpack_require__(26);
	var callRegExpExec = __webpack_require__(189);
	var regexpExec = __webpack_require__(258);
	var fails = __webpack_require__(19);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(183)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(416);
	var anObject = __webpack_require__(10);
	var $flags = __webpack_require__(151);
	var DESCRIPTORS = __webpack_require__(27);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(48)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(19)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(49)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(49)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(49)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(49)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(192)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(26);
	var context = __webpack_require__(261);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(248)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(49)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(49)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(49)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(117);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(261);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(248)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(49)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(192)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(253)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(49)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(56);
	var toLength = __webpack_require__(26);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(262)
	});


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(49)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(26);
	var context = __webpack_require__(261);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(248)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(49)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(49)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(49)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(137)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(15);
	var has = __webpack_require__(53);
	var DESCRIPTORS = __webpack_require__(27);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(48);
	var META = __webpack_require__(101).KEY;
	var $fails = __webpack_require__(19);
	var shared = __webpack_require__(154);
	var setToStringTag = __webpack_require__(136);
	var uid = __webpack_require__(118);
	var wks = __webpack_require__(23);
	var wksExt = __webpack_require__(413);
	var wksDefine = __webpack_require__(266);
	var enumKeys = __webpack_require__(709);
	var isArray = __webpack_require__(184);
	var anObject = __webpack_require__(10);
	var isObject = __webpack_require__(20);
	var toObject = __webpack_require__(37);
	var toIObject = __webpack_require__(56);
	var toPrimitive = __webpack_require__(82);
	var createDesc = __webpack_require__(114);
	var _create = __webpack_require__(111);
	var gOPNExt = __webpack_require__(402);
	var $GOPD = __webpack_require__(54);
	var $GOPS = __webpack_require__(188);
	var $DP = __webpack_require__(34);
	var $keys = __webpack_require__(113);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(112).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(153).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(100)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(47)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(193);
	var buffer = __webpack_require__(265);
	var anObject = __webpack_require__(10);
	var toAbsoluteIndex = __webpack_require__(117);
	var toLength = __webpack_require__(26);
	var isObject = __webpack_require__(20);
	var ArrayBuffer = __webpack_require__(15).ArrayBuffer;
	var speciesConstructor = __webpack_require__(155);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(19)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(116)(ARRAY_BUFFER);


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(193).ABV, {
	  DataView: __webpack_require__(265).DataView
	});


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(90)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(390);
	var validate = __webpack_require__(119);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(182)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(391);
	var toObject = __webpack_require__(37);
	var toLength = __webpack_require__(26);
	var aFunction = __webpack_require__(42);
	var arraySpeciesCreate = __webpack_require__(244);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(99)('flatMap');


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(391);
	var toObject = __webpack_require__(37);
	var toLength = __webpack_require__(26);
	var toInteger = __webpack_require__(70);
	var arraySpeciesCreate = __webpack_require__(244);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(99)('flatten');


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(181)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(99)('includes');


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(256)();
	var process = __webpack_require__(15).process;
	var isNode = __webpack_require__(66)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(66);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(15) });


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(190)('Map');


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(191)('Map');


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(389)('Map') });


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(399);
	var fround = __webpack_require__(397);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(399) });


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var aFunction = __webpack_require__(42);
	var $defineProperty = __webpack_require__(34);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(187), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var aFunction = __webpack_require__(42);
	var $defineProperty = __webpack_require__(34);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(187), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(404)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(405);
	var toIObject = __webpack_require__(56);
	var gOPD = __webpack_require__(54);
	var createProperty = __webpack_require__(245);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(82);
	var getPrototypeOf = __webpack_require__(55);
	var getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(187), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(82);
	var getPrototypeOf = __webpack_require__(55);
	var getOwnPropertyDescriptor = __webpack_require__(54).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(187), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(404)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(15);
	var core = __webpack_require__(67);
	var microtask = __webpack_require__(256)();
	var OBSERVABLE = __webpack_require__(23)('observable');
	var aFunction = __webpack_require__(42);
	var anObject = __webpack_require__(10);
	var anInstance = __webpack_require__(109);
	var redefineAll = __webpack_require__(115);
	var hide = __webpack_require__(47);
	var forOf = __webpack_require__(110);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(116)('Observable');


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(67);
	var global = __webpack_require__(15);
	var speciesConstructor = __webpack_require__(155);
	var promiseResolve = __webpack_require__(409);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(257);
	var perform = __webpack_require__(408);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(417);
	var from = __webpack_require__(385);
	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var getPrototypeOf = __webpack_require__(55);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var getPrototypeOf = __webpack_require__(55);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var getPrototypeOf = __webpack_require__(55);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(89);
	var anObject = __webpack_require__(10);
	var aFunction = __webpack_require__(42);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(190)('Set');


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(191)('Set');


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(389)('Set') });


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(192)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(80);
	var toLength = __webpack_require__(26);
	var isRegExp = __webpack_require__(185);
	var getFlags = __webpack_require__(151);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(252)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(411);
	var userAgent = __webpack_require__(194);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(411);
	var userAgent = __webpack_require__(194);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(137)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(137)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266)('asyncIterator');


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266)('observable');


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(15) });


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(190)('WeakMap');


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(191)('WeakMap');


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(190)('WeakSet');


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(191)('WeakSet');


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(268);
	var getKeys = __webpack_require__(113);
	var redefine = __webpack_require__(48);
	var global = __webpack_require__(15);
	var hide = __webpack_require__(47);
	var Iterators = __webpack_require__(135);
	var wks = __webpack_require__(23);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(264);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(15);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(194);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(832);
	__webpack_require__(771);
	__webpack_require__(773);
	__webpack_require__(772);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(782);
	__webpack_require__(776);
	__webpack_require__(774);
	__webpack_require__(784);
	__webpack_require__(783);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(778);
	__webpack_require__(770);
	__webpack_require__(781);
	__webpack_require__(785);
	__webpack_require__(786);
	__webpack_require__(738);
	__webpack_require__(740);
	__webpack_require__(739);
	__webpack_require__(788);
	__webpack_require__(787);
	__webpack_require__(758);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(763);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(757);
	__webpack_require__(819);
	__webpack_require__(824);
	__webpack_require__(831);
	__webpack_require__(822);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(820);
	__webpack_require__(825);
	__webpack_require__(827);
	__webpack_require__(810);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(818);
	__webpack_require__(821);
	__webpack_require__(823);
	__webpack_require__(826);
	__webpack_require__(828);
	__webpack_require__(829);
	__webpack_require__(830);
	__webpack_require__(733);
	__webpack_require__(735);
	__webpack_require__(734);
	__webpack_require__(737);
	__webpack_require__(736);
	__webpack_require__(722);
	__webpack_require__(720);
	__webpack_require__(726);
	__webpack_require__(723);
	__webpack_require__(729);
	__webpack_require__(731);
	__webpack_require__(719);
	__webpack_require__(725);
	__webpack_require__(716);
	__webpack_require__(730);
	__webpack_require__(714);
	__webpack_require__(728);
	__webpack_require__(727);
	__webpack_require__(721);
	__webpack_require__(724);
	__webpack_require__(713);
	__webpack_require__(715);
	__webpack_require__(718);
	__webpack_require__(717);
	__webpack_require__(732);
	__webpack_require__(268);
	__webpack_require__(804);
	__webpack_require__(415);
	__webpack_require__(809);
	__webpack_require__(416);
	__webpack_require__(805);
	__webpack_require__(806);
	__webpack_require__(807);
	__webpack_require__(808);
	__webpack_require__(789);
	__webpack_require__(414);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(844);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(839);
	__webpack_require__(842);
	__webpack_require__(843);
	__webpack_require__(837);
	__webpack_require__(840);
	__webpack_require__(838);
	__webpack_require__(841);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(790);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(797);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(803);
	__webpack_require__(802);
	__webpack_require__(847);
	__webpack_require__(845);
	__webpack_require__(846);
	__webpack_require__(888);
	__webpack_require__(891);
	__webpack_require__(890);
	__webpack_require__(892);
	__webpack_require__(893);
	__webpack_require__(889);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(869);
	__webpack_require__(872);
	__webpack_require__(868);
	__webpack_require__(866);
	__webpack_require__(867);
	__webpack_require__(870);
	__webpack_require__(871);
	__webpack_require__(853);
	__webpack_require__(887);
	__webpack_require__(852);
	__webpack_require__(886);
	__webpack_require__(898);
	__webpack_require__(900);
	__webpack_require__(851);
	__webpack_require__(885);
	__webpack_require__(897);
	__webpack_require__(899);
	__webpack_require__(850);
	__webpack_require__(896);
	__webpack_require__(849);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(856);
	__webpack_require__(857);
	__webpack_require__(858);
	__webpack_require__(860);
	__webpack_require__(859);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(865);
	__webpack_require__(864);
	__webpack_require__(874);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(879);
	__webpack_require__(878);
	__webpack_require__(881);
	__webpack_require__(880);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(848);
	__webpack_require__(873);
	__webpack_require__(903);
	__webpack_require__(902);
	__webpack_require__(901);
	module.exports = __webpack_require__(67);


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* Clamp.js 0.5.1
	*
	* Copyright 2011-2013, Joseph Schmitt http://joe.sh
	* Released under the WTFPL license
	* http://sam.zoy.org/wtfpl/
	*/
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	    /**
	     * Clamps a text node.
	     * @param {HTMLElement} element. Element containing the text node to clamp.
	     * @param {Object} options. Options to pass to the clamper.
	     */
	    function clamp(element, options) {
	        options = options || {};
	
	        var self = this,
	            win = window,
	            opt = {
	                clamp:              options.clamp || 2,
	                useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	                splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	                animate:            options.animate || false,
	                truncationChar:     options.truncationChar || '…',
	                truncationHTML:     options.truncationHTML
	            },
	
	            sty = element.style,
	            originalText = element.innerHTML,
	
	            supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	            clampValue = opt.clamp,
	            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	            truncationHTMLContainer;
	            
	        if (opt.truncationHTML) {
	            truncationHTMLContainer = document.createElement('span');
	            truncationHTMLContainer.innerHTML = opt.truncationHTML;
	        }
	
	
	// UTILITY FUNCTIONS __________________________________________________________
	
	        /**
	         * Return the current style for an element.
	         * @param {HTMLElement} elem The element to compute.
	         * @param {string} prop The style property.
	         * @returns {number}
	         */
	        function computeStyle(elem, prop) {
	            if (!win.getComputedStyle) {
	                win.getComputedStyle = function(el, pseudo) {
	                    this.el = el;
	                    this.getPropertyValue = function(prop) {
	                        var re = /(\-([a-z]){1})/g;
	                        if (prop == 'float') prop = 'styleFloat';
	                        if (re.test(prop)) {
	                            prop = prop.replace(re, function () {
	                                return arguments[2].toUpperCase();
	                            });
	                        }
	                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	                    }
	                    return this;
	                }
	            }
	
	            return win.getComputedStyle(elem, null).getPropertyValue(prop);
	        }
	
	        /**
	         * Returns the maximum number of lines of text that should be rendered based
	         * on the current height of the element and the line-height of the text.
	         */
	        function getMaxLines(height) {
	            var availHeight = height || element.clientHeight,
	                lineHeight = getLineHeight(element);
	
	            return Math.max(Math.floor(availHeight/lineHeight), 0);
	        }
	
	        /**
	         * Returns the maximum height a given element should have based on the line-
	         * height of the text and the given clamp value.
	         */
	        function getMaxHeight(clmp) {
	            var lineHeight = getLineHeight(element);
	            return lineHeight * clmp;
	        }
	
	        /**
	         * Returns the line-height of an element as an integer.
	         */
	        function getLineHeight(elem) {
	            var lh = computeStyle(elem, 'line-height');
	            if (lh == 'normal') {
	                // Normal line heights vary from browser to browser. The spec recommends
	                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
	            }
	            return parseInt(lh);
	        }
	
	
	// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	        var splitOnChars = opt.splitOnChars.slice(0),
	            splitChar = splitOnChars[0],
	            chunks,
	            lastChunk;
	        
	        /**
	         * Gets an element's last child. That may be another node or a node's contents.
	         */
	        function getLastChild(elem) {
	            //Current element has children, need to go deeper and get last child as a text node
	            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	                return getLastChild(Array.prototype.slice.call(elem.children).pop());
	            }
	            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
	            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
	                elem.lastChild.parentNode.removeChild(elem.lastChild);
	                return getLastChild(element);
	            }
	            //This is the last child we want, return it
	            else {
	                return elem.lastChild;
	            }
	        }
	        
	        /**
	         * Removes one character at a time from the text until its width or
	         * height is beneath the passed-in max param.
	         */
	        function truncate(target, maxHeight) {
	            if (!maxHeight) {return;}
	            
	            /**
	             * Resets global variables.
	             */
	            function reset() {
	                splitOnChars = opt.splitOnChars.slice(0);
	                splitChar = splitOnChars[0];
	                chunks = null;
	                lastChunk = null;
	            }
	            
	            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	            
	            //Grab the next chunks
	            if (!chunks) {
	                //If there are more characters to try, grab the next one
	                if (splitOnChars.length > 0) {
	                    splitChar = splitOnChars.shift();
	                }
	                //No characters to chunk by. Go character-by-character
	                else {
	                    splitChar = '';
	                }
	                
	                chunks = nodeValue.split(splitChar);
	            }
	            
	            //If there are chunks left to remove, remove the last one and see if
	            // the nodeValue fits.
	            if (chunks.length > 1) {
	                // console.log('chunks', chunks);
	                lastChunk = chunks.pop();
	                // console.log('lastChunk', lastChunk);
	                applyEllipsis(target, chunks.join(splitChar));
	            }
	            //No more chunks can be removed using this character
	            else {
	                chunks = null;
	            }
	            
	            //Insert the custom HTML before the truncation character
	            if (truncationHTMLContainer) {
	                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	            }
	
	            //Search produced valid chunks
	            if (chunks) {
	                //It fits
	                if (element.clientHeight <= maxHeight) {
	                    //There's still more characters to try splitting on, not quite done yet
	                    if (splitOnChars.length >= 0 && splitChar != '') {
	                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	                        chunks = null;
	                    }
	                    //Finished!
	                    else {
	                        return element.innerHTML;
	                    }
	                }
	            }
	            //No valid chunks produced
	            else {
	                //No valid chunks even when splitting by letter, time to move
	                //on to the next node
	                if (splitChar == '') {
	                    applyEllipsis(target, '');
	                    target = getLastChild(element);
	                    
	                    reset();
	                }
	            }
	            
	            //If you get here it means still too big, let's keep truncating
	            if (opt.animate) {
	                setTimeout(function() {
	                    truncate(target, maxHeight);
	                }, opt.animate === true ? 10 : opt.animate);
	            }
	            else {
	                return truncate(target, maxHeight);
	            }
	        }
	        
	        function applyEllipsis(elem, str) {
	            elem.nodeValue = str + opt.truncationChar;
	        }
	
	
	// CONSTRUCTOR ________________________________________________________________
	
	        if (clampValue == 'auto') {
	            clampValue = getMaxLines();
	        }
	        else if (isCSSValue) {
	            clampValue = getMaxLines(parseInt(clampValue));
	        }
	
	        var clampedText;
	        if (supportsNativeClamp && opt.useNativeClamp) {
	            sty.overflow = 'hidden';
	            sty.textOverflow = 'ellipsis';
	            sty.webkitBoxOrient = 'vertical';
	            sty.display = '-webkit-box';
	            sty.webkitLineClamp = clampValue;
	
	            if (isCSSValue) {
	                sty.height = opt.clamp + 'px';
	            }
	        }
	        else {
	            var height = getMaxHeight(clampValue);
	            if (height < element.clientHeight) {
	                clampedText = truncate(getLastChild(element), height);
	            }
	        }
	        
	        return {
	            'original': originalText,
	            'clamped': clampedText
	        }
	    }
	
	    return clamp;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 906 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 907 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateToHTML = __webpack_require__(909);
	
	Object.defineProperty(exports, 'stateToHTML', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stateToHTML).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ENTITY_ATTR_MAP, _DATA_TO_ATTR;
	
	exports.default = stateToHTML;
	
	var _draftJs = __webpack_require__(195);
	
	var _draftJsUtils = __webpack_require__(425);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BOLD = _draftJsUtils.INLINE_STYLE.BOLD;
	var CODE = _draftJsUtils.INLINE_STYLE.CODE;
	var ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC;
	var STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH;
	var UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;
	
	
	var INDENT = '  ';
	var BREAK = '<br>';
	
	// Map entity data to element attributes.
	var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, { url: 'href', rel: 'rel', target: 'target', title: 'title', className: 'class' }), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, { src: 'src', height: 'height', width: 'width', alt: 'alt', className: 'class' }), _ENTITY_ATTR_MAP);
	
	// Map entity data to element attributes.
	var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var dataKey = _step.value;
	
	      var dataValue = data[dataKey];
	      if (attrMap.hasOwnProperty(dataKey)) {
	        var attrKey = attrMap[dataKey];
	        attrs[attrKey] = dataValue;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return attrs;
	}), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function (entityType, entity) {
	  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
	  var data = entity.getData();
	  var attrs = {};
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = Object.keys(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var dataKey = _step2.value;
	
	      var dataValue = data[dataKey];
	      if (attrMap.hasOwnProperty(dataKey)) {
	        var attrKey = attrMap[dataKey];
	        attrs[attrKey] = dataValue;
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return attrs;
	}), _DATA_TO_ATTR);
	
	// The reason this returns an array is because a single block might get wrapped
	// in two tags.
	function getTags(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
	      return ['h1'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
	      return ['h2'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
	      return ['h3'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
	      return ['h4'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
	      return ['h5'];
	    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
	      return ['h6'];
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return ['li'];
	    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
	      return ['blockquote'];
	    case _draftJsUtils.BLOCK_TYPE.CODE:
	      return ['pre', 'code'];
	    default:
	      return ['p'];
	  }
	}
	
	function getWrapperTag(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	      return 'ul';
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return 'ol';
	    default:
	      return null;
	  }
	}
	
	var MarkupGenerator = function () {
	  function MarkupGenerator(contentState) {
	    _classCallCheck(this, MarkupGenerator);
	
	    this.contentState = contentState;
	  }
	
	  _createClass(MarkupGenerator, [{
	    key: 'generate',
	    value: function generate() {
	      this.output = [];
	      this.blocks = this.contentState.getBlocksAsArray();
	      this.totalBlocks = this.blocks.length;
	      this.currentBlock = 0;
	      this.indentLevel = 0;
	      this.wrapperTag = null;
	      while (this.currentBlock < this.totalBlocks) {
	        this.processBlock();
	      }
	      this.closeWrapperTag();
	      return this.output.join('').trim();
	    }
	  }, {
	    key: 'processBlock',
	    value: function processBlock() {
	      var block = this.blocks[this.currentBlock];
	      var blockType = block.getType();
	      var newWrapperTag = getWrapperTag(blockType);
	      if (this.wrapperTag !== newWrapperTag) {
	        if (this.wrapperTag) {
	          this.closeWrapperTag();
	        }
	        if (newWrapperTag) {
	          this.openWrapperTag(newWrapperTag);
	        }
	      }
	      this.indent();
	      this.writeStartTag(blockType);
	      this.output.push(this.renderBlockContent(block));
	      // Look ahead and see if we will nest list.
	      var nextBlock = this.getNextBlock();
	      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
	        this.output.push('\n');
	        // This is a litle hacky: temporarily stash our current wrapperTag and
	        // render child list(s).
	        var thisWrapperTag = this.wrapperTag;
	        this.wrapperTag = null;
	        this.indentLevel += 1;
	        this.currentBlock += 1;
	        this.processBlocksAtDepth(nextBlock.getDepth());
	        this.wrapperTag = thisWrapperTag;
	        this.indentLevel -= 1;
	        this.indent();
	      } else {
	        this.currentBlock += 1;
	      }
	      this.writeEndTag(blockType);
	    }
	  }, {
	    key: 'processBlocksAtDepth',
	    value: function processBlocksAtDepth(depth) {
	      var block = this.blocks[this.currentBlock];
	      while (block && block.getDepth() === depth) {
	        this.processBlock();
	        block = this.blocks[this.currentBlock];
	      }
	      this.closeWrapperTag();
	    }
	  }, {
	    key: 'getNextBlock',
	    value: function getNextBlock() {
	      return this.blocks[this.currentBlock + 1];
	    }
	  }, {
	    key: 'writeStartTag',
	    value: function writeStartTag(blockType) {
	      var tags = getTags(blockType);
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = tags[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var tag = _step3.value;
	
	          this.output.push('<' + tag + '>');
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'writeEndTag',
	    value: function writeEndTag(blockType) {
	      var tags = getTags(blockType);
	      if (tags.length === 1) {
	        this.output.push('</' + tags[0] + '>\n');
	      } else {
	        var output = [];
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = tags[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var tag = _step4.value;
	
	            output.unshift('</' + tag + '>');
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	
	        this.output.push(output.join('') + '\n');
	      }
	    }
	  }, {
	    key: 'openWrapperTag',
	    value: function openWrapperTag(wrapperTag) {
	      this.wrapperTag = wrapperTag;
	      this.indent();
	      this.output.push('<' + wrapperTag + '>\n');
	      this.indentLevel += 1;
	    }
	  }, {
	    key: 'closeWrapperTag',
	    value: function closeWrapperTag() {
	      if (this.wrapperTag) {
	        this.indentLevel -= 1;
	        this.indent();
	        this.output.push('</' + this.wrapperTag + '>\n');
	        this.wrapperTag = null;
	      }
	    }
	  }, {
	    key: 'indent',
	    value: function indent() {
	      this.output.push(INDENT.repeat(this.indentLevel));
	    }
	  }, {
	    key: 'renderBlockContent',
	    value: function renderBlockContent(block) {
	      var blockType = block.getType();
	      var text = block.getText();
	      if (text === '') {
	        // Prevent element collapse if completely empty.
	        return BREAK;
	      }
	      text = this.preserveWhitespace(text);
	      var charMetaList = block.getCharacterList();
	      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
	      return entityPieces.map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var entityKey = _ref2[0];
	        var stylePieces = _ref2[1];
	
	        var content = stylePieces.map(function (_ref3) {
	          var _ref4 = _slicedToArray(_ref3, 2);
	
	          var text = _ref4[0];
	          var style = _ref4[1];
	
	          var content = encodeContent(text);
	          // These are reverse alphabetical by tag name.
	          if (style.has(BOLD)) {
	            content = '<strong>' + content + '</strong>';
	          }
	          if (style.has(UNDERLINE)) {
	            content = '<ins>' + content + '</ins>';
	          }
	          if (style.has(ITALIC)) {
	            content = '<em>' + content + '</em>';
	          }
	          if (style.has(STRIKETHROUGH)) {
	            content = '<del>' + content + '</del>';
	          }
	          if (style.has(CODE)) {
	            // If our block type is CODE then we are already wrapping the whole
	            // block in a `<code>` so don't wrap inline code elements.
	            content = blockType === _draftJsUtils.BLOCK_TYPE.CODE ? content : '<code>' + content + '</code>';
	          }
	          return content;
	        }).join('');
	        var entity = entityKey ? _draftJs.Entity.get(entityKey) : null;
	        // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
	        var entityType = entity == null ? null : entity.getType().toUpperCase();
	        if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.LINK) {
	          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	          var strAttrs = stringifyAttrs(attrs);
	          return '<a' + strAttrs + '>' + content + '</a>';
	        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE) {
	          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
	          var _strAttrs = stringifyAttrs(_attrs);
	          return '<img' + _strAttrs + '/>';
	        } else {
	          return content;
	        }
	      }).join('');
	    }
	  }, {
	    key: 'preserveWhitespace',
	    value: function preserveWhitespace(text) {
	      var length = text.length;
	      // Prevent leading/trailing/consecutive whitespace collapse.
	      var newText = new Array(length);
	      for (var i = 0; i < length; i++) {
	        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
	          newText[i] = '\xA0';
	        } else {
	          newText[i] = text[i];
	        }
	      }
	      return newText.join('');
	    }
	  }]);
	
	  return MarkupGenerator;
	}();
	
	function stringifyAttrs(attrs) {
	  if (attrs == null) {
	    return '';
	  }
	  var parts = [];
	  var _iteratorNormalCompletion5 = true;
	  var _didIteratorError5 = false;
	  var _iteratorError5 = undefined;
	
	  try {
	    for (var _iterator5 = Object.keys(attrs)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	      var attrKey = _step5.value;
	
	      var attrValue = attrs[attrKey];
	      if (attrValue != null) {
	        parts.push(' ' + attrKey + '="' + encodeAttr(attrValue + '') + '"');
	      }
	    }
	  } catch (err) {
	    _didIteratorError5 = true;
	    _iteratorError5 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	        _iterator5.return();
	      }
	    } finally {
	      if (_didIteratorError5) {
	        throw _iteratorError5;
	      }
	    }
	  }
	
	  return parts.join('');
	}
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      return true;
	    default:
	      return false;
	  }
	}
	
	function encodeContent(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
	}
	
	function encodeAttr(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
	}
	
	function stateToHTML(content) {
	  return new MarkupGenerator(content).generate();
	}

/***/ },
/* 910 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = replaceTextWithMeta;
	function replaceTextWithMeta(subject, searchText, replaceText) {
	  var text = subject.text;
	  var characterMeta = subject.characterMeta;
	
	  var searchTextLength = searchText.length;
	  var replaceTextLength = replaceText.length;
	  var resultTextParts = [];
	  // Get empty set of same kind as characterMeta.
	  var resultCharMeta = characterMeta.slice(0, 0);
	  var lastEndIndex = 0;
	  var index = text.indexOf(searchText);
	  while (index !== -1) {
	    resultTextParts.push(text.slice(lastEndIndex, index) + replaceText);
	    resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex, index),
	    // Use the metadata of the first char we are replacing.
	    repeatSeq(characterMeta.slice(index, index + 1), replaceTextLength));
	    lastEndIndex = index + searchTextLength;
	    index = text.indexOf(searchText, lastEndIndex);
	  }
	  resultTextParts.push(text.slice(lastEndIndex));
	  resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex));
	  return { text: resultTextParts.join(''), characterMeta: resultCharMeta };
	}
	
	function repeatSeq(seq, count) {
	  var result = seq.slice(0, 0);
	  while (count-- > 0) {
	    result = result.concat(seq);
	  }
	  return result;
	}

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateFromElement = __webpack_require__(912);
	
	Object.defineProperty(exports, 'stateFromElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stateFromElement).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = stateFromElement;
	
	var _replaceTextWithMeta3 = __webpack_require__(910);
	
	var _replaceTextWithMeta4 = _interopRequireDefault(_replaceTextWithMeta3);
	
	var _draftJs = __webpack_require__(195);
	
	var _immutable = __webpack_require__(24);
	
	var _draftJsUtils = __webpack_require__(425);
	
	var _syntheticDom = __webpack_require__(1382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A ParsedBlock has two purposes:
	//   1) to keep data about the block (textFragments, type)
	//   2) to act as some context for storing parser state as we parse its contents
	
	
	var NO_STYLE = (0, _immutable.OrderedSet)();
	var NO_ENTITY = null;
	
	var EMPTY_BLOCK = new _draftJs.ContentBlock({
	  key: (0, _draftJs.genKey)(),
	  text: '',
	  type: _draftJsUtils.BLOCK_TYPE.UNSTYLED,
	  characterList: (0, _immutable.List)(),
	  depth: 0
	});
	
	var LINE_BREAKS = /(\r\n|\r|\n)/g;
	// We use `\r` because that character is always stripped from source (normalized
	// to `\n`), so it's safe to assume it will only appear in the text content when
	// we put it there as a placeholder.
	var SOFT_BREAK_PLACEHOLDER = '\r';
	var ZERO_WIDTH_SPACE = '​';
	
	// Map element attributes to entity data.
	var ELEM_ATTR_MAP = {
	  a: { href: 'url', rel: 'rel', target: 'target', title: 'title' },
	  img: { src: 'src', alt: 'alt' }
	};
	
	var getEntityData = function getEntityData(tagName, element) {
	  var data = {};
	  if (ELEM_ATTR_MAP.hasOwnProperty(tagName)) {
	    var attrMap = ELEM_ATTR_MAP[tagName];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.keys(attrMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var attr = _step.value;
	
	        var dataKey = attrMap[attr];
	        var dataValue = element.getAttribute(attr);
	        if (dataValue != null) {
	          data[dataKey] = dataValue;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return data;
	};
	
	// Functions to convert elements to entities.
	var ELEM_TO_ENTITY = {
	  a: function a(tagName, element) {
	    var data = getEntityData(tagName, element);
	    // Don't add `<a>` elements with no href.
	    if (data.url != null) {
	      return _draftJs.Entity.create(_draftJsUtils.ENTITY_TYPE.LINK, 'MUTABLE', data);
	    }
	  },
	  img: function img(tagName, element) {
	    var data = getEntityData(tagName, element);
	    // Don't add `<img>` elements with no src.
	    if (data.src != null) {
	      return _draftJs.Entity.create(_draftJsUtils.ENTITY_TYPE.IMAGE, 'MUTABLE', data);
	    }
	  }
	};
	
	// TODO: Move this out to a module.
	var INLINE_ELEMENTS = {
	  a: 1, abbr: 1, area: 1, audio: 1, b: 1, bdi: 1, bdo: 1, br: 1, button: 1,
	  canvas: 1, cite: 1, code: 1, command: 1, datalist: 1, del: 1, dfn: 1, em: 1,
	  embed: 1, i: 1, iframe: 1, img: 1, input: 1, ins: 1, kbd: 1, keygen: 1,
	  label: 1, map: 1, mark: 1, meter: 1, noscript: 1, object: 1, output: 1,
	  progress: 1, q: 1, ruby: 1, s: 1, samp: 1, script: 1, select: 1, small: 1,
	  span: 1, strong: 1, sub: 1, sup: 1, textarea: 1, time: 1, u: 1, var: 1,
	  video: 1, wbr: 1, acronym: 1, applet: 1, basefont: 1, big: 1, font: 1,
	  isindex: 1, strike: 1, style: 1, tt: 1
	};
	
	// These elements are special because they cannot contain text as a direct
	// child (some cannot contain childNodes at all).
	var SPECIAL_ELEMENTS = {
	  area: 1, base: 1, br: 1, col: 1, colgroup: 1, command: 1, dl: 1, embed: 1,
	  head: 1, hgroup: 1, hr: 1, iframe: 1, img: 1, input: 1, keygen: 1, link: 1,
	  meta: 1, ol: 1, optgroup: 1, option: 1, param: 1, script: 1, select: 1,
	  source: 1, style: 1, table: 1, tbody: 1, textarea: 1, tfoot: 1, thead: 1,
	  title: 1, tr: 1, track: 1, ul: 1, wbr: 1, basefont: 1, dialog: 1, dir: 1,
	  isindex: 1
	};
	
	// These elements are special because they cannot contain childNodes.
	var SELF_CLOSING_ELEMENTS = { img: 1 };
	
	var BlockGenerator = function () {
	  function BlockGenerator() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, BlockGenerator);
	
	    this.options = options;
	    // This represents the hierarchy as we traverse nested elements; for
	    // example [body, ul, li] where we must know li's parent type (ul or ol).
	    this.blockStack = [];
	    // This is a linear list of blocks that will form the output; for example
	    // [p, li, li, blockquote].
	    this.blockList = [];
	    this.depth = 0;
	  }
	
	  _createClass(BlockGenerator, [{
	    key: 'process',
	    value: function process(element) {
	      this.processBlockElement(element);
	      var contentBlocks = [];
	      this.blockList.forEach(function (block) {
	        var _concatFragments = concatFragments(block.textFragments);
	
	        var text = _concatFragments.text;
	        var characterMeta = _concatFragments.characterMeta;
	
	        var includeEmptyBlock = false;
	        // If the block contains only a soft break then don't discard the block,
	        // but discard the soft break.
	        if (text === SOFT_BREAK_PLACEHOLDER) {
	          includeEmptyBlock = true;
	          text = '';
	        }
	        if (block.tagName === 'pre') {
	          var _trimLeadingNewline = trimLeadingNewline(text, characterMeta);
	
	          text = _trimLeadingNewline.text;
	          characterMeta = _trimLeadingNewline.characterMeta;
	        } else {
	          var _collapseWhiteSpace = collapseWhiteSpace(text, characterMeta);
	
	          text = _collapseWhiteSpace.text;
	          characterMeta = _collapseWhiteSpace.characterMeta;
	        }
	        // Previously we were using a placeholder for soft breaks. Now that we
	        // have collapsed whitespace we can change it back to normal line breaks.
	        text = text.split(SOFT_BREAK_PLACEHOLDER).join('\n');
	        // Discard empty blocks (unless otherwise specified).
	        if (text.length || includeEmptyBlock) {
	          contentBlocks.push(new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            text: text,
	            type: block.type,
	            characterList: characterMeta.toList(),
	            depth: block.depth
	          }));
	        }
	      });
	      if (contentBlocks.length) {
	        return contentBlocks;
	      } else {
	        return [EMPTY_BLOCK];
	      }
	    }
	  }, {
	    key: 'getBlockTypeFromTagName',
	    value: function getBlockTypeFromTagName(tagName) {
	      switch (tagName) {
	        case 'li':
	          {
	            var parent = this.blockStack.slice(-1)[0];
	            return parent.tagName === 'ol' ? _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM : _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM;
	          }
	        case 'blockquote':
	          {
	            return _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE;
	          }
	        case 'h1':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_ONE;
	          }
	        case 'h2':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_TWO;
	          }
	        case 'h3':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_THREE;
	          }
	        case 'h4':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_FOUR;
	          }
	        case 'h5':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_FIVE;
	          }
	        case 'h6':
	          {
	            return _draftJsUtils.BLOCK_TYPE.HEADER_SIX;
	          }
	        case 'pre':
	          {
	            return _draftJsUtils.BLOCK_TYPE.CODE;
	          }
	        case 'figure':
	          {
	            return _draftJsUtils.BLOCK_TYPE.ATOMIC;
	          }
	        default:
	          {
	            return _draftJsUtils.BLOCK_TYPE.UNSTYLED;
	          }
	      }
	    }
	  }, {
	    key: 'processBlockElement',
	    value: function processBlockElement(element) {
	      var tagName = element.nodeName.toLowerCase();
	      var type = this.getBlockTypeFromTagName(tagName);
	      var hasDepth = canHaveDepth(type);
	      var allowRender = !SPECIAL_ELEMENTS.hasOwnProperty(tagName);
	      var block = {
	        tagName: tagName,
	        textFragments: [],
	        type: type,
	        styleStack: [NO_STYLE],
	        entityStack: [NO_ENTITY],
	        depth: hasDepth ? this.depth : 0
	      };
	      if (allowRender) {
	        this.blockList.push(block);
	        if (hasDepth) {
	          this.depth += 1;
	        }
	      }
	      this.blockStack.push(block);
	      if (element.childNodes != null) {
	        Array.from(element.childNodes).forEach(this.processNode, this);
	      }
	      this.blockStack.pop();
	      if (allowRender && hasDepth) {
	        this.depth -= 1;
	      }
	    }
	  }, {
	    key: 'processInlineElement',
	    value: function processInlineElement(element) {
	      var tagName = element.nodeName.toLowerCase();
	      if (tagName === 'br') {
	        this.processText(SOFT_BREAK_PLACEHOLDER);
	        return;
	      }
	      var block = this.blockStack.slice(-1)[0];
	      var style = block.styleStack.slice(-1)[0];
	      var entityKey = block.entityStack.slice(-1)[0];
	      style = addStyleFromTagName(style, tagName, this.options.elementStyles);
	      if (ELEM_TO_ENTITY.hasOwnProperty(tagName)) {
	        // If the to-entity function returns nothing, use the existing entity.
	        entityKey = ELEM_TO_ENTITY[tagName](tagName, element) || entityKey;
	      }
	      block.styleStack.push(style);
	      block.entityStack.push(entityKey);
	      if (element.childNodes != null) {
	        Array.from(element.childNodes).forEach(this.processNode, this);
	      }
	      if (SELF_CLOSING_ELEMENTS.hasOwnProperty(tagName)) {
	        this.processText('~');
	      }
	      block.entityStack.pop();
	      block.styleStack.pop();
	    }
	  }, {
	    key: 'processTextNode',
	    value: function processTextNode(node) {
	      var text = node.nodeValue;
	      // This is important because we will use \r as a placeholder for a soft break.
	      text = text.replace(LINE_BREAKS, '\n');
	      // Replace zero-width space (we use it as a placeholder in markdown) with a
	      // soft break.
	      // TODO: The import-markdown package should correctly turn breaks into <br>
	      // elements so we don't need to include this hack.
	      text = text.split(ZERO_WIDTH_SPACE).join(SOFT_BREAK_PLACEHOLDER);
	      this.processText(text);
	    }
	  }, {
	    key: 'processText',
	    value: function processText(text) {
	      var block = this.blockStack.slice(-1)[0];
	      var style = block.styleStack.slice(-1)[0];
	      var entity = block.entityStack.slice(-1)[0];
	      var charMetadata = _draftJs.CharacterMetadata.create({
	        style: style,
	        entity: entity
	      });
	      var seq = (0, _immutable.Repeat)(charMetadata, text.length);
	      block.textFragments.push({
	        text: text,
	        characterMeta: seq
	      });
	    }
	  }, {
	    key: 'processNode',
	    value: function processNode(node) {
	      if (node.nodeType === _syntheticDom.NODE_TYPE_ELEMENT) {
	        var element = node;
	        var _tagName = element.nodeName.toLowerCase();
	        if (INLINE_ELEMENTS.hasOwnProperty(_tagName)) {
	          this.processInlineElement(element);
	        } else {
	          this.processBlockElement(element);
	        }
	      } else if (node.nodeType === _syntheticDom.NODE_TYPE_TEXT) {
	        this.processTextNode(node);
	      }
	    }
	  }]);
	
	  return BlockGenerator;
	}();
	
	function trimLeadingNewline(text, characterMeta) {
	  if (text.charAt(0) === '\n') {
	    text = text.slice(1);
	    characterMeta = characterMeta.slice(1);
	  }
	  return { text: text, characterMeta: characterMeta };
	}
	
	function trimLeadingSpace(text, characterMeta) {
	  while (text.charAt(0) === ' ') {
	    text = text.slice(1);
	    characterMeta = characterMeta.slice(1);
	  }
	  return { text: text, characterMeta: characterMeta };
	}
	
	function trimTrailingSpace(text, characterMeta) {
	  while (text.slice(-1) === ' ') {
	    text = text.slice(0, -1);
	    characterMeta = characterMeta.slice(0, -1);
	  }
	  return { text: text, characterMeta: characterMeta };
	}
	
	function collapseWhiteSpace(text, characterMeta) {
	  text = text.replace(/[ \t\n]/g, ' ');
	
	  var _trimLeadingSpace = trimLeadingSpace(text, characterMeta);
	
	  text = _trimLeadingSpace.text;
	  characterMeta = _trimLeadingSpace.characterMeta;
	
	  var _trimTrailingSpace = trimTrailingSpace(text, characterMeta);
	
	  text = _trimTrailingSpace.text;
	  characterMeta = _trimTrailingSpace.characterMeta;
	
	  var i = text.length;
	  while (i--) {
	    if (text.charAt(i) === ' ' && text.charAt(i - 1) === ' ') {
	      text = text.slice(0, i) + text.slice(i + 1);
	      characterMeta = characterMeta.slice(0, i).concat(characterMeta.slice(i + 1));
	    }
	  }
	  // There could still be one space on either side of a softbreak.
	
	  var _replaceTextWithMeta = (0, _replaceTextWithMeta4.default)({ text: text, characterMeta: characterMeta }, SOFT_BREAK_PLACEHOLDER + ' ', SOFT_BREAK_PLACEHOLDER);
	
	  text = _replaceTextWithMeta.text;
	  characterMeta = _replaceTextWithMeta.characterMeta;
	
	  var _replaceTextWithMeta2 = (0, _replaceTextWithMeta4.default)({ text: text, characterMeta: characterMeta }, ' ' + SOFT_BREAK_PLACEHOLDER, SOFT_BREAK_PLACEHOLDER);
	
	  text = _replaceTextWithMeta2.text;
	  characterMeta = _replaceTextWithMeta2.characterMeta;
	
	  return { text: text, characterMeta: characterMeta };
	}
	
	function canHaveDepth(blockType) {
	  switch (blockType) {
	    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
	    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
	      {
	        return true;
	      }
	    default:
	      {
	        return false;
	      }
	  }
	}
	
	function concatFragments(fragments) {
	  var text = '';
	  var characterMeta = (0, _immutable.Seq)();
	  fragments.forEach(function (textFragment) {
	    text = text + textFragment.text;
	    characterMeta = characterMeta.concat(textFragment.characterMeta);
	  });
	  return { text: text, characterMeta: characterMeta };
	}
	
	function addStyleFromTagName(styleSet, tagName, elementStyles) {
	  switch (tagName) {
	    case 'b':
	    case 'strong':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.BOLD);
	      }
	    case 'i':
	    case 'em':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.ITALIC);
	      }
	    case 'ins':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.UNDERLINE);
	      }
	    case 'code':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.CODE);
	      }
	    case 'del':
	      {
	        return styleSet.add(_draftJsUtils.INLINE_STYLE.STRIKETHROUGH);
	      }
	    default:
	      {
	        // Allow custom styles to be provided.
	        if (elementStyles && elementStyles[tagName]) {
	          return styleSet.add(elementStyles[tagName]);
	        }
	
	        return styleSet;
	      }
	  }
	}
	
	function stateFromElement(element, options) {
	  var blocks = new BlockGenerator(options).process(element);
	  return _draftJs.ContentState.createFromBlockArray(blocks);
	}

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stateFromHTML = __webpack_require__(915);
	
	Object.defineProperty(exports, 'stateFromHTML', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stateFromHTML).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 914 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseHTML;
	function parseHTML(html) {
	  var doc = void 0;
	  if (typeof DOMParser !== 'undefined') {
	    var parser = new DOMParser();
	    doc = parser.parseFromString(html, 'text/html');
	  } else {
	    doc = document.implementation.createHTMLDocument('');
	    doc.documentElement.innerHTML = html;
	  }
	  return doc.body;
	}

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stateFromHTML;
	
	var _draftJsImportElement = __webpack_require__(911);
	
	var _parseHTML = __webpack_require__(914);
	
	var _parseHTML2 = _interopRequireDefault(_parseHTML);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stateFromHTML(html, options) {
	  var parser = options == null || options.parser == null ? _parseHTML2.default : options.parser;
	  var element = parser(html);
	  return (0, _draftJsImportElement.stateFromElement)(element, options);
	}

/***/ },
/* 916 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BLOCK_TYPE = exports.BLOCK_TYPE = {
	  // This is used to represent a normal text block (paragraph).
	  UNSTYLED: 'unstyled',
	  HEADER_ONE: 'header-one',
	  HEADER_TWO: 'header-two',
	  HEADER_THREE: 'header-three',
	  HEADER_FOUR: 'header-four',
	  HEADER_FIVE: 'header-five',
	  HEADER_SIX: 'header-six',
	  UNORDERED_LIST_ITEM: 'unordered-list-item',
	  ORDERED_LIST_ITEM: 'ordered-list-item',
	  BLOCKQUOTE: 'blockquote',
	  PULLQUOTE: 'pullquote',
	  CODE: 'code-block',
	  ATOMIC: 'atomic'
	};
	
	var ENTITY_TYPE = exports.ENTITY_TYPE = {
	  LINK: 'LINK',
	  IMAGE: 'IMAGE'
	};
	
	var INLINE_STYLE = exports.INLINE_STYLE = {
	  BOLD: 'BOLD',
	  CODE: 'CODE',
	  ITALIC: 'ITALIC',
	  STRIKETHROUGH: 'STRIKETHROUGH',
	  UNDERLINE: 'UNDERLINE'
	};
	
	exports.default = {
	  BLOCK_TYPE: BLOCK_TYPE,
	  ENTITY_TYPE: ENTITY_TYPE,
	  INLINE_STYLE: INLINE_STYLE
	};

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _draftJs = __webpack_require__(195);
	
	var _getSelectedBlocks = __webpack_require__(271);
	
	var _getSelectedBlocks2 = _interopRequireDefault(_getSelectedBlocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calls a provided `modifier` function with a selection for each
	 * selected block in the current editor selection. Passes through additional
	 * arguments to the modifier.
	 *
	 * Note: At the moment it will retain the original selection and override
	 * possible selection changes from modifiers
	 *
	 * @param  {object} editorState The current draft.js editor state object
	 *
	 * @param  {function} modifier  A modifier function to be executed.
	 *                              Must have the signature (editorState, selection, ...)
	 *
	 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
	 *
	 * @return {object} The new editor state
	 */
	
	exports.default = function (editorState, modifier) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var contentState = editorState.getCurrentContent();
	  var currentSelection = editorState.getSelection();
	
	  var startKey = currentSelection.getStartKey();
	  var endKey = currentSelection.getEndKey();
	  var startOffset = currentSelection.getStartOffset();
	  var endOffset = currentSelection.getEndOffset();
	
	  var isSameBlock = startKey === endKey;
	  var selectedBlocks = (0, _getSelectedBlocks2.default)(contentState, startKey, endKey);
	
	  var finalEditorState = editorState;
	  selectedBlocks.forEach(function (block) {
	    var currentBlockKey = block.getKey();
	    var selectionStart = startOffset;
	    var selectionEnd = endOffset;
	
	    if (currentBlockKey === startKey) {
	      selectionStart = startOffset;
	      selectionEnd = isSameBlock ? endOffset : block.getText().length;
	    } else if (currentBlockKey === endKey) {
	      selectionStart = isSameBlock ? startOffset : 0;
	      selectionEnd = endOffset;
	    } else {
	      selectionStart = 0;
	      selectionEnd = block.getText().length;
	    }
	
	    var selection = new _draftJs.SelectionState({
	      anchorKey: currentBlockKey,
	      anchorOffset: selectionStart,
	      focusKey: currentBlockKey,
	      focusOffset: selectionEnd
	    });
	
	    finalEditorState = modifier.apply(undefined, [finalEditorState, selection].concat(args));
	  });
	
	  return _draftJs.EditorState.forceSelection(finalEditorState, currentSelection);
	};

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EMPTY_SET = undefined;
	exports.default = getEntityRanges;
	
	var _immutable = __webpack_require__(24);
	
	var EMPTY_SET = exports.EMPTY_SET = new _immutable.OrderedSet();
	
	function getEntityRanges(text, charMetaList) {
	  var charEntity = null;
	  var prevCharEntity = null;
	  var ranges = [];
	  var rangeStart = 0;
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharEntity = charEntity;
	    var meta = charMetaList.get(i);
	    charEntity = meta ? meta.getEntity() : null;
	    if (i > 0 && charEntity !== prevCharEntity) {
	      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
	      rangeStart = i;
	    }
	  }
	  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
	  return ranges;
	}
	
	function getStyleRanges(text, charMetaList) {
	  var charStyle = EMPTY_SET;
	  var prevCharStyle = EMPTY_SET;
	  var ranges = [];
	  var rangeStart = 0;
	  for (var i = 0, len = text.length; i < len; i++) {
	    prevCharStyle = charStyle;
	    var meta = charMetaList.get(i);
	    charStyle = meta ? meta.getStyle() : EMPTY_SET;
	    if (i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle)) {
	      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
	      rangeStart = i;
	    }
	  }
	  ranges.push([text.slice(rangeStart), charStyle]);
	  return ranges;
	}

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getSelectedBlocks = __webpack_require__(271);
	
	var _getSelectedBlocks2 = _interopRequireDefault(_getSelectedBlocks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (strategy) {
	  return function (editorState, selection) {
	    var contentState = editorState.getCurrentContent();
	    var currentSelection = selection || editorState.getSelection();
	    var startKey = currentSelection.getStartKey();
	    var endKey = currentSelection.getEndKey();
	    var startOffset = currentSelection.getStartOffset();
	    var endOffset = currentSelection.getEndOffset();
	
	    var isSameBlock = startKey === endKey;
	    var selectedBlocks = (0, _getSelectedBlocks2.default)(contentState, startKey, endKey);
	    var entityFound = false;
	
	    // We have to shift the offset to not get false positives when selecting
	    // a character just before or after an entity
	    var finalStartOffset = startOffset + 1;
	    var finalEndOffset = endOffset - 1;
	
	    selectedBlocks.forEach(function (block) {
	      strategy(block, function (start, end) {
	        if (entityFound) {
	          return;
	        }
	
	        var blockKey = block.getKey();
	
	        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
	          return;
	        } else if (blockKey === startKey && end < finalStartOffset) {
	          return;
	        } else if (blockKey === endKey && start > finalEndOffset) {
	          return;
	        }
	
	        entityFound = true;
	      });
	    });
	
	    return entityFound;
	  };
	};

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(156);
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(121);
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var Immutable = __webpack_require__(24);
	
	var generateRandomKey = __webpack_require__(83);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var fragmentArray = [new ContentBlock({
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    }), new ContentBlock({
	      key: generateRandomKey(),
	      type: 'unstyled',
	      text: '',
	      characterList: List()
	    })];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Immutable = __webpack_require__(24);
	
	var List = Immutable.List;
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = (function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  /**
	   * Determine whether we can occupy the specified slice of the decorations
	   * array.
	   */
	
	  _createClass(CompositeDraftDecorator, [{
	    key: 'getDecorations',
	    value: function getDecorations(block) {
	      var decorations = Array(block.getText().length).fill(null);
	
	      this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	        var counter = 0;
	        var strategy = decorator.strategy;
	        strategy(block, function ( /*number*/start, /*number*/end) {
	          // Find out if any of our matching range is already occupied
	          // by another decorator. If so, discard the match. Otherwise, store
	          // the component key for rendering.
	          if (canOccupySlice(decorations, start, end)) {
	            occupySlice(decorations, start, end, ii + DELIMITER + counter);
	            counter++;
	          }
	        });
	      });
	
	      return List(decorations);
	    }
	  }, {
	    key: 'getComponentForKey',
	    value: function getComponentForKey(key) {
	      var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	      return this._decorators[componentKey].component;
	    }
	  }, {
	    key: 'getPropsForKey',
	    value: function getPropsForKey(key) {
	      var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	      return this._decorators[componentKey].props;
	    }
	  }]);
	
	  return CompositeDraftDecorator;
	})();
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	
	var _require = __webpack_require__(24);
	
	var Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(273);
	var DefaultDraftInlineStyle = __webpack_require__(427);
	var DraftEditorCompositionHandler = __webpack_require__(924);
	var DraftEditorContents = __webpack_require__(925);
	var DraftEditorDragHandler = __webpack_require__(926);
	var DraftEditorEditHandler = __webpack_require__(927);
	var DraftEditorPlaceholder = __webpack_require__(929);
	var EditorState = __webpack_require__(21);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var Scroll = __webpack_require__(455);
	var Style = __webpack_require__(281);
	var UserAgent = __webpack_require__(84);
	
	var cx = __webpack_require__(158);
	var emptyFunction = __webpack_require__(57);
	var generateRandomKey = __webpack_require__(83);
	var getDefaultKeyBinding = __webpack_require__(433);
	var nullthrows = __webpack_require__(58);
	var getScrollPosition = __webpack_require__(284);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  'edit': DraftEditorEditHandler,
	  'composite': DraftEditorCompositionHandler,
	  'drag': DraftEditorDragHandler,
	  'cut': null,
	  'render': null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	
	var DraftEditor = (function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  _createClass(DraftEditor, null, [{
	    key: 'defaultProps',
	    value: {
	      blockRenderMap: DefaultDraftBlockRenderMap,
	      blockRendererFn: emptyFunction.thatReturnsNull,
	      blockStyleFn: emptyFunction.thatReturns(''),
	      keyBindingFn: getDefaultKeyBinding,
	      readOnly: false,
	      spellCheck: false,
	      stripPastedStyles: false
	    },
	    enumerable: true
	  }]);
	
	  function DraftEditor(props) {
	    var _this = this;
	
	    _classCallCheck(this, DraftEditor);
	
	    _get(Object.getPrototypeOf(DraftEditor.prototype), 'constructor', this).call(this, props);
	
	    this._blockSelectEvents = false;
	    this._clipboard = null;
	    this._guardAgainstRender = false;
	    this._handler = null;
	    this._dragCount = 0;
	    this._editorKey = generateRandomKey();
	    this._placeholderAccessibilityID = 'placeholder-' + this._editorKey;
	
	    this._onBeforeInput = this._buildHandler('onBeforeInput');
	    this._onBlur = this._buildHandler('onBlur');
	    this._onCharacterData = this._buildHandler('onCharacterData');
	    this._onCompositionEnd = this._buildHandler('onCompositionEnd');
	    this._onCompositionStart = this._buildHandler('onCompositionStart');
	    this._onCopy = this._buildHandler('onCopy');
	    this._onCut = this._buildHandler('onCut');
	    this._onDragEnd = this._buildHandler('onDragEnd');
	    this._onDragOver = this._buildHandler('onDragOver');
	    this._onDragStart = this._buildHandler('onDragStart');
	    this._onDrop = this._buildHandler('onDrop');
	    this._onInput = this._buildHandler('onInput');
	    this._onFocus = this._buildHandler('onFocus');
	    this._onKeyDown = this._buildHandler('onKeyDown');
	    this._onKeyPress = this._buildHandler('onKeyPress');
	    this._onKeyUp = this._buildHandler('onKeyUp');
	    this._onMouseDown = this._buildHandler('onMouseDown');
	    this._onMouseUp = this._buildHandler('onMouseUp');
	    this._onPaste = this._buildHandler('onPaste');
	    this._onSelect = this._buildHandler('onSelect');
	
	    // Manual binding for public and internal methods.
	    this.focus = this._focus.bind(this);
	    this.blur = this._blur.bind(this);
	    this.setMode = this._setMode.bind(this);
	    this.exitCurrentMode = this._exitCurrentMode.bind(this);
	    this.restoreEditorDOM = this._restoreEditorDOM.bind(this);
	    this.setRenderGuard = this._setRenderGuard.bind(this);
	    this.removeRenderGuard = this._removeRenderGuard.bind(this);
	    this.setClipboard = this._setClipboard.bind(this);
	    this.getClipboard = this._getClipboard.bind(this);
	    this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	    this.update = this._update.bind(this);
	    this.onDragEnter = this._onDragEnter.bind(this);
	    this.onDragLeave = this._onDragLeave.bind(this);
	
	    // See `_restoreEditorDOM()`.
	    this.state = { containerKey: 0 };
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	  _createClass(DraftEditor, [{
	    key: '_buildHandler',
	    value: function _buildHandler(eventName) {
	      var _this2 = this;
	
	      return function (e) {
	        if (!_this2.props.readOnly) {
	          var method = _this2._handler && _this2._handler[eventName];
	          method && method.call(_this2, e);
	        }
	      };
	    }
	  }, {
	    key: '_showPlaceholder',
	    value: function _showPlaceholder() {
	      return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	    }
	  }, {
	    key: '_renderPlaceholder',
	    value: function _renderPlaceholder() {
	      if (this._showPlaceholder()) {
	        return React.createElement(DraftEditorPlaceholder, {
	          text: nullthrows(this.props.placeholder),
	          editorState: this.props.editorState,
	          textAlignment: this.props.textAlignment,
	          accessibilityID: this._placeholderAccessibilityID
	        });
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var readOnly = _props.readOnly;
	      var textAlignment = _props.textAlignment;
	
	      var rootClass = cx({
	        'DraftEditor/root': true,
	        'DraftEditor/alignLeft': textAlignment === 'left',
	        'DraftEditor/alignRight': textAlignment === 'right',
	        'DraftEditor/alignCenter': textAlignment === 'center'
	      });
	      var hasContent = this.props.editorState.getCurrentContent().hasText();
	
	      var contentStyle = {
	        outline: 'none',
	        whiteSpace: 'pre-wrap',
	        wordWrap: 'break-word'
	      };
	
	      return React.createElement(
	        'div',
	        { className: rootClass },
	        this._renderPlaceholder(),
	        React.createElement(
	          'div',
	          {
	            className: cx('DraftEditor/editorContainer'),
	            key: 'editor' + this.state.containerKey,
	            ref: 'editorContainer' },
	          React.createElement(
	            'div',
	            {
	              'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	              'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	              'aria-describedby': this._showPlaceholder() ? this._placeholderAccessibilityID : null,
	              'aria-expanded': readOnly ? null : this.props.ariaExpanded,
	              'aria-haspopup': readOnly ? null : this.props.ariaHasPopup,
	              'aria-label': this.props.ariaLabel,
	              'aria-owns': readOnly ? null : this.props.ariaOwneeID,
	              className: cx('public/DraftEditor/content'),
	              contentEditable: !readOnly,
	              'data-testid': this.props.webDriverTestID,
	              onBeforeInput: this._onBeforeInput,
	              onBlur: this._onBlur,
	              onCompositionEnd: this._onCompositionEnd,
	              onCompositionStart: this._onCompositionStart,
	              onCopy: this._onCopy,
	              onCut: this._onCut,
	              onDragEnd: this._onDragEnd,
	              onDragEnter: this.onDragEnter,
	              onDragLeave: this.onDragLeave,
	              onDragOver: this._onDragOver,
	              onDragStart: this._onDragStart,
	              onDrop: this._onDrop,
	              onFocus: this._onFocus,
	              onInput: this._onInput,
	              onKeyDown: this._onKeyDown,
	              onKeyPress: this._onKeyPress,
	              onKeyUp: this._onKeyUp,
	              onMouseUp: this._onMouseUp,
	              onPaste: this._onPaste,
	              onSelect: this._onSelect,
	              ref: 'editor',
	              role: readOnly ? null : this.props.role || 'textbox',
	              spellCheck: allowSpellCheck && this.props.spellCheck,
	              style: contentStyle,
	              suppressContentEditableWarning: true,
	              tabIndex: this.props.tabIndex },
	            React.createElement(DraftEditorContents, {
	              blockRenderMap: this.props.blockRenderMap,
	              blockRendererFn: this.props.blockRendererFn,
	              blockStyleFn: this.props.blockStyleFn,
	              customStyleMap: _extends({}, DefaultDraftInlineStyle, this.props.customStyleMap),
	              editorKey: this._editorKey,
	              editorState: this.props.editorState
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setMode('edit');
	
	      /**
	       * IE has a hardcoded "feature" that attempts to convert link text into
	       * anchors in contentEditable DOM. This breaks the editor's expectations of
	       * the DOM, and control is lost. Disable it to make IE behave.
	       * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	       * ie9-beta-minor-change-list.aspx
	       */
	      if (isIE) {
	        document.execCommand('AutoUrlDetect', false, false);
	      }
	    }
	
	    /**
	     * Prevent selection events from affecting the current editor state. This
	     * is mostly intended to defend against IE, which fires off `selectionchange`
	     * events regardless of whether the selection is set via the browser or
	     * programmatically. We only care about selection events that occur because
	     * of browser interaction, not re-renders and forced selections.
	     */
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this._blockSelectEvents = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._blockSelectEvents = false;
	    }
	
	    /**
	     * Used via `this.focus()`.
	     *
	     * Force focus back onto the editor node.
	     *
	     * Forcing focus causes the browser to scroll to the top of the editor, which
	     * may be undesirable when the editor is taller than the viewport. To solve
	     * this, either use a specified scroll position (in cases like `cut` behavior
	     * where it should be restored to a known position) or store the current
	     * scroll state and put it back in place after focus has been forced.
	     */
	  }, {
	    key: '_focus',
	    value: function _focus(scrollPosition) {
	      var editorState = this.props.editorState;
	
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = ReactDOM.findDOMNode(this.refs.editor);
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent);
	
	      var x = _ref.x;
	      var y = _ref.y;
	
	      editorNode.focus();
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      }
	
	      // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	      if (!alreadyHasFocus) {
	        this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    }
	  }, {
	    key: '_blur',
	    value: function _blur() {
	      ReactDOM.findDOMNode(this.refs.editor).blur();
	    }
	
	    /**
	     * Used via `this.setMode(...)`.
	     *
	     * Set the behavior mode for the editor component. This switches the current
	     * handler module to ensure that DOM events are managed appropriately for
	     * the active mode.
	     */
	  }, {
	    key: '_setMode',
	    value: function _setMode(mode) {
	      this._handler = handlerMap[mode];
	    }
	  }, {
	    key: '_exitCurrentMode',
	    value: function _exitCurrentMode() {
	      this.setMode('edit');
	    }
	
	    /**
	     * Used via `this.restoreEditorDOM()`.
	     *
	     * Force a complete re-render of the editor based on the current EditorState.
	     * This is useful when we know we are going to lose control of the DOM
	     * state (cut command, IME) and we want to make sure that reconciliation
	     * occurs on a version of the DOM that is synchronized with our EditorState.
	     */
	  }, {
	    key: '_restoreEditorDOM',
	    value: function _restoreEditorDOM(scrollPosition) {
	      var _this3 = this;
	
	      this.setState({ containerKey: this.state.containerKey + 1 }, function () {
	        _this3._focus(scrollPosition);
	      });
	    }
	
	    /**
	     * Guard against rendering. Intended for use when we need to manually
	     * reset editor contents, to ensure that no outside influences lead to
	     * React reconciliation when we are in an uncertain state.
	     */
	  }, {
	    key: '_setRenderGuard',
	    value: function _setRenderGuard() {
	      this._guardAgainstRender = true;
	    }
	  }, {
	    key: '_removeRenderGuard',
	    value: function _removeRenderGuard() {
	      this._guardAgainstRender = false;
	    }
	
	    /**
	     * Used via `this.setClipboard(...)`.
	     *
	     * Set the clipboard state for a cut/copy event.
	     */
	  }, {
	    key: '_setClipboard',
	    value: function _setClipboard(clipboard) {
	      this._clipboard = clipboard;
	    }
	
	    /**
	     * Used via `this.getClipboard()`.
	     *
	     * Retrieve the clipboard state for a cut/copy event.
	     */
	  }, {
	    key: '_getClipboard',
	    value: function _getClipboard() {
	      return this._clipboard;
	    }
	
	    /**
	     * Used via `this.update(...)`.
	     *
	     * Propagate a new `EditorState` object to higher-level components. This is
	     * the method by which event handlers inform the `DraftEditor` component of
	     * state changes. A component that composes a `DraftEditor` **must** provide
	     * an `onChange` prop to receive state updates passed along from this
	     * function.
	     */
	  }, {
	    key: '_update',
	    value: function _update(editorState) {
	      this.props.onChange(editorState);
	    }
	
	    /**
	     * Used in conjunction with `_onDragLeave()`, by counting the number of times
	     * a dragged element enters and leaves the editor (or any of its children),
	     * to determine when the dragged element absolutely leaves the editor.
	     */
	  }, {
	    key: '_onDragEnter',
	    value: function _onDragEnter() {
	      this._dragCount++;
	    }
	
	    /**
	     * See `_onDragEnter()`.
	     */
	  }, {
	    key: '_onDragLeave',
	    value: function _onDragLeave() {
	      this._dragCount--;
	      if (this._dragCount === 0) {
	        this.exitCurrentMode();
	      }
	    }
	  }]);
	
	  return DraftEditor;
	})(React.Component);
	
	module.exports = DraftEditor;
	
	/**
	 * Define proxies that can route events to the current handler.
	 */

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var Keys = __webpack_require__(280);
	
	var getEntityKeyForSelection = __webpack_require__(276);
	var isSelectionAtLeafStart = __webpack_require__(442);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart() {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd() {
	    var _this = this;
	
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition.call(_this);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(e) {
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition() {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(this.props.editorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      this.restoreEditorDOM();
	    }
	
	    this.exitCurrentMode();
	    this.removeRenderGuard();
	
	    if (composedChars) {
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      this.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(428);
	var DraftOffsetKey = __webpack_require__(196);
	var EditorState = __webpack_require__(21);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(158);
	var joinClasses = __webpack_require__(1069);
	var nullthrows = __webpack_require__(58);
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	var DraftEditorContents = (function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    _get(Object.getPrototypeOf(DraftEditorContents.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  /**
	   * Provide default styling for list items. This way, lists will be styled with
	   * proper counters and indentation even if the caller does not specify
	   * their own styling at all. If more than five levels of nesting are needed,
	   * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	   */
	
	  _createClass(DraftEditorContents, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var prevEditorState = this.props.editorState;
	      var nextEditorState = nextProps.editorState;
	
	      var prevDirectionMap = prevEditorState.getDirectionMap();
	      var nextDirectionMap = nextEditorState.getDirectionMap();
	
	      // Text direction has changed for one or more blocks. We must re-render.
	      if (prevDirectionMap !== nextDirectionMap) {
	        return true;
	      }
	
	      var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	      var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	      if (didHaveFocus !== nowHasFocus) {
	        return true;
	      }
	
	      var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	      var wasComposing = prevEditorState.isInCompositionMode();
	      var nowComposing = nextEditorState.isInCompositionMode();
	
	      // If the state is unchanged or we're currently rendering a natively
	      // rendered state, there's nothing new to be done.
	      if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	        return false;
	      }
	
	      var prevContent = prevEditorState.getCurrentContent();
	      var nextContent = nextEditorState.getCurrentContent();
	      var prevDecorator = prevEditorState.getDecorator();
	      var nextDecorator = nextEditorState.getDecorator();
	      return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var blockRenderMap = _props.blockRenderMap;
	      var blockRendererFn = _props.blockRendererFn;
	      var customStyleMap = _props.customStyleMap;
	      var editorState = _props.editorState;
	
	      var content = editorState.getCurrentContent();
	      var selection = editorState.getSelection();
	      var forceSelection = editorState.mustForceSelection();
	      var decorator = editorState.getDecorator();
	      var directionMap = nullthrows(editorState.getDirectionMap());
	
	      var blocksAsArray = content.getBlocksAsArray();
	      var blocks = [];
	      var currentWrapperElement = null;
	      var currentWrapperTemplate = null;
	      var currentDepth = null;
	      var currentWrappedBlocks = undefined;
	      var block = undefined,
	          key = undefined,
	          blockType = undefined,
	          child = undefined,
	          childProps = undefined,
	          wrapperTemplate = undefined;
	
	      for (var ii = 0; ii < blocksAsArray.length; ii++) {
	        block = blocksAsArray[ii];
	        key = block.getKey();
	        blockType = block.getType();
	
	        var customRenderer = blockRendererFn(block);
	        var CustomComponent = undefined,
	            customProps = undefined,
	            customEditable = undefined;
	        if (customRenderer) {
	          CustomComponent = customRenderer.component;
	          customProps = customRenderer.props;
	          customEditable = customRenderer.editable;
	        }
	
	        var direction = directionMap.get(key);
	        var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	        var componentProps = {
	          block: block,
	          blockProps: customProps,
	          customStyleMap: customStyleMap,
	          decorator: decorator,
	          direction: direction,
	          forceSelection: forceSelection,
	          key: key,
	          offsetKey: offsetKey,
	          selection: selection,
	          tree: editorState.getBlockTree(key)
	        };
	
	        // Block render map must have a configuration specified for this
	        // block type.
	        var configForType = nullthrows(blockRenderMap.get(blockType));
	
	        wrapperTemplate = configForType.wrapper;
	
	        var useNewWrapper = wrapperTemplate !== currentWrapperTemplate;
	
	        var _Element = blockRenderMap.get(blockType).element || blockRenderMap.get('unstyled').element;
	
	        var depth = block.getDepth();
	        var className = this.props.blockStyleFn(block);
	
	        // List items are special snowflakes, since we handle nesting and
	        // counters manually.
	        if (_Element === 'li') {
	          var shouldResetCount = useNewWrapper || currentDepth === null || depth > currentDepth;
	          className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	        }
	
	        var Component = CustomComponent || DraftEditorBlock;
	        childProps = {
	          className: className,
	          'data-block': true,
	          'data-editor': this.props.editorKey,
	          'data-offset-key': offsetKey,
	          key: key
	        };
	        if (customEditable !== undefined) {
	          childProps = _extends({}, childProps, {
	            contentEditable: customEditable,
	            suppressContentEditableWarning: true
	          });
	        }
	
	        child = React.createElement(_Element, childProps, React.createElement(Component, componentProps));
	
	        if (wrapperTemplate) {
	          if (useNewWrapper) {
	            currentWrappedBlocks = [];
	            currentWrapperElement = React.cloneElement(wrapperTemplate, {
	              key: key + '-wrap',
	              'data-offset-key': offsetKey
	            }, currentWrappedBlocks);
	            currentWrapperTemplate = wrapperTemplate;
	            blocks.push(currentWrapperElement);
	          }
	          currentDepth = block.getDepth();
	          nullthrows(currentWrappedBlocks).push(child);
	        } else {
	          currentWrappedBlocks = null;
	          currentWrapperElement = null;
	          currentWrapperTemplate = null;
	          currentDepth = null;
	          blocks.push(child);
	        }
	      }
	
	      return React.createElement(
	        'div',
	        { 'data-contents': 'true' },
	        blocks
	      );
	    }
	  }]);
	
	  return DraftEditorContents;
	})(React.Component);
	
	function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	}
	
	module.exports = DraftEditorContents;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @typechecks
	 * 
	 */
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	'use strict';
	
	var DataTransfer = __webpack_require__(453);
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	
	var findAncestorOffsetKey = __webpack_require__(275);
	var getTextContentFromFiles = __webpack_require__(439);
	var getUpdatedSelectionState = __webpack_require__(440);
	var nullthrows = __webpack_require__(58);
	
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (document.caretRangeFromPoint) {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd() {
	    this.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(e) {
	    var _this = this;
	
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = this.props.editorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    this.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (this.props.handleDroppedFiles && this.props.handleDroppedFiles(dropSelection, files)) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && _this.update(insertTextAtSelection(editorState, nullthrows(dropSelection), // flow wtf
	        fileText));
	      });
	      return;
	    }
	
	    var dragType = this._internalDrag ? 'internal' : 'external';
	    if (this.props.handleDrop && this.props.handleDrop(dropSelection, data, dragType)) {
	      return;
	    }
	
	    if (this._internalDrag) {
	      this.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    this.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(944);
	var onBlur = __webpack_require__(945);
	var onCompositionStart = __webpack_require__(946);
	var onCopy = __webpack_require__(947);
	var onCut = __webpack_require__(948);
	var onDragOver = __webpack_require__(949);
	var onDragStart = __webpack_require__(950);
	var onFocus = __webpack_require__(951);
	var onInput = __webpack_require__(952);
	var onKeyDown = __webpack_require__(953);
	var onPaste = __webpack_require__(954);
	var onSelect = __webpack_require__(955);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(930);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var SelectionState = __webpack_require__(138);
	
	var setDraftEditorSelection = __webpack_require__(978);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	
	var DraftEditorLeaf = (function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    _get(Object.getPrototypeOf(DraftEditorLeaf.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DraftEditorLeaf, [{
	    key: '_setSelection',
	
	    /**
	     * By making individual leaf instances aware of their context within
	     * the text of the editor, we can set our selection range more
	     * easily than we could in the non-React world.
	     *
	     * Note that this depends on our maintaining tight control over the
	     * DOM structure of the TextEditor component. If leaves had multiple
	     * text nodes, this would be harder.
	     */
	    value: function _setSelection() {
	      var selection = this.props.selection;
	
	      // If selection state is irrelevant to the parent block, no-op.
	      if (selection == null || !selection.getHasFocus()) {
	        return;
	      }
	
	      var _props = this.props;
	      var blockKey = _props.blockKey;
	      var start = _props.start;
	      var text = _props.text;
	
	      var end = start + text.length;
	      if (!selection.hasEdgeWithin(blockKey, start, end)) {
	        return;
	      }
	
	      // Determine the appropriate target node for selection. If the child
	      // is not a text node, it is a <br /> spacer. In this case, use the
	      // <span> itself as the selection target.
	      var node = ReactDOM.findDOMNode(this);
	      var child = node.firstChild;
	      var targetNode = undefined;
	
	      if (child.nodeType === Node.TEXT_NODE) {
	        targetNode = child;
	      } else if (child.tagName === 'BR') {
	        targetNode = node;
	      } else {
	        targetNode = child.firstChild;
	      }
	
	      setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return ReactDOM.findDOMNode(this.refs.leaf).textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setSelection();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setSelection();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var text = this.props.text;
	
	      // If the leaf is at the end of its block and ends in a soft newline, append
	      // an extra line feed character. Browsers collapse trailing newline
	      // characters, which leaves the cursor in the wrong place after a
	      // shift+enter. The extra character repairs this.
	      if (text.endsWith('\n') && this.props.isLast) {
	        text += '\n';
	      }
	
	      var _props2 = this.props;
	      var customStyleMap = _props2.customStyleMap;
	      var offsetKey = _props2.offsetKey;
	      var styleSet = _props2.styleSet;
	
	      var styleObj = styleSet.reduce(function (map, styleName) {
	        var mergedStyles = {};
	        var style = customStyleMap[styleName];
	
	        if (style !== undefined && map.textDecoration !== style.textDecoration) {
	          mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ');
	        }
	
	        return Object.assign(map, style, mergedStyles);
	      }, {});
	
	      return React.createElement(
	        'span',
	        {
	          'data-offset-key': offsetKey,
	          ref: 'leaf',
	          style: styleObj },
	        React.createElement(
	          DraftEditorTextNode,
	          null,
	          text
	        )
	      );
	    }
	  }]);
	
	  return DraftEditorLeaf;
	})(React.Component);
	
	module.exports = DraftEditorLeaf;
	
	// A function passed through from the the top level to define a cx
	// style map for the provided style value.
	
	// Mapping of style names to CSS declarations.
	
	// Whether to force the DOM selection after render.
	
	// Whether this leaf is the last in its block. Used for a DOM hack.
	
	// The current `SelectionState`, used to
	
	// The offset of this string within its block.
	
	// The set of style(s) names to apply to the node.
	
	// The full text to be rendered within this node.

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(158);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	
	var DraftEditorPlaceholder = (function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    _get(Object.getPrototypeOf(DraftEditorPlaceholder.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DraftEditorPlaceholder, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	      var className = cx({
	        'public/DraftEditorPlaceholder/root': true,
	        'public/DraftEditorPlaceholder/hasFocus': hasFocus
	      });
	
	      return React.createElement(
	        'div',
	        { className: className },
	        React.createElement(
	          'div',
	          {
	            className: cx('public/DraftEditorPlaceholder/inner'),
	            id: this.props.accessibilityID },
	          this.props.text
	        )
	      );
	    }
	  }]);
	
	  return DraftEditorPlaceholder;
	})(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(39);
	var UserAgent = __webpack_require__(84);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	
	var DraftEditorTextNode = (function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    _get(Object.getPrototypeOf(DraftEditorTextNode.prototype), 'constructor', this).call(this, props);
	    this._forceFlag = false;
	  }
	
	  _createClass(DraftEditorTextNode, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var node = ReactDOM.findDOMNode(this);
	      var shouldBeNewline = nextProps.children === '';
	      if (shouldBeNewline) {
	        return !isNewline(node);
	      }
	      return node.textContent !== nextProps.children;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      // By flipping this flag, we also keep flipping keys which forces
	      // React to remount this node every time it rerenders.
	      this._forceFlag = !this._forceFlag;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.children === '') {
	        return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	      }
	      return React.createElement(
	        'span',
	        { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return DraftEditorTextNode;
	})(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ },
/* 931 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @typechecks
	 * 
	 */
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	'use strict';
	
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(121);
	var Immutable = __webpack_require__(24);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(432);
	var generateRandomKey = __webpack_require__(83);
	var getSafeBodyFromHTML = __webpack_require__(437);
	var sanitizeDraftText = __webpack_require__(278);
	
	var List = Immutable.List;
	var Repeat = Immutable.Repeat;
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	
	  processText: function processText(textBlocks, character) {
	    return textBlocks.map(function (textLine) {
	      textLine = sanitizeDraftText(textLine);
	      return new ContentBlock({
	        key: generateRandomKey(),
	        type: 'unstyled',
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      });
	    });
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	var UnicodeBidiService = __webpack_require__(1056);
	
	var nullthrows = __webpack_require__(58);
	
	var OrderedMap = Immutable.OrderedMap;
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(91);
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var SelectionState = __webpack_require__(138);
	
	var adjustBlockDepthForContentState = __webpack_require__(936);
	var nullthrows = __webpack_require__(58);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && DraftEntity.get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var atomicBlockTarget = selection.merge({
	        anchorKey: blockBefore.getKey(),
	        anchorOffset: 0
	      });
	      var asCurrentStyle = DraftModifier.setBlockType(content, atomicBlockTarget, content.getBlockForKey(startKey).getType());
	      var withoutAtomicBlock = DraftModifier.removeRange(asCurrentStyle, atomicBlockTarget, 'backward');
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).takeWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of an empty styled block, allow
	   * certain key commands (newline, backspace) to simply change the
	   * style of the block instead of the default behavior.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	      if (block.getLength() > 0) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block') {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	
	var getContentStateFragment = __webpack_require__(198);
	var nullthrows = __webpack_require__(58);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ },
/* 936 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	var applyEntityToContentBlock = __webpack_require__(937);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * 
	 */
	
	'use strict';
	
	var DraftEntity = __webpack_require__(91);
	var DraftStringKey = __webpack_require__(431);
	
	var encodeEntityRanges = __webpack_require__(956);
	var encodeInlineStyleRanges = __webpack_require__(957);
	
	function convertFromDraftStateToRaw(contentState) {
	  var entityStorageKey = 0;
	  var entityStorageMap = {};
	  var rawBlocks = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(block.getEntityAt(start));
	      if (!entityStorageMap.hasOwnProperty(stringifiedEntityKey)) {
	        entityStorageMap[stringifiedEntityKey] = '' + entityStorageKey++;
	      }
	    });
	
	    rawBlocks.push({
	      key: blockKey,
	      text: block.getText(),
	      type: block.getType(),
	      depth: canHaveDepth(block) ? block.getDepth() : 0,
	      inlineStyleRanges: encodeInlineStyleRanges(block),
	      entityRanges: encodeEntityRanges(block, entityStorageMap)
	    });
	  });
	
	  // Flip storage map so that our storage keys map to global
	  // DraftEntity keys.
	  var entityKeys = Object.keys(entityStorageMap);
	  var flippedStorageMap = {};
	  entityKeys.forEach(function (key, jj) {
	    var entity = DraftEntity.get(DraftStringKey.unstringify(key));
	    flippedStorageMap[jj] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    entityMap: flippedStorageMap,
	    blocks: rawBlocks
	  };
	}
	
	function canHaveDepth(block) {
	  var type = block.getType();
	  return type === 'ordered-list-item' || type === 'unordered-list-item';
	}
	
	module.exports = convertFromDraftStateToRaw;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * 
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(121);
	var ContentState = __webpack_require__(272);
	var DraftEntity = __webpack_require__(91);
	
	var createCharacterList = __webpack_require__(941);
	var decodeEntityRanges = __webpack_require__(942);
	var decodeInlineStyleRanges = __webpack_require__(943);
	var generateRandomKey = __webpack_require__(83);
	
	function convertFromRawToDraftState(rawState) {
	  var blocks = rawState.blocks;
	  var entityMap = rawState.entityMap;
	
	  var fromStorageToLocal = {};
	  Object.keys(entityMap).forEach(function (storageKey) {
	    var encodedEntity = entityMap[storageKey];
	    var type = encodedEntity.type;
	    var mutability = encodedEntity.mutability;
	    var data = encodedEntity.data;
	
	    var newKey = DraftEntity.create(type, mutability, data || {});
	    fromStorageToLocal[storageKey] = newKey;
	  });
	
	  var contentBlocks = blocks.map(function (block) {
	    var key = block.key;
	    var type = block.type;
	    var text = block.text;
	    var depth = block.depth;
	    var inlineStyleRanges = block.inlineStyleRanges;
	    var entityRanges = block.entityRanges;
	
	    key = key || generateRandomKey();
	    depth = depth || 0;
	    inlineStyleRanges = inlineStyleRanges || [];
	    entityRanges = entityRanges || [];
	
	    var inlineStyles = decodeInlineStyleRanges(text, inlineStyleRanges);
	
	    // Translate entity range keys to the DraftEntity map.
	    var filteredEntityRanges = entityRanges.filter(function (range) {
	      return fromStorageToLocal.hasOwnProperty(range.key);
	    }).map(function (range) {
	      return _extends({}, range, { key: fromStorageToLocal[range.key] });
	    });
	
	    var entities = decodeEntityRanges(text, filteredEntityRanges);
	    var characterList = createCharacterList(inlineStyles, entities);
	
	    return new ContentBlock({ key: key, type: type, text: text, depth: depth, characterList: characterList });
	  });
	
	  return ContentState.createFromBlockArray(contentBlocks);
	}
	
	module.exports = convertFromRawToDraftState;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var Immutable = __webpack_require__(24);
	
	var List = Immutable.List;
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(122);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(122);
	
	var _require = __webpack_require__(24);
	
	var OrderedSet = _require.OrderedSet;
	var substr = UnicodeUtils.substr;
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * 
	 */
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	'use strict';
	
	var BlockTree = __webpack_require__(426);
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var UserAgent = __webpack_require__(84);
	
	var getEntityKeyForSelection = __webpack_require__(276);
	var isSelectionAtLeafStart = __webpack_require__(442);
	var nullthrows = __webpack_require__(58);
	
	var FF_QUICKFIND_CHAR = '\'';
	var FF_QUICKFIND_LINK_CHAR = '\/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(e) {
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (this.props.handleBeforeInput && this.props.handleBeforeInput(chars)) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	    this.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    return;
	  }
	
	  var mayAllowNative = !isSelectionAtLeafStart(editorState);
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  if (!mayAllowNative) {
	    e.preventDefault();
	    this.update(newEditorState);
	    return;
	  }
	
	  var anchorKey = selection.getAnchorKey();
	  var anchorTree = editorState.getBlockTree(anchorKey);
	
	  // Check the old and new "fingerprints" of the current block to determine
	  // whether this insertion requires any addition or removal of text nodes,
	  // in which case we would prevent the native character insertion.
	  var originalFingerprint = BlockTree.getFingerprint(anchorTree);
	  var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	
	  if (mustPreventDefaultForCharacter(chars) || originalFingerprint !== newFingerprint || nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey)) {
	    e.preventDefault();
	  } else {
	    // The native event is allowed to occur.
	    newEditorState = EditorState.set(newEditorState, {
	      nativelyRenderedContent: newEditorState.getCurrentContent()
	    });
	  }
	
	  this.update(newEditorState);
	}
	
	module.exports = editOnBeforeInput;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	var UserAgent = __webpack_require__(84);
	
	var getActiveElement = __webpack_require__(200);
	
	var isWebKit = UserAgent.isEngine('WebKit');
	
	function editOnBlur(e) {
	  // Webkit has a bug in which blurring a contenteditable by clicking on
	  // other active elements will trigger the `blur` event but will not remove
	  // the DOM selection from the contenteditable. We therefore force the
	  // issue to be certain, checking whether the active element is `body`
	  // to force it when blurring occurs within the window (as opposed to
	  // clicking to another tab or window).
	  if (isWebKit && getActiveElement() === document.body) {
	    global.getSelection().removeAllRanges();
	  }
	
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  this.props.onBlur && this.props.onBlur(e);
	  this.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart() {
	  this.setRenderGuard();
	  this.setMode('composite');
	  this.update(EditorState.set(this.props.editorState, { inCompositionMode: true }));
	}
	
	module.exports = editOnCompositionStart;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(435);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(e) {
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  this.setClipboard(getFragmentFromSelection(this.props.editorState));
	}
	
	module.exports = editOnCopy;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var Style = __webpack_require__(281);
	
	var getFragmentFromSelection = __webpack_require__(435);
	var getScrollPosition = __webpack_require__(284);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(e) {
	  var _this = this;
	
	  var editorState = this.props.editorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  var scrollParent = Style.getScrollParent(e.target);
	
	  var _getScrollPosition = getScrollPosition(scrollParent);
	
	  var x = _getScrollPosition.x;
	  var y = _getScrollPosition.y;
	
	  var fragment = getFragmentFromSelection(editorState);
	  this.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  this.setRenderGuard();
	  this.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    _this.restoreEditorDOM({ x: x, y: y });
	    _this.removeRenderGuard();
	    _this.exitCurrentMode();
	    _this.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ },
/* 949 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(e) {
	  this._internalDrag = false;
	  this.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ },
/* 950 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart() {
	  this._internalDrag = true;
	  this.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	function editOnFocus(e) {
	  var editorState = this.props.editorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  this.props.onFocus && this.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  this.update(EditorState.forceSelection(editorState, selection));
	}
	
	module.exports = editOnFocus;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var DraftOffsetKey = __webpack_require__(196);
	var EditorState = __webpack_require__(21);
	var Entity = __webpack_require__(91);
	var UserAgent = __webpack_require__(84);
	
	var findAncestorOffsetKey = __webpack_require__(275);
	var nullthrows = __webpack_require__(58);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput() {
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode;
	  var isCollapsed = domSelection.isCollapsed;
	
	  if (anchorNode.nodeType !== Node.TEXT_NODE) {
	    return;
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = this.props.editorState;
	
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decode = DraftOffsetKey.decode(offsetKey);
	
	  var blockKey = _DraftOffsetKey$decode.blockKey;
	  var decoratorKey = _DraftOffsetKey$decode.decoratorKey;
	  var leafKey = _DraftOffsetKey$decode.leafKey;
	
	  var _editorState$getBlockTree$getIn = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
	
	  var start = _editorState$getBlockTree$getIn.start;
	  var end = _editorState$getBlockTree$getIn.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && Entity.get(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  this.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	var KeyBindingUtil = __webpack_require__(274);
	var Keys = __webpack_require__(280);
	var SecondaryClipboard = __webpack_require__(935);
	var UserAgent = __webpack_require__(84);
	
	var keyCommandBackspaceToStartOfLine = __webpack_require__(966);
	var keyCommandBackspaceWord = __webpack_require__(967);
	var keyCommandDeleteWord = __webpack_require__(968);
	var keyCommandInsertNewline = __webpack_require__(969);
	var keyCommandPlainBackspace = __webpack_require__(972);
	var keyCommandPlainDelete = __webpack_require__(973);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(970);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(971);
	var keyCommandTransposeCharacters = __webpack_require__(974);
	var keyCommandUndo = __webpack_require__(975);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(e) {
	  var keyCode = e.which;
	  var editorState = this.props.editorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (this.props.handleReturn && this.props.handleReturn(e)) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      this.props.onEscape && this.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      this.props.onTab && this.props.onTab(e);
	      return;
	    case Keys.UP:
	      this.props.onUpArrow && this.props.onUpArrow(e);
	      return;
	    case Keys.DOWN:
	      this.props.onDownArrow && this.props.onDownArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), ' ');
	        this.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = this.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, this.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (this.props.handleKeyCommand && this.props.handleKeyCommand(command)) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    this.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * 
	 */
	
	/**
	 * Paste content.
	 */
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(156);
	var CharacterMetadata = __webpack_require__(71);
	var DataTransfer = __webpack_require__(453);
	var DraftModifier = __webpack_require__(45);
	var DraftPasteProcessor = __webpack_require__(932);
	var EditorState = __webpack_require__(21);
	
	var getEntityKeyForSelection = __webpack_require__(276);
	var getTextContentFromFiles = __webpack_require__(439);
	var splitTextIntoTextBlocks = __webpack_require__(980);
	
	function editOnPaste(e) {
	  var _this = this;
	
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (this.props.handlePastedFiles && this.props.handlePastedFiles(files)) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = _this.props.editorState;
	
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	
	        var text = DraftPasteProcessor.processText(blocks, character);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        _this.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	
	  if (this.props.handlePastedText && this.props.handlePastedText(text, html)) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!this.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = this.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(this.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        this.update(insertFragment(this.props.editorState, internalClipboard));
	        return;
	      }
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, this.props.blockRenderMap);
	      if (htmlFragment) {
	        var htmlMap = BlockMapBuilder.createFromArray(htmlFragment);
	        this.update(insertFragment(this.props.editorState, htmlMap));
	        return;
	      }
	    }
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    this.setClipboard(null);
	  }
	
	  if (textBlocks) {
	    var editorState = this.props.editorState;
	
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    this.update(insertFragment(this.props.editorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  return EditorState.push(editorState, newContent, 'insert-fragment');
	}
	
	module.exports = editOnPaste;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	var ReactDOM = __webpack_require__(39);
	
	var getDraftEditorSelection = __webpack_require__(960);
	
	function editOnSelect() {
	  if (this._blockSelectEvents) {
	    return;
	  }
	
	  var editorState = this.props.editorState;
	  var documentSelection = getDraftEditorSelection(editorState, ReactDOM.findDOMNode(this.refs.editorContainer).firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    this.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(431);
	var UnicodeUtils = __webpack_require__(122);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(122);
	
	var findRangesImmutable = __webpack_require__(197);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(122);
	
	var getRangeClientRects = __webpack_require__(436);
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  // forced layout here
	  document.body.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  document.body.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : undefined;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : undefined;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @typechecks
	 * 
	 */
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	'use strict';
	
	var DraftEntity = __webpack_require__(91);
	var DraftEntitySegments = __webpack_require__(931);
	
	var getRangesForDraftEntity = __webpack_require__(962);
	var invariant = __webpack_require__(7);
	
	function getCharacterRemovalRange(block, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entityKey = block.getEntityAt(start);
	  if (!entityKey) {
	    return selectionState;
	  }
	
	  var entity = DraftEntity.get(entityKey);
	  var mutability = entity.getMutability();
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return start < range.end && end > range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : undefined;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(434);
	
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var getRangeClientRects = __webpack_require__(436);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    var _rects$0 = rects[0];
	    top = _rects$0.top;
	    right = _rects$0.right;
	    bottom = _rects$0.bottom;
	    left = _rects$0.left;
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 || rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @typechecks
	 * 
	 */
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : undefined;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @typechecks
	 * 
	 */
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(961);
	
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top;
	  var right = boundingRect.right;
	  var bottom = boundingRect.bottom;
	  var left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(156);
	
	var generateRandomKey = __webpack_require__(83);
	var insertIntoList = __webpack_require__(441);
	var invariant = __webpack_require__(7);
	
	function insertFragmentIntoContentState(contentState, selectionState, fragment) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : undefined;
	
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var blockMap = contentState.getBlockMap();
	
	  var fragmentSize = fragment.size;
	  var finalKey;
	  var finalOffset;
	
	  if (fragmentSize === 1) {
	    var targetBlock = blockMap.get(targetKey);
	    var pastedBlock = fragment.first();
	    var text = targetBlock.getText();
	    var chars = targetBlock.getCharacterList();
	
	    var newBlock = targetBlock.merge({
	      text: text.slice(0, targetOffset) + pastedBlock.getText() + text.slice(targetOffset),
	      characterList: insertIntoList(chars, pastedBlock.getCharacterList(), targetOffset)
	    });
	
	    blockMap = blockMap.set(targetKey, newBlock);
	
	    finalKey = targetKey;
	    finalOffset = targetOffset + pastedBlock.getText().length;
	
	    return contentState.merge({
	      blockMap: blockMap.set(targetKey, newBlock),
	      selectionBefore: selectionState,
	      selectionAfter: selectionState.merge({
	        anchorKey: finalKey,
	        anchorOffset: finalOffset,
	        focusKey: finalKey,
	        focusOffset: finalOffset,
	        isBackward: false
	      })
	    });
	  }
	
	  var newBlockArr = [];
	
	  contentState.getBlockMap().forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    // Modify head portion of block.
	    var blockSize = text.length;
	    var headText = text.slice(0, targetOffset);
	    var headCharacters = chars.slice(0, targetOffset);
	    var appendToHead = fragment.first();
	
	    var modifiedHead = block.merge({
	      text: headText + appendToHead.getText(),
	      characterList: headCharacters.concat(appendToHead.getCharacterList())
	    });
	
	    newBlockArr.push(modifiedHead);
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment.slice(1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      newBlockArr.push(fragmentBlock.set('key', generateRandomKey()));
	    });
	
	    // Modify tail portion of block.
	    var tailText = text.slice(targetOffset, blockSize);
	    var tailCharacters = chars.slice(targetOffset, blockSize);
	    var prependToTail = fragment.last();
	    finalKey = generateRandomKey();
	
	    var modifiedTail = prependToTail.merge({
	      key: finalKey,
	      text: prependToTail.getText() + tailText,
	      characterList: prependToTail.getCharacterList().concat(tailCharacters)
	    });
	
	    newBlockArr.push(modifiedTail);
	  });
	
	  finalOffset = fragment.last().getLength();
	
	  return contentState.merge({
	    blockMap: BlockMapBuilder.createFromArray(newBlockArr),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = insertFragmentIntoContentState;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	var insertIntoList = __webpack_require__(441);
	var invariant = __webpack_require__(7);
	
	var Repeat = Immutable.Repeat;
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : undefined;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	var expandRangeToStartOfLine = __webpack_require__(958);
	var getDraftEditorSelectionWithNodes = __webpack_require__(434);
	var moveSelectionBackward = __webpack_require__(277);
	var removeTextWithStrategy = __webpack_require__(157);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(430);
	var EditorState = __webpack_require__(21);
	
	var moveSelectionBackward = __webpack_require__(277);
	var removeTextWithStrategy = __webpack_require__(157);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(430);
	var EditorState = __webpack_require__(21);
	
	var moveSelectionForward = __webpack_require__(443);
	var removeTextWithStrategy = __webpack_require__(157);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	var UnicodeUtils = __webpack_require__(122);
	
	var moveSelectionBackward = __webpack_require__(277);
	var removeTextWithStrategy = __webpack_require__(157);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	var UnicodeUtils = __webpack_require__(122);
	
	var moveSelectionForward = __webpack_require__(443);
	var removeTextWithStrategy = __webpack_require__(157);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(45);
	var EditorState = __webpack_require__(21);
	
	var getContentStateFragment = __webpack_require__(198);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(21);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	  var characterList;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Immutable.Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  blockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	}
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = removeRangeFromContentState;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setBlockTypeForContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(24);
	
	function setBlockTypeForContentState(contentState, selectionState, blockType) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Immutable.Map([[endKey, blockMap.get(endKey)]])).map(function (block) {
	    return block.merge({ type: blockType, depth: 0 });
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = setBlockTypeForContentState;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @typechecks
	 * 
	 */
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	'use strict';
	
	var containsNode = __webpack_require__(283);
	var getActiveElement = __webpack_require__(200);
	
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart);
	    addFocusToSelection(selection, node, focusOffset - nodeStart);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset) {
	  if (selection.extend && containsNode(getActiveElement(), node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	    selection.extend(node, offset);
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset) {
	  var range = document.createRange();
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var generateRandomKey = __webpack_require__(83);
	var invariant = __webpack_require__(7);
	
	function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : undefined;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	
	  var keyBelow = generateRandomKey();
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset)
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[blockAbove.getKey(), blockAbove], [blockBelow.getKey(), blockBelow]], blocksAfter).toOrderedMap();
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	}
	
	module.exports = splitBlockInContentState;

/***/ },
/* 980 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.2.1
	 */
	
	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }
	
	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }
	
	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }
	
	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }
	
	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;
	
	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }
	
	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }
	
	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }
	
	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';
	
	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // see https://github.com/cujojs/when/issues/410 for details
	      return function() {
	        process.nextTick(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });
	
	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }
	
	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }
	
	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }
	
	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];
	
	        callback(arg);
	
	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }
	
	      lib$es6$promise$asap$$len = 0;
	    }
	
	    function lib$es6$promise$asap$$attemptVertx() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(1392);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }
	
	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	    function lib$es6$promise$then$$then(onFulfillment, onRejection) {
	      var parent = this;
	
	      var child = new this.constructor(lib$es6$promise$$internal$$noop);
	
	      if (child[lib$es6$promise$$internal$$PROMISE_ID] === undefined) {
	        lib$es6$promise$$internal$$makePromise(child);
	      }
	
	      var state = parent._state;
	
	      if (state) {
	        var callback = arguments[state - 1];
	        lib$es6$promise$asap$$asap(function(){
	          lib$es6$promise$$internal$$invokeCallback(state, child, callback, parent._result);
	        });
	      } else {
	        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	      }
	
	      return child;
	    }
	    var lib$es6$promise$then$$default = lib$es6$promise$then$$then;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	    var lib$es6$promise$$internal$$PROMISE_ID = Math.random().toString(36).substring(16);
	
	    function lib$es6$promise$$internal$$noop() {}
	
	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;
	
	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$selfFulfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }
	
	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }
	
	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;
	
	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }
	
	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable, then) {
	      if (maybeThenable.constructor === promise.constructor &&
	          then === lib$es6$promise$then$$default &&
	          constructor.resolve === lib$es6$promise$promise$resolve$$default) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }
	
	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value, lib$es6$promise$$internal$$getThen(value));
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }
	
	      lib$es6$promise$$internal$$publish(promise);
	    }
	
	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	
	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }
	
	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;
	
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }
	
	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;
	
	      parent._onerror = null;
	
	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;
	
	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;
	
	      if (subscribers.length === 0) { return; }
	
	      var child, callback, detail = promise._result;
	
	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];
	
	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }
	
	      promise._subscribers.length = 0;
	    }
	
	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }
	
	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;
	
	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }
	
	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }
	
	      } else {
	        value = detail;
	        succeeded = true;
	      }
	
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }
	
	    var lib$es6$promise$$internal$$id = 0;
	    function lib$es6$promise$$internal$$nextId() {
	      return lib$es6$promise$$internal$$id++;
	    }
	
	    function lib$es6$promise$$internal$$makePromise(promise) {
	      promise[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$id++;
	      promise._state = undefined;
	      promise._result = undefined;
	      promise._subscribers = [];
	    }
	
	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        return new Constructor(function(resolve, reject) {
	          reject(new TypeError('You must pass an array to race.'));
	        });
	      } else {
	        return new Constructor(function(resolve, reject) {
	          var length = entries.length;
	          for (var i = 0; i < length; i++) {
	            Constructor.resolve(entries[i]).then(resolve, reject);
	          }
	        });
	      }
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	
	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }
	
	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }
	
	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.
	
	      Terminology
	      -----------
	
	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.
	
	      A promise can be in one of three states: pending, fulfilled, or rejected.
	
	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.
	
	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.
	
	
	      Basic Usage:
	      ------------
	
	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);
	
	        // on failure
	        reject(reason);
	      });
	
	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Advanced Usage:
	      ---------------
	
	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.
	
	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();
	
	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }
	
	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Unlike callbacks, promises are great composable primitives.
	
	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON
	
	        return values;
	      });
	      ```
	
	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$nextId();
	      this._result = this._state = undefined;
	      this._subscribers = [];
	
	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        typeof resolver !== 'function' && lib$es6$promise$promise$$needsResolver();
	        this instanceof lib$es6$promise$promise$$Promise ? lib$es6$promise$$internal$$initializePromise(this, resolver) : lib$es6$promise$promise$$needsNew();
	      }
	    }
	
	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	
	      Chaining
	      --------
	
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	
	      Assimilation
	      ------------
	
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	
	      If the assimliated promise rejects, then the downstream promise will also reject.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	
	      Simple Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var result;
	
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	
	      Advanced Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var author, books;
	
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	
	      function foundBooks(books) {
	
	      }
	
	      function failure(reason) {
	
	      }
	
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: lib$es6$promise$then$$default,
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	
	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      this._instanceConstructor = Constructor;
	      this.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (!this.promise[lib$es6$promise$$internal$$PROMISE_ID]) {
	        lib$es6$promise$$internal$$makePromise(this.promise);
	      }
	
	      if (lib$es6$promise$utils$$isArray(input)) {
	        this._input     = input;
	        this.length     = input.length;
	        this._remaining = input.length;
	
	        this._result = new Array(this.length);
	
	        if (this.length === 0) {
	          lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	        } else {
	          this.length = this.length || 0;
	          this._enumerate();
	          if (this._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(this.promise, lib$es6$promise$enumerator$$validationError());
	      }
	    }
	
	    function lib$es6$promise$enumerator$$validationError() {
	      return new Error('Array Methods must be provided an Array');
	    }
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var length  = this.length;
	      var input   = this._input;
	
	      for (var i = 0; this._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        this._eachEntry(input[i], i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var c = this._instanceConstructor;
	      var resolve = c.resolve;
	
	      if (resolve === lib$es6$promise$promise$resolve$$default) {
	        var then = lib$es6$promise$$internal$$getThen(entry);
	
	        if (then === lib$es6$promise$then$$default &&
	            entry._state !== lib$es6$promise$$internal$$PENDING) {
	          this._settledAt(entry._state, i, entry._result);
	        } else if (typeof then !== 'function') {
	          this._remaining--;
	          this._result[i] = entry;
	        } else if (c === lib$es6$promise$promise$$default) {
	          var promise = new c(lib$es6$promise$$internal$$noop);
	          lib$es6$promise$$internal$$handleMaybeThenable(promise, entry, then);
	          this._willSettleAt(promise, i);
	        } else {
	          this._willSettleAt(new c(function(resolve) { resolve(entry); }), i);
	        }
	      } else {
	        this._willSettleAt(resolve(entry), i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var promise = this.promise;
	
	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        this._remaining--;
	
	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          this._result[i] = value;
	        }
	      }
	
	      if (this._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, this._result);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;
	
	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;
	
	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }
	
	      var P = local.Promise;
	
	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }
	
	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(1390)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }
	
	    lib$es6$promise$polyfill$$default();
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161), (function() { return this; }()), __webpack_require__(569)(module)))

/***/ },
/* 982 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 983 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 984 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 985 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 986 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 987 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 988 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 989 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 990 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 991 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 992 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 993 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 994 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 995 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 996 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 997 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 998 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 999 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1000 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1001 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1002 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1003 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1004 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1005 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1006 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1007 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1008 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1009 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1010 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1011 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1012 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1013 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1014 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1015 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1016 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1017 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1018 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1019 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1020 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1021 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1022 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1023 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1024 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1025 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1026 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1027 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1028 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1029 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1030 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1031 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1032 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1033 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1034 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1035 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1036 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1037 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1038 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1039 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1040 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1041 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1042 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1043 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1044 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1045 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1046 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1047 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1048 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1049 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1050 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1051 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1052 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1053 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ },
/* 1054 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '・、。〈-】〔-〟：-？！-／' + '［-｀｛-･⸮؟٪-٬؛،؍' + '﴾﴿᠁।၊။‐-‧‰-⁞' + '¡-±´-¸º»¿]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ },
/* 1055 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(456);
	var UnicodeBidiDirection = __webpack_require__(282);
	
	var invariant = __webpack_require__(7);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(1387);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0];
	    var endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range);
	
	  var modifier = _getModifierAndCompon.modifier;
	  var rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b);
	
	  var aNormalized = _normalizeVersions[0];
	  var bNormalized = _normalizeVersions[1];
	
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(457);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var createArrayFromMixed = __webpack_require__(458);
	var getMarkupWrap = __webpack_require__(460);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1061 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(1063);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(283);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = document.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(457);
	var hyphenate = __webpack_require__(462);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ },
/* 1065 */
/***/ function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   * All rights reserved.
	   *
	   * This source code is licensed under the BSD-style license found in the
	   * LICENSE file in the root directory of this source tree. An additional grant
	   * of patent rights can be found in the PATENTS file in the same directory.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(462);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1067 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1067);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1069 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ },
/* 1070 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(139);
	
	var _PathUtils = __webpack_require__(123);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(75);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(123);
	
	var _Actions = __webpack_require__(139);
	
	var _createHistory = __webpack_require__(468);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-extra.png",
	  width: 378,
	  height: 264,
	  bytes: 1873,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-extra.png";
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "device_d.png",
	  width: 388,
	  height: 224,
	  bytes: 737,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "device_d.png";
	};

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "device_ml.png",
	  width: 164,
	  height: 80,
	  bytes: 351,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "device_ml.png";
	};

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "device_mp.png",
	  width: 80,
	  height: 164,
	  bytes: 311,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "device_mp.png";
	};

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "device_tl.png",
	  width: 204,
	  height: 144,
	  bytes: 424,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "device_tl.png";
	};

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "device_tp.png",
	  width: 144,
	  height: 204,
	  bytes: 425,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "device_tp.png";
	};

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "paypal.png",
	  width: 49,
	  height: 14,
	  bytes: 1570,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "paypal.png";
	};

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "graph-dots.png",
	  width: 2,
	  height: 2,
	  bytes: 76,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "graph-dots.png";
	};

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "graph-text-dots.png",
	  width: 2,
	  height: 2,
	  bytes: 76,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "graph-text-dots.png";
	};

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "fwa-logo.png",
	  width: 134,
	  height: 40,
	  bytes: 1584,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "fwa-logo.png";
	};

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "rackfish.png",
	  width: 74,
	  height: 20,
	  bytes: 838,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "rackfish.png";
	};

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "drop-remove.png",
	  width: 10,
	  height: 10,
	  bytes: 164,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "drop-remove.png";
	};

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "drop-upload.png",
	  width: 36,
	  height: 23,
	  bytes: 201,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "drop-upload.png";
	};

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-bold.png",
	  width: 29,
	  height: 29,
	  bytes: 155,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-bold.png";
	};

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-italic.png",
	  width: 29,
	  height: 29,
	  bytes: 129,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-italic.png";
	};

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-link.png",
	  width: 29,
	  height: 29,
	  bytes: 156,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-link.png";
	};

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-list.png",
	  width: 29,
	  height: 29,
	  bytes: 105,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-list.png";
	};

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-underline.png",
	  width: 29,
	  height: 29,
	  bytes: 136,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-underline.png";
	};

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "icon-unlink.png",
	  width: 29,
	  height: 29,
	  bytes: 168,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "icon-unlink.png";
	};

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "button-hover-white.png",
	  width: 600,
	  height: 33,
	  bytes: 5119,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "button-hover-white.png";
	};

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "button-hover.png",
	  width: 600,
	  height: 33,
	  bytes: 3836,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "button-hover.png";
	};

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-1.png",
	  width: 487,
	  height: 311,
	  bytes: 122233,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-1.png";
	};

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-2.png",
	  width: 487,
	  height: 311,
	  bytes: 237230,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-2.png";
	};

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-3.png",
	  width: 487,
	  height: 311,
	  bytes: 225712,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-3.png";
	};

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-4.png",
	  width: 487,
	  height: 311,
	  bytes: 199154,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-4.png";
	};

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "adobe-micro.png",
	  width: 11,
	  height: 14,
	  bytes: 293,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "adobe-micro.png";
	};

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-1.png",
	  width: 487,
	  height: 311,
	  bytes: 122233,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-1.png";
	};

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-2.png",
	  width: 487,
	  height: 311,
	  bytes: 237230,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-2.png";
	};

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-3.png",
	  width: 487,
	  height: 311,
	  bytes: 225712,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-3.png";
	};

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "case-4.png",
	  width: 487,
	  height: 311,
	  bytes: 199154,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "case-4.png";
	};

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "vimeo-logo.png",
	  width: 112,
	  height: 32,
	  bytes: 1340,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "vimeo-logo.png";
	};

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "youtube-logo.png",
	  width: 112,
	  height: 47,
	  bytes: 1333,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "youtube-logo.png";
	};

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step1.png",
	  width: 368,
	  height: 296,
	  bytes: 2527,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step1.png";
	};

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step2.png",
	  width: 260,
	  height: 240,
	  bytes: 3665,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step2.png";
	};

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step3.png",
	  width: 290,
	  height: 170,
	  bytes: 2422,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step3.png";
	};

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step4.png",
	  width: 368,
	  height: 296,
	  bytes: 3241,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step4.png";
	};

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step5.png",
	  width: 230,
	  height: 192,
	  bytes: 2068,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step5.png";
	};

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "step6.png",
	  width: 202,
	  height: 220,
	  bytes: 2142,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "step6.png";
	};

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "fwa-logo.png",
	  width: 134,
	  height: 40,
	  bytes: 1584,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "fwa-logo.png";
	};

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "graph-text-dots.png",
	  width: 2,
	  height: 2,
	  bytes: 76,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "graph-text-dots.png";
	};

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "logo-placeholder.png",
	  width: 187,
	  height: 20,
	  bytes: 1274,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "logo-placeholder.png";
	};

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "top-placeholder.png",
	  width: 1364,
	  height: 620,
	  bytes: 1317180,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "top-placeholder.png";
	};

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "profile-placeholder.png",
	  width: 97,
	  height: 64,
	  bytes: 514,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "profile-placeholder.png";
	};

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  src: __webpack_require__.p + "tceay-sponsor.png",
	  width: 60,
	  height: 43,
	  bytes: 2757,
	  type: "png",
	};
	module.exports.toString = function() {
	  return __webpack_require__.p + "tceay-sponsor.png";
	};

/***/ },
/* 1117 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140),
	    root = __webpack_require__(103);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1162),
	    hashDelete = __webpack_require__(1163),
	    hashGet = __webpack_require__(1164),
	    hashHas = __webpack_require__(1165),
	    hashSet = __webpack_require__(1166);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140),
	    root = __webpack_require__(103);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140),
	    root = __webpack_require__(103);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(103);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(140),
	    root = __webpack_require__(103);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1124 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1125 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(294);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to search.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 1127 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to search.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 1128 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1129 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(483),
	    arrayIncludes = __webpack_require__(1126),
	    arrayIncludesWith = __webpack_require__(1127),
	    arrayMap = __webpack_require__(292),
	    baseUnary = __webpack_require__(1147),
	    cacheHas = __webpack_require__(1148);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1128),
	    isFlattenable = __webpack_require__(1169);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1154);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1132),
	    keys = __webpack_require__(302);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1134 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(484),
	    equalArrays = __webpack_require__(493),
	    equalByTag = __webpack_require__(1155),
	    equalObjects = __webpack_require__(1156),
	    getTag = __webpack_require__(1159),
	    isArray = __webpack_require__(72),
	    isHostObject = __webpack_require__(297),
	    isTypedArray = __webpack_require__(1199);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(484),
	    baseIsEqual = __webpack_require__(489);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(300),
	    isHostObject = __webpack_require__(297),
	    isMasked = __webpack_require__(1171),
	    isObject = __webpack_require__(104),
	    toSource = __webpack_require__(500);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1138 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(293),
	    isArrayLike = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1136),
	    getMatchData = __webpack_require__(1158),
	    matchesStrictComparable = __webpack_require__(497);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(489),
	    get = __webpack_require__(1195),
	    hasIn = __webpack_require__(1196),
	    isKey = __webpack_require__(207),
	    isStrictComparable = __webpack_require__(496),
	    matchesStrictComparable = __webpack_require__(497),
	    toKey = __webpack_require__(159);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(486);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return arrayReduce(props, function(result, key) {
	    if (key in object) {
	      result[key] = object[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = basePick;


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(487);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1144 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 1145 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1146 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1147 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1148 */
/***/ function(module, exports) {

	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(294);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(294);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ },
/* 1151 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(103);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(209);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1154 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(485),
	    Uint8Array = __webpack_require__(1122),
	    equalArrays = __webpack_require__(493),
	    mapToArray = __webpack_require__(1183),
	    setToArray = __webpack_require__(1186);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(488),
	    keys = __webpack_require__(302);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(490);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(496),
	    keys = __webpack_require__(302);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1118),
	    Map = __webpack_require__(482),
	    Promise = __webpack_require__(1120),
	    Set = __webpack_require__(1121),
	    WeakMap = __webpack_require__(1123),
	    toSource = __webpack_require__(500);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1160 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(491),
	    isArguments = __webpack_require__(299),
	    isArray = __webpack_require__(72),
	    isIndex = __webpack_require__(495),
	    isKey = __webpack_require__(207),
	    isLength = __webpack_require__(210),
	    isString = __webpack_require__(502),
	    toKey = __webpack_require__(159);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isString(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(208);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 1163 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(208);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(208);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(208);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1146),
	    isArguments = __webpack_require__(299),
	    isArray = __webpack_require__(72),
	    isLength = __webpack_require__(210),
	    isString = __webpack_require__(502);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 1168 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(299),
	    isArray = __webpack_require__(72);
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1170 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1152);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1172 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1173 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(205);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(205);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(205);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(205);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1119),
	    ListCache = __webpack_require__(204),
	    Map = __webpack_require__(482);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(206);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(206);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(206);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(206);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1183 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1184 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1185 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1186 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(204);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 1188 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 1189 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1190 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(204),
	    MapCache = __webpack_require__(291);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	var reHasComplexSymbol = __webpack_require__(498);
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  if (!(string && reHasComplexSymbol.test(string))) {
	    return string.length;
	  }
	  var result = reComplexSymbol.lastIndex = 0;
	  while (reComplexSymbol.test(string)) {
	    result++;
	  }
	  return result;
	}
	
	module.exports = stringSize;


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1201),
	    toString = __webpack_require__(303);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1194 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(487);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1134),
	    hasPath = __webpack_require__(1161);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1197 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	function isRegExp(value) {
	  return isObject(value) && objectToString.call(value) == regexpTag;
	}
	
	module.exports = isRegExp;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(210),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(292),
	    baseIteratee = __webpack_require__(295),
	    baseMap = __webpack_require__(1139),
	    isArray = __webpack_require__(72);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|Object|string} [iteratee=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(291);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1202 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	function now() {
	  return Date.now();
	}
	
	module.exports = now;


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(292),
	    baseFlatten = __webpack_require__(1131),
	    basePick = __webpack_require__(1142),
	    rest = __webpack_require__(503),
	    toKey = __webpack_require__(159);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = rest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(490),
	    basePropertyDeep = __webpack_require__(1143),
	    isKey = __webpack_require__(207),
	    toKey = __webpack_require__(159);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(486),
	    baseEach = __webpack_require__(293),
	    baseIteratee = __webpack_require__(295),
	    baseReduce = __webpack_require__(1144),
	    isArray = __webpack_require__(72);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(505);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(296),
	    castSlice = __webpack_require__(492),
	    charsEndIndex = __webpack_require__(1149),
	    charsStartIndex = __webpack_require__(1150),
	    stringToArray = __webpack_require__(499),
	    toString = __webpack_require__(303);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(296),
	    castSlice = __webpack_require__(492),
	    isObject = __webpack_require__(104),
	    isRegExp = __webpack_require__(1198),
	    reHasComplexSymbol = __webpack_require__(498),
	    stringSize = __webpack_require__(1192),
	    stringToArray = __webpack_require__(499),
	    toInteger = __webpack_require__(504),
	    toString = __webpack_require__(303);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options={}] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? baseToString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (reHasComplexSymbol.test(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? castSlice(strSymbols, 0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(baseToString(separator), end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1130),
	    isArrayLikeObject = __webpack_require__(501),
	    rest = __webpack_require__(503);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = rest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	// Released under MIT license
	// Copyright (c) 2009-2010 Dominic Baggott
	// Copyright (c) 2009-2010 Ash Berlin
	// Copyright (c) 2011 Christoph Dorn <christoph@christophdorn.com> (http://www.christophdorn.com)
	
	/*jshint browser:true, devel:true */
	
	(function( expose ) {
	
	/**
	 *  class Markdown
	 *
	 *  Markdown processing in Javascript done right. We have very particular views
	 *  on what constitutes 'right' which include:
	 *
	 *  - produces well-formed HTML (this means that em and strong nesting is
	 *    important)
	 *
	 *  - has an intermediate representation to allow processing of parsed data (We
	 *    in fact have two, both as [JsonML]: a markdown tree and an HTML tree).
	 *
	 *  - is easily extensible to add new dialects without having to rewrite the
	 *    entire parsing mechanics
	 *
	 *  - has a good test suite
	 *
	 *  This implementation fulfills all of these (except that the test suite could
	 *  do with expanding to automatically run all the fixtures from other Markdown
	 *  implementations.)
	 *
	 *  ##### Intermediate Representation
	 *
	 *  *TODO* Talk about this :) Its JsonML, but document the node names we use.
	 *
	 *  [JsonML]: http://jsonml.org/ "JSON Markup Language"
	 **/
	var Markdown = expose.Markdown = function(dialect) {
	  switch (typeof dialect) {
	    case "undefined":
	      this.dialect = Markdown.dialects.Gruber;
	      break;
	    case "object":
	      this.dialect = dialect;
	      break;
	    default:
	      if ( dialect in Markdown.dialects ) {
	        this.dialect = Markdown.dialects[dialect];
	      }
	      else {
	        throw new Error("Unknown Markdown dialect '" + String(dialect) + "'");
	      }
	      break;
	  }
	  this.em_state = [];
	  this.strong_state = [];
	  this.debug_indent = "";
	};
	
	/**
	 *  parse( markdown, [dialect] ) -> JsonML
	 *  - markdown (String): markdown string to parse
	 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
	 *
	 *  Parse `markdown` and return a markdown document as a Markdown.JsonML tree.
	 **/
	expose.parse = function( source, dialect ) {
	  // dialect will default if undefined
	  var md = new Markdown( dialect );
	  return md.toTree( source );
	};
	
	/**
	 *  toHTML( markdown, [dialect]  ) -> String
	 *  toHTML( md_tree ) -> String
	 *  - markdown (String): markdown string to parse
	 *  - md_tree (Markdown.JsonML): parsed markdown tree
	 *
	 *  Take markdown (either as a string or as a JsonML tree) and run it through
	 *  [[toHTMLTree]] then turn it into a well-formated HTML fragment.
	 **/
	expose.toHTML = function toHTML( source , dialect , options ) {
	  var input = expose.toHTMLTree( source , dialect , options );
	
	  return expose.renderJsonML( input );
	};
	
	/**
	 *  toHTMLTree( markdown, [dialect] ) -> JsonML
	 *  toHTMLTree( md_tree ) -> JsonML
	 *  - markdown (String): markdown string to parse
	 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
	 *  - md_tree (Markdown.JsonML): parsed markdown tree
	 *
	 *  Turn markdown into HTML, represented as a JsonML tree. If a string is given
	 *  to this function, it is first parsed into a markdown tree by calling
	 *  [[parse]].
	 **/
	expose.toHTMLTree = function toHTMLTree( input, dialect , options ) {
	  // convert string input to an MD tree
	  if ( typeof input ==="string" ) input = this.parse( input, dialect );
	
	  // Now convert the MD tree to an HTML tree
	
	  // remove references from the tree
	  var attrs = extract_attr( input ),
	      refs = {};
	
	  if ( attrs && attrs.references ) {
	    refs = attrs.references;
	  }
	
	  var html = convert_tree_to_html( input, refs , options );
	  merge_text_nodes( html );
	  return html;
	};
	
	// For Spidermonkey based engines
	function mk_block_toSource() {
	  return "Markdown.mk_block( " +
	          uneval(this.toString()) +
	          ", " +
	          uneval(this.trailing) +
	          ", " +
	          uneval(this.lineNumber) +
	          " )";
	}
	
	// node
	function mk_block_inspect() {
	  var util = __webpack_require__(1389);
	  return "Markdown.mk_block( " +
	          util.inspect(this.toString()) +
	          ", " +
	          util.inspect(this.trailing) +
	          ", " +
	          util.inspect(this.lineNumber) +
	          " )";
	
	}
	
	var mk_block = Markdown.mk_block = function(block, trail, line) {
	  // Be helpful for default case in tests.
	  if ( arguments.length == 1 ) trail = "\n\n";
	
	  var s = new String(block);
	  s.trailing = trail;
	  // To make it clear its not just a string
	  s.inspect = mk_block_inspect;
	  s.toSource = mk_block_toSource;
	
	  if ( line != undefined )
	    s.lineNumber = line;
	
	  return s;
	};
	
	function count_lines( str ) {
	  var n = 0, i = -1;
	  while ( ( i = str.indexOf("\n", i + 1) ) !== -1 ) n++;
	  return n;
	}
	
	// Internal - split source into rough blocks
	Markdown.prototype.split_blocks = function splitBlocks( input, startLine ) {
	  input = input.replace(/(\r\n|\n|\r)/g, "\n");
	  // [\s\S] matches _anything_ (newline or space)
	  // [^] is equivalent but doesn't work in IEs.
	  var re = /([\s\S]+?)($|\n#|\n(?:\s*\n|$)+)/g,
	      blocks = [],
	      m;
	
	  var line_no = 1;
	
	  if ( ( m = /^(\s*\n)/.exec(input) ) != null ) {
	    // skip (but count) leading blank lines
	    line_no += count_lines( m[0] );
	    re.lastIndex = m[0].length;
	  }
	
	  while ( ( m = re.exec(input) ) !== null ) {
	    if (m[2] == "\n#") {
	      m[2] = "\n";
	      re.lastIndex--;
	    }
	    blocks.push( mk_block( m[1], m[2], line_no ) );
	    line_no += count_lines( m[0] );
	  }
	
	  return blocks;
	};
	
	/**
	 *  Markdown#processBlock( block, next ) -> undefined | [ JsonML, ... ]
	 *  - block (String): the block to process
	 *  - next (Array): the following blocks
	 *
	 * Process `block` and return an array of JsonML nodes representing `block`.
	 *
	 * It does this by asking each block level function in the dialect to process
	 * the block until one can. Succesful handling is indicated by returning an
	 * array (with zero or more JsonML nodes), failure by a false value.
	 *
	 * Blocks handlers are responsible for calling [[Markdown#processInline]]
	 * themselves as appropriate.
	 *
	 * If the blocks were split incorrectly or adjacent blocks need collapsing you
	 * can adjust `next` in place using shift/splice etc.
	 *
	 * If any of this default behaviour is not right for the dialect, you can
	 * define a `__call__` method on the dialect that will get invoked to handle
	 * the block processing.
	 */
	Markdown.prototype.processBlock = function processBlock( block, next ) {
	  var cbs = this.dialect.block,
	      ord = cbs.__order__;
	
	  if ( "__call__" in cbs ) {
	    return cbs.__call__.call(this, block, next);
	  }
	
	  for ( var i = 0; i < ord.length; i++ ) {
	    //D:this.debug( "Testing", ord[i] );
	    var res = cbs[ ord[i] ].call( this, block, next );
	    if ( res ) {
	      //D:this.debug("  matched");
	      if ( !isArray(res) || ( res.length > 0 && !( isArray(res[0]) ) ) )
	        this.debug(ord[i], "didn't return a proper array");
	      //D:this.debug( "" );
	      return res;
	    }
	  }
	
	  // Uhoh! no match! Should we throw an error?
	  return [];
	};
	
	Markdown.prototype.processInline = function processInline( block ) {
	  return this.dialect.inline.__call__.call( this, String( block ) );
	};
	
	/**
	 *  Markdown#toTree( source ) -> JsonML
	 *  - source (String): markdown source to parse
	 *
	 *  Parse `source` into a JsonML tree representing the markdown document.
	 **/
	// custom_tree means set this.tree to `custom_tree` and restore old value on return
	Markdown.prototype.toTree = function toTree( source, custom_root ) {
	  var blocks = source instanceof Array ? source : this.split_blocks( source );
	
	  // Make tree a member variable so its easier to mess with in extensions
	  var old_tree = this.tree;
	  try {
	    this.tree = custom_root || this.tree || [ "markdown" ];
	
	    blocks:
	    while ( blocks.length ) {
	      var b = this.processBlock( blocks.shift(), blocks );
	
	      // Reference blocks and the like won't return any content
	      if ( !b.length ) continue blocks;
	
	      this.tree.push.apply( this.tree, b );
	    }
	    return this.tree;
	  }
	  finally {
	    if ( custom_root ) {
	      this.tree = old_tree;
	    }
	  }
	};
	
	// Noop by default
	Markdown.prototype.debug = function () {
	  var args = Array.prototype.slice.call( arguments);
	  args.unshift(this.debug_indent);
	  if ( typeof print !== "undefined" )
	      print.apply( print, args );
	  if ( typeof console !== "undefined" && typeof console.log !== "undefined" )
	      console.log.apply( null, args );
	}
	
	Markdown.prototype.loop_re_over_block = function( re, block, cb ) {
	  // Dont use /g regexps with this
	  var m,
	      b = block.valueOf();
	
	  while ( b.length && (m = re.exec(b) ) != null ) {
	    b = b.substr( m[0].length );
	    cb.call(this, m);
	  }
	  return b;
	};
	
	/**
	 * Markdown.dialects
	 *
	 * Namespace of built-in dialects.
	 **/
	Markdown.dialects = {};
	
	/**
	 * Markdown.dialects.Gruber
	 *
	 * The default dialect that follows the rules set out by John Gruber's
	 * markdown.pl as closely as possible. Well actually we follow the behaviour of
	 * that script which in some places is not exactly what the syntax web page
	 * says.
	 **/
	Markdown.dialects.Gruber = {
	  block: {
	    atxHeader: function atxHeader( block, next ) {
	      var m = block.match( /^(#{1,6})\s*(.*?)\s*#*\s*(?:\n|$)/ );
	
	      if ( !m ) return undefined;
	
	      var header = [ "header", { level: m[ 1 ].length } ];
	      Array.prototype.push.apply(header, this.processInline(m[ 2 ]));
	
	      if ( m[0].length < block.length )
	        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );
	
	      return [ header ];
	    },
	
	    setextHeader: function setextHeader( block, next ) {
	      var m = block.match( /^(.*)\n([-=])\2\2+(?:\n|$)/ );
	
	      if ( !m ) return undefined;
	
	      var level = ( m[ 2 ] === "=" ) ? 1 : 2;
	      var header = [ "header", { level : level }, m[ 1 ] ];
	
	      if ( m[0].length < block.length )
	        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );
	
	      return [ header ];
	    },
	
	    code: function code( block, next ) {
	      // |    Foo
	      // |bar
	      // should be a code block followed by a paragraph. Fun
	      //
	      // There might also be adjacent code block to merge.
	
	      var ret = [],
	          re = /^(?: {0,3}\t| {4})(.*)\n?/,
	          lines;
	
	      // 4 spaces + content
	      if ( !block.match( re ) ) return undefined;
	
	      block_search:
	      do {
	        // Now pull out the rest of the lines
	        var b = this.loop_re_over_block(
	                  re, block.valueOf(), function( m ) { ret.push( m[1] ); } );
	
	        if ( b.length ) {
	          // Case alluded to in first comment. push it back on as a new block
	          next.unshift( mk_block(b, block.trailing) );
	          break block_search;
	        }
	        else if ( next.length ) {
	          // Check the next block - it might be code too
	          if ( !next[0].match( re ) ) break block_search;
	
	          // Pull how how many blanks lines follow - minus two to account for .join
	          ret.push ( block.trailing.replace(/[^\n]/g, "").substring(2) );
	
	          block = next.shift();
	        }
	        else {
	          break block_search;
	        }
	      } while ( true );
	
	      return [ [ "code_block", ret.join("\n") ] ];
	    },
	
	    horizRule: function horizRule( block, next ) {
	      // this needs to find any hr in the block to handle abutting blocks
	      var m = block.match( /^(?:([\s\S]*?)\n)?[ \t]*([-_*])(?:[ \t]*\2){2,}[ \t]*(?:\n([\s\S]*))?$/ );
	
	      if ( !m ) {
	        return undefined;
	      }
	
	      var jsonml = [ [ "hr" ] ];
	
	      // if there's a leading abutting block, process it
	      if ( m[ 1 ] ) {
	        jsonml.unshift.apply( jsonml, this.processBlock( m[ 1 ], [] ) );
	      }
	
	      // if there's a trailing abutting block, stick it into next
	      if ( m[ 3 ] ) {
	        next.unshift( mk_block( m[ 3 ] ) );
	      }
	
	      return jsonml;
	    },
	
	    // There are two types of lists. Tight and loose. Tight lists have no whitespace
	    // between the items (and result in text just in the <li>) and loose lists,
	    // which have an empty line between list items, resulting in (one or more)
	    // paragraphs inside the <li>.
	    //
	    // There are all sorts weird edge cases about the original markdown.pl's
	    // handling of lists:
	    //
	    // * Nested lists are supposed to be indented by four chars per level. But
	    //   if they aren't, you can get a nested list by indenting by less than
	    //   four so long as the indent doesn't match an indent of an existing list
	    //   item in the 'nest stack'.
	    //
	    // * The type of the list (bullet or number) is controlled just by the
	    //    first item at the indent. Subsequent changes are ignored unless they
	    //    are for nested lists
	    //
	    lists: (function( ) {
	      // Use a closure to hide a few variables.
	      var any_list = "[*+-]|\\d+\\.",
	          bullet_list = /[*+-]/,
	          number_list = /\d+\./,
	          // Capture leading indent as it matters for determining nested lists.
	          is_list_re = new RegExp( "^( {0,3})(" + any_list + ")[ \t]+" ),
	          indent_re = "(?: {0,3}\\t| {4})";
	
	      // TODO: Cache this regexp for certain depths.
	      // Create a regexp suitable for matching an li for a given stack depth
	      function regex_for_depth( depth ) {
	
	        return new RegExp(
	          // m[1] = indent, m[2] = list_type
	          "(?:^(" + indent_re + "{0," + depth + "} {0,3})(" + any_list + ")\\s+)|" +
	          // m[3] = cont
	          "(^" + indent_re + "{0," + (depth-1) + "}[ ]{0,4})"
	        );
	      }
	      function expand_tab( input ) {
	        return input.replace( / {0,3}\t/g, "    " );
	      }
	
	      // Add inline content `inline` to `li`. inline comes from processInline
	      // so is an array of content
	      function add(li, loose, inline, nl) {
	        if ( loose ) {
	          li.push( [ "para" ].concat(inline) );
	          return;
	        }
	        // Hmmm, should this be any block level element or just paras?
	        var add_to = li[li.length -1] instanceof Array && li[li.length - 1][0] == "para"
	                   ? li[li.length -1]
	                   : li;
	
	        // If there is already some content in this list, add the new line in
	        if ( nl && li.length > 1 ) inline.unshift(nl);
	
	        for ( var i = 0; i < inline.length; i++ ) {
	          var what = inline[i],
	              is_str = typeof what == "string";
	          if ( is_str && add_to.length > 1 && typeof add_to[add_to.length-1] == "string" ) {
	            add_to[ add_to.length-1 ] += what;
	          }
	          else {
	            add_to.push( what );
	          }
	        }
	      }
	
	      // contained means have an indent greater than the current one. On
	      // *every* line in the block
	      function get_contained_blocks( depth, blocks ) {
	
	        var re = new RegExp( "^(" + indent_re + "{" + depth + "}.*?\\n?)*$" ),
	            replace = new RegExp("^" + indent_re + "{" + depth + "}", "gm"),
	            ret = [];
	
	        while ( blocks.length > 0 ) {
	          if ( re.exec( blocks[0] ) ) {
	            var b = blocks.shift(),
	                // Now remove that indent
	                x = b.replace( replace, "");
	
	            ret.push( mk_block( x, b.trailing, b.lineNumber ) );
	          }
	          else {
	            break;
	          }
	        }
	        return ret;
	      }
	
	      // passed to stack.forEach to turn list items up the stack into paras
	      function paragraphify(s, i, stack) {
	        var list = s.list;
	        var last_li = list[list.length-1];
	
	        if ( last_li[1] instanceof Array && last_li[1][0] == "para" ) {
	          return;
	        }
	        if ( i + 1 == stack.length ) {
	          // Last stack frame
	          // Keep the same array, but replace the contents
	          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ) );
	        }
	        else {
	          var sublist = last_li.pop();
	          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ), sublist );
	        }
	      }
	
	      // The matcher function
	      return function( block, next ) {
	        var m = block.match( is_list_re );
	        if ( !m ) return undefined;
	
	        function make_list( m ) {
	          var list = bullet_list.exec( m[2] )
	                   ? ["bulletlist"]
	                   : ["numberlist"];
	
	          stack.push( { list: list, indent: m[1] } );
	          return list;
	        }
	
	
	        var stack = [], // Stack of lists for nesting.
	            list = make_list( m ),
	            last_li,
	            loose = false,
	            ret = [ stack[0].list ],
	            i;
	
	        // Loop to search over block looking for inner block elements and loose lists
	        loose_search:
	        while ( true ) {
	          // Split into lines preserving new lines at end of line
	          var lines = block.split( /(?=\n)/ );
	
	          // We have to grab all lines for a li and call processInline on them
	          // once as there are some inline things that can span lines.
	          var li_accumulate = "";
	
	          // Loop over the lines in this block looking for tight lists.
	          tight_search:
	          for ( var line_no = 0; line_no < lines.length; line_no++ ) {
	            var nl = "",
	                l = lines[line_no].replace(/^\n/, function(n) { nl = n; return ""; });
	
	            // TODO: really should cache this
	            var line_re = regex_for_depth( stack.length );
	
	            m = l.match( line_re );
	            //print( "line:", uneval(l), "\nline match:", uneval(m) );
	
	            // We have a list item
	            if ( m[1] !== undefined ) {
	              // Process the previous list item, if any
	              if ( li_accumulate.length ) {
	                add( last_li, loose, this.processInline( li_accumulate ), nl );
	                // Loose mode will have been dealt with. Reset it
	                loose = false;
	                li_accumulate = "";
	              }
	
	              m[1] = expand_tab( m[1] );
	              var wanted_depth = Math.floor(m[1].length/4)+1;
	              //print( "want:", wanted_depth, "stack:", stack.length);
	              if ( wanted_depth > stack.length ) {
	                // Deep enough for a nested list outright
	                //print ( "new nested list" );
	                list = make_list( m );
	                last_li.push( list );
	                last_li = list[1] = [ "listitem" ];
	              }
	              else {
	                // We aren't deep enough to be strictly a new level. This is
	                // where Md.pl goes nuts. If the indent matches a level in the
	                // stack, put it there, else put it one deeper then the
	                // wanted_depth deserves.
	                var found = false;
	                for ( i = 0; i < stack.length; i++ ) {
	                  if ( stack[ i ].indent != m[1] ) continue;
	                  list = stack[ i ].list;
	                  stack.splice( i+1, stack.length - (i+1) );
	                  found = true;
	                  break;
	                }
	
	                if (!found) {
	                  //print("not found. l:", uneval(l));
	                  wanted_depth++;
	                  if ( wanted_depth <= stack.length ) {
	                    stack.splice(wanted_depth, stack.length - wanted_depth);
	                    //print("Desired depth now", wanted_depth, "stack:", stack.length);
	                    list = stack[wanted_depth-1].list;
	                    //print("list:", uneval(list) );
	                  }
	                  else {
	                    //print ("made new stack for messy indent");
	                    list = make_list(m);
	                    last_li.push(list);
	                  }
	                }
	
	                //print( uneval(list), "last", list === stack[stack.length-1].list );
	                last_li = [ "listitem" ];
	                list.push(last_li);
	              } // end depth of shenegains
	              nl = "";
	            }
	
	            // Add content
	            if ( l.length > m[0].length ) {
	              li_accumulate += nl + l.substr( m[0].length );
	            }
	          } // tight_search
	
	          if ( li_accumulate.length ) {
	            add( last_li, loose, this.processInline( li_accumulate ), nl );
	            // Loose mode will have been dealt with. Reset it
	            loose = false;
	            li_accumulate = "";
	          }
	
	          // Look at the next block - we might have a loose list. Or an extra
	          // paragraph for the current li
	          var contained = get_contained_blocks( stack.length, next );
	
	          // Deal with code blocks or properly nested lists
	          if ( contained.length > 0 ) {
	            // Make sure all listitems up the stack are paragraphs
	            forEach( stack, paragraphify, this);
	
	            last_li.push.apply( last_li, this.toTree( contained, [] ) );
	          }
	
	          var next_block = next[0] && next[0].valueOf() || "";
	
	          if ( next_block.match(is_list_re) || next_block.match( /^ / ) ) {
	            block = next.shift();
	
	            // Check for an HR following a list: features/lists/hr_abutting
	            var hr = this.dialect.block.horizRule( block, next );
	
	            if ( hr ) {
	              ret.push.apply(ret, hr);
	              break;
	            }
	
	            // Make sure all listitems up the stack are paragraphs
	            forEach( stack, paragraphify, this);
	
	            loose = true;
	            continue loose_search;
	          }
	          break;
	        } // loose_search
	
	        return ret;
	      };
	    })(),
	
	    blockquote: function blockquote( block, next ) {
	      if ( !block.match( /^>/m ) )
	        return undefined;
	
	      var jsonml = [];
	
	      // separate out the leading abutting block, if any. I.e. in this case:
	      //
	      //  a
	      //  > b
	      //
	      if ( block[ 0 ] != ">" ) {
	        var lines = block.split( /\n/ ),
	            prev = [],
	            line_no = block.lineNumber;
	
	        // keep shifting lines until you find a crotchet
	        while ( lines.length && lines[ 0 ][ 0 ] != ">" ) {
	            prev.push( lines.shift() );
	            line_no++;
	        }
	
	        var abutting = mk_block( prev.join( "\n" ), "\n", block.lineNumber );
	        jsonml.push.apply( jsonml, this.processBlock( abutting, [] ) );
	        // reassemble new block of just block quotes!
	        block = mk_block( lines.join( "\n" ), block.trailing, line_no );
	      }
	
	
	      // if the next block is also a blockquote merge it in
	      while ( next.length && next[ 0 ][ 0 ] == ">" ) {
	        var b = next.shift();
	        block = mk_block( block + block.trailing + b, b.trailing, block.lineNumber );
	      }
	
	      // Strip off the leading "> " and re-process as a block.
	      var input = block.replace( /^> ?/gm, "" ),
	          old_tree = this.tree,
	          processedBlock = this.toTree( input, [ "blockquote" ] ),
	          attr = extract_attr( processedBlock );
	
	      // If any link references were found get rid of them
	      if ( attr && attr.references ) {
	        delete attr.references;
	        // And then remove the attribute object if it's empty
	        if ( isEmpty( attr ) ) {
	          processedBlock.splice( 1, 1 );
	        }
	      }
	
	      jsonml.push( processedBlock );
	      return jsonml;
	    },
	
	    referenceDefn: function referenceDefn( block, next) {
	      var re = /^\s*\[(.*?)\]:\s*(\S+)(?:\s+(?:(['"])(.*?)\3|\((.*?)\)))?\n?/;
	      // interesting matches are [ , ref_id, url, , title, title ]
	
	      if ( !block.match(re) )
	        return undefined;
	
	      // make an attribute node if it doesn't exist
	      if ( !extract_attr( this.tree ) ) {
	        this.tree.splice( 1, 0, {} );
	      }
	
	      var attrs = extract_attr( this.tree );
	
	      // make a references hash if it doesn't exist
	      if ( attrs.references === undefined ) {
	        attrs.references = {};
	      }
	
	      var b = this.loop_re_over_block(re, block, function( m ) {
	
	        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
	          m[2] = m[2].substring( 1, m[2].length - 1 );
	
	        var ref = attrs.references[ m[1].toLowerCase() ] = {
	          href: m[2]
	        };
	
	        if ( m[4] !== undefined )
	          ref.title = m[4];
	        else if ( m[5] !== undefined )
	          ref.title = m[5];
	
	      } );
	
	      if ( b.length )
	        next.unshift( mk_block( b, block.trailing ) );
	
	      return [];
	    },
	
	    para: function para( block, next ) {
	      // everything's a para!
	      return [ ["para"].concat( this.processInline( block ) ) ];
	    }
	  }
	};
	
	Markdown.dialects.Gruber.inline = {
	
	    __oneElement__: function oneElement( text, patterns_or_re, previous_nodes ) {
	      var m,
	          res,
	          lastIndex = 0;
	
	      patterns_or_re = patterns_or_re || this.dialect.inline.__patterns__;
	      var re = new RegExp( "([\\s\\S]*?)(" + (patterns_or_re.source || patterns_or_re) + ")" );
	
	      m = re.exec( text );
	      if (!m) {
	        // Just boring text
	        return [ text.length, text ];
	      }
	      else if ( m[1] ) {
	        // Some un-interesting text matched. Return that first
	        return [ m[1].length, m[1] ];
	      }
	
	      var res;
	      if ( m[2] in this.dialect.inline ) {
	        res = this.dialect.inline[ m[2] ].call(
	                  this,
	                  text.substr( m.index ), m, previous_nodes || [] );
	      }
	      // Default for now to make dev easier. just slurp special and output it.
	      res = res || [ m[2].length, m[2] ];
	      return res;
	    },
	
	    __call__: function inline( text, patterns ) {
	
	      var out = [],
	          res;
	
	      function add(x) {
	        //D:self.debug("  adding output", uneval(x));
	        if ( typeof x == "string" && typeof out[out.length-1] == "string" )
	          out[ out.length-1 ] += x;
	        else
	          out.push(x);
	      }
	
	      while ( text.length > 0 ) {
	        res = this.dialect.inline.__oneElement__.call(this, text, patterns, out );
	        text = text.substr( res.shift() );
	        forEach(res, add )
	      }
	
	      return out;
	    },
	
	    // These characters are intersting elsewhere, so have rules for them so that
	    // chunks of plain text blocks don't include them
	    "]": function () {},
	    "}": function () {},
	
	    __escape__ : /^\\[\\`\*_{}\[\]()#\+.!\-]/,
	
	    "\\": function escaped( text ) {
	      // [ length of input processed, node/children to add... ]
	      // Only esacape: \ ` * _ { } [ ] ( ) # * + - . !
	      if ( this.dialect.inline.__escape__.exec( text ) )
	        return [ 2, text.charAt( 1 ) ];
	      else
	        // Not an esacpe
	        return [ 1, "\\" ];
	    },
	
	    "![": function image( text ) {
	
	      // Unlike images, alt text is plain text only. no other elements are
	      // allowed in there
	
	      // ![Alt text](/path/to/img.jpg "Optional title")
	      //      1          2            3       4         <--- captures
	      var m = text.match( /^!\[(.*?)\][ \t]*\([ \t]*([^")]*?)(?:[ \t]+(["'])(.*?)\3)?[ \t]*\)/ );
	
	      if ( m ) {
	        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
	          m[2] = m[2].substring( 1, m[2].length - 1 );
	
	        m[2] = this.dialect.inline.__call__.call( this, m[2], /\\/ )[0];
	
	        var attrs = { alt: m[1], href: m[2] || "" };
	        if ( m[4] !== undefined)
	          attrs.title = m[4];
	
	        return [ m[0].length, [ "img", attrs ] ];
	      }
	
	      // ![Alt text][id]
	      m = text.match( /^!\[(.*?)\][ \t]*\[(.*?)\]/ );
	
	      if ( m ) {
	        // We can't check if the reference is known here as it likely wont be
	        // found till after. Check it in md tree->hmtl tree conversion
	        return [ m[0].length, [ "img_ref", { alt: m[1], ref: m[2].toLowerCase(), original: m[0] } ] ];
	      }
	
	      // Just consume the '!['
	      return [ 2, "![" ];
	    },
	
	    "[": function link( text ) {
	
	      var orig = String(text);
	      // Inline content is possible inside `link text`
	      var res = Markdown.DialectHelpers.inline_until_char.call( this, text.substr(1), "]" );
	
	      // No closing ']' found. Just consume the [
	      if ( !res ) return [ 1, "[" ];
	
	      var consumed = 1 + res[ 0 ],
	          children = res[ 1 ],
	          link,
	          attrs;
	
	      // At this point the first [...] has been parsed. See what follows to find
	      // out which kind of link we are (reference or direct url)
	      text = text.substr( consumed );
	
	      // [link text](/path/to/img.jpg "Optional title")
	      //                 1            2       3         <--- captures
	      // This will capture up to the last paren in the block. We then pull
	      // back based on if there a matching ones in the url
	      //    ([here](/url/(test))
	      // The parens have to be balanced
	      var m = text.match( /^\s*\([ \t]*([^"']*)(?:[ \t]+(["'])(.*?)\2)?[ \t]*\)/ );
	      if ( m ) {
	        var url = m[1];
	        consumed += m[0].length;
	
	        if ( url && url[0] == "<" && url[url.length-1] == ">" )
	          url = url.substring( 1, url.length - 1 );
	
	        // If there is a title we don't have to worry about parens in the url
	        if ( !m[3] ) {
	          var open_parens = 1; // One open that isn't in the capture
	          for ( var len = 0; len < url.length; len++ ) {
	            switch ( url[len] ) {
	            case "(":
	              open_parens++;
	              break;
	            case ")":
	              if ( --open_parens == 0) {
	                consumed -= url.length - len;
	                url = url.substring(0, len);
	              }
	              break;
	            }
	          }
	        }
	
	        // Process escapes only
	        url = this.dialect.inline.__call__.call( this, url, /\\/ )[0];
	
	        attrs = { href: url || "" };
	        if ( m[3] !== undefined)
	          attrs.title = m[3];
	
	        link = [ "link", attrs ].concat( children );
	        return [ consumed, link ];
	      }
	
	      // [Alt text][id]
	      // [Alt text] [id]
	      m = text.match( /^\s*\[(.*?)\]/ );
	
	      if ( m ) {
	
	        consumed += m[ 0 ].length;
	
	        // [links][] uses links as its reference
	        attrs = { ref: ( m[ 1 ] || String(children) ).toLowerCase(),  original: orig.substr( 0, consumed ) };
	
	        link = [ "link_ref", attrs ].concat( children );
	
	        // We can't check if the reference is known here as it likely wont be
	        // found till after. Check it in md tree->hmtl tree conversion.
	        // Store the original so that conversion can revert if the ref isn't found.
	        return [ consumed, link ];
	      }
	
	      // [id]
	      // Only if id is plain (no formatting.)
	      if ( children.length == 1 && typeof children[0] == "string" ) {
	
	        attrs = { ref: children[0].toLowerCase(),  original: orig.substr( 0, consumed ) };
	        link = [ "link_ref", attrs, children[0] ];
	        return [ consumed, link ];
	      }
	
	      // Just consume the "["
	      return [ 1, "[" ];
	    },
	
	
	    "<": function autoLink( text ) {
	      var m;
	
	      if ( ( m = text.match( /^<(?:((https?|ftp|mailto):[^>]+)|(.*?@.*?\.[a-zA-Z]+))>/ ) ) != null ) {
	        if ( m[3] ) {
	          return [ m[0].length, [ "link", { href: "mailto:" + m[3] }, m[3] ] ];
	
	        }
	        else if ( m[2] == "mailto" ) {
	          return [ m[0].length, [ "link", { href: m[1] }, m[1].substr("mailto:".length ) ] ];
	        }
	        else
	          return [ m[0].length, [ "link", { href: m[1] }, m[1] ] ];
	      }
	
	      return [ 1, "<" ];
	    },
	
	    "`": function inlineCode( text ) {
	      // Inline code block. as many backticks as you like to start it
	      // Always skip over the opening ticks.
	      var m = text.match( /(`+)(([\s\S]*?)\1)/ );
	
	      if ( m && m[2] )
	        return [ m[1].length + m[2].length, [ "inlinecode", m[3] ] ];
	      else {
	        // TODO: No matching end code found - warn!
	        return [ 1, "`" ];
	      }
	    },
	
	    "  \n": function lineBreak( text ) {
	      return [ 3, [ "linebreak" ] ];
	    }
	
	};
	
	// Meta Helper/generator method for em and strong handling
	function strong_em( tag, md ) {
	
	  var state_slot = tag + "_state",
	      other_slot = tag == "strong" ? "em_state" : "strong_state";
	
	  function CloseTag(len) {
	    this.len_after = len;
	    this.name = "close_" + md;
	  }
	
	  return function ( text, orig_match ) {
	
	    if ( this[state_slot][0] == md ) {
	      // Most recent em is of this type
	      //D:this.debug("closing", md);
	      this[state_slot].shift();
	
	      // "Consume" everything to go back to the recrusion in the else-block below
	      return[ text.length, new CloseTag(text.length-md.length) ];
	    }
	    else {
	      // Store a clone of the em/strong states
	      var other = this[other_slot].slice(),
	          state = this[state_slot].slice();
	
	      this[state_slot].unshift(md);
	
	      //D:this.debug_indent += "  ";
	
	      // Recurse
	      var res = this.processInline( text.substr( md.length ) );
	      //D:this.debug_indent = this.debug_indent.substr(2);
	
	      var last = res[res.length - 1];
	
	      //D:this.debug("processInline from", tag + ": ", uneval( res ) );
	
	      var check = this[state_slot].shift();
	      if ( last instanceof CloseTag ) {
	        res.pop();
	        // We matched! Huzzah.
	        var consumed = text.length - last.len_after;
	        return [ consumed, [ tag ].concat(res) ];
	      }
	      else {
	        // Restore the state of the other kind. We might have mistakenly closed it.
	        this[other_slot] = other;
	        this[state_slot] = state;
	
	        // We can't reuse the processed result as it could have wrong parsing contexts in it.
	        return [ md.length, md ];
	      }
	    }
	  }; // End returned function
	}
	
	Markdown.dialects.Gruber.inline["**"] = strong_em("strong", "**");
	Markdown.dialects.Gruber.inline["__"] = strong_em("strong", "__");
	Markdown.dialects.Gruber.inline["*"]  = strong_em("em", "*");
	Markdown.dialects.Gruber.inline["_"]  = strong_em("em", "_");
	
	
	// Build default order from insertion order.
	Markdown.buildBlockOrder = function(d) {
	  var ord = [];
	  for ( var i in d ) {
	    if ( i == "__order__" || i == "__call__" ) continue;
	    ord.push( i );
	  }
	  d.__order__ = ord;
	};
	
	// Build patterns for inline matcher
	Markdown.buildInlinePatterns = function(d) {
	  var patterns = [];
	
	  for ( var i in d ) {
	    // __foo__ is reserved and not a pattern
	    if ( i.match( /^__.*__$/) ) continue;
	    var l = i.replace( /([\\.*+?|()\[\]{}])/g, "\\$1" )
	             .replace( /\n/, "\\n" );
	    patterns.push( i.length == 1 ? l : "(?:" + l + ")" );
	  }
	
	  patterns = patterns.join("|");
	  d.__patterns__ = patterns;
	  //print("patterns:", uneval( patterns ) );
	
	  var fn = d.__call__;
	  d.__call__ = function(text, pattern) {
	    if ( pattern != undefined ) {
	      return fn.call(this, text, pattern);
	    }
	    else
	    {
	      return fn.call(this, text, patterns);
	    }
	  };
	};
	
	Markdown.DialectHelpers = {};
	Markdown.DialectHelpers.inline_until_char = function( text, want ) {
	  var consumed = 0,
	      nodes = [];
	
	  while ( true ) {
	    if ( text.charAt( consumed ) == want ) {
	      // Found the character we were looking for
	      consumed++;
	      return [ consumed, nodes ];
	    }
	
	    if ( consumed >= text.length ) {
	      // No closing char found. Abort.
	      return null;
	    }
	
	    var res = this.dialect.inline.__oneElement__.call(this, text.substr( consumed ) );
	    consumed += res[ 0 ];
	    // Add any returned nodes.
	    nodes.push.apply( nodes, res.slice( 1 ) );
	  }
	}
	
	// Helper function to make sub-classing a dialect easier
	Markdown.subclassDialect = function( d ) {
	  function Block() {}
	  Block.prototype = d.block;
	  function Inline() {}
	  Inline.prototype = d.inline;
	
	  return { block: new Block(), inline: new Inline() };
	};
	
	Markdown.buildBlockOrder ( Markdown.dialects.Gruber.block );
	Markdown.buildInlinePatterns( Markdown.dialects.Gruber.inline );
	
	Markdown.dialects.Maruku = Markdown.subclassDialect( Markdown.dialects.Gruber );
	
	Markdown.dialects.Maruku.processMetaHash = function processMetaHash( meta_string ) {
	  var meta = split_meta_hash( meta_string ),
	      attr = {};
	
	  for ( var i = 0; i < meta.length; ++i ) {
	    // id: #foo
	    if ( /^#/.test( meta[ i ] ) ) {
	      attr.id = meta[ i ].substring( 1 );
	    }
	    // class: .foo
	    else if ( /^\./.test( meta[ i ] ) ) {
	      // if class already exists, append the new one
	      if ( attr["class"] ) {
	        attr["class"] = attr["class"] + meta[ i ].replace( /./, " " );
	      }
	      else {
	        attr["class"] = meta[ i ].substring( 1 );
	      }
	    }
	    // attribute: foo=bar
	    else if ( /\=/.test( meta[ i ] ) ) {
	      var s = meta[ i ].split( /\=/ );
	      attr[ s[ 0 ] ] = s[ 1 ];
	    }
	  }
	
	  return attr;
	}
	
	function split_meta_hash( meta_string ) {
	  var meta = meta_string.split( "" ),
	      parts = [ "" ],
	      in_quotes = false;
	
	  while ( meta.length ) {
	    var letter = meta.shift();
	    switch ( letter ) {
	      case " " :
	        // if we're in a quoted section, keep it
	        if ( in_quotes ) {
	          parts[ parts.length - 1 ] += letter;
	        }
	        // otherwise make a new part
	        else {
	          parts.push( "" );
	        }
	        break;
	      case "'" :
	      case '"' :
	        // reverse the quotes and move straight on
	        in_quotes = !in_quotes;
	        break;
	      case "\\" :
	        // shift off the next letter to be used straight away.
	        // it was escaped so we'll keep it whatever it is
	        letter = meta.shift();
	      default :
	        parts[ parts.length - 1 ] += letter;
	        break;
	    }
	  }
	
	  return parts;
	}
	
	Markdown.dialects.Maruku.block.document_meta = function document_meta( block, next ) {
	  // we're only interested in the first block
	  if ( block.lineNumber > 1 ) return undefined;
	
	  // document_meta blocks consist of one or more lines of `Key: Value\n`
	  if ( ! block.match( /^(?:\w+:.*\n)*\w+:.*$/ ) ) return undefined;
	
	  // make an attribute node if it doesn't exist
	  if ( !extract_attr( this.tree ) ) {
	    this.tree.splice( 1, 0, {} );
	  }
	
	  var pairs = block.split( /\n/ );
	  for ( p in pairs ) {
	    var m = pairs[ p ].match( /(\w+):\s*(.*)$/ ),
	        key = m[ 1 ].toLowerCase(),
	        value = m[ 2 ];
	
	    this.tree[ 1 ][ key ] = value;
	  }
	
	  // document_meta produces no content!
	  return [];
	};
	
	Markdown.dialects.Maruku.block.block_meta = function block_meta( block, next ) {
	  // check if the last line of the block is an meta hash
	  var m = block.match( /(^|\n) {0,3}\{:\s*((?:\\\}|[^\}])*)\s*\}$/ );
	  if ( !m ) return undefined;
	
	  // process the meta hash
	  var attr = this.dialect.processMetaHash( m[ 2 ] );
	
	  var hash;
	
	  // if we matched ^ then we need to apply meta to the previous block
	  if ( m[ 1 ] === "" ) {
	    var node = this.tree[ this.tree.length - 1 ];
	    hash = extract_attr( node );
	
	    // if the node is a string (rather than JsonML), bail
	    if ( typeof node === "string" ) return undefined;
	
	    // create the attribute hash if it doesn't exist
	    if ( !hash ) {
	      hash = {};
	      node.splice( 1, 0, hash );
	    }
	
	    // add the attributes in
	    for ( a in attr ) {
	      hash[ a ] = attr[ a ];
	    }
	
	    // return nothing so the meta hash is removed
	    return [];
	  }
	
	  // pull the meta hash off the block and process what's left
	  var b = block.replace( /\n.*$/, "" ),
	      result = this.processBlock( b, [] );
	
	  // get or make the attributes hash
	  hash = extract_attr( result[ 0 ] );
	  if ( !hash ) {
	    hash = {};
	    result[ 0 ].splice( 1, 0, hash );
	  }
	
	  // attach the attributes to the block
	  for ( a in attr ) {
	    hash[ a ] = attr[ a ];
	  }
	
	  return result;
	};
	
	Markdown.dialects.Maruku.block.definition_list = function definition_list( block, next ) {
	  // one or more terms followed by one or more definitions, in a single block
	  var tight = /^((?:[^\s:].*\n)+):\s+([\s\S]+)$/,
	      list = [ "dl" ],
	      i, m;
	
	  // see if we're dealing with a tight or loose block
	  if ( ( m = block.match( tight ) ) ) {
	    // pull subsequent tight DL blocks out of `next`
	    var blocks = [ block ];
	    while ( next.length && tight.exec( next[ 0 ] ) ) {
	      blocks.push( next.shift() );
	    }
	
	    for ( var b = 0; b < blocks.length; ++b ) {
	      var m = blocks[ b ].match( tight ),
	          terms = m[ 1 ].replace( /\n$/, "" ).split( /\n/ ),
	          defns = m[ 2 ].split( /\n:\s+/ );
	
	      // print( uneval( m ) );
	
	      for ( i = 0; i < terms.length; ++i ) {
	        list.push( [ "dt", terms[ i ] ] );
	      }
	
	      for ( i = 0; i < defns.length; ++i ) {
	        // run inline processing over the definition
	        list.push( [ "dd" ].concat( this.processInline( defns[ i ].replace( /(\n)\s+/, "$1" ) ) ) );
	      }
	    }
	  }
	  else {
	    return undefined;
	  }
	
	  return [ list ];
	};
	
	// splits on unescaped instances of @ch. If @ch is not a character the result
	// can be unpredictable
	
	Markdown.dialects.Maruku.block.table = function table (block, next) {
	
	    var _split_on_unescaped = function(s, ch) {
	        ch = ch || '\\s';
	        if (ch.match(/^[\\|\[\]{}?*.+^$]$/)) { ch = '\\' + ch; }
	        var res = [ ],
	            r = new RegExp('^((?:\\\\.|[^\\\\' + ch + '])*)' + ch + '(.*)'),
	            m;
	        while(m = s.match(r)) {
	            res.push(m[1]);
	            s = m[2];
	        }
	        res.push(s);
	        return res;
	    }
	
	    var leading_pipe = /^ {0,3}\|(.+)\n {0,3}\|\s*([\-:]+[\-| :]*)\n((?:\s*\|.*(?:\n|$))*)(?=\n|$)/,
	        // find at least an unescaped pipe in each line
	        no_leading_pipe = /^ {0,3}(\S(?:\\.|[^\\|])*\|.*)\n {0,3}([\-:]+\s*\|[\-| :]*)\n((?:(?:\\.|[^\\|])*\|.*(?:\n|$))*)(?=\n|$)/,
	        i, m;
	    if (m = block.match(leading_pipe)) {
	        // remove leading pipes in contents
	        // (header and horizontal rule already have the leading pipe left out)
	        m[3] = m[3].replace(/^\s*\|/gm, '');
	    } else if (! ( m = block.match(no_leading_pipe))) {
	        return undefined;
	    }
	
	    var table = [ "table", [ "thead", [ "tr" ] ], [ "tbody" ] ];
	
	    // remove trailing pipes, then split on pipes
	    // (no escaped pipes are allowed in horizontal rule)
	    m[2] = m[2].replace(/\|\s*$/, '').split('|');
	
	    // process alignment
	    var html_attrs = [ ];
	    forEach (m[2], function (s) {
	        if (s.match(/^\s*-+:\s*$/))       html_attrs.push({align: "right"});
	        else if (s.match(/^\s*:-+\s*$/))  html_attrs.push({align: "left"});
	        else if (s.match(/^\s*:-+:\s*$/)) html_attrs.push({align: "center"});
	        else                              html_attrs.push({});
	    });
	
	    // now for the header, avoid escaped pipes
	    m[1] = _split_on_unescaped(m[1].replace(/\|\s*$/, ''), '|');
	    for (i = 0; i < m[1].length; i++) {
	        table[1][1].push(['th', html_attrs[i] || {}].concat(
	            this.processInline(m[1][i].trim())));
	    }
	
	    // now for body contents
	    forEach (m[3].replace(/\|\s*$/mg, '').split('\n'), function (row) {
	        var html_row = ['tr'];
	        row = _split_on_unescaped(row, '|');
	        for (i = 0; i < row.length; i++) {
	            html_row.push(['td', html_attrs[i] || {}].concat(this.processInline(row[i].trim())));
	        }
	        table[2].push(html_row);
	    }, this);
	
	    return [table];
	}
	
	Markdown.dialects.Maruku.inline[ "{:" ] = function inline_meta( text, matches, out ) {
	  if ( !out.length ) {
	    return [ 2, "{:" ];
	  }
	
	  // get the preceeding element
	  var before = out[ out.length - 1 ];
	
	  if ( typeof before === "string" ) {
	    return [ 2, "{:" ];
	  }
	
	  // match a meta hash
	  var m = text.match( /^\{:\s*((?:\\\}|[^\}])*)\s*\}/ );
	
	  // no match, false alarm
	  if ( !m ) {
	    return [ 2, "{:" ];
	  }
	
	  // attach the attributes to the preceeding element
	  var meta = this.dialect.processMetaHash( m[ 1 ] ),
	      attr = extract_attr( before );
	
	  if ( !attr ) {
	    attr = {};
	    before.splice( 1, 0, attr );
	  }
	
	  for ( var k in meta ) {
	    attr[ k ] = meta[ k ];
	  }
	
	  // cut out the string and replace it with nothing
	  return [ m[ 0 ].length, "" ];
	};
	
	Markdown.dialects.Maruku.inline.__escape__ = /^\\[\\`\*_{}\[\]()#\+.!\-|:]/;
	
	Markdown.buildBlockOrder ( Markdown.dialects.Maruku.block );
	Markdown.buildInlinePatterns( Markdown.dialects.Maruku.inline );
	
	var isArray = Array.isArray || function(obj) {
	  return Object.prototype.toString.call(obj) == "[object Array]";
	};
	
	var forEach;
	// Don't mess with Array.prototype. Its not friendly
	if ( Array.prototype.forEach ) {
	  forEach = function( arr, cb, thisp ) {
	    return arr.forEach( cb, thisp );
	  };
	}
	else {
	  forEach = function(arr, cb, thisp) {
	    for (var i = 0; i < arr.length; i++) {
	      cb.call(thisp || arr, arr[i], i, arr);
	    }
	  }
	}
	
	var isEmpty = function( obj ) {
	  for ( var key in obj ) {
	    if ( hasOwnProperty.call( obj, key ) ) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function extract_attr( jsonml ) {
	  return isArray(jsonml)
	      && jsonml.length > 1
	      && typeof jsonml[ 1 ] === "object"
	      && !( isArray(jsonml[ 1 ]) )
	      ? jsonml[ 1 ]
	      : undefined;
	}
	
	
	
	/**
	 *  renderJsonML( jsonml[, options] ) -> String
	 *  - jsonml (Array): JsonML array to render to XML
	 *  - options (Object): options
	 *
	 *  Converts the given JsonML into well-formed XML.
	 *
	 *  The options currently understood are:
	 *
	 *  - root (Boolean): wether or not the root node should be included in the
	 *    output, or just its children. The default `false` is to not include the
	 *    root itself.
	 */
	expose.renderJsonML = function( jsonml, options ) {
	  options = options || {};
	  // include the root element in the rendered output?
	  options.root = options.root || false;
	
	  var content = [];
	
	  if ( options.root ) {
	    content.push( render_tree( jsonml ) );
	  }
	  else {
	    jsonml.shift(); // get rid of the tag
	    if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
	      jsonml.shift(); // get rid of the attributes
	    }
	
	    while ( jsonml.length ) {
	      content.push( render_tree( jsonml.shift() ) );
	    }
	  }
	
	  return content.join( "\n\n" );
	};
	
	function escapeHTML( text ) {
	  return text.replace( /&/g, "&amp;" )
	             .replace( /</g, "&lt;" )
	             .replace( />/g, "&gt;" )
	             .replace( /"/g, "&quot;" )
	             .replace( /'/g, "&#39;" );
	}
	
	function render_tree( jsonml ) {
	  // basic case
	  if ( typeof jsonml === "string" ) {
	    return escapeHTML( jsonml );
	  }
	
	  var tag = jsonml.shift(),
	      attributes = {},
	      content = [];
	
	  if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
	    attributes = jsonml.shift();
	  }
	
	  while ( jsonml.length ) {
	    content.push( render_tree( jsonml.shift() ) );
	  }
	
	  var tag_attrs = "";
	  for ( var a in attributes ) {
	    tag_attrs += " " + a + '="' + escapeHTML( attributes[ a ] ) + '"';
	  }
	
	  // be careful about adding whitespace here for inline elements
	  if ( tag == "img" || tag == "br" || tag == "hr" ) {
	    return "<"+ tag + tag_attrs + "/>";
	  }
	  else {
	    return "<"+ tag + tag_attrs + ">" + content.join( "" ) + "</" + tag + ">";
	  }
	}
	
	function convert_tree_to_html( tree, references, options ) {
	  var i;
	  options = options || {};
	
	  // shallow clone
	  var jsonml = tree.slice( 0 );
	
	  if ( typeof options.preprocessTreeNode === "function" ) {
	      jsonml = options.preprocessTreeNode(jsonml, references);
	  }
	
	  // Clone attributes if they exist
	  var attrs = extract_attr( jsonml );
	  if ( attrs ) {
	    jsonml[ 1 ] = {};
	    for ( i in attrs ) {
	      jsonml[ 1 ][ i ] = attrs[ i ];
	    }
	    attrs = jsonml[ 1 ];
	  }
	
	  // basic case
	  if ( typeof jsonml === "string" ) {
	    return jsonml;
	  }
	
	  // convert this node
	  switch ( jsonml[ 0 ] ) {
	    case "header":
	      jsonml[ 0 ] = "h" + jsonml[ 1 ].level;
	      delete jsonml[ 1 ].level;
	      break;
	    case "bulletlist":
	      jsonml[ 0 ] = "ul";
	      break;
	    case "numberlist":
	      jsonml[ 0 ] = "ol";
	      break;
	    case "listitem":
	      jsonml[ 0 ] = "li";
	      break;
	    case "para":
	      jsonml[ 0 ] = "p";
	      break;
	    case "markdown":
	      jsonml[ 0 ] = "html";
	      if ( attrs ) delete attrs.references;
	      break;
	    case "code_block":
	      jsonml[ 0 ] = "pre";
	      i = attrs ? 2 : 1;
	      var code = [ "code" ];
	      code.push.apply( code, jsonml.splice( i, jsonml.length - i ) );
	      jsonml[ i ] = code;
	      break;
	    case "inlinecode":
	      jsonml[ 0 ] = "code";
	      break;
	    case "img":
	      jsonml[ 1 ].src = jsonml[ 1 ].href;
	      delete jsonml[ 1 ].href;
	      break;
	    case "linebreak":
	      jsonml[ 0 ] = "br";
	    break;
	    case "link":
	      jsonml[ 0 ] = "a";
	      break;
	    case "link_ref":
	      jsonml[ 0 ] = "a";
	
	      // grab this ref and clean up the attribute node
	      var ref = references[ attrs.ref ];
	
	      // if the reference exists, make the link
	      if ( ref ) {
	        delete attrs.ref;
	
	        // add in the href and title, if present
	        attrs.href = ref.href;
	        if ( ref.title ) {
	          attrs.title = ref.title;
	        }
	
	        // get rid of the unneeded original text
	        delete attrs.original;
	      }
	      // the reference doesn't exist, so revert to plain text
	      else {
	        return attrs.original;
	      }
	      break;
	    case "img_ref":
	      jsonml[ 0 ] = "img";
	
	      // grab this ref and clean up the attribute node
	      var ref = references[ attrs.ref ];
	
	      // if the reference exists, make the link
	      if ( ref ) {
	        delete attrs.ref;
	
	        // add in the href and title, if present
	        attrs.src = ref.href;
	        if ( ref.title ) {
	          attrs.title = ref.title;
	        }
	
	        // get rid of the unneeded original text
	        delete attrs.original;
	      }
	      // the reference doesn't exist, so revert to plain text
	      else {
	        return attrs.original;
	      }
	      break;
	  }
	
	  // convert all the children
	  i = 1;
	
	  // deal with the attribute node, if it exists
	  if ( attrs ) {
	    // if there are keys, skip over it
	    for ( var key in jsonml[ 1 ] ) {
	        i = 2;
	        break;
	    }
	    // if there aren't, remove it
	    if ( i === 1 ) {
	      jsonml.splice( i, 1 );
	    }
	  }
	
	  for ( ; i < jsonml.length; ++i ) {
	    jsonml[ i ] = convert_tree_to_html( jsonml[ i ], references, options );
	  }
	
	  return jsonml;
	}
	
	
	// merges adjacent text nodes into a single node
	function merge_text_nodes( jsonml ) {
	  // skip the tag name and attribute hash
	  var i = extract_attr( jsonml ) ? 2 : 1;
	
	  while ( i < jsonml.length ) {
	    // if it's a string check the next item too
	    if ( typeof jsonml[ i ] === "string" ) {
	      if ( i + 1 < jsonml.length && typeof jsonml[ i + 1 ] === "string" ) {
	        // merge the second string into the first and remove it
	        jsonml[ i ] += jsonml.splice( i + 1, 1 )[ 0 ];
	      }
	      else {
	        ++i;
	      }
	    }
	    // if it's not a string recurse
	    else {
	      merge_text_nodes( jsonml[ i ] );
	      ++i;
	    }
	  }
	}
	
	} )( (function() {
	  if ( false ) {
	    window.markdown = {};
	    return window.markdown;
	  }
	  else {
	    return exports;
	  }
	} )() );


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1213);
	var invariant = __webpack_require__(1214);
	var ReactPropTypesSecret = __webpack_require__(1212);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1212 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1213 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(568);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Raven.js 1.3.0 (768fdca) | github.com/getsentry/raven-js */
	
	/*
	 * Includes TraceKit
	 * https://github.com/getsentry/TraceKit
	 *
	 * Copyright 2015 Matt Robenolt and other contributors
	 * Released under the BSD license
	 * https://github.com/getsentry/raven-js/blob/master/LICENSE
	 *
	 */
	;(function(window, undefined){
	'use strict';
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	 MIT license
	*/
	
	var TraceKit = {
	    remoteFetching: false,
	    collectWindowErrors: true,
	    // 3 lines before, the offending line, 3 lines after
	    linesOfContext: 7,
	    debug: false
	};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	
	function getLocationHref() {
	    if (typeof document === 'undefined')
	        return '';
	
	    return document.location.href;
	};
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (hasKey(handlers, i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	            location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
	            location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
	            stack = {
	                'message': message,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = window.onerror;
	        window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        window.setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    var sourceCache = {};
	
	    /**
	     * Attempts to retrieve source code via XMLHttpRequest, which is used
	     * to look up anonymous function names.
	     * @param {string} url URL of source code.
	     * @return {string} Source contents.
	     */
	    function loadSource(url) {
	        if (!TraceKit.remoteFetching) { //Only attempt request if remoteFetching is on.
	            return '';
	        }
	        try {
	            var getXHR = function() {
	                try {
	                    return new window.XMLHttpRequest();
	                } catch (e) {
	                    // explicitly bubble up the exception if not found
	                    return new window.ActiveXObject('Microsoft.XMLHTTP');
	                }
	            };
	
	            var request = getXHR();
	            request.open('GET', url, false);
	            request.send('');
	            return request.responseText;
	        } catch (e) {
	            return '';
	        }
	    }
	
	    /**
	     * Retrieves source code from the source code cache.
	     * @param {string} url URL of source code.
	     * @return {Array.<string>} Source contents.
	     */
	    function getSource(url) {
	        if (!isString(url)) return [];
	        if (!hasKey(sourceCache, url)) {
	            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
	            // cross-domain errors will be triggered.
	            var source = '';
	            var domain = '';
	            try { domain = document.domain; } catch (e) {}
	            if (url.indexOf(domain) !== -1) {
	                source = loadSource(url);
	            }
	            sourceCache[url] = source ? source.split('\n') : [];
	        }
	
	        return sourceCache[url];
	    }
	
	    /**
	     * Tries to use an externally loaded copy of source code to determine
	     * the name of a function by looking at the name of the variable it was
	     * assigned to, if any.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} lineNo Line number in source code.
	     * @return {string} The function name, if discoverable.
	     */
	    function guessFunctionName(url, lineNo) {
	        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
	            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
	            line = '',
	            maxLines = 10,
	            source = getSource(url),
	            m;
	
	        if (!source.length) {
	            return UNKNOWN_FUNCTION;
	        }
	
	        // Walk backwards from the first line in the function until we find the line which
	        // matches the pattern above, which is the function definition
	        for (var i = 0; i < maxLines; ++i) {
	            line = source[lineNo - i] + line;
	
	            if (!isUndefined(line)) {
	                if ((m = reGuessFunction.exec(line))) {
	                    return m[1];
	                } else if ((m = reFunctionArgNames.exec(line))) {
	                    return m[1];
	                }
	            }
	        }
	
	        return UNKNOWN_FUNCTION;
	    }
	
	    /**
	     * Retrieves the surrounding lines from where an exception occurred.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} line Line number in source code to centre
	     * around for context.
	     * @return {?Array.<string>} Lines of source code.
	     */
	    function gatherContext(url, line) {
	        var source = getSource(url);
	
	        if (!source.length) {
	            return null;
	        }
	
	        var context = [],
	            // linesBefore & linesAfter are inclusive with the offending line.
	            // if linesOfContext is even, there will be one extra line
	            //   *before* the offending line.
	            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
	            // Add one extra line if linesOfContext is odd
	            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
	            start = Math.max(0, line - linesBefore - 1),
	            end = Math.min(source.length, line + linesAfter - 1);
	
	        line -= 1; // convert to 0-based index
	
	        for (var i = start; i < end; ++i) {
	            if (!isUndefined(source[i])) {
	                context.push(source[i]);
	            }
	        }
	
	        return context.length > 0 ? context : null;
	    }
	
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    /**
	     * Determines where a code fragment occurs in the source code.
	     * @param {RegExp} re The function definition.
	     * @param {Array.<string>} urls A list of URLs to search.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceInUrls(re, urls) {
	        var source, m;
	        for (var i = 0, j = urls.length; i < j; ++i) {
	            // console.log('searching', urls[i]);
	            if ((source = getSource(urls[i])).length) {
	                source = source.join('\n');
	                if ((m = re.exec(source))) {
	                    // console.log('Found function in ' + urls[i]);
	
	                    return {
	                        'url': urls[i],
	                        'line': source.substring(0, m.index).split('\n').length,
	                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
	                    };
	                }
	            }
	        }
	
	        // console.log('no match');
	
	        return null;
	    }
	
	    /**
	     * Determines at which column a code fragment occurs on a line of the
	     * source code.
	     * @param {string} fragment The code fragment.
	     * @param {string} url The URL to search.
	     * @param {(string|number)} line The line number to examine.
	     * @return {?number} The column number.
	     */
	    function findSourceInLine(fragment, url, line) {
	        var source = getSource(url),
	            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
	            m;
	
	        line -= 1;
	
	        if (source && source.length > line && (m = re.exec(source[line]))) {
	            return m.index;
	        }
	
	        return null;
	    }
	
	    /**
	     * Determines where a function was defined within the source code.
	     * @param {(Function|string)} func A function reference or serialized
	     * function definition.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceByFunctionBody(func) {
	        if (typeof document === 'undefined')
	            return;
	
	        var urls = [window.location.href],
	            scripts = document.getElementsByTagName('script'),
	            body,
	            code = '' + func,
	            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            re,
	            parts,
	            result;
	
	        for (var i = 0; i < scripts.length; ++i) {
	            var script = scripts[i];
	            if (script.src) {
	                urls.push(script.src);
	            }
	        }
	
	        if (!(parts = codeRE.exec(code))) {
	            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
	        }
	
	        // not sure if this is really necessary, but I don’t have a test
	        // corpus large enough to confirm that and it was in the original.
	        else {
	            var name = parts[1] ? '\\s+' + parts[1] : '',
	                args = parts[2].split(',').join('\\s*,\\s*');
	
	            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
	            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
	        }
	
	        // look for a normal function definition
	        if ((result = findSourceInUrls(re, urls))) {
	            return result;
	        }
	
	        // look for an old-school event handler function
	        if ((parts = eventRE.exec(code))) {
	            var event = parts[1];
	            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);
	
	            // look for a function defined in HTML as an onXXX handler
	            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');
	
	            if ((result = findSourceInUrls(re, urls[0]))) {
	                return result;
	            }
	
	            // look for ???
	            re = new RegExp(body);
	
	            if ((result = findSourceInUrls(re, urls))) {
	                return result;
	            }
	        }
	
	        return null;
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (isUndefined(ex.stack) || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(?((?:(?:file|https?|chrome-extension):.*?)|<anonymous>):(\d+)(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?@((?:file|https?|chrome).*?):(\d+)(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : '',
	                    'line': +parts[4],
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else if ((parts = chrome.exec(lines[i]))) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = winjs.exec(lines[i]))) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = guessFunctionName(element.url, element.line);
	            }
	
	            if (element.line) {
	                element.context = gatherContext(element.url, element.line);
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (stack[0].line && !stack[0].column && reference) {
	            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
	        } else if (!stack[0].column && !isUndefined(ex.columnNumber)) {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Computes stack trace information from the stacktrace property.
	     * Opera 10 uses this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStacktraceProp(ex) {
	        // Access and store the stacktrace property before doing ANYTHING
	        // else to it because Opera is not very good at providing it
	        // reliably in other circumstances.
	        var stacktrace = ex.stacktrace;
	        if (isUndefined(ex.stacktrace) || !ex.stacktrace) return;
	
	        var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
	            lines = stacktrace.split('\n'),
	            stack = [],
	            parts;
	
	        for (var i = 0, j = lines.length; i < j; i += 2) {
	            if ((parts = testRE.exec(lines[i]))) {
	                var element = {
	                    'line': +parts[1],
	                    'column': +parts[2],
	                    'func': parts[3] || parts[4],
	                    'args': parts[5] ? parts[5].split(',') : [],
	                    'url': parts[6]
	                };
	
	                if (!element.func && element.line) {
	                    element.func = guessFunctionName(element.url, element.line);
	                }
	                if (element.line) {
	                    try {
	                        element.context = gatherContext(element.url, element.line);
	                    } catch (exc) {}
	                }
	
	                if (!element.context) {
	                    element.context = [lines[i + 1]];
	                }
	
	                stack.push(element);
	            }
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * NOT TESTED.
	     * Computes stack trace information from an error message that includes
	     * the stack trace.
	     * Opera 9 and earlier use this method if the option to show stack
	     * traces is turned on in opera:config.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack information.
	     */
	    function computeStackTraceFromOperaMultiLineMessage(ex) {
	        // Opera includes a stack trace into the exception message. An example is:
	        //
	        // Statement on line 3: Undefined variable: undefinedFunc
	        // Backtrace:
	        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
	        //         undefinedFunc(a);
	        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
	        //           zzz(x, y, z);
	        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
	        //           yyy(a, a, a);
	        //   Line 1 of function script
	        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
	        //   ...
	
	        var lines = ex.message.split('\n');
	        if (lines.length < 4) {
	            return null;
	        }
	
	        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
	            stack = [],
	            scripts = document.getElementsByTagName('script'),
	            inlineScriptBlocks = [],
	            parts,
	            i,
	            len,
	            source;
	
	        for (i in scripts) {
	            if (hasKey(scripts, i) && !scripts[i].src) {
	                inlineScriptBlocks.push(scripts[i]);
	            }
	        }
	
	        for (i = 2, len = lines.length; i < len; i += 2) {
	            var item = null;
	            if ((parts = lineRE1.exec(lines[i]))) {
	                item = {
	                    'url': parts[2],
	                    'func': parts[3],
	                    'line': +parts[1]
	                };
	            } else if ((parts = lineRE2.exec(lines[i]))) {
	                item = {
	                    'url': parts[3],
	                    'func': parts[4]
	                };
	                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
	                var script = inlineScriptBlocks[parts[2] - 1];
	                if (script) {
	                    source = getSource(item.url);
	                    if (source) {
	                        source = source.join('\n');
	                        var pos = source.indexOf(script.innerText);
	                        if (pos >= 0) {
	                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
	                        }
	                    }
	                }
	            } else if ((parts = lineRE3.exec(lines[i]))) {
	                var url = window.location.href.replace(/#.*$/, ''),
	                    line = parts[1];
	                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
	                source = findSourceInUrls(re, [url]);
	                item = {
	                    'url': url,
	                    'line': source ? source.line : line,
	                    'func': ''
	                };
	            }
	
	            if (item) {
	                if (!item.func) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	                var context = gatherContext(item.url, item.line);
	                var midline = (context ? context[Math.floor(context.length / 2)] : null);
	                if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
	                    item.context = context;
	                } else {
	                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
	                    item.context = [lines[i + 1]];
	                }
	                stack.push(item);
	            }
	        }
	        if (!stack.length) {
	            return null; // could not parse multiline exception message as Opera stack trace
	        }
	
	        return {
	            'name': ex.name,
	            'message': lines[0],
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = guessFunctionName(initial.url, initial.line);
	            }
	
	            if (!initial.context) {
	                initial.context = gatherContext(initial.url, initial.line);
	            }
	
	            var reference = / '([^']+)' /.exec(message);
	            if (reference) {
	                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        stackInfo.stack[0].context = initial.context;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if ((source = findSourceByFunctionBody(curr))) {
	                item.url = source.url;
	                item.line = source.line;
	
	                if (item.func === UNKNOWN_FUNCTION) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	
	                var reference = / '([^']+)' /.exec(ex.message || ex.description);
	                if (reference) {
	                    item.column = findSourceInLine(reference[1], source.url, source.line);
	                }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            // This must be tried first because Opera 10 *destroys*
	            // its stacktrace property if you try to access the stack
	            // property first!!
	            stack = computeStackTraceFromStacktraceProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromOperaMultiLineMessage(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	    computeStackTrace.guessFunctionName = guessFunctionName;
	    computeStackTrace.gatherContext = gatherContext;
	
	    return computeStackTrace;
	}());
	
	'use strict';
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	var _Raven = window.Raven,
	    hasJSON = !!(typeof JSON === 'object' && JSON.stringify),
	    // Raven can run in contexts where there's no document (react-native)
	    hasDocument = typeof document !== 'undefined',
	    lastCapturedException,
	    lastEventId,
	    globalServer,
	    globalKey,
	    globalProject,
	    globalContext = {},
	    globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        crossOrigin: 'anonymous',
	        collectWindowErrors: true,
	        maxMessageLength: 100
	    },
	    isRavenInstalled = false,
	    objectPrototype = Object.prototype,
	    // capture references to window.console *and* all its methods first
	    // before the console plugin has a chance to monkey patch
	    originalConsole = window.console || {},
	    originalConsoleMethods = {},
	    plugins = [],
	    startTime = now();
	
	for (var method in originalConsole) {
	  originalConsoleMethods[method] = originalConsole[method];
	}
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	var Raven = {
	    VERSION: '1.3.0',
	
	    debug: false,
	
	    /*
	     * Allow multiple versions of Raven to be installed.
	     * Strip Raven from the global context and returns the instance.
	     *
	     * @return {Raven}
	     */
	    noConflict: function() {
	        window.Raven = _Raven;
	        return Raven;
	    },
	
	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        if (globalServer) {
	            logDebug('error', 'Error: Raven has already been configured');
	            return Raven;
	        }
	        if (!dsn) return Raven;
	
	        var uri = parseDSN(dsn),
	            lastSlash = uri.path.lastIndexOf('/'),
	            path = uri.path.substr(1, lastSlash);
	
	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                // tags and extra are special and need to be put into context
	                if (key == 'tags' || key == 'extra') {
	                    globalContext[key] = value;
	                } else {
	                    globalOptions[key] = value;
	                }
	            });
	        }
	
	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        globalOptions.ignoreErrors.push(/^Script error\.?$/);
	        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	        // join regexp rules into one big rule
	        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
	        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
	        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	
	        globalKey = uri.user;
	        globalProject = uri.path.substr(lastSlash + 1);
	
	        // assemble the endpoint from the uri pieces
	        globalServer = '//' + uri.host +
	                      (uri.port ? ':' + uri.port : '') +
	                      '/' + path + 'api/' + globalProject + '/store/';
	
	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }
	
	        if (globalOptions.fetchContext) {
	            TraceKit.remoteFetching = true;
	        }
	
	        if (globalOptions.linesOfContext) {
	            TraceKit.linesOfContext = globalOptions.linesOfContext;
	        }
	
	        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	        // return for chaining
	        return Raven;
	    },
	
	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        if (isSetup() && !isRavenInstalled) {
	            TraceKit.report.subscribe(handleStackInfo);
	
	            // Install all of the plugins
	            each(plugins, function(_, plugin) {
	                plugin();
	            });
	
	            isRavenInstalled = true;
	        }
	
	        return Raven;
	    },
	
	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }
	
	        return Raven.wrap(options, func).apply(this, args);
	    },
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func) {
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }
	
	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }
	
	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }
	
	        // We don't wanna wrap it twice!
	        if (func.__raven__) {
	            return func;
	        }
	
	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.
	
	            while(i--) args[i] = deep ? Raven.wrap(options, arguments[i]) : arguments[i];
	
	            try {
	                /*jshint -W040*/
	                return func.apply(this, args);
	            } catch(e) {
	                Raven.captureException(e, options);
	                throw e;
	            }
	        }
	
	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }
	        wrapped.prototype = func.prototype;
	
	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;
	
	        return wrapped;
	    },
	
	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	        isRavenInstalled = false;
	
	        return Raven;
	    },
	
	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!isError(ex)) return Raven.captureMessage(ex, options);
	
	        // Store the raw exception object for potential debugging and introspection
	        lastCapturedException = ex;
	
	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            var stack = TraceKit.computeStackTrace(ex);
	            handleStackInfo(stack, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }
	
	        return Raven;
	    },
	
	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	        // early call; we'll error on the side of logging anything called before configuration since it's
	        // probably something you should see:
	        if (!!globalOptions.ignoreErrors.test && globalOptions.ignoreErrors.test(msg)) {
	            return;
	        }
	
	        // Fire away!
	        send(
	            objectMerge({
	                message: msg + ''  // Make sure it's actually a string
	            }, options)
	        );
	
	        return Raven;
	    },
	
	    addPlugin: function(plugin) {
	        plugins.push(plugin);
	        if (isRavenInstalled) plugin();
	        return Raven;
	    },
	
	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	        // Intentionally do not merge here since that's an unexpected behavior.
	        globalContext.user = user;
	
	        return Raven;
	    },
	
	    /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	        mergeContext('extra', extra);
	
	        return Raven;
	    },
	
	    /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	        mergeContext('tags', tags);
	
	        return Raven;
	    },
	
	    /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	    clearContext: function() {
	        globalContext = {};
	
	        return Raven;
	    },
	
	    /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	    getContext: function() {
	        // lol javascript
	        return JSON.parse(JSON.stringify(globalContext));
	    },
	
	    /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	    setRelease: function(release) {
	        globalOptions.release = release;
	
	        return Raven;
	    },
	
	    /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	    setDataCallback: function(callback) {
	        globalOptions.dataCallback = callback;
	
	        return Raven;
	    },
	
	    /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	    setShouldSendCallback: function(callback) {
	        globalOptions.shouldSendCallback = callback;
	
	        return Raven;
	    },
	
	    /**
	     * Override the default HTTP transport mechanism that transmits data
	     * to the Sentry server.
	     *
	     * @param {function} transport Function invoked instead of the default
	     *                             `makeRequest` handler.
	     *
	     * @return {Raven}
	     */
	    setTransport: function(transport) {
	        globalOptions.transport = transport;
	
	        return Raven;
	    },
	
	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return lastCapturedException;
	    },
	
	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return lastEventId;
	    },
	
	    /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	    isSetup: function() {
	        return isSetup();
	    }
	};
	
	// Deprecations
	Raven.setUser = Raven.setUserContext;
	Raven.setReleaseContext = Raven.setRelease;
	
	function triggerEvent(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!hasDocument)
	        return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);
	
	    if (document.createEvent) {
	        evt = document.createEvent('HTMLEvents');
	        evt.initEvent(eventType, true, true);
	    } else {
	        evt = document.createEventObject();
	        evt.eventType = eventType;
	    }
	
	    for (key in options) if (hasKey(options, key)) {
	        evt[key] = options[key];
	    }
	
	    if (document.createEvent) {
	        // IE9 if standards
	        document.dispatchEvent(evt);
	    } else {
	        // IE8 regardless of Quirks or Standards
	        // IE9 if quirks
	        try {
	            document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	        } catch(e) {}
	    }
	}
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	/**** Private functions ****/
	function parseDSN(str) {
	    var m = dsnPattern.exec(str),
	        dsn = {},
	        i = 7;
	
	    try {
	        while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch(e) {
	        throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass)
	        throw new RavenConfigError('Do not specify your private key in the DSN!');
	
	    return dsn;
	}
	
	function isUndefined(what) {
	    return what === void 0;
	}
	
	function isFunction(what) {
	    return typeof what === 'function';
	}
	
	function isString(what) {
	    return objectPrototype.toString.call(what) === '[object String]';
	}
	
	function isObject(what) {
	    return typeof what === 'object' && what !== null;
	}
	
	function isEmptyObject(what) {
	    for (var k in what) return false;
	    return true;
	}
	
	// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
	// with some tiny modifications
	function isError(what) {
	    return isObject(what) &&
	        objectPrototype.toString.call(what) === '[object Error]' ||
	        what instanceof Error;
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	function each(obj, callback) {
	    var i, j;
	
	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}
	
	function handleStackInfo(stackInfo, options) {
	    var frames = [];
	
	    if (stackInfo.stack && stackInfo.stack.length) {
	        each(stackInfo.stack, function(i, stack) {
	            var frame = normalizeFrame(stack);
	            if (frame) {
	                frames.push(frame);
	            }
	        });
	    }
	
	    triggerEvent('handle', {
	        stackInfo: stackInfo,
	        options: options
	    });
	
	    processException(
	        stackInfo.name,
	        stackInfo.message,
	        stackInfo.url,
	        stackInfo.lineno,
	        frames,
	        options
	    );
	}
	
	function normalizeFrame(frame) {
	    if (!frame.url) return;
	
	    // normalize the frames data
	    var normalized = {
	        filename:   frame.url,
	        lineno:     frame.line,
	        colno:      frame.column,
	        'function': frame.func || '?'
	    }, context = extractContextFromFrame(frame), i;
	
	    if (context) {
	        var keys = ['pre_context', 'context_line', 'post_context'];
	        i = 3;
	        while (i--) normalized[keys[i]] = context[i];
	    }
	
	    normalized.in_app = !( // determine if an exception came from outside of our app
	        // first we check the global includePaths list.
	        (!!globalOptions.includePaths.test && !globalOptions.includePaths.test(normalized.filename)) ||
	        // Now we check for fun, if the function name is Raven or TraceKit
	        /(Raven|TraceKit)\./.test(normalized['function']) ||
	        // finally, we do a last ditch effort and check for raven.min.js
	        /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	}
	
	function extractContextFromFrame(frame) {
	    // immediately check if we should even attempt to parse a context
	    if (!frame.context || !globalOptions.fetchContext) return;
	
	    var context = frame.context,
	        pivot = ~~(context.length / 2),
	        i = context.length, isMinified = false;
	
	    while (i--) {
	        // We're making a guess to see if the source is minified or not.
	        // To do that, we make the assumption if *any* of the lines passed
	        // in are greater than 300 characters long, we bail.
	        // Sentry will see that there isn't a context
	        if (context[i].length > 300) {
	            isMinified = true;
	            break;
	        }
	    }
	
	    if (isMinified) {
	        // The source is minified and we don't know which column. Fuck it.
	        if (isUndefined(frame.column)) return;
	
	        // If the source is minified and has a frame column
	        // we take a chunk of the offending line to hopefully shed some light
	        return [
	            [],  // no pre_context
	            context[pivot].substr(frame.column, 50), // grab 50 characters, starting at the offending column
	            []   // no post_context
	        ];
	    }
	
	    return [
	        context.slice(0, pivot),    // pre_context
	        context[pivot],             // context_line
	        context.slice(pivot + 1)    // post_context
	    ];
	}
	
	function processException(type, message, fileurl, lineno, frames, options) {
	    var stacktrace, i, fullMessage;
	
	    if (!!globalOptions.ignoreErrors.test && globalOptions.ignoreErrors.test(message)) return;
	
	    message += '';
	    fullMessage = type + ': ' + message;
	
	    if (frames && frames.length) {
	        fileurl = frames[0].filename || fileurl;
	        // Sentry expects frames oldest to newest
	        // and JS sends them as newest to oldest
	        frames.reverse();
	        stacktrace = {frames: frames};
	    } else if (fileurl) {
	        stacktrace = {
	            frames: [{
	                filename: fileurl,
	                lineno: lineno,
	                in_app: true
	            }]
	        };
	    }
	
	    if (!!globalOptions.ignoreUrls.test && globalOptions.ignoreUrls.test(fileurl)) return;
	    if (!!globalOptions.whitelistUrls.test && !globalOptions.whitelistUrls.test(fileurl)) return;
	
	    // Fire away!
	    send(
	        objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                values: [{
	                    type: type,
	                    value: message,
	                    stacktrace: stacktrace
	                }]
	            },
	            culprit: fileurl,
	            message: fullMessage
	        }, options)
	    );
	}
	
	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}
	
	function truncate(str, max) {
	    return str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	function trimPacket(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = globalOptions.maxMessageLength;
	    data.message = truncate(data.message, max);
	    if (data.exception) {
	        var exception = data.exception.values[0];
	        exception.value = truncate(exception.value, max);
	    }
	
	    return data;
	}
	
	function now() {
	    return +new Date();
	}
	
	function getHttpData() {
	    if (!hasDocument || !document.location || !document.location.href) {
	        return;
	    }
	
	    var httpData = {
	        headers: {
	            'User-Agent': navigator.userAgent
	        }
	    };
	
	    httpData.url = document.location.href;
	
	    if (document.referrer) {
	        httpData.headers.Referer = document.referrer;
	    }
	
	    return httpData;
	}
	
	function send(data) {
	    var baseData = {
	        project: globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	    }, httpData = getHttpData();
	
	    if (httpData) {
	        baseData.request = httpData;
	    }
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - startTime;
	
	    // If there are no tags/extra, strip the key from the payload alltogther.
	    if (isEmptyObject(data.tags)) delete data.tags;
	
	    if (globalContext.user) {
	        // sentry.interfaces.User
	        data.user = globalContext.user;
	    }
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    if (isFunction(globalOptions.dataCallback)) {
	        data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	        return;
	    }
	
	    // Check if the request should be filtered or not
	    if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	        return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    lastEventId = data.event_id || (data.event_id = uuid4());
	
	    // Try and clean up the packet before sending by truncating long values
	    data = trimPacket(data);
	
	    logDebug('debug', 'Raven about to send:', data);
	
	    if (!isSetup()) return;
	
	    (globalOptions.transport || makeRequest)({
	        url: globalServer,
	        auth: {
	            sentry_version: '7',
	            sentry_client: 'raven-js/' + Raven.VERSION,
	            sentry_key: globalKey
	        },
	        data: data,
	        options: globalOptions,
	        onSuccess: function success() {
	            triggerEvent('success', {
	                data: data,
	                src: globalServer
	            });
	        },
	        onError: function failure() {
	            triggerEvent('failure', {
	                data: data,
	                src: globalServer
	            });
	        }
	    });
	}
	
	function makeRequest(opts) {
	    // Tack on sentry_data to auth options, which get urlencoded
	    opts.auth.sentry_data = JSON.stringify(opts.data);
	
	    var img = newImage(),
	        src = opts.url + '?' + urlencode(opts.auth),
	        crossOrigin = opts.options.crossOrigin;
	
	    if (crossOrigin || crossOrigin === '') {
	        img.crossOrigin = crossOrigin;
	    }
	    img.onload = opts.onSuccess;
	    img.onerror = img.onabort = opts.onError;
	    img.src = src;
	}
	
	// Note: this is shitty, but I can't figure out how to get
	// sinon to stub document.createElement without breaking everything
	// so this wrapper is just so I can stub it for tests.
	function newImage() {
	    return document.createElement('img');
	}
	
	var ravenNotConfiguredError;
	
	function isSetup() {
	    if (!hasJSON) return false;  // needs JSON support
	    if (!globalServer) {
	        if (!ravenNotConfiguredError)
	          logDebug('error', 'Error: Raven has not been configured.');
	        ravenNotConfiguredError = true;
	        return false;
	    }
	    return true;
	}
	
	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;
	
	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	
	function uuid4() {
	    var crypto = window.crypto || window.msCrypto;
	
	    if (!isUndefined(crypto) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	
	        // set 4 in byte 7
	        arr[3] = arr[3] & 0xFFF | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        arr[4] = arr[4] & 0x3FFF | 0x8000;
	
	        var pad = function(num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = '0' + v;
	            }
	            return v;
	        };
	
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
	        pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    } else {
	        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = Math.random()*16|0,
	                v = c == 'x' ? r : (r&0x3|0x8);
	            return v.toString(16);
	        });
	    }
	}
	
	function logDebug(level) {
	    if (originalConsoleMethods[level] && Raven.debug) {
	        // _slice is coming from vendor/TraceKit/tracekit.js
	        // so it's accessible globally
	        originalConsoleMethods[level].apply(originalConsole, _slice.call(arguments, 1));
	    }
	}
	
	function afterLoad() {
	    // Attempt to initialize Raven on load
	    var RavenConfig = window.RavenConfig;
	    if (RavenConfig) {
	        Raven.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	}
	
	function urlencode(o) {
	    var pairs = [];
	    each(o, function(key, value) {
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    });
	    return pairs.join('&');
	}
	
	function mergeContext(key, context) {
	    if (isUndefined(context)) {
	        delete globalContext[key];
	    } else {
	        globalContext[key] = objectMerge(globalContext[key] || {}, context);
	    }
	}
	
	afterLoad();
	
	// This is being exposed no matter what because there are too many weird
	// usecases for how people use Raven. If this is really a problem, I'm sorry.
	window.Raven = Raven;
	
	// Expose Raven to the world
	if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return Raven;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object') {
	    // browserify
	    module.exports = Raven;
	} else if (typeof exports === 'object') {
	    // CommonJS
	    exports = Raven;
	}
	
	})(typeof window !== 'undefined' ? window : this);


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(1289);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(120);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetConstantsJs = __webpack_require__(1218);
	
	var _PlainComponent = __webpack_require__(1219);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = [].concat(_toConsumableArray(propsList)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var props = _step.value;
	
	            if (props[property]) {
	                return props[property];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	                _iterator["return"]();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        return innermostTemplate.replace(/\%s/g, innermostTitle);
	    }
	
	    return innermostTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(validTags, propsList) {
	    return propsList.filter(function (props) {
	        return !Object.is(typeof props[_HelmetConstantsJs.TAG_NAMES.BASE], "undefined");
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.keys(tag)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var attributeKey = _step2.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    if (validTags.includes(lowerCaseAttributeKey)) {
	                        return innermostBaseTag.concat(tag);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	                        _iterator2["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, validTags, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = new Map();
	
	    var tagList = propsList.filter(function (props) {
	        return !Object.is(typeof props[tagName], "undefined");
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = new Map();
	
	        instanceTags.filter(function (tag) {
	            var validAttributeKey = undefined;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = Object.keys(tag)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var attributeKey = _step3.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    // Special rule with link tags, since rel and href are both valid tags, rel takes priority
	                    if (validTags.includes(lowerCaseAttributeKey) && !(Object.is(validAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[validAttributeKey].toLowerCase(), "canonical")) && !(Object.is(lowerCaseAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[lowerCaseAttributeKey].toLowerCase(), "stylesheet"))) {
	                        validAttributeKey = lowerCaseAttributeKey;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
	                        _iterator3["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            if (!validAttributeKey) {
	                return false;
	            }
	
	            var value = tag[validAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags.has(validAttributeKey)) {
	                approvedSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!instanceSeenTags.has(validAttributeKey)) {
	                instanceSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!approvedSeenTags.get(validAttributeKey).has(value)) {
	                instanceSeenTags.get(validAttributeKey).add(value);
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = instanceSeenTags.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var attributeKey = _step4.value;
	
	                var tagUnion = new Set([].concat(_toConsumableArray(approvedSeenTags.get(attributeKey)), _toConsumableArray(instanceSeenTags.get(attributeKey))));
	
	                approvedSeenTags.set(attributeKey, tagUnion);
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4["return"]) {
	                    _iterator4["return"]();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        instanceSeenTags.clear();
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var oldTags = [].concat(_toConsumableArray(headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]")));
	    var newTags = [];
	    var indexToDelete = undefined;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    newElement.setAttribute(attribute, tag[attribute]);
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).map(function (attribute) {
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ");
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (Object.is(type, _HelmetConstantsJs.TAG_NAMES.SCRIPT) ? "></" + type + ">" : "/>");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2["default"].createElement(_HelmetConstantsJs.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = [].concat(_toConsumableArray(tags)).map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstantsJs.REACT_TAG_MAP[attribute] || attribute;
	
	            mappedTag[mappedAttribute] = tag[attribute];
	        });
	
	        return _react2["default"].createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    return {
	        toComponent: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsReactComponent(type, tags);
	        } : function () {
	            return generateTagsAsReactComponent(type, tags);
	        },
	        toString: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsString(type, tags);
	        } : function () {
	            return generateTagsAsString(type, tags);
	        }
	    };
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var title = _ref.title;
	    var baseTag = _ref.baseTag;
	    var metaTags = _ref.metaTags;
	    var linkTags = _ref.linkTags;
	    var scriptTags = _ref.scriptTags;
	    return {
	        title: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	
	    var HelmetWrapper = (function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            _get(Object.getPrototypeOf(HelmetWrapper.prototype), "constructor", this).apply(this, arguments);
	        }
	
	        /* eslint-enable react/no-multi-comp */
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2["default"])(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2["default"].createElement(Component, this.props);
	            }
	        }], [{
	            key: "propTypes",
	
	            /**
	             * @param {String} title: "Title"
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"src": "http://mysite.com/js/test.js", "type": "text/javascript"}]
	             */
	            value: {
	                title: _react2["default"].PropTypes.string,
	                onChangeClientState: _react2["default"].PropTypes.func,
	                titleTemplate: _react2["default"].PropTypes.string,
	                base: _react2["default"].PropTypes.object,
	                meta: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                link: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                script: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object)
	            },
	            enumerable: true
	        }, {
	            key: "peek",
	            value: Component.peek,
	            enumerable: true
	        }, {
	            key: "rewind",
	            value: function value() {
	                var mappedState = Component.rewind();
	                if (!mappedState) {
	                    // provide fallback if mappedState is undefined
	                    mappedState = mapStateOnServer({
	                        title: "",
	                        baseTag: [],
	                        metaTags: [],
	                        linkTags: [],
	                        scriptTags: []
	                    });
	                }
	
	                return mappedState;
	            },
	            enumerable: true
	        }, {
	            key: "canUseDOM",
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    })(_react2["default"].Component);
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        title: getTitleFromPropsList(propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.META, [_HelmetConstantsJs.TAG_PROPERTIES.NAME, _HelmetConstantsJs.TAG_PROPERTIES.CHARSET, _HelmetConstantsJs.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstantsJs.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.LINK, [_HelmetConstantsJs.TAG_PROPERTIES.REL, _HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.SCRIPT, [_HelmetConstantsJs.TAG_PROPERTIES.SRC], propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var title = newState.title;
	    var baseTag = newState.baseTag;
	    var metaTags = newState.metaTags;
	    var linkTags = newState.linkTags;
	    var scriptTags = newState.scriptTags;
	    var onChangeClientState = newState.onChangeClientState;
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        scriptTags: updateTags(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        linkTags: updateTags(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        baseTag: updateTags(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType];
	        var newTags = _tagUpdates$tagType.newTags;
	        var oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2["default"])(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports["default"] = Helmet(SideEffect(_PlainComponent2["default"]));
	module.exports = exports["default"];

/***/ },
/* 1218 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TAG_NAMES = {
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script"
	};
	
	exports.TAG_NAMES = TAG_NAMES;
	var TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src"
	};
	
	exports.TAG_PROPERTIES = TAG_PROPERTIES;
	var REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};
	exports.REACT_TAG_MAP = REACT_TAG_MAP;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PlainComponent = (function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        _get(Object.getPrototypeOf(PlainComponent.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	})(_react2["default"].Component);
	
	exports["default"] = PlainComponent;
	module.exports = exports["default"];

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(315);
	__webpack_require__(1241);
	module.exports = __webpack_require__(60).Array.from;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1248);
	module.exports = __webpack_require__(60).Array.includes;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(521);
	__webpack_require__(315);
	__webpack_require__(522);
	__webpack_require__(1243);
	__webpack_require__(1249);
	module.exports = __webpack_require__(60).Map;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1247);
	module.exports = __webpack_require__(60).Object.getOwnPropertySymbols;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1244);
	module.exports = __webpack_require__(60).Object.is;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1245);
	module.exports = __webpack_require__(60).Object.keys;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(521);
	__webpack_require__(315);
	__webpack_require__(522);
	__webpack_require__(1246);
	__webpack_require__(1250);
	module.exports = __webpack_require__(60).Set;

/***/ },
/* 1227 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(308);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(165)
	  , toLength  = __webpack_require__(314)
	  , toIndex   = __webpack_require__(1240);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(59);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(165)
	  , getNames  = __webpack_require__(59).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : getNames(toIObject(it));
	};

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(307);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(307);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(59)
	  , descriptor     = __webpack_require__(312)
	  , setToStringTag = __webpack_require__(218)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(124)(IteratorPrototype, __webpack_require__(61)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(59)
	  , toIObject = __webpack_require__(165);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(92)
	  , core    = __webpack_require__(60)
	  , fails   = __webpack_require__(163);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 1237 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(105)
	  , $           = __webpack_require__(59)
	  , DESCRIPTORS = __webpack_require__(216)
	  , SPECIES     = __webpack_require__(61)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(313)
	  , defined   = __webpack_require__(215);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(313)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(214)
	  , $export     = __webpack_require__(92)
	  , toObject    = __webpack_require__(519)
	  , call        = __webpack_require__(513)
	  , isArrayIter = __webpack_require__(512)
	  , toLength    = __webpack_require__(314)
	  , getIterFn   = __webpack_require__(520);
	$export($export.S + $export.F * !__webpack_require__(514)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(507)
	  , step             = __webpack_require__(515)
	  , Iterators        = __webpack_require__(164)
	  , toIObject        = __webpack_require__(165);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(310)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(509);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(511)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(92);
	$export($export.S, 'Object', {is: __webpack_require__(1237)});

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(519);
	
	__webpack_require__(1236)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(509);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(511)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(59)
	  , global         = __webpack_require__(105)
	  , core           = __webpack_require__(60)
	  , has            = __webpack_require__(217)
	  , DESCRIPTORS    = __webpack_require__(216)
	  , $export        = __webpack_require__(92)
	  , redefine       = __webpack_require__(125)
	  , META           = __webpack_require__(311).KEY
	  , $fails         = __webpack_require__(163)
	  , shared         = __webpack_require__(518)
	  , setToStringTag = __webpack_require__(218)
	  , uid            = __webpack_require__(219)
	  , wks            = __webpack_require__(61)
	  , keyOf          = __webpack_require__(1235)
	  , $names         = __webpack_require__(1231)
	  , enumKeys       = __webpack_require__(1230)
	  , isArray        = __webpack_require__(1233)
	  , anObject       = __webpack_require__(305)
	  , toIObject      = __webpack_require__(165)
	  , createDesc     = __webpack_require__(312)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , ObjectProto    = Object.prototype
	  , USE_NATIVE     = typeof $Symbol == 'function';
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , replacer, $replacer;
	  while(arguments.length > i)args.push(arguments[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var BUGGY_JSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(516)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var Wrapper = core.Symbol
	    , sym     = wks(it);
	  if(!(it in Wrapper))setDesc(Wrapper, it, {value: USE_NATIVE ? sym : wrap(sym)});
	});
	
	setter = true;
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || BUGGY_JSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(92)
	  , $includes = __webpack_require__(1229)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(507)('includes');

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(92);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(510)('Map')});

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(92);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(510)('Set')});

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(316);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(319);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(318);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(212);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(304);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(317);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _react2['default'].createClass({
	  displayName: 'Motion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _react.PropTypes.objectOf(_react.PropTypes.number),
	    style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    onRest: _react.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!destStyle.hasOwnProperty(key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function () {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!propsStyle.hasOwnProperty(key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(316);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(319);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(318);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(212);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(304);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(317);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _react2['default'].createClass({
	  displayName: 'StaggeredMotion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.number)),
	    styles: _react.PropTypes.func.isRequired,
	    children: _react.PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!unreadPropStyle.hasOwnProperty(key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function () {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!destStyle.hasOwnProperty(key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(316);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(319);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(318);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1254);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(212);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(304);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(317);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  if (unreadPropStyles == null) {
	    // $FlowFixMe
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    // $FlowFixMe
	    for (var j = 0; j < unreadPropStyles.length; j++) {
	      // $FlowFixMe
	      if (unreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          // $FlowFixMe
	          key: unreadPropStyles[j].key,
	          data: unreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    // $FlowFixMe
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      // $FlowFixMe
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _react2['default'].createClass({
	  displayName: 'TransitionMotion',
	
	  propTypes: {
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.number).isRequired
	    })),
	    styles: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired
	    }))]).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    willLeave: _react.PropTypes.func,
	    willEnter: _react.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      // $FlowFixMe
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // $FlowFixMe
	    willEnter,
	    // $FlowFixMe
	    willLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(
	    // $FlowFixMe
	    this.props.willEnter,
	    // $FlowFixMe
	    this.props.willLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!unreadPropStyle.hasOwnProperty(key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function () {
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(
	      // $FlowFixMe
	      _this.props.willEnter,
	      // $FlowFixMe
	      _this.props.willLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!newMergedPropsStyle.hasOwnProperty(key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    if (typeof props.styles === 'function') {
	      // $FlowFixMe
	      this.unreadPropStyles = props.styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = props.styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 1254 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!nextKeyIndex.hasOwnProperty(prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!prevKeyIndex.hasOwnProperty(pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!prevKeyIndex.hasOwnProperty(pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1251);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1252);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1253);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1257);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(524);
	
	exports.presets = _interopRequire(_presets);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1256);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(524);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(981);
	
	__webpack_require__(1266);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props = __webpack_require__(525);
	
	var _players = __webpack_require__(1263);
	
	var _players2 = _interopRequireDefault(_players);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ReactPlayer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.seekTo = function (fraction) {
	      var player = _this.refs.player;
	      if (player) {
	        player.seekTo(fraction);
	      }
	    }, _this.progress = function () {
	      if (_this.props.url && _this.refs.player) {
	        var progress = {};
	        var loaded = _this.refs.player.getFractionLoaded();
	        var played = _this.refs.player.getFractionPlayed();
	        if (loaded !== null && loaded !== _this.prevLoaded) {
	          progress.loaded = _this.prevLoaded = loaded;
	        }
	        if (played !== null && played !== _this.prevPlayed && _this.props.playing) {
	          progress.played = _this.prevPlayed = played;
	        }
	        if (progress.loaded || progress.played) {
	          _this.props.onProgress(progress);
	        }
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
	    }, _this.renderPlayer = function (Player) {
	      var active = Player.canPlay(_this.props.url);
	      var _this$props = _this.props;
	      var youtubeConfig = _this$props.youtubeConfig;
	      var soundcloudConfig = _this$props.soundcloudConfig;
	      var vimeoConfig = _this$props.vimeoConfig;
	
	      var activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig']);
	
	      var props = active ? _extends({}, activeProps, { ref: 'player' }) : {};
	      return _react2.default.createElement(Player, _extends({
	        key: Player.displayName,
	        youtubeConfig: youtubeConfig,
	        soundcloudConfig: soundcloudConfig,
	        vimeoConfig: vimeoConfig
	      }, props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: this.props.width,
	        height: this.props.height
	      };
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: this.props.className },
	        _players2.default.map(this.renderPlayer)
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return _players2.default.some(function (player) {
	        return player.canPlay(url);
	      });
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props.propTypes;
	ReactPlayer.defaultProps = _props.defaultProps;
	exports.default = ReactPlayer;
	module.exports = exports['default'];

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Base2 = __webpack_require__(220);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm)($|\?)/;
	var AUDIO_EXTENSIONS = /\.(mp3|wav)($|\?)/;
	
	var FilePlayer = function (_Base) {
	  _inherits(FilePlayer, _Base);
	
	  function FilePlayer() {
	    _classCallCheck(this, FilePlayer);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(FilePlayer).apply(this, arguments));
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.player = this.refs.player;
	      this.player.oncanplay = this.onReady;
	      this.player.onplay = this.onPlay;
	      this.player.onpause = function () {
	        return _this2.props.onPause();
	      };
	      this.player.onended = function () {
	        return _this2.props.onEnded();
	      };
	      this.player.onerror = function (e) {
	        return _this2.props.onError(e);
	      };
	      this.player.setAttribute('webkit-playsinline', '');
	      _get(Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      this.player.src = url;
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.src = '';
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
	      this.player.currentTime = this.getDuration() * fraction;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || this.player.buffered.length === 0) return null;
	      return this.player.buffered.end(0) / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Media = AUDIO_EXTENSIONS.test(this.props.url) ? 'audio' : 'video';
	      var style = { display: this.props.url ? 'block' : 'none' };
	      return _react2.default.createElement(Media, {
	        ref: 'player',
	        style: style,
	        width: '100%',
	        height: '100%',
	        preload: 'auto'
	      });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return VIDEO_EXTENSIONS.test(url) || AUDIO_EXTENSIONS.test(url);
	    }
	  }]);
	
	  return FilePlayer;
	}(_Base3.default);
	
	FilePlayer.displayName = 'FilePlayer';
	exports.default = FilePlayer;
	module.exports = exports['default'];

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(481);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(220);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//connect.soundcloud.com/sdk-2.0.0.js';
	var SDK_GLOBAL = 'SC';
	var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
	var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
	
	var songData = {}; // Cache song data requests
	
	var SoundCloud = function (_Base) {
	  _inherits(SoundCloud, _Base);
	
	  function SoundCloud() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SoundCloud)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _this.onStateChange = function (state) {
	      if (state === 'playing') _this.onPlay();
	      if (state === 'paused') _this.props.onPause();
	      if (state === 'loading') _this.props.onBuffer();
	      if (state === 'ended') _this.props.onEnded();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return _get(Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      var _this2 = this;
	
	      if (window[SDK_GLOBAL]) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        (0, _loadScript2.default)(SDK_URL, function (err) {
	          if (err) {
	            reject(err);
	          } else {
	            window[SDK_GLOBAL].initialize({ client_id: _this2.props.soundcloudConfig.clientId });
	            resolve(window[SDK_GLOBAL]);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getSongData',
	    value: function getSongData(url) {
	      if (songData[url]) {
	        return Promise.resolve(songData[url]);
	      }
	      return fetch(RESOLVE_URL + '?url=' + url + '&client_id=' + this.props.soundcloudConfig.clientId).then(function (response) {
	        if (response.status >= 200 && response.status < 300) {
	          songData[url] = response.json();
	          return songData[url];
	        } else {
	          var error = new Error(response.statusText);
	          error.response = response;
	          throw error;
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this3 = this;
	
	      this.stop();
	      this.getSDK().then(function (SC) {
	        _this3.getSongData(url).then(function (data) {
	          if (url !== _this3.props.url) {
	            return; // Abort if url changes during async requests
	          }
	          if (!data.streamable) {
	            _this3.props.onError(new Error('SoundCloud track is not streamable'));
	            return;
	          }
	          var image = data.artwork_url || data.user.avatar_url;
	          if (image) {
	            _this3.setState({ image: image.replace('-large', '-t500x500') });
	          }
	          SC.stream(data.uri, function (player) {
	            _this3.player = player;
	            player._player.on('stateChange', _this3.onStateChange);
	            _this3.onReady();
	          });
	        }, _this3.props.onError);
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady) return;
	      this.player._player.off('stateChange', this.onStateChange);
	      this.player.stop();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Object.getPrototypeOf(SoundCloud.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady) return;
	      this.player.seek(this.getDuration(true) * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady) return;
	      this.player.setVolume(fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration(ms) {
	      if (!this.isReady) return null;
	      if (ms) return this.player.getDuration();
	      return this.player.getDuration() / 1000;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentPosition() / this.getDuration(true);
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getLoadedPosition() / this.getDuration(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        display: this.props.url ? 'block' : 'none',
	        height: '100%',
	        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
	        backgroundSize: 'cover',
	        backgroundPosition: 'center'
	      };
	      return _react2.default.createElement('div', { style: style });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return SoundCloud;
	}(_Base3.default);
	
	SoundCloud.displayName = 'SoundCloud';
	exports.default = SoundCloud;
	module.exports = exports['default'];

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(1265);
	
	var _Base2 = __webpack_require__(220);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_SRC = 'https://player.vimeo.com/video/';
	var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
	var DEFAULT_IFRAME_PARAMS = {
	  api: 1,
	  autoplay: 0,
	  badge: 0,
	  byline: 0,
	  fullscreen: 1,
	  portrait: 0,
	  title: 0
	};
	
	var Vimeo = function (_Base) {
	  _inherits(Vimeo, _Base);
	
	  function Vimeo() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Vimeo)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.onMessage = function (e) {
	      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	      _this.origin = _this.origin || e.origin;
	      var data = JSON.parse(e.data);
	      if (data.event === 'ready') {
	        _this.postMessage('getDuration');
	        _this.postMessage('addEventListener', 'playProgress');
	        _this.postMessage('addEventListener', 'loadProgress');
	        _this.postMessage('addEventListener', 'play');
	        _this.postMessage('addEventListener', 'pause');
	        _this.postMessage('addEventListener', 'finish');
	      }
	      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
	      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
	      if (data.event === 'play') _this.onPlay();
	      if (data.event === 'pause') _this.props.onPause();
	      if (data.event === 'finish') _this.props.onEnded();
	      if (data.method === 'getDuration') {
	        _this.duration = data.value; // Store for use later
	        _this.onReady();
	      }
	    }, _this.postMessage = function (method, value) {
	      if (!_this.origin) return;
	      var data = JSON.stringify({ method: method, value: value });
	      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('message', this.onMessage, false);
	      this.iframe = this.refs.iframe;
	
	      if (!this.props.url && this.props.vimeoConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	
	      _get(Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getIframeParams',
	    value: function getIframeParams() {
	      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = url.match(MATCH_URL)[3];
	      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.postMessage('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.postMessage('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.iframe.src = '';
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
	      this.postMessage('seekTo', this.duration * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.postMessage('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      return this.fractionPlayed || null;
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return this.fractionLoaded || null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getIframeParams = this.getIframeParams();
	
	      var fullscreen = _getIframeParams.fullscreen;
	
	      var style = {
	        display: this.props.url ? 'block' : 'none',
	        width: '100%',
	        height: '100%'
	      };
	      return _react2.default.createElement('iframe', { ref: 'iframe', frameBorder: '0', style: style, allowFullScreen: fullscreen });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vimeo;
	}(_Base3.default);
	
	Vimeo.displayName = 'Vimeo';
	exports.default = Vimeo;
	module.exports = exports['default'];

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(481);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(220);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(1264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	var PLAYER_ID = 'youtube-player';
	var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  controls: 0,
	  playsinline: 1,
	  showinfo: 0,
	  rel: 0,
	  iv_load_policy: 3
	};
	
	var playerIdCount = 0;
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(YouTube)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.playerId = PLAYER_ID + '-' + playerIdCount++, _this.onStateChange = function (_ref) {
	      var data = _ref.data;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState;
	      var PLAYING = _window$SDK_GLOBAL$Pl.PLAYING;
	      var PAUSED = _window$SDK_GLOBAL$Pl.PAUSED;
	      var BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING;
	      var ENDED = _window$SDK_GLOBAL$Pl.ENDED;
	      var CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) _this.onPlay();
	      if (data === PAUSED) _this.props.onPause();
	      if (data === BUFFERING) _this.props.onBuffer();
	      if (data === ENDED) _this.props.onEnded();
	      if (data === CUED) _this.onReady();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.url && this.props.youtubeConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL]) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2.default)(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (this.isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url)
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (YT) {
	        _this2.player = new YT.Player(_this2.playerId, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({}, DEFAULT_PLAYER_VARS, _this2.props.youtubeConfig.playerVars, {
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }),
	          events: {
	            onReady: function onReady() {
	              _this2.loadingSDK = false;
	              _this2.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _this2.props.onError(event.data);
	            }
	          }
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.playVideo) return;
	      this.player.playVideo();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pauseVideo) return;
	      this.player.pauseVideo();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player.stopVideo) return;
	      this.player.stopVideo();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seekTo) return;
	      this.player.seekTo(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.getDuration) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentTime() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
	      return this.player.getVideoLoadedFraction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement('div', { id: this.playerId })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3.default);
	
	YouTube.displayName = 'YouTube';
	exports.default = YouTube;
	module.exports = exports['default'];

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _YouTube = __webpack_require__(1262);
	
	var _YouTube2 = _interopRequireDefault(_YouTube);
	
	var _SoundCloud = __webpack_require__(1260);
	
	var _SoundCloud2 = _interopRequireDefault(_SoundCloud);
	
	var _Vimeo = __webpack_require__(1261);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	var _FilePlayer = __webpack_require__(1259);
	
	var _FilePlayer2 = _interopRequireDefault(_FilePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [_YouTube2.default, _SoundCloud2.default, _Vimeo2.default, _FilePlayer2.default];
	module.exports = exports['default'];

/***/ },
/* 1264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	var MATCH_START_QUERY = /[\?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseStartTime(url) {
	  var match = url.match(MATCH_START_QUERY);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseStartStamp(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp, 10);
	    }
	  }
	  return 0;
	}
	
	function parseStartStamp(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array;
	
	    var _array2 = _slicedToArray(_array, 3);
	
	    var count = _array2[1];
	    var period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(568);
	var objectAssign = __webpack_require__(28);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1266 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  var support = {
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var status = (xhr.status === 1223) ? 204 : xhr.status
	        if (status < 100 || status > 599) {
	          reject(new TypeError('Network request failed'))
	          return
	        }
	        var options = {
	          status: status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(526);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(527);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(526);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1269);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1270);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(527);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(301);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(470);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1269 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(25);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(529);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(322);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(467);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(203);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(222);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(126);
	
	var _RouterContext = __webpack_require__(221);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _RouterUtils = __webpack_require__(323);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(221);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(320);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(221);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  var withContext = middlewares.map(function (m) {
	    return m.renderRouterContext;
	  }).filter(function (f) {
	    return f;
	  });
	  var withComponent = middlewares.map(function (m) {
	    return m.renderRouteComponent;
	  }).filter(function (f) {
	    return f;
	  });
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(288);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(532);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(143);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(320);
	
	var _makeStateWithLocation = __webpack_require__(534);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(143);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(467);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(532);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(531);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(222);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(106);
	
	var _RouterUtils = __webpack_require__(323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(320);
	
	var _makeStateWithLocation = __webpack_require__(534);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(143);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(203);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(222);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(41);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(470);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent) {
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    render: function render() {
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { router: this.context.router }));
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(1290);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(1291);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 1290 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 1291 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(142);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEqual = __webpack_require__(1295);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _Elements = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var capitalized = function capitalized(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	
	        // Register Element for automatic token / source / paymentMethod creation
	        if (hocOptions.impliedTokenType || hocOptions.impliedSourceType || hocOptions.impliedPaymentMethodType) {
	          _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType, hocOptions.impliedPaymentMethodType);
	        }
	      });
	    };
	
	    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
	};
	
	exports.default = Element;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(142);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(1296);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.paymentRequest !== nextProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(nextProps);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(224);
	
	var _Provider = __webpack_require__(324);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.parseElementOrData = function (elementOrOptions) {
	        return elementOrOptions && (typeof elementOrOptions === 'undefined' ? 'undefined' : _typeof(elementOrOptions)) === 'object' && elementOrOptions._frame && _typeof(elementOrOptions._frame) === 'object' && elementOrOptions._frame.id && typeof elementOrOptions._frame.id === 'string' && typeof elementOrOptions._componentName === 'string' ? { type: 'element', element: elementOrOptions } : { type: 'data', data: elementOrOptions };
	      };
	
	      _this.findElement = function (filterBy, specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var filteredElements = allElements.filter(function (e) {
	          return e[filterBy];
	        });
	        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
	          return e[filterBy] === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (filterBy, specifiedType) {
	        var element = _this.findElement(filterBy, specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
	            // First argument is options; infer the Element and tokenize
	            var opts = tokenTypeOrOptions;
	
	            var tokenType = opts.type,
	                rest = _objectWithoutProperties(opts, ['type']);
	
	            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
	            // Since only options were passed in, a corresponding Element must exist
	            // for the tokenization to succeed -- thus we call requireElement.
	            var element = _this.requireElement('impliedTokenType', specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof tokenTypeOrOptions === 'string') {
	            // First argument is token type; tokenize with token type and options
	            var _tokenType = tokenTypeOrOptions;
	            return stripe.createToken(_tokenType, options);
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            if (typeof options.type !== 'string') {
	              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
	            }
	
	            var element = _this.findElement('impliedSourceType', options.type);
	            if (element) {
	              // If an Element exists for the source type, use that to create the
	              // corresponding source.
	              //
	              // NOTE: this prevents users from independently creating sources of
	              // type `foo` if an Element that can create `foo` sources exists in
	              // the current <Elements /> context.
	              return stripe.createSource(element, options);
	            } else {
	              // If no Element exists for the source type, directly create a source.
	              return stripe.createSource(options);
	            }
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreatePaymentMethod = function (stripe) {
	        return function (paymentMethodType, elementOrData, maybeData) {
	          if (!paymentMethodType || typeof paymentMethodType !== 'string') {
	            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. Expected a string, got ' + (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) + '.');
	          }
	
	          if (!['card'].includes(paymentMethodType)) {
	            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. ' + paymentMethodType + ' is not yet supported.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; use passed in Element
	          if (elementOrDataResult.type === 'element') {
	            var _element = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe.createPaymentMethod(paymentMethodType, _element, maybeData);
	            } else {
	              return stripe.createPaymentMethod(paymentMethodType, _element);
	            }
	          }
	
	          // Second argument is data or undefined; infer the Element
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', paymentMethodType);
	
	          if (element) {
	            return data ? stripe.createPaymentMethod(paymentMethodType, element, data) : stripe.createPaymentMethod(paymentMethodType, element);
	          }
	
	          if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	            return stripe.createPaymentMethod(paymentMethodType, data);
	          } else if (!data) {
	            throw new Error('Could not find an Element that can be used to create a PaymentMethod of type: ' + paymentMethodType + '.');
	          } else {
	            // If a bad value was passed in for data, throw an error.
	            throw new Error('Invalid data passed to createPaymentMethod. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedHandleCardPayment = function (stripe) {
	        return function (clientSecret, elementOrData, maybeData) {
	          if (!clientSecret || typeof clientSecret !== 'string') {
	            // If a bad value was passed in for clientSecret, throw an error.
	            throw new Error('Invalid PaymentIntent client secret passed to handleCardPayment. Expected string, got ' + (typeof clientSecret === 'undefined' ? 'undefined' : _typeof(clientSecret)) + '.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; handleCardPayment with element
	          if (elementOrDataResult.type === 'element') {
	            var _element2 = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe.handleCardPayment(clientSecret, _element2, maybeData);
	            } else {
	              return stripe.handleCardPayment(clientSecret, _element2);
	            }
	          }
	
	          // Second argument is data or undefined; infer the Element and create PaymentMethod
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', 'card');
	
	          if (element) {
	            // If an Element exists that can create card payment_methods, use that
	            // to create the corresponding payment_method.
	            //
	            // NOTE: this prevents users from using handleCardPayment with an existing
	            // source or payment_method if an Element that can create card payment_methods
	            // exists in the current <Elements /> context.
	            if (data) {
	              return stripe.handleCardPayment(clientSecret, element, data);
	            } else {
	              return stripe.handleCardPayment(clientSecret, element);
	            }
	          } else {
	            if (!data) {
	              throw new Error('Could not find a CardElement or CardNumberElement which which to perform handleCardPayment.');
	            } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
	              throw new Error('Invalid data passed to handleCardPayment. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	            }
	
	            // If no Element exists that can create a card payment_method,
	            // directly call handleCardPayment.
	            return stripe.handleCardPayment(clientSecret, data);
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe),
	        createPaymentMethod: this.wrappedCreatePaymentMethod(stripe),
	        handleCardPayment: this.wrappedHandleCardPayment(stripe)
	      });
	    };
	
	    // Finds an Element by the specified type, if one exists.
	    // Throws if multiple Elements match.
	
	
	    // Require that exactly one Element is found for the specified type.
	    // Throws if no Element is found.
	
	
	    // Wraps createToken in order to infer the Element that is being tokenized.
	
	
	    // Wraps createSource in order to infer the Element that is being used for
	    // source creation.
	
	
	    // Wraps createPaymentMethod in order to infer the Element that is being
	    // used for PaymentMethod creation.
	
	
	    // Wraps handleCardPayment in order to infer the Element that is being tokenized.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ },
/* 1295 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var PLAIN_OBJECT_STR = '[object Object]';
	
	var isEqual = function isEqual(left, right) {
	  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
	    return left === right;
	  }
	
	  if (left === null || right === null) return left === right;
	
	  var leftArray = Array.isArray(left);
	  var rightArray = Array.isArray(right);
	
	  if (leftArray !== rightArray) return false;
	
	  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
	  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
	
	  if (leftPlainObject !== rightPlainObject) return false;
	
	  if (!leftPlainObject && !leftArray) return false;
	
	  var leftKeys = Object.keys(left);
	  var rightKeys = Object.keys(right);
	
	  if (leftKeys.length !== rightKeys.length) return false;
	
	  var keySet = {};
	  for (var i = 0; i < leftKeys.length; i += 1) {
	    keySet[leftKeys[i]] = true;
	  }
	  for (var _i = 0; _i < rightKeys.length; _i += 1) {
	    keySet[rightKeys[_i]] = true;
	  }
	  var allKeys = Object.keys(keySet);
	  if (allKeys.length !== leftKeys.length) {
	    return false;
	  }
	
	  var l = left;
	  var r = right;
	  var pred = function pred(key) {
	    return isEqual(l[key], r[key]);
	  };
	
	  return allKeys.every(pred);
	};
	
	exports.default = isEqual;

/***/ },
/* 1296 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var focusNode = __webpack_require__(459);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventPropagators = __webpack_require__(168);
	var ExecutionEnvironment = __webpack_require__(43);
	var FallbackCompositionState = __webpack_require__(1305);
	var SyntheticCompositionEvent = __webpack_require__(1344);
	var SyntheticInputEvent = __webpack_require__(1347);
	
	var keyOf = __webpack_require__(102);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(536);
	var ExecutionEnvironment = __webpack_require__(43);
	var ReactPerf = __webpack_require__(62);
	
	var camelizeStyleName = __webpack_require__(1059);
	var dangerousStyleValue = __webpack_require__(1353);
	var hyphenateStyleName = __webpack_require__(1066);
	var memoizeStringOnly = __webpack_require__(464);
	var warning = __webpack_require__(17);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventPluginHub = __webpack_require__(167);
	var EventPropagators = __webpack_require__(168);
	var ExecutionEnvironment = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	var SyntheticEvent = __webpack_require__(94);
	
	var getEventTarget = __webpack_require__(337);
	var isEventSupported = __webpack_require__(339);
	var isTextInputElement = __webpack_require__(562);
	var keyOf = __webpack_require__(102);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1301 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(145);
	var ExecutionEnvironment = __webpack_require__(43);
	
	var createNodesFromMarkup = __webpack_require__(1060);
	var emptyFunction = __webpack_require__(57);
	var getMarkupWrap = __webpack_require__(460);
	var invariant = __webpack_require__(7);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : void 0;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : void 0;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : void 0;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : void 0;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : void 0;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(102);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventPropagators = __webpack_require__(168);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticMouseEvent = __webpack_require__(230);
	
	var keyOf = __webpack_require__(102);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var PooledClass = __webpack_require__(128);
	
	var getTextContentAccessor = __webpack_require__(560);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(127);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactChildren = __webpack_require__(538);
	var ReactComponent = __webpack_require__(540);
	var ReactClass = __webpack_require__(539);
	var ReactDOMFactories = __webpack_require__(1316);
	var ReactElement = __webpack_require__(73);
	var ReactElementValidator = __webpack_require__(544);
	var ReactPropTypes = __webpack_require__(553);
	var ReactVersion = __webpack_require__(555);
	
	var onlyChild = __webpack_require__(1359);
	var warning = __webpack_require__(17);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(146);
	
	var instantiateReactComponent = __webpack_require__(561);
	var shouldUpdateReactComponent = __webpack_require__(341);
	var traverseAllChildren = __webpack_require__(342);
	var warning = __webpack_require__(17);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, removedNodes, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getNativeNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactComponentEnvironment = __webpack_require__(329);
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactElement = __webpack_require__(73);
	var ReactErrorUtils = __webpack_require__(330);
	var ReactInstanceMap = __webpack_require__(331);
	var ReactInstrumentation = __webpack_require__(227);
	var ReactNodeTypes = __webpack_require__(551);
	var ReactPerf = __webpack_require__(62);
	var ReactPropTypeLocations = __webpack_require__(229);
	var ReactPropTypeLocationNames = __webpack_require__(228);
	var ReactReconciler = __webpack_require__(146);
	var ReactUpdateQueue = __webpack_require__(554);
	
	var emptyObject = __webpack_require__(199);
	var invariant = __webpack_require__(7);
	var shouldUpdateReactComponent = __webpack_require__(341);
	var warning = __webpack_require__(17);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	    this._nativeParent = null;
	    this._nativeContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} nativeParent
	   * @param {?object} nativeContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    if (Component.prototype && Component.prototype.isReactComponent) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    } else {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	      if (inst == null || inst.render == null) {
	        renderedElement = inst;
	        warnIfInvalidElement(Component, renderedElement);
	        !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : invariant(false) : void 0;
	        inst = new StatelessComponent(Component);
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, nativeParent, nativeContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, nativeParent, nativeContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedNodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, transaction, nativeParent, nativeContainerInfo, this._processChildContext(context));
	
	    return markup;
	  },
	
	  getNativeNode: function () {
	    return ReactReconciler.getNativeNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : void 0;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : void 0;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : void 0;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    var willReceive = false;
	    var nextContext;
	    var nextProps;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      inst.componentWillReceiveProps(nextProps, nextContext);
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldNativeNode = ReactReconciler.getNativeNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      this._renderedNodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, transaction, this._nativeParent, this._nativeContainerInfo, this._processChildContext(context));
	      this._replaceNodeWithMarkup(oldNativeNode, nextMarkup);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldNativeNode, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldNativeNode, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : void 0;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDefaultInjection = __webpack_require__(1329);
	var ReactMount = __webpack_require__(548);
	var ReactPerf = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(146);
	var ReactUpdates = __webpack_require__(85);
	var ReactVersion = __webpack_require__(555);
	
	var findDOMNode = __webpack_require__(1354);
	var getNativeComponentFromComposite = __webpack_require__(559);
	var renderSubtreeIntoContainer = __webpack_require__(1361);
	var warning = __webpack_require__(17);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getNativeComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 1311 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var AutoFocusUtils = __webpack_require__(1297);
	var CSSPropertyOperations = __webpack_require__(1299);
	var DOMLazyTree = __webpack_require__(145);
	var DOMNamespaces = __webpack_require__(1301);
	var DOMProperty = __webpack_require__(127);
	var DOMPropertyOperations = __webpack_require__(326);
	var EventConstants = __webpack_require__(93);
	var EventPluginHub = __webpack_require__(167);
	var EventPluginRegistry = __webpack_require__(225);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactComponentBrowserEnvironment = __webpack_require__(541);
	var ReactDOMButton = __webpack_require__(1311);
	var ReactDOMComponentFlags = __webpack_require__(542);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMInput = __webpack_require__(1319);
	var ReactDOMOption = __webpack_require__(1321);
	var ReactDOMSelect = __webpack_require__(543);
	var ReactDOMTextarea = __webpack_require__(1324);
	var ReactMultiChild = __webpack_require__(1335);
	var ReactPerf = __webpack_require__(62);
	
	var escapeTextContentForBrowser = __webpack_require__(231);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(339);
	var keyOf = __webpack_require__(102);
	var shallowEqual = __webpack_require__(465);
	var validateDOMNesting = __webpack_require__(343);
	var warning = __webpack_require__(17);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : invariant(false) : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._nativeContainerInfo;
	  var doc = containerInfo._ownerDocument;
	  if (!doc) {
	    // Server rendering.
	    return;
	  }
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._nativeContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the native container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = nativeContainerInfo._idCounter++;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, nativeParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, nativeParent);
	        props = ReactDOMInput.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, nativeParent);
	        props = ReactDOMOption.getNativeProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, nativeParent);
	        props = ReactDOMSelect.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, nativeParent);
	        props = ReactDOMTextarea.getNativeProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (nativeParent != null) {
	      namespaceURI = nativeParent._namespaceURI;
	      parentTag = nativeParent._tag;
	    } else if (nativeContainerInfo._tag) {
	      namespaceURI = nativeContainerInfo._namespaceURI;
	      parentTag = nativeContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo._tag) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else {
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._nativeParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'button':
	      case 'input':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._nativeParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getNativeNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'iframe':
	      case 'object':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent.Mixin, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  receiveComponent: 'receiveComponent'
	});
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(343);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMDebugTool
	 */
	
	'use strict';
	
	var ReactDOMUnknownPropertyDevtool = __webpack_require__(1326);
	
	var warning = __webpack_require__(17);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var ReactDOMDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  onCreateMarkupForProperty: function (name, value) {
	    emitEvent('onCreateMarkupForProperty', name, value);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    emitEvent('onSetValueForProperty', node, name, value);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    emitEvent('onDeleteValueForProperty', node, name);
	  }
	};
	
	ReactDOMDebugTool.addDevtool(ReactDOMUnknownPropertyDevtool);
	
	module.exports = ReactDOMDebugTool;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var DOMLazyTree = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	  this._nativeContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    var domID = nativeContainerInfo._idCounter++;
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    this._nativeContainerInfo = nativeContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getNativeNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(73);
	var ReactElementValidator = __webpack_require__(544);
	
	var mapObject = __webpack_require__(463);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1317 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(325);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactPerf = __webpack_require__(62);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var DOMPropertyOperations = __webpack_require__(326);
	var LinkedValueUtils = __webpack_require__(328);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueNull = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `input` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValueDefaultValue = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = props.checked !== undefined || props.value !== undefined;
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	
	      var initialValue = inst._wrapperState.initialChecked || inst._wrapperState.initialValue;
	      var defaultValue = props.defaultChecked || props.defaultValue;
	      var controlled = props.checked !== undefined || props.value !== undefined;
	      var owner = inst._currentElement._owner;
	
	      if ((initialValue || !inst._wrapperState.controlled) && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && (defaultValue || !controlled) && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var ReactDOMDebugTool = __webpack_require__(1314);
	
	module.exports = { debugTool: ReactDOMDebugTool };

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactChildren = __webpack_require__(538);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMSelect = __webpack_require__(543);
	
	var warning = __webpack_require__(17);
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, nativeParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (nativeParent != null && nativeParent._tag === 'select') {
	      selectValue = ReactDOMSelect.getSelectValueContext(nativeParent);
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getNativeProps: function (inst, props) {
	    var nativeProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	var getNodeForCharacterOffset = __webpack_require__(1357);
	var getTextContentAccessor = __webpack_require__(560);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var DOMChildrenOperations = __webpack_require__(325);
	var DOMLazyTree = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactPerf = __webpack_require__(62);
	
	var escapeTextContentForBrowser = __webpack_require__(231);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(343);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._nativeNode = null;
	  this._nativeParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, nativeParent, nativeContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (nativeParent != null) {
	        parentInfo = nativeParent._ancestorInfo;
	      } else if (nativeContainerInfo != null) {
	        parentInfo = nativeContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = nativeContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._nativeParent = nativeParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = nativeContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getNativeNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getNativeNode: function () {
	    var nativeNode = this._commentNodes;
	    if (nativeNode) {
	      return nativeNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : invariant(false) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    nativeNode = [this._nativeNode, this._closingComment];
	    this._commentNodes = nativeNode;
	    return nativeNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	ReactPerf.measureMethods(ReactDOMTextComponent.prototype, 'ReactDOMTextComponent', {
	  mountComponent: 'mountComponent',
	  receiveComponent: 'receiveComponent'
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var DOMPropertyOperations = __webpack_require__(326);
	var LinkedValueUtils = __webpack_require__(328);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnValueNull = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	function warnIfValueIsNull(props) {
	  if (props != null && props.value === null && !didWarnValueNull) {
	     false ? warning(false, '`value` prop on `textarea` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.') : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = _assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	      warnIfValueIsNull(props);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : void 0;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : void 0;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      warnIfValueIsNull(props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : invariant(false) : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._nativeParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._nativeParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._nativeParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._nativeParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._nativeParent;
	    instB = instB._nativeParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_nativeNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	  !('_nativeNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : invariant(false) : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._nativeParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_nativeNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : invariant(false) : void 0;
	
	  return inst._nativeParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._nativeParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._nativeParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._nativeParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMUnknownPropertyDevtool
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(127);
	var EventPluginRegistry = __webpack_require__(225);
	
	var warning = __webpack_require__(17);
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : void 0;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    process.env.NODE_ENV !== 'production' ? warning(registrationName == null, 'Unknown event handler property %s. Did you mean `%s`?', name, registrationName) : void 0;
	  };
	}
	
	var ReactDOMUnknownPropertyDevtool = {
	  onCreateMarkupForProperty: function (name, value) {
	    warnUnknownProperty(name);
	  },
	  onSetValueForProperty: function (node, name, value) {
	    warnUnknownProperty(name);
	  },
	  onDeleteValueForProperty: function (node, name) {
	    warnUnknownProperty(name);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyDevtool;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDebugTool
	 */
	
	'use strict';
	
	var ReactInvalidSetStateWarningDevTool = __webpack_require__(1333);
	var warning = __webpack_require__(17);
	
	var eventHandlers = [];
	var handlerDoesThrowForEvent = {};
	
	function emitEvent(handlerFunctionName, arg1, arg2, arg3, arg4, arg5) {
	  if (false) {
	    eventHandlers.forEach(function (handler) {
	      try {
	        if (handler[handlerFunctionName]) {
	          handler[handlerFunctionName](arg1, arg2, arg3, arg4, arg5);
	        }
	      } catch (e) {
	        process.env.NODE_ENV !== 'production' ? warning(!handlerDoesThrowForEvent[handlerFunctionName], 'exception thrown by devtool while handling %s: %s', handlerFunctionName, e.message) : void 0;
	        handlerDoesThrowForEvent[handlerFunctionName] = true;
	      }
	    });
	  }
	}
	
	var ReactDebugTool = {
	  addDevtool: function (devtool) {
	    eventHandlers.push(devtool);
	  },
	  removeDevtool: function (devtool) {
	    for (var i = 0; i < eventHandlers.length; i++) {
	      if (eventHandlers[i] === devtool) {
	        eventHandlers.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  onBeginProcessingChildContext: function () {
	    emitEvent('onBeginProcessingChildContext');
	  },
	  onEndProcessingChildContext: function () {
	    emitEvent('onEndProcessingChildContext');
	  },
	  onSetState: function () {
	    emitEvent('onSetState');
	  },
	  onMountRootComponent: function (internalInstance) {
	    emitEvent('onMountRootComponent', internalInstance);
	  },
	  onMountComponent: function (internalInstance) {
	    emitEvent('onMountComponent', internalInstance);
	  },
	  onUpdateComponent: function (internalInstance) {
	    emitEvent('onUpdateComponent', internalInstance);
	  },
	  onUnmountComponent: function (internalInstance) {
	    emitEvent('onUnmountComponent', internalInstance);
	  }
	};
	
	ReactDebugTool.addDevtool(ReactInvalidSetStateWarningDevTool);
	
	module.exports = ReactDebugTool;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var ReactUpdates = __webpack_require__(85);
	var Transaction = __webpack_require__(332);
	
	var emptyFunction = __webpack_require__(57);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(1298);
	var ChangeEventPlugin = __webpack_require__(1300);
	var DefaultEventPluginOrder = __webpack_require__(1303);
	var EnterLeaveEventPlugin = __webpack_require__(1304);
	var ExecutionEnvironment = __webpack_require__(43);
	var HTMLDOMPropertyConfig = __webpack_require__(1306);
	var ReactComponentBrowserEnvironment = __webpack_require__(541);
	var ReactDOMComponent = __webpack_require__(1312);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMEmptyComponent = __webpack_require__(1315);
	var ReactDOMTreeTraversal = __webpack_require__(1325);
	var ReactDOMTextComponent = __webpack_require__(1323);
	var ReactDefaultBatchingStrategy = __webpack_require__(1328);
	var ReactEventListener = __webpack_require__(1331);
	var ReactInjection = __webpack_require__(1332);
	var ReactReconcileTransaction = __webpack_require__(1337);
	var SVGDOMPropertyConfig = __webpack_require__(1339);
	var SelectEventPlugin = __webpack_require__(1340);
	var SimpleEventPlugin = __webpack_require__(1341);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(167);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var EventListener = __webpack_require__(454);
	var ExecutionEnvironment = __webpack_require__(43);
	var PooledClass = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var getEventTarget = __webpack_require__(337);
	var getUnboundedScrollPosition = __webpack_require__(461);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._nativeParent) {
	    inst = inst._nativeParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(127);
	var EventPluginHub = __webpack_require__(167);
	var EventPluginUtils = __webpack_require__(327);
	var ReactComponentEnvironment = __webpack_require__(329);
	var ReactClass = __webpack_require__(539);
	var ReactEmptyComponent = __webpack_require__(545);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactNativeComponent = __webpack_require__(550);
	var ReactPerf = __webpack_require__(62);
	var ReactUpdates = __webpack_require__(85);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInvalidSetStateWarningDevTool
	 */
	
	'use strict';
	
	var warning = __webpack_require__(17);
	
	if (false) {
	  var processingChildContext = false;
	
	  var warnInvalidSetState = function () {
	    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
	  };
	}
	
	var ReactInvalidSetStateWarningDevTool = {
	  onBeginProcessingChildContext: function () {
	    processingChildContext = true;
	  },
	  onEndProcessingChildContext: function () {
	    processingChildContext = false;
	  },
	  onSetState: function () {
	    warnInvalidSetState();
	  }
	};
	
	module.exports = ReactInvalidSetStateWarningDevTool;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1352);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(329);
	var ReactMultiChildUpdateTypes = __webpack_require__(549);
	
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactReconciler = __webpack_require__(146);
	var ReactChildReconciler = __webpack_require__(1308);
	
	var flattenChildren = __webpack_require__(1355);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getNativeNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : invariant(false) : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, lastPlacedNode, nextIndex, transaction, context));
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getNativeNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, afterNode, index, transaction, context) {
	      var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._nativeContainerInfo, context);
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(28);
	
	var CallbackQueue = __webpack_require__(537);
	var PooledClass = __webpack_require__(128);
	var ReactBrowserEventEmitter = __webpack_require__(226);
	var ReactInputSelection = __webpack_require__(547);
	var Transaction = __webpack_require__(332);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1336);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1339 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).map(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventPropagators = __webpack_require__(168);
	var ExecutionEnvironment = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInputSelection = __webpack_require__(547);
	var SyntheticEvent = __webpack_require__(94);
	
	var getActiveElement = __webpack_require__(200);
	var isTextInputElement = __webpack_require__(562);
	var keyOf = __webpack_require__(102);
	var shallowEqual = __webpack_require__(465);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(93);
	var EventListener = __webpack_require__(454);
	var EventPropagators = __webpack_require__(168);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticAnimationEvent = __webpack_require__(1342);
	var SyntheticClipboardEvent = __webpack_require__(1343);
	var SyntheticEvent = __webpack_require__(94);
	var SyntheticFocusEvent = __webpack_require__(1346);
	var SyntheticKeyboardEvent = __webpack_require__(1348);
	var SyntheticMouseEvent = __webpack_require__(230);
	var SyntheticDragEvent = __webpack_require__(1345);
	var SyntheticTouchEvent = __webpack_require__(1349);
	var SyntheticTransitionEvent = __webpack_require__(1350);
	var SyntheticUIEvent = __webpack_require__(169);
	var SyntheticWheelEvent = __webpack_require__(1351);
	
	var emptyFunction = __webpack_require__(57);
	var getEventCharCode = __webpack_require__(335);
	var invariant = __webpack_require__(7);
	var keyOf = __webpack_require__(102);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(230);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(169);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(169);
	
	var getEventCharCode = __webpack_require__(335);
	var getEventKey = __webpack_require__(1356);
	var getEventModifierState = __webpack_require__(336);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(169);
	
	var getEventModifierState = __webpack_require__(336);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(94);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(230);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1352 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(536);
	var warning = __webpack_require__(17);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      if (component) {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(107);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstanceMap = __webpack_require__(331);
	
	var getNativeComponentFromComposite = __webpack_require__(559);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(17);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getNativeComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(342);
	var warning = __webpack_require__(17);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : void 0;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(335);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1357 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(43);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(73);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(231);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(548);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(166);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactRouterLibRouterUtils = __webpack_require__(323);
	
	var _routerStateEquals = __webpack_require__(564);
	
	var _routerStateEquals2 = _interopRequireDefault(_routerStateEquals);
	
	var _constants = __webpack_require__(129);
	
	var _actionCreators = __webpack_require__(344);
	
	function memoizeRouterStateSelector(selector) {
	  var previousRouterState = null;
	
	  return function (state) {
	    var nextRouterState = selector(state);
	    if (_routerStateEquals2['default'](previousRouterState, nextRouterState)) {
	      return previousRouterState;
	    }
	    previousRouterState = nextRouterState;
	    return nextRouterState;
	  };
	}
	
	function getRoutesFromProps(props) {
	  return props.routes || props.children;
	}
	
	var ReduxRouter = (function (_Component) {
	  _inherits(ReduxRouter, _Component);
	
	  _createClass(ReduxRouter, null, [{
	    key: 'propTypes',
	    value: {
	      children: _react.PropTypes.node
	    },
	    enumerable: true
	  }, {
	    key: 'contextTypes',
	    value: {
	      store: _react.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  function ReduxRouter(props, context) {
	    _classCallCheck(this, ReduxRouter);
	
	    _Component.call(this, props, context);
	    this.router = _reactRouterLibRouterUtils.createRouterObject(context.store.history, context.store.transitionManager);
	  }
	
	  ReduxRouter.prototype.componentWillMount = function componentWillMount() {
	    this.context.store.dispatch(_actionCreators.initRoutes(getRoutesFromProps(this.props)));
	  };
	
	  ReduxRouter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.receiveRoutes(getRoutesFromProps(nextProps));
	  };
	
	  ReduxRouter.prototype.receiveRoutes = function receiveRoutes(routes) {
	    if (!routes) return;
	
	    var store = this.context.store;
	
	    store.dispatch(_actionCreators.replaceRoutes(routes));
	  };
	
	  ReduxRouter.prototype.render = function render() {
	    var store = this.context.store;
	
	    if (!store) {
	      throw new Error('Redux store missing from context of <ReduxRouter>. Make sure you\'re ' + 'using a <Provider>');
	    }
	
	    var history = store.history;
	    var routerStateSelector = store[_constants.ROUTER_STATE_SELECTOR];
	
	    if (!history || !routerStateSelector) {
	      throw new Error('Redux store not configured properly for <ReduxRouter>. Make sure ' + 'you\'re using the reduxReactRouter() store enhancer.');
	    }
	
	    return _react2['default'].createElement(ReduxRouterContext, _extends({
	      history: history,
	      routerStateSelector: memoizeRouterStateSelector(routerStateSelector),
	      router: this.router
	    }, this.props));
	  };
	
	  return ReduxRouter;
	})(_react.Component);
	
	var ReduxRouterContext = (function (_Component2) {
	  _inherits(ReduxRouterContext, _Component2);
	
	  function ReduxRouterContext() {
	    _classCallCheck(this, _ReduxRouterContext);
	
	    _Component2.apply(this, arguments);
	  }
	
	  ReduxRouterContext.prototype.render = function render() {
	    var location = this.props.location;
	
	    if (location === null || location === undefined) {
	      return null; // Async matching
	    }
	
	    var RoutingContext = this.props.RoutingContext || _reactRouter.RouterContext;
	
	    return _react2['default'].createElement(RoutingContext, this.props);
	  };
	
	  _createClass(ReduxRouterContext, null, [{
	    key: 'propTypes',
	    value: {
	      location: _react.PropTypes.object,
	      RoutingContext: _react.PropTypes.element
	    },
	    enumerable: true
	  }]);
	
	  var _ReduxRouterContext = ReduxRouterContext;
	  ReduxRouterContext = _reactRedux.connect(function (state, _ref) {
	    var routerStateSelector = _ref.routerStateSelector;
	    return routerStateSelector(state) || {};
	  })(ReduxRouterContext) || ReduxRouterContext;
	  return ReduxRouterContext;
	})(_react.Component);
	
	exports['default'] = ReduxRouter;
	module.exports = exports['default'];

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(25);
	
	var _actionCreators = __webpack_require__(344);
	
	var _routerStateEquals = __webpack_require__(564);
	
	var _routerStateEquals2 = _interopRequireDefault(_routerStateEquals);
	
	var _reduxReactRouter = __webpack_require__(1366);
	
	var _reduxReactRouter2 = _interopRequireDefault(_reduxReactRouter);
	
	var _useDefaults = __webpack_require__(1370);
	
	var _useDefaults2 = _interopRequireDefault(_useDefaults);
	
	var _routeReplacement = __webpack_require__(1368);
	
	var _routeReplacement2 = _interopRequireDefault(_routeReplacement);
	
	function historySynchronization(next) {
	  return function (options) {
	    return function (createStore) {
	      return function (reducer, initialState) {
	        var onError = options.onError;
	        var routerStateSelector = options.routerStateSelector;
	
	        var store = next(options)(createStore)(reducer, initialState);
	        var history = store.history;
	        var transitionManager = store.transitionManager;
	
	        var prevRouterState = undefined;
	        var routerState = undefined;
	
	        transitionManager.listen(function (error, nextRouterState) {
	          if (error) {
	            onError(error);
	            return;
	          }
	
	          if (!_routerStateEquals2['default'](routerState, nextRouterState)) {
	            prevRouterState = routerState;
	            routerState = nextRouterState;
	            store.dispatch(_actionCreators.routerDidChange(nextRouterState));
	          }
	        });
	
	        store.subscribe(function () {
	          var nextRouterState = routerStateSelector(store.getState());
	
	          if (nextRouterState && prevRouterState !== nextRouterState && !_routerStateEquals2['default'](routerState, nextRouterState)) {
	            routerState = nextRouterState;
	            var _nextRouterState$location = nextRouterState.location;
	            var state = _nextRouterState$location.state;
	            var pathname = _nextRouterState$location.pathname;
	            var query = _nextRouterState$location.query;
	
	            history.replace({ state: state, pathname: pathname, query: query });
	          }
	        });
	
	        return store;
	      };
	    };
	  };
	}
	
	exports['default'] = _redux.compose(_useDefaults2['default'], _routeReplacement2['default'], historySynchronization)(_reduxReactRouter2['default']);
	module.exports = exports['default'];

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = historyMiddleware;
	
	var _constants = __webpack_require__(129);
	
	/**
	 * Middleware for interacting with the history API
	 * @param {History} History object
	 */
	
	function historyMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type === _constants.HISTORY_API) {
	          var _action$payload = action.payload;
	          var method = _action$payload.method;
	          var args = _action$payload.args;
	
	          return history[method].apply(history, args);
	        }
	        return next(action);
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isActive;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactRouterLibIsActive = __webpack_require__(533);
	
	var _reactRouterLibIsActive2 = _interopRequireDefault(_reactRouterLibIsActive);
	
	/**
	 * Creates a router state selector that returns whether or not the given
	 * pathname and query are active.
	 * @param {String} pathname
	 * @param {Object} query
	 * @param {Boolean} indexOnly
	 * @return {Boolean}
	 */
	
	function isActive(pathname, query) {
	  var indexOnly = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	  return function (state) {
	    if (!state) return false;
	    var location = state.location;
	    var params = state.params;
	    var routes = state.routes;
	
	    return _reactRouterLibIsActive2['default']({ pathname: pathname, query: query }, indexOnly, location, routes, params);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reduxReactRouter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _reactRouterLibCreateTransitionManager = __webpack_require__(222);
	
	var _reactRouterLibCreateTransitionManager2 = _interopRequireDefault(_reactRouterLibCreateTransitionManager);
	
	var _historyMiddleware = __webpack_require__(1364);
	
	var _historyMiddleware2 = _interopRequireDefault(_historyMiddleware);
	
	var _constants = __webpack_require__(129);
	
	function reduxReactRouter(_ref) {
	  var routes = _ref.routes;
	  var createHistory = _ref.createHistory;
	  var parseQueryString = _ref.parseQueryString;
	  var stringifyQuery = _ref.stringifyQuery;
	  var routerStateSelector = _ref.routerStateSelector;
	
	  return function (createStore) {
	    return function (reducer, initialState) {
	
	      var baseCreateHistory = undefined;
	      if (typeof createHistory === 'function') {
	        baseCreateHistory = createHistory;
	      } else if (createHistory) {
	        baseCreateHistory = function () {
	          return createHistory;
	        };
	      }
	
	      var createAppHistory = _reactRouter.useRouterHistory(baseCreateHistory);
	
	      var history = createAppHistory({
	        parseQueryString: parseQueryString,
	        stringifyQuery: stringifyQuery
	      });
	
	      var transitionManager = _reactRouterLibCreateTransitionManager2['default'](history, _reactRouter.createRoutes(routes || children));
	
	      var store = _redux.applyMiddleware(_historyMiddleware2['default'](history))(createStore)(reducer, initialState);
	
	      store.transitionManager = transitionManager;
	      store.history = history;
	      store[_constants.ROUTER_STATE_SELECTOR] = routerStateSelector;
	
	      return store;
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = replaceRoutesMiddleware;
	
	var _constants = __webpack_require__(129);
	
	function replaceRoutesMiddleware(replaceRoutes) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        var isInitRoutes = action.type === _constants.INIT_ROUTES;
	        if (isInitRoutes || action.type === _constants.REPLACE_ROUTES) {
	          replaceRoutes(action.payload, isInitRoutes);
	        }
	        return next(action);
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = routeReplacement;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(3);
	
	var _replaceRoutesMiddleware = __webpack_require__(1367);
	
	var _replaceRoutesMiddleware2 = _interopRequireDefault(_replaceRoutesMiddleware);
	
	function routeReplacement(next) {
	  return function (options) {
	    return function (createStore) {
	      return function (reducer, initialState) {
	        var baseRoutes = options.routes;
	        var getRoutes = options.getRoutes;
	        var routerStateSelector = options.routerStateSelector;
	
	        var store = undefined;
	
	        var childRoutes = [];
	        var areChildRoutesResolved = false;
	        var childRoutesCallbacks = [];
	
	        function replaceRoutes(r, isInit) {
	          childRoutes = _reactRouter.createRoutes(r);
	
	          var routerState = routerStateSelector(store.getState());
	          if (routerState && !isInit) {
	            var _routerState$location = routerState.location;
	            var state = _routerState$location.state;
	            var pathname = _routerState$location.pathname;
	            var query = _routerState$location.query;
	
	            store.history.replace({ state: state, pathname: pathname, query: query });
	          }
	
	          if (!areChildRoutesResolved) {
	            areChildRoutesResolved = true;
	            childRoutesCallbacks.forEach(function (cb) {
	              return cb(null, childRoutes);
	            });
	          }
	        }
	
	        var routes = undefined;
	        if (baseRoutes) {
	          routes = baseRoutes;
	        } else if (getRoutes) {
	          routes = getRoutes({
	            dispatch: function dispatch(action) {
	              return store.dispatch(action);
	            },
	            getState: function getState() {
	              return store.getState();
	            }
	          });
	        } else {
	          routes = [{
	            getChildRoutes: function getChildRoutes(location, cb) {
	              if (!areChildRoutesResolved) {
	                childRoutesCallbacks.push(cb);
	                return;
	              }
	
	              cb(null, childRoutes);
	            }
	          }];
	        }
	
	        store = _redux.compose(_redux.applyMiddleware(_replaceRoutesMiddleware2['default'](replaceRoutes)), next(_extends({}, options, {
	          routes: _reactRouter.createRoutes(routes)
	        })))(createStore)(reducer, initialState);
	
	        return store;
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = routerStateReducer;
	
	var _constants = __webpack_require__(129);
	
	/**
	 * Reducer of ROUTER_DID_CHANGE actions. Returns a state object
	 * with { pathname, query, params, navigationType }
	 * @param  {Object} state - Previous state
	 * @param  {Object} action - Action
	 * @return {Object} New state
	 */
	
	function routerStateReducer(state, action) {
	  if (state === undefined) state = null;
	
	  var _extends2;
	
	  switch (action.type) {
	    case _constants.ROUTER_DID_CHANGE:
	      return action.payload;
	    case _constants.REPLACE_ROUTES:
	      if (!state) return state;
	      return _extends({}, state, (_extends2 = {}, _extends2[_constants.DOES_NEED_REFRESH] = true, _extends2));
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1370 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = useDefaults;
	var defaults = {
	  onError: function onError(error) {
	    throw error;
	  },
	  routerStateSelector: function routerStateSelector(state) {
	    return state.router;
	  }
	};
	
	function useDefaults(next) {
	  return function (options) {
	    return function (createStore) {
	      return function (reducer, initialState) {
	        var optionsWithDefaults = _extends({}, defaults, options);
	
	        var baseCreateHistory = optionsWithDefaults.createHistory;
	        var baseHistory = optionsWithDefaults.history;
	
	        var createHistory = undefined;
	        if (typeof baseCreateHistory === 'function') {
	          createHistory = baseCreateHistory;
	        } else if (baseHistory) {
	          createHistory = function () {
	            return baseHistory;
	          };
	        } else {
	          createHistory = null;
	        }
	
	        return next(_extends({}, optionsWithDefaults, {
	          createHistory: createHistory
	        }))(createStore)(reducer, initialState);
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1371 */
/***/ function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(565);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1373 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(566);
	
	var _isPlainObject = __webpack_require__(301);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(567);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(161)))

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = useStandardScroll;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domHelpersEventsOff = __webpack_require__(419);
	
	var _domHelpersEventsOff2 = _interopRequireDefault(_domHelpersEventsOff);
	
	var _domHelpersEventsOn = __webpack_require__(420);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _domHelpersQueryScrollLeft = __webpack_require__(422);
	
	var _domHelpersQueryScrollLeft2 = _interopRequireDefault(_domHelpersQueryScrollLeft);
	
	var _domHelpersQueryScrollTop = __webpack_require__(423);
	
	var _domHelpersQueryScrollTop2 = _interopRequireDefault(_domHelpersQueryScrollTop);
	
	var _domHelpersUtilRequestAnimationFrame = __webpack_require__(424);
	
	var _domHelpersUtilRequestAnimationFrame2 = _interopRequireDefault(_domHelpersUtilRequestAnimationFrame);
	
	var _historyLibDOMStateStorage = __webpack_require__(286);
	
	var _utilsCreateUseScroll = __webpack_require__(1377);
	
	var _utilsCreateUseScroll2 = _interopRequireDefault(_utilsCreateUseScroll);
	
	var _utilsSetScrollRestoration = __webpack_require__(1378);
	
	var _utilsSetScrollRestoration2 = _interopRequireDefault(_utilsSetScrollRestoration);
	
	/**
	 * `useStandardScroll` attempts to imitate native browser scroll behavior by
	 * recording updates to the window scroll position, then restoring the previous
	 * scroll position upon a `POP` transition.
	 */
	
	function useStandardScroll(createHistory) {
	  var currentKey = undefined;
	
	  function getScrollPosition() {
	    var state = _historyLibDOMStateStorage.readState(currentKey);
	
	    if (!state || !state.scrollPosition) {
	      return [0, 0];
	    }
	
	    return state.scrollPosition;
	  }
	
	  // `history` will invoke this listener synchronously, so `currentKey` will
	  // always be defined.
	  function updateLocation(_ref) {
	    var key = _ref.key;
	
	    currentKey = key;
	  }
	
	  var unsetScrollRestoration = undefined,
	      unlistenScroll = undefined,
	      unlistenBefore = undefined;
	
	  function start(history) {
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    unsetScrollRestoration = _utilsSetScrollRestoration2['default']('manual');
	
	    var savePositionHandle = null;
	
	    // We have to listen to each scroll update rather than to just location
	    // updates, because some browsers will update scroll position before
	    // emitting the location change.
	    function onScroll() {
	      if (savePositionHandle !== null) {
	        return;
	      }
	
	      // It's possible that this scroll operation was triggered by what will be
	      // a `POP` transition. Instead of updating the saved location
	      // immediately, we have to enqueue the update, then potentially cancel it
	      // if we observe a location update.
	      savePositionHandle = _domHelpersUtilRequestAnimationFrame2['default'](function () {
	        savePositionHandle = null;
	
	        var state = _historyLibDOMStateStorage.readState(currentKey);
	        var scrollPosition = [_domHelpersQueryScrollLeft2['default'](window), _domHelpersQueryScrollTop2['default'](window)];
	
	        // We have to directly update `DOMStateStorage`, because actually
	        // updating the location could cause e.g. React Router to re-render the
	        // entire page, which would lead to observably bad scroll performance.
	        _historyLibDOMStateStorage.saveState(currentKey, _extends({}, state, { scrollPosition: scrollPosition }));
	      });
	    }
	
	    _domHelpersEventsOn2['default'](window, 'scroll', onScroll);
	    unlistenScroll = function () {
	      return _domHelpersEventsOff2['default'](window, 'scroll', onScroll);
	    };
	
	    unlistenBefore = history.listenBefore(function () {
	      if (savePositionHandle !== null) {
	        _domHelpersUtilRequestAnimationFrame2['default'].cancel(savePositionHandle);
	        savePositionHandle = null;
	      }
	    });
	  }
	
	  function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (unsetScrollRestoration) {
	      unsetScrollRestoration();
	    }
	
	    unlistenScroll();
	    unlistenBefore();
	  }
	
	  return _utilsCreateUseScroll2['default'](getScrollPosition, start, stop, updateLocation)(createHistory);
	}
	
	module.exports = exports['default'];

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = createUseScroll;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _domHelpersEventsOff = __webpack_require__(419);
	
	var _domHelpersEventsOff2 = _interopRequireDefault(_domHelpersEventsOff);
	
	var _domHelpersEventsOn = __webpack_require__(420);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _domHelpersQueryScrollLeft = __webpack_require__(422);
	
	var _domHelpersQueryScrollLeft2 = _interopRequireDefault(_domHelpersQueryScrollLeft);
	
	var _domHelpersQueryScrollTop = __webpack_require__(423);
	
	var _domHelpersQueryScrollTop2 = _interopRequireDefault(_domHelpersQueryScrollTop);
	
	var _domHelpersUtilRequestAnimationFrame = __webpack_require__(424);
	
	var _domHelpersUtilRequestAnimationFrame2 = _interopRequireDefault(_domHelpersUtilRequestAnimationFrame);
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	function createUseScroll(getScrollPosition, start, stop, updateLocation) {
	  return function (createHistory) {
	    return function () {
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var shouldUpdateScroll = options.shouldUpdateScroll;
	
	      var historyOptions = _objectWithoutProperties(options, ['shouldUpdateScroll']);
	
	      var history = createHistory(historyOptions);
	
	      var scrollTarget = undefined;
	      var numScrollAttempts = undefined;
	      var checkScrollHandle = undefined;
	
	      function cancelCheckScroll() {
	        if (checkScrollHandle !== null) {
	          _domHelpersUtilRequestAnimationFrame2['default'].cancel(checkScrollHandle);
	          checkScrollHandle = null;
	        }
	      }
	
	      function onScroll() {
	        if (!scrollTarget) {
	          return;
	        }
	
	        var _scrollTarget = scrollTarget;
	        var xTarget = _scrollTarget[0];
	        var yTarget = _scrollTarget[1];
	
	        var x = _domHelpersQueryScrollLeft2['default'](window);
	        var y = _domHelpersQueryScrollTop2['default'](window);
	
	        if (x === xTarget && y === yTarget) {
	          scrollTarget = null;
	          cancelCheckScroll();
	        }
	      }
	
	      // FIXME: This is not the right way to track whether there are listeners.
	      var numListeners = 0;
	
	      function checkStart() {
	        if (numListeners === 0) {
	          if (start) {
	            start(history);
	          }
	
	          scrollTarget = null;
	          numScrollAttempts = 0;
	          checkScrollHandle = null;
	
	          _domHelpersEventsOn2['default'](window, 'scroll', onScroll);
	        }
	
	        ++numListeners;
	      }
	
	      function checkStop() {
	        --numListeners;
	
	        if (numListeners === 0) {
	          if (stop) {
	            stop();
	          }
	
	          _domHelpersEventsOff2['default'](window, 'scroll', onScroll);
	
	          cancelCheckScroll();
	        }
	      }
	
	      function listenBefore(hook) {
	        checkStart();
	        var unlisten = history.listenBefore(hook);
	
	        return function () {
	          unlisten();
	          checkStop();
	        };
	      }
	
	      function checkScrollPosition() {
	        checkScrollHandle = null;
	
	        // We can only get here if scrollTarget is set. Every code path that
	        // unsets scroll target also cancels the handle to avoid calling this
	        // handler. Still, check anyway just in case.
	        /* istanbul ignore if: paranoid guard */
	        if (!scrollTarget) {
	          return;
	        }
	
	        var _scrollTarget2 = scrollTarget;
	        var x = _scrollTarget2[0];
	        var y = _scrollTarget2[1];
	
	        window.scrollTo(x, y);
	
	        ++numScrollAttempts;
	
	        /* istanbul ignore if: paranoid guard */
	        if (numScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	          scrollTarget = null;
	          return;
	        }
	
	        checkScrollHandle = _domHelpersUtilRequestAnimationFrame2['default'](checkScrollPosition);
	      }
	
	      var oldLocation = undefined;
	      var listeners = [],
	          currentLocation = undefined,
	          unlisten = undefined;
	
	      function onChange(location) {
	        oldLocation = currentLocation;
	        currentLocation = location;
	
	        listeners.forEach(function (listener) {
	          return listener(location);
	        });
	
	        // Whatever we were doing before isn't relevant any more.
	        cancelCheckScroll();
	
	        // useStandardScroll needs the new location even when not updating the
	        // scroll position, to update the current key.
	        if (updateLocation) {
	          updateLocation(location);
	        }
	
	        var scrollPosition = undefined;
	        if (shouldUpdateScroll) {
	          scrollPosition = shouldUpdateScroll(oldLocation, currentLocation);
	        } else {
	          scrollPosition = true;
	        }
	
	        if (scrollPosition && !Array.isArray(scrollPosition)) {
	          scrollPosition = getScrollPosition(currentLocation);
	        }
	
	        scrollTarget = scrollPosition;
	
	        // Check the scroll position to see if we even need to scroll.
	        onScroll();
	        if (!scrollTarget) {
	          return;
	        }
	
	        numScrollAttempts = 0;
	        checkScrollPosition();
	      }
	
	      function listen(listener) {
	        checkStart();
	
	        if (listeners.length === 0) {
	          unlisten = history.listen(onChange);
	        }
	
	        // Add the listener to the list afterward so we can manage calling it
	        // initially with the current location.
	        listeners.push(listener);
	        listener(currentLocation);
	
	        return function () {
	          listeners = listeners.filter(function (item) {
	            return item !== listener;
	          });
	          if (listeners.length === 0) {
	            unlisten();
	          }
	
	          checkStop();
	        };
	      }
	
	      return _extends({}, history, {
	        listenBefore: listenBefore,
	        listen: listen
	      });
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 1378 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = setScrollRestoration;
	
	function setScrollRestoration(scrollRestoration) {
	  /* istanbul ignore if: not supported by any browsers on Travis */
	  if ('scrollRestoration' in window.history) {
	    var _ret = (function () {
	      var oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = scrollRestoration;
	
	      return {
	        v: function () {
	          window.history.scrollRestoration = oldScrollRestoration;
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	
	  return null;
	}
	
	module.exports = exports['default'];

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.striptags = factory();
	  }
	}(this, function () {
	    var STATE_OUTPUT       = 0,
	        STATE_HTML         = 1,
	        STATE_PRE_COMMENT  = 2,
	        STATE_COMMENT      = 3,
	        WHITESPACE         = /\s/,
	        ALLOWED_TAGS_REGEX = /<(\w*)>/g;
	
	    function striptags(html, allowableTags) {
	        var html = html || '',
	            state = STATE_OUTPUT,
	            depth = 0,
	            output = '',
	            tagBuffer = '',
	            inQuote = false,
	            i, length, c;
	
	        if (typeof allowableTags === 'string') {
	            // Parse the string into an array of tags
	            allowableTags = parseAllowableTags(allowableTags);
	        } else if (!Array.isArray(allowableTags)) {
	            // If it is not an array, explicitly set to null
	            allowableTags = null;
	        }
	
	        for (i = 0, length = html.length; i < length; i++) {
	            c = html[i];
	
	            switch (c) {
	                case '<': {
	                    // ignore '<' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // '<' followed by a space is not a valid tag, continue
	                    if (html[i + 1] == ' ') {
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // change to STATE_HTML
	                    if (state == STATE_OUTPUT) {
	                        state = STATE_HTML;
	
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // ignore additional '<' characters when inside a tag
	                    if (state == STATE_HTML) {
	                        depth++;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '>': {
	                    // something like this is happening: '<<>>'
	                    if (depth) {
	                        depth--;
	                        break;
	                    }
	
	                    // ignore '>' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // an HTML tag was closed
	                    if (state == STATE_HTML) {
	                        inQuote = state = 0;
	
	                        if (allowableTags) {
	                            tagBuffer += '>';
	                            flushTagBuffer();
	                        }
	
	                        break;
	                    }
	
	                    // '<!' met its ending '>'
	                    if (state == STATE_PRE_COMMENT) {
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    // if last two characters were '--', then end comment
	                    if (state == STATE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '-') {
	
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                // catch both single and double quotes
	                case '"':
	                case '\'': {
	                    if (state == STATE_HTML) {
	                        if (inQuote == c) {
	                            // end quote found
	                            inQuote = false;
	                        } else if (!inQuote) {
	                            // start quote only if not already in one
	                            inQuote = c;
	                        }
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '!': {
	                    if (state == STATE_HTML &&
	                        html[i - 1] == '<') {
	
	                        // looks like we might be starting a comment
	                        state = STATE_PRE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '-': {
	                    // if the previous two characters were '!-', this is a comment
	                    if (state == STATE_PRE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '!') {
	
	                        state = STATE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case 'E':
	                case 'e': {
	                    // check for DOCTYPE, because it looks like a comment and isn't
	                    if (state == STATE_PRE_COMMENT &&
	                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {
	
	                        state = STATE_HTML;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                default: {
	                    consumeCharacter(c);
	                }
	            }
	        }
	
	        function consumeCharacter(c) {
	            if (state == STATE_OUTPUT) {
	                output += c;
	            } else if (allowableTags && state == STATE_HTML) {
	                tagBuffer += c;
	            }
	        }
	
	        function flushTagBuffer() {
	            var normalized = '',
	                nonWhitespaceSeen = false,
	                i, length, c;
	
	            normalizeTagBuffer:
	            for (i = 0, length = tagBuffer.length; i < length; i++) {
	                c = tagBuffer[i].toLowerCase();
	
	                switch (c) {
	                    case '<': {
	                        break;
	                    }
	
	                    case '>': {
	                        break normalizeTagBuffer;
	                    }
	
	                    case '/': {
	                        nonWhitespaceSeen = true;
	                        break;
	                    }
	
	                    default: {
	                        if (!c.match(WHITESPACE)) {
	                            nonWhitespaceSeen = true;
	                            normalized += c;
	                        } else if (nonWhitespaceSeen) {
	                            break normalizeTagBuffer;
	                        }
	                    }
	                }
	            }
	
	            if (allowableTags.indexOf(normalized) !== -1) {
	                output += tagBuffer;
	            }
	
	            tagBuffer = '';
	        }
	
	        return output;
	    }
	
	    /**
	     * Return an array containing tags that are allowed to pass through the
	     * algorithm.
	     *
	     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
	     * @return array|null An array of allowed tags or null if none.
	     */
	    function parseAllowableTags(allowableTags) {
	        var tagsArray = [],
	            match;
	
	        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
	            tagsArray.push(match[1]);
	        }
	
	        return tagsArray.length !== 0 ? tagsArray : null;
	    }
	
	    return striptags;
	}));


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(1381)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1381 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 1382 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NODE_TYPE_ELEMENT = exports.NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_TEXT = exports.NODE_TYPE_TEXT = 3;
	var NODE_TYPE_FRAGMENT = exports.NODE_TYPE_FRAGMENT = 11;
	var SELF_CLOSING = exports.SELF_CLOSING = {
	  area: true, base: true, br: true, col: true, embed: true, hr: true, img: true,
	  input: true, keygen: true, link: true, meta: true, param: true, source: true,
	  track: true, wbr: true
	};
	
	var Node = exports.Node = function Node() {
	  _classCallCheck(this, Node);
	};
	
	var TextNode = exports.TextNode = function (_Node) {
	  _inherits(TextNode, _Node);
	
	  function TextNode(value) {
	    _classCallCheck(this, TextNode);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TextNode).apply(this, arguments));
	
	    _this.nodeType = NODE_TYPE_TEXT;
	    _this.nodeName = '#text';
	    _this.nodeValue = value;
	    return _this;
	  }
	
	  _createClass(TextNode, [{
	    key: 'toString',
	    value: function toString() {
	      return escape(this.nodeValue);
	    }
	  }]);
	
	  return TextNode;
	}(Node);
	
	var ElementNode = exports.ElementNode = function (_Node2) {
	  _inherits(ElementNode, _Node2);
	
	  function ElementNode(name, attributes, childNodes) {
	    _classCallCheck(this, ElementNode);
	
	    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ElementNode).apply(this, arguments));
	
	    var isSelfClosing = SELF_CLOSING[name] === true;
	    _this2.nodeType = NODE_TYPE_ELEMENT;
	    _this2.nodeName = name;
	    _this2.attributes = attributes == null ? new Map() : new Map(attributes);
	    _this2.childNodes = [];
	    _this2.isSelfClosing = isSelfClosing;
	    if (!isSelfClosing && childNodes) {
	      childNodes.forEach(_this2.appendChild, _this2);
	    }
	    return _this2;
	  }
	
	  _createClass(ElementNode, [{
	    key: 'appendChild',
	    value: function appendChild(node) {
	      if (node.nodeType === NODE_TYPE_FRAGMENT) {
	        if (node.childNodes != null) {
	          var _childNodes;
	
	          (_childNodes = this.childNodes).push.apply(_childNodes, _toConsumableArray(node.childNodes));
	        }
	      } else {
	        this.childNodes.push(node);
	      }
	    }
	  }, {
	    key: 'getAttribute',
	    value: function getAttribute(name) {
	      return this.attributes.get(name);
	    }
	  }, {
	    key: 'toString',
	    value: function toString(isXHTML) {
	      var attributes = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.attributes.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2);
	
	          var name = _step$value[0];
	          var value = _step$value[1];
	
	          attributes.push(name + (value ? '="' + escapeAttr(value) + '"' : ''));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var attrString = attributes.length ? ' ' + attributes.join(' ') : '';
	      if (this.isSelfClosing) {
	        return '<' + this.nodeName + attrString + (isXHTML ? '/>' : '>');
	      }
	      var childNodes = this.childNodes.map(function (node) {
	        return node.toString(isXHTML);
	      }).join('');
	      return '<' + this.nodeName + attrString + '>' + childNodes + '</' + this.nodeName + '>';
	    }
	  }]);
	
	  return ElementNode;
	}(Node);
	
	var FragmentNode = exports.FragmentNode = function (_Node3) {
	  _inherits(FragmentNode, _Node3);
	
	  function FragmentNode(childNodes) {
	    _classCallCheck(this, FragmentNode);
	
	    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(FragmentNode).apply(this, arguments));
	
	    _this3.nodeType = NODE_TYPE_FRAGMENT;
	    _this3.childNodes = [];
	    if (childNodes) {
	      childNodes.forEach(_this3.appendChild, _this3);
	    }
	    return _this3;
	  }
	
	  _createClass(FragmentNode, [{
	    key: 'appendChild',
	    value: function appendChild(node) {
	      if (node.nodeType === NODE_TYPE_FRAGMENT) {
	        if (node.childNodes != null) {
	          var _childNodes2;
	
	          (_childNodes2 = this.childNodes).push.apply(_childNodes2, _toConsumableArray(node.childNodes));
	        }
	      } else {
	        this.childNodes.push(node);
	      }
	    }
	  }, {
	    key: 'toString',
	    value: function toString(isXHTML) {
	      return this.childNodes.map(function (node) {
	        return node.toString(isXHTML);
	      }).join('');
	    }
	  }]);
	
	  return FragmentNode;
	}(Node);
	
	function escape(html) {
	  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	function escapeAttr(html) {
	  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

/***/ },
/* 1383 */
/***/ function(module, exports) {

	
	/**
	 * Expose `toNoCase`.
	 */
	
	module.exports = toNoCase;
	
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/;
	var hasCamel = /[a-z][A-Z]/;
	var hasSeparator = /[\W_]/;
	
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase (string) {
	  if (hasSpace.test(string)) return string.toLowerCase();
	
	  if (hasSeparator.test(string)) string = unseparate(string);
	  if (hasCamel.test(string)) string = uncamelize(string);
	  return string.toLowerCase();
	}
	
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g;
	
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate (string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : '';
	  });
	}
	
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g;
	
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize (string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
	  });
	}

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	
	var toSpace = __webpack_require__(1386);
	
	
	/**
	 * Expose `toSlugCase`.
	 */
	
	module.exports = toSlugCase;
	
	
	/**
	 * Convert a `string` to slug case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	
	function toSlugCase (string) {
	  return toSpace(string).replace(/\s/g, '-');
	}

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	var toSlugCase = __webpack_require__(1384);
	var anglicize = __webpack_require__(570);
	
	module.exports = slug;
	
	function slug (input) {
	  return toSlugCase(anglicize(input));
	}


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(1383);
	
	
	/**
	 * Expose `toSpaceCase`.
	 */
	
	module.exports = toSpaceCase;
	
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	
	function toSpaceCase (string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : '';
	  });
	}

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.10
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2015 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.10',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            for (var i in extensions) {
	                if ("browser cpu device engine os".indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
	                    regexes[i] = extensions[i].concat(regexes[i]);
	                }
	            }
	            return regexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.split(".")[0] : undefined;
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function () {
	
	            var result, i = 0, j, k, p, q, matches, match, args = arguments;
	
	            // loop through all regexes maps
	            while (i < args.length && !matches) {
	
	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)
	
	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }
	
	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	
	            ], [NAME, VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [
	
	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /JUC.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /XiaoMi\/MiuiBrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i         // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /FBAV\/([\w\.]+);/i                                                 // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	                
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s[6])/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	            /(samsung);smarttv/i
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                        // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,                   // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	
	            /\s(tablet)[;\/\s]/i,                                               // Unidentifiable Tablet
	            /\s(mobile)[;\/\s]/i                                                // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]
	
	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(haiku)\s(\w+)/i,                                                  // Haiku
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	
	    var UAParser = function (uastring, extensions) {
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        this.setUA(ua);
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(1391)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note: 
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 1388 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1388);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1117);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(161)))

/***/ },
/* 1390 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1391 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1392 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main-0b910a23e507c5c0e897.js
 **/